webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(488)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_service__ = __webpack_require__(116);




var _this = this;




/**
 * @typedef {Object} ResponseError
 * @property {string} msg
 * @property {string} Error
 */

var current_token = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getAccessToken();

function validToken(access_token) {
  if (!access_token || access_token === "") return false;
  function JWTExpired(payload) {
    var expireDate = payload.exp * 1000;
    var now = Date.now();
    return now > expireDate;
  }
  var tokendata = JSON.parse(window.atob(access_token.split(".")[1]));
  return tokendata && !JWTExpired(tokendata);
}

function renewToken() {
  var refreshToken = localStorage.getItem("refresh_token");
  var codeVerifier = localStorage.getItem("code_verifier");
  var formData = new FormData();
  formData.append("client_id", "loopOpFrontend");
  formData.append("code_verifier", codeVerifier);
  formData.append("refresh_token", refreshToken);
  formData.append("grant_type", "refresh_token");
  var url = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getServerUrl() + "connect/token";
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!refreshToken) {
      throw Error("no refreshToken or codeVerifier");
    }

    axiosInstanceAuth.post(url, formData).then(function (res) {
      var data = res.data;
      if (data && data.access_token && data.refresh_token && data.id_token) {
        __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
        resolve(localStorage.getItem("access_token") || "yooo");
      } else {
        throw Error("Bad token response");
      }
    }).catch(function (err) {
      console.error("Error on POST in renewToken()");
      reject(err);
    });
  });
}

var axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*"
  }
});
var axiosInstanceAuth = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*"
  }
});

axiosInstance.interceptors.request.use(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var access_token, refreshProcess;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            current_token = __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].getAccessToken();
            access_token = void 0;

            if (!validToken(current_token)) {
              _context.next = 6;
              break;
            }

            access_token = current_token;
            _context.next = 19;
            break;

          case 6:
            _context.prev = 6;
            refreshProcess = renewToken();
            _context.next = 10;
            return refreshProcess;

          case 10:
            access_token = _context.sent;
            _context.next = 18;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](6);

            console.error("Token Renwal failed:", _context.t0);
            __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].removeTokensFromStorage();
            __WEBPACK_IMPORTED_MODULE_4__app_service__["a" /* default */].directToLogin();

          case 18:
            console.warn("Token has beed renewed");

          case 19:
            config.headers = {
              Authorization: "Bearer " + access_token,
              Accept: "application/json"
            };
            return _context.abrupt("return", config);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[6, 13]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

axiosInstance.interceptors.response.use(
/**
 *
 * @param {import('axios').AxiosResponse<T>} response
 * @returns {Promise<T|ResponseError>}
 */
function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (!response.data) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({
      msg: "We got a 200 OK with an empty response",
      Error: "EMPTY SERVER RESPONSE"
    });
  }
  if (response.data.Error) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({
      msg: "Backendmsg: " + response.Error,
      Error: response.Error
    });
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (axiosInstance);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16e8f212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    togglePermission: function togglePermission(_items) {
      var selected = _.takeWhile(_items, ["permitted", true]);
      if (selected.length !== _items.length) _.forEach(_items, function (itm) {
        itm.permitted = true;
      });else _.forEach(_items, function (itm) {
        itm.permitted = false;
      });
    },
    getSelectedItems: function getSelectedItems(_items) {
      return _items.filter(function (el) {
        return el.permitted;
      });
    },
    putItems: function putItems(_this, _url, _items, _source, _successCallback, _errorCallback) {
      $.ajax({
        method: "PUT",
        url: _url,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items),
        dataType: "json",
        contentType: "application/json; charset=utf-8",

        success: function success() {
          _successCallback();
        },
        error: function error(data) {
          if (data.statusText == "OK") return;
          console.error("Error on PUT in " + _source + ".saveChanges()");
          _errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_Language__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_UploadService__ = __webpack_require__(114);











var Compress = __webpack_require__(682);
var uuidv4 = __webpack_require__(32);

var globals = new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  name: "globals",
  computed: {
    currentUserRole: function currentUserRole() {
      if (this.currentUserInfo && this.currentUserInfo.UserTypeId) return this.currentUserInfo.UserTypeId;
      return -1;
    },
    currentUserName: function currentUserName() {
      if (!this.currentUserInfo) return "";
      return this.currentUserInfo.IsLoggedInAsUser || this.currentUserInfo.LoginName || "";
    },
    permissions: function permissions() {
      return this.currentUserInfo && this.currentUserInfo.Permissions || {};
    },
    currentDateFormatForInputMask: function currentDateFormatForInputMask() {
      var dateFormat = "yyyy-mm-dd";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "dd.mm.yyyy";
          break;
        case "fr":
        case "es":
          dateFormat = "dd/mm/yyyy";
          break;
        default:
          dateFormat = "yyyy-mm-dd";
      }
      return dateFormat;
    },
    currentDateFormatForMoment: function currentDateFormatForMoment() {
      var dateFormat = "YYYY-MM-DD";
      switch (this.currentLocale) {
        case "de":
          dateFormat = "DD.MM.YYYY";
          break;
        case "fr":
        case "es":
          dateFormat = "DD/MM/YYYY";
          break;
        default:
          dateFormat = "YYYY-MM-DD";
      }
      return dateFormat;
    },
    currentDateTimeFormatForMoment: function currentDateTimeFormatForMoment() {
      return this.currentDateFormatForMoment + " - HH:mm:ss";
    },
    currentLocale: function currentLocale() {
      return this.selectedLanguage.substring(0, 2);
    },
    isAgencyUser: function isAgencyUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.AgencyGuid;
    },
    isLeadAgencyUser: function isLeadAgencyUser() {
      return !!this.currentUserInfo && this.currentUserInfo.AgencyTypeName === "Lead";
    },
    isLocalAgencyUser: function isLocalAgencyUser() {
      return !!this.currentUserInfo && this.currentUserInfo.AgencyTypeName === "Local";
    },
    isAudiUser: function isAudiUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsAudiUser;
    },
    isLoggedInAsOtherUser: function isLoggedInAsOtherUser() {
      return !!this.currentUserInfo && !!this.currentUserInfo.IsLoggedInAsUser;
    },
    isIEBrowser: function isIEBrowser() {
      var ua = window.navigator.userAgent;
      // IE 10 or older
      if (ua.indexOf("MSIE ") > 0) return true;
      // IE 11
      if (ua.indexOf("Trident/") > 0) return true;
      // Edge (IE 12+)
      if (ua.indexOf("Edge/") > 0) return true;
      // other browser
      return false;
    },
    googleApiKey: function googleApiKey() {
      if (_.includes("https://projects.qm-servicestoredb.de/#/", "msmloop.com")) return __WEBPACK_IMPORTED_MODULE_7__package_json__["googleApiKeys"].msm;
      if (_.includes("https://projects.qm-servicestoredb.de/#/", "audi-mysteryshopping")) return __WEBPACK_IMPORTED_MODULE_7__package_json__["googleApiKeys"].audi;
      return __WEBPACK_IMPORTED_MODULE_7__package_json__["googleApiKeys"].dev;
    }
  },
  methods: {
    localizeFlatpickrConfig: function localizeFlatpickrConfig() {
      this.flatpickrDateConfig.locale = this.currentLocale;
      this.flatpickrIsoDateConfig.locale = this.currentLocale;
      this.flatpickrDatetimeConfig.locale = this.currentLocale;

      var dateFormat = void 0;
      switch (this.currentLocale) {
        case "de":
          dateFormat = "d.m.Y";
          break;
        case "fr":
        case "es":
          dateFormat = "d/m/Y";
          break;
        default:
          dateFormat = "Y-m-d";
      }
      this.flatpickrDateConfig.altFormat = dateFormat;
      this.flatpickrIsoDateConfig.altFormat = dateFormat;
      this.flatpickrDatetimeConfig.altFormat = dateFormat + " H:i";
    },

    /**
     * We used to manually toogle open(),but this broke support for mobile and is disabled at the moment
     * @param {String} inputId the Id of the input element
     */
    toggleFlatpickr: function toggleFlatpickr(inputId) {
      return;
      var el = document.getElementById(inputId);
      if (!el) return;
      var fp = el._flatpickr;
      if (!fp) return;
      fp.toggle();
    },

    /**
     * Show global spinner
     * @param {boolean} immediate
     */
    showSpinner: function showSpinner(immediate) {
      var _this = this;

      if (!this.$debouncedShowSpinnerFunc) this.$debouncedShowSpinnerFunc = _.debounce(function () {
        return _this.spinnerVisible = true;
      }, 500);

      if (!this.$stackedSpinnerRequests) this.$stackedSpinnerRequests = 0;
      this.$stackedSpinnerRequests++;

      this.$debouncedShowSpinnerFunc();
      if (immediate) this.$debouncedShowSpinnerFunc.flush();
    },
    hideSpinner: function hideSpinner() {
      if (--this.$stackedSpinnerRequests > 0) return;

      this.$stackedSpinnerRequests = 0; // Avoid negative values
      this.$debouncedShowSpinnerFunc.cancel();
      this.spinnerVisible = false;
    },
    getCurrencyString: function getCurrencyString(value, currencyCode) {
      if (typeof value === "undefined" || isNaN(value) || value === null) return "";
      var result = value.toFixed(2);
      var currency = void 0;
      switch (currencyCode) {
        case "EUR":
          currency = {
            symbol: "€",
            prefix: false
          };
          break;
        case "USD":
          currency = {
            symbol: "$",
            prefix: true
          };
          break;
        case "CNY":
          currency = {
            symbol: "¥",
            prefix: false
          };
          break;
        default:
          currency = {
            symbol: "",
            prefix: false
          };
      }

      switch (this.currentLocale) {
        case "de":
          result = result.replace(".", ",").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          break;
        default:
          result = result.replace(",", ".").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      result = currency.prefix ? currency.symbol + " " + result : result + " " + currency.symbol;
      return result;
    },
    showSuccessSnackbar: function showSuccessSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00023;
      options.style = "snackbar-success";
      options.id = "successSnackbar";
      options.onClose = function () {
        $("#successSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#successSnackbar > span").show();
    },
    showErrorSnackbar: function showErrorSnackbar(text, timeout) {
      var options = _.cloneDeep(this.snackbarConfig);
      if (typeof timeout === "number" && timeout > 0) options.timeout = timeout;
      options.content = text || this.lang.G00024;
      options.style = "snackbar-error";
      options.id = "errorSnackbar";
      options.onClose = function () {
        $("#errorSnackbar > span").hide();
      };
      $.snackbar(options);
      $("#errorSnackbar > span").show();
    },
    getUrlBlobOfDownload: function getUrlBlobOfDownload(guid) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res, defaultName, regex, filename, matching, FILE;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].getFilesbyId(guid, false);

              case 2:
                res = _context.sent;

                if (res.data) {
                  _context.next = 5;
                  break;
                }

                throw new Error("No data recieved on download");

              case 5:
                defaultName = "";
                // we get a noisy string.Clean it!

                regex = /filename=(.*);/;
                filename = "";

                if (res.headers["content-disposition"]) {
                  matching = res.headers["content-disposition"].match(regex);

                  filename = matching && matching[1] ? matching[1] : "download.xlsx";
                }

                FILE = window.URL.createObjectURL(new Blob([res.data]));
                return _context.abrupt("return", { Blob: FILE, Name: filename });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    downloadFile: function downloadFile(guid) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fileObj, docUrl;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getUrlBlobOfDownload(guid);

              case 2:
                fileObj = _context2.sent;
                docUrl = document.createElement("a");

                docUrl.href = fileObj.Blob;
                docUrl.setAttribute("download", fileObj.Name);
                document.body.appendChild(docUrl);
                docUrl.click();
                docUrl.remove();

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    /**
     * Downloads a file and names it
     * @param {String} guid The download guid
     * @param {String} filename The file name
     */
    downloadFilewithName: function downloadFilewithName(guid, filename) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res, FILE, docUrl;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].getFilesbyId(guid, false);

              case 2:
                res = _context3.sent;

                if (res.data) {
                  _context3.next = 5;
                  break;
                }

                throw new Error("No data recieved on download");

              case 5:
                FILE = window.URL.createObjectURL(new Blob([res.data]));
                docUrl = document.createElement("a");

                docUrl.href = FILE;
                docUrl.setAttribute("download", filename);
                document.body.appendChild(docUrl);
                docUrl.click();
                docUrl.remove();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    /**
     * Compress file using https://www.npmjs.com/package/compress.js
     * File type does not get changed, but file get resized
     * @param {Blob} file
     * @param {number} size the max size in MB
     */
    compressFile: function compressFile(file, size) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var compress = new Compress();

        compress.compress([file], {
          size: size,
          quality: 0.9,
          maxWidth: 1920,
          maxHeight: 1920,
          resize: true // default
        }).then(function (results) {
          var img1 = results[0];
          var base64str = img1.data;
          var imgExt = img1.ext;
          var compressedFile = Compress.convertBase64ToFile(base64str, imgExt);
          compressedFile.name = file.name;
          resolve(compressedFile);
        }).catch(function (err) {
          reject(err);
        });
      });
    },

    /**
     * Upload file
     * @param {Blob} file
     * @param {boolean} compress on default no compression
     * @param {callback} success
     * @param {callback} error
     * @param {callback} done
     */
    uploadFile: function uploadFile(file) {
      var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _success = arguments[2];

      var _this5 = this;

      var _error = arguments[3];
      var done = arguments[4];
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var uploadData, uploadGuid;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!compress) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return _this5.compressFile(file, 1).catch(function (err) {
                  console.error("Error while compressing");
                  console.error(err);
                  _this5.showErrorSnackbar(_this5.lang.G00033);
                });

              case 3:
                file = _context4.sent;

              case 4:
                uploadData = new FormData();

                uploadData.append("file", file, file.name);
                uploadGuid = uuidv4();

                _this5.pendingUploads[uploadGuid] = {};

                _this5.pendingUploads[uploadGuid].request = $.ajax({
                  method: "POST",
                  url: "api/Upload",
                  data: uploadData,
                  dataType: "json",
                  contentType: false,
                  processData: false,
                  global: false,
                  xhr: function xhr() {
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                      _this5.pendingUploads[uploadGuid].sizes = [0, file.size, 0];

                      xhr.upload.addEventListener("progress", function (e) {
                        if (e.lengthComputable && _this5.pendingUploads[uploadGuid]) {
                          _this5.pendingUploads[uploadGuid].sizes = [e.loaded, e.total, e.loaded / e.total];
                          _this5.calculateUploadProgress();
                        }
                      }, false);
                    }
                    return xhr;
                  },
                  success: function success(data) {
                    if (_success) _success(data);
                  },
                  error: function error(err) {
                    if (err.statusText === "abort") {
                      console.error("Upload canceled by user");
                      _this5.globals.showErrorSnackbar(_this5.lang.G00001);
                    } else {
                      console.error("Error on POST in uploadFile()");
                      _this5.globals.showErrorSnackbar(_this5.lang.G00002);
                      delete _this5.pendingUploads[uploadGuid];
                    }
                    if (_error) _error();
                  },
                  complete: function complete() {
                    _this5.calculateUploadProgress();
                    if (done) done();
                  }
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },

    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    uploadFilesv2: function uploadFilesv2(files) {
      var _this6 = this;

      var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var compressedFiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, uploadProcesses;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!compress) {
                  _context5.next = 31;
                  break;
                }

                compressedFiles = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context5.prev = 5;
                _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context5.next = 16;
                  break;
                }

                file = _step.value;
                _context5.next = 11;
                return _this6.compressFile(file, 1).catch(function (err) {
                  console.error("Error while compressing");
                  console.error(err);
                  _this6.showErrorSnackbar(_this6.lang.G00033);
                });

              case 11:
                file = _context5.sent;

                compressedFiles.push(file);

              case 13:
                _iteratorNormalCompletion = true;
                _context5.next = 7;
                break;

              case 16:
                _context5.next = 22;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context5.t0;

              case 22:
                _context5.prev = 22;
                _context5.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context5.prev = 25;

                if (!_didIteratorError) {
                  _context5.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context5.finish(25);

              case 29:
                return _context5.finish(22);

              case 30:
                files = compressedFiles;

              case 31:
                uploadProcesses = [];

                files.map(function (file) {
                  uploadProcesses.push(__WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].upload(file));
                });
                return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(uploadProcesses));

              case 34:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[5, 18, 22, 30], [23,, 25, 29]]);
      }))();
    },

    /**
     *
     * @param {Array<File>} files -List of Files to upload
     * @param {boolean} [compress = false] - Should we Compress the files
     * @param {boolean} [offline = false] - Are we in offline mode
     * @param {any} [guid = false] - provide an extra guid for indexdb key
     * @returns {Promise<Array> | Promise<Array<String>> }
     */
    uploadFilesv3: function uploadFilesv3(files) {
      var compress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _this7 = this;

      var offline = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var guid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var compressedFiles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, file, blob, f, uploadProcesses;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!compress) {
                  _context6.next = 38;
                  break;
                }

                compressedFiles = [];
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context6.prev = 5;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(files);

              case 7:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context6.next = 23;
                  break;
                }

                file = _step2.value;

                if (_this7.isImageType(file)) {
                  _context6.next = 13;
                  break;
                }

                compressedFiles.push(file);
                _context6.next = 20;
                break;

              case 13:
                _context6.next = 15;
                return reduceFileSize(file, 500 * 1024, 1920, 1920, 0.9);

              case 15:
                blob = _context6.sent;
                _context6.next = 18;
                return blobToFile(blob, file);

              case 18:
                f = _context6.sent;

                compressedFiles.push(f);

              case 20:
                _iteratorNormalCompletion2 = true;
                _context6.next = 7;
                break;

              case 23:
                _context6.next = 29;
                break;

              case 25:
                _context6.prev = 25;
                _context6.t0 = _context6["catch"](5);
                _didIteratorError2 = true;
                _iteratorError2 = _context6.t0;

              case 29:
                _context6.prev = 29;
                _context6.prev = 30;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 32:
                _context6.prev = 32;

                if (!_didIteratorError2) {
                  _context6.next = 35;
                  break;
                }

                throw _iteratorError2;

              case 35:
                return _context6.finish(32);

              case 36:
                return _context6.finish(29);

              case 37:
                files = compressedFiles;

              case 38:
                uploadProcesses = [];

                if (offline) {
                  uploadProcesses = files.map(function (file) {
                    var key = void 0;
                    if (guid) {
                      key = [guid, uuidv4()];
                    } else {
                      key = uuidv4();
                    }
                    return __WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].offlineUpload(file, key);
                  });
                } else {
                  uploadProcesses = files.map(function (file) {
                    return __WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].upload(file);
                  });
                }
                return _context6.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(uploadProcesses));

              case 41:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[5, 25, 29, 37], [30,, 32, 36]]);
      }))();
    },
    getFilefromStore: function getFilefromStore(guid) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", __WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].getFilesbyId(guid, true));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },

    /**
     *
     * @param {Array<String>} guidarray
     * @returns {Promise<Array<String>>}
     */
    getFilesfromStore: function getFilesfromStore(guidarray) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var progress, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, id;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                progress = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context8.prev = 4;

                for (_iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(guidarray); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  id = _step3.value;

                  progress.push(__WEBPACK_IMPORTED_MODULE_9__services_UploadService__["a" /* default */].getFilesbyId(id, true));
                }
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](4);
                _didIteratorError3 = true;
                _iteratorError3 = _context8.t0;

              case 12:
                _context8.prev = 12;
                _context8.prev = 13;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 15:
                _context8.prev = 15;

                if (!_didIteratorError3) {
                  _context8.next = 18;
                  break;
                }

                throw _iteratorError3;

              case 18:
                return _context8.finish(15);

              case 19:
                return _context8.finish(12);

              case 20:
                return _context8.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(progress));

              case 21:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[4, 8, 12, 20], [13,, 15, 19]]);
      }))();
    },
    calculateUploadProgress: function calculateUploadProgress() {
      var sumLoaded = 0,
          sumTotal = 0,
          countDone = 0;
      var count = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.pendingUploads).length;

      for (var upload in this.pendingUploads) {
        sumLoaded += this.pendingUploads[upload].sizes[0];
        sumTotal += this.pendingUploads[upload].sizes[1];
        countDone += this.pendingUploads[upload].sizes[2];
      }

      if (count < 1 || countDone == count) {
        this.currentUploadProgress = 100;
        this.pendingUploads = {};
        return;
      }
      this.currentUploadProgress = Number((sumLoaded * 100 / sumTotal).toFixed(0));
    },
    cancelPendingUploads: function cancelPendingUploads() {
      var _this10 = this;

      this.$nextTick(function () {
        for (var guid in _this10.pendingUploads) {
          _this10.pendingUploads[guid].request.abort();
        }
        _this10.pendingUploads = {};
        _this10.currentUploadProgress = 100;
      });
    },
    isValidFileType: function isValidFileType(file, acceptedTypes) {
      if (!acceptedTypes) return true;
      var types = _.split(_.replace(acceptedTypes, / /g, ""), ",");

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(types), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var type = _step4.value;

          if (type === "image/*" && _.startsWith(file.type, "image/") || type === "video/*" && _.startsWith(file.type, "video/") || type === "audio/*" && _.startsWith(file.type, "audio/")) return true;

          if (file.type === type) return true;

          if (_.startsWith(type, ".") && _.endsWith(file.name, type)) return true;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },

    // Requests the language strings for the selected language from server
    // Requests the language strings for the selected language from server
    getLanguageStrings: function getLanguageStrings(that, success, error) {
      var _this11 = this;

      if (that.$options.name && this.langCache[that.$options.name]) {
        that.lang = this.langCache[that.$options.name];
        if (success) success();
        return;
      }
      var langKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(that.lang);

      __WEBPACK_IMPORTED_MODULE_8__services_Language__["a" /* default */].getTranslationfor(that.lang).then(function (_ref) {
        var data = _ref.data;

        var dataKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
        if (dataKeys.length == langKeys.length) that.lang = data;else {
          for (var i = 0; i < dataKeys.length; i++) {
            that.lang[dataKeys[i]] = data[dataKeys[i]];
          }
        }
        if (that.$options.name) _this11.langCache[that.$options.name] = that.lang;
        if (success) success();
      }).catch(function (err) {
        if (err.status === 0 || err.status === 401) return; // Request canceled or unauthorized
        console.error("Language data access failed in getLanguageStrings()", err);
        _this11.showErrorSnackbar(_this11.lang.G00003);
        if (error) error(err);
      });
    },

    // Requests information about the current user from backend
    getCurrentUserInfo: function getCurrentUserInfo(callback, errorCallback) {
      var _this12 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/Current",
        success: function success(data) {
          _this12.currentUserInfo = data;
          _this12.selectedLanguage = data.FrontendLanguageCode;
          _this12.$emit("currentUserInfoReceived");
          if (callback) callback();
        },
        error: function error() {
          console.error("Userdata access failed in getCurrentUserInfo()");
          _this12.currentUserInfo = null;
          if (errorCallback) errorCallback();
        }
      });
    },
    isAccessAllowed: function isAccessAllowed(policy) {
      if (!policy || !this.currentUserInfo || !this.currentUserInfo.Policies) return false;

      var idx = this.currentUserInfo.Policies.indexOf(policy);
      if (idx < 0) return false;
      return true;
    },
    operationPermitted: function operationPermitted(target) {
      if (!target) return false;
      var targetParts = _.split(target, ".");
      if (targetParts.length < 2) return false;

      var permissionObject = this.permissions[targetParts[0]];
      if (!permissionObject) return false;

      for (var i = 1; i < targetParts.length; i++) {
        if (!permissionObject[targetParts[i]]) return false;else permissionObject = permissionObject[targetParts[i]];
      }
      return !!permissionObject;
    },

    // Extracts the date in a localized format from an iso timestamp
    getLocalizedDateFromIsoTimestamp: function getLocalizedDateFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(isoTimestamp).format(this.currentDateFormatForMoment);
    },

    // Extracts the date and time in a localized format from an iso timestamp
    getLocalizedDateTimeFromIsoTimestamp: function getLocalizedDateTimeFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(isoTimestamp).format(this.currentDateTimeFormatForMoment);
    },

    // Extracts the date and time in a localized format from an iso timestamp in UTC
    getLocalizedDateTimeFromUtcIsoTimestamp: function getLocalizedDateTimeFromUtcIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default.a.utc(isoTimestamp).local().format(this.currentDateTimeFormatForMoment);
    },
    getIsoDateFromIsoTimestamp: function getIsoDateFromIsoTimestamp(isoTimestamp) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(isoTimestamp).format("YYYY-MM-DD");
    },

    // Requests a list of all countries and returns it by calling the callback function
    getCountryList: function getCountryList(callback) {
      var _this13 = this;

      if (!_.isEmpty(this.countryList)) {
        if (callback) callback(this.countryList);
        return;
      }

      if (!this.$pendingCountryListCallbacks) {
        this.$pendingCountryListCallbacks = [callback];
      } else {
        this.$pendingCountryListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this13.$pendingCountryListCallbacks), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var cb = _step5.value;
            if (cb) cb(data);
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        delete _this13.$pendingCountryListCallbacks;
      };

      var queryString = "api/Data/Countries";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this13.countryList = data;
          executeCallbacks(_this13.countryList);
        },
        error: function error() {
          console.error("Error on GET in getCountryList()");
          _this13.globals.showErrorSnackbar(_this13.lang.G00004);
          executeCallbacks({});
        }
      });
    },
    getOccupationalGroupList: function getOccupationalGroupList(callback) {
      var _this14 = this;

      if (!_.isEmpty(this.occupationalGroupList)) {
        callback(this.occupationalGroupList);
        return;
      }

      var queryString = "api/Data/OccupationalGroup";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this14.occupationalGroupList = data;
          callback(_this14.occupationalGroupList);
        },
        error: function error() {
          console.error("Error on GET in getOccupationalGroupList()");
          _this14.globals.showErrorSnackbar(_this14.lang.G00005);
        }
      });
    },
    getTimezonesList: function getTimezonesList(callback) {
      var _this15 = this;

      if (!_.isEmpty(this.timezonesList)) {
        callback(this.timezonesList);
        return;
      }

      var queryString = "api/Data/Timezones";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this15.timezonesList = data;
          callback(_this15.timezonesList);
        },
        error: function error() {
          console.error("Error on GET in getTimezonesList()");
          _this15.globals.showErrorSnackbar(_this15.lang.G00008);
        }
      });
    },
    getRegionsList: function getRegionsList(callback) {
      var _this16 = this;

      if (!_.isEmpty(this.regionsList)) {
        callback(this.regionsList);
        return;
      }

      var queryString = "api/Data/Regions";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this16.regionsList = data;
          callback(_this16.regionsList);
        },
        error: function error() {
          console.error("Error on GET in getRegionsList()");
          _this16.globals.showErrorSnackbar(_this16.lang.G00009);
        }
      });
    },
    getLanguageList: function getLanguageList(callback) {
      var _this17 = this;

      if (!_.isEmpty(this.languageList)) {
        callback(this.languageList);
        return;
      }

      var queryString = "api/Data/Languages";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this17.languageList = data;
          callback(_this17.languageList);
        },
        error: function error() {
          console.error("Error on GET in getLanguageList()");
          _this17.globals.showErrorSnackbar(_this17.lang.G00010);
        }
      });
    },
    getMarketList: function getMarketList(callback) {
      var _this18 = this;

      if (!_.isEmpty(this.marketList)) {
        callback(this.marketList);
        return;
      }

      var queryString = "api/Data/Markets";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this18.marketList = data;
          callback(_this18.marketList);
        },
        error: function error() {
          console.error("Error on GET in getMarketList()");
          _this18.globals.showErrorSnackbar(_this18.lang.G00034);
        }
      });
    },

    /**
     * Returns a list of clients if still existing else fetch them from backend
     * @returns Promise
     */
    getClientList: function getClientList() {
      var _this19 = this;

      if (!_.isEmpty(this.clientList)) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          resolve(_this19.clientList);
        });
      }

      var queryString = "api/Data/ClientsWithGuid";
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          method: "GET",
          url: queryString,
          success: function success(data) {
            _this19.clientList = [];
            for (var guid in data) {
              _this19.clientList.push({
                ClientGuid: guid,
                ClientName: data[guid]
              });
            }
            _this19.clientList.sort(function (a, b) {
              if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
              if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
              return 0;
            });

            resolve(_this19.clientList);
          },
          error: function error() {
            console.error("Error on GET in getClientList()");
            _this19.globals.showErrorSnackbar(_this19.lang.G00011);
            reject([]);
          }
        });
      });
    },
    getImporterList: function getImporterList(callback) {
      var _this20 = this;

      if (!_.isEmpty(this.importerList)) {
        callback(this.importerList);
        return;
      }

      if (!this.$pendingImporterListCallbacks) {
        this.$pendingImporterListCallbacks = [callback];
      } else {
        this.$pendingImporterListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this20.$pendingImporterListCallbacks), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var cb = _step6.value;
            cb(data);
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        delete _this20.$pendingImporterListCallbacks;
      };

      var queryString = "api/Importer";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this20.importerList = [];
          if (!_.isEmpty(data)) {
            _this20.importerList = data;
            var internationalImporter = _.remove(_this20.importerList, function (importer) {
              return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
            });
            if (internationalImporter[0]) _this20.importerList.unshift(internationalImporter[0]);
          }
          executeCallbacks(_this20.importerList);
        },
        error: function error() {
          console.error("Error on GET in getImporterList()");
          _this20.globals.showErrorSnackbar(_this20.lang.G00026);
          executeCallbacks([]);
        }
      });
    },
    getCarModelList: function getCarModelList(callback) {
      var _this21 = this;

      if (!_.isEmpty(this.carModelList)) {
        callback(this.carModelList);
        return;
      }

      $.ajax({
        method: "GET",
        url: "api/CarModel",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this21.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this21.carModelList = [];
          if (!_.isEmpty(data)) _this21.carModelList = data;
          callback(_this21.carModelList);
        },
        error: function error() {
          console.error("Car model list access failed in getCarModelList()");
          _this21.globals.showErrorSnackbar(_this21.lang.G00028);
          callback([]);
        }
      });
    },
    getCarSegmentList: function getCarSegmentList(callback) {
      var _this22 = this;

      if (!_.isEmpty(this.carSegmentList)) {
        callback(this.carSegmentList);
        return;
      }

      $.ajax({
        method: "GET",
        url: "api/CarModel/CarSegment",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this22.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this22.carSegmentList = [];
          if (!_.isEmpty(data)) _this22.carSegmentList = data;
          callback(_this22.carSegmentList);
        },
        error: function error() {
          console.error("Segment list access failed in getCarSegmentList()");
          _this22.globals.showErrorSnackbar(_this22.lang.G00029);
          callback([]);
        }
      });
    },
    getClientTypes: function getClientTypes(callback) {
      var _this23 = this;

      if (this.clientTypes[0]) {
        callback(this.clientTypes);
        return;
      }

      var queryString = "api/Data/ClientTypes";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this23.clientTypes = data;
          callback(_this23.clientTypes);
        },
        error: function error() {
          console.error("Error on GET in getClientTypes()");
          _this23.globals.showErrorSnackbar(_this23.lang.G00031);
          callback([]);
        }
      });
    },

    /**
     * NOT WORKING ENDPOINT RETURNS  ""
     * @param {function} callback
     * @returns {string}
     */
    getDepartmentUsers: function getDepartmentUsers(callback) {
      var _this24 = this;

      callback("");

      //return;
      try {
        if (this.departmentUsers[0]) {
          callback(this.departmentUsers);
          return;
        }

        var queryString = "api/Data/DepartmentUsers";
        $.ajax({
          method: "GET",
          url: queryString,
          success: function success(data) {
            _this24.departmentUsers = data;
            callback(_this24.departmentUsers);
          },
          error: function error() {
            console.error("Error on GET in getDepartmentUsers()");
            _this24.globals.showErrorSnackbar(_this24.lang.G00032);
            callback([]);
          }
        });
      } catch (e) {}
    },
    getProjectList: function getProjectList(callback) {
      var _this25 = this;

      var queryString = "api/Data/Projects";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (_.isEmpty(data)) data = [];
          callback(data);
        },
        error: function error() {
          console.error("Error on GET in getProjectList()");
          _this25.globals.showErrorSnackbar(_this25.lang.G00012);
          callback([]);
        }
      });
    },
    getWaveList: function getWaveList(callback) {
      var _this26 = this;

      var queryString = "api/Data/Waves";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Error on GET in getWaveList()");
          _this26.globals.showErrorSnackbar(_this26.lang.G00013);
          callback([]);
        }
      });
    },
    getScenarioList: function getScenarioList(callback) {
      var _this27 = this;

      var queryString = "api/Data/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Error on GET in getScenarioList()");
          _this27.globals.showErrorSnackbar(_this27.lang.G00014);
          callback([]);
        }
      });
    },
    getAgencyList: function getAgencyList(callback) {
      var _this28 = this;

      var queryString = "api/Data/agencies";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data && data[0]) callback(data);else callback([]);
        },
        error: function error() {
          console.error("Agency data access failed in getAgencyList()");
          _this28.globals.showErrorSnackbar(_this28.lang.G00015);
          callback({});
        }
      });
    },
    getShopperList: function getShopperList(callback) {
      var _this29 = this;

      var queryString = "api/Data/MysteryShopper";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          callback(data);
        },
        error: function error() {
          console.error("Shopper data access failed in getShopperList()");
          _this29.globals.showErrorSnackbar(_this29.lang.G00016);
          callback({});
        }
      });
    },
    getUserList: function getUserList(callback) {
      var _this30 = this;

      if (!_.isEmpty(this.userList)) {
        callback(this.userList);
        return;
      }

      var queryString = "api/Data/OpUser";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this30.userList = data;
          callback(data);
        },
        error: function error() {
          console.error("User data access failed in getUserList()");
          _this30.globals.showErrorSnackbar(_this30.lang.G00030);
          callback({});
        }
      });
    },
    getSettlementStatusses: function getSettlementStatusses(callback) {
      var _this31 = this;

      if (!_.isEmpty(this.settlementStatusses)) {
        callback(this.settlementStatusses);
        return;
      }

      var queryString = "api/Data/SettlementStatusses";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this31.settlementStatusses = data;
          callback(_this31.settlementStatusses);
        },
        error: function error() {
          console.error("Error on GET in getSettlementStatusses()");
          _this31.globals.showErrorSnackbar(_this31.lang.G00007);
        }
      });
    },
    getRoleData: function getRoleData(callback) {
      var _this32 = this;

      if (this.roleData[0]) {
        callback(this.roleData);
        return;
      }

      if (!this.$pendingRoleDataCallbacks) {
        this.$pendingRoleDataCallbacks = [callback];
      } else {
        this.$pendingRoleDataCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this32.$pendingRoleDataCallbacks), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var cb = _step7.value;
            if (cb) cb(data);
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        delete _this32.$pendingRoleDataCallbacks;
      };

      var queryString = "api/Data/RoleTypes";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this32.roleData = data;
          executeCallbacks(_this32.roleData);
        },
        error: function error() {
          console.error("Error on GET in getRoleData()");
          _this32.globals.showErrorSnackbar(_this32.lang.G00017);
          executeCallbacks([]);
        }
      });
    },
    getAgencyTypeList: function getAgencyTypeList(callback) {
      var _this33 = this;

      if (!_.isEmpty(this.agencyTypeList)) {
        callback(this.agencyTypeList);
        return;
      }

      if (!this.$pendingAgencyTypeListCallbacks) {
        this.$pendingAgencyTypeListCallbacks = [callback];
      } else {
        this.$pendingAgencyTypeListCallbacks.push(callback);
        return;
      }

      var executeCallbacks = function executeCallbacks(data) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this33.$pendingAgencyTypeListCallbacks), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var cb = _step8.value;
            cb(data);
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }

        delete _this33.$pendingAgencyTypeListCallbacks;
      };

      var queryString = "api/Data/AgencyTypes";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this33.agencyTypeList = data;
          executeCallbacks(_this33.agencyTypeList);
        },
        error: function error() {
          console.error("Error on GET in getAgencyTypeList()");
          _this33.globals.showErrorSnackbar(_this33.lang.G00027);
          executeCallbacks([]);
        }
      });
    },
    getDistanceUnitList: function getDistanceUnitList(callback) {
      var _this34 = this;

      if (!_.isEmpty(this.distanceUnitList)) {
        callback(this.distanceUnitList);
        return;
      }

      var queryString = "api/Data/DistanceUnits";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this34.distanceUnitList = data;
          callback(_this34.distanceUnitList);
        },
        error: function error() {
          console.error("Error on GET in getDistanceUnitList()");
          _this34.globals.showErrorSnackbar(_this34.lang.G00019);
        }
      });
    },
    getCountryLanguageList: function getCountryLanguageList(callback) {
      var _this35 = this;

      if (!_.isEmpty(this.countryLanguageList)) {
        callback(this.countryLanguageList);
        return;
      }

      var queryString = "api/Data/CountryLanguages";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this35.countryLanguageList = data;
          callback(_this35.countryLanguageList);
        },
        error: function error() {
          console.error("Error on GET in getCountryLanguageList()");
          _this35.globals.showErrorSnackbar(_this35.lang.G00020);
        }
      });
    },
    getLocaleList: function getLocaleList(callback) {
      var _this36 = this;

      if (!_.isEmpty(this.localeList)) {
        callback(this.localeList);
        return;
      }

      var queryString = "api/Data/Locales";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this36.localeList = data;
          callback(_this36.localeList);
        },
        error: function error() {
          console.error("Error on GET in getLocaleList()");
          _this36.globals.showErrorSnackbar(_this36.lang.G00021);
        }
      });
    },
    getPasswordPolicyList: function getPasswordPolicyList(callback) {
      var _this37 = this;

      if (!_.isEmpty(this.passwordPolicyList)) {
        callback(this.passwordPolicyList);
        return;
      }

      var queryString = "api/Data/PasswordPolicy";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this37.passwordPolicyList = data;
          callback(_this37.passwordPolicyList);
        },
        error: function error() {
          console.error("Error on GET in getPasswordPolicyList()");
          _this37.globals.showErrorSnackbar(_this37.lang.G00006);
        }
      });
    },
    getSurveyInstancesStatusList: function getSurveyInstancesStatusList(callback) {
      var _this38 = this;

      if (!_.isEmpty(this.surveyInstancesStatusList)) {
        callback(this.surveyInstancesStatusList);
        return;
      }

      var queryString = "api/Data/SurveyInstancesStatusses";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this38.surveyInstancesStatusList = data;
          callback(_this38.surveyInstancesStatusList);
        },
        error: function error() {
          console.error("Error on GET in getSurveyInstancesStatusList()");
          _this38.globals.showErrorSnackbar(_this38.lang.G00022);
        }
      });
    },

    // source: https://stackoverflow.com/questions/20600800/js-client-side-exif-orientation-rotate-and-mirror-jpeg-images
    getImageOrientation: function getImageOrientation(image, callback) {
      if (!image) return;

      var reader = new FileReader();

      reader.onload = function (event) {
        var view = new DataView(event.target.result);

        if (view.getUint16(0, false) != 0xffd8) return callback(-2);

        var length = view.byteLength,
            offset = 2;

        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;

          if (marker == 0xffe1) {
            if (view.getUint32(offset += 2, false) != 0x45786966) {
              return callback(-1);
            }
            var little = view.getUint16(offset += 6, false) == 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;

            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) == 0x0112) return callback(view.getUint16(offset + i * 12 + 8, little));
            }
          } else if ((marker & 0xff00) != 0xff00) break;else offset += view.getUint16(offset, false);
        }
        return callback(-1);
      };

      reader.readAsArrayBuffer(image.slice(0, 64 * 1024));
    },
    resetImageOrientation: function resetImageOrientation(srcImage, srcOrientation, callback) {
      var _this39 = this;

      if (srcOrientation === 1) {
        callback(srcImage);
        return;
      }

      var img = new Image();

      img.onload = function () {
        var width = img.width,
            height = img.height,
            canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");

        // set proper canvas dimensions before transform & export
        if (4 < srcOrientation && srcOrientation < 9) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            break;
        }

        // draw image
        ctx.drawImage(img, 0, 0);

        var file = _this39.dataURItoBlob(canvas.toDataURL(srcImage.type));
        file.name = srcImage.name;
        file.lastModifiedDate = new Date();

        // export base64
        callback(file);
      };

      img.src = srcImage.imageUrl;
    },

    //source: https://web.archive.org/web/20160425180542/http://blog.devteaminc.co/posting-a-canvas-image-to-twitter-using-oauth/
    dataURItoBlob: function dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);else byteString = unescape(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    doAfterNTicks: function doAfterNTicks(that, n, f) {
      var _this40 = this;

      that.$nextTick(function () {
        if (n < 2) f();else _this40.doAfterNTicks(that, n - 1, f);
      });
    },

    //source: https://stackoverflow.com/questions/16308037/detect-when-elements-within-a-scrollable-div-are-out-of-view
    isNodeVisibleInDOM: function isNodeVisibleInDOM(elem, container, partial) {
      var contHeight = $(container).height();
      var elemTop = $(elem).offset().top - $(container).offset().top;
      var elemBottom = elemTop + $(elem).height();

      var isTotal = elemTop >= 0 && elemBottom <= contHeight;
      var isPart = (elemTop < 0 && elemBottom > 0 || elemTop > 0 && elemTop <= contHeight) && partial;

      return isTotal || isPart;
    },
    truncateString: function truncateString(str, maxLength) {
      if (!str || typeof str !== "string") return "";
      return _.truncate(str, {
        length: maxLength,
        separator: " "
      });
    },
    getMarkupText: function getMarkupText(html) {
      if (!html || typeof html !== "string") return "";
      var container = document.createElement("DIV");
      container.innerHTML = html;
      return container.textContent || container.innerText || "";
    },
    isLocalizedDateTodayOrBefore: function isLocalizedDateTodayOrBefore(date) {
      var momentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date, this.currentDateFormatForMoment);
      return momentDate.isValid() && this.isISODateTodayOrBefore(momentDate);
    },
    isISODateTodayOrBefore: function isISODateTodayOrBefore(date) {
      if (!date) return false;
      var momentDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date);
      if (!momentDate.isValid()) return false;
      var today = __WEBPACK_IMPORTED_MODULE_6_moment___default()(new Date());
      return momentDate.isSameOrBefore(today, "day");
    },
    stringEqualsWithoutWildcard: function stringEqualsWithoutWildcard(str1, str2) {
      if (typeof str1 !== "string" || typeof str2 !== "string") return false;
      str1 = str1.replace(/%/g, "");
      str2 = str2.replace(/%/g, "");
      if (str1 === str2) return true;
      return false;
    },
    removeWildcardsFromString: function removeWildcardsFromString(str) {
      if (typeof str !== "string") return "";
      return str.replace(/%/g, "");
    },
    addWildcardsToString: function addWildcardsToString(str) {
      if (!str || typeof str !== "string") return "";
      return "%" + str + "%";
    },
    roleTypeHasSuffix: function roleTypeHasSuffix(guid, suffix) {
      if (!guid || !suffix || _.isEmpty(this.roleData)) return false;
      var rt = _.find(this.roleData, function (r) {
        return r.RoleTypeGuid === guid;
      });
      if (!rt) {
        console.error("Role type not found");
        return false;
      }
      return _.endsWith(rt.RoleTypeName, suffix);
    },
    getUserRole: function getUserRole() {
      var _this41 = this;

      if (_.isEmpty(this.currentUserInfo) || _.isEmpty(this.currentUserInfo.RoleGuid)) return false;
      var role = null;
      var roleType = _.find(this.roleData, function (r) {
        return r.RoleTypeGuid.toLowerCase == _this41.currentUserInfo.RoleTypeGuid.toLowerCase;
      });
      if (!roleType) {
        return false;
      } else {
        role = _.find(roleType.Roles, function (r) {
          return r.RoleGuid.toLowerCase == _this41.currentUserInfo.RoleGuid.toLowerCase;
        });
      }
      if (role != null) {
        return role;
      }
      return false;
    },
    doAfterEvents: function doAfterEvents(eventList, task) {
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

      var count = eventList.length;
      var execute = function execute() {
        if (--count > 0) return;
        task();
      };
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(eventList), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var event = _step9.value;

          target.$once(event, execute);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    insertAtCaret: function insertAtCaret(areaId, text) {
      var area = document.getElementById(areaId);
      var start = area.selectionStart;
      var end = area.selectionEnd;

      $(area).val($(area).val().substring(0, start) + text + $(area).val().substring(end));
      area.selectionStart = area.selectionEnd = start + 1;
    }
  },
  watch: {
    selectedLanguage: function selectedLanguage(newLanguage) {
      if (newLanguage) {
        this.langCache = {};
        this.getLanguageStrings(this);
        this.localizeFlatpickrConfig();
        this.settlementStatusses = {};
        this.countryList = {};
        this.regionsList = [];
        this.occupationalGroupList = {};
        this.roleData = [];
        this.getRoleData();
        this.$emit("languageUpdated");
      }
    }
  },
  data: function data() {
    return {
      currentUserInfo: null,
      selectedLanguage: "",
      spinnerVisible: false,
      tooltipDelay: {
        show: 500,
        hide: 100
      },
      /**
       * We used to have clickOpens: false,
       * This was to manually call open() ,but it breaks mobile views so we use the default onClick from flatpickr now
       */
      flatpickrDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        defaultDate: [""],
        locale: "en"
      },
      flatpickrIsoDateConfig: {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Z",
        defaultDate: [""],
        locale: "en"
      },
      flatpickrTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        locale: "en"
      },
      flatpickrDatetimeConfig: {
        altInput: true,
        altFormat: "Y-m-d H:i",
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        locale: "en"
      },
      snackbarConfig: {
        content: "", // text of the snackbar
        style: "",
        timeout: 3000,
        htmlAllowed: false
      },
      countryList: {},
      occupationalGroupList: {},
      timezonesList: [],
      regionsList: [],
      languageList: {},
      marketList: [],
      roleData: [],
      agencyTypeList: [],
      userList: [],
      distanceUnitList: {},
      countryLanguageList: [],
      localeList: [],
      passwordPolicyList: [],
      surveyInstancesStatusList: [],
      settlementStatusses: {},
      clientList: [],
      importerList: [],
      carModelList: [],
      carSegmentList: [],
      clientTypes: [],
      departmentUsers: [],
      pendingUploads: {},
      currentUploadProgress: 100,
      langCache: {},
      lang: {
        G00000: "No results found",
        G00001: "Upload canceled",
        G00002: "Upload failed",
        G00003: "Language data access failed",
        G00004: "Country data request failed",
        G00005: "Occupational group data request failed",
        G00006: "Password policy data request failed",
        G00007: "Invoice status list data request failed",
        G00008: "Timezone data request failed",
        G00009: "Region data request failed",
        G00010: "Language data request failed",
        G00011: "Client data request failed",
        G00012: "Project data request failed",
        G00013: "Wave data request failed",
        G00014: "Scenario data request failed",
        G00015: "Agency data request failed",
        G00016: "Shopper data request failed",
        G00017: "Role data request failed",
        G00018: "Security role data request failed",
        G00019: "Distance unit data request failed",
        G00020: "Country language data request failed",
        G00021: "Locale data request failed",
        G00022: "Check status data request failed",
        G00023: "Success",
        G00024: "Error",
        G00025: "File download failed",
        G00026: "Importer data request failed",
        G00027: "Agency type data request failed",
        G00028: "Car model data request failed",
        G00029: "Car segment data request failed",
        G00030: "User data request failed",
        G00031: "Client type data request failed",
        G00032: "Department users data request failed",
        G00033: "File compression before uploading failed",
        G00034: "Market data request failed"
      }
    };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (globals);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);



/**
 * @typedef {import('lodash')} _
 */


var API_BASE = "api/Surveys";

function lockSurvey(id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].patch("API_BASE/" + id + "/Lock", { Lock: true }).then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function deleteByID(id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].delete(API_BASE + "/" + id).then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function getByID(id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_BASE + "/" + id).then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function exportByID(id) {
  var queryString = API_BASE + "/" + id + "/Export";
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_BASE + "/" + id + "/Export").then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

/**
 *
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise}
 */
function getAll() {
  var filterStrings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var selectedPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var sortField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "SurveyTitle";
  var sortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "asc";

  var queryString = API_BASE + "/Get?page_size=" + pageSize + "&page=" + selectedPage + "&sort_column=" + sortField + "&sort_order=" + sortOrder;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  var Filter = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(filterStrings) ? "" : filterStrings;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(queryString, { Filter: Filter }).then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function create(content) {
  var queryString = "" + API_BASE;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(queryString, content).then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}

function update(id, content) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].put(API_BASE + "/" + id, content);
}

function getCustomPropertiesByID(id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_BASE + "/" + id + "/CustomProperties").then(function (response) {
      if (response.Error) {
        reject("Backendmsg:" + response.Error);
      }
      resolve(response);
    }).catch(function (err) {
      return reject(err);
    });
  });
}
var UseSurvey = {
  getAll: getAll,
  getByID: getByID,
  create: create,
  update: update,
  lockSurvey: lockSurvey,
  deleteByID: deleteByID,
  exportByID: exportByID,
  getCustomPropertiesByID: getCustomPropertiesByID
};

/* harmony default export */ __webpack_exports__["a"] = (UseSurvey);

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__features_json__);



var CURRENT_TARGET = "deutscheBahn" || ["dev"];

var feature = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  computed: {
    currentTarget: function currentTarget() {
      return CURRENT_TARGET;
    },
    isAudiTarget: function isAudiTarget() {
      return CURRENT_TARGET.includes("audi");
    },
    isDBTarget: function isDBTarget() {
      return CURRENT_TARGET.includes("deutscheBahn");
    },
    isPorscheTarget: function isPorscheTarget() {
      return CURRENT_TARGET.includes("porsche");
    },
    isMSMGermanyTarget: function isMSMGermanyTarget() {
      if (CURRENT_TARGET.includes("dev") || CURRENT_TARGET.includes("prod") || CURRENT_TARGET.includes("training")) return true;else return false;
    }
  },
  methods: {
    isEnabled: function isEnabled(name) {
      if (!__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name] || !__WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target) {
        console.error("Unknown feature: " + name);
        return false;
      }

      var targets = __WEBPACK_IMPORTED_MODULE_1__features_json___default.a[name].target.split(" ");
      if (targets.indexOf(CURRENT_TARGET) > -1) return true;
      return false;
    },
    isDisabled: function isDisabled(name) {
      return !this.isEnabled(name);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (feature);

/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * An Answer Object
 * @typedef AnswerObject
 * @property {number} SurveyInstanceId The Id and PK of the Object
 * @property {Object} SurveyInstanceAnswer List of questions with answers
 */

/**
 * An Answer Object
 * @typedef LanguageObj
 * @property {number} SurveyInstanceId The Id and PK of the Object
 * @property {Object} SurveyInstanceAnswer List of questions with answers
 */

/**
 * @typedef StoredAnswers
 * @property {number} id
 * @property {questions}
 */

/**
 * @typedef questions
 * @property { Array | String} questionName
 */

/**
 * @typedef SurveyObj
 * @property {String} title
 * @property {Array} pages
 * @property {String} showQuestionNumbers
 */

/**
 * @typedef {object} SurveyInstanceData
 * @property {String} ClientGuid
 * @property {number} ClientId
 * @property {Array<LanguageObj>} Languages
 * @property {String} LocaleCode
 * @property {String} LocationAddress
 * @property {String} LocationCountry
 * @property {String} LocationName
 * @property {String} LocationStoreId
 * @property {String} ScenarioName
 * @property {SurveyObj} Survey
 * @property {number} SurveyId
 * @property {Object} SurveyInstanceAnswer
 * @property {String} SurveyInstanceAnswerMemoAgency
 * @property {String} SurveyInstanceAnswerMemoMSM
 * @property {String} SurveyInstanceAnswerMemoShopper
 * @property {number} SurveyInstanceAnswerPoints
 * @property {Object} SurveyInstanceAnswerPosition
 * @property {boolean} SurveyInstanceAnswerReadOnly
 * @property {String} SurveyInstanceGuid
 * @property {number} SurveyInstanceId
 * @property {number} SurveyInstanceProgress
 * @property {number} SurveyInstanceStatusId
 * @property {String} SurveyInstanceType
 * @property {String} WaveName
 */

/**
 * @typedef  newTicketData
 * @property {String} Comment
 * @property {number} SurveyInstanceId
 * @property {Array<String>} FileGuidList
 * @property {String} Answer
 * @property {String} FileGuids
 * @property {String} QuestionGuid
 * @property {String} ExpirationDate
 * @property {String} Name
 */

/**
 * @typedef StoredFlags
 * @type {object}
 * @property {SurveyFlags}
 * @property {boolean} redirectCache
 */

/**
 * @typedef SurveyFlags
 * @property {boolean} offlineCache
 */

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79e3792d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = {"name":"msm_loop_v2","version":"2.4.9.1","description":"MSM Loop v2","author":"Marc Stöckel","private":true,"scripts":{"local":"node build/dev-server.js config=localhost","dev":"node build/dev-server.js","dev-msm":"node build/dev-server.js config=dev.projects.msmloop.com","dev-db":"node build/dev-server.js config=dev.projects.qm-servicestoredb.de","dev-audi":"node build/dev-server.js config=projects-audi.dsinux.hh-it.local","start":"node build/dev-server.js","build":"node build/build.js","test":"jest","prod":"node build/dev-server.js config=projects.prod","selenium":"webdriver-manager update && webdriver-manager start","e2e":"protractor _e2etests_/protractor-local.conf.js"},"googleApiKeys":{"dev":"AIzaSyAYTZ_Xy5ho5kkg8hr91JiSYdoXY16JgqI","msm":"AIzaSyANcvr9_qvJu0_Qj4DqcWPygtQALed9pRQ","audi":"AIzaSyANXa3eXWwvDKV4fU94IJAsYDdhQTqe3lo"},"jest":{"setupFiles":["./src/setup-jest.js"],"moduleFileExtensions":["js","json","vue"],"testMatch":["**/?(*.)+(test).[jt]s?(x)"],"moduleNameMapper":{"^@[/](.+)":"<rootDir>/src/$1","^components[/](.+)":"<rootDir>/src/components/$1","src/components/([^\\.]*)$":"<rootDir>/src/components/$1.vue","^vue$":"vue/dist/vue.common.js","src/([^\\.]*)$":"<rootDir>/src/$1.vue","ace-builds":"<rootDir>/node_modules/ace-builds","\\.(css|less|scss|sass)$":"identity-obj-proxy"},"transform":{".*\\.(vue)$":"vue-jest",".+\\.(css|styl|less|sass|scss|png|jpg|ttf|woff|woff2)$":"jest-transform-stub","^.+\\.js$":"<rootDir>/node_modules/babel-jest"},"transformIgnorePatterns":["<rootDir>/node_modules/(?!(cropperjs)/)"],"collectCoverage":false,"collectCoverageFrom":["src/components/**/*.{js,vue}","!**/node_modules/**"],"coverageReporters":["html","text-summary"],"reporters":["default","jest-junit"],"testPathIgnorePatterns":["/node_modules/","/_e2etests_/"]},"dependencies":{"@riophae/vue-treeselect":"0.0.38","ace-builds":"1.4.7","animate.css":"3.7.0","axios":"^0.21.1","base64url":"3.0.1","bootstrap":"3.3.7","bootstrap-material-design":"0.5.10","bootstrap-vue":"2.0.0-rc.11","bootstrap4":"npm:bootstrap@4.5.2","compress.js":"^1.1.2","css-vars-ponyfill":"2.2.1","dhtmlx-gantt":"7.1.12","flatpickr":"4.6.3","inputmask":"4.0.8","jquery":"3.3.1","liquor-tree":"0.2.61","localforage":"^1.10.0","lodash":"4.17.11","material-design-icons":"3.0.1","moment":"2.24.0","phantomjs-prebuilt":"^2.1.16","protractor":"^7.0.0","select2":"4.0.10","snackbarjs":"1.1.0","survey-creator":"1.8.75","survey-knockout":"1.8.75","survey-vue":"1.8.45","text-encoding-shim":"1.0.5","typeface-roboto":"0.0.54","uuid":"3.3.2","v-tooltip":"2.0.3","vue":"2.6.12","vue-click-outside":"1.0.7","vue-cropperjs":"3.0.0","vue-currency-input":"1.6.0","vue-router":"3.0.1","vue-treeselect":"^1.0.7","vuex":"3.1.3","vuex-persist":"^3.1.3","xlsx":"^0.16.9"},"devDependencies":{"@vue/test-utils":"1.0.0-beta.27","autoprefixer":"^6.7.2","babel-core":"^6.22.1","babel-jest":"23.6.0","babel-loader":"^6.2.10","babel-plugin-transform-es2015-for-of":"^6.23.0","babel-plugin-transform-runtime":"^6.22.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chalk":"^1.1.3","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","css-loader":"^0.28.0","eventsource-polyfill":"^0.9.6","execa":"^1.0.0","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","flush-promises":"^1.0.2","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.19.1","identity-obj-proxy":"^3.0.0","jasmine-reporters":"^2.3.2","jasmine-spec-reporter":"^7.0.0","jest":"23.6.0","jest-junit":"^12.3.0","jest-transform-stub":"^2.0.0","node-sass":"^7.0.0","npm":"^6.4.1","opn":"^4.0.2","optimize-css-assets-webpack-plugin":"^1.3.0","ora":"^1.2.0","protractor-jasmine2-screenshot-reporter":"^0.5.0","rimraf":"^2.6.0","sass-loader":"6.0.6","semver":"^5.3.0","shelljs":"^0.8.5","url-loader":"^1.0.1","vue-jest":"3.0.0","vue-loader":"^12.1.0","vue-style-loader":"^3.0.1","vue-template-compiler":"2.6.12","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0","webpack-version-file-plugin":"^0.3.3","ws":"3.3.2"},"engines":{"node":"16.x.x","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_typdefs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__types_typdefs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__View__ = __webpack_require__(391);





var API_BASE = "api/SurveyInstances";
var API_HIST = "api/SurveyInstanceHistory";

/**
 *
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise<SurveyInstanceData[]>}
 */
function getAll(filterStrings) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var selectedPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var sortField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "SurveyInstanceId";
  var sortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "asc";

  var queryString = API_BASE + "/Get?page_size=" + pageSize + "&page=" + selectedPage + "&sort_column=" + sortField + "&sort_order=" + sortOrder;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  var Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(queryString, { Filter: Filter });
}

/**
 *
 * @param {SurveyInstanceData} content
 * @returns
 */
function create(content) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post("" + API_BASE, content);
}

/**
 *
 * @param {number} id The SurveyInstanceId
 * @returns
 */
function deleteByID(id) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].delete(API_BASE + "/" + id);
}
/**
 * Fetch the History of the check
 * The fields wich  are in the history are defined in the DB
 * @param {number} id - The check id
 * @returns the Object with the checkHistory
 */
function getHistoryByID(id) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_HIST + "/" + id);
}

/**
 * Fetch the History of the check
 * The fields wich are in the history are defined in the DB
 * @param {string} guid - The check guid
 * @returns the Object with the checkHistory
 */
function getHistoryByGUID(guid) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_HIST + "/" + guid);
}

/**
 * change the status of a single SurveyInstance
 * @param {number} id - the Id
 * @param {number} newstatus - the new Status
 * @returns
 */
function changeStatus(id, newstatus) {
  var sendData = {
    SurveyInstanceIds: [id],
    SurveyInstanceStatusId: newstatus
  };
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].put(API_BASE, sendData);
}

/**
 * change the status of multiple SurveyInstances
 * @param {number[]} id - the id's of the SurveyInstances
 * @param {number} newstatus - the new status of all the SurveyInstances
 * @returns
 */
function changeStatusMultiple(id, newstatus) {
  var sendData = {
    SurveyInstanceIds: id,
    SurveyInstanceStatusId: newstatus
  };
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].put(API_BASE, sendData);
}

/**
 * 
 * @param {number} id 
 * @returns 
 */
function getOneSurveyAndSurveyInstanceJson(id) {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(API_BASE + "/SurveyAndSurveyInstanceJsons/", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([id]));
}

/**
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {*} filter 
 * @returns {Promise<SurveyInstanceData[]>}
 */
function getExport(clientGuid, fileType, filterStrings) {
  var Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(API_BASE + "/Export/" + clientGuid + "?file_type=" + fileType, { Filter: Filter });
}

/**
 * All API calls concerning Checks/SurveyInstances
 */
var UseSurveyInstance = {
  getAll: getAll,
  create: create,
  deleteByID: deleteByID,
  getHistoryByGUID: getHistoryByGUID,
  getHistoryByID: getHistoryByID,
  changeStatus: changeStatus,
  changeStatusMultiple: changeStatusMultiple,
  getOneSurveyAndSurveyInstanceJson: getOneSurveyAndSurveyInstanceJson,
  getExport: getExport,
  View: __WEBPACK_IMPORTED_MODULE_3__View__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (UseSurveyInstance);

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    /**
     * Toggles the adding of a 'loading' class to the main
     * .v-select wrapper. Useful to control UI state when
     * results are being processed through AJAX.
     */
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      mutableLoading: false
    };
  },


  watch: {
    /**
     * Anytime the search string changes, emit the
     * 'search' event. The event is passed with two
     * parameters: the search string, and a function
     * that accepts a boolean parameter to toggle the
     * loading state.
     *
     * @emits search
     */
    search: function search() {
      this.$emit('search', this.search, this.toggleLoading);
    },


    /**
     * Sync the loading prop with the internal
     * mutable loading value.
     * @param val
     */
    loading: function loading(val) {
      this.mutableLoading = val;
    }
  },

  methods: {
    /**
     * Toggle this.loading. Optionally pass a boolean
     * value. If no value is provided, this.loading
     * will be set to the opposite of it's current value.
     * @param toggle Boolean
     * @returns {*}
     */
    toggleLoading: function toggleLoading() {
      var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (toggle == null) {
        return this.mutableLoading = !this.mutableLoading;
      }
      return this.mutableLoading = toggle;
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    autoscroll: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    typeAheadPointer: function typeAheadPointer() {
      if (this.autoscroll) {
        this.maybeAdjustScroll();
      }
    },
    open: function open(_open) {
      var _this = this;

      if (this.autoscroll && _open) {
        this.$nextTick(function () {
          return _this.maybeAdjustScroll();
        });
      }
    }
  },

  methods: {
    /**
     * Adjust the scroll position of the dropdown list
     * if the current pointer is outside of the
     * overflow bounds.
     * @returns {*}
     */
    maybeAdjustScroll: function maybeAdjustScroll() {
      var optionEl = this.$refs.dropdownMenu ? this.$refs.dropdownMenu.children[this.typeAheadPointer] || false : false;

      if (optionEl) {
        var bounds = this.getDropdownViewport();

        var _optionEl$getBounding = optionEl.getBoundingClientRect(),
            top = _optionEl$getBounding.top,
            bottom = _optionEl$getBounding.bottom,
            height = _optionEl$getBounding.height;

        if (top < bounds.top) {
          return this.$refs.dropdownMenu.scrollTop = optionEl.offsetTop;
        } else if (bottom > bounds.bottom) {
          return this.$refs.dropdownMenu.scrollTop = optionEl.offsetTop - (bounds.height - height);
        }
      }
    },


    /**
     * The currently viewable portion of the dropdownMenu.
     * @returns {{top: (string|*|number), bottom: *}}
     */
    getDropdownViewport: function getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      typeAheadPointer: -1
    };
  },


  watch: {
    filteredOptions: function filteredOptions() {
      for (var i = 0; i < this.filteredOptions.length; i++) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },
    open: function open(_open) {
      if (_open) {
        this.typeAheadToLastSelected();
      }
    },
    selectedValue: function selectedValue() {
      if (this.open) {
        this.typeAheadToLastSelected();
      }
    }
  },

  methods: {
    /**
     * Move the typeAheadPointer visually up the list by
     * setting it to the previous selectable option.
     * @return {void}
     */
    typeAheadUp: function typeAheadUp() {
      for (var i = this.typeAheadPointer - 1; i >= 0; i--) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },


    /**
     * Move the typeAheadPointer visually down the list by
     * setting it to the next selectable option.
     * @return {void}
     */
    typeAheadDown: function typeAheadDown() {
      for (var i = this.typeAheadPointer + 1; i < this.filteredOptions.length; i++) {
        if (this.selectable(this.filteredOptions[i])) {
          this.typeAheadPointer = i;
          break;
        }
      }
    },


    /**
     * Select the option at the current typeAheadPointer position.
     * Optionally clear the search input on selection.
     * @return {void}
     */
    typeAheadSelect: function typeAheadSelect() {
      var typeAheadOption = this.filteredOptions[this.typeAheadPointer];

      if (typeAheadOption && this.selectable(typeAheadOption)) {
        this.select(typeAheadOption);
      }
    },


    /**
     * Moves the pointer to the last selected option.
     */
    typeAheadToLastSelected: function typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationTranslation__ = __webpack_require__(389);



/**
 * @typedef {string} GUID
 */
/**
 * @typedef {Object} Location
 * @property {number} ClientId
 * @property {string} LocationStoreId
 * @property {string} LocationName
 * @property {string} LocationStatusId
 */

//api/SurveyInstanceHistory/{SurveyInstanceGuid}
var API_BASE = "/api/Locations";
var API_HIST = "api/LocationHistory";

/**
 * Gets all location Paginated
 * @param {Object} filterStrings Contains the Columms as key and the filter as values
 * @param {Number} pageSize Items per page
 * @param {Number} selectedPage The Selected Field
 * @param {String} sortField The Field to sort by
 * @param {('asc'|'desc')} [sortOrder]  Sort order
 * @returns {Promise<import('axios').AxiosResponse<Location[]>}
 * @re
 */
function getAll(filterStrings) {
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var selectedPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var sortField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "LocationName";
  var sortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "asc";

  var queryString = API_BASE + "/Get?page_size=" + pageSize + "&page=" + selectedPage + "&sort_column=" + sortField + "&sort_order=" + sortOrder;
  queryString = encodeURI(queryString);

  //TODO: validate Filter and trim
  var Filter = _.isEmpty(filterStrings) ? "" : filterStrings;

  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].post(queryString, { Filter: Filter });
}

/**
 * Gets a singel Location
 * @param {number} id
 * @returns {Promise<import('axios').AxiosResponse<Location>}
 */
function getById(id) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + id);
}

/**
 *
 * @param {Location} content
 * @returns {Promise<import('axios').AxiosResponse<any[]>}
 */
function create(content) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].post("" + API_BASE, content);
}

/**
 * Update a single Location
 * @param {number} id The Location id you want to update
 * @param {Location} content The new Location data
 */
function update(id, content) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(API_BASE + "/" + id, content);
}

/**
 * Delete a single Location
 * @param {number} id The id of the Location you want to delete
 */
function deleteByID(id) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].delete(API_BASE + "/" + id);
}

/**
 * Fetch the History of a single Location
 * @param {GUID} id - The Location GUID
 */
function getHistoryByGUID(GUID) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_HIST + "/" + GUID);
}
/**
 * Create a Translation for a given Location
 * @param {GUID} guid
 */
function createTranslation(guid, data) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].post(API_BASE + "/" + guid + "/Translations", data);
}
/**
 * Get all the Translation for a given Location
 * @param {GUID} guid
 * @returns
 */
function getTranslation(guid) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + guid + "/Translations");
}

var UseLocation = {
  getAll: getAll,
  getById: getById,
  create: create,
  update: update,
  deleteByID: deleteByID,
  getHistoryByGUID: getHistoryByGUID,
  Translations: {
    create: createTranslation,
    update: __WEBPACK_IMPORTED_MODULE_1__LocationTranslation__["a" /* default */].update,
    delete: __WEBPACK_IMPORTED_MODULE_1__LocationTranslation__["a" /* default */].deleteByGuid,
    getAll: getTranslation
  }
};

/* harmony default export */ __webpack_exports__["a"] = (UseLocation);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IndexDB__ = __webpack_require__(387);









var UploadFilesService = function () {
  function UploadFilesService() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, UploadFilesService);

    this.DB_NAME = __WEBPACK_IMPORTED_MODULE_7__IndexDB__["a" /* DB_NAME */];
  }
  /**
   *
   * @param {File} file The file you want to Upload
   * @param {Function} progresscallback - optional callback for Progress event
   * @returns {Promise<R>} - returns the response in a Promise
   */


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(UploadFilesService, [{
    key: "upload",
    value: function upload(file) {
      var progresscallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var formData = new FormData();
      var onUploadProgress = progresscallback;
      if (!progresscallback) {
        onUploadProgress = function onUploadProgress(r) {};
      }
      formData.append("file", file);

      return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].post("api/Upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress: onUploadProgress
      });
    }
    /**
     *
     * @param  {Array<SurveyInstanceAnswerFile>}files JSON of files like saved for SurveyInstanceAnswer
     * @returns
     */

  }, {
    key: "delete",
    value: function _delete(files) {
      return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].post("api/Download/Delete", __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(files));
    }

    /**
     *
     * @param {String} id guid of the file
     * @param {boolean} offline true if we want to acces the cache
     * @returns {Promise<File> | Promise<import("axios").AxiosResponse<File>>}
     */

  }, {
    key: "getFilesbyId",
    value: function getFilesbyId(id) {
      var offline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (offline) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__IndexDB__["b" /* getFilefromDB_byID */])(id);
      }
      return __WEBPACK_IMPORTED_MODULE_6__requestBase__["a" /* default */].get("/api/Download/" + id, {
        responseType: "blob"
      });
    }
  }, {
    key: "clearOfflineFiles",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__IndexDB__["c" /* clearFileStore */])();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function clearOfflineFiles() {
        return _ref.apply(this, arguments);
      }

      return clearOfflineFiles;
    }()
  }, {
    key: "isFileChached",
    value: function isFileChached(key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__IndexDB__["d" /* storeHas */])(__WEBPACK_IMPORTED_MODULE_7__IndexDB__["e" /* FILES_STORE_NAME */], key);
    }
  }, {
    key: "offlineUpload",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(file, id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = [];
                _context2.t1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default.a;
                _context2.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__IndexDB__["f" /* addFiletoDB */])(file, id);

              case 4:
                _context2.t2 = _context2.sent;
                _context2.t3 = (0, _context2.t1)(_context2.t2);
                _context2.t4 = _context2.t0.concat.call(_context2.t0, _context2.t3);
                _context2.t5 = {
                  DownloadId: _context2.t4
                };
                _context2.t6 = [_context2.t5];
                result = {
                  data: _context2.t6
                };
                return _context2.abrupt("return", result);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function offlineUpload(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return offlineUpload;
    }()
  }]);

  return UploadFilesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (new UploadFilesService());

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);


var API_BASE = "api/UserSecurity";

// `api/UserSecurity/${this.editUserDialogData.userData.UserId}/LocationProperties`;

var LocationProperties = {
  /**
   * All LocationProperties of one Client and the permission of the Use
   * @param {string} ClientGuid the guid of the Client
   * @param {string} UserGuid the guid of the User
   * @returns - returns an Array
   */
  getforUser: function getforUser(ClientGuid, UserGuid) {
    return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + UserGuid + "/LocationProperties/Client/" + ClientGuid);
  },

  /**
   * Update the LocationProperties for a given User
   * @param {string} UserGuid the guid of the User
   * @param {object[]} data The Properties you want to update
   * @returns
   */
  updateforUser: function updateforUser(UserGuid, data) {
    return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(API_BASE + "/" + UserGuid + "/LocationProperties", data);
  },


  /**
   *  Get list of propertie names which are not allowed for creation of new cx properties.
   */
  getCxProperties: function getCxProperties() {
    return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/CxProperties");
  }
};

// TODO: Add Locations,Project,etc
var UseUserSecurity = {
  LocationProperties: LocationProperties
};

/* harmony default export */ __webpack_exports__["a"] = (UseUserSecurity);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__globals__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feature__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Live__ = __webpack_require__(142);











var base64url = __webpack_require__(690);
if (false) {
  process.auth = {};
}
var SERVER_URL = "https://authentication.qm-servicestoredb.de/";
var CLIENT_URL = "https://projects.qm-servicestoredb.de/#/";

/* harmony default export */ __webpack_exports__["a"] = ({
  // app wide variables
  tokenRenewalPending: false,
  tokenRenewalCallbacks: [],
  appReloadPending: false,
  dynamicDomain: null,
  // app functions
  isJWTExpired: function isJWTExpired(token) {
    var payload = this.getTokenData(token);
    var expireDate = payload.exp * 1000;
    var now = Date.now();
    return now > expireDate;
  },

  /**
   * Allow using alternative Redirect Url if the feature is activated
   * @param {String} url
   * @returns if not allowed
   */
  allowAlternativeRedirectUrl: function allowAlternativeRedirectUrl(url) {
    var _this = this;

    if (!__WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].isEnabled("MultipleDomains") || ![]) return;

    var urlArray = url.split("/");
    [].forEach(function (redirect) {
      if (urlArray.length >= 5 && urlArray.slice(0, 4).join("/") + "/" === redirect) {
        _this.dynamicDomain = redirect;
      }
    });
    if (!this.dynamicDomain) {
      this.dynamicDomain = CLIENT_URL;
    }
  },

  /**
   * @returns ServerURL
   */
  getServerUrl: function getServerUrl() {
    return SERVER_URL;
  },

  /**
   * @returns ClientURL
   */
  getClientURL: function getClientURL() {
    // #1313
    if (__WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].isEnabled("MultipleDomains") && !this.dynamicDomain) this.allowAlternativeRedirectUrl(window.location.href);
    if (this.dynamicDomain) {
      return this.dynamicDomain;
    } else {
      return CLIENT_URL;
    }
  },
  isUserAuthenticated: function isUserAuthenticated() {
    var access_token = this.getAccessToken();
    return access_token ? !this.isJWTExpired(access_token) : false;
  },
  getTokenData: function getTokenData(token) {
    if (!token) return;
    var data = JSON.parse(window.atob(token.split(".")[1]));
    return data;
  },
  getAccessToken: function getAccessToken() {
    return localStorage.getItem("access_token") || null;
  },
  getIdToken: function getIdToken() {
    return localStorage.getItem("id_token") || null;
  },
  checkRouteValid: function checkRouteValid(hash) {
    if (hash.length > 2) {
      var route = hash.slice(1);
      for (var r in __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].options.routes) {
        var path = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].options.routes[r].path;
        if (path == route) return true;
      }
    }
    return false;
  },
  randomString: function randomString(length) {
    var charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~";
    var result = "";

    while (length > 0) {
      var bytes = new Uint8Array(16);
      var crypto = window.crypto || window.msCrypto;
      var random = crypto.getRandomValues(bytes);

      random.forEach(function (c) {
        if (length == 0) {
          return;
        }
        if (c < charset.length) {
          result += charset[c];
          length--;
        }
      });
    }
    return result;
  },
  hexString: function hexString(buffer) {
    var byteArray = new Uint8Array(buffer);

    var hexCodes = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(byteArray)).map(function (value) {
      var hexCode = value.toString(16);
      var paddedHexCode = hexCode.padStart(2, "0");
      return paddedHexCode;
    });

    return hexCodes.join("");
  },
  digestMessage: function digestMessage(message) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var encoder, data, crypto, result;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              encoder = new __WEBPACK_IMPORTED_MODULE_8_text_encoding_shim__["TextEncoder"]();
              data = encoder.encode(message);
              crypto = window.crypto || window.msCrypto;
              _context.next = 5;
              return crypto.subtle.digest("SHA-256", data);

            case 5:
              result = _context.sent;

              if (result.result) result = result.result; // IE11 returns an object containing result property
              return _context.abrupt("return", result);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  digestMessageToHexString: function digestMessageToHexString(message) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this3;
              _context2.next = 3;
              return _this3.digestMessage(message);

            case 3:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", _context2.t0.hexString.call(_context2.t0, _context2.t1));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  directToLogin: function directToLogin() {
    var _this4 = this;

    this.tokenRenewalPending = true;
    var nonce = this.randomString(4096);
    var stateNonce = this.randomString(4096);
    var codeVerifier = this.randomString(128);
    this.digestMessageToHexString(nonce).then(function (nonceDigest) {
      _this4.digestMessageToHexString(stateNonce).then(function (stateDigest) {
        _this4.digestMessage(codeVerifier).then(function (codeVerifierDigest) {
          var urlData = _this4.getTokensFromUrl();
          var stateDigestFromUrl = urlData && urlData.state_digest;
          var state = void 0;
          if (stateDigestFromUrl) {
            state = sessionStorage.getItem(stateDigestFromUrl);
          } else {
            if (location.pathname.indexOf("survey.html") > -1) state = location.pathname + location.hash;else state = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].currentRoute.fullPath;
            sessionStorage.setItem(stateDigest, state);
          }
          sessionStorage.setItem("nonce_digest", nonceDigest);
          localStorage.setItem("code_verifier", codeVerifier);

          var codeVerifierDigestBase64 = base64url.encode(codeVerifierDigest);
          var postLoginRedirectUrl = _this4.getClientURL() + "callback";

          var fullAuthUrl = SERVER_URL + "connect/authorize?client_id=loopOpFrontend&redirect_uri=" + encodeURIComponent(postLoginRedirectUrl) + "&response_type=code&scope=openid%20profile%20offline_access%20loopOpBackend&state=" + (stateDigestFromUrl || stateDigest) + "&nonce=" + nonceDigest + "&code_challenge_method=S256&code_challenge=" + codeVerifierDigestBase64;

          window.location.href = fullAuthUrl;
        });
      });
    });
  },
  redirectAfterLoginCallback: function redirectAfterLoginCallback() {
    var _this5 = this;

    var tokens = this.getTokensFromUrl();
    var codeVerifier = localStorage.getItem("code_verifier");
    if (!tokens || !tokens.code || !codeVerifier) {
      console.error("Missing code in URL");
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }

    this.tokenRenewalPending = true;
    var formData = new FormData();
    formData.append("client_id", "loopOpFrontend");
    formData.append("code_verifier", codeVerifier);
    formData.append("code", tokens.code);
    formData.append("grant_type", "authorization_code");
    formData.append("redirect_uri", this.getClientURL() + "callback");
    $.ajax({
      method: "POST",
      url: SERVER_URL + "connect/token",
      data: formData,
      contentType: false,
      processData: false,
      global: false,
      success: function success(data) {
        if (data && data.access_token && data.refresh_token && data.id_token) {
          _this5.storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
          _this5.configureAjaxSetup();
          _this5.setClientTimeZone();

          _this5.tokenRenewalCallbacks.forEach(function (callback) {
            callback();
          });
          _this5.tokenRenewalCallbacks = [];

          var nonceFromToken = _this5.getTokenData(data.id_token).nonce;
          var nonceFromStorage = sessionStorage.getItem("nonce_digest");
          sessionStorage.removeItem("nonce_digest");
          var stateFromStorage = void 0;
          if (tokens.state_digest) {
            stateFromStorage = sessionStorage.getItem(tokens.state_digest);
            sessionStorage.removeItem(tokens.state_digest);
          }
          if (nonceFromStorage !== nonceFromToken || !stateFromStorage) {
            _this5.directToLogin();
          } else {
            if (stateFromStorage.indexOf("survey.html") > -1) location = window.origin + stateFromStorage;else __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push(stateFromStorage);
          }
        }
      },
      error: function error(err) {
        console.error("Error on POST in redirectAfterLoginCallback()");
        console.error(err);
        _this5.removeTokensFromStorage();
        _this5.directToLogin();
      },
      complete: function complete() {
        _this5.tokenRenewalPending = false;
      }
    });
  },
  setClientTimeZone: function setClientTimeZone() {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!tz) return;
    var query = "api/SecurityUsers/Localization?TimeZoneName=" + encodeURIComponent(tz);

    $.ajax({
      method: "PUT",
      url: query,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: function error() {
        console.error("Error on PUT in setClientTimeZone()");
        __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].showErrorSnackbar("Timezone update failed");
      }
    });
  },
  getDefaultAjaxSetupConfig: function getDefaultAjaxSetupConfig() {
    var _this6 = this;

    return {
      headers: {
        Pragma: "no-cache"
      },
      beforeSend: function beforeSend(jqXHR, options) {
        if (!_this6.isUserAuthenticated() && !options.isAuthRequest) {
          var repeatAjax = function repeatAjax() {
            $.ajax($.extend(options, {
              beforeSend: $.noop,
              headers: {
                Authorization: "Bearer " + _this6.getAccessToken()
              }
            }));
          };
          _this6.renewToken(repeatAjax);
          return false;
        }
      }
    };
  },
  configureAjaxSetup: function configureAjaxSetup() {
    var access_token = this.getAccessToken();
    if (!access_token) {
      console.error("No access token available");
      this.directToLogin();
      return;
    }
    var config = this.getDefaultAjaxSetupConfig();
    config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);
  },
  initializeGlobalAjaxEvents: function initializeGlobalAjaxEvents() {
    var _this7 = this;

    if (!localStorage.getItem("refresh_token") && !this.tokenRenewalPending) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }
    var access_token = this.getAccessToken();
    var config = this.getDefaultAjaxSetupConfig();
    if (access_token) config.headers.Authorization = "Bearer " + access_token;
    $.ajaxSetup(config);

    window.addEventListener("storage", function (e) {
      if (e.key === "refresh_token") {
        _this7.configureAjaxSetup();
      }
    });

    $(document).ajaxComplete(function (event, jqXHR, options, data) {
      var apiVersion = jqXHR.getResponseHeader("frontend-version");
      var isDevSystem = __WEBPACK_IMPORTED_MODULE_7__feature__["a" /* default */].currentTarget.indexOf("dev") > -1;
      if (!isDevSystem && !_this7.appReloadPending && apiVersion && apiVersion !== __WEBPACK_IMPORTED_MODULE_5__package_json__["version"]) {
        _this7.appReloadPending = true;
        // Force hard reload of the page if a new version of the app is available
        console.error("Frontend version mismatch - reloading page");
        __WEBPACK_IMPORTED_MODULE_9__Live__["a" /* default */].Live.clearSiteDataAll().then(function (res) {
          location.reload(true);
        }).catch(function () {
          console.error("Live error");
        });
      }

      if (jqXHR.status === 401) {
        _this7.renewToken(function () {
          $.ajax($.extend(options, {
            beforeSend: $.noop,
            headers: {
              Authorization: "Bearer " + _this7.getAccessToken()
            }
          }));
        });
      }
    });
  },
  renewToken: function renewToken(done) {
    var _this8 = this;

    if (done) this.tokenRenewalCallbacks.push(done);
    if (this.tokenRenewalPending) return;

    this.tokenRenewalPending = true;
    var refreshToken = localStorage.getItem("refresh_token");
    var codeVerifier = localStorage.getItem("code_verifier");
    if (!refreshToken || !codeVerifier) {
      this.removeTokensFromStorage();
      this.directToLogin();
      return;
    }
    var formData = new FormData();
    formData.append("client_id", "loopOpFrontend");
    formData.append("code_verifier", codeVerifier);
    formData.append("refresh_token", refreshToken);
    formData.append("grant_type", "refresh_token");
    $.ajax({
      method: "POST",
      url: SERVER_URL + "connect/token",
      data: formData,
      contentType: false,
      processData: false,
      global: false,
      isAuthRequest: true,
      success: function success(data) {
        if (data && data.access_token && data.refresh_token && data.id_token) {
          _this8.storeTokensInStorage(data.access_token, data.id_token, data.refresh_token);
          _this8.configureAjaxSetup();

          _this8.tokenRenewalCallbacks.forEach(function (callback) {
            callback();
          });
          _this8.tokenRenewalCallbacks = [];
        }
      },
      error: function error(data) {
        console.error("Error on POST in renewToken()");
        _this8.removeTokensFromStorage();
        _this8.directToLogin();
      },
      complete: function complete() {
        _this8.tokenRenewalPending = false;
      }
    });
  },
  getPostLoginUrl: function getPostLoginUrl() {
    var hashString = window.location.hash;
    var idx = hashString.indexOf("id_token");
    if (idx < 0) return "";

    var postLoginUrl = hashString.slice(2, idx);
    return postLoginUrl;
  },
  storeTokensInStorage: function storeTokensInStorage(access_token, id_token, refresh_token) {
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("id_token", id_token);
    localStorage.setItem("refresh_token", refresh_token);
    __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].$emit("accessTokenChanged");
  },
  removeTokensFromStorage: function removeTokensFromStorage() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("refresh_token");
    __WEBPACK_IMPORTED_MODULE_6__globals__["a" /* default */].$emit("accessTokenChanged");
  },
  getTokensFromUrl: function getTokensFromUrl() {
    var params = {};
    window.location.hash.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      params[key] = value;
    });

    var result = {};
    if (params.code) result.code = params.code;
    if (params.state) result.state_digest = params.state;

    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length < 1) return null;
    return result;
  },
  logout: function logout() {
    var _this9 = this;

    var logoutUrl = SERVER_URL + "connect/endsession";
    var postLogoutRedirectUrl = this.getClientURL() + "logout_callback";

    var stateNonce = this.randomString(4096);
    this.digestMessageToHexString(stateNonce).then(function (stateDigest) {
      var state = __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].currentRoute.fullPath;
      sessionStorage.setItem(stateDigest, state);

      var id_token = _this9.getIdToken();
      var fullLogoutUrl = logoutUrl + "?id_token_hint=" + id_token + "&post_logout_redirect_uri=" + encodeURIComponent(postLogoutRedirectUrl) + "&state=" + stateDigest;

      _this9.removeTokensFromStorage();
      window.location.href = fullLogoutUrl;
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cf5834e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(497)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d9f93f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7dcc8756",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserManagement__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UserManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_UserManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProjectManagement_ProjectManagement__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProjectManagement_ProjectManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProjectManagement_ProjectManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AgencyManagement_AgencyManagement__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AgencyManagement_AgencyManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_AgencyManagement_AgencyManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SurveyManagement_SurveyManagement__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SurveyManagement_SurveyManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_SurveyManagement_SurveyManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CheckManagement_CheckManagement__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CheckManagement_CheckManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_CheckManagement_CheckManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KPIManagement_KPIManagement__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_KPIManagement_KPIManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_KPIManagement_KPIManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PageNotFound__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ShopperManagement_ShopperManagement__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ShopperManagement_ShopperManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_ShopperManagement_ShopperManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ShopperManagement_ShopperCheckManagement__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ShopperManagement_ShopperCheckManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_ShopperManagement_ShopperCheckManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Recruiting_Recruiting__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Recruiting_Recruiting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Recruiting_Recruiting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ShopperApproval_ShopperApproval__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ShopperApproval_ShopperApproval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_ShopperApproval_ShopperApproval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UserSettings__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UserSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_UserSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__feature__ = __webpack_require__(77);




















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [
// Routes to the different components are registered here
{
  path: "/clientmanagement",
  name: "ClientManagement",
  component: __WEBPACK_IMPORTED_MODULE_2__components_ClientManagement_ClientManagement___default.a
}, {
  path: "/locationmanagement",
  name: "LocationManagement",
  component: __WEBPACK_IMPORTED_MODULE_3__components_LocationManagement_LocationManagement___default.a
}, {
  path: "/locationimport/:clientGuid",
  name: "LocationImport",
  component: __WEBPACK_IMPORTED_MODULE_4__components_LocationManagement_LocationImport___default.a
}, {
  path: "/usermanagement",
  name: "UserManagement",
  component: __WEBPACK_IMPORTED_MODULE_5__components_UserManagement___default.a
}, {
  path: "/projectmanagement",
  name: "ProjectManagement",
  component: __WEBPACK_IMPORTED_MODULE_6__components_ProjectManagement_ProjectManagement___default.a
}, {
  path: "/agencymanagement",
  name: "AgencyManagement",
  component: __WEBPACK_IMPORTED_MODULE_7__components_AgencyManagement_AgencyManagement___default.a
}, {
  path: "/surveymanagement",
  name: "SurveyManagement",
  component: __WEBPACK_IMPORTED_MODULE_8__components_SurveyManagement_SurveyManagement___default.a
}, {
  path: "/checkmanagement",
  name: "CheckManagement",
  component: __WEBPACK_IMPORTED_MODULE_9__components_CheckManagement_CheckManagement___default.a
}, {
  path: "/kpimanagement",
  name: "KPIManagement",
  component: __WEBPACK_IMPORTED_MODULE_10__components_KPIManagement_KPIManagement___default.a
}, {
  path: "/recruiting",
  name: "Recruiting",
  component: __WEBPACK_IMPORTED_MODULE_14__components_Recruiting_Recruiting___default.a
}, {
  path: "/shoppermanagement",
  name: "ShopperManagement",
  component: __WEBPACK_IMPORTED_MODULE_12__components_ShopperManagement_ShopperManagement___default.a
}, {
  path: "/shoppermanagement/checks",
  name: "ShopperCheckManagement",
  props: function props(route) {
    return {
      selectedShopperGuid: route.query.selectedShopperGuid
    };
  },
  component: __WEBPACK_IMPORTED_MODULE_13__components_ShopperManagement_ShopperCheckManagement___default.a
}, {
  path: "/surveycode",
  name: "SurveyCodeLogin"
}, {
  path: "/surveycode/:sc",
  name: "SurveyCodeDirectLogin"
}, {
  path: "/callback",
  name: "DirectToLoginCallback"
}, {
  path: "/logout_callback",
  name: "DirectToLogoutCallback"
}];

if (__WEBPACK_IMPORTED_MODULE_17__feature__["a" /* default */].isEnabled("userSettings")) routes.push({
  path: "/settings",
  name: "UserSettings",
  component: __WEBPACK_IMPORTED_MODULE_16__components_UserSettings___default.a
});
if (__WEBPACK_IMPORTED_MODULE_17__feature__["a" /* default */].isEnabled("shopperApproval")) routes.push({
  path: "/shopperapproval",
  name: "ShopperApproval",
  component: __WEBPACK_IMPORTED_MODULE_15__components_ShopperApproval_ShopperApproval___default.a
});

routes.push({
  path: "*",
  name: "PageNotFound",
  component: __WEBPACK_IMPORTED_MODULE_11__components_PageNotFound___default.a
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  //mode: 'history',
  routes: routes
}));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestBase__ = __webpack_require__(20);



var API_BASE = "api/Live";

function clearSiteDataAll() {
  var queryString = API_BASE + "/ClearSiteData/all";
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(queryString);
}

function clearSiteDataCombined(dataSelection) {
  var queryString = API_BASE + "/ClearSiteData";
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(queryString, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataSelection));
}

function getVersion() {
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].get(API_BASE + "/Version");
}

/* harmony default export */ __webpack_exports__["a"] = ({
  clearSiteDataAll: clearSiteDataAll,
  clearSiteDataCombined: clearSiteDataCombined,
  getVersion: getVersion
});

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, exports) {

module.exports = {"changePasswordSelf":{"target":"prod training dev audi training-audi dev-audi deutscheBahn porsche"},"userSettings":{"target":"prod training dev audi training-audi dev-audi deutscheBahn porsche"},"clearData":{"target":"training dev training-audi dev-audi"},"leadAgencies":{"target":"audi training-audi dev-audi"},"shopperApproval":{"target":"audi training-audi dev-audi"},"loginAs":{"target":"prod training dev audi training-audi dev-audi deutscheBahn porsche"},"audi_importers":{"target":"training dev audi training-audi dev-audi"},"surveyEditorJSONEditor":{"target":"demo training dev training-audi dev-audi porsche"},"CXReporting":{"target":"demo training dev"},"Autosave":{"target":"prod dev training deutscheBahn"},"AutoFillDateCheck":{"target":"test"},"MultipleDomains":{"target":"dev china"}}

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagement",
  created: function created() {
    var _this = this;

    this.globals.getRegionsList(function (callbackData) {
      _this.allRegions = callbackData;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getAgencyTypeList(function (data) {
      _this2.agencyTypeList = data;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.writeComponentSettingsToStore();
  },
  data: function data() {
    return {
      showEditModal: false,
      showDeleteModal: false,
      tableFilter: "",
      tableElementCount: 0,
      pageSize: 20,
      pageNumer: 0,
      selectedAgency: {},
      agencySelected: false,
      modeAdd: null,
      allRegions: [],
      agencyTypeList: [],
      agencyList: [],
      refreshEnabled: false,
      lang: {
        AM0000: "Agentur löschen",
        AM0001: "Soll folgende Agentur wirklich gelöscht werden?",
        AM0002: "Ja",
        AM0003: "Nein",
        AM0004: "ID",
        AM0005: "Name",
        AM0006: "Agentur seit"
      }
    };
  },

  methods: {
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/agencyManagement"];
      if (storedData) {
        if (storedData.searchString) this.$refs["agencyManagementToolbar"].searchString = _.cloneDeep(storedData.searchString);
        if (storedData.pageSize) this.$refs["agencyManagementToolbar"].pageSize = _.cloneDeep(storedData.pageSize);
        if (storedData.currentSort) this.$refs["agencyManagementTable"].currentSort = _.cloneDeep(storedData.currentSort);
        this.$refs["agencyManagementToolbar"].emitUserSearch();
        this.$refs["agencyManagementToolbar"].emitChangePageSize();
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      if (this.$refs["agencyManagementToolbar"] && this.$refs["agencyManagementTable"]) {
        this.$store.commit("localFilters/agencyManagement", {
          searchString: this.$refs["agencyManagementToolbar"].searchString,
          currentSort: this.$refs["agencyManagementTable"].currentSort,
          pageSize: this.$refs["agencyManagementToolbar"].pageSize
        });
      }
    },
    toggleModal: function toggleModal(modeAdd) {
      this.modeAdd = modeAdd;
      if (modeAdd) {
        this.selectedAgency = {};
        this.agencySelected = false;
      }
      this.showEditModal = !this.showEditModal;
    },

    // Emits from toolbar
    onSearchTextChanged: function onSearchTextChanged(value) {
      this.tableFilter = value;
    },
    onPageSizeChanged: function onPageSizeChanged(value) {
      this.pageSize = value;
    },
    onPageNumberChanged: function onPageNumberChanged(value) {
      this.pageNumer = value - 1;
    },
    triggerReload: function triggerReload() {
      if (this.$refs.agencyManagementTable) this.$refs.agencyManagementTable.getAllAgencies();
    },

    // Emits from table
    onTableElementsCountChange: function onTableElementsCountChange(value) {
      this.tableElementCount = value;
    },
    onAgencySelected: function onAgencySelected(agency) {
      this.selectedAgency = agency;
      this.agencySelected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(agency).length === 0 ? false : true;
    },
    onAgencyOpenEdit: function onAgencyOpenEdit(agency) {
      this.selectedAgency = agency;
      this.toggleModal(false);
    },

    // Emits from edit modal
    onModalClosed: function onModalClosed() {
      this.showEditModal = false;
    },
    onAgencyDeleted: function onAgencyDeleted() {
      var _this3 = this;

      $.ajax({
        method: "DELETE",
        url: "api/agencies/" + this.selectedAgency.AgencyGuid,
        success: function success() {
          _this3.showDeleteModal = false;
          _this3.onAgencySelected({});
          _this3.$refs.agencyManagementTable.getAllAgencies();
          _this3.globals.showSuccessSnackbar("Agency deletion successful");
        },
        error: function error(_error) {
          console.error("Error deleting agency", _error);
          _this3.globals.showErrorSnackbar("Agency deletion failed");
        }
      });
    },
    onAgencySaved: function onAgencySaved(newAgency) {
      var _this4 = this;

      var request = {
        method: "POST",
        url: "api/agencies",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newAgency),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.selectedAgency = newAgency;
          if (data[0]) _this4.selectedAgency.AgencyGuid = data[0].AgencyGuid;
          _this4.$refs.agencyManagementTable.getAllAgencies();
          _this4.globals.showSuccessSnackbar("Agency data update successful");
        },
        error: function error() {
          _this4.globals.showErrorSnackbar("Agency data update failed");
        }
      };

      if (!this.modeAdd) {
        request.method = "PUT";
        request.url += "/" + newAgency.AgencyGuid;
      }

      $.ajax(request);
    },
    onRefreshEnabled: function onRefreshEnabled(value) {
      this.refreshEnabled = value;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.triggerReload();
    }
  },
  components: {
    AgencyManagementToolbar: __WEBPACK_IMPORTED_MODULE_2__AgencyManagementToolbar___default.a,
    AgencyManagementTable: __WEBPACK_IMPORTED_MODULE_3__AgencyManagementTable___default.a,
    AgencyManagementEditModal: __WEBPACK_IMPORTED_MODULE_4__AgencyManagementEditModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagementEditModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: ["showEditModal", "modeAdd", "editAgencyModel", "allRegions", "agencyList"],
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    this.fpAgencySince = flatpickr("#inputAgencySince", this.globals.flatpickrDateConfig);

    this.globals.getAgencyTypeList(function (data) {
      _this.agencyTypeList = data;
      var localAgency = _.find(_this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Local";
      });
      _this.localAgencyTypeGuid = localAgency ? localAgency.AgencyTypeGuid : "";
    });
  },
  destroyed: function destroyed() {
    if (this.fpAgencySince) this.fpAgencySince.destroy();
  },
  data: function data() {
    return {
      lang: {
        AM3000: "Neue Agentur anlegen",
        AM3001: "Agentur bearbeiten",
        AM3002: "Stammdaten",
        AM3003: "Name",
        AM3004: "Straße",
        AM3005: "Stadt",
        AM3006: "PLZ",
        AM3007: "Land",
        AM3008: "Agentur seit",
        AM3009: "Abbrechen",
        AM3010: "Speichern",
        AM3011: "Region",
        AM3012: "Adresszusatz",
        AM3013: "Bitte auswählen...",
        AM3014: "Diese Angabe ist erforderlich!",
        AM3015: "Agency type",
        AM3016: "Lead agency"
      },
      agencyEditModel: {
        AgencyId: "",
        AgencyGuid: "",
        AgencyName: "",
        AgencyTypeGuid: "",
        AgencyAddress: "",
        AgencyAddress2: "",
        AgencyCity: "",
        AgencyPostalCode: "",
        AgencyCountry: "",
        AgencyState_Region: "",
        AgencySince: ""
      },
      showMe: false,
      loading: false,
      regionsOfCountry: [],
      invalidInputIds: [],
      fpAgencySince: null,
      agencyTypeList: [],
      localAgencyTypeGuid: ""
    };
  },

  computed: {
    leadAgencyList: function leadAgencyList() {
      var _this2 = this;

      return this.agencyList.filter(function (ag) {
        return ag.AgencyTypeGuid !== _this2.localAgencyTypeGuid && ag.AgencyGuid !== _this2.agencyEditModel.AgencyGuid;
      });
    }
  },
  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editAgency") {
        if (!result) {
          this.globals.showErrorSnackbar("Form validation failed");
          return;
        }
        this.emitNewAgency();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    toggleDialog: function toggleDialog(show) {
      if (show === false) {
        this.showMe = show;
      }

      if (this.showMe) {
        $("#editAgency").modal("show");
        if (this.modeAdd) {
          this.prepareNew();
        } else this.getAgencyEditModel();
        if (!this.agencyEditModel.AgencyCountry) this.countryChanged(true);
      } else {
        $("#editAgency").modal("hide");
        this.$emit("modalClosed", true);
      }
    },
    prepareNew: function prepareNew() {
      var _this3 = this;

      this.loading = true;
      this.agencyEditModel = {};
      if (this.localAgencyTypeGuid) this.$set(this.agencyEditModel, "AgencyTypeGuid", this.localAgencyTypeGuid);

      if (this.globals.currentUserInfo.AgencyGuid) {
        var myAgency = _.find(this.leadAgencyList, function (a) {
          return a.AgencyGuid === _this3.globals.currentUserInfo.AgencyGuid.toUpperCase();
        });
        if (myAgency) this.agencyEditModel.ParentAgency = myAgency.AgencyGuid;
      }
      this.fpAgencySince.clear();
      this.$nextTick(function () {
        _this3.resetValidationErrors("editAgency");
        _this3.loading = false;
      });
    },
    getAgencyEditModel: function getAgencyEditModel() {
      var _this4 = this;

      this.loading = true;
      $.ajax({
        method: "GET",
        url: "api/agencies/" + this.editAgencyModel.AgencyGuid,
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }

          if (data.ParentAgencies) {
            data.ParentAgency = data.ParentAgencies[0].AgencyGuid;
            delete data.ParentAgencies;
          }
          _this4.agencyEditModel = data;
          _this4.countryChanged();
          _this4.fpAgencySince.setDate(_this4.agencyEditModel.AgencySince, true, "Y-m-d");
          _this4.$nextTick(function () {
            _this4.resetValidationErrors("editAgency");
          });
        },
        error: function error() {
          console.error("Agency data access failed in getAgencyEditModel()");
          _this4.globals.showErrorSnackbar("Agency data access failed");
        },
        complete: function complete() {
          _this4.loading = false;
        }
      });
    },


    // Emit methods
    emitNewAgency: function emitNewAgency() {
      var saveData = _.cloneDeep(this.agencyEditModel);

      if (saveData.AgencyTypeGuid !== this.localAgencyTypeGuid) delete saveData.ParentAgency;

      if (saveData.ParentAgency) {
        saveData.ParentAgencies = [{ AgencyGuid: saveData.ParentAgency }];
        delete saveData.ParentAgency;
      }

      this.$emit("onAgencySaved", saveData);
      this.toggleDialog(false);
    },
    countryChanged: function countryChanged(resetRegionModel) {
      this.regionsOfCountry = [];
      var country = this.agencyEditModel.AgencyCountry;
      if (!this.allRegions) return;

      if (country) {
        var filteredRegions = this.allRegions.filter(function (r) {
          return r.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >= 0;
        });

        if (filteredRegions.length > 0) {
          this.regionsOfCountry = filteredRegions[0].Regions;
          //this.$refs.editAgencyRegionSelect.reinit();
        }
      }

      if (!country || resetRegionModel) delete this.agencyEditModel.RegionGuid;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showEditModal: function showEditModal(newVal) {
      this.showMe = newVal;
      if (newVal) this.toggleDialog();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ["tableFilter", "pageSize", "pageNumber", "selectedAgency"],
  name: "AgencyManagementTable",
  data: function data() {
    return {
      lang: {
        AM2000: "ID",
        AM2001: "Name",
        AM2002: "Straße",
        AM2003: "Stadt",
        AM2004: "Region",
        AM2005: "PLZ",
        AM2006: "Land",
        AM2007: "Adresszusatz",
        AM2008: "Agentur seit"
      },
      allAgencies: [],
      filteredAgencies: [],
      pagedAgencies: [],
      currentSort: { key: "AgencyId", asc: true }
    };
  },

  // Manage Lifecycle Hooks
  created: function created() {
    this.getAllAgencies();
  },
  mounted: function mounted() {
    var _this = this;

    this.setClientTableHeight();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    // Sets the new table height after the window got resized
    $(window).on("resize", function () {
      _this.setClientTableHeight();
    }).resize();
  },

  // Methods
  methods: {
    // Common methods
    handleHttpError: function handleHttpError(err, text) {
      console.error("An error occured while fetching data from Back end\n        " + (text ? text : ""), err);
    },
    extractHttpData: function extractHttpData(response) {
      if (response.status === 200) {
        // When server respondet with OK - 200
        return response.body;
      } else {
        this.handleHttpError(null, response.statusText);
      }
    },
    setRefreshEnabled: function setRefreshEnabled(value) {
      this.$emit("onRefreshEnabled", value);
    },

    // Special methods
    getAllAgencies: function getAllAgencies() {
      var _this2 = this;

      this.setRefreshEnabled(false);

      $.ajax({
        method: "GET",
        url: "api/agencies",
        success: function success(res) {
          if (_.isEmpty(res)) res = [];
          _this2.allAgencies = res;
          _this2.$emit("agenciesReceived", _this2.allAgencies);
          _this2.filteredAgencies = res;
          _this2.emitTableElementCount();
          _this2.doPaging();
          _this2.orderTableCell("");
          _this2.doFiltering();
        },
        error: function error(_error) {
          _this2.handleHttpError(_error);
        },
        complete: function complete() {
          _this2.setRefreshEnabled(true);
        }
      });
    },
    selectAgency: function selectAgency(agency) {
      this.$emit("onAgencySelected", agency);
    },
    openEditAgency: function openEditAgency(agency) {
      if (!this.globals.isAccessAllowed("LoopOp_Agencies_Read")) return;
      this.$emit("onAgencyOpenEdit", agency);
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableCell: function orderTableCell(orderProp) {
      var _this3 = this;

      // Nothing to sort by => return
      if (orderProp === "" && this.currentSort.key === "") return;

      if (orderProp !== "") {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      var sortFunction = function sortFunction(agency) {
        if (typeof agency[_this3.currentSort.key] === "string") {
          return agency[_this3.currentSort.key].toLowerCase();
        }
        return agency[_this3.currentSort.key];
      };

      this.filteredAgencies = _.orderBy(this.filteredAgencies, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
      this.doPaging();
    },
    doPaging: function doPaging() {
      var startIndex = this.pageNumber * this.pageSize;
      var endIndex = startIndex + this.pageSize;
      this.pagedAgencies = this.filteredAgencies.slice(startIndex, endIndex);
    },
    doFiltering: function doFiltering() {
      // Reset filtering when search string is empty
      this.tableFilter === "" || this.tableFilter === undefined ? (this.filteredAgencies = this.allAgencies, this.doPaging()) : null;

      var words = this.tableFilter.split(" ");
      // Get all keys from agency object
      var keys = ["AgencyId", "AgencyName", "AgencyTypeName", "AgencyAddress", "AgencyAddress2", "AgencyCity", "AgencyState_Region", "AgencyCountry", "AgencyPostalCode", "AgencySince"];

      var agencyFilter = function agencyFilter(agency) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (agency[key] && agency[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredAgencies = this.allAgencies.filter(agencyFilter);
      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableCell(this.currentSort.key);
      this.emitTableElementCount();
    },

    // Emits to parent component
    emitTableElementCount: function emitTableElementCount() {
      this.$emit("onTableElementsCountChange", this.filteredAgencies.length);
    },
    setClientTableHeight: function setClientTableHeight() {
      var height = $(window).height();
      height -= $(".agency--panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards
      $(".main-table-scrollbar").css("max-height", height);
      $(".table-space").css("max-height", height);

      //Sets top-property for filter, so it doesnt scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    pageSize: function pageSize() {
      this.doPaging();
    },
    pageNumber: function pageNumber() {
      this.doPaging();
    },
    tableFilter: function tableFilter() {
      this.doFiltering();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AgencyManagementToolbar",
  props: ["tableElementCount", "agencySelected", "refreshEnabled"],
  data: function data() {
    return {
      lang: {
        AM1000: "Aktualisieren",
        AM1001: "Suche ...",
        AM1002: "Neue Agentur",
        AM1003: "Bearbeiten",
        AM1004: "Elemente pro Seite",
        AM1005: "Alle",
        AM1006: "Erste Seite",
        AM1007: "Letzte Seite",
        AM1008: "Löschen",
        AM1009: "Total agencies count"
      },
      searchString: "",
      pageSize: 20,
      currentPage: 1,
      pageNumbers: [],
      showPages: []
    };
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  methods: {
    // Emit functions
    emitUserSearch: function emitUserSearch() {
      this.$emit("searchTextChanged", this.searchString);
    },
    emitChangePageNumber: function emitChangePageNumber() {
      this.$emit("pageNumberChanged", this.currentPage);
    },
    emitChangePageSize: function emitChangePageSize() {
      this.$emit("pageSizeChanged", this.pageSize);
    },
    emitEditAgency: function emitEditAgency(addMode) {
      this.$emit("openEditAgency", addMode);
    },
    emitDeleteAgency: function emitDeleteAgency() {
      this.$emit("openDeleteAgency");
    },
    emitTriggerReload: function emitTriggerReload() {
      this.$emit("onTriggerReload");
    },

    // Markup functions
    changePageSize: function changePageSize(pageNumber, pageSize) {
      this.selectPage(pageNumber);
      this.pageSize = pageSize === -1 ? this.tableElementCount : pageSize;
      this.emitChangePageSize();
      this.pageCount();
      this.getPageingObject();
    },
    selectPage: function selectPage(pageNumber) {
      this.currentPage = pageNumber || 1;
      this.emitChangePageNumber();
      this.getPageingObject();
    },
    pageCount: function pageCount() {
      this.pageNumbers = [];
      var pages = this.tableElementCount ? Math.ceil(this.tableElementCount / this.pageSize) : 0;
      for (var i = 1; i <= pages; i++) {
        this.pageNumbers.push(i);
      }
    },
    getPageingObject: function getPageingObject() {
      if (this.currentPage < 4) {
        this.showPages = this.pageNumbers.slice(0, 5);
        return;
      }

      var outOfIndex = this.currentPage + 2 > this.pageNumbers.length;

      var startIndex = outOfIndex ? this.pageNumbers.length - 5 : this.currentPage - 3;

      var endIndex = outOfIndex ? this.pageNumbers.length : this.currentPage + 2;

      // for cases where there are only 4 pages
      if (startIndex < 0) {
        startIndex = 0;
      }

      this.showPages = this.pageNumbers.slice(startIndex, endIndex);
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    tableElementCount: function tableElementCount() {
      this.pageCount();
      this.getPageingObject();
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AddChecksFurtherSettingsModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    survey: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      settings: {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {}
      },
      fpBegin: null,
      fpEnd: null,
      lang: {
        CFM000: "Offer details",
        CFM001: "Online",
        CFM002: "Location free",
        CFM003: "Begin",
        CFM004: "End",
        CFM005: "Payment",
        CFM006: "Addition",
        CFM007: "Total",
        CFM008: "Edit offer description",
        CFM009: "Reset",
        CFM010: "Close",
        CFM011: "Offer description",
        CFM012: "Shopper Filter",
        CFM013: "Difficulty",
        CFM014: "inherit from survey",
        CFM015: "simple",
        CFM016: "difficult",
        CFM017: "End date before start date",
        CFM018: "Inherit from survey"
      }
    };
  },

  computed: {
    totalPayment: function totalPayment() {
      return this.settings.SurveyInstanceBasePayment + this.settings.SurveyInstancePlusPayment;
    }
  },
  watch: {
    showModal: function showModal(newValue) {
      if (newValue) this.openModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksFurtherSettingsModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeModal");
    });
    $("#addChecksFurtherSettingsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed", _this.settings);
    });

    this.fpBegin = flatpickr("#inputFurtherSettingsStartDate", this.globals.flatpickrDateConfig);
    this.fpEnd = flatpickr("#inputFurtherSettingsEndDate", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpBegin) this.fpBegin.destroy();
    if (this.fpEnd) this.fpEnd.destroy();
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.globals.$on("getDataFromHtmlEditorModal", function (data) {
        _this2.settings.SurveyInstanceDescription = data;
      });
      this.globals.$on("getDataFromShopperFilterModal", function (data) {
        _this2.settings.ShopperFilter = data;
      });
      $("#addChecksFurtherSettingsModal").modal("show");
    },
    closeModal: function closeModal() {
      if (this.settings.SurveyInstanceSince && this.settings.SurveyInstanceUntil && this.settings.SurveyInstanceSince > this.settings.SurveyInstanceUntil) {
        this.globals.showErrorSnackbar(this.lang.CFM017);
        return;
      }

      this.globals.$off("getDataFromHtmlEditorModal");
      this.globals.$off("getDataFromShopperFilterModal");
      $("#addChecksFurtherSettingsModal").modal("hide");
    },
    openHtmlEditor: function openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CFM011,
        content: this.settings.SurveyInstanceDescription
      });
    },
    openShopperFilterModal: function openShopperFilterModal() {
      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.settings.ShopperFilter);
    },
    clearSettings: function clearSettings() {
      this.fpBegin.clear();
      this.fpEnd.clear();
      this.settings = {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {}
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckImportModal",
  data: function data() {
    return {
      sid: null,
      SurveyInstances: [],
      SurveyQuestions: {},
      SurveyQuestionChoices: {},
      selectedFile: {},
      header: [],
      importData: [],
      undefinedElements: [],
      showUndefinedElements: false,
      requests: [],
      failedRequests: [],
      showFailedRequests: false,
      gotSurveyData: false,
      importDataChecked: false,
      uploadDisabled: true,
      undefinedQuestionChoices: [],
      showUndefinedQuestionChoices: false,
      invalidChecks: [],
      importFinished: false,
      importStart: null,
      importEnd: null
    };
  },

  methods: {
    openModal: function openModal() {
      this.selectedFile = {}, $("#checkImportModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#checkImportModal").modal("hide");
    },
    onImportFileChange: function onImportFileChange(e) {
      var _this = this;

      this.selectedFile = e.target.files[0];

      var reader = new FileReader();
      reader.onload = function (e) {
        /* Parse data */
        var bstr = e.target.result;
        var wb = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(bstr, { type: "binary" });
        /* Get first worksheet */
        var wsname = wb.SheetNames[0];
        var ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        _this.importData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(ws, { header: 1, defval: "" });
        _this.header = _this.importData.shift();
      };
      reader.readAsBinaryString(this.selectedFile);
    },
    checkImportData: function checkImportData() {
      this.formatHeaders();
      this.setUpSurveyInstanceAnswers();
      if (this.undefinedElements.length != 0) {
        this.globals.showErrorSnackbar(this.undefinedElements.length + " undefined element(s)");
      }
      this.importDataChecked = true;
    },
    setUpSurveyInstanceAnswers: function setUpSurveyInstanceAnswers() {
      var _this2 = this;

      var request;
      var SurveyInstanceAnswer;
      var currentRowNumber = 1;

      this.requests = [];

      this.importData.forEach(function (row) {
        currentRowNumber++;
        request = {
          checkId: null,
          content: {
            LocaleCode: "en-GB",
            SurveyInstanceAnswer: null,
            SurveyInstanceAnswerDateOfVisit: null,
            SurveyInstanceAnswerMaxPoints: 0,
            SurveyInstanceAnswerMemoAgency: "",
            SurveyInstanceAnswerMemoMSM: "",
            SurveyInstanceAnswerMemoShopper: "",
            SurveyInstanceAnswerPoints: 0,
            SurveyInstanceAnswerTimeIn: null,
            SurveyInstanceAnswerTimeOut: null,
            SurveyInstanceProgress: 100
          }
        };
        SurveyInstanceAnswer = {};

        var _loop = function _loop(key) {

          // Guids of questions, comments and translations have a length of 37, because a Q, C or T was added. That Letter has to be removed to find the question per guid.
          // Multiple Choice (MC) answers have a length of 36
          if (_this2.header[key].length === 37) {
            // get questions
            guid = _this2.header[key].substring(1, 37);

            if (_this2.header[key].substring(0, 1) === "T") {
              // catch translations
              // "t_" identifies translations in the save request
              t_name = "t_";
              l = _this2.SurveyQuestions.find(function (q) {
                return q.QuestionGuid == guid;
              });

              if (l != undefined) {
                t_name = t_name + l.Name;
                SurveyInstanceAnswer[t_name] = row[key];
              } else {
                _this2.addToUndefinedElements(guid, key);
              }
            } else if (_this2.header[key].substring(0, 1) === "C") {
              l = _this2.SurveyQuestions.find(function (q) {
                return q.QuestionGuid == guid;
              });

              if (l != undefined) {
                if (l.Type === "text" || l.Type === "comment") {
                  if (row[key] != "") {
                    SurveyInstanceAnswer[l.Name] = row[key];
                  }
                } else if (l.HasComment === true) {
                  newGuid = l.CommentGuid;
                  m = _this2.SurveyQuestions.find(function (q) {
                    return q.QuestionGuid == newGuid;
                  });

                  if (row[key] != "") {
                    SurveyInstanceAnswer[m.Name] = row[key];
                  }
                }
              } else {
                _this2.addToUndefinedElements(guid, key);
              }
            } else {
              l = _this2.SurveyQuestions.find(function (q) {
                return q.QuestionGuid == guid;
              });

              if (l != undefined) {
                if (l.Type === "checkbox") {
                  // MC answers will be stored in an array
                  SurveyInstanceAnswer[l.Name] = [];
                } else if (l.Type === "radiogroup" || l.Type === "dropdown") {
                  if (row[key] != "") {
                    answer = _this2.SurveyQuestionChoices.find(function (qc) {
                      return qc.QuestionGuid == guid && qc.Position == row[key];
                    });

                    if (answer != undefined) {
                      SurveyInstanceAnswer[l.Name] = answer.Name;
                    } else {
                      _this2.showUndefinedQuestionChoices = true;
                      _this2.undefinedQuestionChoices.push({ column: _this2.columnToLetter(parseInt(key) + 1), row: currentRowNumber, check: request.checkId, guid: guid });
                    }
                  } else {
                    SurveyInstanceAnswer[l.Name] = "";
                  }
                } else {
                  SurveyInstanceAnswer[l.Name] = row[key];
                }
              } else {
                _this2.addToUndefinedElements(guid, key);
              }
            }
          } else if (_this2.header[key].length === 36 && row[key] != "") {
            // mc answer
            guid = _this2.header[key];
            answer = _this2.SurveyQuestionChoices.find(function (qc) {
              return qc.ChoiceGuid == guid;
            });

            if (answer != undefined) {
              question = _this2.SurveyQuestions.find(function (q) {
                return q.QuestionGuid == answer.QuestionGuid;
              });

              if (question != undefined) {
                // SurveyInstanceAnswer[question.Name] is undefined when the MC Question was not found (wrong GUID in import file)
                // when undefined skip question choices of that question
                if (SurveyInstanceAnswer[question.Name] != undefined) {
                  SurveyInstanceAnswer[question.Name].push(answer.Name);
                }
              } else {
                _this2.addToUndefinedElements(guid, key);
              }
            } else {
              _this2.addToUndefinedElements(guid, key);
            }
          } else if (_this2.header[key] == "CheckID") {
            request.checkId = row[key];
          } else if (_this2.header[key] == "Head Date") {
            request.content.SurveyInstanceAnswerDateOfVisit = row[key];
          } else if (_this2.header[key] == "Head Time") {
            request.content.SurveyInstanceAnswerTimeIn = row[key];
          } else if (_this2.header[key] == "Head Out Time") {
            request.content.SurveyInstanceAnswerTimeOut = row[key];
          } else if (_this2.header[key] == "Wave") {
            request.wave = row[key];
          } else if (_this2.header[key] == "Scenario") {
            request.scenario = row[key];
          } else if (_this2.header[key] == "Location ID") {
            request.locationId = row[key];
          }
        };

        for (var key in row) {
          var guid;
          var t_name;
          var l;
          var l;
          var newGuid;
          var m;
          var l;
          var answer;
          var answer;
          var question;

          _loop(key);
        }
        // finished SurveyInstanceAnswer including empty values
        request.content.SurveyInstanceAnswer = SurveyInstanceAnswer;
        var valid = _this2.validateRequest(request, currentRowNumber);
        if (request.checkId !== null && valid) {
          _this2.requests.push(request);
        }
      });
    },
    validateRequest: function validateRequest(request, rowNumber) {
      var instance = this.SurveyInstances.find(function (i) {
        return i.SurveyInstanceId == request.checkId;
      });
      if (instance != undefined && instance.SurveyInstanceStatusId == 100 && instance.LocationStoreId == request.locationId && instance.ScenarioName == request.scenario && instance.WaveName == request.wave) {
        return true;
      } else if (instance == undefined) {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "CheckID not found in survey." });
      } else if (instance.SurveyInstanceStatusId > 100) {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "Checkstatus greater than 100." });
      } else if (instance.LocationStoreId != request.locationId) {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "LocationID does not match." });
      } else if (instance.ScenarioName != request.scenario) {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "Scenario does not match." });
      } else if (instance.WaveName != request.wave) {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "Wave does not match." });
      } else {
        this.invalidChecks.push({ row: rowNumber, checkId: request.checkId, msg: "" });
      }
      return false;
    },
    formatHeaders: function formatHeaders() {
      for (var key in this.header) {
        var index_one = this.header[key].indexOf("[");
        var index_two = this.header[key].indexOf("]");
        var guid = this.header[key].substring(index_one + 1, index_two).toUpperCase();
        if (guid != "") {
          this.header[key] = guid;
        }
      }
    },
    addToUndefinedElements: function addToUndefinedElements(guid, key) {
      var alreadyIn = this.undefinedElements.find(function (e) {
        return e.guid == guid;
      });
      if (alreadyIn == undefined) {
        this.undefinedElements.push({ column: this.columnToLetter(parseInt(key) + 1), guid: guid });
        this.showUndefinedElements = true;
      }
    },
    columnToLetter: function columnToLetter(column) {
      var temp,
          letter = '';
      while (column > 0) {
        temp = (column - 1) % 26;
        letter = String.fromCharCode(temp + 65) + letter;
        column = (column - temp - 1) / 26;
      }
      return letter;
    },
    saveSurveys: function saveSurveys() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var date, key, requestData, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                date = new Date(Date.now());

                _this3.importStart = date.toLocaleString();

                _this3.failedRequests = [];

                _context.t0 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.keys(_this3.requests);

              case 4:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 23;
                  break;
                }

                key = _context.t1.value;
                _context.prev = 6;
                requestData = _this3.requests[key];
                _context.next = 10;
                return _this3.saveSurveyInstance(requestData, key);

              case 10:
                res = _context.sent;

                if (!res) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return _this3.updateCheckStatus(120, requestData.checkId);

              case 14:
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t2 = _context["catch"](6);

                console.error("Error in saveSurveys");
                console.error(_context.t2);
                _this3.globals.showErrorSnackbar("saving survey instance " + (parseInt(index) + 1) + " failed");

              case 21:
                _context.next = 4;
                break;

              case 23:
                if (_this3.failedRequests.length !== 0) {
                  _this3.showFailedRequests = true;
                  _this3.globals.showErrorSnackbar(_this3.failedRequests.length + " Check imports failed");
                } else {
                  _this3.globals.showSuccessSnackbar("Check import complete");
                }
                _this3.importFinished = true;
                date = new Date(Date.now());
                _this3.importEnd = date.toLocaleString();

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[6, 16]]);
      }))();
    },
    saveSurveyInstance: function saveSurveyInstance(requestData, index) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var date = new Date(Date.now());
        var queryString = "api/SurveyInstancesAnswers/ViaCheckimport/" + requestData.checkId;
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(requestData.content, function (key, value) {
          if (value !== null && value !== "" && value.length !== 0) return value;
        });
        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (_this4.isEmpty(data) === false) {
              date = new Date(Date.now());
              console.error("Problem on PUT in saveSurveys with CheckID: " + requestData.checkId);
              _this4.failedRequests.push({ check: requestData.checkId, time: date.toTimeString().substring(0, 8) });
              resolve(false);
            } else {
              resolve(true);
            }
          },
          error: function error() {
            date = new Date(Date.now());
            console.error("Error on PUT in saveSurveys with CheckID: " + requestData.checkId);
            _this4.failedRequests.push({ check: requestData.checkId, time: date.toTimeString().substring(0, 8) });
            reject();
          },
          complete: function complete() {
            _this4.globals.showSuccessSnackbar(parseInt(index) + 1 + "/" + _this4.requests.length + " complete");
          }
        });
      });
    },
    getSurveyData: function getSurveyData() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.SurveyQuestions = {};
                _this5.SurveyQuestionChoices = {};
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this5.getSurveyQuestions(), _this5.getSurveyQuestionChoices(), _this5.getSurveyInstances()]);

              case 5:
                if (!(_this5.isEmpty(_this5.SurveyQuestions) === true || _this5.isEmpty(_this5.SurveyQuestionChoices) === true || _this5.SurveyInstances.length === 0)) {
                  _context2.next = 9;
                  break;
                }

                _this5.globals.showErrorSnackbar("Survey not found");
                _this5.gotSurveyData = false;
                return _context2.abrupt("return", false);

              case 9:
                _this5.gotSurveyData = true;
                return _context2.abrupt("return", true);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](2);

                console.error("Error in getSurveyData");
                console.error(_context2.t0);
                _this5.globals.showErrorSnackbar("Survey request failed");
                _this5.gotSurveyData = false;
                return _context2.abrupt("return", false);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[2, 13]]);
      }))();
    },
    getSurveyDataAndCheckImportData: function getSurveyDataAndCheckImportData() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var succ;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this6.getSurveyData();

              case 2:
                succ = _context3.sent;

                if (succ) {
                  _this6.checkImportData();
                };

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    isEmpty: function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    getSurveyQuestions: function getSurveyQuestions() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queryString = "api/Surveys/SurveyQuestions/" + _this7.sid;
        $.ajax({
          url: queryString,
          type: "GET",
          success: function success(data) {
            _this7.SurveyQuestions = data;
            resolve();
          },
          error: function error() {
            console.error("Error on GET in getSurveyQuestions");
            _this7.globals.showErrorSnackbar("Request failed");
            reject();
          }
        });
      });
    },
    getSurveyQuestionChoices: function getSurveyQuestionChoices() {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queryString = "api/Surveys/SurveyQuestionChoices/" + _this8.sid;
        $.ajax({
          url: queryString,
          type: "GET",
          success: function success(data) {
            _this8.SurveyQuestionChoices = data;
            resolve();
          },
          error: function error() {
            console.error("Error on GET in getSurveyQuestionChoices");
            _this8.globals.showErrorSnackbar("Request failed");
            reject();
          }
        });
      });
    },
    updateCheckStatus: function updateCheckStatus(status, surveyInstanceId) {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var sendData = {};
        sendData.SurveyInstanceIds = [surveyInstanceId];
        sendData.SurveyInstanceStatusId = status;
        $.ajax({
          method: "PUT",
          url: "api/SurveyInstances",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            //if (data.Error) this.globals.showErrorSnackbar(data.Error);
            resolve();
          },
          error: function error() {
            console.error("Error on PUT in updateCheckStatus()");
            _this9.globals.showErrorSnackbar("Status update failed");
            reject();
          }
        });
      });
    },
    getSurveyInstances: function getSurveyInstances() {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queryString = "api/SurveyInstances/Get?sort_column=SurveyInstanceId&sort_order=asc";
        var body = { "Filter": { "SurveyId": _this10.sid } };
        $.ajax({
          method: "POST",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this10.SurveyInstances = data[0].SurveyInstances;
            resolve();
          },
          error: function error() {
            console.error("Error on POST in getSurveyInstances");
            _this10.globals.showErrorSnackbar("Request failed");
            reject();
          }
        });
      });
    },
    enableUpload: function enableUpload() {
      if (this.gotSurveyData && this.importDataChecked) {
        return true;
      } else {
        return false;
      }
    },
    turnAround: function turnAround(id) {
      // turns around arrows in the accordion
      document.getElementById(id).classList.toggle("turned180");
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    this.openModal();
    $("#checkImportModal").on("hidden.bs.modal", function (e) {
      _this11.$emit("modalClosed");
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckLocalAgencyAssignmentModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedChecks: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    agencies: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      selectedLocalAgency: "",
      lang: {
        CLAA00: "Agency assignment",
        CLAA01: "Local agency",
        CLAA02: "Please choose a local agency...",
        CLAA03: "Close",
        CLAA04: "Save",
        CLAA05: "Agency assignment request failed",
        CLAA06: "Agency assignment updated",
        CLAA07: "Assignment update failed"
      }
    };
  },

  computed: {
    localAgencies: function localAgencies() {
      var _this = this;

      if (!this.globals.currentUserInfo.AgencyGuid || this.agencies.length < 1) return [];
      var lead = this.agencies.find(function (a) {
        return a.AgencyGuid === _this.globals.currentUserInfo.AgencyGuid.toUpperCase();
      });
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    }
  },
  watch: {
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();else this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#checkLocalAgencyAssignmentModal").on("hide.bs.modal", function (e) {
      _this2.$emit("closeModal");
    });
    $("#checkLocalAgencyAssignmentModal").on("hidden.bs.modal", function (e) {
      _this2.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.getAgencyAssignment();
      $("#checkLocalAgencyAssignmentModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#checkLocalAgencyAssignmentModal").modal("hide");
    },
    getAgencyAssignment: function getAgencyAssignment() {
      var _this3 = this;

      this.selectedLocalAgency = "";
      var sendData = { SurveyInstances: [] };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var guid = _step.value;

          sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/AgencyAssignment/Get",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.selectedLocalAgency = "";
          if (data.Properties && data.Properties.AssignedLocalAgencyGuid) _this3.selectedLocalAgency = data.Properties.AssignedLocalAgencyGuid;
        },
        error: function error() {
          console.error("Error on POST in getAgencyAssignment()");
          _this3.globals.showErrorSnackbar(_this3.lang.CLAA05);
        }
      });
    },
    saveAgencyAssignment: function saveAgencyAssignment() {
      var _this4 = this;

      var sendData = {
        Properties: {
          AssignedLocalAgencyGuid: this.selectedLocalAgency
        },
        SurveyInstances: []
      };
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var guid = _step2.value;

          sendData.SurveyInstances.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      $.ajax({
        method: "PATCH",
        url: "api/SurveyInstances/AgencyAssignment",
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.$emit("modalDataSaved");
          _this4.globals.showSuccessSnackbar(_this4.lang.CLAA06);
          _this4.closeModal();
        },
        error: function error() {
          console.error("Error on PATCH in saveAgencyAssignment()");
          _this4.globals.showErrorSnackbar(_this4.lang.CLAA07);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_click_outside__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckManagementEditModal__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CheckManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CheckManagementAddModal__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CheckManagementAddModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CheckManagementAddModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SettlementDownloadModal__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SettlementDownloadModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__SettlementDownloadModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckPaymentModal__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CheckPaymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CheckPaymentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShopperFilterModal__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShopperFilterModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ShopperFilterModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CheckLocalAgencyAssignmentModal__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CheckLocalAgencyAssignmentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CheckLocalAgencyAssignmentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_SurveyInstances__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_survey_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_survey_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_survey_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CheckImportModal__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CheckImportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__CheckImportModal__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagement",
  components: {
    CheckManagementEditModal: __WEBPACK_IMPORTED_MODULE_6__CheckManagementEditModal___default.a,
    CheckManagementAddModal: __WEBPACK_IMPORTED_MODULE_7__CheckManagementAddModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_8__Tools_Dialogs_ConfirmationDialog___default.a,
    SettlementDownloadModal: __WEBPACK_IMPORTED_MODULE_9__SettlementDownloadModal___default.a,
    CheckPaymentModal: __WEBPACK_IMPORTED_MODULE_10__CheckPaymentModal___default.a,
    ShopperFilterModal: __WEBPACK_IMPORTED_MODULE_11__ShopperFilterModal___default.a,
    CheckLocalAgencyAssignmentModal: __WEBPACK_IMPORTED_MODULE_12__CheckLocalAgencyAssignmentModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_13__Tools_Select2___default.a,
    CheckImportModal: __WEBPACK_IMPORTED_MODULE_17__CheckImportModal___default.a
  },
  computed: {
    isDeleteDisabled: function isDeleteDisabled() {
      var haschecks = this.includeChecks ? this.selectedCheckIds.length > 0 : this.selectedCheckIds.length < this.checkCount;
      return !haschecks || !this.SelectedStatuscanDelete;
    },
    SelectedStatuscanDelete: function SelectedStatuscanDelete() {
      return !this.selectCheckStatus.find(function (s) {
        return s > 100;
      });
    },
    filterableStatusCodes: function filterableStatusCodes() {
      return this.dataLists.statusCodes.filter(function (c) {
        return c.VisibleInFilter;
      });
    }
  },
  created: function created() {
    var _this = this;

    this.globals.$off("openShopperFilterModal");
    this.globals.$on("openShopperFilterModal", function () {
      _this.showShopperFilterModal = true;
    });
    this.configureSurveyJs();
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();
    // this.setFilterTop();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setElementHeights);
    this.getDataLists();
    $(window).on("resize", this.setElementHeights).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setElementHeights);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setElementHeights: function setElementHeights() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#checks-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards;

        $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);

        //height -= $(".main-table > thead").height();
        //$(".main-table-scrollbar").css("max-height", height);

        height = $(window).height();
        height -= $(".main-table > thead").height() + 390;
        $("#create-checks-table").css("max-height", height);
        height += 85;
        $("#check-list-table").css("max-height", height);

        // Set top for Filter, that it doesent scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this2 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        if (_this2.$refs.clientSelect) _this2.$refs.clientSelect.updateValue();
        if (_this2.$refs.importerSelect) _this2.$refs.importerSelect.updateValue();
        if (_this2.$refs.projectSelect) _this2.$refs.projectSelect.updateValue();

        delete _this2.$filterRestorePending;
        _this2.getCheckData();
      };

      var restoreFilters = function restoreFilters() {
        _this2.$nextTick(function () {
          var storedData = _this2.$store.getters["localFilters/checkManagement"];
          if (storedData) {
            for (var key in storedData) {
              if (key === "selectedClient") _this2.onClientSelection(storedData[key]);else if (_.has(_this2, key)) _this2[key] = _.cloneDeep(storedData[key]);
            }
          }

          if (!_this2.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this2.feature.isAudiTarget) {
            var storedClient = _this2.$store.getters["sharedFilters/client"];
            _this2.selectedClient = storedClient.ClientGuid || "";
            _this2.onClientSelection(_this2.selectedClient);
          } else {
            _this2.onClientSelection();

            var storedImporter = _this2.$store.getters["sharedFilters/importer"];
            _this2.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this2.$store.getters["sharedFilters/project"];
          _this2.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };

      var eventsToWaitFor = ["ClientListReceived", "ProjectListReceived", "StatusListReceived"];
      if (this.feature.isAudiTarget) eventsToWaitFor.push("ImporterListReceived");
      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this3 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/checkManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        selectedCheckType: this.selectedCheckType,
        selectedOnlineState: this.selectedOnlineState,
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.dataLists.clientList, function (c) {
            return c.ClientGuid === _this3.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.dataLists.importerList, function (i) {
            return i.ImporterGuid === _this3.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.dataLists.projectsOfClient, function (p) {
          return p.ProjectGuid === _this3.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    getNameOfSelectedClient: function getNameOfSelectedClient() {
      var _this4 = this;

      if (this.dataLists.clientList.length < 1) return "";
      var currentClient = this.dataLists.clientList.filter(function (c) {
        return c.ClientGuid == _this4.selectedClient;
      });
      if (currentClient.length < 1) return "";
      return currentClient[0].ClientName;
    },
    downloadCheckData: function downloadCheckData() {
      var _this5 = this;

      var Filter = {};
      for (var key in this.filterStrings) {
        if (this.filterStrings[key].length > 0) {
          //If contains seperator
          if (this.filterStrings[key].includes(",")) {
            var filterArray = this.filterStrings[key].split(",");
            Filter[key] = filterArray;
          } else Filter[key] = this.filterStrings[key];
        }
      }
      if (this.selectedClient) Filter.ClientGuid = this.selectedClient;
      if (this.selectedProject) Filter.ProjectGuid = this.selectedProject;
      if (this.selectedImporter) Filter.ImporterGuid = this.selectedImporter;
      if (this.selectedCheckType) Filter.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedCheckType === "FO" && typeof this.selectedOnlineState === "boolean") Filter.OnlineState = this.selectedOnlineState;

      this.globals.showSpinner();
      __WEBPACK_IMPORTED_MODULE_14__services_SurveyInstances__["a" /* default */].getExport(this.selectedClient, this.checkExportFileType, Filter).then(function (res) {
        var data = res.data;
        if (data.length > 0 && data[0].DownloadId) _this5.globals.downloadFile(data[0].DownloadId);

        _this5.globals.hideSpinner();
        _this5.showExportModal = false;
      }).catch(function (error) {
        console.error("Error on POST in downloadCheckData()");
        _this5.globals.showErrorSnackbar("Check export failed");
      });
    },
    onAddChecksDialogDataSaved: function onAddChecksDialogDataSaved() {
      // this.getCheckData(); // Refresh datatable
    },
    onAddChecksDialogClosed: function onAddChecksDialogClosed() {
      this.showAddChecksDialog = false;
      this.getCheckData();
    },
    onEditChecksDialogClosed: function onEditChecksDialogClosed() {
      var _this6 = this;

      this.showEditChecksDialog = false;
      this.$nextTick(function () {
        _this6.getCheckData();
      });
    },
    onCheckImportModalClosed: function onCheckImportModalClosed() {
      this.showCheckImportModal = false;
    },
    onClientSelection: function onClientSelection(client) {
      var _this7 = this;

      if (client) this.selectedClient = client;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getProjectsOfSelectedClient();
      if (_.findIndex(this.dataLists.projectsOfClient, function (p) {
        return p.ProjectGuid === _this7.selectedProject;
      }) < 0) this.selectedProject = "";
    },
    onProjectSelection: function onProjectSelection(project) {
      if (project) this.selectedProject = project;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.getCheckData();
    },
    toggleOnlineStateFilter: function toggleOnlineStateFilter() {
      if (typeof this.selectedOnlineState !== "boolean") this.selectedOnlineState = true;else if (this.selectedOnlineState) this.selectedOnlineState = false;else this.selectedOnlineState = null;

      this.getCheckData();
    },
    getProjectsOfSelectedClient: function getProjectsOfSelectedClient() {
      var _this8 = this;

      this.dataLists.projectsOfClient = [];
      if (!this.selectedClient) return;

      var pl = this.dataLists.projectList.find(function (p) {
        return p.ClientGuid === _this8.selectedClient;
      });
      if (pl && pl.Projects) this.dataLists.projectsOfClient = pl.Projects;
    },
    openDeleteChecksDialog: function openDeleteChecksDialog() {
      $("#deleteChecksDialog").modal("show");
    },
    cloneSelectedChecks: function cloneSelectedChecks() {
      var _this9 = this;

      if (this.selectedChecks.length < 1) return;
      var sendData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selectedChecks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var guid = _step.value;

          sendData.push({ SurveyInstanceGuid: guid });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $.ajax({
        method: "POST",
        url: "/api/SurveyInstances/AgencyClone",
        data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this9.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this9.selectedChecks = [];
          _this9.selectedCheckIds = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var check = _step2.value;

              _this9.selectedChecks.push(check.SurveyInstanceGuid);
              _this9.selectedCheckIds.push(check.SurveyInstanceId);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this9.getCheckData();
          _this9.globals.showSuccessSnackbar(_this9.lang.CM0077);
        },
        error: function error(_error) {
          console.error("Error on POST in cloneSelectedChecks()");
          _this9.globals.showErrorSnackbar(_this9.lang.CM0078);
        }
      });
    },
    showCheckHistory: function showCheckHistory() {
      if (!this.selectedChecks[0] || !this.selectedCheckIds[0]) return;
      var config = {
        type: "SurveyInstance",
        guid: this.selectedChecks[0],
        id: this.selectedCheckIds[0]
      };
      this.globals.$emit("showElementHistory", config);
    },
    openCheck: function openCheck(id, langCode, countryCode) {
      var _this10 = this;

      window.name = "MSMLoopMainApp";
      var locationCode = null;
      if (langCode) locationCode = langCode;
      if (langCode && countryCode) locationCode += "-" + countryCode;
      var newWindow = window.open(window.origin + "/survey.html#/view/" + id + "?lang=" + locationCode);
      newWindow.onbeforeunload = function () {
        _this10.getCheckData();
      };
      newWindow.openerVueInstance = this;
    },
    openChecks: function openChecks(force) {
      var _this11 = this;

      if (!force && this.selectedChecks.length > 3) {
        this.globals.$off("OpenMultipleChecksModalYesConfirmation");
        this.globals.$on("OpenMultipleChecksModalYesConfirmation", function () {
          _this11.openChecks(true);
        });

        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "OpenMultipleChecksModal",
          confirmationTitle: this.lang.CM0053,
          colorRed: true,
          yesButtonText: this.lang.CM0054,
          noButtonText: this.lang.CM0055,
          htmlText: "<p><b>" + this.lang.CM0056 + ":\n            " + this.selectedChecks.length + "<br>\n            <br>" + this.lang.CM0057 + "<br>\n            <br>" + this.lang.CM0058 + "</b></p>"
        });
        return;
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        var _loop = function _loop() {
          var id = _step3.value;

          var tmpCheckData = _this11.checkData.find(function (checkData) {
            return checkData.SurveyInstanceId === id;
          });
          _this11.openCheck(id, tmpCheckData.LocationExportDefaultLanguageCode, tmpCheckData.LocationExportDefaultCountryCode);
        };

        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.selectedCheckIds), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    calcAllowedStatusCodes: function calcAllowedStatusCodes() {
      var _this12 = this;

      if (this.filterStrings.SurveyInstanceStatusId.toString().length < 2) this.allowedStatusCodes = [];else {
        this.allowedStatusCodes = _.find(this.dataLists.statusCodes, function (s) {
          return s.SurveyInstanceStatusId == _this12.filterStrings.SurveyInstanceStatusId;
        }).SurveyInstanceFollowUpStatusses;
        if (!this.allowedStatusCodes) this.allowedStatusCodes = [];
      }

      this.selectedStatusCode = null;
    },
    getStatusCodeDescription: function getStatusCodeDescription(code) {
      var statusCodeObject = _.find(this.dataLists.statusCodes, function (c) {
        return c.SurveyInstanceStatusId === code;
      });
      if (statusCodeObject) return statusCodeObject.SurveyInstanceStatusDescription;else return code.toString();
    },

    // Sends a delete request for the selected checks to the server
    deleteChecks: function deleteChecks() {
      var _this13 = this;

      $.ajax({
        method: "DELETE",
        url: "api/SurveyInstances?include=" + this.includeChecks,
        data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.selectedCheckIds),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this13.globals.showErrorSnackbar(data.Error);else {
            // If delete was successful, refresh displayed data and hide dialog
            _this13.globals.showSuccessSnackbar("Check deletion successful");
            _this13.getCheckData();
            _this13.selectedChecks = [];
            _this13.selectedCheckIds = [];
            $("#deleteChecksDialog").modal("hide");
          }
        },
        error: function error() {
          console.error("Check data deletion failed in deleteChecks()");
          _this13.globals.showErrorSnackbar("Check deletion failed");
        }
      });
    },
    getSurveyList: function getSurveyList() {
      var _this14 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/projectssurveys",
        success: function success(data) {
          _this14.dataLists.surveyList = data;
        },
        error: function error() {
          console.error("Survey data access failed in getSurveyList()");
          _this14.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },
    getDataLists: function getDataLists() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var clientListPromise;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this15.globals.getProjectList(function (data) {
                  _this15.dataLists.projectList = data;
                  _this15.$emit("ProjectListReceived");
                  _this15.getProjectsOfSelectedClient();
                });
                _this15.globals.getWaveList(function (data) {
                  _this15.dataLists.waveList = data;
                });
                _this15.globals.getScenarioList(function (data) {
                  _this15.dataLists.scenarioList = data;
                });
                _this15.getSurveyList();
                _this15.globals.getAgencyList(function (data) {
                  _this15.dataLists.agencyList = [];
                  if (data && data[0]) _this15.dataLists.agencyList = data;
                });
                _this15.globals.getShopperList(function (data) {
                  _this15.dataLists.shopperList = data;
                });
                _this15.globals.getSurveyInstancesStatusList(function (callbackData) {
                  _this15.dataLists.statusCodes = callbackData;
                  _this15.$emit("StatusListReceived");
                });
                clientListPromise = _this15.globals.getClientList();

                clientListPromise.then(function (data) {
                  _this15.dataLists.clientList = data;
                  if (_this15.feature.isAudiTarget && _this15.feature.isEnabled("audi_importers") && data && data[0]) _this15.onClientSelection(data[0].ClientGuid);
                  _this15.$emit("ClientListReceived");
                });

                if (_this15.feature.isAudiTarget && _this15.feature.isEnabled("audi_importers")) {
                  _this15.globals.getImporterList(function (data) {
                    _this15.dataLists.importerList = data;
                    _this15.$emit("ImporterListReceived");
                  });
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this15);
      }))();
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortCheckData: function sortCheckData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;

      this.getCheckData();
    },

    // Catches check data for the table from the server, including current filter, pagination and sort settings
    getCheckData: function getCheckData() {
      var _this16 = this;

      if (this.firstMount == true) {
        this.firstMount = false;
        return;
      }
      if (this.$filterRestorePending) return;
      this.refreshEnabled = false;
      this.globals.showSpinner();
      var query = "api/SurveyInstances/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;

      var body = { Filter: {} };
      for (var key in this.filterStrings) {
        if (this.filterStrings[key].length > 0) {
          //If contains seperator
          if (this.filterStrings[key].includes(",")) {
            var filterArray = this.filterStrings[key].split(",");
            body.Filter[key] = filterArray;
          } else body.Filter[key] = this.filterStrings[key];
        }
      }
      if (this.selectedClient) body.Filter.ClientGuid = this.selectedClient;
      if (this.selectedProject) body.Filter.ProjectGuid = this.selectedProject;
      if (this.selectedImporter) body.Filter.ImporterGuid = this.selectedImporter;
      if (this.selectedCheckType) body.Filter.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedCheckType === "FO" && typeof this.selectedOnlineState === "boolean") body.Filter.OnlineState = this.selectedOnlineState;
      __WEBPACK_IMPORTED_MODULE_14__services_SurveyInstances__["a" /* default */].getAll(body.Filter, this.pageSize, this.selectedPage, this.sortField, this.sortOrder).then(function (_ref) {
        var data = _ref.data;

        if (data[0]) {
          if (data[0].SurveyInstances) _this16.checkData = data[0].SurveyInstances;else _this16.checkData = [];
          _this16.pageCount = data[0].Page_Count;
          _this16.checkCount = data[0].Count;
        }
      }).catch(function (err) {
        console.error("Error on POST in getCheckData()");
        _this16.globals.showErrorSnackbar(_this16.lang.CM0062);
      }).finally(function () {
        return _this16.refreshEnabled = true, _this16.globals.hideSpinner();
      });
    },
    selectSingleCheck: function selectSingleCheck(checkGuid, checkId) {
      this.selectedChecks = [checkGuid];
      this.selectedCheckIds = [checkId];
      this.lastSelectedCheck = checkGuid;
    },
    selectCheckRange: function selectCheckRange(checkGuid, lastSelected) {
      var _this17 = this;

      document.getSelection().removeAllRanges();
      if (!lastSelected) return;

      var idx1 = _.findIndex(this.checkData, function (c) {
        return c.SurveyInstanceGuid === _this17.lastSelectedCheck;
      });
      var idx2 = _.findIndex(this.checkData, function (c) {
        return c.SurveyInstanceGuid === checkGuid;
      });

      if (idx1 > idx2) {
        var tmp = idx1;
        idx1 = idx2;
        idx2 = tmp;
      }

      for (var i = idx1; i <= idx2; i++) {
        if (!this.isCheckSelected(this.checkData[i].SurveyInstanceGuid)) {
          var Check = this.checkData[i];
          this.selectedChecks.push(Check.SurveyInstanceGuid);
          this.selectedCheckIds.push(Check.SurveyInstanceId);
        }
      }
    },
    addCheckToSelected: function addCheckToSelected(checkGuid, checkId) {
      if (this.selectedChecks.includes(checkGuid)) {
        this.selectedChecks = this.selectedChecks.filter(function (guid) {
          return guid !== checkGuid;
        });
        this.selectedCheckIds = this.selectedCheckIds.filter(function (id) {
          return id !== checkId;
        });
        this.lastSelectedCheck = "";
      } else {
        this.selectedChecks.push(checkGuid);
        this.selectedCheckIds.push(checkId);
        this.lastSelectedCheck = checkGuid;
      }
    },

    // Toggles the selected-state of a given check.
    // If the check is not yet selected, it will be added to the array of selected checks.
    // If the check is already selected, it will be removed from that array.
    selectCheck: function selectCheck(checkGuid, checkId, e) {
      if (!e) return;

      if (e.ctrlKey && !e.shiftKey) {
        this.addCheckToSelected(checkGuid, checkId);
      } else if (!e.ctrlKey && e.shiftKey) {
        this.selectCheckRange(checkGuid, this.lastSelectedCheck);
      } else {
        this.selectSingleCheck(checkGuid, checkId);
      }
      this.selectCheckStatus = this.updateSelectedStatus(this.selectedChecks);
      this.selectedStatusCode = null;
      this.$forceUpdate();
    },
    updateSelectedStatus: function updateSelectedStatus(checkguids) {
      return this.checkData.filter(function (c) {
        return checkguids.includes(c.SurveyInstanceGuid);
      }).map(function (el) {
        return el.SurveyInstanceStatusId;
      });
    },
    clearLastSelection: function clearLastSelection() {
      this.lastSelectedCheck = "";
    },

    // Returns true if the given check is selected, otherwise false is returned.
    isCheckSelected: function isCheckSelected(checkGuid) {
      return this.selectedChecks.includes(checkGuid);
    },
    isPageSelected: function isPageSelected() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.checkData), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var check = _step4.value;

          if (!this.isCheckSelected(check.SurveyInstanceGuid)) return false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return true;
    },
    togglePageSelected: function togglePageSelected() {
      var _this18 = this;

      if (this.checkData.length < 1) return;
      var selState = this.isPageSelected();
      if (!selState) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.checkData), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var check = _step5.value;

            if (!this.isCheckSelected(check.SurveyInstanceGuid)) {
              this.selectedChecks.push(check.SurveyInstanceGuid);
              this.selectedCheckIds.push(check.SurveyInstanceId);
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          var _loop2 = function _loop2() {
            var check = _step6.value;

            _.remove(_this18.selectedChecks, function (guid) {
              return guid === check.SurveyInstanceGuid;
            });
            _.remove(_this18.selectedCheckIds, function (id) {
              return id === check.SurveyInstanceId;
            });
          };

          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.checkData), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            _loop2();
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        this.$forceUpdate();
      }
    },
    changeSelectedChecksStatus: function changeSelectedChecksStatus() {
      var _this19 = this;

      if (!this.selectedStatusCode || this.selectedCheckIds.length === 0) return;

      var sendData = {};
      sendData.SurveyInstanceIds = this.selectedCheckIds;
      sendData.SurveyInstanceStatusId = this.selectedStatusCode;

      __WEBPACK_IMPORTED_MODULE_14__services_SurveyInstances__["a" /* default */].changeStatusMultiple(this.selectedCheckIds, this.selectedStatusCode).then(function (_ref2) {
        var data = _ref2.data;

        if (data.Error) _this19.globals.showErrorSnackbar(data.Error);else {
          _this19.globals.showSuccessSnackbar("Status update successful");
          _this19.getCheckData();
          _this19.selectedStatusCode = null;
        }
      }).catch(function (err) {
        console.error("Error on PUT in changeSelectedChecksStatus()", err);
        _this19.globals.showErrorSnackbar("Status update failed");
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.getCheckData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showAutovalidationDialog: function showAutovalidationDialog() {
      var _this20 = this;

      $("#autovalidationDialog").modal("show");

      $("#autovalidationDialog").on("hidden.bs.modal", function (e) {
        _this20.autovalidation.invalidChecks = [];
        _this20.autovalidation.validatedChecks = [];
      });
    },
    startAutovalidation: function startAutovalidation() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var checksToValidate, res, _key, r, key;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this21.autovalidation.invalidChecks = [];
                _this21.autovalidation.validatedChecks = [];

                checksToValidate = [];

                if (!(_this21.selectedChecks.length > 0)) {
                  _context2.next = 41;
                  break;
                }

                _context2.prev = 4;
                res = [];
                _context2.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this21.selectedChecks);

              case 7:
                if ((_context2.t1 = _context2.t0()).done) {
                  _context2.next = 22;
                  break;
                }

                _key = _context2.t1.value;
                _context2.prev = 9;
                _context2.next = 12;
                return _this21.getOneSurveyAndSurveyInstanceJson(_this21.selectedChecks[_key]);

              case 12:
                r = _context2.sent;

                res = res.concat(r.data);
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t2 = _context2["catch"](9);

                console.error("Check data access failed in getSurveyAndSurveyInstanceJson()");
                _this21.globals.showErrorSnackbar("Check data access failed");

              case 20:
                _context2.next = 7;
                break;

              case 22:
                //const res = await this.getSurveyAndSurveyInstanceJson();
                res.forEach(function (e) {
                  if (e.SurveyInstanceStatusId <= 200 && e.SurveyInstanceStatusId > 100) {
                    e.Survey = JSON.parse(e.Survey);
                    e.SurveyInstanceAnswer = JSON.parse(e.SurveyInstanceAnswer);
                    e.SurveyInstanceAnswerPosition = JSON.parse(e.SurveyInstanceAnswerPosition);
                    checksToValidate.push(e);
                  } else {
                    _this21.autovalidation.invalidChecks.push({
                      SID: e.SurveyId,
                      CheckID: e.SurveyInstanceId,
                      Status: e.SurveyInstanceStatusId
                    });
                  }
                });
                _context2.t3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(checksToValidate);

              case 24:
                if ((_context2.t4 = _context2.t3()).done) {
                  _context2.next = 31;
                  break;
                }

                key = _context2.t4.value;
                _context2.next = 28;
                return _this21.validateCheck(checksToValidate[key]);

              case 28:
                _this21.globals.showSuccessSnackbar(parseInt(key) + 1 + "/" + _this21.selectedChecks.length + " checks finished!");
                _context2.next = 24;
                break;

              case 31:
                _context2.next = 37;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t5 = _context2["catch"](4);

                console.error("Error in autovalidation");
                console.error(_context2.t5);

              case 37:
                _this21.getCheckData();
                $("#autovalidationDialog").modal("show");
                _context2.next = 42;
                break;

              case 41:
                _this21.globals.showErrorSnackbar("No checks selected");

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this21, [[4, 33], [9, 16]]);
      }))();
    },
    getOneSurveyAndSurveyInstanceJson: function getOneSurveyAndSurveyInstanceJson(id) {
      return __WEBPACK_IMPORTED_MODULE_14__services_SurveyInstances__["a" /* default */].getOneSurveyAndSurveyInstanceJson(id);
    },
    getSurveyAndSurveyInstanceJson: function getSurveyAndSurveyInstanceJson() {
      var _this22 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var query = "api/SurveyInstances/SurveyAndSurveyInstanceJsons/";
        $.ajax({
          method: "POST",
          url: query,
          data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(_this22.selectedChecks),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            resolve(data);
          },
          error: function error() {
            console.error("Check data access failed in getSurveyAndSurveyInstanceJson()");
            _this22.globals.showErrorSnackbar("Check data access failed");
            reject();
          }
        });
      });
    },
    validateCheck: function validateCheck(check) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var newStatus;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this23.autovalidation.survey = new __WEBPACK_IMPORTED_MODULE_15_survey_vue__["Model"](check.Survey);

                _this23.autovalidation.survey.data = check.SurveyInstanceAnswer;
                _this23.autovalidation.survey.runTriggers();

                if (!(_this23.autovalidation.survey.hasErrors() || check.SurveyInstanceAnswerDateOfVisit == null || check.SurveyInstanceAnswerTimeIn == null || check.SurveyInstanceAnswerTimeOut == null)) {
                  _context3.next = 7;
                  break;
                }

                _this23.autovalidation.invalidChecks.push({
                  SID: check.SurveyId,
                  CheckID: check.SurveyInstanceId,
                  Status: check.SurveyInstanceStatusId
                });
                _context3.next = 39;
                break;

              case 7:
                // clean surveyanswers
                _this23.cleanupSurveyAnswer();
                // calc new progress
                check.SurveyInstanceProgress = _this23.calcSurveyProgress(_this23.autovalidation.survey, check);
                // calc Points
                _this23.calcPointsOfContainer(_this23.autovalidation.survey);

                _context3.t0 = true;
                _context3.next = _context3.t0 === (check.SurveyInstanceStatusId === 110) ? 13 : _context3.t0 === (check.SurveyInstanceStatusId === 130) ? 15 : _context3.t0 === (check.SurveyInstanceStatusId === 150) ? 17 : _context3.t0 === _.includes([120, 140, 160, 165, 170, 190], check.SurveyInstanceStatusId) ? 19 : _context3.t0 === (check.SurveyInstanceStatusId === 200) ? 21 : 23;
                break;

              case 13:
                newStatus = 120;
                return _context3.abrupt("break", 24);

              case 15:
                newStatus = 140;
                return _context3.abrupt("break", 24);

              case 17:
                newStatus = 155;
                return _context3.abrupt("break", 24);

              case 19:
                newStatus = 200;
                return _context3.abrupt("break", 24);

              case 21:
                newStatus = 200;
                return _context3.abrupt("break", 24);

              case 23:
                return _context3.abrupt("break", 24);

              case 24:
                if (!newStatus) {
                  _context3.next = 39;
                  break;
                }

                _context3.prev = 25;
                _context3.next = 28;
                return _this23.saveSurveyInstanceAnswers(check);

              case 28:
                if (newStatus === 200 && check.SurveyInstanceStatusId === 200) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 31;
                return _this23.updateCheckStatus(newStatus, check.SurveyInstanceId);

              case 31:
                _this23.autovalidation.validatedChecks.push({
                  SID: check.SurveyId,
                  CheckID: check.SurveyInstanceId,
                  "Status old": check.SurveyInstanceStatusId,
                  "Status New": newStatus
                });
                _context3.next = 39;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t1 = _context3["catch"](25);

                console.error("Error in saveSurveys");
                console.error(_context3.t1);
                _this23.globals.showErrorSnackbar("saving survey instance " + check.SurveyInstanceId + " failed");

              case 39:
                _this23.autovalidation.survey = null;
                return _context3.abrupt("return");

              case 41:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this23, [[25, 34]]);
      }))();
    },
    saveSurveyInstanceAnswers: function saveSurveyInstanceAnswers(check) {
      var queryString = "api/SurveyInstancesAnswers/ViaAutovalidation/" + check.SurveyInstanceId;

      var surveyObject = _.clone(check);
      delete surveyObject.Survey;
      delete surveyObject.SurveyId;
      delete surveyObject.SurveyInstanceGuid;
      delete surveyObject.SurveyInstanceId;
      delete surveyObject.SurveyInstanceStatusId;
      surveyObject.SurveyInstanceAnswer = _.cloneDeep(this.autovalidation.survey.data);
      surveyObject.SurveyInstanceAnswerMaxPoints = this.autovalidation.survey.pointsMax;
      surveyObject.SurveyInstanceAnswerPoints = this.autovalidation.survey.pointsReached;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(surveyObject),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              reject("Server Error:" + data.Error);
            }
            resolve(data);
          },
          error: function error(_error2) {
            reject(_error2);
          }
        });
      });
    },
    updateCheckStatus: function updateCheckStatus(status, id) {
      if (!status) return;
      var sendData = {};
      sendData.SurveyInstanceIds = [id];
      sendData.SurveyInstanceStatusId = status;
      var queryString = "api/SurveyInstances";

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        $.ajax({
          url: queryString,
          type: "PUT",
          data: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              reject("Server Error:" + data.Error);
            }
            resolve(data);
          },
          error: function error(_error3) {
            reject(_error3);
          }
        });
      });
    },
    calcSurveyProgress: function calcSurveyProgress(survey, check) {
      var requiredFields = ["SurveyInstanceAnswerDateOfVisit", "SurveyInstanceAnswerTimeIn", "SurveyInstanceAnswerTimeOut"];
      var visibleQuestions = survey.getAllQuestions(true);
      var requiredCount = 0;
      var answeredCount = 0;
      for (var i = 0; i < visibleQuestions.length; i++) {
        if (visibleQuestions[i].isRequired) {
          requiredCount++;
          if (!visibleQuestions[i].isEmpty()) answeredCount++;
        }
      }
      requiredCount += requiredFields.length;
      requiredFields.forEach(function (field) {
        if (check[field] !== "") {
          answeredCount++;
        }
      });
      var result = Math.round(answeredCount / requiredCount * 100);
      return result;
    },
    configureSurveyJs: function configureSurveyJs() {
      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["FunctionFactory"].Instance.register("setMaxPoints", function (params) {
        if (params.length < 1 || !survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = survey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["FunctionFactory"].Instance.register("unsetMaxPoints", function (params) {
        if (params.length < 1 || !survey) return;
        for (var i = 0; i < params.length; i++) {
          var q = survey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "isCluster:boolean"
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("panel", {
        name: "backgroundColor:text"
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("question", "commentForShopper:text");

      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("checkbox", "exclusiveValue:checkboxValue");

      // Add points to answers
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPoints", ["points:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("selectbase", "choices:itemvalues");
      var choicesQuestion = __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.findProperty("selectbase", "choices");
      choicesQuestion.typeValue = "itemvaluesWithPoints";
      choicesQuestion.className = "itemvaluesWithPoints";

      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("rating", "rateValues:itemvalues");
      var ratingProperty = __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.findProperty("rating", "rateValues");
      ratingProperty.typeValue = "itemvaluesWithPoints";
      ratingProperty.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addClass("itemvaluesWithPointsAndMaxPoints", ["points:number", "maxPoints:number"], null, "itemvalue");
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("radiogroup", "choices:itemvalues");
      var radioQuestion = __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.findProperty("radiogroup", "choices");
      radioQuestion.typeValue = "itemvaluesWithPointsAndMaxPoints";
      radioQuestion.className = "itemvaluesWithPointsAndMaxPoints";

      if (this.feature.isDBTarget) {
        __WEBPACK_IMPORTED_MODULE_15_survey_vue__["Serializer"].addProperties("itemvalue", [{ name: "createTicket", type: "boolean" }]);
      }

      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("question", {
        name: "pointsMax:number"
      });

      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("question", "guid");
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("panelbase", "guid");
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("itemvalue", "guid");

      // Add custom question numbers
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["Serializer"].addProperty("question", {
        name: "customQuestionNumber",
        default: 0,
        category: "layout",
        visibleIndex: 3,
        visibleIf: function visibleIf(obj) {
          return obj.survey.showQuestionNumbers === "off";
        }
      });

      // Add properties for currency inputs
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€"
      });
      __WEBPACK_IMPORTED_MODULE_15_survey_vue__["JsonObject"].metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma"
      });

      // Add flatpickr widget

      /**
       * toogles the onClick Event handler for flatpickr and disables the next Input element
       */
      var toggleFlatPickrReadonlyState = function toggleFlatPickrReadonlyState(question, el, fp) {
        if (!fp) return;
        // TODO fix read only state with missing siblings
        $(el).prop("disabled", true); //hope this is a jquery el
        return;

        if (question.inputType === "time") el.type = "time";

        if (question.isReadOnly) {
          $(el.parentElement).off("click", fp.toggle);
          if (question.inputType !== "time") el.nextSibling.disabled = true;
        } else {
          $(el.parentElement).on("click", fp.toggle);
          if (question.inputType !== "time") el.nextSibling.disabled = false;
        }
      };

      /**
       * Create hidden button on answers marked for creating a ticket
       * [#1151]
       * Exclusive feature for "Deutsche Bahn"
       */
      if (this.feature.isDBTarget) {
        var createTicketWidget = {
          name: "createticketradiogroup",
          isFit: function isFit(question) {
            return question.getType() == "radiogroup";
          },
          isDefaultRender: true,
          init: function init() {
            __WEBPACK_IMPORTED_MODULE_15_survey_vue__["Serializer"].addClass("createticketradiogroup", [], null, "empty");
          }
        };
        __WEBPACK_IMPORTED_MODULE_15_survey_vue__["CustomWidgetCollection"].Instance.add(createTicketWidget, "customtype");
      }
    },
    calcPointsOfContainer: function calcPointsOfContainer(container) {
      var type = container.getType();
      var containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      container.pointsReached = 0;
      var elements = type === "survey" ? container.pages : container.elements;

      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(elements), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var el = _step7.value;

          if (_.indexOf(containerTypes, el.getType()) > -1) {
            this.calcPointsOfContainer(el);
            container.pointsMax += el.pointsMax || 0;
            container.pointsReached += el.pointsReached || 0;
          } else {
            var qpoints = this.getPointsOfQuestion(el);
            container.pointsMax += qpoints.pointsMax;
            container.pointsReached += qpoints.pointsReached;
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }
    },

    // Returns the points of a given question
    getPointsOfQuestion: function getPointsOfQuestion(question) {
      var points = { pointsMax: 0, pointsReached: 0 };
      var qtype = question.getType();
      if (!qtype || typeof question.value === "undefined") return points;

      if (_.indexOf(["text", "comment", "file"], qtype) > -1) {
        if (question.pointsMax) {
          points.pointsMax = question.pointsMax;
          points.pointsReached = question.pointsMax;
        }
      } else if (qtype === "checkbox") {
        if (question.value.length > 0) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(question.value), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var item = _step8.value;

              var answer = _.find(question.choices, {
                value: item
              });
              if (answer && answer.points) points.pointsReached += answer.points;
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } else if (qtype === "radiogroup") {
        var _answer = _.find(question.choices, { value: question.value });
        if (_answer) {
          if (_answer.maxPoints) points.pointsMax = _answer.maxPoints;else if (question.pointsMax) points.pointsMax = question.pointsMax;

          if (_answer.points) points.pointsReached = _answer.points;
        }
      } else if (qtype === "dropdown") {
        var _answer2 = _.find(question.choices, { value: question.value });
        if (_answer2) {
          if (question.pointsMax) points.pointsMax = question.pointsMax;
          if (_answer2.points) points.pointsReached = _answer2.points;
        }
      } else if (qtype === "rating") {
        if (!question.rateValues || question.rateValues.length < 1) {
          if (question.pointsMax) {
            points.pointsMax = question.pointsMax;
            points.pointsReached = question.pointsMax;
          }
        } else {
          var _answer3 = _.find(question.rateValues, { value: question.value });
          if (_answer3) {
            if (question.pointsMax) points.pointsMax = question.pointsMax;
            if (_answer3.points) points.pointsReached = _answer3.points;
          }
        }
      }
      return points;
    },
    showAutovalidationButton: function showAutovalidationButton() {
      var role = this.globals.getUserRole();
      if (!role) {
        return false;
      }
      switch (role.RoleName) {
        case "MSM_Administrator_Sysadmin":
          return true;
        case "MSM_MSM_Administrator":
          return true;
        case "MSM_MSM_ProjectLeader_Senior":
          return true;
        default:
          return false;
      }
    },
    cleanupSurveyAnswer: function cleanupSurveyAnswer() {
      if (this.autovalidation.survey.clearInvisibleValues === "none") return;
      var visibleQuestions = this.autovalidation.survey.getAllQuestions(true);

      this.autovalidation.survey.data = _.pickBy(this.autovalidation.survey.data, function (value, key) {
        return _.findIndex(visibleQuestions, function (q) {
          return q.name === key;
        }) > -1;
      });
    },
    isCheckImportTester: function isCheckImportTester() {
      if (this.globals.currentUserInfo.LoginName.toLowerCase() === "fraubart" || this.globals.currentUserInfo.LoginName.toLowerCase() === "ezumbult" || this.globals.currentUserInfo.LoginName.toLowerCase() === "jlackner" || this.globals.currentUserInfo.LoginName.toLowerCase() === "sheining") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    selectedClient: function selectedClient() {
      if (!this.showAddChecksDialog) this.getCheckData();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    },
    "filterStrings.SurveyInstanceStatusId": function filterStringsSurveyInstanceStatusId() {
      this.selectedChecks = [];
      this.selectedCheckIds = [];
      this.selectedPage = 1;
      this.includeChecks = true;
      this.calcAllowedStatusCodes();
      this.getCheckData();
    }
  },
  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_5_vue_click_outside___default.a
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectCheckStatus: [],
      selectedChecks: [], // GUIDs
      selectedCheckIds: [], // IDs TODO: Should be removed
      lastSelectedCheck: -1,
      includeChecks: true,
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      selectedCheckType: "",
      selectedOnlineState: null,
      pageSize: 20, // Number of checks on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      checkCount: 0,
      showEditChecksDialog: false,
      showAddChecksDialog: false,
      showSettlementDownloadModal: false,
      showCheckPaymentModal: false,
      showShopperFilterModal: false,
      showCheckLocalAgencyAssignmentModal: false,
      showCheckImportModal: false,
      checkExportFileType: "xlsx",
      showExportModal: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        ClientGuid: "",
        SurveyId: "",
        SurveyInstanceId: "",
        SurveyInstanceGuid: "",
        ShortSurveyCode: "",
        WaveName: "",
        SurveyInstanceStatusId: "",
        ProjectGuid: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceAnswerDateOfVisit: "",
        SurveyInstanceShopperSubmittedAt: "",
        SurveyInstancePartnerSubmittedAt: "",
        SurveyInstanceNote: "",
        SurveyInstanceUntil: "",
        ScenarioName: "",
        SurveyInstanceInfo: "",
        SurveyInstanceResponsable: "",
        ApprovedShopperName: "",
        SurveyInstanceScore: "",
        SurveyInstanceProgress: "",
        SettlementNumber: "",
        SurveyInstanceModifiedAt: ""
      },
      sortField: "SurveyInstanceId", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if check data is requested and server did not respond yet to avoid multiple requests at the same time
      firstMount: true,
      checkData: [], // Stores the check data on the current page
      dataLists: {
        clientList: [], // List of all clients
        importerList: [],
        surveyList: [], // List of all surveys
        statusCodes: [],
        projectList: [],
        projectsOfClient: [],
        waveList: [],
        scenarioList: [],
        agencyList: [],
        shopperList: {}
      },
      allowedStatusCodes: [],
      selectedStatusCode: null,
      invalidInputIds: [], // IDs of inputs with validation error
      metaInformationOfCurrentCheck: {},
      lang: {
        // Contains localization strings for the selected language
        CM0000: "Update",
        CM0001: "New",
        CM0002: "Edit",
        CM0003: "Delete",
        CM0004: "Export",
        CM0005: "Open",
        CM0006: "Move to Status",
        CM0007: "Select Page",
        CM0008: "Deselect Page",
        CM0009: "Invert Selection",
        CM0010: "Reset Selection",
        CM0011: "Please select a client...",
        CM0012: "Elements per page",
        CM0013: "First page",
        CM0014: "Last page",
        CM0015: "SID",
        CM0016: "Check ID",
        CM0017: "Survey Code",
        CM0018: "Status",
        CM0019: "Project",
        CM0020: "Wave",
        CM0021: "Scenario",
        CM0022: "Address",
        CM0023: "Country",
        CM0024: "Visit",
        CM0025: "Submit Shopper",
        CM0026: "Submit Partner",
        CM0027: "Internal note",
        CM0028: "Expiry Date",
        CM0029: "User",
        CM0030: "Score",
        CM0031: "Progress",
        CM0032: "Filter",
        CM0033: "Survey View",
        CM0034: "Delete Checks",
        CM0035: "Do you really want to delete the selected checks?",
        CM0036: "No",
        CM0037: "Yes",
        CM0038: "Check Export",
        CM0039: "Download",
        CM0040: "Cancel",
        CM0041: "Export Checks for Client",
        CM0042: "Please select a file type",
        CM0043: "Text CSV (.csv)",
        CM0044: "Microsoft Excel 97-2003 (.xls)",
        CM0045: "Microsoft Excel 2007-2013 XML (.xlsx)",
        CM0046: "Please filter for status first",
        CM0047: "Modified At",
        CM0048: "Please select a project...",
        CM0049: "Total checks count",
        CM0050: "StoreID",
        CM0051: "Location Name",
        CM0052: "Estimated - Relevant are the reporting results",
        CM0053: "Open multiple checks",
        CM0054: "Yes",
        CM0055: "No",
        CM0056: "You are trying to open the following amount of checks",
        CM0057: "Opening many checks at once can lead to performance issues until your browser will load multiple new tabs at once.",
        CM0058: "Do you really want to proceed?",
        CM0059: "Invoice lists",
        CM0060: "Invoice",
        CM0061: "Payments",
        CM0062: "Check request failed",
        CM0063: "Free offer",
        CM0064: "Manual assignment",
        CM0065: "Agency",
        CM0066: "Check type",
        CM0067: "Online",
        CM0068: "Meaning of the filterable values",
        CM0069: "Invoice approved",
        CM0070: "Submitted by shopper",
        CM0071: "Check is assigned",
        CM0072: "Partner check or no payout",
        CM0073: "Check Info",
        CM0074: "Importer",
        CM0075: "Assign",
        CM0076: "Clone",
        CM0077: "Checks cloned",
        CM0078: "Check cloning failed",
        CM0079: "Shopper",
        CM0080: "History",
        CM0081: "Check template - self creating check",
        CM0082: "self creating check"
      },
      autovalidation: {
        invalidChecks: [],
        validatedChecks: [],
        survey: null
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddChecksFurtherSettingsModal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddChecksFurtherSettingsModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AddChecksFurtherSettingsModal__);





var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagementAddModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a,
    AddChecksFurtherSettingsModal: __WEBPACK_IMPORTED_MODULE_5__AddChecksFurtherSettingsModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList(function (data) {
        _this.agencyTypeList = data;
      });
    }
  },

  computed: {
    leadAgencyGuid: function leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      var leadAgency = _.find(this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Lead";
      });
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies: function leadAgencies() {
      var _this2 = this;

      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(function (a) {
        return a.AgencyTypeGuid === _this2.leadAgencyGuid;
      });
    },
    filteredSubProjects: function filteredSubProjects() {
      var _this3 = this;

      if (this.feature.currentTarget != "dev") {
        if (!this.selectedProjectLocal) return null;
        return this.subProjects.filter(function (sp) {
          return sp.ProjectGuid === _this3.selectedProjectLocal;
        });
      }
    },
    filteredOrders: function filteredOrders() {
      var _this4 = this;

      if (this.feature.currentTarget != "dev") {
        if (!this.selectedSubProject) return null;
        return this.orders.filter(function (o) {
          return o.SubProjectId == _this4.selectedSubProject;
        });
      }
    }
  },
  methods: {
    selectedCheckTypeChanged: function selectedCheckTypeChanged(value) {
      this.selectedCheckType = value;
      this.selectedUser = "";
      this.selectedAgency = "";

      if (this.isLocationDummy == 1) {
        this.toggleLocationDummyActivated();
      }

      this.loadLocationDataFromCacheIfNeeded();
    },

    // Initializes the dialog on opening
    openAddChecksDialog: function openAddChecksDialog() {
      if (this.feature.currentTarget != "dev" && this.globals.isAccessAllowed("LoopOp_SurveyInstances_Create") && this.feature.isMSMGermanyTarget) {
        this.getOrders();
        this.getSubProjects();
      }

      this.selectedClientLocal = "";
      if (this.selectedClient) {
        this.selectedClientLocal = this.selectedClient;
      }
      this.selectedProjectLocal = "";
      if (this.selectedProject) this.selectedProjectLocal = this.selectedProject;
      this.selectedCheckType = "";
      if (this.feature.isAudiTarget) this.selectedCheckType = "AG";
      this.selectedAgency = "";
      this.selectedUser = "";
      this.globalAmount = 0;
      this.checkInfo = "";
      this.isLocationDummy = 0;
      this.selectedBriefingGuid = "";
      this.briefingAttachments = [];
      this.surveyAttachments = [];
      this.selectedSurveyGuid = "";
      this.selectedLocations = [];
      this.amountList = [];
      this.createdChecks = [];
      this.createdCheckIds = [];
      this.$refs["addChecksFurtherSettingsModal"].clearSettings();
      this.clearFilterStrings();
      this.getLocationData(true);
      $("#addChecksDialog").modal("show");
    },


    // Closes the addChecksDialog
    closeAddChecksDialog: function closeAddChecksDialog() {
      $("#addChecksDialog").modal("hide");
      this.$emit("checksCreated", {
        guids: this.createdChecks,
        ids: this.createdCheckIds
      });
    },


    /**
     * Toogle the flag that shows if location dummy is choosen
     * @param {boolean} toValue set Value to toValue
     */
    toggleLocationDummyActivated: function toggleLocationDummyActivated(toValue) {
      if (!toValue) this.isLocationDummy = !this.isLocationDummy;else this.isLocationDummy = toValue;

      if (!this.isLocationDummy) {
        this.locationData = this.cache.locationData;
        this.selectedLocations = this.cache.selectedLocations;

        // this.$forceUpdate();
      } else {
        // cache locationData and selectedLocations
        this.cache.selectedLocations = this.selectedLocations;
        this.cache.locationData = this.locationData;

        this.selectedLocations = [null];
        this.locationData = [];
      }
    },


    /**
     * Needed if selectedCheckType was 'DCT' and LocationDummy selected, and selectedCheckType gets changed into not 'DCT'.
     * In this case it is neccessary to show the location list. The location list is stored in this.cache.locationData.
     */
    loadLocationDataFromCacheIfNeeded: function loadLocationDataFromCacheIfNeeded() {
      if (this.selectedCheckType !== "DCT" && this.isLocationDummy) {
        this.locationData = this.cache.locationData;
      }
    },
    clearFilter: function clearFilter() {
      if (!this.feature.isAudiTarget) this.selectedClientLocal = "";
      this.selectedProjectLocal = "";
      this.selectedSurvey = "";
      this.selectedWave = "";
      this.selectedScenario = "";
      this.selectedUser = "";
      this.selectedAgency = "";
      this.globalAmount = 0;
      this.selectedLocations = [];
      this.amountList = [];
      this.clearFilterStrings();
      this.$forceUpdate();
    },
    clearFilterStrings: function clearFilterStrings() {
      var _this5 = this;

      var filterKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filterStrings);
      filterKeys.forEach(function (filterKey) {
        return _this5.filterStrings[filterKey] = "";
      });
    },
    sortLocationData: function sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },
    toggleLocationSelected: function toggleLocationSelected(locationId) {
      var idx = _.indexOf(this.selectedLocations, locationId);
      if (idx > -1) _.pullAt(this.selectedLocations, idx);else this.selectedLocations.push(locationId);
      this.$forceUpdate();
    },
    isLocationSelected: function isLocationSelected(locationId) {
      return _.indexOf(this.selectedLocations, locationId) > -1;
    },
    isPageSelected: function isPageSelected() {
      for (var i = 0; i < this.locationData.length; i++) {
        if (!this.isLocationSelected(this.locationData[i].LocationId)) return false;
      }
      return true;
    },
    togglePageSelected: function togglePageSelected() {
      if (this.locationData.length < 1) return;
      var selState = this.isPageSelected();
      if (!selState) {
        for (var i = 0; i < this.locationData.length; i++) {
          if (!this.isLocationSelected(this.locationData[i].LocationId)) this.selectedLocations.push(this.locationData[i].LocationId);
        }
      } else {
        for (var _i = 0; _i < this.locationData.length; _i++) {
          this.toggleLocationSelected(this.locationData[_i].LocationId);
        }
      }
    },
    getLocationData: function getLocationData(discardAmounts) {
      var _this6 = this;

      if (!this.selectedClientLocal || !this.selectedProjectLocal && this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.locationData = [];
        this.pageCount = 0;
        this.pageSize = 20;
        this.selectedPage = 1;
        return;
      }

      if (!discardAmounts) this.storeAmountsForPage();
      var getString = "api/SurveyInstances/Locations/" + this.selectedClientLocal + "?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      var sendData = {};
      if (!_.isEmpty(filter)) sendData.Filter = filter;
      if (this.selectedProjectLocal && this.feature.isAudiTarget) sendData.ProjectGuidForImporterFilter = this.selectedProjectLocal;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(sendData) ? "" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data[0]) {
            if (data[0].Locations) {
              if (_this6.isLocationDummy) {
                _this6.cache.locationData = data[0].Locations;
              } else {
                _this6.cache.locationData = [];
                _this6.locationData = data[0].Locations;
              }
              _this6.cache.selectedLocations = [];
            }
            // If GET was successful, store location data and page count from server
            else _this6.locationData = [];
            _this6.pageCount = data[0].Page_Count;
            _this6.totalElementsCount = data[0].Count;
            _this6.readAmountsForPage();
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationData()");
          _this6.globals.showErrorSnackbar("Location data access failed");
        }
      });
    },
    createChecks: function createChecks() {
      var _this7 = this;

      this.storeAmountsForPage();
      this.removeUnselectedLocationsFromAmountList();
      this.setGlobalAmount();
      _.remove(this.amountList, function (entry) {
        return entry.Amount < 1;
      });

      if (this.amountList.length < 1) {
        this.globals.showErrorSnackbar(this.lang.CM2042);
        console.error("Error creating checks: No amounts selected");
        return;
      }

      var sendData = {};
      if (this.selectedSurvey) sendData.Surveys = [this.selectedSurvey];
      if (this.selectedScenario && this.selectedWave) sendData.WavesScenarios = [{ WaveGuid: this.selectedWave, ScenarioGuid: this.selectedScenario }];
      if (this.selectedAgency) {
        if (this.feature.isAudiTarget) sendData.LeadAgencyGuid = this.selectedAgency;else sendData.LocalAgencyGuid = this.selectedAgency;
      }
      if (this.selectedUser) sendData.ShopperGuid = this.selectedUser;
      sendData.Locations = this.amountList;
      if (this.selectedCheckType) sendData.SurveyInstanceType = this.selectedCheckType;
      if (this.selectedBriefingGuid) sendData.BriefingDownloadGuid = this.selectedBriefingGuid;
      if (this.selectedSurveyGuid) sendData.SurveyDownloadGuid = this.selectedSurveyGuid;
      if (this.checkInfo) sendData.SurveyInstanceInfo = this.checkInfo;
      if (this.selectedOrder) sendData.OrderId = this.selectedOrder;

      if (this.selectedCheckType === "FO") {
        for (var key in this.furtherCheckSettings) {
          if (this.furtherCheckSettings[key] || typeof this.furtherCheckSettings[key] === "boolean") sendData[key] = this.furtherCheckSettings[key];
        }
      }

      // Handle LocationDummy
      sendData.Locations[0].isDummyLocation = this.isLocationDummy ? 1 : 0;
      sendData.ClientGuid = this.selectedClient;

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances",
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this7.globals.showSuccessSnackbar(_this7.lang.CM2041);
          _this7.$emit("dialogDataSaved");
          _this7.amountList = [];
          //#1773
          //this.selectedSurvey = "";
          //this.selectedWave = "";

          if (_.isEmpty(data)) {
            console.error("Missing check IDs");
            return;
          }
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var check = _step.value;

              _this7.createdChecks.push(check.SurveyInstanceGuid);
              _this7.createdCheckIds.push(check.SurveyInstanceId);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        },
        error: function error() {
          console.error("Error on POST in createChecks()");
          _this7.globals.showErrorSnackbar(_this7.lang.CM2040);
        }
      });
    },
    setAmount: function setAmount(amount, locationIds) {
      var am = _.find(this.amountList, function (a) {
        return a.Amount == amount;
      });
      if (am) {
        am.LocationIds = _.union(am.LocationIds, locationIds);
      } else {
        var amountObj = { Amount: amount, LocationIds: locationIds };
        this.amountList.push(amountObj);
      }
    },
    setGlobalAmount: function setGlobalAmount() {
      if (!this.globalAmount) return;
      for (var i = 0; i < this.selectedLocations.length; i++) {
        if (!this.hasAmount(this.selectedLocations[i])) {
          this.setAmount(this.globalAmount, [this.selectedLocations[i]]);
        }
      }
    },
    hasAmount: function hasAmount(locationId) {
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (var j = 0; j < locs.length; j++) {
          if (locs[j] == locationId) return true;
        }
      }
      return false;
    },
    removeUnselectedLocationsFromAmountList: function removeUnselectedLocationsFromAmountList() {
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;
        for (var j = 0; j < locs.length; j++) {
          if (!this.isLocationSelected(locs[j])) _.pullAt(locs, j);
        }
        if (locs.length < 1) _.pullAt(this.amountList, i);
      }
    },
    storeAmountsForPage: function storeAmountsForPage() {
      for (var i = 0; i < this.locationData.length; i++) {
        if (this.locationData[i].Amount) {
          this.setAmount(this.locationData[i].Amount, [this.locationData[i].LocationId]);
        }
      }
    },
    readAmountsForPage: function readAmountsForPage() {
      var _this8 = this;

      if (this.amountList.length < 1) return;
      for (var i = 0; i < this.amountList.length; i++) {
        var locs = this.amountList[i].LocationIds;

        var _loop = function _loop(j) {
          ld = _.find(_this8.locationData, function (l) {
            return l.LocationId == locs[j];
          });

          if (ld) {
            ld.Amount = _this8.amountList[i].Amount;
          }
        };

        for (var j = 0; j < locs.length; j++) {
          var ld;

          _loop(j);
        }
      }
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },


    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    getProjectAttachments: function getProjectAttachments() {
      var _this9 = this;

      var queryString = "/api/data/ProjectAttachments/" + this.selectedProjectLocal;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this9.briefingAttachments = data.filter(function (d) {
              return d.AttachmentType === "Briefing";
            });
            _this9.surveyAttachments = data.filter(function (d) {
              return d.AttachmentType === "Survey";
            });
          }
        },
        error: function error() {
          console.error("Attachments data access failed in getProjectAttachments()");
          _this9.globals.showErrorSnackbar(_this9.lang.CM2043);
        }
      });
    },
    furtherSettingsModalClosed: function furtherSettingsModalClosed(data) {
      this.showFurtherSettingsModal = false;
      this.furtherCheckSettings = data;
    },
    getOrders: function getOrders() {
      var _this10 = this;

      var queryString = "/api/SurveyInstances/Orders";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this10.orders = data;
          }
        },
        error: function error(err) {
          console.error("Get orders failed", err);
        }
      });
    },
    getSubProjects: function getSubProjects() {
      var _this11 = this;

      var queryString = "/api/SurveyInstances/SubProjects";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this11.subProjects = data;
          }
        },
        error: function error(err) {
          console.error("Get SubProjects failed", err);
        }
      });
    }
  },
  watch: (_watch = {
    selectedAgency: function selectedAgency() {
      this.selectedUser = "";
    },
    showDialog: function showDialog(newValue) {
      if (newValue) this.openAddChecksDialog();else this.closeAddChecksDialog();
    },
    selectedClientLocal: function selectedClientLocal(newValue) {
      if (newValue) {
        var pl = this.dataLists.projectList.find(function (p) {
          return p.ClientGuid === newValue;
        });
        if (pl && pl.Projects) this.projectsOfClient = pl.Projects;else this.projectsOfClient = [];
      }
      this.selectedProjectLocal = "";
      this.selectedLocations = [];
      this.amountList = [];
      // function is triggered by client select in normal check management, but agency users do not have access to this modal
      if (this.globals.operationPermitted("Entities.SurveyInstance.AllowCreate") && this.globals.operationPermitted("Entities.SurveyInstanceLocation.AllowRead")) {
        this.getLocationData(true);
      }
    },
    selectedProjectLocal: function selectedProjectLocal(newValue) {
      if (newValue) {
        var sl = this.dataLists.surveyList.find(function (s) {
          return s.ProjectGuid === newValue;
        });
        if (sl && sl.Surveys) this.surveysOfProject = sl.Surveys;else this.surveysOfProject = [];

        var wl = this.dataLists.waveList.find(function (w) {
          return w.ProjectGuid === newValue;
        });
        if (wl && wl.Waves) this.wavesOfProject = wl.Waves;else this.wavesOfProject = [];

        this.surveyAttachments = [];
        this.briefingAttachments = [];
        this.getProjectAttachments();
      }

      this.selectedSurveyGuid = "";
      this.selectedBriefingGuid = "";
      this.selectedSurvey = "";
      this.selectedWave = "";
      this.selectedSubProject = "";

      if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.selectedLocations = [];
        this.amountList = [];
        this.getLocationData(true);
      }
    },
    selectedSubProject: function selectedSubProject() {
      this.selectedOrder = "";
    },
    selectedWave: function selectedWave(newValue) {
      if (newValue) {
        var scl = this.dataLists.scenarioList.find(function (s) {
          return s.WaveGuid === newValue;
        });
        if (scl && scl.Scenarios) this.scenariosOfWave = scl.Scenarios;else this.scenariosOfWave = [];
      }
      this.selectedScenario = "";
    },
    selectedUser: function selectedUser(newValue) {
      if (!newValue) return;
      this.selectedAgency = "";
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, "selectedAgency", function selectedAgency(newValue) {
    if (!newValue) return;
    this.selectedUser = "";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, "selectedSurvey", function selectedSurvey(id) {
    if (!id) this.selectedSurveyData = {};else this.selectedSurveyData = _.find(this.surveysOfProject, function (s) {
      return s.SurveyId == id;
    }) || {};
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, "globals.selectedLanguage", function globalsSelectedLanguage() {
    this.globals.getLanguageStrings(this);
  }), _watch),
  props: ["dataLists", "selectedClient", "selectedProject", "showDialog"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedPage: 1,
      pageSize: 20,
      pageCount: 0,
      totalElementsCount: 0,
      sortOrder: "asc",
      sortField: "LocationId",
      filterStrings: {
        Search: "",
        LocationId: "",
        LocationStoreId: "",
        LocationCountry: "",
        LocationAddress: "",
        LocationProperties: "",
        LocationStatusId: "",
        SurveyInstancesCount: ""
      },
      isLocationDummy: false,
      cache: {
        selectedLocations: [],
        locationData: []
      },
      locationData: [],
      selectedLocations: [],
      projectsOfClient: [],
      surveysOfProject: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      agencyTypeList: [],
      selectedClientLocal: -1,
      selectedProjectLocal: "",
      selectedSurvey: "",
      selectedSurveyData: {},
      selectedWave: "",
      selectedScenario: "",
      selectedUser: "",
      selectedAgency: "",
      selectedBriefingGuid: "",
      selectedSurveyGuid: "",
      selectedCheckType: "",
      selectedSubProject: "",
      selectedOrder: "",
      globalAmount: 0,
      checkInfo: "",
      amountList: [],
      briefingAttachments: [],
      surveyAttachments: [],
      createdChecks: [],
      createdCheckIds: [], //TODO: should be removed
      furtherCheckSettings: {
        OnlineState: false,
        LocationFree: false
      },
      showFurtherSettingsModal: false,
      orders: null,
      subProjects: null,
      lang: {
        CM2000: "Create Checks",
        CM2001: "Select Client...",
        CM2002: "Select Project...",
        CM2003: "Select Survey...",
        CM2004: "Select Wave...",
        CM2005: "Select Scenario...",
        CM2006: "Select Shopper...",
        CM2007: "Begin",
        CM2008: "End",
        CM2009: "Amount",
        CM2010: "Clear Filter",
        CM2011: "Select Page",
        CM2012: "Deselect Page",
        CM2013: "Select Agency...",
        CM2014: "Search...",
        CM2015: "Elements per page",
        CM2016: "First page",
        CM2017: "Last page",
        CM2018: "Location ID",
        CM2019: "Location Store ID",
        CM2020: "Country",
        CM2021: "Location Address",
        CM2022: "Location Properties",
        CM2023: "Status Location",
        CM2024: "Existing Checks",
        CM2025: "Filter",
        CM2026: "Create",
        CM2027: "Check Description",
        CM2028: "It is not allowed to create checks with an amount of 0 surveys",
        CM2029: "Choose briefing document...",
        CM2030: "Choose survey document...",
        CM2031: "Select check type",
        CM2032: "Free offer",
        CM2033: "Manual assignment",
        CM2034: "Agency",
        CM2035: "Check refund",
        CM2036: "Reset",
        CM2037: "Selected locations",
        CM2038: "Offer details",
        CM2039: "Close",
        CM2040: "Check creation failed",
        CM2041: "Check creation successful",
        CM2042: "No amounts selected",
        CM2043: "Attachment data access failed",
        CM2044: "Check Info",
        CM2045: "Total locations count",
        CM2046: "Check template - self creating check",
        CM2047: "Location Dummy"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generalSettingsData__ = __webpack_require__(378);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_6__Tools_Select2___default.a
  },
  props: ["dataLists", "selectedChecks", "selectedCheckIds", "selectedClient", "selectedProject", "includeChecks", "showDialog", "projectSelected"],
  data: function data() {
    var _disabled;

    // Global data inside the component is stored here
    return {
      loading: false,
      listenForSettlementChanges: false,
      ChangesCounter: 0,
      checkData: {}, // The check data of the selected check is stored here
      generalSettingsData: __WEBPACK_IMPORTED_MODULE_7__generalSettingsData__["a" /* default */],
      surveyInstanceDescriptionMixed: false,
      WaveAndScenarioChangedAfterLoading: false,
      surveyInstanceInfoMixed: false,
      specificSettingsData: {
        selectedCheck: {},
        dataList: []
      },
      disabled: (_disabled = {
        inputCustomReportingDateCheckMgmtEdit: true,
        inputEditSurveyInstanceNote: true,
        selectCheckEditSurveyInstanceSkillLevel: true,
        inputCheckEditEndDate: true,
        inputCheckEditStartDate: true,
        inputCheckEditSurveyInstanceInfo: true,
        checkManagementEditModalSelectSurvey: true,
        checkManagementEditModalSelectBriefing: true,
        checkManagementEditModalSelectLocation: true,
        checkManagementEditModalSelectScenario: true,
        checkManagementEditModalSelectWave: true,
        checkManagementEditModalSelectAgency: true,
        checkManagementEditModalSelectLocalAgency: true,
        checkManagementEditModalSelectLeadAgency: true,
        checkManagementEditModalSelectUser: true,
        checkManagementEditModalSelectSurveyInstanceType: true
      }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_disabled, "inputCustomReportingDateCheckMgmtEdit", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_disabled, "locationFreeStatus", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_disabled, "onlineStatus", true), _disabled),
      internalNoteForAllChecks: false,
      shopperFilter: {},
      shopperFilterDataDirty: false,
      scenarioList: [],
      wavesOfProject: [],
      scenariosOfWave: [],
      locationsOfSelectedClient: [],
      briefingAttachments: [],
      surveyAttachments: [],
      previousLocationGuid: "",
      languageStringsReceived: false,
      lang: {
        CM1000: "Edit Checks",
        CM1001: "General Settings",
        CM1002: "Visible in Notification",
        CM1003: "External Interface",
        CM1004: "Visible for location notification",
        CM1005: "Query Tool",
        CM1006: "Dashboard",
        CM1007: "Check Explorer",
        CM1008: "Aggregated Report",
        CM1009: "Raw Data Exports",
        CM1010: "Frequencies",
        CM1011: "Media Explorer",
        CM1012: "Type of Mail",
        CM1013: "Custom Reporting Date",
        CM1014: "Scenario",
        CM1015: "User",
        CM1016: "Agency",
        CM1017: "Check Specific Settings",
        CM1018: "Selected Checks",
        CM1019: "Date of Visit",
        CM1020: "Time In",
        CM1021: "Time Out",
        CM1022: "Memo Shopper",
        CM1023: "Memo Agency",
        CM1024: "Memo MSM",
        CM1025: "Cancel",
        CM1026: "Save",
        CM1027: "Check Description",
        CM1028: "Wave",
        CM1029: "Location",
        CM1030: "Location changed",
        CM1031: "Yes",
        CM1032: "No",
        CM1033: "ATTENTION: Changing the location may impact filters inside the check. Do you really want to change the location?",
        CM1034: "Briefing",
        CM1035: "Survey",
        CM1036: "Check type",
        CM1037: "Free offer",
        CM1038: "Manual assignment",
        CM1039: "Agency",
        CM1040: "Begin",
        CM1041: "End",
        CM1042: "Online",
        CM1043: "Location free",
        CM1044: "Edit offer description",
        CM1045: "Check property access failed",
        CM1046: "No agency selected",
        CM1047: "No user selected",
        CM1048: "Check property update successful",
        CM1049: "Check property update failed",
        CM1050: "Attachment data access failed",
        CM1051: "Offer description",
        CM1052: "Internal note",
        CM1053: "Shopper filter",
        CM1054: "Shopper filter request failed",
        CM1055: "Shopper filter update failed",
        CM1056: "Check Info",
        CM1057: "Difficulty",
        CM1058: "simple",
        CM1059: "difficult",
        CM1060: "End date before start date",
        CM1061: "Inherit from survey",
        CM1062: "Combined filters",
        CM1063: "OK",
        CM1064: "Due to the selection of multiple checks there are lots of possible filter combinations that could not be represented in this view. In this case an empty filter appears.",
        CM1065: "Nevertheless it's possible to define a new filter for all selected checks. Already existing filters will be overwritten.",
        CM1066: "Lead agency",
        CM1067: "Local agency",
        CM1068: "Shopper",
        CM1069: "Age",
        CM1070: "Gender",
        CM1071: "Car",
        CM1072: "Target segment",
        CM1073: "Target model",
        CM1074: "Check template - self creating check",
        CM1075: "self creating check",
        CM1076: "Use internal note for all checks",
        CM1077: "CX Reporting",
        CM1078: "Order data access failed"
      },
      controllingSettingsData: {
        dataList: null,
        selectedCheck: {}
      },
      orders: null,
      subProjects: null,
      selectedSubProject: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this.languageStringsReceived = true;
      });
    }

    $("#editChecksDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("leadAgencies")) {
      this.globals.getAgencyTypeList(function (data) {
        _this.agencyTypeList = data;
      });
    }
  },

  computed: {
    leadAgencyGuid: function leadAgencyGuid() {
      if (this.agencyTypeList.length < 1) return "";
      var leadAgency = _.find(this.agencyTypeList, function (at) {
        return at.AgencyTypeName === "Lead";
      });
      return leadAgency ? leadAgency.AgencyTypeGuid : "";
    },
    leadAgencies: function leadAgencies() {
      var _this2 = this;

      if (!this.leadAgencyGuid) return [];
      return this.dataLists.agencyList.filter(function (a) {
        return a.AgencyTypeGuid === _this2.leadAgencyGuid;
      });
    },
    localAgencies: function localAgencies() {
      var _this3 = this;

      if (!this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid || this.leadAgencies.length < 1) return [];

      var lead = this.leadAgencies.find(function (a) {
        return a.AgencyGuid === _this3.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid;
      });
      if (this.$refs.checkEditSelectLocalAgency) this.$refs.checkEditSelectLocalAgency.updateValue();
      return lead && lead.ChildAgencies ? lead.ChildAgencies : [];
    },
    filteredSubProjects: function filteredSubProjects() {
      var _this4 = this;

      if (!this.controllingSettingsData.selectedCheck || !this.subProjects) return [];
      return this.subProjects.filter(function (sp) {
        return sp.ProjectGuid === _this4.controllingSettingsData.selectedCheck.ProjectGuid;
      });
    },
    filteredOrders: function filteredOrders() {
      var _this5 = this;

      if (!this.controllingSettingsData.selectedCheck && !this.controllingSettingsData.selectedCheck.SubProjectId || !this.subProjects || !this.orders) return [];
      return this.orders.filter(function (o) {
        return o.SubProjectId == _this5.controllingSettingsData.selectedCheck.SubProjectId;
      });
    },
    disableSaveButton: function disableSaveButton() {
      if (!this.globals.isAccessAllowed("LoopOp_SurveyInstancesProperties_Update")) {
        return true;
      } else {
        // disable button, because it is impossible to have changes and ChangesCounter is 0
        if (this.ChangesCounter === 0) return true;

        // it is not allowed to save if there invalid entries, in wave or scenario field after changing scenario or wave
        if (this.WaveAndScenarioChangedAfterLoading && !this.disabled.checkManagementEditModalSelectScenario && !this.disabled.checkManagementEditModalSelectWave && (!this.generalSettingsData.SurveyInstanceWaveGuid || !this.generalSettingsData.SurveyInstanceScenarioGuid || this.generalSettingsData.SurveyInstanceScenarioGuid == "" || this.generalSettingsData.SurveyInstanceScenarioGuid == "-1" || this.generalSettingsData.SurveyInstanceWaveGuid == "")) return true;
      }
    }
  },
  methods: {
    SurveyInstanceWaveGuidChanged: function SurveyInstanceWaveGuidChanged() {
      var _this6 = this;

      this.getScenariosOfWave();
      if (_.findIndex(this.scenariosOfWave, function (o) {
        return o.ScenarioGuid == _this6.generalSettingsData.SurveyInstanceScenarioGuid;
      }) < 0) {
        this.generalSettingsData.SurveyInstanceScenarioGuid = "";
      }
    },
    SurveyInstanceAssignedLocalAgencyGuidChanged: function SurveyInstanceAssignedLocalAgencyGuidChanged() {
      //this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
    },
    SurveyInstanceAssignedLeadAgencyGuidChanged: function SurveyInstanceAssignedLeadAgencyGuidChanged() {
      this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
      this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = null;
    },
    SurveyInstanceShopperChanged: function SurveyInstanceShopperChanged() {
      if (this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid && this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid.length > 5) {
        this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = "";
        this.SurveyInstanceAssignedLocalAgencyGuidChanged = true;
      } else if (this.SurveyInstanceAssignedLocalAgencyGuidChanged === false) this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
      if (this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid && this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid.length > 5) {
        this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid = "";
        this.SurveyInstanceAssignedLeadAgencyGuidChanged = true;
      } else if (this.SurveyInstanceAssignedLeadAgencyGuidChanged === false) this.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
    },
    surveyInstanceTypeChanged: function surveyInstanceTypeChanged(value) {
      this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid = null;
      //this.generalSettingsData.SurveyInstanceAssignedShopperGuid = null;
      if (value === "AG") {
        if (this.generalSettingsData.surveyInstanceAssignedShopperGuid && this.generalSettingsData.surveyInstanceAssignedShopperGuid.length > 5) this.generalSettingsData.surveyInstanceAssignedShopperGuid = "";
      }
      if (value === "FO") {
        if (typeof this.generalSettingsData.LocationFree !== "number") this.generalSettingsData.LocationFree = 0;
        if (typeof this.generalSettingsData.OnlineState !== "number") this.generalSettingsData.OnlineState = 0;
      }
    },
    controllSettingDataChanged: function controllSettingDataChanged(value) {
      if (this.listenForSettlementChanges) {
        this.ChangesCounter++;
      }
    },
    convertScenarioList: function convertScenarioList() {
      this.scenarioList = [];
      for (var i = 0; i < this.dataLists.scenarioList.length; i++) {
        this.scenarioList = _.union(this.scenarioList, this.dataLists.scenarioList[i].Scenarios);
      }
    },
    openShopperFilterModal: function openShopperFilterModal() {
      var _this7 = this;

      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit("sendDataToShopperFilterModal", this.shopperFilter);
      if (!this.$multipleCheckFilterMessageShown && this.selectedChecks.length > 1) {
        this.$multipleCheckFilterMessageShown = true;
        setTimeout(function () {
          _this7.globals.$emit("openGlobalNotificationDialog", {
            initiator: "CheckManagementEditModalOpenShopperFilter",
            notificationTitle: _this7.lang.CM1062,
            closeButtonText: _this7.lang.CM1063,
            htmlText: "<p>" + _this7.lang.CM1064 + "<br><br>" + _this7.lang.CM1065 + "</p>"
          });
        }, 200);
      }
    },

    //Toggle Buttons
    toggleBtn: function toggleBtn(btnID) {
      var stateBefore = _.cloneDeep(this.disabled[btnID]);
      if (!this.generalSettingsData.IsReadonly && this.generalSettingsData.MaxSurveyInstanceStatusId <= 200) {
        this.disabled[btnID] = !this.disabled[btnID];
      }

      //For audi if InstanceStatusId > 50
      if (btnID == "checkManagementEditModalSelectLeadAgency" && this.feature.isAudiTarget && this.generalSettingsData.MaxSurveyInstanceStatusId > 50 || this.generalSettingsData.IsReadonly && btnID != "inputCheckEditSurveyInstanceInfo") {
        this.disabled[btnID] = true;
      }

      //If Status > 190 or LocationGUID == "-1" disable Location
      else if (btnID == "checkManagementEditModalSelectLocation" && (this.generalSettingsData.IsReadonly || this.generalSettingsData.MaxSurveyInstanceStatusId > 190 || this.generalSettingsData.SurveyInstanceLocationGuid === "-1")) this.disabled[btnID] = true;
        //If Status > 190 or BriefingDownloadGUID == "-1" disable
        else if (btnID == "checkManagementEditModalSelectBriefing" && (this.generalSettingsData.IsReadonly || this.generalSettingsData.MaxSurveyInstanceStatusId > 190 || this.generalSettingsData.BriefingDownloadGuid === "-1")) this.disabled[btnID] = true;
          //If Status > 190 or SurveyDownloadGUID == "-1" disable
          else if (btnID == "checkManagementEditModalSelectSurvey" && (this.generalSettingsData.IsReadonly || this.generalSettingsData.MaxSurveyInstanceStatusId > 190 || this.generalSettingsData.SurveyDownloadGuid === "-1")) this.disabled[btnID] = true;
            //If isAccessAllowed
            else if (btnID == "inputEditSurveyInstanceNote" && !this.globals.isAccessAllowed("LoopOp_SurveyInstancesAnswers_Update")) this.disabled[btnID] = true;
              // CheckInfo field should be always editable: #1932
              else if (btnID == "inputCheckEditSurveyInstanceInfo") {
                  this.disabled[btnID] = !stateBefore;
                }

      this.$forceUpdate();
    },


    //toggleSettings new
    toggleSettingNew: function toggleSettingNew(setting) {
      if (this.generalSettingsData[setting] == 1) this.generalSettingsData[setting] = 0;else this.generalSettingsData[setting] = 1;

      this.$forceUpdate();
    },

    //toggleSettings old
    toggleSetting: function toggleSetting(setting) {
      // XOR flip the bit
      this.generalSettingsData[setting] = this.generalSettingsData[setting] ^ 1;
      this.$forceUpdate();
    },

    /**
     * Apply the internal note from specificSettings to all (selected) checks, if the relevant checkbox is true
     * @param {string} InstanceNote
     */
    applyInstanceNoteForAll: function applyInstanceNoteForAll(InstanceNote) {
      if (this.internalNoteForAllChecks) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.specificSettingsData.dataList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var check = _step.value;

            check.SurveyInstanceNote = InstanceNote;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },

    // Fills the editCheck dialog with data, depending on the dialog mode.
    openEditChecksDialog: function openEditChecksDialog() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.debug("openEditChecksDialog - triggered");
                if (_this8.feature.currentTarget != "dev" && _this8.globals.isAccessAllowed("LoopOp_SurveyInstances_Create") && _this8.feature.isMSMGermanyTarget) {
                  _this8.getOrders();
                  _this8.getSubProjects();
                }

                _this8.ChangesCounter = 0;
                _this8.listenForSettlementChanges = false;

                _context.prev = 4;
                _context.next = 7;
                return _this8.getCheckSpecificData();

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);

                console.error("Error on -> await this.getCheckSpecificData", _context.t0);

              case 12:
                _context.prev = 12;
                _context.next = 15;
                return _this8.globals.$on("getDataFromShopperFilterModal", function (data) {
                  if (_.isEqual(_this8.shopperFilter, data)) return;
                  _this8.shopperFilter = data;
                  _this8.shopperFilterDataDirty = true;
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t1 = _context["catch"](12);

                console.error('Error on -> await this.globals.$on("getDataFromShopperFilterModal"', _context.t1);

              case 20:
                _context.prev = 20;

                if (!_this8.$clientChanged) {
                  _context.next = 25;
                  break;
                }

                _context.next = 24;
                return _this8.getLocationsOfSelectedClient();

              case 24:
                delete _this8.$clientChanged;

              case 25:
                _context.next = 30;
                break;

              case 27:
                _context.prev = 27;
                _context.t2 = _context["catch"](20);

                console.error('Error on -> await this.getLocationsOfSelectedClient()', _context.t2);

              case 30:
                _context.prev = 30;

                if (!(_this8.feature.currentTarget != "dev" && _this8.feature.isMSMGermanyTarget)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 34;
                return _this8.getSurveyInstanceOrderIds();

              case 34:
                _context.next = 39;
                break;

              case 36:
                _context.prev = 36;
                _context.t3 = _context["catch"](30);

                console.error('Error on -> await this.getSurveyInstanceOrderIds()', _context.t3);

              case 39:

                _this8.convertScenarioList();
                _this8.getWavesOfProject();
                _this8.getProjectAttachments();

                _this8.checkData = { Surveys: [] };
                _this8.loading = true;
                $.ajax({
                  method: "POST",
                  url: "api/SurveyInstances/Properties?include=" + _this8.includeChecks,
                  data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this8.selectedCheckIds),
                  dataType: "json",
                  contentType: "application/json; charset=utf-8",
                  success: function success(data) {
                    console.debug("openEditChecksDialog - POST success", data);
                    if (data.Error) {
                      _this8.globals.showErrorSnackbar(data.Error);
                      _this8.$emit("dialogClosed");
                    } else {
                      // SurveyInstanceNotes comes from api/SurveyInstances/Properties/DetailsList
                      var tmpSurveyInstanceNote = "";

                      if (_this8.generalSettingsData.SurveyInstanceNote //&&
                      //this.generalSettingsData.SurveyInstanceNote !== ""
                      ) {
                          tmpSurveyInstanceNote = _this8.generalSettingsData.SurveyInstanceNote;
                        }
                      _this8.generalSettingsData.setData(data);

                      if (data.SurveyInstanceSkillLevel) _this8.generalSettingsData.SurveyInstanceSkillLevel = data.SurveyInstanceSkillLevel;else _this8.generalSettingsData.SurveyInstanceSkillLevel = _this8.generalSettingsData.SurveySkillLevel;

                      if (data.LocationFree) _this8.generalSettingsData.LocationFree = data.LocationFree;else _this8.generalSettingsData.LocationFree = "-1";
                      if (data.OnlineState) _this8.generalSettingsData.OnlineState = data.OnlineState;else _this8.generalSettingsData.OnlineState = "-1";
                      if (data.SurveyInstanceSince) _this8.generalSettingsData.SurveyInstanceSince = data.SurveyInstanceSince.split("T")[0];else _this8.generalSettingsData.SurveyInstanceSince = "-1";
                      if (data.SurveyInstanceUntil) _this8.generalSettingsData.SurveyInstanceUntil = data.SurveyInstanceUntil.split("T")[0];else _this8.generalSettingsData.SurveyInstanceUntil = "-1";
                      if (data.SurveyInstanceCustomReportingDate) _this8.generalSettingsData.SurveyInstanceCustomReportingDate = data.SurveyInstanceCustomReportingDate.split("T")[0];else _this8.generalSettingsData.SurveyInstanceCustomReportingDate = "-1";
                      if (tmpSurveyInstanceNote !== "") {
                        _this8.generalSettingsData.SurveyInstanceNote = tmpSurveyInstanceNote;
                      }
                      _this8.previousLocationGuid = data.SurveyInstanceLocationGuid;
                      _this8.getShopperFilterObject();

                      if (data.SurveyInstanceDescription === "-1") {
                        _this8.generalSettingsData.SurveyInstanceDescription = "";
                        _this8.surveyInstanceDescriptionMixed = true;
                      }
                      if (data.SurveyInstanceInfo === "-1") {
                        _this8.generalSettingsData.SurveyInstanceInfo = "";
                        _this8.surveyInstanceInfoMixed = true;
                      }

                      // this.$nextTick(() => {
                      $("#checkManagementEditModalSelectAgency").val(_this8.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid);
                      $("#checkManagementEditModalSelectUser").val(_this8.generalSettingsData.SurveyInstanceAssignedShopperGuid);

                      if (_this8.$refs.checkEditSelectLeadAgency) _this8.$refs.checkEditSelectLeadAgency.updateValue();

                      if (!_this8.generalSettingsData.BriefingDownloadGuid) _this8.generalSettingsData.BriefingDownloadGuid = "";
                      if (!_this8.generalSettingsData.SurveyDownloadGuid) _this8.generalSettingsData.SurveyDownloadGuid = "";
                      // });

                      $("#editChecksDialog").modal("show");
                      _this8.globals.$off("getDataFromHtmlEditorModal");
                      _this8.globals.$on("getDataFromHtmlEditorModal", function (data) {
                        _this8.generalSettingsData.SurveyInstanceDescription = data;
                      });

                      _this8.$nextTick(function () {
                        // Event listener for changes on generalSettingsData
                        _this8.generalSettingsData.onChange(function (propertyName, value) {
                          if ((propertyName === "SurveyInstanceScenarioGuid" || propertyName === "SurveyInstanceWaveGuid") && value != "-1") {
                            _this8.WaveAndScenarioChangedAfterLoading = true;
                          }
                          _this8.ChangesCounter++;
                        });
                        // Event listener for changes on specificSettingsData
                        $(".specific-settings-data-input").on("change input", function () {
                          _this8.ChangesCounter++;
                        });

                        // Event listener for changes on custom reporitn date
                        $(".custom-reporting-date-input").on("change input", function () {
                          _this8.ChangesCounter++;
                        });

                        _this8.listenForSettlementChanges = true;
                      });
                    }
                  },
                  error: function error() {
                    console.error("Check data access failed in openEditChecksDialog()");
                    _this8.globals.showErrorSnackbar(_this8.lang.CM1045);
                    _this8.$emit("dialogClosed");
                  },
                  complete: function complete(res) {
                    _this8.loading = false;
                  }
                });

              case 45:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this8, [[4, 9], [12, 17], [20, 27], [30, 36]]);
      }))();
    },

    // Closes the editChecksDialog
    closeEditChecksDialog: function closeEditChecksDialog() {
      var _this9 = this;

      this.globals.$off("getDataFromShopperFilterModal");
      this.generalSettingsData.valueChangedCallback = null;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.disabled).forEach(function (key) {
        _this9.disabled[key] = true;
      });

      $("#editChecksDialog").modal("hide");
    },
    getShopperFilterObject: function getShopperFilterObject() {
      var _this10 = this;

      if (this.generalSettingsData.SurveyInstanceType !== "FO" || this.selectedChecks.length > 1) {
        this.shopperFilter = {};
        this.shopperFilterDataDirty = false;
        return;
      }

      var url = "api/SurveyInstances/ShopperFilter/" + this.selectedChecks[0];
      $.ajax({
        method: "GET",
        url: url,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this10.shopperFilter = data && data.ShopperFilter ? data.ShopperFilter : {};
          _this10.shopperFilterDataDirty = false;
        },
        error: function error() {
          console.error("Error on GET in getShopperFilterObject()");
          _this10.globals.showErrorSnackbar(_this10.lang.CM1054);
          _this10.$emit("dialogClosed");
        }
      });
    },
    saveShopperFilterObject: function saveShopperFilterObject() {
      var _this11 = this;

      if (!this.shopperFilterDataDirty) return;
      var url = "api/SurveyInstances/ShopperFilter";
      var sendData = {
        SurveyInstanceGuids: this.selectedChecks,
        ShopperFilter: this.shopperFilter
      };

      $.ajax({
        method: "PUT",
        url: url,
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.shopperFilterDataDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveShopperFilterObject()");
          _this11.globals.showErrorSnackbar(_this11.lang.CM1055);
        }
      });
    },
    changeCounter: function changeCounter() {
      this.ChangesCounter++;
    },


    // Sends the data from editCheck dialog to the server to store it in the database
    saveEditCheckDialogData: function saveEditCheckDialogData() {
      var _this12 = this;

      this.saveShopperFilterObject();
      this.saveCheckSpecificData();
      this.saveCheckControllingData();

      /* if (
        this.generalSettingsData.SurveyInstanceType === "AG" &&
        !this.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid &&
        !this.feature.isAudiTarget
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1046);
        return;
      }
      if (
        this.generalSettingsData.SurveyInstanceType === "MA" &&
        !this.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ) {
        this.globals.showErrorSnackbar(this.lang.CM1047);
        return;
      }*/
      if (this.generalSettingsData.SurveyInstanceSince && this.generalSettingsData.SurveyInstanceSince !== "-1" && this.generalSettingsData.SurveyInstanceUntil && this.generalSettingsData.SurveyInstanceUntil !== "-1" && this.generalSettingsData.SurveyInstanceSince > this.generalSettingsData.SurveyInstanceUntil) {
        this.globals.showErrorSnackbar(this.lang.CM1060);
        return;
      }

      var sendData = _.cloneDeep(this.generalSettingsData);

      //If disabled set sendData to "-1"

      if (this.disabled.inputCustomReportingDateCheckMgmtEdit) sendData.SurveyInstanceCustomReportingDate = "-1";

      if (this.disabled.checkManagementEditModalSelectSurveyInstanceType) sendData.SurveyInstanceType = "-1";

      if (this.disabled.checkManagementEditModalSelectUser && this.generalSettingsData.SurveyInstanceType !== "AG") sendData.SurveyInstanceAssignedShopperGuid = "-1";

      if (document.getElementById("checkManagementEditModalSelectLeadAgency")) {
        if (this.disabled.checkManagementEditModalSelectLeadAgency) sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
        sendData.SurveyInstanceAssignedLeadAgencyGuidChanged = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectLocalAgency")) {
        if (this.disabled.checkManagementEditModalSelectLocalAgency) sendData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectAgency")) {
        if (this.disabled.checkManagementEditModalSelectAgency && sendData.SurveyInstanceAssignedLocalAgencyGuid == null) {
          sendData.SurveyInstanceAssignedLocalAgencyGuid = "-1";
          sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
        }
      }

      if (document.getElementById("checkManagementEditModalSelectWave")) {
        if (this.disabled.checkManagementEditModalSelectWave) sendData.SurveyInstanceWaveGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectScenario")) {
        if (this.disabled.checkManagementEditModalSelectScenario) sendData.SurveyInstanceScenarioGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectLocation")) {
        if (this.disabled.checkManagementEditModalSelectLocation) sendData.SurveyInstanceLocationGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectBriefing")) {
        if (this.disabled.checkManagementEditModalSelectBriefing) sendData.BriefingDownloadGuid = "-1";
      }

      if (document.getElementById("checkManagementEditModalSelectSurvey")) {
        if (this.disabled.checkManagementEditModalSelectSurvey) sendData.SurveyDownloadGuid = "-1";
      }

      if (document.getElementById("inputCheckEditSurveyInstanceInfo")) {
        if (this.disabled.inputCheckEditSurveyInstanceInfo) sendData.SurveyInstanceInfo = "-1";
      }

      if (document.getElementById("inputCheckEditStartDate")) {
        if (this.disabled.inputCheckEditStartDate) sendData.SurveyInstanceSince = "-1";
      }

      if (document.getElementById("inputCheckEditEndDate")) {
        if (this.disabled.inputCheckEditEndDate) sendData.SurveyInstanceUntil = "-1";
      }

      if (document.getElementById("selectCheckEditSurveyInstanceSkillLevel")) {
        if (this.disabled.selectCheckEditSurveyInstanceSkillLevel) sendData.SurveyInstanceSkillLevel = "-1";
      }

      if (document.getElementById("inputEditSurveyInstanceNote")) {
        if (this.disabled.inputEditSurveyInstanceNote) sendData.SurveyInstanceNote = "-1";
      }

      if (document.getElementById("onlineStatus")) {
        if (this.disabled.onlineStatus) {
          sendData.OnlineState = -1;
        }
      }

      if (document.getElementById("locationFreeStatus")) {
        if (this.disabled.locationFreeStatus) {
          sendData.LocationFree = -1;
        }
      }

      //#1794 Fix for Agency with multi check selected
      if (!sendData.SurveyInstanceAssignedLeadAgencyGuid) sendData.SurveyInstanceAssignedLeadAgencyGuid = "-1";
      sendData.SurveyInstanceIds = this.selectedCheckIds;
      if (this.surveyInstanceDescriptionMixed && !sendData.SurveyInstanceDescription) {
        sendData.SurveyInstanceDescription = "-1";
      }
      this.surveyInstanceDescriptionMixed = false;
      if (this.surveyInstanceInfoMixed && !sendData.SurveyInstanceInfo) {
        sendData.SurveyInstanceInfo = "-1";
      }
      this.surveyInstanceInfoMixed = false;

      if (!sendData.SurveyInstanceCustomReportingDate) delete sendData.SurveyInstanceCustomReportingDate;

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties?include=" + this.includeChecks,
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this12.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this12.globals.showSuccessSnackbar(_this12.lang.CM1048);
          _this12.$emit("dialogDataSaved");
          _this12.closeEditChecksDialog();
        },
        error: function error() {
          console.error("Error on PUT in saveEditCheckDialogData()");
          _this12.globals.showErrorSnackbar(_this12.lang.CM1049);
        }
      });
    },

    /** Check if the SurveyInstancesNotes (internal notes) of all selected SurveyInstances are the same
     * @param surveyInstanceList contains list of surveyinstances comming from "api/SurveyInstances/Properties/DetailsList"
     */
    hasSameSurveyInstanceNote: function hasSameSurveyInstanceNote(surveyInstanceList) {
      if (surveyInstanceList.length == 1) {
        return true;
      } else if (surveyInstanceList.length == 0) {
        return false;
      }

      var firstNote = "";
      for (var i = 0; i < surveyInstanceList.length; i++) {
        if (surveyInstanceList[i].SurveyInstanceNote && surveyInstanceList[i].SurveyInstanceNote != "") {
          if (i === 0) {
            firstNote = surveyInstanceList[i].SurveyInstanceNote;
          } else {
            if (surveyInstanceList[i].SurveyInstanceNote !== firstNote) {
              return false;
            }
          }
        } else {
          return false;
        }
      }

      return true;
    },
    getCheckSpecificData: function getCheckSpecificData() {
      var _this13 = this;

      return $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.selectedChecks),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || !data.length) {
            _this13.specificSettingsData.dataList = [];
            _this13.specificSettingsData.selectedCheck = {};
            return;
          }
          _this13.generalSettingsData.setData(data);
          // SurveyInstanceNote should be empty, if the notes are different and only shown if there are the same
          if (_this13.hasSameSurveyInstanceNote(data)) {
            _this13.generalSettingsData.SurveyInstanceNote = data[0].SurveyInstanceNote;
          } else {
            _this13.generalSettingsData.SurveyInstanceNote = "";
          }
          _this13.specificSettingsData.dataList = data;
          _this13.specificSettingsData.selectedCheck = data[0];
        },
        error: function error() {
          console.error("Error on POST in getCheckSpecificData()");
          _this13.globals.showErrorSnackbar(_this13.lang.CM1045);
        }
      });
    },
    saveCheckSpecificData: function saveCheckSpecificData() {
      var _this14 = this;

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(this.specificSettingsData.dataList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var check = _step2.value;

          for (var property in check) {
            if (!check[property]) delete check[property];
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      $.ajax({
        method: "PUT",
        url: "api/SurveyInstances/Properties/DetailsList",
        data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.specificSettingsData.dataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        error: function error() {
          console.error("Error on PUT in saveCheckSpecificData()");
          _this14.globals.showErrorSnackbar(_this14.lang.CM1049);
        }
      });
    },
    getWavesOfProject: function getWavesOfProject() {
      var _this15 = this;

      if (!this.selectedProject) {
        this.wavesOfProject = [];
        return;
      }

      var wl = this.dataLists.waveList.find(function (w) {
        return w.ProjectGuid === _this15.selectedProject;
      });
      if (wl && wl.Waves) this.wavesOfProject = wl.Waves;else this.wavesOfProject = [];
    },
    getScenariosOfWave: function getScenariosOfWave() {
      var _this16 = this;

      if (!this.generalSettingsData.SurveyInstanceWaveGuid) {
        this.scenariosOfWave = [];
        return;
      }

      var sl = this.dataLists.scenarioList.find(function (s) {
        return s.WaveGuid === _this16.generalSettingsData.SurveyInstanceWaveGuid;
      });
      if (sl && sl.Scenarios) this.scenariosOfWave = sl.Scenarios;else this.scenariosOfWave = [];
    },
    selectedLocationChanged: function selectedLocationChanged() {
      var _this17 = this;

      if (!this.previousLocationGuid || this.generalSettingsData.SurveyInstanceLocationGuid === this.previousLocationGuid) return;

      this.globals.$off("CheckManagementEditModalSelectedLocationChangedCloseDialog");
      this.globals.$once("CheckManagementEditModalSelectedLocationChangedCloseDialog", function () {
        if (_this17.previousLocationGuid) _this17.generalSettingsData.SurveyInstanceLocationGuid = _this17.previousLocationGuid;
      });
      this.globals.$off("CheckManagementEditModalSelectedLocationChangedYesConfirmation");
      this.globals.$once("CheckManagementEditModalSelectedLocationChangedYesConfirmation", function () {
        _this17.previousLocationGuid = "";
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "CheckManagementEditModalSelectedLocationChanged",
        confirmationTitle: this.lang.CM1030,
        colorRed: true,
        yesButtonText: this.lang.CM1031,
        noButtonText: this.lang.CM1032,
        htmlText: "<p><b>" + this.lang.CM1033 + "</b></p>"
      });
    },
    getLocationsOfSelectedClient: function getLocationsOfSelectedClient() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this18.selectedClient) {
                  _context2.next = 3;
                  break;
                }

                _this18.locationsOfSelectedClient = [];
                return _context2.abrupt("return");

              case 3:
                return _context2.abrupt("return", $.ajax({
                  method: "POST",
                  url: "api/SurveyInstances/Locations/" + _this18.selectedClient,
                  success: function success(data) {
                    if (data[0]) {
                      if (data[0].Locations) _this18.locationsOfSelectedClient = data[0].Locations;else _this18.locationsOfSelectedClient = [];
                    }
                  },
                  error: function error() {
                    console.error("Error on POST in getLocationsOfSelectedClient()");
                    _this18.globals.showErrorSnackbar("Location data access failed");
                  }
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this18);
      }))();
    },
    getProjectAttachments: function getProjectAttachments() {
      var _this19 = this;

      if (!this.selectedProject) {
        this.briefingAttachments = [];
        this.surveyAttachments = [];
        return;
      }
      var queryString = "/api/data/ProjectAttachments/" + this.selectedProject;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this19.briefingAttachments = data.filter(function (d) {
              return d.AttachmentType === "Briefing";
            });
            _this19.surveyAttachments = data.filter(function (d) {
              return d.AttachmentType === "Survey";
            });
          }
        },
        error: function error() {
          console.error("Project attachments data access failed in getProjectAttachments()");
          _this19.globals.showErrorSnackbar(_this19.lang.CM1050);
        }
      });
    },
    openHtmlEditor: function openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CM1051,
        content: this.generalSettingsData.SurveyInstanceDescription
      });
    },
    getSurveyInstanceOrderIds: function getSurveyInstanceOrderIds() {
      var _this20 = this;

      return $.ajax({
        method: "POST",
        url: "api/SurveyInstances/SurveyInstanceOrderIds",
        data: this.selectedChecks.toString(),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this20.globals.showErrorSnackbar(data.Error);
          } else {
            _this20.controllingSettingsData.dataList = data;
            _this20.controllingSettingsData.selectedCheck = data[0];
          }
        },
        error: function error(err) {
          console.error("Order data access failed in getSurveyInstanceOrderIds()", err);
          _this20.globals.showErrorSnackbar(_this20.lang.CM1078);
        }
      });
    },
    getOrders: function getOrders() {
      var _this21 = this;

      var queryString = "/api/SurveyInstances/Orders";
      return $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this21.orders = data;
          }
        },
        error: function error(err) {
          console.error("Get orders failed", err);
        }
      });
    },
    getSubProjects: function getSubProjects() {
      var _this22 = this;

      var queryString = "/api/SurveyInstances/SubProjects";
      return $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data.length > 0) {
            _this22.subProjects = data;
          }
        },
        error: function error(err) {
          console.error("Get SubProjects failed", err);
        }
      });
    },
    saveCheckControllingData: function saveCheckControllingData() {
      var _this23 = this;

      var controllingData = [];
      if (this.concontrollingSettingsData && this.concontrollingSettingsData.dataList && this.controllingSettingsData.dataList.length > 0) {
        this.controllingSettingsData.dataList.forEach(function (check) {
          controllingData.push({
            OrderId: check.OrderId || null,
            SurveyInstanceGuid: check.SurveyInstanceGuid
          });
        });
        $.ajax({
          method: "POST",
          url: "api/SurveyInstances/UpdateSurveyInstanceOrderIds",
          data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(controllingData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          error: function error() {
            console.error("Error on POST in saveCheckControllingData()");
            _this23.globals.showErrorSnackbar("Saving controlling data failed.");
          }
        });
      }
    }
  },
  watch: {
    showDialog: function showDialog(value) {
      if (value) this.openEditChecksDialog();else this.closeEditChecksDialog();
    },
    selectedClient: function selectedClient(newValue) {
      if (newValue) this.$clientChanged = true;
    },
    "generalSettingsData.SurveyInstanceWaveGuid": function generalSettingsDataSurveyInstanceWaveGuid() {
      this.getScenariosOfWave();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this24 = this;

      this.languageStringsReceived = false;
      this.globals.getLanguageStrings(this, function () {
        _this24.languageStringsReceived = true;
      });
    },

    "controllingSettingsData.selectedCheck": {
      handler: function handler(newValue, oldValue) {
        if (newValue.OrderId) {
          newValue.SubProjectId = this.orders.find(function (o) {
            return o.OrderId == newValue.OrderId;
          }).SubProjectId;
        }
      },

      deep: true
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckPaymentModal",
  components: {},
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#checkPaymentModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });

    $("#collapseCheckPaymentSpecific").on("show.bs.collapse", function () {
      $("#checkPaymentModal .modal-dialog").css("width", "1200px");
    });
    $("#collapseCheckPaymentSpecific").on("hide.bs.collapse", function () {
      $("#checkPaymentModal .modal-dialog").css("width", "");
    });
    $("#collapseCheckPaymentGeneral").on("show.bs.collapse", function () {
      _this.calcGeneralPaymentData();
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.selectedCheck = {};
      this.checkDataList = [];
      this.generalSettlementData = {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0
      };
      var success = function success() {
        $("#checkPaymentModal").modal("show");
      };
      var error = function error() {
        _this2.$emit("modalClosed");
      };
      this.getPaymentData(success, error);
    },
    closeModal: function closeModal() {
      $("#checkPaymentModal").modal("hide");
    },
    openEditVATModal: function openEditVATModal() {
      this.globals.$emit("openEditVatRatesModal");
    },
    getPaymentData: function getPaymentData(_success, _error) {
      var _this3 = this;

      var query = "api/SurveyInstances/Properties/Settlement";

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.surveyInstanceGuids),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || _.isEmpty(data)) {
            console.error("Unexpected server response in getPaymentData()");
            if (_error) _error();
            return;
          }
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            if (_error) _error();
            return;
          }
          _this3.checkDataList = data;
          _this3.paymentFormDirty = false;

          if (!_this3.globals.operationPermitted("Entities.SurveyInstancePayment.AllowUpdate")) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this3.checkDataList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _check = _step.value;

                _check.EnableEditPayments = false;
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }if (!_this3.selectedCheck.SurveyInstanceGuid) _this3.selectedCheck = _this3.checkDataList[0];else {
            _this3.selectedCheck = _.find(_this3.checkDataList, function (c) {
              return c.SurveyInstanceGuid === _this3.selectedCheck.SurveyInstanceGuid;
            });
          }
          _this3.calcGeneralPaymentData();
          if (_success) _success();
        },
        error: function error(err) {
          console.error("Error on POST in getPaymentData()");
          _this3.globals.showErrorSnackbar(_this3.lang.CPM026);
          if (_error) _error();
        }
      });
    },
    savePaymentData: function savePaymentData() {
      var _this4 = this;

      if (this.hasNegativePayout()) {
        this.globals.showErrorSnackbar(this.lang.CPM030);
        console.error("At least one check has a negative payout value");
        return;
      }

      var query = "api/SurveyInstances/Properties/Settlement";

      $.ajax({
        method: "PUT",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.checkDataList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data) return;
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.CPM027);
          _this4.getPaymentData();
        },
        error: function error(_error2) {
          console.error("Error on PUT in savePaymentData()");
          _this4.globals.showErrorSnackbar(_this4.lang.CPM028);
        }
      });
    },
    hasNegativePayout: function hasNegativePayout() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var check = _step2.value;

          if (check.Payout < 0) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },
    calcGeneralTotalPayment: function calcGeneralTotalPayment() {
      this.generalSettlementData.TotalPayment = 0;
      if (this.generalSettlementData.BasePayment) this.generalSettlementData.TotalPayment += this.generalSettlementData.BasePayment;
      if (this.generalSettlementData.PlusPayment) this.generalSettlementData.TotalPayment += this.generalSettlementData.PlusPayment;
      if (this.generalSettlementData.MinusPayment) this.generalSettlementData.TotalPayment -= this.generalSettlementData.MinusPayment;
    },
    calcSpecificTotalPayment: function calcSpecificTotalPayment() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedCheck;

      check.TotalPayment = 0;
      if (check.BasePayment) check.TotalPayment += check.BasePayment;
      if (check.PlusPayment) check.TotalPayment += check.PlusPayment;
      if (check.MinusPayment) check.TotalPayment -= check.MinusPayment;
      if (!this.selectedCheck.VatNotMandatory) check.TotalPayment += check.TotalPayment * check.VatRate;
      check.Payout = check.TotalPayment;
      if (check.PurchaseMoney) check.Payout += check.PurchaseMoney;
      this.$forceUpdate();
    },
    calcGeneralPaymentData: function calcGeneralPaymentData() {
      this.generalSettlementData.BasePaymentSum = 0;
      this.generalSettlementData.PlusPaymentSum = 0;
      this.generalSettlementData.MinusPaymentSum = 0;
      this.generalSettlementData.PurchaseMoneySum = 0;
      this.generalSettlementData.TotalPaymentSum = 0;
      this.generalSettlementData.PayoutApproved = !!this.checkDataList[0].PayoutApproved;
      this.generalSettlementData.EnableEditPayments = true;

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var check = _step3.value;

          this.calcSpecificTotalPayment(check);
          if (check.BasePayment) this.generalSettlementData.BasePaymentSum += check.BasePayment;
          if (check.PlusPayment) this.generalSettlementData.PlusPaymentSum += check.PlusPayment;
          if (check.MinusPayment) this.generalSettlementData.MinusPaymentSum += check.MinusPayment;
          if (check.PurchaseMoney) this.generalSettlementData.PurchaseMoneySum += check.PurchaseMoney;
          if (check.TotalPayment) this.generalSettlementData.TotalPaymentSum += check.TotalPayment;

          if (check.PayoutApproved !== this.generalSettlementData.PayoutApproved) this.generalSettlementData.PayoutApproved = "mixed";

          this.generalSettlementData.EnableEditPayments = this.generalSettlementData.EnableEditPayments && !!check.EnableEditPayments;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    writeToAllChecks: function writeToAllChecks(prop) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.checkDataList), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var check = _step4.value;

          check[prop] = this.generalSettlementData[prop];
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.calcGeneralPaymentData();
    },
    togglePayoutApprovedForAll: function togglePayoutApprovedForAll() {
      var idx = _.findIndex(this.checkDataList, function (c) {
        return !c.EnablePayoutApprovedChange;
      });
      if (idx > -1) {
        this.globals.showErrorSnackbar(this.lang.CPM029);
        console.error("At least one check is not allowed to change payout approval state");
        return;
      }
      this.generalSettlementData.PayoutApproved = !this.generalSettlementData.PayoutApproved;
      this.writeToAllChecks("PayoutApproved");
      this.$forceUpdate();
    },
    showDialogData: function showDialogData() {
      this.generalSettlementData.BasePayment = this.showNumberData(this.generalSettlementData.BasePayment);
      this.generalSettlementData.PlusPayment = this.showNumberData(this.generalSettlementData.PlusPayment);
      this.generalSettlementData.MinusPayment = this.showNumberData(this.generalSettlementData.MinusPayment);
      this.generalSettlementData.TotalPayment = this.showNumberData(this.generalSettlementData.TotalPayment);
    },
    showNumberData: function showNumberData(field) {
      return field ? field !== -1 ? field : null : 0;
    }
  },
  watch: {
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();else this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["surveyInstanceGuids", "showModal"],
  data: function data() {
    return {
      checkDataList: [],
      selectedCheck: {},
      paymentFormDirty: false,
      generalSettlementData: {
        BasePaymentSum: 0,
        PlusPaymentSum: 0,
        MinusPaymentSum: 0,
        PurchaseMoneySum: 0,
        TotalPaymentSum: 0
      },
      lang: {
        CPM000: "Payments",
        CPM001: "All Checks",
        CPM002: "ATTENTION: Changing these values will update all selected checks!",
        CPM003: "Invoice release",
        CPM004: "Payment",
        CPM005: "Addition",
        CPM006: "Deduction",
        CPM007: "Total",
        CPM008: "Others",
        CPM009: "Comment",
        CPM010: "Individual Processing",
        CPM011: "Checks",
        CPM012: "Project",
        CPM013: "Wave",
        CPM014: "Scenario",
        CPM015: "Shopper",
        CPM016: "VAT Mandatory",
        CPM017: "Payout",
        CPM018: "Invoice",
        CPM019: "Remove release",
        CPM020: "Release invoice",
        CPM021: "Release submitted at",
        CPM022: "Release will be submitted after saving.",
        CPM023: "Close",
        CPM024: "Save",
        CPM025: "Tax rates",
        CPM026: "Payment data access failed",
        CPM027: "Payment data updated",
        CPM028: "Payment data update failed",
        CPM029: "At least one check is not allowed to change payout approval state",
        CPM030: "Negative payout"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SettlementDownloadModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      settlementNumber: "",
      lang: {
        SDM000: "Download Invoice List",
        SDM001: "Invoice Number",
        SDM002: "Create new invoice list",
        SDM003: "Cancel",
        SDM004: "Download",
        SDM005: "Invoice list export failed",
        SDM006: "Invoice list created",
        SDM007: "Invoice list creation failed",
        SDM008: "Invalid invoice number"
      }
    };
  },

  watch: {
    showModal: function showModal() {
      if (this.showModal) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#settlementDownloadModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeModal");
    });
    $("#settlementDownloadModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.settlementNumber = "";
      this.$nextTick(function () {
        $("#settlementDownloadModal").modal("show");
      });
    },
    closeModal: function closeModal() {
      $("#settlementDownloadModal").modal("hide");
    },
    downloadSettlementList: function downloadSettlementList() {
      var _this2 = this;

      this.settlementNumber = this.settlementNumber.replace(" ", "").replace("\n", "");
      if (this.settlementNumber.length !== 8 || !this.settlementNumber.match(/^[0-9]+$/)) {
        console.error("Invalid SettlementNumber:", this.settlementNumber);
        this.globals.showErrorSnackbar(this.lang.SDM008);
        return;
      }

      var queryString = "api/Settlement/SettlementNumber/" + this.settlementNumber + "/Export";
      $.ajax({
        method: "GET",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (!data || !data[0] || !data[0].DownloadId) {
            console.error("Missing DownloadId");
            _this2.globals.showErrorSnackbar(_this2.lang.SDM005);
            return;
          }
          _this2.globals.downloadFile(data[0].DownloadId);
          _this2.$emit("closeModal");
        },
        error: function error() {
          console.error("Error on POST in downloadSettlementList()");
          _this2.globals.showErrorSnackbar(_this2.lang.SDM005);
        }
      });
    },
    createNewSettlementList: function createNewSettlementList() {
      var _this3 = this;

      var queryString = "api/Settlement";

      $.ajax({
        method: "POST",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.settlementNumber = data.SettlementNumber;
          _this3.globals.showSuccessSnackbar(_this3.lang.SDM006);
        },
        error: function error() {
          console.error("Error on POST in createNewSettlementList()");
          _this3.globals.showErrorSnackbar(_this3.lang.SDM007);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperFilterModal",
  components: {
    ShopperFilter: __WEBPACK_IMPORTED_MODULE_0__Recruiting_ShopperFilter___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedClient: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      filterObject: {},
      countryList: [],
      regionList: [],
      locationPropertiesList: [],
      copyData: {},
      lang: {
        CSM000: "Shopper Filter",
        CSM001: "Close",
        CSM002: "Location property data request failed",
        CSM003: "Please set client filter first",
        CSM004: "Copy filter",
        CSM005: "Paste filter"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    selectedClient: function selectedClient() {
      this.locationPropertiesList = [];
      if (this.filterObject.NotWithLocationPropertyGuids) delete this.filterObject.NotWithLocationPropertyGuids;
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
      this.globals.getRegionsList(function (callbackData) {
        _this.regionList = callbackData;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.globals.getCountryList(this.convertCountryList);
    this.globals.getRegionsList(function (callbackData) {
      _this2.regionList = callbackData;
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#shopperFilterModal").on("hidden.bs.modal", function (e) {
      _this3.$refs.shopperFilterComponent.collectFilterData();
      _this3.globals.$emit("getDataFromShopperFilterModal", _this3.filterObject);
      _this3.$emit("modalClosed");
    });

    this.globals.$off("sendDataToShopperFilterModal");
    this.globals.$on("sendDataToShopperFilterModal", function (data) {
      _this3.filterObject = data ? _.cloneDeep(data) : {};
      _this3.$nextTick(function () {
        _this3.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    });
  },

  methods: {
    openModal: function openModal() {
      if (!this.selectedClient) {
        console.error("No client selected");
        this.globals.showErrorSnackbar(this.lang.CSM003);
        this.$emit("modalClosed");
        return;
      }
      this.getLocationProperties();
      $("#shopperFilterModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperFilterModal").modal("hide");
    },
    copyFilter: function copyFilter() {
      this.$refs.shopperFilterComponent.collectFilterData();
      this.copyData = {
        filterObject: _.cloneDeep(this.filterObject),
        client: this.selectedClient
      };
    },
    restoreFilter: function restoreFilter() {
      var _this4 = this;

      if (!this.copyData.client || this.copyData.client !== this.selectedClient || !this.copyData.filterObject) return;
      this.filterObject = this.copyData.filterObject;
      this.$nextTick(function () {
        _this4.$refs.shopperFilterComponent.restoreFilterSettings();
      });
    },
    convertCountryList: function convertCountryList(data) {
      this.countryList = [];
      for (var country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country]
        });
      }
    },
    getLocationProperties: function getLocationProperties() {
      var _this5 = this;

      if (this.locationPropertiesList.length > 0) return;

      var query = "api/Recruiting/Data/LocationProperties/" + this.selectedClient;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this5.locationPropertiesList = data;
        },
        error: function error() {
          console.error("Error on GET in getLocationProperties()");
          _this5.globals.showErrorSnackbar(_this5.lang.CSM002);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SurveyManagement_SurveyManagementEditModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SurveyManagement_SurveyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SurveyManagement_SurveyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImporterManagement__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImporterManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ImporterManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Clients__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_UserSecurity__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tools_utils__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_Surveys__ = __webpack_require__(70);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ClientManagement",
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setClientTableHeight);
    this.getClientData();
    this.getEditClientDialogSelectData();
    this.getCPList();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setClientTableHeight).resize();

    this.globals.$once("ConfirmCXKundeYesConfirmation", function () {
      _this.editClientDialogData.clientData.ClientCx = true;
    });
    this.globals.$once("ConfirmCXKundeNoConfirmation", function () {
      _this.editClientDialogData.clientData.ClientCx = false;
    });
    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setClientTableHeight);
  },
  destroyed: function destroyed() {
    if (this.fpInputSince) this.fpInputSince.destroy();
    $(window).off("resize", this.setClientTableHeight);
    this.writeComponentSettingsToStore();
  },

  computed: {
    toLowerCaseForbidden: function toLowerCaseForbidden() {
      return this.forbiddenCPs.map(function (e) {
        return e.toLowerCase();
      });
    },
    selectedClientData: function selectedClientData() {
      var _this2 = this;

      if (!this.clientData.length || this.selectedClient < 1) return null;
      return this.clientData.filter(function (c) {
        return c.ClientId === _this2.selectedClient;
      })[0];
    }
  },
  methods: {
    currentCPNames: function currentCPNames(filterFn) {
      if (filterFn) {
        return this.editClientDialogData.clientData.CustomProperties.filter(filterFn).map(function (e) {
          return e.Name;
        });
      } else {
        return this.editClientDialogData.clientData.CustomProperties.map(function (e) {
          return e.Name;
        });
      }
    },
    getCPList: function getCPList() {
      var _this3 = this;

      // TODO: add real Endpoint
      __WEBPACK_IMPORTED_MODULE_8__services_UserSecurity__["a" /* default */].LocationProperties.getCxProperties().then(function (data) {
        _this3.forbiddenCPs = data.data.CxPropertyNames;
      });
    },
    setCXKunde: function setCXKunde(_event) {
      if (!this.editClientDialogData.clientData.WasCX && this.editClientDialogData.clientData.ClientCx) {
        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "ConfirmCXKunde",
          confirmationTitle: this.lang.C0126,
          colorRed: false,
          yesButtonText: this.lang.C0128,
          noButtonText: this.lang.C0100,
          htmlText: "<p>" + this.lang.C0127 + "</p>\n          <br><p>" + this.lang.C0129 + "</p>"
        });
      }
    },
    setClientTableHeight: function setClientTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#clients-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards

        $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/clientManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName) {
          this.searchString = this.globals.removeWildcardsFromString(storedClient.ClientName);
        } else this.searchString = "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/clientManagement", {
        searchString: this.searchString,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (this.globals.removeWildcardsFromString(storedClient.ClientName) !== this.searchString) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.globals.addWildcardsToString(this.searchString)
          });
        }
      }
    },
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.includes(id);
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var _this4 = this;

      // [#1208] check dissalowed cp Names
      if (this.editClientDialogData.clientData.CustomProperties && this.editClientDialogData.clientData.CustomProperties.length > 0) {
        // filter new and old(notcx) props
        if (this.currentCPNames(function (el) {
          return !el.LocationPropertyGuid;
        }).some(function (cp) {
          return !_this4.isAllowedCP(cp);
        })) {
          this.globals.showErrorSnackbar(this.lang.C0131);
          return false;
        }

        var hasoldCX = this.currentCPNames(function (el) {
          return el.LocationPropertyGuid && !el.Cx;
        }).some(function (cp) {
          return !_this4.isAllowedCP(cp);
        });
        if (hasoldCX && !this.editClientDialogData.clientData.ClientCx) {
          this.globals.showErrorSnackbar(this.lang.C0131);
          return false;
        }

        if (this.hasDuplicates(this.currentCPNames())) {
          this.globals.showErrorSnackbar(this.lang.C0132);
          return false;
        }
      }
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editClient") {
        this.editClientDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditClientDialogData();
      }
      return true;
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },


    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed: function onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
    },


    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved: function onEditSurveyDialogDataSaved(savedSurvey) {
      var _this5 = this;

      if (!this.editSurveyDialogModeAdd) {
        var changedSurvey = this.editClientDialogData.clientData.Surveys.filter(function (e) {
          return e.SurveyId == _this5.editClientDialogData.selectedSurvey.SurveyId;
        });
        changedSurvey[0].SurveyTitle = savedSurvey.SurveyTitle;
      }
    },


    // Returns the title of the selected survey
    getSelectedSurveyTitle: function getSelectedSurveyTitle() {
      var _this6 = this;

      if (!this.editClientDialogData.clientData.Surveys) return "";
      var currentSurvey = this.editClientDialogData.clientData.Surveys.filter(function (s) {
        return s.SurveyId == _this6.editClientDialogData.selectedSurvey.SurveyId;
      });
      if (currentSurvey.length < 1) return "";
      return currentSurvey[0].SurveyTitle;
    },


    // Sends a delete request for the selected survey to the server
    deleteSurvey: function deleteSurvey() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_10__services_Surveys__["a" /* default */].deleteByD(this.editClientDialogData.selectedSurvey.SurveyId).then(function (_res) {
        _this7.globals.showSuccessSnackbar("Survey deletion successful");
        // If DELETE was successful, remove survey from survey list
        _this7.editClientDialogData.clientData.Surveys = _this7.editClientDialogData.clientData.Surveys.filter(function (e) {
          return e.SurveyId != _this7.editClientDialogData.selectedSurvey.SurveyId;
        });
        _this7.editClientDialogData.selectedSurvey.SurveyId = -1;
        _this7.showDeleteSurveyModal = false;
      }).catch(function (_ref) {
        var msg = _ref.msg,
            Error = _ref.Error;

        console.error("Error on DELETE in deleteSurvey()", msg);
        _this7.globals.showErrorSnackbar("Survey deletion failed");
      });
    },


    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor: function redirectToSurveyEditor(surveyId) {
      var _this8 = this;

      $.ajax({
        method: "PATCH",
        url: "api/Surveys/" + surveyId + "/Lock",
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this8.globals.showErrorSnackbar(data.Error);else {
            $("#editClient").modal("hide");
            window.name = "MSMLoopMainApp";
            window.open(window.origin + "/survey.html#/editor/" + surveyId);
          }
        },
        error: function error() {
          console.error("Error on PATCH in redirectToSurveyEditor()");
          _this8.globals.showErrorSnackbar("Survey lock failed");
        }
      });
    },
    isAllowedCP: function isAllowedCP(cp) {
      if (!(typeof cp === "string")) return false;
      if (cp.length === 0) return false;
      if (this.forbiddenCPs.includes(cp)) return false;
      if (this.toLowerCaseForbidden.includes(cp.toLowerCase())) return false;
      return true;
    },


    /**
     * returns true if a given array of strings contains duplicates
     * @param {string[]} arr
     * @returns {boolean}
     */
    hasDuplicates: function hasDuplicates(arr) {
      var cps = arr;
      var unique = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(cps));
      return unique.length !== cps.length;
    },
    canAddNewNewCustomProperty: function canAddNewNewCustomProperty() {
      var _this9 = this;

      if (this.editClientDialogData.newCustomProperty.trim() === "") {
        return false;
      }
      if (this.editClientDialogData.clientData.CustomProperties && this.editClientDialogData.clientData.CustomProperties.find(function (v) {
        return v.Name === _this9.editClientDialogData.newCustomProperty.trim();
      })) {
        return false;
      }
      return true;
    },


    // Adds a new custom property to client data
    addNewCustomProperty: function addNewCustomProperty() {
      if (this.editClientDialogData.newCustomProperty.trim() === "") {
        this.globals.showErrorSnackbar(this.lang.C0130);
        return;
      }

      this.editClientDialogData.newCustomProperty = this.editClientDialogData.newCustomProperty.trim();

      if (!this.isAllowedCP(this.editClientDialogData.newCustomProperty)) {
        this.globals.showErrorSnackbar(this.lang.C0131);
        return;
      }

      if (!("CustomProperties" in this.editClientDialogData.clientData)) this.editClientDialogData.clientData.CustomProperties = [];

      var newProp = {
        ID: "",
        Name: this.editClientDialogData.newCustomProperty,
        Visibility: 0,
        Position: this.editClientDialogData.clientData.CustomProperties.length + 1
      };
      this.editClientDialogData.clientData.CustomProperties.push(newProp);
      this.editClientDialogData.newCustomProperty = "";

      this.correctTextareaHeight();
    },


    // Shows a security dialog to ask the user if a custom property should really be deleted
    openRemoveCustomPropertyDialog: function openRemoveCustomPropertyDialog(propId) {
      this.removeCustomPropertySecurityDialogData.propId = propId;
      this.removeCustomPropertySecurityDialogData.propName = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id == propId;
      })[0].Name;
      $("#removeCustomPropertySecurityDialog").modal("show");
    },


    // Removes the custom property with the given ID from the client data
    removeCustomProperty: function removeCustomProperty(propId) {
      var position = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id == propId;
      })[0].Position;

      this.editClientDialogData.clientData.CustomProperties = this.editClientDialogData.clientData.CustomProperties.filter(function (prop) {
        return prop.Id != propId;
      });

      var prop;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.editClientDialogData.clientData.CustomProperties), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          prop = _step.value;

          if (prop.Position > position) prop.Position--;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      $("#removeCustomPropertySecurityDialog").modal("hide");
      this.$forceUpdate();
      this.correctTextareaHeight();
    },


    // Reorders custom properties after the position of a property changed
    reorderCustomProperties: function reorderCustomProperties() {
      var allPositions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Tools_utils__["a" /* getRange */])(1, this.editClientDialogData.clientData.CustomProperties.length, 1);
      var missingPos = 0;
      var newPos = 0;
      var propName = "";

      // Find missing position number and the position and name of the changed property
      for (var i = 0; i < allPositions.length; i++) {
        if (this.editClientDialogData.clientData.CustomProperties[i].Position != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.editClientDialogData.clientData.CustomProperties[i].Position;
          propName = this.editClientDialogData.clientData.CustomProperties[i].Name;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.editClientDialogData.clientData.CustomProperties[i].Name != propName) {
          // Do NOT move the changed property
          if (this.editClientDialogData.clientData.CustomProperties[i].Position < missingPos && this.editClientDialogData.clientData.CustomProperties[i].Position >= newPos) {
            this.editClientDialogData.clientData.CustomProperties[i].Position++;
          }
          if (this.editClientDialogData.clientData.CustomProperties[i].Position > missingPos && this.editClientDialogData.clientData.CustomProperties[i].Position <= newPos) {
            this.editClientDialogData.clientData.CustomProperties[i].Position--;
          }
        }
      }
      this.sortCustomPropertiesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },


    // Sorts the available custom properties by their position number
    sortCustomPropertiesByPosition: function sortCustomPropertiesByPosition() {
      if (typeof this.editClientDialogData.clientData.CustomProperties == "undefined") return;
      this.editClientDialogData.clientData.CustomProperties.sort(function (a, b) {
        return a.Position - b.Position;
      });
      this.correctTextareaHeight();
    },

    /**
     * returns true if you can remove that property
     */
    isCustomPropertyRemovable: function isCustomPropertyRemovable(prop) {
      var ret = false;
      switch (true) {
        case prop.LocationPropertyGuid === "F65898B5-4D53-4E4E-959A-06D128D9F7FE":
          ret = false;
          break;
        case prop.LocationPropertyGuid === "B820479A-0F40-4584-9C76-8553AD91276D":
          ret = false;
          break;
        case prop.Cx:
          ret = false;
          break;
        default:
          ret = true;
          break;
      }
      return ret;
    },


    // Refreshes the region list in the dropdown of the editClient dialog depending on the selected country
    changedCountry: function changedCountry(country, section) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter(function (region) {
            // Filter regions for the given country
            return region.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter(function (tz) {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (section == "general") {
        if (regionObj.length == 0) this.editClientDialogData.currentRegionsGeneral = [];else this.editClientDialogData.currentRegionsGeneral = regionObj[0].Regions;

        if (tzObj.length == 0) this.editClientDialogData.currentTimeZonesGeneral = [];else this.editClientDialogData.currentTimeZonesGeneral = tzObj[0].TimeZones;

        var idx = this.editClientDialogData.currentRegionsGeneral.map(function (e) {
          return e.RegionGuid;
        }).indexOf(this.editClientDialogData.clientData.ClientRegionGuid);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientRegionGuid;

        idx = this.editClientDialogData.currentTimeZonesGeneral.map(function (e) {
          return e.TimeZoneId;
        }).indexOf(this.editClientDialogData.clientData.ClientTimeZoneId);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientTimeZoneId;
      } else if (section == "billing") {
        if (regionObj.length == 0) this.editClientDialogData.currentRegionsBilling = [];else this.editClientDialogData.currentRegionsBilling = regionObj[0].Regions;

        var idx = this.editClientDialogData.currentRegionsBilling.map(function (e) {
          return e.RegionGuid;
        }).indexOf(this.editClientDialogData.clientData.ClientBillingRegionGuid);

        if (idx < 0) delete this.editClientDialogData.clientData.ClientBillingRegionGuid;
      }
    },


    // Opens the editClient dialog after dialog data received
    editClientDialogDataReceived: function editClientDialogDataReceived() {
      $("#editClient").modal("show");

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#editClient").off("shown.bs.modal", this.correctTextareaHeight);
        $("#editClient").on("shown.bs.modal", this.correctTextareaHeight);
      }
      $("#collapseCustProp").off("shown.bs.collapse", this.correctTextareaHeight);
      $("#collapseCustProp").on("shown.bs.collapse", this.correctTextareaHeight);
    },


    // Fills the editClient dialog with data, depending on the dialog mode.
    // Available modes: "create" --> New client is created, default values are set
    //                  "edit" --> Edit existing client, catch values from server
    openEditClientDialog: function openEditClientDialog(mode) {
      var _this10 = this;

      this.fpInputSince = flatpickr("#inputSinceClientMgmtEdit", this.globals.flatpickrDateConfig);

      if (mode == "create") {
        this.editClientDialogData.dialogTitle = this.lang.C0088;
        this.editClientDialogData.dialogType = "create";
        delete this.editClientDialogData.clientData.ClientId;
        delete this.editClientDialogData.clientData.ClientName;
        delete this.editClientDialogData.clientData.ClientAddress;
        delete this.editClientDialogData.clientData.ClientAddress2;
        delete this.editClientDialogData.clientData.ClientCity;
        delete this.editClientDialogData.clientData.ClientRegionName;
        delete this.editClientDialogData.clientData.ClientPostalCode;
        delete this.editClientDialogData.clientData.ClientCountry;
        delete this.editClientDialogData.clientData.ClientSince;
        delete this.editClientDialogData.clientData.ClientContactFirstName;
        delete this.editClientDialogData.clientData.ClientContactLastName;
        delete this.editClientDialogData.clientData.ClientContactPhone;
        delete this.editClientDialogData.clientData.ClientContactFax;
        delete this.editClientDialogData.clientData.ClientContactEmail;
        delete this.editClientDialogData.clientData.ClientBillTo;
        delete this.editClientDialogData.clientData.ClientBillingAddress;
        delete this.editClientDialogData.clientData.ClientBillingAddress2;
        delete this.editClientDialogData.clientData.ClientBillingCity;
        delete this.editClientDialogData.clientData.ClientBillingState_Region;
        delete this.editClientDialogData.clientData.ClientBillingCountry;
        delete this.editClientDialogData.clientData.ClientBillingPostalCode;
        delete this.editClientDialogData.clientData.ClientBillToEmail;
        delete this.editClientDialogData.clientData.ClientBillingTerms;
        delete this.editClientDialogData.clientData.ClientTimeZoneId;
        delete this.editClientDialogData.clientData.ClientAdditionalInfo;
        delete this.editClientDialogData.clientData.ClientPageLogoURL;
        this.editClientDialogData.clientData.ClientStatusId = "A";
        this.editClientDialogData.clientData.ClientTypeGuid = "3B5C81B1-1F9A-4EC1-8138-E42C58236FB1"; // Real client
        this.editClientDialogData.clientData.Surveys = [];
        this.editClientDialogData.clientData.CustomProperties = [];

        this.changedCountry("", "general");
        this.changedCountry("", "billing");
        $("#editClient").modal("show");
        this.fpInputSince.clear();
      } else if (mode == "edit") {
        this.editClientDialogData.dialogTitle = this.lang.C0089;
        this.editClientDialogData.dialogType = "edit";
        this.editClientDialogData.clientData = {};
        __WEBPACK_IMPORTED_MODULE_7__services_Clients__["a" /* default */].getClientbyID(this.selectedClient).then(function (res) {
          var data = res.data;
          _this10.editClientDialogDataReceived();
          _this10.editClientDialogData.clientData = data; // Store response data from server
          _this10.changedCountry(_this10.editClientDialogData.clientData.ClientCountry, "general"); // Load region dropdown depending on the selected country
          _this10.changedCountry(_this10.editClientDialogData.clientData.ClientBillingCountry, "billing");
          _this10.sortCustomPropertiesByPosition();

          _this10.fpInputSince.setDate(_this10.editClientDialogData.clientData.ClientSince);
        }).catch(function (errObj) {
          console.error("Client data access failed in openEditClientDialog()");
          console.error(errObj);
          _this10.globals.showErrorSnackbar("Client data access failed");
        });
      } else {
        // Wrong mode
        console.error("Wrong client dialog mode in openEditClientDialog()");
        $("#editClient").modal("hide");
        return false;
      }
      this.editClientDialogData.selectedSurvey.SurveyId = -1;
      this.editClientDialogData.showAlert = false;
      this.resetValidationErrors("editClient");
      return true; // Mode was ok
    },


    // Catches data for dropdown lists from server
    getEditClientDialogSelectData: function getEditClientDialogSelectData() {
      var _this11 = this;

      if (this.globals.selectedLanguage) this.globals.getCountryList();
      this.globals.getRegionsList(function (callbackData) {
        _this11.regionList = callbackData;
      });
      this.globals.getTimezonesList(function (callbackData) {
        _this11.timeZones = callbackData;
      });
      this.globals.getLanguageList(function (callbackData) {
        _this11.languageList = callbackData;
      });
      this.globals.getLocaleList(function (callbackData) {
        _this11.localesList = callbackData;
      });
      this.globals.getClientTypes(function (callbackData) {
        _this11.clientTypes = callbackData;
      });
    },


    // Sends the data from editClient dialog to the server to store it in the database
    saveEditClientDialogData: function saveEditClientDialogData() {
      var _this12 = this;

      if (!this.editClientDialogData.clientData.ClientTypeGuid) this.editClientDialogData.clientData.ClientTypeGuid = "3B5C81B1-1F9A-4EC1-8138-E42C58236FB1"; // Real client

      if (this.editClientDialogData.dialogType == "create") {
        // Create new client

        this.editClientDialogData.clientData.ClientCx = !!this.editClientDialogData.clientData.ClientCx;
        __WEBPACK_IMPORTED_MODULE_7__services_Clients__["a" /* default */].createClient(this.editClientDialogData.clientData).then(function (res) {
          var data = res.data;
          $("#editClient").modal("hide");
          _this12.globals.showSuccessSnackbar("Client creation successful");

          _this12.globals.clientList = [];
          _this12.getClientData();

          if (data && data[0] && data[0].ClientId) _this12.selectedClient = data[0].ClientId;
        }).catch(function (err) {
          console.error("Error on POST in saveEditClientDialogData(),", err);
          _this12.globals.showErrorSnackbar("Client creation failed");
        });
      } else if (this.editClientDialogData.dialogType == "edit") {
        // Update existing client
        __WEBPACK_IMPORTED_MODULE_7__services_Clients__["a" /* default */].updateClient(this.editClientDialogData.clientData.ClientId, this.editClientDialogData.clientData).then(function (_res) {
          $("#editClient").modal("hide");
          _this12.globals.showSuccessSnackbar("Client update successful");

          _this12.globals.clientList = [];
          _this12.getClientData();
        }).catch(function (err) {
          console.error("Error on PUT in saveEditClientDialogData()", err);
          _this12.globals.showErrorSnackbar("Client update failed");
        });
      } else console.error("Wrong client dialog mode in saveEditClientDialogData()");
    },


    // Calculates the sort order for the given column and triggers the filter where the clientdata will be sorted
    sortClientData: function sortClientData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.filterClientData();
    },


    // Catches client data for the table from the server
    getClientData: function getClientData() {
      var _this13 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded
      __WEBPACK_IMPORTED_MODULE_7__services_Clients__["a" /* default */].getClients().then(function (_ref2) {
        var data = _ref2.data;

        _this13.clientData = [];
        if (!_.isEmpty(data)) _this13.clientData = data;
        _this13.filterClientData();
      }).catch(function (err) {
        console.error("Error on GET in getClientData()");
        _this13.globals.showErrorSnackbar("Cant get Clients");
      }).finally(function (r) {
        _this13.refreshEnabled = true; // Enable refresh of the client data after server response
      });
    },


    // Updates the current pagesize and the selected pagenumber and triggers the reload of the page
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfClientData();
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Tools_utils__["a" /* getRange */])(1, this.numberOfPages(), 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Tools_utils__["a" /* getRange */])(1, 6, 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Tools_utils__["a" /* getRange */])(this.numberOfPages() - 5, this.numberOfPages(), 1);
      } else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__Tools_utils__["a" /* getRange */])(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },


    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages: function numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredClientData.length % this.pageSize == 0) return this.filteredClientData.length / this.pageSize;else return parseInt(this.filteredClientData.length / this.pageSize) + 1;
    },


    // Selects the client data that has to be displayed on the selected page
    loadCurrentPageOfClientData: function loadCurrentPageOfClientData() {
      if (this.pageSize == -1) this.clientDataOnCurrentPage = this.filteredClientData;else {
        // Display all data, no pages
        this.clientDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredClientData[i] != null) this.clientDataOnCurrentPage[i - startIndex] = this.filteredClientData[i];
        }
      }
    },


    // Filters the client data by every single word in the searchString, separated by a blank
    // and triggers the sorting and the reload of the selected page, so that the expected data is displayed on the table
    filterClientData: function filterClientData() {
      if (!this.searchString) this.filteredClientData = this.clientData;
      var words = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.searchString.trim().split(" ")));

      var keys = ["ClientId", "ClientName", "ClientAddress", "ClientPostalCode", "ClientCity", "ClientRegionCode", "ClientCountry"];

      /**
       * Returns true if any word is contained in any of the keys of the client or the words are empty
       */
      var clientFilter = function clientFilter(client) {
        var containsSearch = false;
        if (words[0].length <= 0) return true;
        words.forEach(function (word) {
          return keys.forEach(function (key) {
            if (!containsSearch) containsSearch = client[key] && client[key].toString().toLowerCase().includes(word.toLowerCase());
          });
        });
        return containsSearch;
      };
      this.filteredClientData = !_.isEmpty(this.clientData) ? this.clientData.filter(clientFilter) : [];

      this.startSorting(this.filteredClientData); // Sort the filtered data
      this.loadCurrentPageOfClientData(); // Display selected page of filtered and sorted data
    },


    // Sorts the clientData depending on the selected column and sort order
    startSorting: function startSorting(clientData) {
      // Sort by ID
      switch (this.sortField) {
        case "id":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            return a.ClientId - b.ClientId;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            return a.ClientId - b.ClientId;
          });
          break;
        case "name":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
          break;
        case "address":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase()) return -1;
            if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase()) return 1;
            return 0;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            if (a.ClientAddress.toLowerCase() < b.ClientAddress.toLowerCase()) return -1;
            if (a.ClientAddress.toLowerCase() > b.ClientAddress.toLowerCase()) return 1;
            return 0;
          });
          break;
        case "city":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase()) return -1;
            if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase()) return 1;
            return 0;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            if (a.ClientCity.toLowerCase() < b.ClientCity.toLowerCase()) return -1;
            if (a.ClientCity.toLowerCase() > b.ClientCity.toLowerCase()) return 1;
            return 0;
          });
          break;
        case "region":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            if (!a.ClientState_Region) a.ClientState_Region = "";
            if (!b.ClientState_Region) b.ClientState_Region = "";

            if (a.ClientRegionName.toLowerCase() < b.ClientRegionName.toLowerCase()) return -1;
            if (a.ClientRegionName.toLowerCase() > b.ClientRegionName.toLowerCase()) return 1;
            return 0;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            if (!a.ClientState_Region) a.ClientState_Region = "";
            if (!b.ClientState_Region) b.ClientState_Region = "";

            if (a.ClientRegionName.toLowerCase() < b.ClientRegionName.toLowerCase()) return -1;
            if (a.ClientRegionName.toLowerCase() > b.ClientRegionName.toLowerCase()) return 1;
            return 0;
          });
          break;
        case "postalcode":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            return a.ClientPostalCode - b.ClientPostalCode;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            return a.ClientPostalCode - b.ClientPostalCode;
          });
          break;
        case "country":
          if (this.sortOrder == "asc") clientData.sort(function (a, b) {
            if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase()) return -1;
            if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase()) return 1;
            return 0;
          });else if (this.sortOrder == "desc") clientData.sort(function (b, a) {
            if (a.ClientCountry.toLowerCase() < b.ClientCountry.toLowerCase()) return -1;
            if (a.ClientCountry.toLowerCase() > b.ClientCountry.toLowerCase()) return 1;
            return 0;
          });
          break;
        default:
          console.error("Error: invalid sortField in startSorting()");
          break;
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setClientTableHeight);
      this.globals.getCountryList();
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedClient: -1, // ID of the selected client, -1 if none is selected
      pageSize: 20, // Number of clients on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      searchString: "",
      sortField: "name", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if client data is requested and server did not respond yet to avoid multiple requests at the same time
      filteredClientData: [], // Stores the client data that passed the filter
      clientDataOnCurrentPage: [], // Stores the client data on the current page
      clientData: [], // Stores the whole client data from server
      timeZones: [], // List of available timezones
      regionList: [], // List of all available regions
      languageList: {},
      localesList: [],
      clientTypes: [],
      forbiddenCPs: [], // Dont Allow Properties with this name
      fpInputSince: null,
      editClientDialogData: {
        // Data for the editClient dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        clientData: {}, // The client data of the selected client is stored here
        currentRegionsGeneral: [], // List of regions in the selected country in the general section
        currentRegionsBilling: [], // List of regions in the selected country in the billing section
        currentTimeZonesGeneral: [],
        newCustomProperty: "", // Stores the name of a new custom property
        showAlert: false, // true --> Alert for validation errors is visible
        selectedSurvey: { SurveyId: -1 } // Stores the selected survey on the survey page
      },
      removeCustomPropertySecurityDialogData: {
        propId: -1,
        propName: ""
      },
      showEditSurveyDialog: false,
      showDeleteSurveyModal: false,
      showImportersModal: false,
      editSurveyDialogModeAdd: true,
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        C0000: "Aktualisieren",
        C0001: "Neuer Kunde",
        C0002: "Bearbeiten",
        C0005: "Geokodierung",
        C0006: "Neuer Fragebogen",
        C0007: "Suche...",
        C0008: "Elemente pro Seite",
        C0009: "Alle",
        C0010: "Erste Seite",
        C0011: "Letzte Seite",
        C0012: "Kunden-ID",
        C0013: "Kundenname",
        C0014: "Straße",
        C0015: "Stadt",
        C0016: "Region",
        C0017: "PLZ",
        C0018: "Land",
        C0019: "ID",
        C0020: "Allgemein",
        C0021: "Kundenname",
        C0022: "Straße",
        C0023: "Adresszusatz",
        C0024: "Stadt",
        C0025: "Region",
        C0026: "Bitte auswählen...",
        C0027: "Land",
        C0028: "PLZ",
        C0029: "Kunde seit dem",
        C0030: "Zeitzone",
        C0031: "Zusätzliche Anmerkungen",
        C0032: "Kontakt",
        C0033: "Vorname",
        C0034: "Nachname",
        C0035: "Telefon",
        C0036: "Fax",
        C0037: "E-Mail",
        C0038: "Rechnungsinformationen",
        C0039: "Rechnungsempfänger",
        C0040: "Adresse",
        C0041: "Adresszusatz",
        C0042: "Stadt",
        C0043: "Region",
        C0044: "Land",
        C0045: "PLZ",
        C0046: "E-Mail",
        C0047: "Bezeichnungen",
        C0048: "Personalisierung",
        C0049: "Kundenlogo URL",
        C0050: "Jedes Bild-Format ist erlaubt, jedoch für beste Bildqualität, benutzen Sie PNG-Format mit transparentem Hintergrund und einer Höhe unter 100 Pixel.",
        C0051: "Begrüßungstext für Kunden",
        C0052: "Beispiel",
        C0053: "Willkommen",
        C0054: "Erlaubt Platzhalter",
        C0055: "Startseite Layout",
        C0056: "Farbkodierung",
        C0057: "MSM Navigator Standarddefinition",
        C0058: "Nachkommastellen",
        C0059: "Fragebögen",
        C0060: "ID",
        C0061: "Fragebogen",
        C0062: "Custom Properties",
        C0063: "Neue Auswertungsebene",
        C0064: "Hinzufügen",
        C0065: "Eigenschaftsbezeichnung",
        C0066: "ID",
        C0067: "Position",
        C0068: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0069: "Abbrechen",
        C0070: "Speichern",
        C0088: "Neuer Kunde",
        C0089: "Kunden bearbeiten",
        C0090: "Diese Angabe ist erforderlich!",
        C0091: "Dies ist keine gültige Telefonnummer!",
        C0092: "Dies ist keine gültige Faxnummer!",
        C0093: "Dies ist keine gültige URL!",
        C0094: "Dies ist keine gültige E-Mail Adresse!",
        C0095: "Neuer Fragebogen",
        C0096: "Allgemein",
        C0097: "Kunde",
        C0098: "Titel",
        C0099: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        C0100: "Abbrechen",
        C0101: "Speichern",
        C0102: "Fragebogen bearbeiten",
        C0103: "Sichtbarkeit",
        C0104: "Operativ",
        C0105: "Reporting",
        C0107: "Bearbeiten",
        C0108: "Fragebogen Editor",
        C0109: "Löschen",
        C0110: "Benutzerdefinierte Eigenschaft löschen",
        C0111: "ACHTUNG: Beim Entfernen einer Benutzerdefinierten Eigenschaft, werden auch alle zugehörigen Definitionen bei den Standorten entfernt!",
        C0112: "Soll die Benutzerdefinierte Eigenschaft",
        C0113: "wirklich gelöscht werden?",
        C0114: "Nein",
        C0115: "Ja",
        C0116: "Delete Survey",
        C0117: "Do you really want to delete the following survey?",
        C0118: "Importers",
        C0119: "Total clients count",
        C0120: "Type",
        C0121: "Status",
        C0122: "Active",
        C0123: "Inactive",
        C0124: "CX Kunde",
        C0125: "Mark as CX and create relevant custom properties",
        C0126: "Mark as CX relevant?",
        C0127: "Confirm that you want to mark this Client as CX relevant",
        C0128: "Confirm",
        C0129: "This will create additional Custom Properties",
        C0130: "Invalider Input",
        C0131: "Verbotene Eigenschaft",
        C0132: "Duplizierte Eigenschaft"
      }
    };
  },

  components: {
    SurveyManagementEditModal: __WEBPACK_IMPORTED_MODULE_4__SurveyManagement_SurveyManagementEditModal___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_5__Tools_Dialogs_ConfirmationDialog___default.a,
    ImporterManagement: __WEBPACK_IMPORTED_MODULE_6__ImporterManagement___default.a
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImporterManagement",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newImporter: "",
      importerList: [],
      isImporterEditing: false,
      lang: {
        IMP000: "Importers",
        IMP001: "New importer",
        IMP002: "Add",
        IMP003: "Importer",
        IMP004: "Actions",
        IMP005: "Close",
        IMP006: "Importer list access failed",
        IMP007: "Importer name already exists",
        IMP008: "Importer creation successful",
        IMP009: "Importer creation failed",
        IMP010: "Importer update successful",
        IMP011: "Importer update failed",
        IMP012: "Importer deletion successful",
        IMP013: "Importer deletion failed",
        IMP014: "Delete Importer",
        IMP015: "Yes",
        IMP016: "No",
        IMP017: "Do you really want to delete the following importer?",
        IMP018: "Empty importer name not allowed"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#importerManagementModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.newImporter = "";
      this.isImporterEditing = false;
      this.getImporterList();
      $("#importerManagementModal").modal("show");
    },
    closeModal: function closeModal() {
      this.globals.importerList = [];
      $("#importerManagementModal").modal("hide");
    },
    getImporterList: function getImporterList() {
      var _this2 = this;

      $.ajax({
        method: "GET",
        url: "api/Importer",
        success: function success(data) {
          _this2.importerList = [];
          if (!_.isEmpty(data)) {
            _this2.importerList = data;
            var internationalImporter = _.remove(_this2.importerList, function (importer) {
              return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
            });
            if (internationalImporter[0]) _this2.importerList.unshift(internationalImporter[0]);
          }
        },
        error: function error() {
          console.error("Importer list access failed in getImporterList()");
          _this2.globals.showErrorSnackbar(_this2.lang.IMP006);
        }
      });
    },
    addNewImporter: function addNewImporter() {
      var _this3 = this;

      $("#inputNewImporter").focus();
      if (!this.newImporter || this.isImporterEditing) return;
      if (_.findIndex(this.importerList, function (i) {
        return i.ImporterName === _this3.newImporter;
      }) > -1) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        return;
      }
      var postData = {
        ImporterName: this.newImporter
      };
      $.ajax({
        method: "POST",
        url: "api/Importer",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.importerList.unshift(data);
          _this3.globals.showSuccessSnackbar(_this3.lang.IMP008);
          _this3.newImporter = "";
        },
        error: function error() {
          console.error("Error on POST in addNewImporter()");
          _this3.globals.showErrorSnackbar(_this3.lang.IMP009);
        }
      });
    },
    updateImporter: function updateImporter(importer) {
      var _this4 = this;

      $.ajax({
        method: "PUT",
        url: "api/Importer/" + importer.ImporterGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(importer),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.globals.showSuccessSnackbar(_this4.lang.IMP010);
        },
        error: function error() {
          console.error("Error on PUT in updateImporter()");
          _this4.globals.showErrorSnackbar(_this4.lang.IMP011);
        }
      });
    },
    deleteImporter: function deleteImporter(importer) {
      var _this5 = this;

      if (this.isImporterEditing) return;

      this.globals.$off("DeleteImporterYesConfirmation");
      this.globals.$on("DeleteImporterYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/Importer/" + importer.ImporterGuid,
          success: function success(data) {
            _.remove(_this5.importerList, function (i) {
              return i.ImporterGuid === importer.ImporterGuid;
            });
            _this5.$forceUpdate();
            _this5.globals.showSuccessSnackbar(_this5.lang.IMP012);
          },
          error: function error() {
            console.error("Error on DELETE in deleteImporter()");
            _this5.globals.showErrorSnackbar(_this5.lang.IMP013);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteImporter",
        confirmationTitle: this.lang.IMP014,
        colorRed: true,
        yesButtonText: this.lang.IMP015,
        noButtonText: this.lang.IMP016,
        htmlText: "<p>" + this.lang.IMP017 + "</p>\n                  <p><b>" + importer.ImporterName + "</b></p>"
      });
    },
    editImporter: function editImporter(e, importer) {
      if (this.isImporterEditing) return;
      importer.editing = true;
      this.isImporterEditing = true;
      importer.prevImporterName = importer.ImporterName;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveImporter: function saveImporter(e, importer) {
      var input = $(e.target).closest("tr").find("input");

      if (!importer.ImporterName) {
        this.globals.showErrorSnackbar(this.lang.IMP018);
        input.focus();
        return;
      }

      var count = _.filter(this.importerList, function (i) {
        return i.ImporterName === importer.ImporterName;
      }).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.IMP007);
        input.focus();
        return;
      }

      this.isImporterEditing = false;
      delete importer.editing;
      delete importer.prevImporterName;
      input.prop("readonly", "true");
      this.updateImporter(importer);
    },
    undoImporterChanges: function undoImporterChanges(e, importer) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isImporterEditing = false;
      delete importer.editing;
      importer.ImporterName = importer.prevImporterName;
      delete importer.prevImporterName;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ImportUsersModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    $("#importUsersDialog").on("hidden.bs.modal", function () {
      _this.$emit("dialogClosed");
    });

    $("#importUsersImportFileInput").click(function (e) {
      $(e.target).val("");
      _this.importUsersDialogData.selectedFile = {};
      _this.$forceUpdate();
    });
  },

  methods: {
    openImportUsersDialog: function openImportUsersDialog() {
      var selOption = this.importUsersDialogData.selectedOption;
      this.importUsersDialogData = {
        selectedOption: selOption,
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false
      };

      if (this.feature.isAudiTarget && this.clientList[0]) {
        this.importUsersDialogData.UserTypeId = 4;
        this.importUsersDialogData.ClientId = this.clientList[0].ClientId;
      }

      $("#importUsersImportFileInput").val("");
      this.importStep = 1; //TODO:
      $("#importUsersDialog").modal("show");
    },
    closeImportUsersDialog: function closeImportUsersDialog() {
      $("#importUsersDialog").modal("hide");
    },
    downloadUserList: function downloadUserList() {
      // TODO:
      if (this.importUsersDialogData.serverResponse && this.importUsersDialogData.serverResponse[0] && this.importUsersDialogData.serverResponse[0].DownloadId) {
        this.globals.downloadFile(this.importUsersDialogData.serverResponse[0].DownloadId);
        this.closeImportUsersDialog();
      } else console.error("Missing downloadId in downloadUserList()");
    },
    uploadImportData: function uploadImportData() {
      var _this2 = this;

      if (this.importUsersDialogData.UserTypeId == 4 && !this.importUsersDialogData.ClientId) {
        this.globals.showErrorSnackbar("Please select a client");
        console.error("Missing client selection for user export");
        return;
      }

      if (this.importUsersDialogData.selectedOption === "text") {
        if (this.importUsersDialogData.selectedText === "") {
          this.globals.showErrorSnackbar("Please insert import data");
          console.error("Error: No import text available in uploadImportData()");
          return;
        }

        // Escape all " characters
        var importText = this.importUsersDialogData.selectedText.replace(/"/g, '\\"');

        // Build import JSON
        var importString = '{"data":"';
        importString += importText + '"';
        importString += ',"trim":' + this.importUsersDialogData.trimImportData;
        importString += "}";

        var url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: url,
          data: importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: function success(data) {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            _this2.getCurrentImportData();
          },
          error: function error() {
            console.error("Error on POST in uploadImportData()");
            _this2.globals.showErrorSnackbar("User import failed");
          },
          complete: function complete() {
            _this2.importUsersDialogData.selectedText = "";
            _this2.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
            _this2.$emit("importComplete");
          }
        });
      } else if (this.importUsersDialogData.selectedOption === "file") {
        if (_.isEmpty(this.importUsersDialogData.selectedFile)) {
          console.error("Error: No import file available in uploadImportData()");
          this.globals.showErrorSnackbar("Please select an import file");
          return;
        }

        var _importString = '{"file":"' + this.importUsersDialogData.selectedFile.file + '"';
        _importString += ',"trim":' + this.importUsersDialogData.trimImportData + "}";

        var _url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          _url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) _url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) _url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: _url,
          data: _importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: function success(data) {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            _this2.getCurrentImportData();
          },
          error: function error(data) {
            console.error("Error on POST in uploadImportData()");
            _this2.globals.showErrorSnackbar("User import failed");
          },
          complete: function complete() {
            _this2.importUsersDialogData.selectedText = "";
            _this2.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
          }
        });
      }
    },
    getCurrentImportData: function getCurrentImportData() {
      var _this3 = this;

      var url = "api/SecurityUsers/Import?page_size=0&filter={\"Errors\":false}";

      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          if (data && data[0]) {
            if (data[0].Error_Counter) _this3.importStep = 2;else _this3.saveImportData();
          }
        },
        error: function error() {
          console.error("Error on GET in getCurrentImportData()");
          _this3.globals.showErrorSnackbar("Import data access failed");
        }
      });
    },
    saveImportData: function saveImportData() {
      var _this4 = this;

      var dataString = '{"save":true}';

      // the save action also needs to know which usertype and id to use
      // because we again check for errors
      var url = "api/SecurityUsers/Import";
      if (this.importUsersDialogData.UserTypeId) {
        url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
        if (this.importUsersDialogData.UserTypeId == 4 && this.importUsersDialogData.ClientId) url += "&clientId=" + this.importUsersDialogData.ClientId;
        if (this.importUsersDialogData.UserTypeId == 2 && this.importUsersDialogData.AgencyId) url += "&agencyId=" + this.importUsersDialogData.AgencyId;
      }

      $.ajax({
        method: "POST",
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.globals.showSuccessSnackbar("User import successful");

          if (data && data[0] && data[0].DownloadId) {
            _this4.importUsersDialogData.serverResponse = data;
            _this4.importStep = 3;
          } else {
            _this4.closeImportUsersDialog();
          }
          //TODO: Download password list
        },
        error: function error() {
          console.error("Error on POST in saveImportData()");
          _this4.globals.showErrorSnackbar("User import failed");
        }
      });
    },
    onImportFileChange: function onImportFileChange(e) {
      var _this5 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.importUsersDialogData.selectedFile = {};
        return;
      }
      var fileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (!data || !data[0]) return;

        if (_this5.importUsersDialogData.selectedFile) {
          _this5.importUsersDialogData.selectedFile.file = data[0].DownloadId;
          _this5.importUsersDialogData.selectedFile.name = fileObject.name;
        } else _this5.importUsersDialogData.selectedFile = data;

        _this5.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, false, uploadSuccess);
      e.target.value = null;
    }
  },
  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue === true) this.openImportUsersDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["showDialog", "roleData", "clientList", "agencyList"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedRoleID: -1,
      importUsersDialogData: {
        selectedOption: "text",
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false
      },
      importStep: 1,
      lang: {}
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_liquor_tree__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KpiQuestionAssignmentModal",
  components: { liquortree: __WEBPACK_IMPORTED_MODULE_1_liquor_tree__["a" /* default */], Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#kpiAssignmentDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  props: ["showDialog", "clientList", "selectedClientFromParent", "selectedKpiData", "kpiEvaluationRulesList", "kpiGroupEvaluationRulesList", "projectList"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openKpiAssignmentDialog() : this.closeKpiAssignmentDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedClientGuid: "",
      kpiGroupsOfSelectedClient: [],
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiGuid: "",
      selectedKpi: {},
      surveysFromSelectedKpiGroup: [],
      selectedSurveyGuid: "",
      treeData: [],
      showTree: false,
      treeViewChanged: false,
      treeOptions: {
        parentSelect: true,
        deletion: function deletion(node) {
          return node.checked();
        }
      },
      lang: {
        KM1000: "KPI – Question Assignment",
        KM1001: "Client",
        KM1002: "KPI Group",
        KM1003: "Evaluation rule",
        KM1004: "Client",
        KM1005: "KPI Group",
        KM1006: "Please select a KPI Group...",
        KM1007: "KPI",
        KM1008: "Please select a KPI...",
        KM1009: "Close",
        KM1010: "Survey",
        KM1011: "Please select a survey...",
        KM1012: "Save",
        KM1013: "Project"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (!this.selectedClientGuid) return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClientGuid;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (!this.selectedKpiGroupGuid) return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfselectedEvaluationRuleGuid: function nameOfselectedEvaluationRuleGuid() {
      var _this4 = this;

      if (!this.selectedKpiGroupGuid) return " - ";
      var evaluationRule = void 0;
      var kpi = this.kpisOfSelectedKpiGroup.find(function (el) {
        return el.KPIGuid === _this4.selectedKpiGuid;
      });
      if (kpi && kpi.KPIEvaluationRuleGuid) {
        evaluationRule = this.kpiEvaluationRulesList.find(function (el) {
          return el.EvaluationRuleGuid === kpi.KPIEvaluationRuleGuid;
        });
        return evaluationRule.EvaluationRule;
      }

      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this4.selectedKpiGroupGuid;
      });
      if (kpiGroup) evaluationRule = this.kpiGroupEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid;
      });
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject: function nameOfSelectedProject() {
      if (!this.selectedKpiGroupGuid || !this.selectedClientGuid) return " - ";
      var kpiGroup = _.find(this.kpiGroupsOfSelectedClient, ["KPIGroupGuid", this.selectedKpiGroupGuid]);
      var projectGuid = void 0,
          projectName = void 0;
      if (kpiGroup && kpiGroup.Projects && kpiGroup.Projects[0] && kpiGroup.Projects[0].ProjectGuid) projectGuid = kpiGroup.Projects[0].ProjectGuid;

      if (projectGuid) {
        var clientProjects = _.find(this.projectList, ["ClientGuid", this.selectedClientGuid]);
        if (clientProjects && clientProjects.Projects && clientProjects.Projects.length > 0) {
          var projectData = _.find(clientProjects.Projects, ["ProjectGuid", projectGuid]);
          if (projectData && projectData.ProjectName) projectName = projectData.ProjectName;
        }
      }
      if (projectName) return projectName;
      return " - ";
    },
    selectedSurvey: function selectedSurvey() {
      var _this5 = this;

      return this.surveysFromSelectedKpiGroup.find(function (survey) {
        return survey.SurveyGuid === _this5.selectedSurveyGuid;
      });
    }
  },
  methods: {
    selectedSurveyGuidChanged: function selectedSurveyGuidChanged() {
      this.getSelectedSurvey();
    },
    selectedKpiGuidChanged: function selectedKpiGuidChanged() {
      this.getKpiSurveyAssignment();
    },
    selectedKpiGroupGuidChanged: function selectedKpiGroupGuidChanged() {
      this.getKpiInformation(true);
    },
    selectedClientGuidChanged: function selectedClientGuidChanged() {
      this.getKpiGroupsOfSelectedClient(true);
    },
    openKpiAssignmentDialog: function openKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("show");
      this.initKpiAssignmentDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeKpiAssignmentDialog: function closeKpiAssignmentDialog() {
      $("#kpiAssignmentDialog").modal("hide");
    },
    initKpiAssignmentDialog: function initKpiAssignmentDialog() {
      this.selectedClientGuid = "";
      if (this.selectedClientFromParent) this.selectedClientGuid = this.selectedClientFromParent;

      this.selectedKpiGroupGuid = "";
      this.selectedKpiGuid = "";
      this.selectedSurveyGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.surveysFromSelectedKpiGroup = [];
      this.treeData = [];
      this.showTree = false;
      this.treeViewChanged = false;
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient(changed) {
      var _this6 = this;

      this.selectedKpiGroupGuid = "";
      if (changed) {
        this.selectedKpiGuid = "";
        this.selectedSurveyGuid = "";
      }
      this.surveysFromSelectedKpiGroup = [];
      this.kpisOfSelectedKpiGroup = [];
      this.treeData = [];
      this.reloadTreeView();

      var queryString = "api/KPIGroups/Client/" + this.selectedClientGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this6.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          _this6.sortKpiGroupsByKpiCode();
          if (!changed && !_.isEmpty(_this6.selectedKpiData)) {
            _this6.$nextTick(function () {
              _this6.selectedKpiGroupGuid = _this6.selectedKpiData.KPIGroups[0].KPIGroupGuid;
              _this6.getKpiInformation();
            });
          }
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this6.globals.showErrorSnackbar("KPI Group request failed");
        }
      });
    },
    sortKpiGroupsByKpiCode: function sortKpiGroupsByKpiCode() {
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase()) return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiInformation: function getKpiInformation(changed) {
      this.treeData = [];
      this.reloadTreeView();
      if (this.selectedKpiGroupGuid) {
        this.getKpisOfSelectedKpiGroup(changed);
        this.getSurveysFromSelectedKpiGroup();
      }
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup(changed) {
      var _this7 = this;

      if (!this.selectedKpiGroupGuid) return;
      this.selectedKpiGuid = "";
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          _this7.sortKpisByKpiCode();

          if (!changed && !_.isEmpty(_this7.selectedKpiData)) _this7.$nextTick(function () {
            _this7.selectedKpiGuid = _this7.selectedKpiData.KPIGuid;
            _this7.getKpiSurveyAssignment();
          });
        },
        error: function error() {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          _this7.globals.showErrorSnackbar("KPI data request failed");
        }
      });
    },
    sortKpisByKpiCode: function sortKpisByKpiCode() {
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        if (a.KPICode.toLowerCase() < b.KPICode.toLowerCase()) return -1;
        if (a.KPICode.toLowerCase() > b.KPICode.toLowerCase()) return 1;
        return 0;
      });
    },
    getSurveysFromSelectedKpiGroup: function getSurveysFromSelectedKpiGroup() {
      var _this8 = this;

      if (!this.selectedKpiGroupGuid) return;
      var getString = "api/KPIGroups/" + this.selectedKpiGroupGuid + "/Data/SurveyQuestions";

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          _this8.surveysFromSelectedKpiGroup = !_.isEmpty(data) ? data : [];
          _this8.sortSurveysBySurveyTitle();
        },
        error: function error() {
          console.error("Survey data request failed in getSurveysFromSelectedKpiGroup()");
          _this8.globals.showErrorSnackbar("Survey data request failed");
        }
      });
    },
    sortSurveysBySurveyTitle: function sortSurveysBySurveyTitle() {
      this.surveysFromSelectedKpiGroup.sort(function (a, b) {
        if (a.SurveyTitle.toLowerCase() < b.SurveyTitle.toLowerCase()) return -1;
        if (a.SurveyTitle.toLowerCase() > b.SurveyTitle.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiSurveyAssignment: function getKpiSurveyAssignment() {
      var _this9 = this;

      if (!this.selectedKpiGuid) {
        this.selectedKpi.SurveyQuestions = [];
        return;
      }
      var getString = "api/KPIs/" + this.selectedKpiGuid;

      $.ajax({
        method: "GET",
        url: getString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this9.selectedKpi = data[0];
            if (!_this9.selectedKpi.SurveyQuestions) _this9.selectedKpi.SurveyQuestions = [];
          } else _this9.selectedKpi = {};
          _this9.getSelectedSurvey();
        },
        error: function error() {
          console.error("Assignment data request failed in getKpiSurveyAssignment()");
          _this9.globals.showErrorSnackbar("Assignment data request failed");
        }
      });
    },
    getSelectedSurvey: function getSelectedSurvey() {
      this.treeData = [];
      this.reloadTreeView();
      this.treeViewChanged = false;
      if (this.selectedSurveyGuid && this.selectedKpiGuid) {
        this.generateTreeDataFromSurvey(this.selectedSurvey);
      }
    },

    // generate the json string for liquor tree from received survey of a selected kpi group
    generateTreeDataFromSurvey: function generateTreeDataFromSurvey(selectedSurvey) {
      if (!selectedSurvey || !selectedSurvey.Panel) return;
      var surveyCluster = selectedSurvey.Panel;
      this.treeData = surveyCluster.map(function (surveyElement) {
        var node = {};
        node.data = surveyElement;
        node.text = surveyElement.Title;
        if (surveyElement.Questions) node.children = surveyElement.Questions.map(function (question) {
          var child = {};
          child.data = question;
          child.text = question.Title;
          return child;
        });
        return node;
      });
      if (this.selectedKpi.SurveyQuestions) this.setCheckedSurveyQuestions(this.selectedKpi.SurveyQuestions);
      this.reloadTreeView();
    },
    setCheckedSurveyQuestions: function setCheckedSurveyQuestions(surveyQuestions) {
      var _this10 = this;

      var checkedQuestions = surveyQuestions.filter(function (survey) {
        return survey.SurveyGuid === _this10.selectedSurveyGuid;
      });
      if (checkedQuestions.length === 0) return;
      var questions = checkedQuestions[0].Questions;
      if (!questions) return;
      this.treeData.forEach(function (treeElement) {
        if (treeElement.children) {
          questions.forEach(function (question) {
            var node = treeElement.children.find(function (child) {
              return child.data.QuestionGuid === question.QuestionGuid;
            });
            if (node) node.state = {
              checked: true
            };
          });
        }
      });
    },
    reloadTreeView: function reloadTreeView() {
      var _this11 = this;

      this.showTree = false;
      this.$nextTick(function () {
        _this11.showTree = true;
      });
    },
    toggleQuestionCheckbox: function toggleQuestionCheckbox(node) {
      this.treeViewChanged = true;
      node.checked() ? node.uncheck() : node.check();
    },
    getCheckedSurveyQuestions: function getCheckedSurveyQuestions() {
      var _this12 = this;

      var tree = this.$refs.kpiQuestionAssignmentTree;
      if (!tree) return;
      var idx = this.selectedKpi.SurveyQuestions.findIndex(function (element) {
        return element.SurveyGuid === _this12.selectedSurveyGuid;
      });
      var selection = tree.findAll({ state: { checked: true } });
      var questions = [];
      if (selection) {
        selection.forEach(function (element) {
          if (!element.data.IsCluster) {
            questions.push({
              QuestionGuid: element.data.QuestionGuid,
              QuestionTitle: element.text
            });
          }
        });
        if (idx === -1) {
          var newSurveyQuestion = {
            SurveyGuid: this.selectedSurveyGuid,
            SurveyTitle: this.selectedSurvey.SurveyTitle,
            Questions: questions
          };
          this.selectedKpi.SurveyQuestions.push(newSurveyQuestion);
        } else this.selectedKpi.SurveyQuestions[idx].Questions = questions;
      } else this.selectedKpi.SurveyQuestions.splice(idx, 1);
    },
    saveKpiQuestionAssignmentData: function saveKpiQuestionAssignmentData() {
      var _this13 = this;

      var queryString = "api/KPIs/" + this.selectedKpiGuid;
      this.getCheckedSurveyQuestions();

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpi),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data[0] && data[0].error) {
            console.error(data[0].error);
            _this13.globals.showErrorSnackbar(data[0].error);
            return;
          }
          _this13.globals.showSuccessSnackbar("Assignment data update successful");
          _this13.treeViewChanged = false;
        },
        error: function error() {
          console.error("Assignment data update failed in saveKpiQuestionAssignmentData()");
          _this13.globals.showErrorSnackbar("Assignment data update failed");
        }
      });
    },
    convertQuestionTypeToLetter: function convertQuestionTypeToLetter(type) {
      if (!type) return "";
      switch (type) {
        case "checkbox":
          return "M";
        case "radiogroup":
          return "S";
        case "dropdown":
          return "D";
        case "rating":
          return "R";
        default:
          return "";
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPICopyModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    projects: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedProject: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      selectedSourceProject: "",
      selectedTargetProject: "",
      lang: {
        KCM000: "Copy KPI Data",
        KCM001: "Source project",
        KCM002: "Please select a source project...",
        KCM003: "Target project",
        KCM004: "Please select a target project...",
        KCM005: "Close",
        KCM006: "Copy",
        KCM007: "Copying to the same project is not possible",
        KCM008: "KPI data copied",
        KCM009: "KPI data copy failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#kpiCopyModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.selectedSourceProject = "";
      this.selectedTargetProject = "";
      if (this.selectedProject) this.selectedSourceProject = this.selectedProject;
      $("#kpiCopyModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#kpiCopyModal").modal("hide");
    },
    copyKpis: function copyKpis() {
      var _this2 = this;

      if (this.selectedSourceProject === this.selectedTargetProject) {
        console.error("kpi copy not possible due to identical source and target project");
        this.globals.showErrorSnackbar(this.lang.KCM007);
        return;
      }

      var query = "api/KPIs/CopyKPIs/FromProject/" + this.selectedSourceProject + "/ToProject/" + this.selectedTargetProject;
      $.ajax({
        method: "POST",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this2.globals.showSuccessSnackbar(_this2.lang.KCM008);
          _this2.$emit("copyDone");
          _this2.closeModal();
        },
        error: function error(_error) {
          console.error("Error on POST in copyKpis()");
          _this2.globals.showErrorSnackbar(_this2.lang.KCM009);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIGroupEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKPIGroupDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("KPIGroupDeleteModalYesConfirmation");
    this.globals.$on("KPIGroupDeleteModalYesConfirmation", function () {
      _this.deleteSelectedKpiGroup();
    });
  },

  props: ["showDialog", "clientList", "projectList", "kpiGroupEvaluationRulesList", "selectedClientForKpiGroups"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditKPIGroupDialog() : this.closeEditKPIGroupDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedKpiGroupInformation: {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: []
      },
      selectedTab: "editKpiGroupTab",
      selectedKpiGroupGuid: "",
      filterKpiGroupString: "",
      filteredKpiGroups: [],
      selectedKpiGroupDirty: false,
      changeKpiOrderDirty: false,
      changeKpiGroupOrderDirty: false,
      kpiGroupsOfSelectedClient: [],
      kpisOfSelectedKpiGroup: [],
      selectedClientGuid: "",
      selectedProjectGuid: "",
      clientProjectList: [],
      showAlert: false,
      invalidInputIds: [],
      selectedEvaluationRule: "",
      lang: {
        KM4000: "KPI Group Code",
        KM4001: "KPI Group Shorttext",
        KM4002: "Close",
        KM4003: "Save",
        KM4004: "KPI Group Longtext",
        KM4005: "Description",
        KM4006: "KPI Group Management",
        KM4007: "Client",
        KM4008: "Project",
        KM4009: "Please select a project...",
        KM4010: "Evaluation rule",
        KM4011: "Please select an evaluation rule...",
        KM4012: "ID",
        KM4013: "Filter",
        KM4014: "Edit KPI Group",
        KM4015: "New",
        KM4016: "Delete",
        KM4017: "KPI Order",
        KM4018: "KPI Shorttext",
        KM4019: "Position",
        KM4020: "Delete KPI Group",
        KM4021: "Do you really want to delete the following KPI group?",
        KM4022: "Yes",
        KM4023: "No",
        KM4024: "ID",
        KM4025: "KPI Group Code",
        KM4026: "KPI Group Shorttext",
        KM4027: "KPI Group",
        KM4028: "Your inputs are incorrect. Please check the fields marked in red!",
        KM4029: "This is a required entry!",
        KM4030: "Save positions",
        KM4031: "Weight",
        KM4032: "KPI Group Code – max. 200 characters",
        KM4033: "KPI Group Shorttext – max. 50 characters, will be visible in Cockpit",
        KM4034: "KPI Group Longtext – max. 200 characters",
        KM4035: "Weight of the KPI Group related to other KPI Groups",
        KM4036: "Position",
        KM4037: "KPI Group Order",
        KM4038: "KPI Group Shorttext",
        KM4039: "Position"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClientGuid === "") return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClientGuid;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid: function nameOfSelectedEvaluationRuleGuid() {
      var selectedEvaluationRuleGuid = this.selectedKpiGroupInformation.KPIEvaluationRuleGuid;
      if (!selectedEvaluationRuleGuid) return " - ";
      var evaluationRule = this.kpiGroupEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === selectedEvaluationRuleGuid;
      });
      this.selectedEvaluationRule = evaluationRule.EvaluationRule || " - ";
      return this.selectedEvaluationRule;
    }
  },
  methods: {
    selectedClientGuidChanged: function selectedClientGuidChanged() {
      this.createNewKpiGroup();
      this.getKpiGroupsOfSelectedClient();
    },
    initEditKPIGroupDialog: function initEditKPIGroupDialog() {
      this.createNewKpiGroup();
      this.selectedClientGuid = this.selectedClientForKpiGroups;
      this.changeKpiGroupOrderDirty = false;
    },

    // reset form states and empty input fields
    createNewKpiGroup: function createNewKpiGroup() {
      this.selectedKpiGroupInformation = {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: []
      };
      this.selectedKpiGroupGuid = "";
      this.selectedEvaluationRule = "";
      this.selectedProjectGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupDirty = false;
      this.showAlert = false;
      this.changeKpiOrderDirty = false;
      this.changeKpiGroupOrderDirty = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    openEditKPIGroupDialog: function openEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("show");
      this.initEditKPIGroupDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeEditKPIGroupDialog: function closeEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("hide");
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient() {
      var _this4 = this;

      var queryString = "api/KPIGroups/Client/" + this.selectedClientGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) {
            _this4.kpiGroupsOfSelectedClient = data;
            _this4.kpiGroupsOfSelectedClient.forEach(function (kpiGroup) {
              if (!kpiGroup.Projects) kpiGroup.Projects = [];
            });
          } else _this4.kpiGroupsOfSelectedClient = [];
          _this4.sortKpiGroupsByPosition();
          _this4.doFilterKpiGroups();
          _this4.filterClientProjectList();
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this4.globals.showErrorSnackbar("KPI Group data request failed");
        }
      });
    },
    doFilterKpiGroups: function doFilterKpiGroups() {
      var _this5 = this;

      // Reset filtering when search string is empty
      if (!this.kpiGroupsOfSelectedClient || this.kpiGroupsOfSelectedClient.length < 1) {
        this.filteredKpiGroups = this.kpiGroupsOfSelectedClient;
        return;
      }

      var words = this.filterKpiGroupString.split(" ");
      var keys = ["KPIGroupId", "KPIGroupCode", "KPIGroupShortText"];

      var kpiGroupFilter = function kpiGroupFilter(kpiGroup) {
        var isKpiGroupInList = _this5.kpiGroupsOfSelectedClient.find(function (element) {
          return element.KPIGroupGuid === kpiGroup.KPIGroupGuid;
        });
        if (!isKpiGroupInList) return false;

        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (kpiGroup[key] && kpiGroup[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredKpiGroups = this.kpiGroupsOfSelectedClient.filter(kpiGroupFilter);
    },
    filterClientProjectList: function filterClientProjectList() {
      var _this6 = this;

      this.clientProjectList = [];
      if (this.selectedClientGuid) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this6.selectedClientGuid;
        });
        if (listOfClientProjects && listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup() {
      var _this7 = this;

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.selectedKpiGroupInformation = data[0] || {};
          _this7.selectedProjectGuid = _this7.selectedKpiGroupInformation.Projects && _this7.selectedKpiGroupInformation.Projects.length > 0 ? _this7.selectedKpiGroupInformation.Projects[0].ProjectGuid : "";

          _this7.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          _this7.sortKpisByGroupPosition();
        },
        error: function error() {
          console.error("KPI data request failed in getKpisOfSelectedKpiGroup()");
          _this7.globals.showErrorSnackbar("KPI data request failed");
        }
      });
    },
    getSelectedKpiGroupInformation: function getSelectedKpiGroupInformation() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Read");
        this.selectedKpiGroupGuid = "";
        return;
      }

      if (!this.selectedKpiGroupGuid) return;
      this.getKpisOfSelectedKpiGroup();
      this.selectedKpiGroupDirty = false;
      this.changeKpiOrderDirty = false;
      this.showAlert = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    getKpiGroupData: function getKpiGroupData() {
      if (this.selectedTab === "editKpiGroupTab" || this.selectedTab === "kpiOrderTab") this.getSelectedKpiGroupInformation();
      if (this.selectedTab === "kpiGroupOrderTab") {
        this.changeKpiGroupOrderDirty = false;
        this.getKpiGroupsOfSelectedClient();
      }
    },
    getClientProject: function getClientProject(projectGuid) {
      var result = this.clientProjectList.find(function (element) {
        return element.ProjectGuid === projectGuid;
      });
      return { ProjectGuid: result.ProjectGuid };
    },
    saveEditKPIGroupDialogData: function saveEditKPIGroupDialogData() {
      var _this8 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Create") && !this.selectedKpiGroupGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Create");
        return;
      } else if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Update") && this.selectedKpiGroupGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      var queryString = !this.selectedKpiGroupGuid ? "api/KPIGroups/Client/" + this.selectedClientGuid // new kpi group
      : "api/KPIGroups/" + this.selectedKpiGroupGuid; // update exisiting kpi group

      this.selectedKpiGroupInformation.Projects = [];
      if (this.selectedProjectGuid) {
        var clientProject = this.getClientProject(this.selectedProjectGuid);
        this.selectedKpiGroupInformation.Projects.push(clientProject);
      }

      if (this.selectedKpiGroupInformation.KPIGroupWeight === "") delete this.selectedKpiGroupInformation.KPIGroupWeight;

      if (!this.selectedKpiGroupGuid) {
        // create new kpi group
        $.ajax({
          method: "POST",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this8.globals.showSuccessSnackbar("KPI Group creation successful");
            _this8.selectedKpiGroupGuid = data[0].KPIGroupGuid;
            _this8.selectedKpiGroupInformation = _.cloneDeep(data[0]);
            _this8.selectedKpiGroupDirty = false;
            _this8.getKpiGroupsOfSelectedClient();
          },
          error: function error() {
            console.error("Error on POST in saveEditKPIGroupDialogData()");
            _this8.globals.showErrorSnackbar("KPI Group creation failed");
          }
        });
      } else {
        // update exisiting kpi group
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this8.globals.showSuccessSnackbar("KPI Group update successful");
            _this8.selectedKpiGroupDirty = false;
            _this8.getKpiGroupsOfSelectedClient();
          },
          error: function error() {
            console.error("Error on PUT in saveEditKPIGroupDialogData()");
            _this8.globals.showErrorSnackbar("KPI Group update failed");
          }
        });
      }
    },
    openDeleteKpiGroupConfirmationDialog: function openDeleteKpiGroupConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Delete");
        return;
      }

      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "KPIGroupDeleteModal",
        confirmationTitle: this.lang.KM4020,
        colorRed: true,
        yesButtonText: this.lang.KM4022,
        noButtonText: this.lang.KM4023,
        htmlText: "<p><b>" + this.lang.KM4021 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4024 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4025 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupCode + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM4026 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiGroupInformation.KPIGroupShortText + "</label>\n        </div>"
      };
    },
    deleteSelectedKpiGroup: function deleteSelectedKpiGroup() {
      var _this9 = this;

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          _this9.globals.showSuccessSnackbar("KPI group deletion successful");
          _this9.createNewKpiGroup();
          _this9.getKpiGroupsOfSelectedClient();
          _this9.$forceUpdate();
        },
        error: function error() {
          console.error("KPI group deletion failed in deleteSelectedKpiGroup()");
          _this9.globals.showErrorSnackbar("KPI group deletion failed");
        }
      });
    },

    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup: function reorderKpisInKpiGroup() {
      var _this10 = this;

      var numberOfKpis = this.kpisOfSelectedKpiGroup.length,
          allPositions = _.range(1, numberOfKpis + 1),
          missingPos = 0,
          newPos = 0,
          kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach(function (position, index) {
        if (position !== _this10.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this10.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = _this10.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },

    // Sorts the available kpis by their position number
    sortKpisByGroupPosition: function sortKpisByGroupPosition() {
      if (this.kpisOfSelectedKpiGroup.length < 0) return;
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    saveKpisNewOrder: function saveKpisNewOrder() {
      var _this11 = this;

      // save new kpi order in selected kpi group
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.globals.showSuccessSnackbar("Save KPI Position successful");
          _this11.changeKpiOrderDirty = false;
          _this11.getKpiGroupsOfSelectedClient();
        },
        error: function error() {
          console.error("Error on PUT in saveKpisNewOrder()");
          _this11.globals.showErrorSnackbar("Save KPI Position failed");
        }
      });
    },

    // Reorders kpiGroups from a client after the position of a kpiGroup changed
    reorderKpiGroups: function reorderKpiGroups() {
      var _this12 = this;

      var numberOfKpiGroups = this.kpiGroupsOfSelectedClient.length,
          allPositions = _.range(1, numberOfKpiGroups + 1),
          missingPos = 0,
          newPos = 0,
          kpiGroupGuid = "";

      // Find missing position number and the position and code of the changed kpiGroup
      allPositions.forEach(function (position, index) {
        if (position !== _this12.kpiGroupsOfSelectedClient[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this12.kpiGroupsOfSelectedClient[index].KPIGroupPosition;
          kpiGroupGuid = _this12.kpiGroupsOfSelectedClient[index].KPIGroupGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpiGroupsOfSelectedClient[i].KPIGroupGuid !== kpiGroupGuid) {
          // Do NOT move the changed kpiGroup
          if (this.kpiGroupsOfSelectedClient[i].KPIGroupPosition < missingPos && this.kpiGroupsOfSelectedClient[i].KPIGroupPosition >= newPos) this.kpiGroupsOfSelectedClient[i].KPIGroupPosition++;
          if (this.kpiGroupsOfSelectedClient[i].KPIGroupPosition > missingPos && this.kpiGroupsOfSelectedClient[i].KPIGroupPosition <= newPos) this.kpiGroupsOfSelectedClient[i].KPIGroupPosition--;
        }
      }
      this.sortKpiGroupsByPosition();
    },

    // Sorts the available kpi groups by their position number
    sortKpiGroupsByPosition: function sortKpiGroupsByPosition() {
      if (this.kpiGroupsOfSelectedClient.length < 0) return;
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    generateKpiGroupNewOrderPayload: function generateKpiGroupNewOrderPayload() {
      return this.kpiGroupsOfSelectedClient.map(function (kpiGroup) {
        return {
          KPIGroupGuid: kpiGroup.KPIGroupGuid,
          KPIGroupPosition: kpiGroup.KPIGroupPosition
        };
      });
    },
    saveKpiGroupsNewOrder: function saveKpiGroupsNewOrder() {
      var _this13 = this;

      var queryString = "api/KPIGroups/Positions/Client/" + this.selectedClientGuid;
      var payload = this.generateKpiGroupNewOrderPayload();
      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this13.globals.showSuccessSnackbar("Save KPI Group Postion successful");
          _this13.changeKpiGroupOrderDirty = false;
          _this13.getKpiGroupsOfSelectedClient();
        },
        error: function error() {
          console.error("Error on PUT in saveKpiGroupsNewOrder()");
          _this13.globals.showErrorSnackbar("Save KPI Group Position failed");
        }
      });
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editKPIGroupDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKPIGroupDialogData();
      }
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KPICopyModal__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__KPICopyModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__KPICopyModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Tools_Select2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagement",
  components: {
    "kpi-group-edit-modal": __WEBPACK_IMPORTED_MODULE_5__KPIGroupEditModal_vue___default.a,
    "kpi-management-edit-modal": __WEBPACK_IMPORTED_MODULE_3__KPIManagementEditModal___default.a,
    "kpi-assignment-modal": __WEBPACK_IMPORTED_MODULE_6__KPIAssignmentModal_vue___default.a,
    "kpi-management-translate-modal": __WEBPACK_IMPORTED_MODULE_4__KPIManagementTranslateModal___default.a,
    KPICopyModal: __WEBPACK_IMPORTED_MODULE_7__KPICopyModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_8__Tools_Select2___default.a
  },
  data: function data() {
    return {
      showEditKpiDialog: false,
      showTranslateKpiDialog: false,
      showKpiGroupEditDialog: false,
      showKpiAssignmentDialog: false,
      showKPICopyModal: false,
      clientList: [],
      importerList: [],
      projectList: [],
      clientProjectList: [],
      filteredKpiData: [],
      kpiDataOnCurrentPage: [],
      refreshEnabled: false, // false, if kpi data is requested and server did not respond yet to avoid multiple requests at the same time
      kpiData: [], // List of all kpis
      selectedKpiGuid: "", // GUID of the selected kpi
      selectedKpiData: {},
      searchString: "",
      pageSize: 20, // Number of kpis on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      selectedClient: "",
      selectedImporter: "",
      selectedProject: "",
      clientInformation: {},
      kpiGroupEvaluationRulesList: [],
      kpiEvaluationRulesList: [],
      columnFilterObject: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIGroups: "",
        ClientName: "",
        Importers: "",
        Projects: "",
        SurveyIdString: "",
        KPIEvaluationRuleName: ""
      },
      currentSort: { key: "KPICode", asc: true },
      selectedClientForKpiTranslation: {},
      lang: {
        // Contains localization strings for the selected language
        KM0000: "Refresh",
        KM0001: "KPI Management",
        KM0002: "Search...",
        KM0003: "Items per page",
        KM0004: "First page",
        KM0005: "Last page",
        KM0006: "KPI Code",
        KM0007: "KPI Shorttext",
        KM0008: "KPI Longtext",
        KM0009: "Translation",
        KM0010: "KPI Groups",
        KM0011: "Please select a client...",
        KM0012: "Please select a project...",
        KM0013: "Client",
        KM0014: "Filter",
        KM0015: "Project",
        KM0016: "Calculation rule",
        KM0017: "Assignment",
        KM0018: "Please select an importer...",
        KM0019: "Importer",
        KM0020: "Total KPIs count",
        KM0021: "Copy KPI data"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getKpiGroupEvaluationRulesList();
    this.getKpiEvaluationRulesList();
    var clientListPromise = this.globals.getClientList();
    clientListPromise.then(function (data) {
      _this.clientList = data;
      if (_this.feature.isAudiTarget && _this.feature.isEnabled("audi_importers") && _this.clientList[0]) {
        _this.selectedClient = _this.clientList[0].ClientGuid;
        _this.onClientSelection();
      }
      _this.$emit("ClientListReceived");
    });
    this.globals.getProjectList(function (data) {
      _this.projectList = data;
      if (_this.selectedClient) _this.getClientProjectList();
      _this.$emit("ProjectListReceived");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this.importerList = data;
      });
    }

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    selectedImporterChanged: function selectedImporterChanged() {
      selectedKpiGuid = "";
      selectedKpiData = {};
      getKpiData();
    },
    selectedClientChanged: function selectedClientChanged(value) {
      this.selectedClient = value;
      this.onClientSelection();
    },
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#kpi-top-panel").height() + $("#app-navbar").height() +
        // $(".main-table > thead").height() +
        47;
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this2 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        if (_this2.$refs.clientSelect) _this2.$refs.clientSelect.updateValue();
        if (_this2.$refs.importerSelect) _this2.$refs.importerSelect.updateValue();
        if (_this2.$refs.projectSelect) _this2.$refs.projectSelect.updateValue();

        delete _this2.$filterRestorePending;
        _this2.getKpiData();
      };
      var restoreFilters = function restoreFilters() {
        _this2.$nextTick(function () {
          var storedData = _this2.$store.getters["localFilters/kpiManagement"];
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this2, key)) _this2[key] = _.cloneDeep(storedData[key]);
              if (key === "selectedClient") _this2.onClientSelection();
            }
          }

          if (!_this2.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this2.feature.isAudiTarget || !_this2.feature.isEnabled("audi_importers")) {
            var storedClient = _this2.$store.getters["sharedFilters/client"];
            _this2.selectedClient = storedClient.ClientGuid || "";
            _this2.onClientSelection();
          } else {
            var storedImporter = _this2.$store.getters["sharedFilters/importer"];
            _this2.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this2.$store.getters["sharedFilters/project"];
          _this2.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };
      this.globals.doAfterEvents(["ClientListReceived", "ProjectListReceived"], restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this3 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/kpiManagement", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        columnFilterObject: this.columnFilterObject,
        searchString: this.searchString,
        currentSort: this.currentSort,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.clientList, function (c) {
            return c.ClientGuid === _this3.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.importerList, function (i) {
            return i.ImporterGuid === _this3.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.clientProjectList, function (p) {
          return p.ProjectGuid === _this3.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    onClientSelection: function onClientSelection() {
      this.selectedKpiGuid = "";
      this.selectedKpiData = {};
      this.getKpiData();
      this.getClientProjectList();
      this.getClientInformation();
    },
    getClientInformation: function getClientInformation() {
      var _this4 = this;

      if (this.selectedClient) this.clientInformation = this.clientList.find(function (client) {
        return client.ClientGuid === _this4.selectedClient;
      });
    },

    // Select Customer Project
    getClientProjectList: function getClientProjectList() {
      var _this5 = this;

      this.selectedProject = "";
      this.clientProjectList = [];
      if (this.selectedClient) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this5.selectedClient;
        });
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiData: function getKpiData() {
      var _this6 = this;

      if (this.$filterRestorePending) return;
      if (!this.selectedClient) {
        this.kpiData = [];
        this.doFiltering();
        return;
      }
      this.refreshEnabled = false;
      var queryString = "api/KPIs/Client/" + this.selectedClient;

      if (this.selectedImporter) queryString += "?ImporterGuid=" + this.selectedImporter;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this6.kpiData = !_.isEmpty(data) ? data : [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this6.kpiData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var kpi = _step.value;

              kpi.SurveyIdString = _this6.getSurveyIdListString(kpi.Surveys);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this6.doFiltering();
        },
        error: function error() {
          console.error("KPI data request failed in getKpiData()");
          _this6.globals.showErrorSnackbar("KPI data access failed");
        },
        complete: function complete() {
          _this6.refreshEnabled = true;
        }
      });
    },
    getKpiGroupEvaluationRulesList: function getKpiGroupEvaluationRulesList() {
      var _this7 = this;

      var queryString = "api/KPIGroups/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpiGroupEvaluationRulesList = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            return _this7.kpiGroupEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value
            });
          });
        },
        error: function error() {
          console.error("KPI group evaluation rules access failed in getKpiGroupEvaluationRulesList()");
          _this7.globals.showErrorSnackbar("Evaluation rules access failed");
        }
      });
    },
    getKpiEvaluationRulesList: function getKpiEvaluationRulesList() {
      var _this8 = this;

      var queryString = "api/KPIs/Data/EvaluationRules";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this8.kpiEvaluationRulesList = [];
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref3) {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            return _this8.kpiEvaluationRulesList.push({
              EvaluationRuleGuid: key,
              EvaluationRule: value
            });
          });
        },
        error: function error() {
          console.error("KPI evaluation rules access failed in getKpiEvaluationRulesList()");
          _this8.globals.showErrorSnackbar("Evaluation rules access failed");
        }
      });
    },
    getSurveyIdListString: function getSurveyIdListString(surveys) {
      if (!surveys || !surveys.length) return "";
      var result = "";
      for (var i = 0; i < surveys.length; i++) {
        result += surveys[i].SurveyId;
        if (i < surveys.length - 1) result += ", ";
      }
      return result;
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      var _this9 = this;

      // Nothing to sort by => return
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      var sortFunction = function sortFunction(kpi) {
        if (typeof kpi[_this9.currentSort.key] === "string") {
          return kpi[_this9.currentSort.key].toLowerCase();
        } else if (Array.isArray(kpi[_this9.currentSort.key])) {
          if (kpi[_this9.currentSort.key][0].KPIGroupCode) return kpi[_this9.currentSort.key][0].KPIGroupCode.toLowerCase();
          if (kpi[_this9.currentSort.key][0].ProjectName) return kpi[_this9.currentSort.key][0].ProjectName.toLowerCase();
          if (kpi[_this9.currentSort.key][0].ImporterName) return kpi[_this9.currentSort.key][0].ImporterName.toLowerCase();
        }
        return kpi[_this9.currentSort.key];
      };
      this.filteredKpiData = _.orderBy(this.filteredKpiData, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
      this.loadCurrentPageOfKpiData();
    },
    doFiltering: function doFiltering() {
      var _this10 = this;

      // Reset filtering when search string is empty
      if (!this.searchString) this.filteredKpiData = this.kpiData;

      var words = this.searchString.split(" ");
      var keys = ["KPICode", "KPIShortText", "KPILongText", "KPIGroups", "ClientName", "Importers", "Projects", "SurveyIdString", "KPIEvaluationRuleName"];

      var filterStrings = this.columnFilterObject;

      var kpiFilter = function kpiFilter(kpi) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (key === "KPIGroups") {
              if (kpi[key][0] && kpi[key][0].KPIGroupCode && kpi[key][0].KPIGroupCode.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (key === "Projects") {
              if (kpi[key][0] && kpi[key][0].ProjectName && kpi[key][0].ProjectName.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (key === "Importers") {
              if (kpi[key] && kpi[key][0].ImporterName.toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
                containsSearch = true;
                return;
              }
            } else if (kpi[key] && kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        if (!containsSearch) return false; // KPI does not match search string

        keys.forEach(function (key) {
          if (!containsSearch) return;

          if (key === "KPIGroups") {
            if (kpi[key][0] && kpi[key][0].KPIGroupCode && kpi[key][0].KPIGroupCode.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (key === "Projects") {
            if (kpi[key][0] && kpi[key][0].ProjectName && kpi[key][0].ProjectName.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (key === "Importers") {
            if (!kpi[key] && filterStrings[key] || kpi[key] && kpi[key][0].ImporterName.toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
              containsSearch = false;
              return;
            }
          } else if (!kpi[key] && filterStrings[key] || kpi[key] && kpi[key].toString().toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
            containsSearch = false; // KPI does not match filterstring
            return;
          }
        });
        return containsSearch;
      };

      this.filteredKpiData = !_.isEmpty(this.kpiData) ? this.kpiData.filter(kpiFilter) : [];

      // Filter kpi data for selected project
      if (this.selectedProject) {
        this.filteredKpiData = this.filteredKpiData.filter(function (kpi) {
          return kpi.Projects[0].ProjectGuid === _this10.selectedProject;
        });
      }

      this.currentSort.asc = !this.currentSort.asc;
      this.orderTableByColumn(this.currentSort.key);
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.numberOfPages() <= 7) {
        return _.range(1, this.numberOfPages() + 1);
      } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
        return _.range(1, 7);
      } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
        return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3);
      }
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.loadCurrentPageOfKpiData();
    },

    // Returns the count of pages depending on the selected pagesize and the length of the client data list
    numberOfPages: function numberOfPages() {
      if (this.pageSize == -1) return 1;
      if (this.filteredKpiData.length % this.pageSize == 0) return this.filteredKpiData.length / this.pageSize;else return parseInt(this.filteredKpiData.length / this.pageSize) + 1;
    },
    loadCurrentPageOfKpiData: function loadCurrentPageOfKpiData() {
      if (this.pageSize == -1) this.kpiDataOnCurrentPage = this.filteredKpiData;else {
        // Display all data, no pages
        this.kpiDataOnCurrentPage = [];
        var startIndex = (this.selectedPage - 1) * this.pageSize;
        for (var i = startIndex; i < startIndex + this.pageSize; i++) {
          if (this.filteredKpiData[i] != null) this.kpiDataOnCurrentPage[i - startIndex] = this.filteredKpiData[i];
        }
      }
    },
    openEditKpiDialog: function openEditKpiDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showEditKpiDialog = true;
    },
    onEditKpiDialogClosed: function onEditKpiDialogClosed() {
      this.showEditKpiDialog = false;
      this.getKpiData();
    },
    getSelectedClient: function getSelectedClient(clientGuid) {
      var client = this.clientList.find(function (client) {
        return client.ClientGuid === clientGuid;
      });
      return { clientGuid: client.ClientGuid, clientName: client.ClientName };
    },

    // Opens the dialog to translate kpis
    openKpiLanguageDialog: function openKpiLanguageDialog() {
      this.selectedClientForKpiTranslation = this.getSelectedClient(this.selectedClient);
      this.showTranslateKpiDialog = true;
    },

    // Gets executed after the translateKpiDialog got closed
    onTranslateKpiDialogClosed: function onTranslateKpiDialogClosed() {
      this.showTranslateKpiDialog = false;
    },
    openEditKpiDataDialog: function openEditKpiDataDialog() {
      this.showEditKpiDialog = true;
    },
    openKpiGroupEditModal: function openKpiGroupEditModal() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiGroupEditDialog = true;
    },
    onKpiGroupEditDialogClosed: function onKpiGroupEditDialogClosed() {
      this.showKpiGroupEditDialog = false;
      this.getKpiData();
    },
    openKpiAssignmentDialog: function openKpiAssignmentDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIsAssignment_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIsAssignment_Read");
        return;
      }
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_ReadAll")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_ReadAll");
        return;
      }
      this.showKpiAssignmentDialog = true;
    },
    onKpiAssignmentDialogDialogClosed: function onKpiAssignmentDialogDialogClosed() {
      this.showKpiAssignmentDialog = false;
      this.getKpiData();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKpiDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    this.globals.$off("KPIDeleteModalYesConfirmation");
    this.globals.$on("KPIDeleteModalYesConfirmation", function () {
      _this.deleteSelectedKpi();
    });
  },

  props: ["showDialog", "clientList", "selectedClientForKpi", "selectedProjectGuidFromParent", "projectList", "kpiEvaluationRulesList"],
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditKpiDialog() : this.closeEditKpiDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      kpiGroupsOfSelectedClient: [],
      selectedTab: "editKpiTab",
      selectedKpiGroupGuid: "",
      kpisOfSelectedKpiGroup: [],
      selectedKpiDirty: false,
      selectedKpiGuid: "",
      invalidInputIds: [],
      showAlert: false,
      changeKpiOrderDirty: false,
      selectedKpiGroupInformation: {},
      clientProjectList: [],
      selectedProjectGuid: "",
      projectKpiGroupList: [],
      selectedKpiInformation: {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: []
      },
      lang: {
        KM2000: "KPI Management",
        KM2001: "Select a KPI Group…",
        KM2002: "Position",
        KM2003: "KPI Code",
        KM2004: "KPI Shorttext",
        KM2005: "Edit KPI",
        KM2006: "KPI Order",
        KM2007: "KPI Code",
        KM2008: "KPI Shorttext",
        KM2009: "KPI Longtext",
        KM2010: "Description",
        KM2011: "This is a required entry!",
        KM2012: "Your inputs are incorrect. Please check the fields marked in red!",
        KM2013: "New",
        KM2014: "Save",
        KM2015: "Delete",
        KM2016: "KPI Shorttext",
        KM2017: "Position",
        KM2018: "Close",
        KM2019: "Delete KPI",
        KM2020: "Yes",
        KM2021: "No",
        KM2022: "Do you really want to delete the following KPI?",
        KM2023: "ID",
        KM2024: "KPI Code",
        KM2025: "KPI Shorttext",
        KM2026: "Client",
        KM2027: "KPI Group",
        KM2028: "Evaluation rule",
        KM2029: "Project",
        KM2030: "Please select a project...",
        KM2031: "Inherited",
        KM2032: "Weight",
        KM2033: "Save positions",
        KM2034: "KPI Shorttext – max. 50 characters, will be visible in Cockpit",
        KM2035: "KPI Longtext – max. 200 characters",
        KM2036: "Weight of the KPI within the KPI Group",
        KM2037: "KPI Code – max. 200 characters"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClient === "") return " - ";
      var client = this.clientList.find(function (c) {
        return c.ClientGuid === _this2.selectedClient;
      });
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup: function nameOfSelectedKpiGroup() {
      var _this3 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this3.selectedKpiGroupGuid;
      });
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid: function nameOfSelectedEvaluationRuleGuid() {
      var _this4 = this;

      if (this.selectedKpiGroupGuid === "") return " - ";
      var kpiGroup = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === _this4.selectedKpiGroupGuid;
      });
      var evaluationRule = this.kpiEvaluationRulesList.find(function (element) {
        return element.EvaluationRuleGuid === kpiGroup.KPIEvaluationRuleGuid;
      });
      return evaluationRule ? evaluationRule.EvaluationRule : " - ";
    },
    nameOfSelectedProject: function nameOfSelectedProject() {
      var _this5 = this;

      if (this.selectedProjectGuid === "") return " - ";
      var projectName = this.clientProjectList.filter(function (project) {
        return project.ProjectGuid === _this5.selectedProjectGuid;
      });
      return projectName ? projectName[0].ProjectName : " - ";
    }
  },
  methods: {
    selectedKpiGroupGuidCHanged: function selectedKpiGroupGuidCHanged() {
      this.createNewKpi();
      this.getKpisOfSelectedKpiGroup();
    },
    selectedClientChanged: function selectedClientChanged() {
      this.getClientProjectList();
      this.getKpiGroupsOfSelectedClient();
    },
    initEditKpiDialog: function initEditKpiDialog() {
      this.createNewKpi();
      this.selectedClient = this.selectedClientForKpi;
      this.getKpiGroupsOfSelectedClient();
      this.selectedKpiGuid = "";
      this.selectedKpiGroupGuid = "";
      this.changeKpiOrderDirty = false;
      this.kpiGroupsOfSelectedClient = [];
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupInformation = {};
    },
    createNewKpi: function createNewKpi() {
      this.selectedKpiInformation = {
        KPICode: "",
        KPIShortText: "",
        KPILongText: "",
        KPIDescription: "",
        KPIGroups: []
      };
      this.selectedKpiGuid = "";
      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");
    },
    openEditKpiDialog: function openEditKpiDialog() {
      $("#editKpiDialog").modal("show");
      this.initEditKpiDialog();
      this.getClientProjectList();
    },
    closeEditKpiDialog: function closeEditKpiDialog() {
      $("#editKpiDialog").modal("hide");
    },
    getClientProjectList: function getClientProjectList() {
      var _this6 = this;

      this.selectedProjectGuid = "";
      this.selectedKpiGroupGuid = "";
      this.clientProjectList = [];
      this.kpisOfSelectedKpiGroup = [];

      if (this.selectedProjectGuidFromParent) {
        this.selectedProjectGuid = this.selectedProjectGuidFromParent;
      }

      if (this.selectedClient) {
        var listOfClientProjects = this.projectList.filter(function (project) {
          return project.ClientGuid === _this6.selectedClient;
        });
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList: function sortClientProjectList() {
      this.clientProjectList.sort(function (a, b) {
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase()) return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpiGroupsOfSelectedClient: function getKpiGroupsOfSelectedClient() {
      var _this7 = this;

      if (!this.selectedClient) return;
      this.selectedKpiGroupGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.createNewKpi();

      var queryString = "api/KPIGroups/Client/" + this.selectedClient;
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.kpiGroupsOfSelectedClient = !_.isEmpty(data) ? data : [];
          _this7.sortKpiGroups();
          _this7.filterKpiGroupsByProject();
        },
        error: function error() {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          _this7.globals.showErrorSnackbar("KPI Group request failed");
        }
      });
    },
    filterKpiGroupsByProject: function filterKpiGroupsByProject() {
      var _this8 = this;

      this.selectedKpiGroupGuid = "";
      this.projectKpiGroupList = [];

      if (this.selectedProjectGuid) {
        var listOfProjectKpiGroup = this.kpiGroupsOfSelectedClient.filter(function (kpiGroup) {
          if (!kpiGroup.Projects) return false;
          return kpiGroup.Projects[0].ProjectGuid === _this8.selectedProjectGuid;
        });
        if (listOfProjectKpiGroup.length > 0) this.projectKpiGroupList = listOfProjectKpiGroup;
      }
    },
    sortKpiGroups: function sortKpiGroups() {
      this.kpiGroupsOfSelectedClient.sort(function (a, b) {
        if (a.KPIGroupCode.toLowerCase() < b.KPIGroupCode.toLowerCase()) return -1;
        if (a.KPIGroupCode.toLowerCase() > b.KPIGroupCode.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup: function getKpisOfSelectedKpiGroup() {
      var _this9 = this;

      if (!this.selectedKpiGroupGuid) {
        this.kpisOfSelectedKpiGroup = [];
        return;
      }
      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || !data[0] || _.isEmpty(data[0]) || !data[0].KPIs) {
            _this9.selectedKpiGroupInformation = {};
            _this9.kpisOfSelectedKpiGroup = [];
            return;
          }
          _this9.selectedKpiGroupInformation = data[0];
          _this9.kpisOfSelectedKpiGroup = data[0].KPIs;
          _this9.sortKpisByGroupPosition();
        },
        error: function error() {
          console.error("Error on GET in getKpisOfSelectedKpiGroup()");
          _this9.globals.showErrorSnackbar("KPIs request failed");
        }
      });
    },
    getKpiData: function getKpiData() {
      var _this10 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Read");
        this.selectedKpiGuid = "";
        return;
      }
      this.refreshEnabled = false;
      var queryString = "api/KPIs/" + this.selectedKpiGuid;

      this.showAlert = false;
      this.selectedKpiDirty = false;
      this.resetValidationErrors("editKpiDialog");

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || !data[0] || _.isEmpty(data[0])) {
            _this10.selectedKpiInformation = {};
            return;
          }
          _this10.selectedKpiInformation = data[0];
        },
        error: function error() {
          console.error("KPI data request failed in getKpiData()");
          _this10.globals.showErrorSnackbar("KPI data request failed");
        },
        complete: function complete() {
          _this10.refreshEnabled = true;
        }
      });
    },
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result;
      }
      if (dialog === "editKpiDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKpiDialogData();
      }
    },
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error");
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    openDeleteKpiConfirmationDialog: function openDeleteKpiConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Delete");
        return;
      }
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "KPIDeleteModal",
        confirmationTitle: this.lang.KM2019,
        colorRed: true,
        yesButtonText: this.lang.KM2020,
        noButtonText: this.lang.KM2021,
        htmlText: "<p><b>" + this.lang.KM2022 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2023 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPIId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2024 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPICode + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.KM2025 + "</label>\n          <label class=\"col-md-8 text-black\">" + this.selectedKpiInformation.KPIShortText + "</label>\n        </div>"
      };
    },
    deleteSelectedKpi: function deleteSelectedKpi() {
      var _this11 = this;

      var queryString = "api/KPIs/" + this.selectedKpiGuid;
      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          _this11.globals.showSuccessSnackbar("KPI deletion successful");
          _this11.createNewKpi();
          _this11.getKpisOfSelectedKpiGroup();
          _this11.$forceUpdate();
        },
        error: function error() {
          console.error("KPI deletion failed in deleteSelectedKpi()");
          _this11.globals.showErrorSnackbar("KPI deletion failed");
        }
      });
    },

    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup: function reorderKpisInKpiGroup() {
      var _this12 = this;

      var numberOfKpis = this.kpisOfSelectedKpiGroup.length,
          allPositions = _.range(1, numberOfKpis + 1),
          missingPos = 0,
          newPos = 0,
          kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach(function (position, index) {
        if (position !== _this12.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = _this12.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = _this12.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos && this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos) this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },
    sortKpisByGroupPosition: function sortKpisByGroupPosition() {
      if (!this.kpisOfSelectedKpiGroup == "undefined") return;
      this.kpisOfSelectedKpiGroup.sort(function (a, b) {
        return a.KPIGroupPosition - b.KPIGroupPosition;
      });
    },
    saveKpisNewOrder: function saveKpisNewOrder() {
      var _this13 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Update")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      var queryString = "api/KPIGroups/" + this.selectedKpiGroupGuid;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;
      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this13.globals.showSuccessSnackbar("KPI Group update successful");
          _this13.changeKpiOrderDirty = false;
          _this13.getKpisOfSelectedKpiGroup();
        },
        error: function error() {
          console.error("Error on POST in saveEditKPIGroupDialogData()");
          _this13.globals.showErrorSnackbar("KPI Group update failed");
        }
      });
    },
    getKPIGroup: function getKPIGroup(kpiGroupGuid) {
      var result = this.kpiGroupsOfSelectedClient.find(function (element) {
        return element.KPIGroupGuid === kpiGroupGuid;
      });
      return {
        KPIGroupGuid: result.KPIGroupGuid,
        KPIGroupCode: result.KPIGroupCode
      };
    },
    saveEditKpiDialogData: function saveEditKpiDialogData() {
      var _this14 = this;

      if (!this.globals.isAccessAllowed("LoopOp_KPIs_Create") && !this.selectedKpiGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Create");
        return;
      } else if (!this.globals.isAccessAllowed("LoopOp_KPIs_Update") && this.selectedKpiGuid) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIs_Update");
        return;
      }

      var queryString = !this.selectedKpiGuid ? "api/KPIs" // new kpi group
      : "api/KPIs/" + this.selectedKpiGuid; // update exisiting kpi group
      var kpiGroup = this.getKPIGroup(this.selectedKpiGroupGuid);
      if (this.selectedKpiInformation.KPIGroups) this.selectedKpiInformation.KPIGroups = [];
      this.selectedKpiInformation.KPIGroups.push(kpiGroup);

      if (!this.selectedKpiInformation.KPIEvaluationRuleGuid) delete this.selectedKpiInformation.KPIEvaluationRuleGuid;

      if (this.selectedKpiInformation.KPIWeight === "") delete this.selectedKpiInformation.KPIWeight;

      if (!this.selectedKpiGuid) {
        $.ajax({
          method: "POST",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this14.globals.showSuccessSnackbar("KPI creation successful");
            _this14.selectedKpiGuid = data[0].KPIGuid;
            _this14.selectedKpiInformation = _.cloneDeep(data[0]);
            _this14.selectedKpiDirty = false;
            _this14.getKpisOfSelectedKpiGroup();
          },
          error: function error() {
            console.error("Error on POST in saveEditKpiDialogData()");
            _this14.globals.showErrorSnackbar("KPI creation failed");
          }
        });
      } else {
        $.ajax({
          method: "PUT",
          url: queryString,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedKpiInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this14.globals.showSuccessSnackbar("KPI update successful");
            _this14.selectedKpiDirty = false;
            _this14.getKpisOfSelectedKpiGroup();
          },
          error: function error() {
            console.error("Error on POST in saveEditKpiDialogData()");
            _this14.globals.showErrorSnackbar("KPI update failed");
          }
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "KPIManagementTranslateModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateKpiDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openTranslateKpiDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["showDialog", "client", "projects", "initialProject"],
  data: function data() {
    return {
      selectedLocaleCode: "",
      selectedProject: "",
      searchKpiString: "",
      kpiTranslations: [],
      filteredKpiTranslations: [],
      avaibleLocaleList: [],
      isTranslationDirty: false,
      isInitialSort: false,
      currentSort: { key: "Type", asc: true },
      lang: {
        KM3000: "Save",
        KM3001: "KPI Translation",
        KM3002: "Language selection",
        KM3003: "Please choose a language...",
        KM3004: "Search...",
        KM3005: "Type",
        KM3006: "Text",
        KM3007: "Translation",
        KM3008: "Client",
        KM3009: "Close",
        KM3010: "Discard changes",
        KM3011: "Yes",
        KM3012: "No",
        KM3013: "There are unsaved changes. Do you want to proceed?",
        KM3014: "Reset sort",
        KM3015: "Project",
        KM3016: "Please select a project..."
      }
    };
  },

  methods: {
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateKpiDialog: function openTranslateKpiDialog() {
      $("#translateKpiDialog").modal("show");
      this.initTranslateKpiDialog();
      this.getAvailableLocaleList();
    },
    initTranslateKpiDialog: function initTranslateKpiDialog() {
      this.selectedLocaleCode = "";
      this.selectedProject = this.initialProject ? this.initialProject : "";
      this.searchKpiString = "";
      this.isTranslationDirty = false;
      this.isInitialSort = false;
      this.kpiTranslations = [];
      this.filteredKpiTranslations = [];
    },
    closeKpiTranslationModal: function closeKpiTranslationModal() {
      if (this.isTranslationDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          $("#translateKpiDialog").modal("hide");
        });
        return;
      }
      $("#translateKpiDialog").modal("hide");
    },
    getAvailableLocaleList: function getAvailableLocaleList() {
      var _this2 = this;

      var queryString = "api/KPITranslation/" + this.client.clientGuid + "/AvailableLocales";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this2.avaibleLocaleList = !_.isEmpty(data) ? data : [];
          _this2.$nextTick(function () {
            $("#selectLocale").val("").trigger("change");
          });
        },
        error: function error() {
          console.error("Available locale list access failed in getAvailableLocaleList()");
          _this2.globals.showErrorSnackbar("Available locale list access failed");
        }
      });
    },
    selectedLocaleChanged: function selectedLocaleChanged(value, event) {
      var _this3 = this;

      if (!value) return;
      if (this.isTranslationDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this3.selectedLocaleCode = value;
          _this3.getKpiTranslations();
        }, function () {
          $(event.target).val(_this3.selectedLocaleCode).trigger("change");
        });
        return;
      }
      this.selectedLocaleCode = value;
      this.getKpiTranslations();
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      var _this4 = this;

      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }

      this.isInitialSort = true;

      var sortFunction = function sortFunction(kpi) {
        if (typeof kpi[_this4.currentSort.key] === "string") {
          return kpi[_this4.currentSort.key].toLowerCase();
        }
        return kpi[_this4.currentSort.key];
      };
      this.filteredKpiTranslations = _.orderBy(this.filteredKpiTranslations, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    doFiltering: function doFiltering() {
      if (!this.searchKpiString) this.filteredKpiTranslations = this.kpiTranslations;

      var words = this.searchKpiString.split(" ");
      var keys = ["Type", "Text", "Translation", "InheritedTranslation"];

      var kpiFilter = function kpiFilter(kpi) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (kpi[key] && kpi[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };

      this.filteredKpiTranslations = !_.isEmpty(this.kpiTranslations) ? this.kpiTranslations.filter(kpiFilter) : [];
      this.currentSort.asc = !this.currentSort.asc;
      this.getInitialSort();
    },
    getKpiTranslations: function getKpiTranslations() {
      var _this5 = this;

      if (!this.client.clientGuid || !this.selectedLocaleCode) {
        this.kpiTranslations = [];
        this.doFiltering();
        return;
      }
      var queryString = "api/KPITranslation/" + this.client.clientGuid + "?LocaleCode=" + this.selectedLocaleCode;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this5.kpiTranslations = !_.isEmpty(data) ? data : [];
          _this5.isTranslationDirty = false;
          _this5.doFiltering();
          _this5.correctTextareaHeight();
        },
        error: function error() {
          console.error("KPI Translations access failed in getKpiTranslations()");
          _this5.globals.showErrorSnackbar("KPI Translations access failed");
        }
      });
    },
    saveKpiTranslations: function saveKpiTranslations() {
      var _this6 = this;

      var queryString = "api/KPITranslation/" + this.client.clientGuid + "?LocaleCode=" + this.selectedLocaleCode;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.kpiTranslations),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this6.globals.showSuccessSnackbar("KPI Translation update successful");
          _this6.isTranslationDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveKpiTranslations()");
          _this6.globals.showErrorSnackbar("KPI Translation update failed");
        }
      });
    },
    getInitialSort: function getInitialSort() {
      this.isInitialSort = false;
      // kpi groups
      var orderByKpiGroupType = ["KPIGroupCode", "KPIGroupShortText", "KPIGroupLongText"];
      var kpiGroups = this.filteredKpiTranslations.filter(function (kpi) {
        return !kpi.KPIGroupGuid;
      });
      this.sortElementsBy(kpiGroups, orderByKpiGroupType);
      // kpi
      var orderByKpiType = ["KPICode", "KPIShortText", "KPILongText"];
      var kpis = this.filteredKpiTranslations.filter(function (kpi) {
        return kpi.KPIGroupGuid;
      });
      this.sortElementsBy(kpis, orderByKpiType);

      kpis.forEach(function (kpi, index) {
        var idx = _.findLastIndex(kpiGroups, function (kpiGroup) {
          return kpiGroup.Guid === kpi.KPIGroupGuid;
        });
        kpiGroups.splice(idx + index % 3 + 1, 0, kpi);
      });

      this.filteredKpiTranslations = kpiGroups;
    },
    sortElementsBy: function sortElementsBy(elementsToSort, sortBy) {
      elementsToSort.sort(function (a, b) {
        if (a.Guid > b.Guid) return 1;
        if (a.Guid < b.Guid) return -1;

        if (a.Guid === b.Guid) {
          if (sortBy.indexOf(a.Type) > sortBy.indexOf(b.Type)) return 1;
          if (sortBy.indexOf(a.Type) < sortBy.indexOf(b.Type)) return -1;
          if (sortBy.indexOf(a.Type) === sortBy.indexOf(b.Type)) return 0;
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Locations__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Surveys__ = __webpack_require__(70);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationDataTranslateModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedLocation: {
      type: String,
      default: ""
    },
    selectedLocationId: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      languageisFresh: false,
      selectedCountry: "",
      selectedLanguage: "",
      countryList: [],
      countryLanguages: [],
      translationDataList: [],
      baseLocationData: {},
      currentTranslationDataDirty: false,
      currentCountryLanguages: [],
      lang: {
        LTM000: "Translate location data",
        LTM001: "Country",
        LTM002: "Language",
        LTM003: "Please select a country...",
        LTM004: "Please select a language...",
        LTM005: "No translation data for this language stored yet.",
        LTM006: "Name of the location",
        LTM007: "Street",
        LTM008: "Addition to address",
        LTM009: "Region",
        LTM010: "City",
        LTM011: "Postal code",
        LTM012: "Close",
        LTM013: "Save",
        LTM014: "Unsaved Changes",
        LTM015: "Save",
        LTM016: "Discard changes",
        LTM017: "There are unsaved changes for the current translation entry. Do you want to save them?",
        LTM018: "Location data access failed",
        LTM019: "Localized location data access failed",
        LTM020: "Translation data update successful",
        LTM021: "Translation data update failed"
      }
    };
  },

  computed: {
    currentTranslationData: function currentTranslationData() {
      var _this = this;

      if (!this.selectedLanguage) return {};
      var data = _.find(this.translationDataList, function (trData) {
        return trData.CountryCode === _this.selectedCountry && trData.LanguageCode === _this.selectedLanguage;
      });
      return data || {};
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this2 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(function (data) {
        return _this2.countryList = data;
      });
    },
    showModal: function showModal(newVal) {
      if (newVal) this.openModal();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getSelectData();

    $("#locationDataTranslateModal").on("hidden.bs.modal", function (e) {
      return _this3.$emit("modalClosed");
    });

    this.globals.$off("IgnoreUnsavedLocationTranslationYesConfirmation");
    this.globals.$on("IgnoreUnsavedLocationTranslationYesConfirmation", this.saveLocalizedLocationData);
    this.globals.$off("IgnoreUnsavedLocationTranslationNoConfirmation");
    this.globals.$on("IgnoreUnsavedLocationTranslationNoConfirmation", this.getLocalizedLocationData);
  },

  methods: {
    countryChanged: function countryChanged(country) {
      var _this4 = this;

      if (!country) return;
      var countryObj = this.countryLanguages.find(function (country) {
        return country.CountryCode === _this4.selectedCountry;
      });
      this.currentCountryLanguages = countryObj && countryObj.Languages ? countryObj.Languages : [];
    },
    openModal: function openModal() {
      this.getLocalizedLocationData();
      this.getBaseLocationData();
    },
    closeModal: function closeModal() {
      $("#locationDataTranslateModal").modal("hide");
    },
    showDirtyDataWarning: function showDirtyDataWarning() {
      this.$refs.selectLocalizedLocationDataCountryCode.close();
      this.$refs.selectLocalizedLocationDataLanguageCode.close();

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "IgnoreUnsavedLocationTranslation",
        confirmationTitle: this.lang.LTM014,
        colorRed: true,
        yesButtonText: this.lang.LTM015,
        noButtonText: this.lang.LTM016,
        htmlText: "<p>" + this.lang.LTM017 + "</p>"
      });
    },
    addNewTranslationData: function addNewTranslationData() {
      this.translationDataList.push({
        LocationGuid: this.selectedLocation,
        CountryCode: this.selectedCountry,
        LanguageCode: this.selectedLanguage
      });
    },
    getBaseLocationData: function getBaseLocationData() {
      var _this5 = this;

      if (this.selectedLocationId < 0) return;

      $.ajax({
        method: "GET",
        url: "api/Locations/" + this.selectedLocationId,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.baseLocationData = data;
        },
        error: function error() {
          console.error("Error on GET in getBaseLocationData()");
          _this5.globals.showErrorSnackbar(_this5.lang.LTM018);
        }
      });
    },
    getLocalizedLocationData: function getLocalizedLocationData() {
      var _this6 = this;

      if (!this.selectedLocation) return;

      $.ajax({
        method: "GET",
        url: "api/Locations/" + this.selectedLocation + "/Translations",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.translationDataList = data;
          _this6.currentTranslationDataDirty = false;
          if (!$("#locationDataTranslateModal").hasClass("in")) $("#locationDataTranslateModal").modal("show");
        },
        error: function error() {
          console.error("Error on GET in getLocalizedLocationData()");
          _this6.globals.showErrorSnackbar(_this6.lang.LTM019);
          _this6.$emit("modalClosed");
        }
      });
    },
    saveLocalizedLocationData: function saveLocalizedLocationData() {
      var _this7 = this;

      var requests = this.translationDataList.map(function (translation) {
        if (translation.LocationTranslationGuid) {
          return __WEBPACK_IMPORTED_MODULE_2__services_Locations__["a" /* default */].Translations.update(_this7.selectedLocation, translation);
        } else {
          return __WEBPACK_IMPORTED_MODULE_2__services_Locations__["a" /* default */].Translations.create(_this7.selectedLocation, translation);
        }
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(requests).then(function (res) {
        _this7.currentTranslationDataDirty = false;
        _this7.globals.showSuccessSnackbar(_this7.lang.LTM020);
      }).catch(function (errors) {
        console.error("Error on POST in saveLocalizedLocationData()");
        _this7.globals.showErrorSnackbar(_this7.lang.LTM021);
      });
    },
    deleteTranslationData: function deleteTranslationData() {
      var _this8 = this;

      if (!this.currentTranslationData.LocationTranslationGuid) {
        this.removeCurrentTranslationFromList();
        return;
      }
      var queryString = "api/Locations/Translations/" + this.currentTranslationData.LocationTranslationGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this8.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this8.removeCurrentTranslationFromList();
          _this8.globals.showSuccessSnackbar(_this8.lang.LTM020);
        },
        error: function error() {
          console.error("Error on DELETE in deleteTranslationData()");
          _this8.globals.showErrorSnackbar(_this8.lang.LTM021);
        }
      });
    },
    removeCurrentTranslationFromList: function removeCurrentTranslationFromList() {
      var _this9 = this;

      _.remove(this.translationDataList, function (td) {
        return td.CountryCode === _this9.selectedCountry && td.LanguageCode === _this9.selectedLanguage;
      });
      var tmpLang = this.selectedLanguage;
      this.selectedLanguage = "";
      this.currentTranslationDataDirty = false;
      this.$nextTick(function () {
        _this9.selectedLanguage = tmpLang;
      });
    },
    getSelectData: function getSelectData() {
      var _this10 = this;

      if (this.globals.selectedLanguage) {
        this.globals.getCountryList(function (data) {
          return _this10.countryList = data;
        });
      }
      this.globals.getCountryLanguageList(function (callbackData) {
        _this10.countryLanguages = callbackData;
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationExportModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      clientList: [],
      exportLocationsFileType: "xlsx",
      lang: {
        LEX000: "Location Export",
        LEX001: "Cancel",
        LEX002: "Download",
        LEX003: "No client selected",
        LEX004: "Location export failed",
        LEX005: "Client"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    var clientListPromise = this.globals.getClientList();
    clientListPromise.then(function (data) {
      _this.clientList = data;
      if (_this.clientList.length === 1) {
        _this.$nextTick(function () {
          _this.selectedClient = _this.clientList[0].ClientGuid;
        });
      }
    });

    $("#exportLocationsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      $("#exportLocationsModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#exportLocationsModal").modal("hide");
    },
    downloadExportData: function downloadExportData() {
      var _this2 = this;

      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LEX003);
        return;
      }

      var url = "api/Locations/Export/" + this.selectedClient + "?file_type=" + this.exportLocationsFileType;
      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          try {
            var guid = JSON.parse(data)[0].DownloadId;
            _this2.globals.downloadFile(guid);
            _this2.closeModal();
          } catch (error) {
            _this2.globals.showErrorSnackbar(_this2.lang.LEX004);
            console.error(error);
          }
        },
        error: function error() {
          console.error("Export data access failed in downloadExportData()");
          _this2.globals.showErrorSnackbar(_this2.lang.LEX004);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationImport",
  created: function created() {
    var guidRegex = RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);

    if (guidRegex.test(this.$route.params.clientGuid)) this.selectedClient = this.$route.params.clientGuid;else {
      this.globals.showErrorSnackbar(this.lang.I0039);
      this.$router.push({
        path: "/locationmanagement"
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    var error = function error() {
      _this.$router.push({
        path: "/locationmanagement"
      });
    };
    this.getCurrentImportData(error);

    $(window).on("resize", this.setTableHeight).resize();

    $("#feedbackModal").on("hide.bs.modal", function () {
      _this.checkForErrors = false;
      _this.initialRender = false;
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
  },

  methods: {
    setTableHeight: function setTableHeight() {
      var height = $(window).height();
      height -= $("#import-top-panel").height() + $("#app-navbar").height() + 47; // 47 pixel for the free space around the cards
      $(".import-table-panel").css("max-height", height);
    },

    // Display some information dialog to let the user know what to do, depending on whether there are errors or not
    showInitialMessages: function showInitialMessages() {
      if (this.noErrors) {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0009;
        this.feedbackModalData.text = this.lang.I0010;
        this.feedbackModalData.text += this.lang.I0011;
        this.feedbackModalData.text += this.lang.I0012;
      } else {
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0013;
        this.feedbackModalData.text = this.lang.I0014;
        this.feedbackModalData.text += this.lang.I0015;
        this.feedbackModalData.text += this.lang.I0016;
        this.feedbackModalData.text += this.lang.I0017;
        this.feedbackModalData.text += this.lang.I0018;
      }
      $("#feedbackModal").modal("show");
    },

    // Display information about errors that are still available
    showErrorCheckMessages: function showErrorCheckMessages() {
      if (this.serverResponse.Error_Counter < 1) {
        // No more errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0023;
        this.feedbackModalData.text = this.lang.I0024;
        this.feedbackModalData.text += this.lang.I0025;
        $("#feedbackModal").modal("show");
      } else {
        // Still errors left
        this.feedbackModalData.type = "okNoAction";
        this.feedbackModalData.title = this.lang.I0026;
        this.feedbackModalData.text = this.lang.I0027;
        $("#feedbackModal").modal("show");
      }
    },

    // Toggles the selected-state of a given row, if it does not contain errors.
    // If the row is not yet selected, it will be added to the array of selected rows.
    // If the row is already selected, it will be removed from that array.
    toggleRowSelected: function toggleRowSelected(index) {
      if (this.rowContainsError(index)) return;
      var idx = this.selectedRowNumbers.indexOf(this.serverResponse.Locations[index].RN);
      if (idx > -1) this.selectedRowNumbers.splice(idx, 1);else this.selectedRowNumbers.push(this.serverResponse.Locations[index].RN);
    },

    // Selects all available rows
    // selectAllRows() {
    //   let rowNumbers = this.getRange(1, this.serverResponse.Count, 1);
    //   this.selectedRowNumbers = rowNumbers;
    // },
    // Returns true if row is selected, otherwise false.
    isRowSelected: function isRowSelected(index) {
      return this.selectedRowNumbers.indexOf(this.serverResponse.Locations[index].RN) > -1;
    },

    // Returns true if given datarow is updated, otherwise false.
    isRowUpdated: function isRowUpdated(index) {
      return this.serverResponse.Locations[index].state === "U";
    },

    // Returns true if given datarow is new, otherwise false.
    isRowNew: function isRowNew(index) {
      return this.serverResponse.Locations[index].state === "I";
    },

    // Closes the import and returns to the client management
    exitImport: function exitImport() {
      $("#feedbackModal").modal("hide");
      this.$router.push({
        path: "/locationmanagement"
      });
    },

    // Sends a message to the server to store the import data in the database
    saveImportData: function saveImportData() {
      var _this2 = this;

      if (this.noErrors || this.selectedRowNumbers.length > 0) {
        var dataString = '{"save":true';

        if (this.selectedRowNumbers.length > 0) dataString += ',"selected":' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedRowNumbers);
        dataString += "}";

        // Send data to the server
        $.ajax({
          method: "POST",
          url: "api/Locations/Import/" + this.selectedClient,
          data: dataString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            _this2.globals.showSuccessSnackbar(_this2.lang.I0020);
            _this2.$router.push({
              path: "/locationmanagement"
            });
          },
          error: function error() {
            console.error("Error on POST in saveImportData()");
            _this2.globals.showErrorSnackbar(_this2.lang.I0022);
          }
        });
      } else console.error("Error on saveImportData(): There are still errors left");
    },

    // Sends corrected import data to the server to check, if the new data is valid
    validateImportData: function validateImportData() {
      var _this3 = this;

      var dataString = '{"corrections":';

      var correctionData = [];
      for (var locIdx = 0; locIdx < this.serverResponse.Locations.length; locIdx++) {
        if (this.serverResponse.Locations[locIdx].ErrorColumnNames)
          // Build data structure
          for (var errIdx = 0; errIdx < this.serverResponse.Locations[locIdx].ErrorColumnNames.length; errIdx++) {
            var obj = {};
            obj.RN = this.serverResponse.Locations[locIdx].RN;
            obj.ColumnName = this.serverResponse.Locations[locIdx].ErrorColumnNames[errIdx];
            obj.Value = this.serverResponse.Locations[locIdx][obj.ColumnName];

            correctionData.push(obj);
          }
      }

      dataString += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(correctionData) + "}";
      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.checkForErrors = true;
          _this3.getCurrentImportData();
          _this3.globals.showSuccessSnackbar(_this3.lang.I0040);
        },
        error: function error() {
          console.error("Error on POST in validateImportData()");
          _this3.globals.showErrorSnackbar(_this3.lang.I0041);
        }
      });
    },

    // Returns a string that contains all parameters for the request containing paging and filter states
    getRequestParamString: function getRequestParamString() {
      var getString = "?page_size=" + this.pageSize;
      getString += "&page=" + this.selectedPage;
      getString += "&sort_order=" + (this.sortOrderAsc ? "asc" : "desc");
      if (this.sortColumn) getString += "&sort_column=" + this.sortColumn;

      if (this.errorFilterState || this.newFilterState || this.updatedFilterState) {
        getString += "&filter={";
        if (this.errorFilterState) getString += '"Errors":' + this.errorFilterState;

        if (this.errorFilterState && (this.newFilterState || this.updatedFilterState)) getString += ",";

        if (this.newFilterState || this.updatedFilterState) {
          getString += '"States":[';

          if (this.newFilterState) {
            getString += '"I"';
            if (this.updatedFilterState) getString += ',"U"';
          } else {
            if (this.updatedFilterState) getString += '"U"';
          }
          getString += "]";
        }
        getString += "}";
      }
      return getString;
    },

    // Requests importdata for the current page with the current settings from the server
    getCurrentImportData: function getCurrentImportData(_error) {
      var _this4 = this;

      var getString = "api/Locations/Import/" + this.getRequestParamString();
      getString = encodeURI(getString);

      $.ajax({
        method: "GET",
        url: getString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this4.pageSize = data[0].Page_Size;
          _this4.selectedPage = data[0].Page;
          _this4.pageCount = data[0].Page_Count;
          _this4.serverResponse = data[0];
          _this4.noErrors = !_this4.errorsExist();
          _this4.tableHeaders = _this4.getTableHeaders();

          if (_this4.initialRender) {
            // Only executes the first time after component rendering
            _this4.showInitialMessages();
            if (_this4.serverResponse.Error_Counter + _this4.serverResponse.Updated_Counter + _this4.serverResponse.Inserted_Counter == 0) {
              _this4.errorFilterState = false;
              _this4.updatedFilterState = false;
              _this4.newFilterState = false;
            }
          }

          if (_this4.checkForErrors) {
            // Only executes after data validation
            _this4.showErrorCheckMessages();
            if (_this4.serverResponse.Error_Counter + _this4.serverResponse.Updated_Counter + _this4.serverResponse.Inserted_Counter == 0) {
              _this4.errorFilterState = false;
              _this4.updatedFilterState = false;
              _this4.newFilterState = false;
            }
          }
        },
        error: function error() {
          console.error("Error on GET in getCurrentImportData()");
          _this4.globals.showErrorSnackbar(_this4.lang.I0042);
          if (_error) _error();
        }
      });
    },

    // Tells the server to discard the import data
    discardImportData: function discardImportData() {
      var _this5 = this;

      var dataString = '{"save":false}';

      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this5.exitImport();
        },
        error: function error() {
          console.error("Error on POST in discardImportData()");
          _this5.globals.showErrorSnackbar();
        }
      });
    },

    // Displays a security check dialog if the user tries to cancel the import
    cancelLocationImport: function cancelLocationImport() {
      this.feedbackModalData.type = "YesNoCancelImport";
      this.feedbackModalData.title = this.lang.I0028;
      this.feedbackModalData.text = this.lang.I0029;
      $("#feedbackModal").modal("show");
    },

    // Returns true, if the row with the given index contains an error value, otherwise false
    rowContainsError: function rowContainsError(index) {
      if (this.noErrors) return false;

      if (this.serverResponse.Locations[index].ErrorColumnNames) return true;
      return false;
    },

    // Returns true, if the field with the given rowindex and columnname contains an error, otherwise false
    isErrorValue: function isErrorValue(rowindex, column) {
      if (!this.rowContainsError(rowindex)) return false;

      if (this.serverResponse.Locations[rowindex].ErrorColumnNames.indexOf(column) > -1) return true;
    },

    // Returns true if there are errors in the server response, otherwise false
    errorsExist: function errorsExist() {
      if (!this.serverResponse.Error_Counter) return false;
      return this.serverResponse.Error_Counter > 0;
    },

    // Returns a list of header names for the table
    getTableHeaders: function getTableHeaders() {
      if (!this.serverResponse || !this.serverResponse.Locations) return [""];
      var headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.serverResponse.Locations[0]);

      // Remove columns that do not have to be shown
      var idx = void 0;
      var removeCols = ["RN", "state", "ErrorColumnNames"];
      for (var i = 0; i < removeCols.length; i++) {
        idx = headers.indexOf(removeCols[i]);
        if (idx !== -1) headers.splice(idx, 1);
      }
      return headers;
    },
    getVisibleLocationData: function getVisibleLocationData(location) {
      return _.pick(location, this.tableHeaders);
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getCurrentImportData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    errorFilterState: function errorFilterState() {
      this.getCurrentImportData();
    },
    newFilterState: function newFilterState() {
      if (!(this.initialRender || this.checkForErrors)) this.getCurrentImportData();
    },
    updatedFilterState: function updatedFilterState() {
      if (!(this.initialRender || this.checkForErrors)) this.getCurrentImportData();
    },
    sortColumn: function sortColumn() {
      this.getCurrentImportData();
    },
    sortOrderAsc: function sortOrderAsc() {
      this.getCurrentImportData();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedClient: "",
      serverResponse: [], // Stores the server response data
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      sortOrderAsc: true,
      sortColumn: "",
      noErrors: false, // true --> there are currently no errors in the import data
      tableHeaders: [],
      errorFilterState: true, // Stores the current state of the error-filter
      newFilterState: true, // Stores the current state of the new-filter
      updatedFilterState: true, // Stores the current state of the updated-filter
      checkForErrors: false,
      initialRender: true,
      selectedRowNumbers: [], // Stores the index of the selected table-row
      feedbackModalData: {
        type: "info", // Should be "okNoAction", "okImportSuccessful" or "YesNoCancelImport" -> different dialog types
        title: "", // Set the dialog title here
        text: "" // Set the dialog text here
      },
      lang: {
        I0000: "Save",
        I0001: "Send correction",
        I0002: "Cancel import",
        I0003: "Error",
        I0004: "Add",
        I0005: "Updated",
        I0006: "No",
        I0007: "Yes",
        I0008: "OK",
        I0009: "Import data were successfully verified.",
        I0010: "The data were successfully verified and free of error!<br><br>",
        I0011: "The imported data can be seen in the following table.<br>",
        I0012: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0013: "Check import data",
        I0014: "Please check the data to be imported.<br><br>",
        I0015: "In all lines marked in yellow errors are highlighted in red.<br>",
        I0016: "The incorrect inputs can only be edit by double clicking.<br>",
        I0017: 'For resending the revised data click <b>"Send correction"</b>.<br>',
        I0018: 'By clicking <b>"Activate filter"</b> only faulty records will be shown.<br>',
        I0019: "Import was successful",
        I0020: "Data were successfully imported.",
        I0021: "Import failed",
        I0022: "An error occurred while importing!",
        I0023: "Correction was successful",
        I0024: "The data were successfully verified and free of further errors!<br><br>",
        I0025: 'For writing the data to the database click <b>"Save"</b>.<br>',
        I0026: "Incorrect correction",
        I0027: "Sorry, but there are still errors in the import data. Please correct them!",
        I0028: "Cancel import",
        I0029: "Do you really want to cancel the import?",
        I0030: "Items per page",
        I0031: "First page",
        I0032: "Last page",
        I0033: "Selected",
        I0034: "Incorrect",
        I0035: "Updated",
        I0036: "Add",
        I0037: "Clear selection",
        I0038: "No data",
        I0039: "Invalid client",
        I0040: "Import data update successful",
        I0041: "Import data update failed",
        I0042: "Import data access failed"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationImportDataModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      importOption: "text",
      trimImportData: false,
      importText: "",
      selectedFile: {},
      selectedClient: "",
      clientList: [],
      lang: {
        LIM000: "Location import",
        LIM001: "Text import",
        LIM002: "File import",
        LIM003: "Text",
        LIM004: "Please insert the table data to be imported here.",
        LIM005: "File",
        LIM006: "Please select a file...",
        LIM007: "Cancel",
        LIM008: "OK",
        LIM009: "Clean data",
        LIM010: "Client",
        LIM011: "No client selected",
        LIM012: "Please insert import data",
        LIM013: "Please select an import file",
        LIM014: "Location import failed"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    var clientListPromise = this.globals.getClientList();
    clientListPromise.then(function (data) {
      _this.clientList = data;
      if (_this.clientList.length === 1) _this.selectedClient = _this.clientList[0].ClientGuid;
    });

    $("#importLocationsModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
      if (_this.$locationImportSuccess) {
        delete _this.$locationImportSuccess;
        _this.$router.push({
          path: "locationimport/" + _this.selectedClient
        });
      }
    });
  },

  methods: {
    openModal: function openModal() {
      this.importText = "";
      this.selectedFile = {};
      $("#importLocationsModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#importLocationsModal").modal("hide");
    },
    uploadImportData: function uploadImportData() {
      var _this2 = this;

      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LIM011);
        return;
      }
      var requestData = void 0;
      if (this.importOption === "text") {
        if (!this.importText) {
          this.globals.showErrorSnackbar(this.lang.LIM012);
          return;
        }
        // Escape all " characters
        var importText = this.importText.replace(/"/g, '\\"');
        requestData = "{\"data\":\"" + importText + "\",\"trim\":" + this.trimImportData + "}";
      } else {
        if (_.isEmpty(this.selectedFile)) {
          this.globals.showErrorSnackbar(this.lang.LIM013);
          return;
        }
        requestData = "{\"file\":\"" + this.selectedFile.file + "\",\"trim\":" + this.trimImportData + "}";
      }

      $.ajax({
        method: "POST",
        url: "api/Locations/Import/" + this.selectedClient,
        data: requestData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        timeout: 600000,
        success: function success(data) {
          _this2.$locationImportSuccess = true;
          $("#importLocationsModal").modal("hide");
        },
        error: function error(data) {
          console.error("Error on POST in uploadImportData()");
          _this2.globals.showErrorSnackbar(_this2.lang.LIM014);
        },
        complete: function complete() {
          _this2.importText = "";
          $("#locationImportFileInput")[0].value = null;
        }
      });
    },


    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange: function onImportFileChange(e) {
      var _this3 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.selectedFile = {};
        return;
      }
      var fileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (_this3.selectedFile) {
          _this3.selectedFile.file = data[0].DownloadId;
          _this3.selectedFile.name = fileObject.name;
        } else _this3.selectedFile = data;

        _this3.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, false, uploadSuccess);
      e.target.value = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationExportModal__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationExportModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LocationExportModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationManagement",
  components: {
    LocationImportDataModal: __WEBPACK_IMPORTED_MODULE_1__LocationImportDataModal___default.a,
    LocationExportModal: __WEBPACK_IMPORTED_MODULE_2__LocationExportModal___default.a,
    LocationManagementEditModal: __WEBPACK_IMPORTED_MODULE_3__LocationManagementEditModal___default.a,
    LocationDataTranslateModal: __WEBPACK_IMPORTED_MODULE_4__LocationDataTranslateModal___default.a
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    this.getLocationData();
    $(window).on("resize", this.setLocationTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setLocationTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setLocationTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setLocationTableHeight: function setLocationTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#locations-top-panel").height() + $("#app-navbar").height() +
        //$(".main-table > thead").height() +
        47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/locationManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/locationManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },
    onLocationDataUpdated: function onLocationDataUpdated($event) {
      if ($event) {
        this.selectedLocation = $event.LocationId;
        this.selectedLocationGuid = $event.LocationGuid;
      }
      this.getLocationData();
    },
    openDeleteLocationDialog: function openDeleteLocationDialog() {
      var _this = this;

      var objIndex = _.findIndex(this.locationData, function (o) {
        return o.LocationId == _this.selectedLocation;
      });
      this.deleteLocationDialogData = this.locationData[objIndex];
      $("#deleteLocation").modal("show");
    },
    deleteLocationData: function deleteLocationData() {
      var _this2 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Locations/" + this.selectedLocation,
        success: function success(data) {
          $("#deleteLocation").modal("hide");
          _this2.globals.showSuccessSnackbar("Location deletion successful");
          _this2.selectedLocation = -1;
          _this2.selectedLocationGuid = "";
          _this2.getLocationData();
        },
        error: function error() {
          console.error("Location data deletion failed in deleteLocationData()");
          _this2.globals.showErrorSnackbar("Location deletion failed");
        }
      });
    },
    sortLocationData: function sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },
    getLocationData: function getLocationData() {
      var _this3 = this;

      this.refreshEnabled = false;

      var getString = "api/Locations/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (typeof data[0] == "undefined") {
            _this3.locationData = [];
            _this3.pageCount = 1;
          } else {
            _this3.locationData = data[0].Locations;
            _this3.pageCount = data[0].Page_Count;
            _this3.totalElementsCount = data[0].Count;
          }
        },
        error: function error() {
          console.error("Error on POST in getLocationData()");
          _this3.globals.showErrorSnackbar("Location data access failed");
        },
        complete: function complete() {
          _this3.refreshEnabled = true;
        }
      });
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedLocation: -1, // ID of the selected location, -1 if none is selected
      selectedLocationGuid: "",
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ClientId: "",
        ClientName: "",
        ImporterName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationPostalCode: "",
        LocationCountry: "",
        LocationStatusId: ""
      },
      sortField: "LocationName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      locationData: [], // Stores the location data on the current page
      deleteLocationDialogData: {}, // Stores data for the deleteLocation dialog
      showLocationImportDataModal: false,
      showLocationExportModal: false,
      showEditLocationModal: false,
      showLocationDataTranslateModal: false,
      lang: {
        // Contains localization strings for the selected language
        L0000: "Aktualisieren",
        L0001: "Neuer Standort",
        L0002: "Bearbeiten",
        L0003: "Löschen",
        L0004: "Geokodierung",
        L0005: "Suche...",
        L0006: "Elemente pro Seite",
        L0007: "Erste Seite",
        L0008: "Letzte Seite",
        L0009: "Kunde",
        L0010: "LOC#",
        L0011: "Name",
        L0012: "Straße",
        L0013: "Stadt",
        L0014: "Region",
        L0015: "PLZ",
        L0016: "Land",
        L0017: "Telefon",
        L0018: "Stunden",
        L0019: "Status",
        L0020: "Filter",
        L0021: "Allgemein",
        L0022: "Kunde",
        L0023: "Bitte auswählen...",
        L0024: "Store-ID",
        L0025: "Name des Standortes",
        L0026: "Straße",
        L0027: "Adresszusatz",
        L0028: "Landkreis",
        L0029: "Stadt",
        L0030: "Land",
        L0031: "Region",
        L0032: "Zeitzone",
        L0033: "PLZ",
        L0034: "Telefon",
        L0035: "Telefax",
        L0036: "Öffnungszeiten",
        L0037: "Standort Foto URL",
        L0038: "Export E-Mail",
        L0039: "Export E-Mail Name",
        L0040: "Standort Status",
        L0041: "Aktiv",
        L0042: "Vorübergehend Deaktiviert",
        L0043: "Dauerhaft Deaktiviert",
        L0044: "Breitengrad",
        L0045: "Längengrad",
        L0046: "Geocode Quelle",
        L0052: "Zusätzliche Anmerkungen",
        L0053: "Zusätzliche Anmerkungen",
        L0054: "Benutzerdefinierte Eigenschaften",
        L0055: "Beschreibung",
        L0056: "Wert",
        L0057: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        L0058: "Abbrechen",
        L0059: "Speichern",
        L0060: "Standort löschen",
        L0061: "Soll folgender Standort wirklich gelöscht werden?",
        L0062: "Kunde",
        L0063: "LOC#",
        L0064: "Name",
        L0065: "Straße",
        L0066: "Stadt",
        L0067: "Region",
        L0068: "PLZ",
        L0069: "Land",
        L0070: "Telefon",
        L0071: "Stunden",
        L0072: "Status",
        L0073: "Nein",
        L0074: "Ja",
        L0075: "Neuer Standort",
        L0076: "Standort bearbeiten",
        L0077: "Kunden-ID",
        L0078: "Diese Angabe ist erforderlich!",
        L0079: "Dies ist keine gültige Telefonnummer!",
        L0080: "Dies ist keine gültige Faxnummer!",
        L0081: "Dies ist keine gültige URL!",
        L0082: "Dies ist keine gültige E-Mail Adresse!",
        L0083: "Ungültiger Wert",
        L0084: "Default Export Country",
        L0085: "Default Export Language",
        L0086: "Location Import",
        L0087: "Download locations",
        L0088: "Importer",
        L0089: "Total locations count",
        L0090: "Show location history",
        L0091: "Translate"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_Locations__ = __webpack_require__(113);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LocationManagementEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    selectedLocation: {
      type: Number,
      default: -1
    },
    lang: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogTitle: "",
      locationData: {},
      currentRegions: [],
      currentTimeZones: [],
      currentExportLanguages: [],
      showAlert: false,
      timeZones: [],
      locationStatusList: [],
      regionList: [],
      clientList: [],
      importerList: [],
      countryLanguages: [],
      invalidInputIds: [],
      loading: false,
      countryChanged: 0
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.getLocationStatusList();
      this.globals.getCountryList();
    },
    showModal: function showModal(newVal) {
      if (newVal) this.initLocationData();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.getSelectData();

    $("#locationManagementEditModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      $("#locationManagementEditModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#locationManagementEditModal").modal("hide");
    },
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error");
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1);
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id);
      }
      return result;
    },
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result;
      }

      if (dialogId === "locationManagementEditModal") {
        this.showAlert = !result;
        if (!result) return;
        this.saveLocationData();
      }
    },
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input");
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    showLocationHistory: function showLocationHistory() {
      var config = {
        type: "Location",
        guid: this.locationData.LocationGuid,
        id: this.locationData.LocationId
      };
      this.globals.$emit("showElementHistory", config);
    },
    changedCountry: function changedCountry(country) {
      this.locationData.LocationCountry = country;
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (this.regionList) {
        if (country) {
          regionObj = this.regionList.filter(function (region) {
            return region.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (this.timeZones) {
        if (country) {
          tzObj = this.timeZones.filter(function (tz) {
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (regionObj.length === 0) this.currentRegions = [];else this.currentRegions = regionObj[0].Regions;

      if (tzObj.length === 0) this.currentTimeZones = [];else this.currentTimeZones = tzObj[0].TimeZones;
      var IsValidRegion = this.currentRegions.map(function (e) {
        return e.RegionGuid;
      }).includes(this.locationData.RegionGuid);
      if (!IsValidRegion) delete this.locationData.RegionGuid;

      var IsValidTimeZone = this.currentTimeZones.map(function (e) {
        return e.TimeZoneId;
      }).includes(this.locationData.LocationTimeZoneId);
      if (!IsValidTimeZone) delete this.locationData.LocationTimeZoneId;
    },
    changedExportCountryCode: function changedExportCountryCode(keepLanguageCode, selected) {
      var languageList = [];
      if (this.countryLanguages[0]) {
        if (selected) {
          var cl = this.countryLanguages.filter(function (country) {
            return country.CountryCode === selected;
          });
          if (cl[0] && cl[0].Languages) languageList = cl[0].Languages;
        }
      }
      this.currentExportLanguages = languageList;
      if (!keepLanguageCode) delete this.locationData.LocationExportDefaultLanguageCode;
    },
    sortCustomPropertiesByPosition: function sortCustomPropertiesByPosition() {
      if (!this.locationData.CustomProperties) return;

      this.locationData.CustomProperties.sort(function (a, b) {
        return a.Position - b.Position;
      });
    },
    locationDataReceived: function locationDataReceived() {
      this.openModal();

      if ($("#collapseCustProp").attr("aria-expanded")) {
        $("#locationManagementEditModal").off("shown.bs.modal", this.correctTextareaHeight);
        $("#locationManagementEditModal").on("shown.bs.modal", this.correctTextareaHeight);
      }
      $("#collapseCustProp").off("shown.bs.collapse", this.correctTextareaHeight);
      $("#collapseCustProp").on("shown.bs.collapse", this.correctTextareaHeight);
    },
    initLocationData: function initLocationData() {
      var _this2 = this;

      this.loading = true;
      if (this.selectedLocation < 1) {
        this.dialogTitle = this.lang.L0075;
        this.locationData = {
          LocationStatusId: "A"
        };
        if (this.audiClientId) {
          this.locationData.ClientId = this.audiClientId;
          this.getLocationProperties(this.audiClientId);
        }

        this.changedCountry("");
        this.currentExportLanguages = [];
        this.loading = false;
        this.openModal();
      } else {
        this.dialogTitle = this.lang.L0076;
        this.locationData = {};
        this.currentExportLanguages = [];
        __WEBPACK_IMPORTED_MODULE_1__services_Locations__["a" /* default */].getById(this.selectedLocation).then(function (_ref) {
          var data = _ref.data;

          if (data.Importers) {
            data.ImporterGuid = data.Importers[0].ImporterGuid;
            delete data.Importers;
          }
          _this2.locationData = data;
          _this2.changedCountry(_this2.locationData.LocationCountry);
          _this2.changedExportCountryCode(true, _this2.locationData.LocationExportDefaultCountryCode);
          _this2.sortCustomPropertiesByPosition();
          _this2.locationDataReceived();
        }).catch(function (err) {
          console.error("Location data access failed in initLocationData()");
          console.error(err);
          _this2.globals.showErrorSnackbar("Location data access failed");
        }).finally(function () {
          return _this2.loading = false;
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("locationManagementEditModal");
    },
    saveLocationData: function saveLocationData() {
      var _this3 = this;

      if (this.clientList.length < 1) {
        this.globals.showErrorSnackbar("No client available");
        return;
      }
      var sendData = _.cloneDeep(this.locationData);
      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;

        if (!sendData.ClientId) sendData.ClientId = this.clientList[0].ClientId;
      }

      for (var prop in sendData) {
        if (typeof sendData[prop] === "string" && !sendData[prop]) delete sendData[prop];
      }

      if (this.selectedLocation < 1) {
        __WEBPACK_IMPORTED_MODULE_1__services_Locations__["a" /* default */].create(sendData).then(function (_ref2) {
          var data = _ref2.data;

          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.globals.showSuccessSnackbar("Location creation successful");
          _this3.closeModal();
          _this3.$emit("locationDataUpdated", data[0].LocationId);
        }).catch(function (err) {
          console.error("Error on POST in saveLocationData()", err);
          _this3.globals.showErrorSnackbar("Location creation failed");
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_Locations__["a" /* default */].update(this.locationData.LocationId, sendData).then(function (_ref3) {
          var data = _ref3.data;

          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.globals.showSuccessSnackbar("Location update successful");
          _this3.closeModal();
          _this3.$emit("locationDataUpdated");
        }).catch(function (err) {
          console.error("Error on PUT in saveLocationData()", err);
          _this3.globals.showErrorSnackbar("Location update failed");
        });
      }
    },
    getSelectData: function getSelectData() {
      var _this4 = this;

      if (this.globals.selectedLanguage) {
        this.globals.getCountryList();
        this.getLocationStatusList();
      }
      this.globals.getCountryLanguageList(function (callbackData) {
        _this4.countryLanguages = callbackData;
      });
      this.getClientList(function () {
        if (_this4.feature.isAudiTarget && _this4.clientList[0]) {
          _this4.audiClientId = _this4.clientList[0].ClientId;
        }
      });
      if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
        this.globals.getImporterList(function (callbackData) {
          _this4.importerList = _.cloneDeep(callbackData);
          _.remove(_this4.importerList, function (importer) {
            return importer.ImporterGuid === "1D86A788-07D6-4681-BD8C-9C15800DF8BA";
          });
        });
      }
      this.globals.getRegionsList(function (callbackData) {
        _this4.regionList = callbackData;
      });
      this.globals.getTimezonesList(function (callbackData) {
        _this4.timeZones = callbackData;
      });
    },
    getClientList: function getClientList(callback) {
      var _this5 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this5.clientList = [];
          for (var x in data) {
            _this5.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this5.clientList.sort(function (a, b) {
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });

          if (callback) callback();
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this5.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },
    getLocationStatusList: function getLocationStatusList() {
      var _this6 = this;

      $.ajax({
        method: "GET",
        url: "api/data/locationstatusses",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.locationStatusList = data;
        },
        error: function error() {
          console.error("Location status data access failed in getLocationStatusList()");
          _this6.globals.showErrorSnackbar("Location status data access failed");
        }
      });
    },
    getLocationProperties: function getLocationProperties(clientId) {
      var _this7 = this;

      if (!clientId || this.globals.isAgencyUser) return;
      this.locationData.ClientId = clientId;
      $.ajax({
        method: "GET",
        url: "/api/Clients/" + clientId + "/LocationProperties",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          //this.locationData.CustomProperties = data;
          _this7.sortCustomPropertiesByPosition();
          _this7.$forceUpdate();
        },
        error: function error() {
          console.error("Location properties data access failed in getLocationProperties()");
          _this7.globals.showErrorSnackbar("Location properties data access failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    setInitialRoute: function setInitialRoute() {
      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser ? this.$router.push("/locationmanagement") : this.$router.push("/clientmanagement");
      } else {
        this.$router.push("/checkmanagement");
      }
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WaveEditModal__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WaveEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__WaveEditModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagement",
  components: {
    ProjectManagementEditModal: __WEBPACK_IMPORTED_MODULE_1__ProjectManagementEditModal___default.a,
    ScenarioEditModal: __WEBPACK_IMPORTED_MODULE_2__ScenarioEditModal___default.a,
    WaveEditModal: __WEBPACK_IMPORTED_MODULE_3__WaveEditModal___default.a
  },
  mounted: function mounted() {
    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    }
    this.getEditProjectDialogSelectData();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#projects-top-panel").height() + $("#app-navbar").height() +
        // $(".main-table > thead").height() +
        47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/projectManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedProject = this.$store.getters["sharedFilters/project"];
      this.filterStrings.ProjectName = storedProject.ProjectName || "";

      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/projectManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedProject = this.$store.getters["sharedFilters/project"];
      if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
        this.$store.commit("sharedFilters/project", {
          ProjectName: this.filterStrings.ProjectName
        });
      }
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },

    // Gets executed after the editProjectDialog successfully saved some data
    onEditProjectDialogDataSaved: function onEditProjectDialogDataSaved(newProjectData) {
      this.getProjectData(); // Refresh datatable
      if (newProjectData.ProjectId) {
        this.selectedProjectData = newProjectData;
        this.selectedProject = newProjectData.ProjectId;
        this.clientOfSelectedProject = newProjectData.ClientId;
      }
    },


    // Gets executed after the editProjectDialog got closed
    onEditProjectDialogClosed: function onEditProjectDialogClosed() {
      this.showEditProjectDialog = false;
    },
    onEditScenarioDialogClosed: function onEditScenarioDialogClosed() {
      this.showEditScenarioDialog = false;
    },
    onEditWaveDialogClosed: function onEditWaveDialogClosed() {
      this.showEditWaveDialog = false;
    },


    // Opens the security check dialog for deleting the selected project
    openDeleteProjectDialog: function openDeleteProjectDialog() {
      var _this = this;

      var objIndex = _.findIndex(this.projectData, function (o) {
        return o.ProjectId == _this.selectedProject;
      });
      this.deleteProjectDialogData = this.projectData[objIndex];
      $("#deleteProjectDialog").modal("show");
    },


    // Sends a delete request for the selected project to the server
    deleteProjectData: function deleteProjectData() {
      var _this2 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Projects/" + this.selectedProject,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          _this2.globals.showSuccessSnackbar("Project deletion successful");
          _this2.selectedProject = -1;
          _this2.getProjectData();
          $("#deleteProjectDialog").modal("hide");
        },
        error: function error() {
          console.error("Project data deletion failed in deleteProjectData()");
          _this2.globals.showErrorSnackbar("Project deletion failed");
        }
      });
    },


    // Catch client list
    getClientList: function getClientList() {
      var _this3 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this3.clientList = [];
          for (var x in data) {
            _this3.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this3.clientList.sort(function (a, b) {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this3.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },


    // Catch survey list
    getSurveyList: function getSurveyList() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/surveys",
        success: function success(data) {
          _this4.surveyList = [];
          if (!_.isEmpty(data)) _this4.surveyList = data;
        },
        error: function error() {
          console.error("Survey data access failed in getSurveyList()");
          _this4.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },


    // Catches data for dropdown lists from server
    getEditProjectDialogSelectData: function getEditProjectDialogSelectData() {
      this.getClientList();
      this.getSurveyList();
    },


    // Calculates the sort order for the given column and refreshes the displayed data
    sortProjectData: function sortProjectData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getProjectData();
    },


    // Catches project data for the table from the server, including current filter, pagination and sort settings
    getProjectData: function getProjectData() {
      var _this5 = this;

      this.refreshEnabled = false;

      var getString = "api/Projects/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this5.projectData = data[0].Projects; // If GET was successful, store project data and page count from server
          _this5.pageCount = data[0].Page_Count;
          _this5.totalElementsCount = data[0].Count;
        },
        error: function error() {
          console.error("Error on POST in getProjectData()");
          _this5.globals.showErrorSnackbar("Project data access failed");
        },
        complete: function complete() {
          _this5.refreshEnabled = true;
        }
      });
    },


    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getProjectData();
    },


    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },


    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    selectedProject: function selectedProject(newValue) {
      if (newValue < 0) {
        this.selectedProjectData = {};
        return;
      }
      if (this.selectedProjectData.ProjectId === newValue) return;
      var project = _.find(this.projectData, function (p) {
        return p.ProjectId == newValue;
      });
      if (project) this.selectedProjectData = project;
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getProjectData();
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedProject: -1, // ID of the selected project, -1 if none is selected
      selectedProjectData: {},
      clientOfSelectedProject: -1,
      pageSize: 20, // Number of projects on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showEditProjectDialog: false,
      showEditScenarioDialog: false,
      showEditWaveDialog: false,
      editProjectDialogModeAdd: true,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ProjectId: "",
        ProjectName: "",
        ClientName: "",
        ImporterName: "",
        ProjectActiveLocationsCount: "",
        ProjectTotalLocationsCount: "",
        ProjectSurveysCount: "",
        ProjectSince: "",
        ProjectCreatedBy: ""
      },
      sortField: "projectName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if project data is requested and server did not respond yet to avoid multiple requests at the same time
      projectData: [], // Stores the project data on the current page
      clientList: [], // List of all clients
      surveyList: [], // List of all surveys
      deleteProjectDialogData: {}, // Stores data for the deleteProject dialog
      invalidInputIds: [], // IDs of inputs with validation error
      lang: {
        // Contains localization strings for the selected language
        P0000: "Refresh",
        P0001: "Add project",
        P0002: "Edit",
        P0003: "Delete",
        P0004: "Search...",
        P0005: "Items per page",
        P0006: "First page",
        P0007: "Last page",
        P0008: "ProjectID",
        P0009: "Name",
        P0010: "Active locations",
        P0011: "All locations",
        P0012: "Active surveys",
        P0014: "Creation date",
        P0015: "Created by",
        P0016: "Filter",
        P0017: "Add project",
        P0018: "Edit project",
        P0019: "Delete project",
        P0020: "Do you really want to delete the following project?",
        P0021: "ProjectID",
        P0022: "Name",
        P0023: "Created at",
        P0024: "No",
        P0025: "Yes",
        P0026: "Cancel",
        P0027: "Save",
        P0028: "Scenarios",
        P0029: "Waves",
        P0030: "Client",
        P0031: "Importer",
        P0032: "Total projects count"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(32);

// Returns the current date with an offset of days
var getCurrentDate = function getCurrentDate(days) {
  var cdate = new Date();
  cdate.setDate(cdate.getDate() + days);
  cdate.setHours(0, 0, 0, 0);
  return cdate;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagementEditModal",
  components: { gantt: __WEBPACK_IMPORTED_MODULE_1__ProjectManagementGantt___default.a, Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a },
  props: ["selectedProject", "clientList", "surveyList", "showDialog", "dialogModeAdd"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      projectData: {
        Gantt: {
          data: [{
            id: uuidv4(),
            text: "",
            type: gantt.config.types.project,
            start_date: getCurrentDate(0),
            end_date: getCurrentDate(0)
          }]
        }
      }, // The project data of the selected project is stored here
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      isGanttVisible: false,
      currentScaleUnit: "week",
      selectedAssignedSurveyIds: [],
      selectedUnassignedSurveyIds: [],
      availableSurveys: [],
      fpProjectSince: null,
      fpProjectUntil: null,
      listOfProjectAccountables: {},
      briefings: [],
      surveys: [],
      importerList: [],
      departmentUsers: [],
      departmentUsersFilterString: "",
      lang: {
        P1000: "General",
        P1001: "Name",
        P1002: "This is a required entry!",
        P1003: "Client",
        P1004: "Please select...",
        P1005: "Surveys",
        P1006: "Available surveys",
        P1007: "Allocated surveys",
        P1008: "Project planning",
        P1009: "Your inputs are incorrect. Please check all fields marked in red!",
        P1010: "Cancel",
        P1011: "Save",
        P1012: "Create project",
        P1013: "Edit project",
        P1014: "Reporting visibility",
        P1015: "Start date",
        P1016: "End date",
        P1017: "Yes",
        P1018: "No",
        P1019: "Change Reporting Visibility",
        P1020: "Do you really want to make the whole survey visible in reporting?",
        P1021: "All defined security settings on user level for this survey will be lost.",
        P1022: "Project accountable",
        P1023: "File Upload",
        P1024: "Briefing",
        P1025: "Choose briefing",
        P1026: "Please choose a briefing...",
        P1027: "Download briefing",
        P1028: "Delete briefing",
        P1029: "File name",
        P1030: "Actions",
        P1031: "Survey",
        P1032: "Choose survey",
        P1033: "Please choose a survey...",
        P1034: "Download survey",
        P1035: "Delete survey",
        P1036: "Importer",
        P1037: "Responsibility",
        P1038: "Name",
        P1039: "Filter",
        P1040: "Responsible",
        P1041: "Show project history"
      }
    };
  },

  computed: {
    filteredDepartmentUsers: function filteredDepartmentUsers() {
      var _this = this;

      var result = [];
      _.forEach(this.departmentUsers, function (dep) {
        if (!dep.Employees) return;
        if (!_this.departmentUsersFilterString) {
          result.push(dep);
          return;
        }

        var filteredEmployees = _.filter(dep.Employees, function (emp) {
          return emp.DisplayName.toLowerCase().indexOf(_this.departmentUsersFilterString.toLowerCase()) > -1;
        });
        if (filteredEmployees[0]) {
          var resEntry = _.cloneDeep(dep);
          resEntry.Employees = filteredEmployees;
          result.push(resEntry);
        }
      });
      return result;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.getProjectAccountables();
    if (!this.globals.getDepartmentUsers) this.globals.getDepartmentUsers(function (callbackData) {
      _this2.departmentUsers = callbackData;
    });
    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this2.importerList = data;
      });
    }

    $("#editProjectDialog").on("hidden.bs.modal", function (e) {
      _this2.$emit("dialogClosed");
    });

    $("#editProjectDialog").on("shown.bs.modal", function () {
      gantt.render();
    });

    $("#collapseEditProjectPlanning").on("show.bs.collapse", function () {
      $("#editProjectDialog .modal-dialog").css("width", "95vw");
      _this2.isGanttVisible = true;
    });
    $("#collapseEditProjectPlanning").on("hide.bs.collapse", function () {
      $("#editProjectDialog .modal-dialog").css("width", "1200px");
      _this2.isGanttVisible = false;
    });

    $("#collapseEditProjectPlanning").on("shown.bs.collapse", function () {
      gantt.render();
    });

    // Initialize flatpickr instances
    this.fpProjectSince = flatpickr("#inputProjectSince", this.globals.flatpickrDateConfig);
    this.fpProjectUntil = flatpickr("#inputProjectUntil", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpProjectSince) this.fpProjectSince.destroy();
    if (this.fpProjectUntil) this.fpProjectUntil.destroy();
  },

  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editProjectDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditProjectDialogData();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    showProjectHistory: function showProjectHistory() {
      var config = {
        type: "Project",
        guid: this.projectData.ProjectGuid,
        id: this.projectData.ProjectId
      };
      this.globals.$emit("showElementHistory", config);
    },
    zoomGanttChart: function zoomGanttChart(zoomIn) {
      var currentUnit = gantt.config.scale_unit;
      var newUnit = "";

      switch (currentUnit) {
        case "week":
          newUnit = zoomIn ? "week" : "month";
          break;
        case "month":
          newUnit = zoomIn ? "week" : "year";
          break;
        case "year":
          newUnit = zoomIn ? "month" : "year";
          break;
        default:
          newUnit = "week";
      }

      switch (newUnit) {
        case "week":
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
          break;
        case "month":
          gantt.config.date_scale = "%M %Y";
          gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
          break;
        case "year":
          gantt.config.date_scale = "%Y";
          gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
          break;
        default:
          gantt.config.date_scale = "%F, %Y, W%W";
          gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }

      gantt.config.scale_unit = newUnit;
      this.currentScaleUnit = newUnit;
      gantt.render();
    },


    // Stores all surveys that are available for the selected client to a list and removes all selected surveys, if necessary
    filterSurveysForClient: function filterSurveysForClient(cid, removeSelectedSurveys) {
      cid = parseInt(cid);
      if (cid > -1) {
        var listObj = this.surveyList.filter(function (s) {
          return s.ClientId == cid;
        });
        this.availableSurveys = listObj.length == 0 ? [] : listObj[0].Surveys;
      } else this.availableSurveys = [];

      this.selectedAssignedSurveyIds = [];
      this.selectedUnassignedSurveyIds = [];

      if (removeSelectedSurveys) this.projectData.Surveys = [];
    },
    getAvailableSurveysForClient: function getAvailableSurveysForClient() {
      var _this3 = this;

      var request = "api/Clients/" + this.projectData.ClientId + "/AvailableSurveys";
      this.projectData.AvailableSurveys = [];
      $.ajax({
        method: "GET",
        url: request,
        success: function success(data) {
          if (data && data.AvailableSurveys) {
            _this3.projectData.AvailableSurveys = data.AvailableSurveys;
            _this3.filterSurveysForClient(_this3.projectData.ClientId, false);
          }
          _this3.filterSurveysForClient(_this3.projectData.ClientId, false);
        },
        error: function error() {
          console.error("Survey data access failed in getAvailableSurveysForClient()");
          _this3.globals.showErrorSnackbar("Survey data access failed");
        }
      });
    },


    // Shows a security modal for changing reporting visibility to avoid data loss
    surveyReportingVisibilityChanged: function surveyReportingVisibilityChanged(survey) {
      if (survey.ReportingVisibility === false) return;
      var forceReportingVisibilityChange = false;

      this.globals.$off("SurveyReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on("SurveyReportingVisibilityChangedModalYesConfirmation", function () {
        survey.ReportingVisibility = true;
        forceReportingVisibilityChange = true;
      });
      this.globals.$off("SurveyReportingVisibilityChangedModalDialogClosed");
      this.globals.$on("SurveyReportingVisibilityChangedModalDialogClosed", function () {
        if (!forceReportingVisibilityChange) survey.ReportingVisibility = false;
        forceReportingVisibilityChange = false;
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SurveyReportingVisibilityChangedModal",
        confirmationTitle: this.lang.P1019,
        colorRed: true,
        yesButtonText: this.lang.P1017,
        noButtonText: this.lang.P1018,
        htmlText: "<p><b>" + this.lang.P1020 + "</b></p>\n          <p>" + this.lang.P1021 + "</p>"
      });
    },


    // Assigns selected surveys to the project
    assignSurveys: function assignSurveys() {
      if (this.selectedUnassignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedUnassignedSurveyIds.length; i++) {
        this.projectData.Surveys.push({
          SurveyId: this.selectedUnassignedSurveyIds[i],
          ReportingVisibility: true
        });
      }
      this.selectedUnassignedSurveyIds = [];
    },


    // Unassigns selected surveys from the project
    unassignSurveys: function unassignSurveys() {
      if (this.selectedAssignedSurveyIds.length === 0) return;
      for (var i = 0; i < this.selectedAssignedSurveyIds.length; i++) {
        var index = this.getIndexOfSurveyInProjectDataSurveys(this.selectedAssignedSurveyIds[i]);
        this.projectData.Surveys.splice(index, 1);
        this.projectData.AvailableSurveys.push(this.selectedAssignedSurveyIds[i]);
      }
      this.selectedAssignedSurveyIds = [];
    },


    // Returns a list of currently assigned surveys
    getAssignedSurveys: function getAssignedSurveys() {
      var _this4 = this;

      var assignedSurveys = this.availableSurveys.filter(function (s) {
        return _.findIndex(_this4.projectData.Surveys, function (ps) {
          return s.SurveyId === ps.SurveyId;
        }) > -1;
      });
      return assignedSurveys;
    },


    // Returns a list of currently unassigned surveys
    getUnassignedSurveys: function getUnassignedSurveys() {
      var _this5 = this;

      var unassignedSurveys = this.availableSurveys.filter(function (s) {
        return _.findIndex(_this5.projectData.Surveys, function (ps) {
          return s.SurveyId === ps.SurveyId;
        }) < 0 && _.findIndex(_this5.projectData.AvailableSurveys, function (pas) {
          return s.SurveyId === pas;
        }) > -1;
      });
      return unassignedSurveys;
    },


    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem: function toggleListItem(list, id) {
      var index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(id);
    },


    // Adds a new item to the survey list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleSurveyListItem: function toggleSurveyListItem(list, id) {
      var index = _.findIndex(list, function (s) {
        return s.SurveyId === id;
      });

      if (index > -1) {
        list.splice(index, 1);
      } else list.push({ SurveyId: id, ReportingVisibility: true });
    },


    // Returns the index of a survey in the list of surveys that are attached to the project
    getIndexOfSurveyInProjectDataSurveys: function getIndexOfSurveyInProjectDataSurveys(id) {
      return _.findIndex(this.projectData.Surveys, function (s) {
        return s.SurveyId === id;
      });
    },


    // Fills the editProject dialog with data, depending on the dialog mode.
    openEditProjectDialog: function openEditProjectDialog() {
      var _this6 = this;

      this.departmentUsersFilterString = "";

      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.P1012;
        delete this.projectData.ProjectId;
        delete this.projectData.ProjectGuid;
        delete this.projectData.ProjectCreatedBy;
        delete this.projectData.ProjectName;
        delete this.projectData.ClientId;
        delete this.projectData.ImporterGuid;
        delete this.projectData.ProjectSince;
        delete this.projectData.ProjectUntil;
        delete this.projectData.ProjectActiveLocationsCount;
        delete this.projectData.ProjectTotalLocationsCount;
        delete this.projectData.ProjectSurveysCount;
        delete this.projectData.ProjectAccountableGuid;
        delete this.projectData.ProjectEmployees;

        if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers") && this.clientList[0]) {
          this.projectData.ClientId = this.clientList[0].ClientId;
          this.getAvailableSurveysForClient();
        }

        this.fpProjectUntil.clear();
        this.fpProjectSince.clear();

        this.briefings = [];
        this.surveys = [];

        this.filterSurveysForClient(-1, true);
        this.initGanttProject();
        $("#editProjectDialog").modal("show");
      } else {
        this.dialogTitle = this.lang.P1013;

        $.ajax({
          method: "GET",
          url: "api/Projects/" + this.selectedProject,
          success: function success(data) {
            if (data.Importers) {
              data.ImporterGuid = data.Importers[0].ImporterGuid;
              delete data.Importers;
            }
            _this6.projectData = data; // Store response data from server
            if (_this6.projectData.ClientId) _this6.filterSurveysForClient(data.ClientId, false);
            if (!_this6.projectData.Surveys) _this6.projectData.Surveys = [];

            if (_this6.projectData.ProjectSince) _this6.fpProjectSince.setDate(_this6.projectData.ProjectSince);else _this6.fpProjectSince.clear();
            if (_this6.projectData.ProjectUntil) _this6.fpProjectUntil.setDate(_this6.projectData.ProjectUntil);else _this6.fpProjectUntil.clear();

            if (_this6.projectData.Attachments) {
              _this6.briefings = _this6.projectData.Attachments.filter(function (attachment) {
                return attachment.AttachmentType === "Briefing";
              });
              _this6.surveys = _this6.projectData.Attachments.filter(function (attachment) {
                return attachment.AttachmentType === "Survey";
              });
            }

            gantt.clearAll();
            if (_this6.projectData.ProjectSince && _this6.projectData.ProjectUntil) {
              gantt.parse(_this6.projectData.Gantt);
              _this6.prepareGanttChart();
            } else _this6.initGanttProject();
            $("#editProjectDialog").modal("show");
          },
          error: function error() {
            console.error("Project data access failed in openEditProjectDialog()");
            _this6.globals.showErrorSnackbar("Project data access failed");
            _this6.$emit("dialogClosed");
          }
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("editProjectDialog");
    },


    // Closes the editProjectDialog
    closeEditProjectDialog: function closeEditProjectDialog() {
      $("#editProjectDialog").modal("hide");
    },


    // Opens all tasks in the current gantt dataset and sets the initial zoom depending on the project duration
    prepareGanttChart: function prepareGanttChart() {
      var gData = this.projectData.Gantt.data;
      for (var i = 0; i < gData.length; i++) {
        if (gData[i].type != gantt.config.types.scenario && gantt.hasChild(gData[i].id)) {
          gantt.open(gData[i].id);
        }
      }

      var duration = (gData[0].end_date - gData[0].start_date) / (1000 * 60 * 60 * 24); // duration in days

      if (duration > 120) {
        gantt.config.scale_unit = "year";
        gantt.config.date_scale = "%Y";
        gantt.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
      } else if (duration > 30) {
        gantt.config.scale_unit = "month";
        gantt.config.date_scale = "%M %Y";
        gantt.config.subscales = [{ unit: "week", step: 1, date: "W%W" }];
      } else {
        gantt.config.scale_unit = "week";
        gantt.config.date_scale = "%F, %Y, W%W";
        gantt.config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];
      }
    },


    // Sends the data from editProject dialog to the server to store it in the database
    saveEditProjectDialogData: function saveEditProjectDialogData() {
      var _this7 = this;

      if (this.briefings.length > 0 || this.surveys.length > 0) this.projectData.Attachments = this.briefings.concat(this.surveys);else delete this.projectData.Attachments;
      var sendData = _.cloneDeep(this.projectData);
      delete sendData.Gantt;

      if (sendData.ImporterGuid) {
        sendData.Importers = [{ ImporterGuid: sendData.ImporterGuid }];
        delete sendData.ImporterGuid;
      }

      if (this.dialogModeAdd) {
        // Create new project
        $.ajax({
          method: "POST",
          url: "api/Projects",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If POST was successful, refresh displayed data and hide dialog
            _this7.globals.showSuccessSnackbar("Project creation successful");
            _this7.closeEditProjectDialog();
            // this.$emit("dialogDataSaved", data.ProjectId, sendData.ClientId);
            _this7.$emit("dialogDataSaved", data);
          },
          error: function error() {
            console.error("Error on POST in saveEditProjectDialogData()");
            _this7.globals.showErrorSnackbar("Project creation failed");
          }
        });
      } else {
        // Update existing project
        $.ajax({
          method: "PUT",
          url: "api/Projects/" + this.projectData.ProjectId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data && data.length > 0 && data[0].error) {
              console.error("Error on PUT in saveEditProjectDialogData()");
              _this7.globals.showErrorSnackbar(data[0].error);
              return;
            }
            // If PUT was successful, refresh displayed data and hide dialog
            _this7.globals.showSuccessSnackbar("Project update successful");
            _this7.closeEditProjectDialog();
            _this7.$emit("dialogDataSaved", sendData.ProjectId, sendData.ClientId);
          },
          error: function error() {
            console.error("Error on PUT in saveEditProjectDialogData()");
            _this7.globals.showErrorSnackbar("Project update failed");
          }
        });
      }
    },


    // Updates the task data after a task was updated
    updateGanttTask: function updateGanttTask(id, action, task) {
      if (action == "inserted") {
        this.projectData.Gantt.data.push(task);
      } else if (action == "updated") {
        var idx = this.projectData.Gantt.data.map(function (t) {
          return t.id;
        }).indexOf(id);
        this.projectData.Gantt.data[idx] = task;
      } else if (action == "deleted") {
        this.projectData.Gantt.data = this.projectData.Gantt.data.filter(function (t) {
          return t.id != id;
        });
      } else console.error("Error on task update in updateGanttTask()");
    },


    // Initializes the gantt project data
    initGanttProject: function initGanttProject() {
      var projectTemplate = {
        id: uuidv4(),
        text: "",
        type: gantt.config.types.project,
        start_date: getCurrentDate(0),
        end_date: getCurrentDate(1)
      };

      projectTemplate.start_date.setHours(0, 0, 0, 0);
      projectTemplate.end_date.setHours(0, 0, 0, 0);

      this.projectData.Gantt.data = [projectTemplate];

      gantt.clearAll();
      gantt.parse(this.projectData.Gantt);
      this.prepareGanttChart();
    },
    getProjectAccountables: function getProjectAccountables() {
      var _this8 = this;

      var queryString = "/api/data/ProjectAccountable";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!_.isEmpty(data)) _this8.listOfProjectAccountables = data;
        },
        error: function error() {
          console.error("Project accountables data access failed in getProjectAccountables()");
          _this8.globals.showErrorSnackbar("Project accountables data access failed");
        }
      });
    },
    onBriefingAttachmentFileChange: function onBriefingAttachmentFileChange(e) {
      var _this9 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      var attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this9.briefings.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Briefing"
        });

        _this9.globals.showSuccessSnackbar("Attachment upload successful");
        _this9.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },
    onSurveyAttachmentFileChange: function onSurveyAttachmentFileChange(e) {
      var _this10 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      var attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this10.surveys.push({
          DownloadId: data[0].DownloadId,
          FileName: attachmentFileObject.name,
          AttachmentType: "Survey"
        });

        _this10.globals.showSuccessSnackbar("Attachment upload successful");
        _this10.$forceUpdate();
      };
      this.globals.uploadFile(attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },
    removeAttachmentFile: function removeAttachmentFile(list, fileIndex) {
      list.splice(fileIndex, 1);
      this.$forceUpdate();
    },
    isEmployeeResponsible: function isEmployeeResponsible(userId) {
      if (!this.projectData.ProjectEmployees || !this.projectData.ProjectEmployees[0]) return false;
      return _.findIndex(this.projectData.ProjectEmployees, function (emp) {
        return emp.UserId == userId;
      }) > -1;
    },
    toggleEmployeeResponsibility: function toggleEmployeeResponsibility(userId) {
      if (!this.projectData.ProjectEmployees) this.projectData.ProjectEmployees = [];

      if (!this.isEmployeeResponsible(userId)) this.projectData.ProjectEmployees.push({
        UserId: userId
      });else _.remove(this.projectData.ProjectEmployees, function (emp) {
        return emp.UserId === userId;
      });

      this.$forceUpdate();
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog && (this.dialogModeAdd || this.globals.isAccessAllowed("LoopOp_Projects_Read"))) {
        this.openEditProjectDialog();
      } else {
        this.closeEditProjectDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__);
//
//
//
//


// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js";
// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_quick_info.js";
// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_csp.js";
// import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_smart_rendering.js";
// import "dhtmlx-gantt/codebase/locale/locale_de.js";
var uuidv4 = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ProjectManagementGantt",
  props: {
    tasks: {
      type: Object,
      default: function _default() {
        return { data: [], links: [] };
      }
    }
  },
  methods: {
    // Updates start date and end date of parent tasks if a child was updated
    // updateParentTaskDates(changedTask) {
    //   var parentTaskId = gantt.getParent(changedTask);
    //   if (!parentTaskId) return;

    //   // Update the parent of the changed task to fit the duration
    //   var parentTask = gantt.getTask(parentTaskId);
    //   var siblings = gantt.getChildren(parentTask.id);
    //   if (siblings.length > 0) {
    //     var minStartDate = gantt.getTask(siblings[0]).start_date;
    //     var maxEndDate = gantt.getTask(siblings[0]).end_date;

    //     for (var i = 1; i < siblings.length; i++) {
    //       if (minStartDate > gantt.getTask(siblings[i]).start_date)
    //         minStartDate = gantt.getTask(siblings[i]).start_date;
    //       if (maxEndDate < gantt.getTask(siblings[i]).end_date)
    //         maxEndDate = gantt.getTask(siblings[i]).end_date;
    //     }

    //     if (maxEndDate <= minStartDate)
    //       maxEndDate.setDate(minStartDate.getDate() + 1);

    //     parentTask.start_date = minStartDate;
    //     parentTask.end_date = maxEndDate;
    //   }
    //   gantt.updateTask(parentTask.id);
    // },

    // Updates start date and end date of children tasks if a parent was updated
    // updateChildrenTaskDates(changedTask) {
    //   var children = gantt.getChildren(changedTask.id);
    //   if (children.length < 1) return;

    //   // Update the children of the changed task to fit the duration
    //   var child;
    //   for (var i = 0; i < children.length; i++) {
    //     child = gantt.getTask(children[i]);
    //     if (child.start_date < changedTask.start_date)
    //       child.start_date = changedTask.start_date;
    //     if (child.end_date > changedTask.end_date)
    //       child.end_date = changedTask.end_date;

    //     if (child.end_date <= child.start_date)
    //       if (child.start_date == changedTask.start_date)
    //         child.end_date = gantt.date.add(child.start_date, 1, "day");
    //       else child.start_date = gantt.date.add(child.end_date, -1, "day");

    //     this.updateChildrenTaskDates(child);
    //   }
    // },

    // Deletes all children from the changed task
    deleteChildren: function deleteChildren(changedTask) {
      var children = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].getChildren(changedTask.id);
      if (children) {
        for (var i = 0; i < children.length; i++) {
          __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].deleteTask(children[i]);
          this.$emit("task-updated", children[i], "deleted");
        }
      }
    },


    // Initializes events
    $_initGanttEvents: function $_initGanttEvents() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].$_eventsInitialized) return;

      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onTemplatesReady", function () {
        // parse
        __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.xml_date = function (dateString) {
          return new Date(dateString);
        };
        // stringify
        __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.xml_format = function (date) {
          var isoDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
          return isoDate;
        };
      });

      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onTaskCreated", function (task) {
        var parentTask = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].getTask(__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].getParent(task));
        task.id = uuidv4();
        if (parentTask.type == __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.project) {
          task.type = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.wave; // Projects can only contain waves
          task.text = "New wave";
        } else if (parentTask.type == __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.wave) {
          task.type = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.scenario; // Waves can only contain scenarios
          task.text = "New scenario";
        } else return false; // No subtasks for scenarios
        return true;
      });

      // gantt.attachEvent("onTaskDblClick", id => {
      //   if (!id) return false;
      //   // There is only one project that can not be deleted
      //   if (gantt.getTask(id).type == gantt.config.types.project) return false;
      //   return true;
      // });

      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onAfterTaskAdd", function (id, task) {
        // this.updateParentTaskDates(task);

        _this.$emit("task-updated", id, "inserted", task);
        __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].render();
      });
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onAfterTaskUpdate", function (id, task) {
        if (task.type == __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.project && task.end_date <= task.start_date) task.end_date.setDate(task.start_date.getDate() + 1);

        // this.updateParentTaskDates(task);
        // this.updateChildrenTaskDates(task);

        _this.$emit("task-updated", id, "updated", task);
        __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].render();
      });
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onAfterTaskDelete", function (id, task) {
        // this.updateParentTaskDates(task);

        _this.$emit("task-updated", id, "deleted");
        __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].render();
      });

      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onBeforeTaskDelete", function (id, task) {
        _this.deleteChildren(task);
      });

      // Hide delete button for project
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onBeforeLightbox", function (id) {
        var task = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].getTask(id);

        if (task.type === "project") $(".gantt_delete_btn_set").css("display", "none");else setTimeout(function () {
          // The timeout is a workaround for no visible delete button at first opening
          $(".gantt_delete_btn_set").css("display", "block");
        }, 1);

        return true;
      });

      // Store current task to remove reportingVisibility settings later for non wave tasks
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onBeforeLightbox", function (id) {
        _this.currentLightboxTask = __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].getTask(id);
        return true;
      });
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].attachEvent("onAfterLightbox", function () {
        if (_this.currentLightboxTask.type !== "wave") delete _this.currentLightboxTask.reportingVisibility;
      });

      // gantt.attachEvent("onTaskDrag", (id, mode, task, original) => {
      //   var formatFunc = gantt.date.date_to_str("%d/%m/%Y");
      //   if (
      //     formatFunc(task.start_date) == formatFunc(gantt.getState().min_date)
      //   ) {
      //     gantt.getState().min_date = gantt.date.add(
      //       gantt.getState().min_date,
      //       -1,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().min_date);
      //   } else if (
      //     formatFunc(task.end_date) == formatFunc(gantt.getState().max_date)
      //   ) {
      //     gantt.getState().max_date = gantt.date.add(
      //       gantt.getState().max_date,
      //       2,
      //       "day"
      //     );
      //     gantt.render();
      //     gantt.showDate(gantt.getState().max_date);
      //   }
      // });

      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].$_eventsInitialized = true;
    }
  },
  mounted: function mounted() {
    this.$_initGanttEvents();
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].init(this.$refs.gantt);
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].parse(this.$props.tasks);
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.autosize = true;

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.lightbox.sections = [{
      name: "description",
      height: 70,
      map_to: "text",
      type: "textarea",
      focus: true
    }, {
      name: "time",
      height: 35,
      map_to: "auto",
      type: "time"
    }, {
      name: "rep",
      type: "checkbox",
      map_to: "reportingVisibility",
      options: [{
        key: "true",
        label: "Visible in reporting?"
      }],
      default_value: true
    }];

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.scale_unit = "week";
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.scale_height = 50;
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.date_scale = "%F, %Y, W%W";
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.subscales = [{ unit: "day", step: 1, date: "%j, %D" }];

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.show_progress = false;
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.show_links = false;
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.drag_move = false;
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.drag_resize = false;

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.columns = [{ name: "text", width: "*", tree: true, resize: true }, {
      name: "start_date",
      label: "Start date",
      template: function template(task) {
        return __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.task_date(task.start_date);
      },
      align: "center"
    }, {
      name: "end_date",
      label: "End date",
      template: function template(task) {
        return __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.task_date(__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].date.add(task.end_date, 0, "day"));
      },
      align: "center"
    }, { name: "add", label: "", width: 44 }];

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.wave = "wave";
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.scenario = "scenario";
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].locale.labels.type_wave = "New Wave";
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].locale.labels.type_scenario = "New Scenario";

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].locale.labels.section_rep = "Reporting";

    // Set checkbox state and hide checkbox for non wave tasks
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].form_blocks.checkbox.set_value = function (node, value, task) {
      node.firstChild.firstChild.checked = !!value;
      var style = task.type === "wave" ? "" : "none";
      node.style.display = style; // editor area
      node.previousSibling.style.display = style; //section header
      __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].resizeLightbox(); //correct size of lightbox
    };
    // Store checkbox state as boolean instead of string array
    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].form_blocks.checkbox.get_value = function (node, task) {
      var checked = node.firstChild.firstChild.checked;
      return checked;
    };

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.task_class = function (start, end, task) {
      if (task.type == __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.wave) {
        return "wave_task";
      }
      if (task.type == __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.types.scenario) {
        return "scenario_task";
      }
      return "";
    };

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].templates.grid_row_class = function (start, end, task) {
      if (task.$level > 1) {
        return "no_subtasks";
      }
      return "";
    };

    __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__["gantt"].config.readonly = true;
  },
  data: function data() {
    return {
      currentLightboxTask: null,
      lang: {
        date: {
          month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          day_full: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          day_short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        },
        labels: {
          new_task: "New task",
          icon_save: "Save",
          icon_cancel: "Cancel",
          icon_details: "Details",
          icon_edit: "Edit",
          icon_delete: "Delete",
          confirm_closing: "Your changes will be lost, are you sure?",
          confirm_deleting: "Task will be deleted permanently, are you sure?",

          section_description: "Description",
          section_time: "Time period",
          section_type: "Type",
          section_rep: "Reporting",

          column_text: "Task Name",
          column_start_date: "Start datee",
          column_end_date: "End datee",
          column_duration: "Duration",
          column_add: "",

          confirm_link_deleting: "Dependency will be deleted permanently, are you sure?",
          link_from: "From",
          link_to: "To",
          link_start: "Start",
          link_end: "End",

          type_task: "Task",
          type_project: "Project",
          type_milestone: "Milestone",
          type_wave: "Wave",
          type_scenario: "Scenario",

          minutes: "Minutes",
          hours: "Hours",
          days: "Days",
          weeks: "Week",
          months: "Months",
          years: "Years"
        }
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ScenarioEditDialog",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: ["showDialog", "selectedProjectData", "clientList", "selectedClientFromProject"],
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editScenarioDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("ScenarioDeleteModalYesConfirmation");
    this.globals.$on("ScenarioDeleteModalYesConfirmation", function () {
      _this.deleteSelectedScenario();
    });
  },

  watch: {
    selectedTab: function selectedTab(newValue) {
      this.tabVisibilityChanged();
      if (newValue === "assignClientTab") this.getScenariosOfSelectedClient();
    },
    showDialog: function showDialog() {
      if (this.showDialog) this.openScenarioEditDialog();else this.closeScenarioEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      scenarios: [],
      filteredScenarios: [],
      filteredClients: [],
      filterScenarioString: "",
      filterClientString: "",
      selectedClient: -1,
      selectedTab: "editScenarioTab",
      copyScenarios: false,
      unsavedAssignments: false,
      selectedScenarioDirty: false,
      selectedScenario: {
        ScenarioGuid: "",
        ScenarioName: "",
        ScenarioDescription: "",
        ScenarioLongtext: ""
      },
      selectedScenarios: [],
      scenariosOfSelectedClient: [],
      lang: {
        SC0000: "Scenario Administration",
        SC0001: "Copy",
        SC0002: "Save",
        SC0003: "Delete",
        SC0004: "Name",
        SC0005: "Description",
        SC0006: "Close",
        SC0007: "Edit scenario",
        SC0008: "Assign scenarios",
        SC0009: "Client name",
        SC0010: "New",
        SC0011: "Filter",
        SC0012: "ID",
        SC0013: "Name",
        SC0014: "Description",
        SC0015: "Delete Scenario",
        SC0016: "Do you really want to delete the following scenario?",
        SC0017: "Yes",
        SC0018: "No",
        SC0019: "Project",
        SC0020: "Client",
        SC0021: "Longtext"
      }
    };
  },

  computed: {
    nameOfSelectedClient: function nameOfSelectedClient() {
      var _this2 = this;

      if (this.selectedClient < 0) return "";
      var client = _.find(this.clientList, function (c) {
        return c.ClientId == _this2.selectedClient;
      });
      if (client) return client.ClientName;
      return "";
    }
  },
  methods: {
    saveSelectedScenario: function saveSelectedScenario() {
      var _this3 = this;

      var data = void 0,
          queryString = void 0;
      var currentScenarioIndex = _.findIndex(this.scenarios, function (s) {
        return s.ScenarioGuid === _this3.selectedScenario.ScenarioGuid;
      });
      if (currentScenarioIndex > -1) {
        // Scenario does already exist
        queryString = "api/Scenarios/" + this.selectedScenario.ScenarioGuid;
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedScenario);

        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this3.scenarios[currentScenarioIndex] = _.cloneDeep(_this3.selectedScenario);
            _this3.doFilteringScenarios();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Scenario update successful");
            _this3.selectedScenarioDirty = false;
          },
          error: function error() {
            console.error("Error on PUT in saveSelectedScenario()");
            _this3.globals.showErrorSnackbar("Scenario update failed");
          }
        });
      } else {
        // Scenario does not yet exist
        delete this.selectedScenario.ScenarioId;

        queryString = "api/Scenarios";
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedScenario);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].ScenarioId) _this3.selectedScenario.ScenarioId = data[0].ScenarioId;
              if (data[0].ScenarioGuid) _this3.selectedScenario.ScenarioGuid = data[0].ScenarioGuid;
            }
            var scenario = _.cloneDeep(_this3.selectedScenario);
            _this3.scenarios.push(scenario);
            _this3.scenariosOfSelectedClient.push(scenario.ScenarioGuid);
            _this3.selectScenario(scenario.ScenarioGuid);
            _this3.doFilteringScenarios();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Scenario update successful");
            _this3.selectedScenarioDirty = false;
          },
          error: function error() {
            console.error("Error on POST in saveSelectedScenario()");
            _this3.globals.showErrorSnackbar("Scenario update failed");
          }
        });
      }
    },
    deleteSelectedScenario: function deleteSelectedScenario() {
      var _this4 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Scenarios/" + this.selectedScenario.ScenarioGuid,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this4.globals.showSuccessSnackbar("Scenario deletion successful");
          _.remove(_this4.scenarios, function (s) {
            return s.ScenarioGuid === _this4.selectedScenario.ScenarioGuid;
          });
          _this4.createNewScenario();
          _this4.doFilteringScenarios();
        },
        error: function error() {
          console.error("Scenario deletion failed in deleteSelectedScenario()");
          _this4.globals.showErrorSnackbar("Scenario deletion failed");
        }
      });
    },
    createNewScenario: function createNewScenario() {
      this.selectedScenario = {
        ScenarioGuid: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_uuid__["v4"])(),
        ScenarioName: "",
        ClientIds: [this.selectedClient]
      };
      this.selectedScenarios = [];
      this.selectedScenarioDirty = false;
    },
    copyScenariosClicked: function copyScenariosClicked() {
      this.copyScenarios = !this.copyScenarios;
      this.selectedClient = -1;
      if (!this.copyScenarios) this.selectedScenarios = [];
    },
    getAllScenarios: function getAllScenarios() {
      var _this5 = this;

      var queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this5.scenarios = [];
          if (data && data[0]) _this5.scenarios = data;
          _this5.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getAllScenarios()");
          _this5.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    getScenariosOfSelectedClient: function getScenariosOfSelectedClient() {
      var _this6 = this;

      var queryString = "api/Clients/" + this.selectedClient + "/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (data) {
            if (_this6.selectedTab === "assignClientTab") {
              if (_this6.copyScenarios) {
                _this6.selectedScenarios = _.union(_this6.selectedScenarios, data.Scenarios);
                _this6.unsavedAssignments = true;
              } else {
                _this6.selectedScenarios = data.Scenarios || [];
                _this6.unsavedAssignments = false;
              }
            }
            if (data.Scenarios) _this6.scenariosOfSelectedClient = data.Scenarios;else _this6.scenariosOfSelectedClient = [];
          } else {
            _this6.selectedScenarios = [];
            _this6.scenariosOfSelectedClient = [];
          }
          _this6.copyScenarios = false;
          if (_this6.selectedTab === "editScenarioTab") _this6.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getScenariosOfSelectedClient()");
          _this6.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    saveScenariosOfSelectedClient: function saveScenariosOfSelectedClient() {
      var _this7 = this;

      var queryString = "api/Clients/" + this.selectedClient + "/Scenarios";
      var sendData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        Scenarios: this.selectedScenarios
      });

      $.ajax({
        method: "PUT",
        url: queryString,
        data: sendData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.globals.showSuccessSnackbar("Scenario assignment update successful");
          _this7.unsavedAssignments = false;
        },
        error: function error() {
          console.error("Error on PUT in saveScenariosOfSelectedClient()");
          _this7.globals.showErrorSnackbar("Scenario assignment update failed");
        }
      });
    },
    doFilteringScenarios: function doFilteringScenarios() {
      var _this8 = this;

      // Reset filtering when search string is empty
      if (!this.scenarios || !this.scenarios[0]) return;

      var words = this.filterScenarioString.split(" ");
      var keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      var scenarioFilter = function scenarioFilter(scenario) {
        if (_this8.selectedTab === "editScenarioTab" && _.indexOf(_this8.scenariosOfSelectedClient, scenario.ScenarioGuid) < 0) return false;

        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (scenario[key] && scenario[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },
    doFilteringClients: function doFilteringClients() {
      // Reset filtering when search string is empty
      if (!this.clientList || this.clientList.length < 1) return;
      if (!this.filterClientString) {
        this.filteredClients = this.clientList;
        return;
      }

      var words = this.filterClientString.split(" ");
      var keys = ["ClientId", "ClientName"];

      var clientFilter = function clientFilter(client) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (client[key] && client[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredClients = this.clientList.filter(clientFilter);
    },
    getScenarioData: function getScenarioData(guid) {
      var sc = _.find(this.scenarios, function (s) {
        return s.ScenarioGuid === guid;
      });
      if (sc) sc = _.cloneDeep(sc);else sc = this.selectedScenario;
      return sc;
    },
    selectScenario: function selectScenario(scenarioGuid) {
      if (this.selectedTab === "editScenarioTab") {
        this.selectedScenarios = [scenarioGuid];
        this.selectedScenarioDirty = false;
      } else {
        if (this.selectedClient < 0) return;
        var idx = _.indexOf(this.selectedScenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedScenarios, idx);
        } else {
          this.selectedScenarios.push(scenarioGuid);
        }
        this.unsavedAssignments = true;
      }

      if (this.selectedScenarios.length === 1) this.selectedScenario = this.getScenarioData(this.selectedScenarios[0]);else if (this.selectedScenarios.length < 1) this.createNewScenario();
      this.$forceUpdate();
    },
    isScenarioSelected: function isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedScenarios, scenarioGuid) > -1;
    },
    selectClient: function selectClient(id) {
      this.getScenariosOfSelectedClient(id);
    },
    isClientSelected: function isClientSelected(id) {
      return this.selectedClient == id;
    },
    openDeleteScenarioConfirmationDialog: function openDeleteScenarioConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "ScenarioDeleteModal",
        confirmationTitle: this.lang.SC0015,
        colorRed: true,
        yesButtonText: this.lang.SC0017,
        noButtonText: this.lang.SC0018,
        htmlText: "<p><b>" + this.lang.SC0016 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.SC0012 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedScenario.ScenarioId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.SC0013 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedScenario.ScenarioName + "</label>\n        </div>"
      };
    },
    tabVisibilityChanged: function tabVisibilityChanged() {
      this.selectedScenarios = [];
      this.createNewScenario();
      this.copyScenarios = false;
      this.unsavedAssignments = false;
      this.selectedScenarioDirty = false;
      this.doFilteringScenarios();
    },
    openScenarioEditDialog: function openScenarioEditDialog() {
      this.selectedClient = this.selectedClientFromProject;
      this.getScenariosOfSelectedClient();
      this.tabVisibilityChanged();
      this.getAllScenarios();
      this.doFilteringClients();
      $("#editScenarioDialog").modal("show");
    },
    closeScenarioEditDialog: function closeScenarioEditDialog() {
      $("#editScenarioDialog").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WaveStatusModal__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WaveStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WaveStatusModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Surveys__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WaveEditDialog",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a, WaveStatusModal: __WEBPACK_IMPORTED_MODULE_2__WaveStatusModal___default.a },
  props: ["showDialog", "selectedClient", "selectedProjectData"],
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }

    $("#editWaveDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("WaveDeleteModalYesConfirmation");
    this.globals.$on("WaveDeleteModalYesConfirmation", function () {
      _this.deleteSelectedWave();
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval")) this.globals.getCarModelList(function (data) {
      _this.carModelList = _.cloneDeep(data);
    });
  },
  destroyed: function destroyed() {
    if (this.fpInputWaveUntil) this.fpInputWaveUntil.destroy();
    if (this.fpInputWaveSince) this.fpInputWaveSince.destroy();
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openWaveEditDialog();else this.closeWaveEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.initFlatpickr();
    }
  },
  data: function data() {
    return {
      waves: [],
      wavePositions: [],
      scenarios: [],
      filteredWaves: [],
      filteredScenarios: [],
      carModelList: [],
      filterWaveString: "",
      filterScenarioString: "",
      selectedTab: "editWaveTab",
      selectedWave: {},
      selectedWaveDirty: false,
      wavePositionsDirty: false,
      scenariosOfClient: [],
      fpInputWaveUntil: null,
      fpInputWaveSince: null,
      forceReportingVisibilityChange: false,
      surveyList: [],
      lang: {
        WV0000: "Wave Administration",
        WV0001: "Filter",
        WV0002: "ID",
        WV0003: "Name",
        WV0004: "Start date",
        WV0005: "End date",
        WV0006: "Edit wave",
        WV0007: "Assign scenarios",
        WV0008: "Reporting Visibility",
        WV0009: "New",
        WV0010: "Save",
        WV0011: "Delete",
        WV0012: "ID",
        WV0013: "Name",
        WV0014: "Description",
        WV0015: "Close",
        WV0016: "Yes",
        WV0017: "No",
        WV0018: "Delete Wave",
        WV0019: "Do you really want to delete the following wave?",
        WV0020: "Period of time",
        WV0021: "Change Reporting Visibility",
        WV0022: "Do you really want to make the whole wave visible in reporting?",
        WV0023: "All defined security settings on user level for this wave will be lost.",
        WV0024: "Project",
        WV0025: "Client",
        WV0026: "Save positions",
        WV0027: "Position",
        WV0028: "Cost center",
        WV0029: "Audi cars",
        WV0030: "Model",
        WV0031: "Share",
        WV0032: "Overall share values exceed 100%",
        WV0033: "Info",
        WV0034: "Status",
        WV0035: "Competitor Cars",
        WV0036: "Actions",
        WV0037: "Add model",
        WV0038: "Empty model already exists",
        WV0039: "Shortname",
        WV0040: "No master survey"
      }
    };
  },

  methods: {
    // Initialize flatpickr instances
    initFlatpickr: function initFlatpickr() {
      this.fpInputWaveSince = flatpickr("#inputWaveStartDate", this.globals.flatpickrDateConfig);
      this.fpInputWaveUntil = flatpickr("#inputWaveEndDate", this.globals.flatpickrDateConfig);
    },
    readCarModelDistributionFromSelectedWave: function readCarModelDistributionFromSelectedWave() {
      var _this2 = this;

      this.clearCarModelDistribution();

      if (!this.selectedWave.CarModelDistribution) return;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var waveEntry = _step.value;

          var modelListEntry = _.find(_this2.carModelList, function (model) {
            return model.CarModelGuid === waveEntry.CarModelGuid;
          });
          if (modelListEntry) modelListEntry.Distribution = waveEntry.Distribution * 100;
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CarModelDistribution), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    storeCarModelDistributionToSelectedWave: function storeCarModelDistributionToSelectedWave() {
      var sum = 0;
      this.selectedWave.CarModelDistribution = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var entry = _step2.value;

          if (entry.Distribution) {
            sum += entry.Distribution;
            this.selectedWave.CarModelDistribution.push({
              CarModelGuid: entry.CarModelGuid,
              Distribution: entry.Distribution / 100
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.selectedWave.CarModelDistribution.length < 1) delete this.selectedWave.CarModelDistribution;

      if (sum > 100) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error("Overall car model distribution values for this wave exceed 100%");
        return false;
      }
      return true;
    },
    clearCarModelDistribution: function clearCarModelDistribution() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.carModelList), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var entry = _step3.value;
          delete entry.Distribution;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    addCompetitorCarModel: function addCompetitorCarModel() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CompetitorCarModelDistribution), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var entry = _step4.value;

          if (!entry.CompetitorCarModel) {
            this.globals.showErrorSnackbar(this.lang.WV0038);
            console.error("Empty competitor model already existis");
            return;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.selectedWave.CompetitorCarModelDistribution.push({});
      this.$forceUpdate();
    },
    deleteCompetitorCarModel: function deleteCompetitorCarModel(index) {
      _.pullAt(this.selectedWave.CompetitorCarModelDistribution, index);
      this.$forceUpdate();
    },
    validateDistributionValue: function validateDistributionValue(model, type) {
      var lowerLimit = 0,
          upperLimit = 100;
      if (type === "competitor") upperLimit = 1;

      if (typeof model.Distribution !== "number" || model.Distribution < lowerLimit) model.Distribution = lowerLimit;else if (model.Distribution > upperLimit) model.Distribution = upperLimit;

      this.$forceUpdate();
    },
    validateCompetitorCarModelDistribution: function validateCompetitorCarModelDistribution() {
      if (this.selectedWave.CompetitorCarModelDistribution.length < 1) {
        delete this.selectedWave.CompetitorCarModelDistribution;
        return;
      }

      var sum = 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedWave.CompetitorCarModelDistribution), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var model = _step5.value;

          sum += model.Distribution || 0;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (sum > 1) {
        this.globals.showErrorSnackbar(this.lang.WV0032);
        console.error("Overall competitor model distribution values for this wave exceed 100%");
        return false;
      }
    },
    showWaveStatus: function showWaveStatus() {
      var config = {
        guid: this.selectedWave.WaveGuid,
        id: this.selectedWave.WaveId
      };
      this.globals.$emit("showWaveStatus", config);
    },
    saveSelectedWave: function saveSelectedWave() {
      var _this3 = this;

      if (this.carModelList.length > 0 && !this.storeCarModelDistributionToSelectedWave()) {
        return;
      }
      if (this.selectedWave.CompetitorCarModelDistribution && this.validateCompetitorCarModelDistribution() === false) {
        return;
      }
      if (isNaN(parseInt(this.selectedWave.MasterSurvey))) {
        this.selectedWave.MasterSurvey = null;
      }
      var data = void 0,
          queryString = void 0;
      var currentWaveIndex = _.findIndex(this.waves, function (w) {
        return w.WaveGuid === _this3.selectedWave.WaveGuid;
      });
      if (this.selectedWave.WaveSince >= this.selectedWave.WaveUntil) {
        this.globals.showErrorSnackbar("Start >= End");
        return;
      } else if (currentWaveIndex > -1) {
        // Wave does already exist
        queryString = "api/ProjectWaves/" + this.selectedWave.WaveGuid;
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedWave);

        $.ajax({
          method: "PUT",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (!_this3.selectedWave.CompetitorCarModelDistribution) _this3.selectedWave.CompetitorCarModelDistribution = [];
            if (!_this3.selectedWave.MasterSurvey) {
              _this3.selectedWave.MasterSurvey = null;
            }
            _this3.waves[currentWaveIndex] = _.cloneDeep(_this3.selectedWave);
            _this3.doFilteringWaves();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Wave update successful");
            _this3.selectedWaveDirty = false;
          },
          error: function error() {
            console.error("Error on PUT in saveSelectedWave()");
            _this3.globals.showErrorSnackbar("Wave update failed");
          }
        });
      } else {
        // Wave does not yet exist
        delete this.selectedWave.WaveId;
        this.selectedWave.WaveGuid = uuidv4();

        queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";
        data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.selectedWave]);

        $.ajax({
          method: "POST",
          url: queryString,
          data: data,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this3.globals.showErrorSnackbar(data.Error);
              return;
            }
            if (data[0]) {
              if (data[0].WaveId) _this3.selectedWave.WaveId = data[0].WaveId;
              if (data[0].WaveGuid) _this3.selectedWave.WaveGuid = data[0].WaveGuid;
              if (data[0].WavePosition) _this3.selectedWave.WavePosition = data[0].WavePosition;
            }
            if (!_this3.selectedWave.CompetitorCarModelDistribution) _this3.selectedWave.CompetitorCarModelDistribution = [];
            var wave = _.cloneDeep(_this3.selectedWave);
            _this3.waves.push(wave);
            _this3.doFilteringWaves();
            _this3.$forceUpdate();
            _this3.globals.showSuccessSnackbar("Wave update successful");
            _this3.selectedWaveDirty = false;
          },
          error: function error() {
            console.error("Error on POST in saveSelectedWave()");
            _this3.globals.showErrorSnackbar("Wave update failed");
          }
        });
      }
    },
    saveWavePositions: function saveWavePositions() {
      var _this4 = this;

      var queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";

      this.readWavePositions();
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.wavePositions);

      $.ajax({
        method: "PUT",
        url: queryString,
        data: data,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Wave position update successful");
          _this4.wavePositionsDirty = false;
        },
        error: function error() {
          console.error("Error on PUT in saveWavePositions()");
          _this4.globals.showErrorSnackbar("Wave position update failed");
        }
      });
    },
    deleteSelectedWave: function deleteSelectedWave() {
      var _this5 = this;

      $.ajax({
        method: "DELETE",
        url: "api/ProjectWaves/" + this.selectedWave.WaveGuid,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this5.globals.showSuccessSnackbar("Wave deletion successful");
          _.remove(_this5.waves, function (w) {
            return w.WaveGuid === _this5.selectedWave.WaveGuid;
          });
          _this5.createNewWave();
          _this5.closeWavePositionGap();
          _this5.doFilteringWaves();
        },
        error: function error() {
          console.error("Wave deletion failed in deleteSelectedWave()");
          _this5.globals.showErrorSnackbar("Wave deletion failed");
        }
      });
    },
    createNewWave: function createNewWave() {
      this.selectedWave = {
        WaveGuid: uuidv4(),
        ReportingVisibility: true,
        Scenarios: []
      };
      this.fpInputWaveUntil.clear();
      this.fpInputWaveSince.clear();
      this.clearCarModelDistribution();
      if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval")) this.selectedWave.CompetitorCarModelDistribution = [];
      this.selectedWaveDirty = false;
    },
    getAllWaves: function getAllWaves() {
      var _this6 = this;

      var queryString = "api/Projects/" + this.selectedProjectData.ProjectGuid + "/Waves";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data || _.isEmpty(data)) {
            _this6.waves = [];
            return;
          }
          _this6.waves = data;
          _this6.sortWavesByPosition();
          _this6.doFilteringWaves();
        },
        error: function error() {
          console.error("Error on GET in getAllWaves()");
          _this6.globals.showErrorSnackbar("Wave request failed");
        }
      });
    },
    getAllScenarios: function getAllScenarios() {
      var _this7 = this;

      var queryString = "api/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this7.scenarios = data;
          _this7.getScenariosOfClient();
        },
        error: function error() {
          console.error("Error on GET in getAllScenarios()");
          _this7.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    getScenariosOfClient: function getScenariosOfClient() {
      var _this8 = this;

      var queryString = "/api/Clients/" + this.selectedClient + "/Scenarios";
      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this8.scenarios = _this8.scenarios.filter(function (sc) {
            return _.indexOf(data.Scenarios, sc.ScenarioGuid) < 0 ? false : true;
          });
          _this8.doFilteringScenarios();
        },
        error: function error() {
          console.error("Error on GET in getScenariosOfClient()");
          _this8.globals.showErrorSnackbar("Scenario request failed");
        }
      });
    },
    doFilteringWaves: function doFilteringWaves() {
      // Reset filtering when search string is empty
      if (!this.waves || this.waves.length < 1) return;
      if (!this.filterWaveString) {
        this.filteredWaves = this.waves;
        return;
      }

      var words = this.filterWaveString.split(" ");
      var keys = ["WaveId", "WaveName", "WaveStart", "WaveEnd"];

      var waveFilter = function waveFilter(wave) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (wave[key] && wave[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredWaves = this.waves.filter(waveFilter);
    },
    reorderWaves: function reorderWaves() {
      var allPositions = _.range(1, this.waves.length + 1);
      var missingPos = 0;
      var newPos = 0;
      var waveGuid = "";

      // Find missing position number and the position and name of the changed wave
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WavePosition != allPositions[i]) {
          missingPos = allPositions[i];
          newPos = this.waves[i].WavePosition;
          waveGuid = this.waves[i].WaveGuid;
        }
      }
      if (missingPos == 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.waves[i].WaveGuid != waveGuid) {
          // Do NOT move the changed wave
          if (this.waves[i].WavePosition < missingPos && this.waves[i].WavePosition >= newPos) {
            this.waves[i].WavePosition++;
          }
          if (this.waves[i].WavePosition > missingPos && this.waves[i].WavePosition <= newPos) {
            this.waves[i].WavePosition--;
          }
        }
      }
      this.sortWavesByPosition();
      this.$forceUpdate(); // Forces the table to update
    },
    closeWavePositionGap: function closeWavePositionGap() {
      if (this.waves.length < 1) return;
      this.waves[0].WavePosition = 1;
      for (var i = 1; i < this.waves.length; i++) {
        // Closes gap
        if (this.waves[i].WavePosition > this.waves[i - 1].WavePosition + 1) this.waves[i].WavePosition--;
        // Fixes double wave positions
        if (this.waves[i].WavePosition == this.waves[i - 1].WavePosition) this.waves[i].WavePosition++;
      }
    },
    sortWavesByPosition: function sortWavesByPosition() {
      if (!this.waves) return;
      this.waves.sort(function (a, b) {
        return a.WavePosition - b.WavePosition;
      });
    },
    readWavePositions: function readWavePositions() {
      this.wavePositions = [];
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.waves), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var wave = _step6.value;

          this.wavePositions.push({
            WaveGuid: wave.WaveGuid,
            WavePosition: wave.WavePosition
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },
    doFilteringScenarios: function doFilteringScenarios() {
      // Reset filtering when search string is empty
      if (!this.scenarios || this.scenarios.length < 1) return;
      if (!this.filterScenarioString) {
        this.filteredScenarios = this.scenarios;
        return;
      }

      var words = this.filterScenarioString.split(" ");
      var keys = ["ScenarioId", "ScenarioName", "ScenarioDescription"];

      var scenarioFilter = function scenarioFilter(scenario) {
        var containsSearch = false;
        words.forEach(function (word) {
          keys.forEach(function (key) {
            if (scenario[key] && scenario[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredScenarios = this.scenarios.filter(scenarioFilter);
    },
    selectWave: function selectWave(WaveGuid) {
      var wave = this.waves.find(function (w) {
        return w.WaveGuid === WaveGuid;
      });
      if (wave) {
        this.selectedWave = _.cloneDeep(wave);
        if (this.carModelList.length > 0) this.readCarModelDistributionFromSelectedWave();
        if (this.feature.isAudiTarget && this.feature.isEnabled("shopperApproval") && !this.selectedWave.CompetitorCarModelDistribution) this.selectedWave.CompetitorCarModelDistribution = [];
        this.fpInputWaveSince.setDate(this.selectedWave.WaveSince);
        this.fpInputWaveUntil.setDate(this.selectedWave.WaveUntil);
        this.selectedWaveDirty = false;
      } else this.createNewWave();
    },
    isWaveSelected: function isWaveSelected(WaveGuid) {
      return this.selectedWave.WaveGuid === WaveGuid;
    },
    selectScenario: function selectScenario(scenarioGuid) {
      if (!this.selectedWave.WaveId) return;
      if (!this.selectedWave.Scenarios) this.selectedWave.Scenarios = [scenarioGuid];else {
        var idx = _.indexOf(this.selectedWave.Scenarios, scenarioGuid);
        if (idx > -1) {
          _.pullAt(this.selectedWave.Scenarios, idx);
        } else {
          this.selectedWave.Scenarios.push(scenarioGuid);
        }
      }
      this.selectedWaveDirty = true;
      this.$forceUpdate();
    },
    isScenarioSelected: function isScenarioSelected(scenarioGuid) {
      return _.indexOf(this.selectedWave.Scenarios, scenarioGuid) > -1;
    },
    openDeleteWaveConfirmationDialog: function openDeleteWaveConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      return {
        initiator: "WaveDeleteModal",
        confirmationTitle: this.lang.WV0018,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: "<p><b>" + this.lang.WV0019 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0002 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedWave.WaveId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0003 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.selectedWave.WaveName + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-3 text-black\">" + this.lang.WV0020 + "</label>\n          <label class=\"col-md-9 text-black\">" + this.globals.getLocalizedDateFromIsoTimestamp(this.selectedWave.WaveSince) + " - " + this.globals.getLocalizedDateFromIsoTimestamp(this.selectedWave.WaveUntil) + "</label>\n        </div>"
      };
    },
    openWaveEditDialog: function openWaveEditDialog() {
      var _this9 = this;

      this.wavePositionsDirty = false;
      this.filteredWaves = [];
      this.createNewWave();
      this.getAllWaves();
      this.getAllScenarios();
      __WEBPACK_IMPORTED_MODULE_3__services_Surveys__["a" /* default */].getAll({
        ProjectGuid: this.selectedProjectData.ProjectGuid
      }, null // set page_size null to get unlimited page_size
      ).then(function (_ref) {
        var data = _ref.data;

        _this9.surveyList = data[0].Surveys;
      });
      $("#editWaveDialog").modal("show");
    },
    closeWaveEditDialog: function closeWaveEditDialog() {
      $("#editWaveDialog").modal("hide");
    },
    waveReportingVisibilityChanged: function waveReportingVisibilityChanged(wave) {
      if (wave.ReportingVisibility === false) return;
      var forceReportingVisibilityChange = false;

      this.globals.$off("WaveReportingVisibilityChangedModalYesConfirmation");
      this.globals.$on("WaveReportingVisibilityChangedModalYesConfirmation", function () {
        wave.ReportingVisibility = true;
        forceReportingVisibilityChange = true;
      });
      this.globals.$off("WaveReportingVisibilityChangedModalDialogClosed");
      this.globals.$on("WaveReportingVisibilityChangedModalDialogClosed", function () {
        if (!forceReportingVisibilityChange) wave.ReportingVisibility = false;
        forceReportingVisibilityChange = false;
      });
      this.openReportingVisibilityChangedDialog();
    },
    openReportingVisibilityChangedDialog: function openReportingVisibilityChangedDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getReportingVisibilityChangedDialogData());
    },
    getReportingVisibilityChangedDialogData: function getReportingVisibilityChangedDialogData() {
      return {
        initiator: "WaveReportingVisibilityChangedModal",
        confirmationTitle: this.lang.WV0021,
        colorRed: true,
        yesButtonText: this.lang.WV0016,
        noButtonText: this.lang.WV0017,
        htmlText: "<p><b>" + this.lang.WV0022 + "</b></p>\n        <p>" + this.lang.WV0023 + "</p>"
      };
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "WaveStatusModal",
  data: function data() {
    return {
      elementId: 0,
      statusData: {},
      lang: {
        WVS000: "Wave Status",
        WVS001: "Check Status",
        WVS002: "Total check count",
        WVS003: "In approval",
        WVS004: "In progress",
        WVS005: "In reporting",
        WVS006: "In time",
        WVS007: "Approvals",
        WVS008: "Without proposals",
        WVS009: "With proposals",
        WVS010: "Approved",
        WVS011: "Rejected",
        WVS012: "Audi Cars",
        WVS013: "Model",
        WVS014: "Target value",
        WVS015: "Current value",
        WVS016: "Close",
        WVS017: "Wave status request failed",
        WVS018: "Competitor cars"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showWaveStatus");
    this.globals.$on("showWaveStatus", function (config) {
      _this.getWaveStatus(config);
    });
  },

  methods: {
    openModal: function openModal() {
      $("#waveStatusModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#waveStatusModal").modal("hide");
    },
    getWaveStatus: function getWaveStatus(config) {
      var _this2 = this;

      if (!config) return;
      var query = "api/ProjectWaves/" + config.guid + "/Status";
      this.elementId = config.id;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this2.statusData = data;
          _this2.openModal();
        },
        error: function error(_error) {
          console.error("Error on GET in getWaveStatus()");
          _this2.globals.showErrorSnackbar(_this2.lang.WVS017);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var uuidv4 = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckFilter",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Tools_Select2___default.a
  },
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    locationPropertiesList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    countryList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    regionList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    locationList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      selectedClient: "",
      selectedProject: "",
      selectedWave: "",
      selectedImporter: "",
      clientList: [],
      importerList: [],
      projectList: [],
      waveList: [],
      scenarioList: [],
      // cityLists: [],
      dynamicFilters: [],
      filterTypes: ["Country", "Region", "City", "PostalCode", "Location", "LocationProperty", "Scenario", "Status", "Check"],
      recruitingStatusList: ["NOT_ASSIGNED", "ASSIGNED_WITH_ANSWER", "ASSIGNED_NO_ANSWER"],
      resultCheckData: {},
      lang: {
        RCC000: "Check filter",
        RCC001: "Available Checks",
        RCC002: "Client",
        RCC003: "Project",
        RCC004: "Wave",
        RCC005: "Choose",
        RCC006: "Type of filter",
        RCC007: "Select values",
        RCC008: "Add filter",
        RCC009: "Check data request failed",
        RCC010: "City data request failed",
        RCC011: "City",
        RCC012: "Country",
        RCC013: "Location property",
        RCC014: "Scenario",
        RCC015: "Status",
        RCC016: "Not assigned",
        RCC017: "Edited",
        RCC018: "Assigned but not edited",
        RCC019: "Please type in a value",
        RCC020: "Postal code",
        RCC021: "The maximum count of checks that can be shown on the map is exceeded. If you want to see all results on the map, please define some more filters.",
        RCC022: "Importer",
        RCC023: "Region",
        RCC024: "Location",
        RCC025: "Check",
        RCC026: "No regions available"
      }
    };
  },

  computed: {
    projectsOfSelectedClient: function projectsOfSelectedClient() {
      var _this = this;

      var entry = _.find(this.projectList, function (el) {
        return el.ClientGuid === _this.selectedClient;
      });
      if (entry && entry.Projects) return entry.Projects;
      return [];
    },
    wavesOfSelectedProject: function wavesOfSelectedProject() {
      var _this2 = this;

      var entry = _.find(this.waveList, function (el) {
        return el.ProjectGuid === _this2.selectedProject;
      });
      if (entry && entry.Waves) return entry.Waves;
      return [];
    },
    scenariosOfSelectedWave: function scenariosOfSelectedWave() {
      var _this3 = this;

      var entry = _.find(this.scenarioList, function (el) {
        return el.WaveGuid === _this3.selectedWave;
      });
      if (entry && entry.Scenarios) return entry.Scenarios;
      return [];
    },
    checkCountExceeded: function checkCountExceeded() {
      if (!this.resultCheckData || _.isEmpty(this.resultCheckData) || !this.resultCheckData.SurveyInstances) return false;
      return this.resultCheckData.SurveyInstanceCount > this.resultCheckData.SurveyInstances.length;
    },

    // isCountryFilterDefined() {
    //   for (let filter of this.dynamicFilters) {
    //     if (
    //       filter.Type === "Country" &&
    //       filter.Value &&
    //       filter.Value.length > 0
    //     )
    //       return true;
    //   }
    //   return false;
    // }
    regionsFiltered: function regionsFiltered() {
      var _this4 = this;

      var filteredRegionsList = [];

      var countryFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Country"
      });
      if (countryFilterIndex > -1) {
        // filter regions on multiple countries
        this.dynamicFilters[countryFilterIndex].Value.forEach(function (countryCode) {
          filteredRegionsList = _.union(filteredRegionsList, _this4.getRegionsByCountryCode(countryCode));
        });

        // order regions alphabetic
        if (filteredRegionsList) filteredRegionsList = _.sortBy(filteredRegionsList, [function (o) {
          return o.RegionName;
        }]);
      }
      // // check if selected region in regions of selected countries
      var regionFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Region"
      });
      if (regionFilterIndex > -1 && this.dynamicFilters[regionFilterIndex].Value) {
        this.dynamicFilters[regionFilterIndex].Value = this.dynamicFilters[regionFilterIndex].Value.filter(function (value) {
          return _.findIndex(filteredRegionsList, function (cDFV) {
            return cDFV.RegionGuid === value;
          }) >= 0;
        });
      }

      return filteredRegionsList;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
    },
    selectedClient: function selectedClient(newClient) {
      if (!this.$filterRestorePending) this.selectedProject = "";
      this.getLocationProperties();
      // this.getLocationsOfClient();
    },
    selectedProject: function selectedProject() {
      if (!this.$filterRestorePending) this.selectedWave = "";
    },
    selectedWave: function selectedWave(newGuid) {
      var _this5 = this;

      if (!this.$filterRestorePending) _.forEach(this.dynamicFilters, function (f) {
        if (f.Type === "Scenario") {
          delete f.Value;
          f.currentDynamicFilterValues = _this5.scenariosOfSelectedWave;
        }
      });

      if (newGuid) this.getCheckFilterResult();else this.resultCheckData = {};
    },
    resultCheckData: function resultCheckData(newData) {
      this.$emit("checkDataChanged", newData);
    }
  },
  created: function created() {
    this.debouncedUpdateSelect2Data = _.debounce(this.updateSelect2Data, 500);
  },
  mounted: function mounted() {
    var _this6 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
    var clientListPromise = this.globals.getClientList();
    clientListPromise.then(function (data) {
      _this6.clientList = data;
      if (_this6.feature.isAudiTarget && _this6.feature.isEnabled("audi_importers") && _this6.clientList[0]) _this6.selectedClient = _this6.clientList[0].ClientGuid;
      _this6.$emit("ClientListReceived");
    });
    this.globals.getProjectList(function (data) {
      _this6.projectList = data;
      _this6.$emit("ProjectListReceived");
    });
    this.globals.getWaveList(function (data) {
      _this6.waveList = data;
      _this6.$emit("WaveListReceived");
    });
    this.globals.getScenarioList(function (data) {
      _this6.scenarioList = data;
      _this6.$emit("ScenarioListReceived");
    });

    if (this.feature.isAudiTarget && this.feature.isEnabled("audi_importers")) {
      this.globals.getImporterList(function (data) {
        _this6.importerList = data;
        _this6.$emit("ImporterListReceived");
      });
    }
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
  },

  methods: {
    filterSubvalueChanged: function filterSubvalueChanged(value, filter) {
      filter.Subvalue = value;
      this.getCheckFilterResult();
    },
    filterValueChanged: function filterValueChanged(value, filter) {
      filter.Value = value;
      this.dynamicFilterValueChanged(filter);
    },
    filterTypeChanged: function filterTypeChanged(value, filter) {
      filter.Type = value;
      this.dynamicFilterTypeChanged(filter);
    },
    selectedImporterChanged: function selectedImporterChanged() {
      this.selectedWave && this.getCheckFilterResult();
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this7 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;

      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        _this7.$nextTick(function () {
          delete _this7.$filterRestorePending;
          _this7.debouncedUpdateSelect2Data();
        });
      };

      var restoreFilters = function restoreFilters() {
        _this7.$nextTick(function () {
          var storedData = _this7.$store.getters["localFilters/recruiting_checkFilter"];
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this7, key)) _this7[key] = _.cloneDeep(storedData[key]);
            }
          }

          if (!_this7.$store.getters["userSettings/syncFilters"]) {
            restoreDone();
            return;
          }
          if (!_this7.feature.isAudiTarget || !_this7.feature.isEnabled("audi_importers")) {
            var storedClient = _this7.$store.getters["sharedFilters/client"];
            if (_this7.selectedClient !== storedClient.ClientGuid) {
              _this7.selectedWave = "";
              _this7.dynamicFilters = [];
            }
            _this7.selectedClient = storedClient.ClientGuid || "";
          } else {
            var storedImporter = _this7.$store.getters["sharedFilters/importer"];
            _this7.selectedImporter = storedImporter.ImporterGuid || "";
          }

          var storedProject = _this7.$store.getters["sharedFilters/project"];
          if (_this7.selectedProject !== storedProject.ProjectGuid) {
            _this7.selectedWave = "";
            _this7.dynamicFilters = [];
          }
          _this7.selectedProject = storedProject.ProjectGuid || "";

          restoreDone();
        });
      };

      var eventsToWaitFor = ["ClientListReceived", "ProjectListReceived", "WaveListReceived", "ScenarioListReceived"];

      if (this.feature.isAudiTarget) eventsToWaitFor.push("ImporterListReceived");

      if (this.countryList.length < 1) {
        eventsToWaitFor.push("CountryListReceived");
        this.$parent.$once("CountryListReceived", function () {
          return _this7.$emit("CountryListReceived");
        });
      }

      if (this.regionList.length < 1) {
        eventsToWaitFor.push("RegionListReceived");
        this.$parent.$once("RegionListReceived", function () {
          _this7.$emit("RegionListReceived");
        });
      }

      if (this.selectedClient && this.locationList.length < 1) {
        eventsToWaitFor.push("LocationsReceived");
        this.$parent.$once("LocationsReceived", function () {
          return _this7.$emit("LocationsReceived");
        });
      }

      if (this.selectedClient && this.locationPropertiesList.length < 1) {
        eventsToWaitFor.push("LocationPropertiesReceived");
        this.$parent.$once("LocationPropertiesReceived", function () {
          return _this7.$emit("LocationPropertiesReceived");
        });
      }

      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      var _this8 = this;

      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/recruiting_checkFilter", {
        selectedClient: this.selectedClient,
        selectedImporter: this.selectedImporter,
        selectedProject: this.selectedProject,
        selectedWave: this.selectedWave,
        dynamicFilters: this.dynamicFilters
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        if (this.selectedClient) {
          var client = _.find(this.clientList, function (c) {
            return c.ClientGuid === _this8.selectedClient;
          });
          if (client) this.$store.commit("sharedFilters/client", client);
        } else {
          var storedClient = this.$store.getters["sharedFilters/client"];
          if (storedClient.ClientGuid) this.$store.commit("sharedFilters/client");
        }
      } else {
        if (this.selectedImporter) {
          var importer = _.find(this.importerList, function (i) {
            return i.ImporterGuid === _this8.selectedImporter;
          });
          if (importer) this.$store.commit("sharedFilters/importer", importer);
        } else {
          var storedImporter = this.$store.getters["sharedFilters/importer"];
          if (storedImporter.ImporterGuid) this.$store.commit("sharedFilters/importer");
        }
      }

      if (this.selectedProject) {
        var project = _.find(this.projectsOfSelectedClient, function (p) {
          return p.ProjectGuid === _this8.selectedProject;
        });
        if (project) this.$store.commit("sharedFilters/project", project);
      } else {
        var storedProject = this.$store.getters["sharedFilters/project"];
        if (storedProject.ProjectGuid) this.$store.commit("sharedFilters/project");
      }
    },
    updateSelect2Data: function updateSelect2Data() {
      var _this9 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var filter = _step.value;

          if (filter.Type === "Country") filter.currentDynamicFilterValues = _this9.countryList;else if (filter.Type === "Status") filter.currentDynamicFilterValues = _this9.recruitingStatusList;else if (filter.Type === "LocationProperty") filter.currentDynamicFilterValues = _this9.locationPropertiesList;else if (filter.Type === "Scenario") {
            filter.currentDynamicFilterValues = _this9.scenariosOfSelectedWave;
            if (filter.Value) _.remove(filter.Value, function (selectedValue) {
              return _.findIndex(filter.currentDynamicFilterValues, function (val) {
                return val.ScenarioGuid === selectedValue;
              }) < 0;
            });
          }
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$forceUpdate();

      this.$nextTick(function () {
        for (var refName in _this9.$refs) {
          if (_this9.$refs[refName][0]) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this9.$refs[refName]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _component = _step2.value;

                if (_component.reinit) _component.reinit();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (_this9.$refs[refName].reinit) _this9.$refs[refName].reinit();
        }
      });

      this.getCheckFilterResult();
    },
    updateSelect2Values: function updateSelect2Values() {
      for (var refName in this.$refs) {
        if (this.$refs[refName][0]) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$refs[refName]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _component2 = _step3.value;

              if (_component2.updateValue) _component2.updateValue();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else if (this.$refs[refName].updateValue) this.$refs[refName].updateValue();
      }
    },
    getTranslationFor: function getTranslationFor(text) {
      switch (text) {
        case "City":
          return this.lang.RCC011;
        case "Country":
          return this.lang.RCC012;
        case "Region":
          return this.lang.RCC023;
        case "PostalCode":
          return this.lang.RCC020;
        case "LocationProperty":
          return this.lang.RCC013;
        case "Location":
          return this.lang.RCC024;
        case "Scenario":
          return this.lang.RCC014;
        case "Status":
          return this.lang.RCC015;
        case "NOT_ASSIGNED":
          return this.lang.RCC016;
        case "ASSIGNED_WITH_ANSWER":
          return this.lang.RCC017;
        case "ASSIGNED_NO_ANSWER":
          return this.lang.RCC018;
        case "Check":
          return this.lang.RCC025;
      }
      return text;
    },
    clearCheckFilter: function clearCheckFilter() {
      if (!this.feature.isAudiTarget) this.selectedClient = "";else {
        this.selectedImporter = "";
        this.selectedProject = "";
      }
      this.dynamicFilters = [];
      this.resultCheckData = {};
    },
    addDynamicFilter: function addDynamicFilter() {
      this.dynamicFilters.push({
        Guid: uuidv4(),
        Type: ""
      });
    },
    removeDynamicFilter: function removeDynamicFilter(filter) {
      if (filter.Type === "Country") {
        _.remove(this.dynamicFilters, function (f) {
          return f.Type === "City";
        });
        _.remove(this.dynamicFilters, function (f) {
          return f.Type === "Region";
        });
      }
      _.remove(this.dynamicFilters, function (f) {
        return f.Guid === filter.Guid;
      });
      this.getCheckFilterResult();
      this.$forceUpdate();
      this.updateSelect2Values();
    },
    isLastDynamicFilterEmpty: function isLastDynamicFilterEmpty() {
      if (this.dynamicFilters.length < 1) return false;
      return !this.dynamicFilters[this.dynamicFilters.length - 1].Type;
    },
    propertyAlreadyUsed: function propertyAlreadyUsed(guid) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _filter = _step4.value;

          if (_filter.Value === guid) return true;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    isTypeEnabled: function isTypeEnabled(type, filter) {
      if (type === "LocationProperty") return true;
      // else if (
      //   type === "City" &&
      //   (!this.isCountryFilterDefined || filter.Type === "Country")
      // )
      //   return false;

      // Shown Regions depending on countries
      var countryFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Country"
      });
      if (type === "Region") if (countryFilterIndex < 0 || countryFilterIndex >= 0 && !this.dynamicFilters[countryFilterIndex].Value || countryFilterIndex >= 0 && this.dynamicFilters[countryFilterIndex].Value && this.dynamicFilters[countryFilterIndex].Value.length < 1) return false;

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _filter2 = _step5.value;

          if (_filter2.Type === type) return false;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return true;
    },

    // setCitiesOfSelectedCountriesForCityFilter() {
    //   let cityFilter = _.find(this.dynamicFilters, f => f.Type === "City");
    //   if (!cityFilter) return;

    //   let cities = [];
    //   let countryFilter = _.find(
    //     this.dynamicFilters,
    //     f => f.Type === "Country"
    //   );
    //   if (countryFilter && countryFilter.Value) {
    //     countryFilter.Value.forEach(entry => {
    //       let cityList = _.find(this.cityLists, c => c.CountryCode === entry);
    //       if (cityList && cityList.Cities)
    //         cities = _.union(cities, cityList.Cities);
    //     });
    //     cities = _.sortBy(cities, [c => c.City.toLowerCase()]);
    //   }
    //   cityFilter.currentDynamicFilterValues = cities;
    //   cityFilter.secondLevelSelectVisible = false;

    //   this.$nextTick(() => {
    //     cityFilter.secondLevelSelectVisible = true;
    //     this.$forceUpdate();
    //   });
    // },
    dynamicFilterTypeChanged: function dynamicFilterTypeChanged(filter) {
      delete filter.Value;
      delete filter.ValuesValue;
      delete filter.currentDynamicFilterValues;
      delete filter.currentDynamicFilterValueValues;
      delete filter.secondLevelSelectVisible;
      delete filter.thirdLevelSelectVisible;

      switch (filter.Type) {
        case "Country":
          filter.currentDynamicFilterValues = this.countryList;
          break;
        case "Region":
          filter.currentDynamicFilterValues = this.regionsFiltered;
          break;
        case "City":
        case "PostalCode":
        case "Location":
        case "Check":
          filter.currentDynamicFilterValues = [];
          break;
        case "LocationProperty":
          filter.currentDynamicFilterValues = this.locationPropertiesList;
          break;
        case "Scenario":
          filter.currentDynamicFilterValues = this.scenariosOfSelectedWave;
          break;
        case "Status":
          filter.currentDynamicFilterValues = this.recruitingStatusList;
          break;
        default:
          return;
      }

      filter.secondLevelSelectVisible = true;
    },
    dynamicFilterValueChanged: function dynamicFilterValueChanged(filter) {
      var _this10 = this;

      // Forces select2 to rerender with new options
      delete filter.Subvalue;
      delete filter.thirdLevelSelectVisible;

      if (["Status", "City", "PostalCode", "Country", "Location"].includes(filter.Type)) {
        // if country value empty (e.g. after deselect) remove all regions
        if (filter.Type === "Country" && (!filter.Value || filter.Value.length < 1)) {
          _.remove(this.dynamicFilters, function (f) {
            return f.Type === "Region";
          });
        } else if (filter.Type === "Country") {
          if (!filter.Value || filter.Value.length < 1) return;

          var regionFilter = this.dynamicFilters.find(function (el) {
            return el.Type === "Region";
          });
          if (regionFilter) regionFilter.currentDynamicFilterValues = this.regionsFiltered;
        }

        this.getCheckFilterResult();
      } else {
        this.$nextTick(function () {
          if (!filter.Value) return;
          // check if we have "LocationPropertyGuid"
          var currVal = filter.currentDynamicFilterValues.find(function (val) {
            return val[filter.Type + "Guid"] === filter.Value;
          });

          if (currVal && currVal[filter.Type + "Values"] && currVal[filter.Type + "Values"].length > 0) {
            filter.currentDynamicFilterValueValues = currVal[filter.Type + "Values"];
            filter.thirdLevelSelectVisible = true;
            _this10.$forceUpdate();
          } else _this10.getCheckFilterResult();
        });
      }
    },
    getRegionsByCountryCode: function getRegionsByCountryCode(countryCode) {
      return this.regionList.filter(function (region) {
        var result = false;

        if (region.CountryCode.toLowerCase() === countryCode.toLowerCase()) {
          result = true;
        }
        return result;
      }).map(function (region) {
        return region.Regions;
      }).flat();
    },
    collectFilterData: function collectFilterData() {
      var result = {
        ClientGuid: this.selectedClient,
        ProjectGuid: this.selectedProject,
        WaveGuid: this.selectedWave
      };
      if (this.selectedImporter) result.ImporterGuid = this.selectedImporter;

      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var _filter3 = _step6.value;

          if (!_filter3.Type || !_filter3.Value) continue;

          if (_filter3.Type === "Country") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.CountryCodes = _filter3.Value;
          } else if (_filter3.Type === "Region") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.RegionGuids = _filter3.Value;
          } else if (_filter3.Type === "City") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.Cities = _filter3.Value;
          } else if (_filter3.Type === "PostalCode") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.PostalCodes = _filter3.Value;
          } else if (_filter3.Type === "Location") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.LocationStoreIds = _filter3.Value;
          } else if (_filter3.Type === "LocationProperty") {
            if (!_filter3.Value || !_filter3.Subvalue || _filter3.Subvalue.length < 1) continue;
            if (!result.LocationProperties) result.LocationProperties = [];
            result.LocationProperties.push({
              LocationPropertyGuid: _filter3.Value,
              LocationPropertyValues: _filter3.Subvalue
            });
          } else if (_filter3.Type === "Check") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.SurveyInstanceIds = _filter3.Value.map(function (value) {
              return parseInt(value);
            });
          } else if (_filter3.Type === "Scenario") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.ScenarioGuids = _filter3.Value;
          } else if (_filter3.Type === "Status") {
            if (!_filter3.Value || _filter3.Value.length < 1) continue;
            result.SurveyInstanceRecruitingStatus = _filter3.Value;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.$emit("filterUpdate", result);
    },
    getLocationsOfClient: function getLocationsOfClient() {
      this.$emit("requestLocations", this.selectedClient);
    },
    getLocationProperties: function getLocationProperties() {
      this.$emit("requestLocationProperties", this.selectedClient);
    },
    getCheckFilterResult: function getCheckFilterResult() {
      var _this11 = this;

      if (this.$filterRestorePending || !this.selectedWave) return;
      this.collectFilterData();
      var query = "api/Recruiting/SurveyInstances";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this11.resultCheckData = data;
        },
        error: function error() {
          console.error("Error on POST in getCheckFilterResult()");
          _this11.globals.showErrorSnackbar(_this11.lang.RC0009);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globals__ = __webpack_require__(69);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.gmapsInfoWindowMarkerButtonClicked = function (type, guid) {
  var data = { type: type, guid: guid };
  __WEBPACK_IMPORTED_MODULE_0__globals__["a" /* default */].$emit("gmapsInfoWindowMarkerButtonClicked", data);
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleMaps",
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    checkList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    shopperList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      geocoder: null,
      map: null,
      mapInitDone: false,
      searchString: "",
      currentMapRadius: 50,
      isMapRadiusVisible: false,
      location: "Deutschland",
      currentPosition: null,
      icons: {
        ASSIGNED_NO_ANSWER: { icon: "ylw-circle.png" },
        ASSIGNED_WITH_ANSWER: { icon: "orange-circle.png" },
        NOT_ASSIGNED: { icon: "grn-circle.png" },
        shopper: { icon: "blu-stars.png" }
      },
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        scaleControl: true,
        rotateControl: false,
        disableDefaultUi: false,
        mapTypeId: "roadmap"
      },
      checkMarkers: [],
      shopperMarkers: [],
      currentMapCircle: null,
      selectedMarker: null,
      searchBox: null,
      lang: {
        RCM000: "Search",
        RCM001: "Radius in km",
        RCM002: "Switch radius visibility",
        RCM003: "Filter for this check",
        RCM004: "Filter for this shopper",
        RCM005: "Wave",
        RCM006: "Gender",
        RCM007: "Age",
        RCM008: "male",
        RCM009: "female",
        RCM010: "Shopper",
        RCM011: "Check assigned but not yet edited",
        RCM012: "Check assigned and edited",
        RCM013: "Check not assigned",
        RCM014: "Remove filter",
        RCM015: "Scenario",
        RCM016: "Vehicle",
        RCM017: "Target model",
        RCM018: "Approved shopper",
        RCM019: "City",
        RCM020: "diverse"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
    }

    if (!window.google) {
      this.globals.$once("googleInitDone", function () {
        _this.initGoogleMap();
      });
    } else {
      this.initGoogleMap();
    }
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    isMapRadiusVisible: function isMapRadiusVisible(newVal) {
      if (newVal) $(".btn-marker-info").removeClass("hidden");else {
        var button = $(".btn-marker-info");
        button.addClass("hidden");
        button.removeClass("btn-warning");
        button.html(this.lang.RCM003);
      }
    }
  },
  methods: {
    initGoogleMap: function initGoogleMap() {
      var _this2 = this;

      var currentPosition = { lat: 51, lng: 10.5 };

      var init = function init() {
        _this2.mapOptions.center = new google.maps.LatLng(currentPosition.lat, currentPosition.lng);
        _this2.mapOptions.zoom = 6;

        _this2.map = new google.maps.Map(document.getElementById("gmaps-container"), _this2.mapOptions);
        _this2.map.infowindow = new google.maps.InfoWindow();

        var input = document.getElementById("gmapsSearchInput");
        _this2.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        var radiusInput = document.getElementById("gmapsRadiusInput");
        _this2.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(radiusInput);

        _this2.searchBox = new google.maps.places.SearchBox(input);
        _this2.searchBox.addListener("places_changed", _this2.searchLocation);

        _this2.geocoder = new google.maps.Geocoder();

        google.maps.event.addListenerOnce(_this2.map, "tilesloaded", function () {
          _this2.mapInitDone = true;
        });
      };

      navigator.geolocation.getCurrentPosition(function (pos) {
        currentPosition = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude
        };
        init();
      }, function (error) {
        console.error(error);
        init();
      });

      this.globals.$off("gmapsInfoWindowMarkerButtonClicked");
      this.globals.$on("gmapsInfoWindowMarkerButtonClicked", function (data) {
        var button = $("#gmapsInfoWindowMarkerButton-" + data.guid);
        if (button) {
          if (_this2.currentFilterObject.RadiusSurveyInstanceGuid === data.guid) {
            button.removeClass("btn-warning");
            button.html(_this2.lang.RCM003);
            data.state = false;
          } else {
            button.addClass("btn-warning");
            button.html(_this2.lang.RCM014);
            data.state = true;
          }
        }
        _this2.$emit("markerInfoSelectButtonClicked", data);
      });
    },
    iconMarkerFactory: function iconMarkerFactory() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "NOT_ASSIGNED";
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { width: 50, height: 50 };

      var iconBaseUrl = "https://maps.google.com/mapfiles/kml/paddle/";
      var url = "" + iconBaseUrl + this.icons[type].icon;
      var scaledSize = size;
      return { url: url, scaledSize: scaledSize };
    },
    zoomToLocation: function zoomToLocation(formatted_address) {
      var _this3 = this;

      this.geocoder.geocode({ address: formatted_address }, function (results, status) {
        if (status !== "OK" || !results[0]) {
          throw new Error(status);
        }
        _this3.map.setCenter(results[0].geometry.location);
        _this3.map.fitBounds(results[0].geometry.viewport);
      });
    },
    searchLocation: function searchLocation() {
      var _this4 = this;

      var location = this.searchBox.getPlaces(); //TODO: does not work if location in searchbox was selected before
      if (location) this.zoomToLocation(location[0].formatted_address);else {
        if (!this.searchString) return;
        this.geocoder.geocode({ address: this.searchString }, function (results, status) {
          if (status !== "OK" || !results[0]) {
            throw new Error(status);
          }
          _this4.zoomToLocation(results[0].formatted_address);
        });
      }
    },
    currentMapRadiusChanged: function currentMapRadiusChanged() {
      if (this.currentMapRadius < 0) this.currentMapRadius = 0;else if (this.currentMapRadius > 9999) this.currentMapRadius = 9999;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    changeMapRadiusVisibility: function changeMapRadiusVisibility() {
      this.isMapRadiusVisible = !this.isMapRadiusVisible;
      this.drawMarkerCircle(this.selectedMarker);
      this.emitRadiusData();
    },
    emitRadiusData: function emitRadiusData() {
      var radiusData = {
        visible: this.isMapRadiusVisible,
        radius: this.currentMapRadius
      };
      this.$emit("mapRadiusChanged", radiusData);
    },
    showChecksOnMap: function showChecksOnMap() {
      var _this5 = this;

      this.clearCheckMarkers();

      this.checkList.forEach(function (check) {
        if (!check.Location) return;
        var location = {
          lng: check.Location.Longitude,
          lat: check.Location.Latitude
        };

        var infotext = "<div style=\"text-align: left;\">\n          <b>Check ID: " + check.SurveyInstanceId + "</b>\n          <br>\n          <br>" + check.LocationName + "\n          <br>\n          <br>" + check.LocationAddress + "\n          <br>" + check.LocationPostalCode + " " + check.LocationCity + "\n          <br>\n          <br>" + _this5.lang.RCM005 + ": " + check.WaveName + "\n          <br>" + _this5.lang.RCM015 + ": " + check.ScenarioName;

        if (check.ApprovedShopperName) infotext += "<br>\n          <br>" + _this5.lang.RCM018 + ":\n          <br>" + check.ApprovedShopperName;

        infotext += "<br><button class=\"btn btn-raised btn-success btn-marker-info hidden\" \n            id=\"gmapsInfoWindowMarkerButton-" + check.SurveyInstanceGuid + "\" \n            onclick=\"gmapsInfoWindowMarkerButtonClicked('check','" + check.SurveyInstanceGuid + "')\">" + _this5.lang.RCM003 + "</button>\n          </div>";

        var marker = new google.maps.Marker({
          position: location,
          map: _this5.map,
          icon: _this5.iconMarkerFactory(check.SurveyInstanceRecruitingStatus),
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this5.showMarkerInfo(marker);
          _this5.drawMarkerCircle(marker);
          _this5.selectedMarker = marker;
          _this5.$nextTick(function () {
            var button = $("#gmapsInfoWindowMarkerButton-" + check.SurveyInstanceGuid);
            if (_this5.isMapRadiusVisible) button.removeClass("hidden");
            if (check.SurveyInstanceGuid === _this5.currentFilterObject.RadiusSurveyInstanceGuid) {
              button.addClass("btn-warning");
              button.html(_this5.lang.RCM014);
            }
          });
        });
        _this5.checkMarkers.push(marker);
      });
    },
    showShoppersOnMap: function showShoppersOnMap() {
      var _this6 = this;

      this.clearShopperMarkers();

      this.shopperList.forEach(function (shopper) {
        if (!shopper.Location) return;
        var location = {
          lng: shopper.Location.Longitude,
          lat: shopper.Location.Latitude
        };
        //SM1033
        var gender = {
          F: _this6.lang.RCM009,
          M: _this6.lang.RCM008,
          D: _this6.lang.RCM020
        };
        var infotext = "<div style=\"text-align: left;\">\n          <b>" + shopper.FirstName + " " + shopper.LastName + " (" + shopper.Username + ")</b>\n          <br>\n          <br>" + _this6.lang.RCM006 + ": " + gender[shopper.Gender] + "\n          <br>" + _this6.lang.RCM007 + ": " + shopper.Age + "\n          <br>" + _this6.lang.RCM019 + ": " + shopper.City;

        if (shopper.AudiShopperInfos) for (var i = 0; i < shopper.AudiShopperInfos.length; i++) {
          infotext += "\n          <br>\n          <br><b>" + _this6.lang.RCM016 + " " + (i + 1) + "</b>: " + shopper.AudiShopperInfos[i].ShopperCar + "\n          <br>" + _this6.lang.RCM017 + ": " + shopper.AudiShopperInfos[i].CarModelName + " (" + shopper.AudiShopperInfos[i].CarMatch + ")\n          ";
        }

        infotext += "<br><button class=\"btn btn-raised btn-success btn-marker-info hidden\"\n            id=\"gmapsInfoWindowMarkerButton-" + shopper.ShopperGuid + "\"\n            onclick=\"gmapsInfoWindowMarkerButtonClicked('shopper','" + shopper.ShopperGuid + "')\">" + _this6.lang.RCM004 + "</button>\n        </div>";
        var marker = new google.maps.Marker({
          position: location,
          map: _this6.map,
          icon: _this6.iconMarkerFactory("shopper"),
          infotext: infotext
        });
        marker.addListener("click", function () {
          _this6.showMarkerInfo(marker);
          _this6.drawMarkerCircle(marker);
          _this6.selectedMarker = marker;
        });
        _this6.shopperMarkers.push(marker);
      });
    },
    showMarkerInfo: function showMarkerInfo(marker) {
      this.map.infowindow.setContent(marker.infotext);
      this.map.infowindow.open(this.map, marker);
    },
    drawMarkerCircle: function drawMarkerCircle(marker) {
      if (this.currentMapCircle) this.currentMapCircle.setMap(null); // Remove old circle
      if (!marker || !this.isMapRadiusVisible) return;

      this.currentMapCircle = new google.maps.Circle({
        map: this.map,
        radius: this.currentMapRadius * 1000,
        fillColor: "#990000"
      });
      this.currentMapCircle.bindTo("center", marker, "position");
    },
    clearCheckMarkers: function clearCheckMarkers() {
      this.checkMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.checkMarkers = [];
    },
    clearShopperMarkers: function clearShopperMarkers() {
      this.shopperMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.shopperMarkers = [];
      this.selectedMarker = null;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckFilter__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CheckFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperFilter__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShopperFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMaps__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMaps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__GoogleMaps__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Recruiting",
  components: {
    CheckFilter: __WEBPACK_IMPORTED_MODULE_1__CheckFilter___default.a,
    ShopperFilter: __WEBPACK_IMPORTED_MODULE_2__ShopperFilter___default.a,
    GoogleMaps: __WEBPACK_IMPORTED_MODULE_3__GoogleMaps___default.a
  },
  data: function data() {
    return {
      currentFilterObject: {},
      checkFilterResults: {},
      shopperFilterResults: {},
      locationPropertiesList: [],
      countryList: [],
      regionList: [],
      locationList: [],
      lang: {
        RC000: "Show results on map",
        RC001: "Export",
        RC002: "Export failed",
        RC003: "Location property data request failed",
        RC004: "Clear filters"
      }
    };
  },

  computed: {
    isExportDisabled: function isExportDisabled() {
      if (!this.checkFilterResults.SurveyInstanceCount || !this.shopperFilterResults.ShopperCount || this.checkFilterResults.SurveyInstanceCount * this.shopperFilterResults.ShopperCount > 10000) return true;

      return false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
      this.globals.getRegionsList(function (callbackData) {
        _this.regionList = callbackData;
        _this.$emit("RegionListReceived");
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList(this.convertCountryList);
      this.globals.getRegionsList(function (callbackData) {
        _this2.regionList = callbackData;
        _this2.$emit("RegionListReceived");
      });
    }

    this.debouncedGetShopperFilterResults = _.debounce(this.$refs.shopperFilterRef.getShopperFilterResult, 600);
  },

  methods: {
    convertCountryList: function convertCountryList(data) {
      this.countryList = [];
      for (var country in data) {
        this.countryList.push({
          CountryCode: country,
          CountryName: data[country]
        });
      }
      this.$emit("CountryListReceived");
    },
    clearFilters: function clearFilters() {
      this.$refs.checkFilterRef.clearCheckFilter();
      this.$refs.shopperFilterRef.clearShopperFilter();
    },
    updateCheckFilter: function updateCheckFilter(data) {
      this.currentFilterObject.SurveyInstance = data;
    },
    updateShopperFilter: function updateShopperFilter(data) {
      this.currentFilterObject.Shopper = data;
    },
    updateMapRadius: function updateMapRadius(data) {
      if (!data.visible) {
        delete this.currentFilterObject.Radius;
        delete this.currentFilterObject.RadiusSurveyInstanceGuid;
        this.$refs.checkFilterRef.getCheckFilterResult();
      } else {
        this.currentFilterObject.Radius = data.radius * 1000;
      }

      if (this.debouncedGetShopperFilterResults) this.debouncedGetShopperFilterResults();
    },
    onCheckDataChanged: function onCheckDataChanged($event) {
      this.checkFilterResults = $event;

      if (typeof this.currentFilterObject.Radius === "number") this.$refs.shopperFilterRef.getShopperFilterResult();
    },
    onShopperDataChanged: function onShopperDataChanged($event) {
      this.shopperFilterResults = $event;
    },
    onCheckSelectionChanged: function onCheckSelectionChanged($event) {
      if (!$event) return;
      if (!$event.state || !$event.guid) delete this.currentFilterObject.RadiusSurveyInstanceGuid;else this.currentFilterObject.RadiusSurveyInstanceGuid = $event.guid;

      this.$refs.checkFilterRef.getCheckFilterResult();
    },
    exportResults: function exportResults() {
      var _this3 = this;

      var query = "api/Recruiting/Export";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.globals.downloadFile(data[0].DownloadId);
        },
        error: function error() {
          console.error("Error on POST in exportResults()");
          _this3.globals.showErrorSnackbar(_this3.lang.RC002);
        }
      });
    },
    getLocationsOfClient: function getLocationsOfClient(client) {
      var _this4 = this;

      if (!client) {
        this.locationList = [];
        this.$emit("LocationsReceived");
        return;
      }

      $.ajax({
        method: "POST",
        url: "api/SurveyInstances/Locations/" + client,
        success: function success(data) {
          if (data[0]) {
            if (data[0].Locations) _this4.locationList = data[0].Locations.map(function (location) {
              return {
                LocationGuid: location.LocationGuid,
                LocationName: location.LocationAddress,
                LocationCountry: location.LocationCountry
              };
            });else _this4.locationList = [];
          }
          _this4.$emit("LocationsReceived");
        },
        error: function error() {
          console.error("Error on POST in getLocationsOfSelectedClient()");
          _this4.globals.showErrorSnackbar("Location data access failed");
        }
      });
    },
    getLocationProperties: function getLocationProperties(client) {
      var _this5 = this;

      if (!client) {
        this.locationPropertiesList = [];
        this.$emit("LocationPropertiesReceived");
        return;
      }

      var query = "api/Recruiting/Data/LocationProperties/" + client;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this5.locationPropertiesList = data;
          _this5.$emit("LocationPropertiesReceived");
        },
        error: function error() {
          console.error("Error on GET in getLocationProperties()");
          _this5.globals.showErrorSnackbar(_this5.lang.RC003);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tools_VueSelect__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_VueSelect_css_vue_select_css__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tools_VueSelect_css_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tools_VueSelect_css_vue_select_css__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var uuidv4 = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperFilter",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a,
    VueSelect: __WEBPACK_IMPORTED_MODULE_5__Tools_VueSelect__["a" /* default */]
  },
  props: {
    currentFilterObject: {
      Type: Object,
      default: function _default() {
        return {};
      }
    },
    locationPropertiesList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    countryList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    },
    regionList: {
      Type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      notSameLocation: false,
      notWithLocationPropertyGuids: [],
      notWithinTimespanValue: 0,
      notWithinTimespan: "days",
      timespans: ["days", "weeks", "months", "years"],
      dynamicFilters: [],
      isVueSelect: false,
      isInputNumber: false,
      shopperPropertiesList: [],
      occupationalGroupList: [],
      isRecruitingFilter: false,
      isFirstTimeForShopperFiler: true,
      filterTypes: ["Country", "Region", "City", "PostalCode", "Gender", "Age", "OccupationalGroup", "ShopperProperty", "ShopperMinChecks"],
      resultShopperData: {},
      lang: {
        RCS000: "Shopper filter",
        RCS001: "Available Shoppers",
        RCS002: "Not same location for",
        RCS003: "Select only shoppers that did not visit the location of the check within a given time period",
        RCS004: "Not within location properties... (optional)",
        RCS005: "Select only shoppers that did not visit any location where the selected location properties have the same value as for the locations that the shopper already visited",
        RCS006: "Choose",
        RCS007: "Type of filter",
        RCS008: "Value",
        RCS009: "Select Value(s)",
        RCS010: "Add filter",
        RCS011: "Shopper property data request failed",
        RCS012: "Shopper data request failed",
        RCS013: "Shopper property",
        RCS014: "days",
        RCS015: "weeks",
        RCS016: "months",
        RCS017: "years",
        RCS018: "Please type in a value",
        RCS019: "male",
        RCS020: "female",
        RCS021: "divers",
        RCS022: "from",
        RCS023: "to",
        RCS024: "Country",
        RCS025: "City",
        RCS026: "Postal code",
        RCS027: "Gender",
        RCS028: "Age",
        RCS029: "Occupational group",
        RCS030: "The maximum count of shoppers that can be shown on the map is exceeded. If you want to see all results on the map, please define some more filters.",
        RCS031: "No answer",
        RCS032: "Region",
        RCS033: "No regions available",
        RCS034: "min checks",
        RCS035: "Min Checks"
      }
    };
  },

  computed: {
    shopperCountExceeded: function shopperCountExceeded() {
      if (!this.resultShopperData || _.isEmpty(this.resultShopperData) || !this.resultShopperData.Shoppers) return false;
      return this.resultShopperData.ShopperCount > this.resultShopperData.Shoppers.length;
    },
    regionsFiltered: function regionsFiltered() {
      var _this = this;

      var filteredRegionsList = [];

      var countryFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Country"
      });

      if (countryFilterIndex > -1) {
        // filter regions on multiple countries
        this.dynamicFilters[countryFilterIndex].Value.forEach(function (countryCode) {
          filteredRegionsList = _.union(filteredRegionsList, _this.getRegionsByCountryCode(countryCode));
        });

        // order regions alphabetic
        if (filteredRegionsList) filteredRegionsList = _.sortBy(filteredRegionsList, [function (o) {
          return o.RegionName;
        }]);
      }
      // // check if selected region in regions of selected countries
      var regionFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Region"
      });
      if (regionFilterIndex > -1 && this.dynamicFilters[regionFilterIndex].Value) {
        this.dynamicFilters[regionFilterIndex].Value = this.dynamicFilters[regionFilterIndex].Value.filter(function (value) {
          return _.findIndex(filteredRegionsList, function (cDFV) {
            return cDFV.RegionGuid === value;
          }) >= 0;
        });
      }

      return filteredRegionsList;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this2 = this;

      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
      this.globals.getOccupationalGroupList(function (data) {
        _this2.occupationalGroupList = [];
        for (var guid in data) {
          _this2.occupationalGroupList.push({
            OccupationalGroupGuid: guid,
            OccupationalGroupName: data[guid]
          });
        }
        _this2.$emit("OccupationalGroupsReceived");
        _this2.debouncedUpdateSelect2Data();
      });
    },
    resultShopperData: function resultShopperData(newData) {
      this.$emit("shopperDataChanged", newData);
    }
  },
  created: function created() {
    if (this.$route) {
      this.isRecruitingFilter = this.$route.name === "Recruiting";
    }
    this.debouncedUpdateSelect2Data = _.debounce(this.updateSelect2Data, 500);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.debouncedUpdateSelect2Data);
      this.globals.getOccupationalGroupList(function (data) {
        _this3.occupationalGroupList = [];
        for (var guid in data) {
          _this3.occupationalGroupList.push({
            OccupationalGroupGuid: guid,
            OccupationalGroupName: data[guid]
          });
        }
        _this3.$emit("OccupationalGroupsReceived");
      });
    }
    this.getShopperProperties();
    this.getShopperFilterResult();
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
  },

  methods: {
    filterSubvalueChanged: function filterSubvalueChanged(newval, filter) {
      filter.Subvalue = newval;
      this.getShopperFilterResult();
    },
    vueSelectFilterChanged: function vueSelectFilterChanged(newval, filter) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filter.updating = true;
                _this4.$forceUpdate();
                _context.next = 4;
                return _this4.filterValueChanged(newval, filter);

              case 4:
                delete filter.updating;
                _this4.$forceUpdate();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    filterValueChanged: function filterValueChanged(newval, filter) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (newval.length > 0 && Array.isArray(newval)) {
                  newval = newval.filter(function (v, i, a) {
                    return a.indexOf(v) === i;
                  });
                }

                filter.Value = newval;
                _this5.dynamicFilterValueChanged(filter);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    filterTypeChanged: function filterTypeChanged(t, filter) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                filter.Type = t;

                _context3.next = 3;
                return _this6.dynamicFilterTypeChanged(filter);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    notWithLocationPropertyGuidsChanged: function notWithLocationPropertyGuidsChanged(value) {
      this.notWithLocationPropertyGuids = value;
      this.notSameLocation = true;
      this.getShopperFilterResult();
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      var _this7 = this;

      if (!this.$store.getters["userSettings/rememberFilters"] || !this.isRecruitingFilter) return;
      var storedData = this.$store.getters["localFilters/recruiting_shopperFilter"];
      this.$filterRestorePending = true;
      var restoreDone = function restoreDone() {
        _this7.$nextTick(function () {
          delete _this7.$filterRestorePending;
          _this7.debouncedUpdateSelect2Data();
        });
      };
      var restoreFilters = function restoreFilters() {
        _this7.$nextTick(function () {
          if (storedData) {
            for (var key in storedData) {
              if (_.has(_this7, key)) _this7[key] = _.cloneDeep(storedData[key]);
            }
          }
          restoreDone();
        });
      };

      var eventsToWaitFor = ["ShopperPropertiesReceived"];

      if (this.countryList.length < 1) {
        eventsToWaitFor.push("CountryListReceived");
        this.$parent.$once("CountryListReceived", function () {
          return _this7.$emit("CountryListReceived");
        });
      }

      if (this.regionList.length < 1) {
        eventsToWaitFor.push("RegionListReceived");
        this.$parent.$once("RegionListReceived", function () {
          _this7.$emit("RegionListReceived");
        });
      }

      // If no client is choosen it is not possible to get LocationPropertiesReceived event triggered
      if (this.locationPropertiesList.length < 1 && storedData.notWithLocationPropertyGuids && storedData.notWithLocationPropertyGuids.length > 0) {
        eventsToWaitFor.push("LocationPropertiesReceived");
        this.$parent.$once("LocationPropertiesReceived", function () {
          return _this7.$emit("LocationPropertiesReceived");
        });
      }

      if (this.occupationalGroupList.length < 1) eventsToWaitFor.push("OccupationalGroupsReceived");

      this.globals.doAfterEvents(eventsToWaitFor, restoreFilters, this);
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"] || !this.isRecruitingFilter) return;
      this.$store.commit("localFilters/recruiting_shopperFilter", {
        notSameLocation: this.notSameLocation,
        notWithLocationPropertyGuids: this.notWithLocationPropertyGuids,
        notWithinTimespanValue: this.notWithinTimespanValue,
        notWithinTimespan: this.notWithinTimespan,
        dynamicFilters: this.dynamicFilters
      });
    },
    updateSelect2Data: function updateSelect2Data() {
      var _this8 = this;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var filter = _step.value;

          if (filter.Type === "Gender") filter.currentDynamicFilterValues = [{ GenderName: this.lang.RCS019, GenderCode: "M" }, { GenderName: this.lang.RCS020, GenderCode: "F" }, { GenderName: this.lang.RCS021, GenderCode: "D" }];else if (filter.Type === "Country") filter.currentDynamicFilterValues = this.countryList;else if (filter.Type === "OccupationalGroup") filter.currentDynamicFilterValues = this.occupationalGroupList;else if (filter.Type === "ShopperProperty") filter.currentDynamicFilterValues = this.shopperPropertiesList;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _.remove(this.notWithLocationPropertyGuids, function (selectedValue) {
        return _.findIndex(_this8.locationPropertiesList, function (val) {
          return val.LocationPropertyGuid === selectedValue;
        }) < 0;
      });
      this.$forceUpdate();

      this.$nextTick(function () {
        for (var refName in _this8.$refs) {
          if (_this8.$refs[refName][0]) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this8.$refs[refName]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _component = _step2.value;

                if (_component.reinit) _component.reinit();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else if (_this8.$refs[refName].reinit) _this8.$refs[refName].reinit();
        }
      });

      this.getShopperFilterResult();
    },
    updateSelect2Values: function updateSelect2Values() {
      for (var refName in this.$refs) {
        if (this.$refs[refName][0]) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.$refs[refName]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _component2 = _step3.value;

              if (_component2.updateValue) _component2.updateValue();
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        } else if (this.$refs[refName].updateValue) this.$refs[refName].updateValue();
      }
    },
    getTranslationFor: function getTranslationFor(text) {
      switch (text) {
        case "ShopperProperty":
          return this.lang.RCS013;
        case "Country":
          return this.lang.RCS024;
        case "Region":
          return this.lang.RCS032;
        case "City":
          return this.lang.RCS025;
        case "PostalCode":
          return this.lang.RCS026;
        case "Gender":
          return this.lang.RCS027;
        case "Age":
          return this.lang.RCS028;
        case "OccupationalGroup":
          return this.lang.RCS029;
        case "days":
          return this.lang.RCS014;
        case "weeks":
          return this.lang.RCS015;
        case "months":
          return this.lang.RCS016;
        case "years":
          return this.lang.RCS017;
        case "ShopperMinChecks":
          return this.lang.RCS035;
      }
      return text;
    },
    clearShopperFilter: function clearShopperFilter() {
      this.notSameLocation = false;
      this.notWithLocationPropertyGuids = [];
      this.notWithinTimespanValue = 0;
      this.notWithinTimespan = "days";
      this.dynamicFilters = [];
      this.getShopperFilterResult();
    },
    validateTimespanValue: function validateTimespanValue() {
      if (this.notWithinTimespanValue < 0) this.notWithinTimespanValue = 0;else if (this.notWithinTimespanValue > 100000) this.notWithinTimespanValue = 100000;
      this.notWithinTimespanValue = Math.floor(this.notWithinTimespanValue);
    },
    addDynamicFilter: function addDynamicFilter() {
      this.dynamicFilters.push({
        Guid: uuidv4(),
        Type: ""
      });
    },
    removeDynamicFilter: function removeDynamicFilter(filter) {
      if (filter.Type === "Country") {
        _.remove(this.dynamicFilters, function (f) {
          return f.Type === "City";
        });
        _.remove(this.dynamicFilters, function (f) {
          return f.Type === "Region";
        });
      }
      _.remove(this.dynamicFilters, function (f) {
        return f.Guid === filter.Guid;
      });
      this.getShopperFilterResult();
      this.$forceUpdate();
      this.updateSelect2Values();
    },
    isLastDynamicFilterEmpty: function isLastDynamicFilterEmpty() {
      if (this.dynamicFilters.length < 1) return false;
      return !this.dynamicFilters[this.dynamicFilters.length - 1].Type;
    },
    isTypeEnabled: function isTypeEnabled(type, filter) {
      if (type === "ShopperProperty") return true;

      // Shown Regions depending on countries
      var countryFilterIndex = _.findIndex(this.dynamicFilters, {
        Type: "Country"
      });
      if (type === "Region") if (countryFilterIndex < 0 || countryFilterIndex >= 0 && !this.dynamicFilters[countryFilterIndex].Value || countryFilterIndex >= 0 && this.dynamicFilters[countryFilterIndex].Value && this.dynamicFilters[countryFilterIndex].Value.length < 1) return false;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _filter = _step4.value;

          if (_filter.Type === type) return false;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return true;
    },
    propertyAlreadyUsed: function propertyAlreadyUsed(guid) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var filter = _step5.value;

          if (filter.Value === guid) return true;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    dynamicFilterTypeChanged: function dynamicFilterTypeChanged(filter) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                delete filter.Value;
                delete filter.ValuesValue;
                delete filter.currentDynamicFilterValues;
                delete filter.currentDynamicFilterValueValues;
                delete filter.secondLevelSelectVisible;
                delete filter.secondLevelRangeVisible;
                _this9.isVueSelect = false;
                _this9.isInputNumber = false;
                _context4.t0 = filter.Type;
                _context4.next = _context4.t0 === "Country" ? 11 : _context4.t0 === "Region" ? 14 : _context4.t0 === "City" ? 16 : _context4.t0 === "PostalCode" ? 19 : _context4.t0 === "Gender" ? 22 : _context4.t0 === "OccupationalGroup" ? 24 : _context4.t0 === "Age" ? 26 : _context4.t0 === "ShopperProperty" ? 30 : _context4.t0 === "ShopperMinChecks" ? 32 : 36;
                break;

              case 11:
                filter.currentDynamicFilterValues = _this9.countryList;
                filter.secondLevelSelectVisible = true;
                return _context4.abrupt("break", 37);

              case 14:
                filter.currentDynamicFilterValues = _this9.regionsFiltered;
                return _context4.abrupt("break", 37);

              case 16:
                _this9.isVueSelect = true;
                filter.Value = [];
                return _context4.abrupt("break", 37);

              case 19:
                _this9.isVueSelect = true;
                filter.Value = [];
                return _context4.abrupt("break", 37);

              case 22:
                filter.currentDynamicFilterValues = [{ GenderName: _this9.lang.RCS019, GenderCode: "M" }, { GenderName: _this9.lang.RCS020, GenderCode: "F" }, { GenderName: _this9.lang.RCS021, GenderCode: "D" }];
                return _context4.abrupt("break", 37);

              case 24:
                filter.currentDynamicFilterValues = _this9.occupationalGroupList;
                return _context4.abrupt("break", 37);

              case 26:
                _this9.isInputNumber = true;
                filter.secondLevelRangeVisible = true;
                filter.Value = {};
                return _context4.abrupt("break", 37);

              case 30:
                filter.currentDynamicFilterValues = _this9.shopperPropertiesList;
                return _context4.abrupt("break", 37);

              case 32:
                _this9.isInputNumber = true;
                filter.secondLevelRangeVisible = true;
                filter.Value = {};
                return _context4.abrupt("break", 37);

              case 36:
                return _context4.abrupt("return");

              case 37:
                filter.secondLevelSelectVisible = true;

              case 38:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    dynamicFilterValueChanged: function dynamicFilterValueChanged(filter) {
      var _this10 = this;

      // Forces select2 to rerender with new options
      delete filter.Subvalue;
      delete filter.thirdLevelInputVisible;
      // if country value empty (e.g. after deselect) remove all regions
      if (filter.Type === "Country" && (!filter.Value || filter.Value.length < 1)) {
        _.remove(this.dynamicFilters, function (f) {
          return f.Type === "Region";
        });
      } else if (filter.Type === "Country") {
        if (!filter.Value || filter.Value.length < 1) return;
        var regionFilter = _.find(this.dynamicFilters, {
          Type: "Region"
        });
        if (regionFilter) regionFilter.currentDynamicFilterValues = this.regionsFiltered;
      }

      if (filter.Type !== "ShopperProperty") {
        this.getShopperFilterResult();
        return;
      }

      this.$nextTick(function () {
        if (!filter.Value) return;
        var currVal = "";

        if (filter.Type === "ShopperProperty") {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filter.currentDynamicFilterValues), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var topic = _step6.value;

              currVal = _.find(topic.ChildProperties, function (val) {
                return val[filter.Type + "Guid"] === filter.Value;
              });
              if (currVal) break;
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        } else currVal = _.find(filter.currentDynamicFilterValues, function (val) {
          return val[filter.Type + "Guid"] === filter.Value;
        });

        if (currVal) {
          filter.thirdLevelInputType = currVal.PropertyType;
          if (currVal.PropertyType === "SingleSelect") filter.thirdLevelInputType = "MultiSelect";
          filter.thirdLevelInputVisible = true;

          if (filter.thirdLevelInputType === "Checkbox") {
            filter.Subvalue = true;
          }
          if ((filter.thirdLevelInputType === "MultiSelect" || filter.thirdLevelInputType === "SingleSelect") && currVal[filter.Type + "Values"] && currVal[filter.Type + "Values"].length > 0) {
            filter.currentDynamicFilterValueValues = currVal[filter.Type + "Values"];

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filter.currentDynamicFilterValueValues), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var value = _step7.value;

                if (value.ListCustomValue) {
                  value.ListValueGuid = value.ListCustomValue;
                  value.ListValue = value.ListCustomValue;
                  delete value.ListCustomValue;
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          } else _this10.getShopperFilterResult();
          _this10.$forceUpdate();
        }
      });
    },
    getRegionsByCountryCode: function getRegionsByCountryCode(countryCode) {
      return this.regionList.filter(function (region) {
        var result = false;

        if (region.CountryCode.toLowerCase() === countryCode.toLowerCase()) {
          result = true;
        }
        return result;
      }).map(function (region) {
        return region.Regions;
      }).flat();
    },
    collectFilterData: function collectFilterData() {
      var result = {};

      if (this.notSameLocation) {
        result.NotSameLocation = this.notSameLocation;
        result.NotWithinDays = this.notWithinTimespanValue;
        if (this.notWithinTimespan === "days") result.NotWithinDays *= 1;else if (this.notWithinTimespan === "weeks") result.NotWithinDays *= 7;else if (this.notWithinTimespan === "months") result.NotWithinDays *= 30;else if (this.notWithinTimespan === "years") result.NotWithinDays *= 365;

        if (this.notWithLocationPropertyGuids.length > 0) result.NotWithLocationPropertyGuids = this.notWithLocationPropertyGuids;
      }

      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.dynamicFilters), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var filter = _step8.value;

          if (!filter.Type || !filter.Value) continue;

          if (filter.Type === "Country") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.CountryCodes = filter.Value;
          } else if (filter.Type === "Region") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.Regions = filter.Value;
          } else if (filter.Type === "City") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.Cities = filter.Value;
          } else if (filter.Type === "PostalCode") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.PostalCodes = filter.Value;
          } else if (filter.Type === "Gender") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.Genders = filter.Value;
          } else if (filter.Type === "OccupationalGroup") {
            if (!filter.Value || filter.Value.length < 1) continue;
            result.OccupationalGroups = filter.Value;
          } else if (filter.Type === "Age") {
            if (!filter.Value || _.isEmpty(filter.Value)) continue;
            if (!filter.Value.From) delete filter.Value.From;
            if (!filter.Value.To) delete filter.Value.To;

            if (filter.Value.From < 0) filter.Value.From = 0;
            if (filter.Value.From > 100) filter.Value.From = 100;
            if (filter.Value.To < 0) filter.Value.To = 0;
            if (filter.Value.To > 100) filter.Value.To = 100;

            if (filter.Value.From && filter.Value.To && filter.Value.From > filter.Value.To) {
              ;

              var _ref = [filter.Value.To, filter.Value.From];
              filter.Value.From = _ref[0];
              filter.Value.To = _ref[1];
            }if (!_.isEmpty(filter.Value)) result.Age = filter.Value;
          } else if (filter.Type === "ShopperMinChecks") {
            if (!filter.Value) continue;
            result.ShopperMinChecks = filter.Value;
          } else if (filter.Type === "ShopperProperty") {
            if (!filter.Value || typeof filter.Subvalue === "undefined") continue;

            var filterObject = {
              ShopperPropertyGuid: filter.Value
            };

            if (filter.thirdLevelInputType === "MultiSelect") {
              if (filter.Subvalue.length < 1) continue;
              var guids = _.groupBy(filter.Subvalue, function (val) {
                return !!val.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
              });
              if (guids.true) filterObject.ListValueGuids = guids.true;
              if (guids.false) filterObject.ListCustomValues = guids.false;
            } else if (filter.thirdLevelInputType === "SingleSelect") {
              if (!!filter.Subvalue.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) filterObject.ListValueGuids = [filter.Subvalue];else filterObject.ListCustomValues = [filter.Subvalue];
            } else if (filter.thirdLevelInputType === "Checkbox") {
              filterObject.BitValue = filter.Subvalue;
            } else {
              // Text and Integer
              filterObject.TextValues = _.words(filter.Subvalue);
            }

            if (!result.ShopperProperties) result.ShopperProperties = [];
            result.ShopperProperties.push(filterObject);
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      this.$emit("filterUpdate", result);
    },
    restoreFilterSettings: function restoreFilterSettings() {
      this.clearShopperFilter();
      var filterObject = this.currentFilterObject;
      if (_.isEmpty(filterObject)) return;

      this.notSameLocation = typeof filterObject.NotSameLocation === "boolean" ? filterObject.NotSameLocation : false;
      this.notWithLocationPropertyGuids = filterObject.NotWithLocationPropertyGuids || [];
      this.notWithinTimespanValue = filterObject.NotWithinDays || 0;
      if (this.notWithinTimespanValue && this.notWithinTimespanValue % 365 === 0) {
        this.notWithinTimespanValue /= 365;
        this.notWithinTimespan = "years";
      } else if (this.notWithinTimespanValue && this.notWithinTimespanValue % 30 === 0) {
        this.notWithinTimespanValue /= 30;
        this.notWithinTimespan = "months";
      } else if (this.notWithinTimespanValue && this.notWithinTimespanValue % 7 === 0) {
        this.notWithinTimespanValue /= 7;
        this.notWithinTimespan = "weeks";
      } else this.notWithinTimespan = "days";

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.filterTypes), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var type = _step9.value;

          var apiType = this.getApiPropertyNameForFilterType(type);
          if (filterObject[apiType]) {
            if (type === "ShopperProperty") {
              var _iteratorNormalCompletion10 = true;
              var _didIteratorError10 = false;
              var _iteratorError10 = undefined;

              try {
                for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(filterObject.ShopperProperties), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                  var prop = _step10.value;

                  var subvalue = prop.ListValueGuids || prop.ListCustomValues || prop.TextValues || prop.BitValue;

                  if (prop.ListValueGuids && prop.ListCustomValues) subvalue = _.concat(prop.ListValueGuids, prop.ListCustomValues);

                  this.createDynamicFilter(type, prop.ShopperPropertyGuid, subvalue);
                }
              } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                  }
                } finally {
                  if (_didIteratorError10) {
                    throw _iteratorError10;
                  }
                }
              }
            } else {
              this.createDynamicFilter(type, filterObject[apiType]);
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      this.updateSelect2Values();
    },
    createDynamicFilter: function createDynamicFilter(type, value, subvalue) {
      var filter = {
        Guid: uuidv4(),
        Type: type
      };
      this.dynamicFilterTypeChanged(filter);
      // This is a little workaround, because for ShopperMinChecks the backend gives an array instead of a value, but a value is neede to put back on backend.
      if (type === "ShopperMinChecks" && Array.isArray(value)) filter.Value = value[0];else if (type == "ShopperProperty") {
        filter.Value = [value];
      } else filter.Value = value;
      this.dynamicFilterValueChanged(filter);
      this.$nextTick(function () {
        if (typeof subvalue !== "undefined") filter.Subvalue = subvalue;
      });
      this.dynamicFilters.push(filter);
    },
    getApiPropertyNameForFilterType: function getApiPropertyNameForFilterType(filterType) {
      switch (filterType) {
        case "Country":
          return "CountryCodes";
        case "Region":
          return "Regions";
        case "City":
          return "Cities";
        case "PostalCode":
          return "PostalCodes";
        case "Gender":
          return "Genders";
        case "Age":
          return "Age";
        case "OccupationalGroup":
          return "OccupationalGroups";
        case "ShopperProperty":
          return "ShopperProperties";
        case "ShopperMinChecks":
          return "ShopperMinChecks";
        default:
          return "";
      }
    },
    getShopperProperties: function getShopperProperties() {
      var _this11 = this;

      var query = "api/Recruiting/Data/ShopperProperties";
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this11.shopperPropertiesList = data;
          if (!data || _.isEmpty(data)) _this11.shopperPropertiesList = [];

          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this11.shopperPropertiesList), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var topic = _step11.value;

              topic.ShopperPropertyName = topic.Title;
              topic.ShopperPropertyType = topic.Type;
              delete topic.Title;
              delete topic.Type;

              if (topic.ChildProperties) {
                var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                  for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(topic.ChildProperties), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var _property = _step12.value;

                    _property.ShopperPropertyName = _property.Title;
                    _property.ShopperPropertyType = _property.Type;
                    _property.ShopperPropertyValues = _property.AvailableValues;
                    delete _property.Title;
                    delete _property.Type;
                    delete _property.AvailableValues;
                  }
                } catch (err) {
                  _didIteratorError12 = true;
                  _iteratorError12 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                      _iterator12.return();
                    }
                  } finally {
                    if (_didIteratorError12) {
                      throw _iteratorError12;
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }

          _this11.$emit("ShopperPropertiesReceived");
        },
        error: function error() {
          console.error("Error on GET in getShopperProperties()");
          _this11.globals.showErrorSnackbar(_this11.lang.RCS011);
        }
      });
    },
    getShopperFilterResult: function getShopperFilterResult() {
      var _this12 = this;

      if (!this.isRecruitingFilter || this.$filterRestorePending) return;
      this.collectFilterData();
      var query = "api/Recruiting/Shoppers";
      var postData = this.currentFilterObject;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this12.resultShopperData = data;
        },
        error: function error() {
          console.error("Error on POST in getShopperFilterResult()");
          _this12.globals.showErrorSnackbar(_this12.lang.RCS012);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ApprovalWaveStatusModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a
  },
  data: function data() {
    return {
      selectedProject: "",
      selectedWave: "",
      statusData: {},
      projectsWaves: [],
      lang: {
        AWS000: "Wave Status",
        AWS001: "Project",
        AWS002: "Wave",
        AWS003: "Please select a project...",
        AWS004: "Please select a wave...",
        AWS005: "Check Status",
        AWS006: "Total check count",
        AWS007: "In approval",
        AWS008: "In progress",
        AWS009: "In reporting",
        AWS010: "In time",
        AWS011: "Approvals",
        AWS012: "None",
        AWS013: "Open",
        AWS014: "Approved",
        AWS015: "Wave charactertistics",
        AWS016: "Gender",
        AWS017: "Male",
        AWS018: "Female",
        AWS019: "Age",
        AWS020: "Min",
        AWS021: "Max",
        AWS022: "Above 65",
        AWS023: "Distance",
        AWS024: "Reg. year shopper car",
        AWS025: "Model match",
        AWS026: "Downgrade",
        AWS027: "Match",
        AWS028: "Upgrade",
        AWS029: "Audi cars",
        AWS030: "Model",
        AWS031: "Target value",
        AWS032: "Current value",
        AWS033: "Competitor cars",
        AWS034: "Close",
        AWS035: "Wave status access failed"
      }
    };
  },

  computed: {
    availableWaves: function availableWaves() {
      var _this = this;

      if (!this.projectsWaves[0]) return [];
      var project = _.find(this.projectsWaves, function (p) {
        return p.ProjectGuid === _this.selectedProject;
      });
      return project && project.Waves ? project.Waves : [];
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getWaveList(function (data) {
      _this2.projectsWaves = data;
    });

    this.globals.$off("showApprovalWaveStatus");
    this.globals.$on("showApprovalWaveStatus", function (check) {
      if (check.ProjectGuid && check.WaveGuid) {
        _this2.selectedProject = check.ProjectGuid;
        _this2.selectedWave = check.WaveGuid;
        _this2.$refs.waveSelect.updateValue();
      }
      _this2.getWaveStatus();
      _this2.openModal();
    });
  },

  methods: {
    openModal: function openModal() {
      $("#approvalWaveStatusModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#approvalWaveStatusModal").modal("hide");
    },
    getWaveStatus: function getWaveStatus() {
      var _this3 = this;

      if (!this.selectedWave) return;
      var query = "api/ProjectWaves/" + this.selectedWave + "/AgencyStatus";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) _this3.statusData = data;
        },
        error: function error(_error) {
          console.error("Error on GET in getWaveStatus()");
          _this3.globals.showErrorSnackbar(_this3.lang.AWS035);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CarModelManagement",
  components: { select2: __WEBPACK_IMPORTED_MODULE_2__components_Tools_Select2___default.a },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newModel: "",
      newSegment: "",
      selectedSegments: [],
      segmentList: [],
      modelList: [],
      isModelEditing: false,
      isSegmentEditing: false,
      lang: {
        CMM000: "Car Models",
        CMM001: "Models",
        CMM002: "Segments",
        CMM003: "New model name",
        CMM004: "Segments",
        CMM005: "Add",
        CMM006: "Name",
        CMM007: "Segments",
        CMM008: "Actions",
        CMM009: "New segment name",
        CMM010: "Close",
        CMM011: "Car model already exists",
        CMM012: "Car model created",
        CMM013: "Car model creation failed",
        CMM014: "Car model updated",
        CMM015: "Car model update failed",
        CMM016: "Car model deleted",
        CMM017: "Car model deletion failed",
        CMM018: "Delete Car Model",
        CMM019: "Yes",
        CMM020: "No",
        CMM021: "Do you really want to delete the following car model?",
        CMM022: "Incomplete data",
        CMM023: "Segment already exists",
        CMM024: "Segment created",
        CMM025: "Segment creation failed",
        CMM026: "Segment updated",
        CMM027: "Segment update failed",
        CMM028: "Segment deleted",
        CMM029: "Segment deletion failed",
        CMM030: "Delete Segment",
        CMM031: "Do you really want to delete the following segment?",
        CMM032: "ATTENTION: Car models will also be deleted if they are not assigned to any other segment!",
        CMM033: "Please select a segment name"
      }
    };
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#carModelManagement").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.newModel = "";
      this.newSegment = "";
      this.isModelEditing = false;
      this.isSegmentEditing = false;
      this.globals.getCarSegmentList(function (data) {
        _this2.segmentList = data;
        if (data[0] && data[0].CarSegmentGuid) _this2.$nextTick(function () {
          _this2.selectedSegments = [data[0].CarSegmentGuid];
        });
      });
      this.globals.getCarModelList(function (data) {
        return _this2.modelList = data;
      });
      $("#carModelManagement").modal("show");
    },
    closeModal: function closeModal() {
      this.globals.carModelList = [];
      this.globals.carSegmentList = [];
      $("#carModelManagement").modal("hide");
    },
    getCarSegmentNameList: function getCarSegmentNameList(segments) {
      var _this3 = this;

      if (!segments || !segments[0] || !this.segmentList[0]) return "";
      var result = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var seg = _step.value;

          var segmentObject = _.find(_this3.segmentList, function (s) {
            return s.CarSegmentGuid === seg.CarSegmentGuid;
          });
          if (segmentObject && segmentObject.CarSegmentName) {
            if (result.length > 0) result += ", ";
            result += segmentObject.CarSegmentName;
          }
        };

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(segments), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    getCarSegmentsGuidList: function getCarSegmentsGuidList(model) {
      var result = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(model.CarSegments), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var segment = _step2.value;

          result.push(segment.CarSegmentGuid);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return result;
    },
    carSegmentsOfModelChanged: function carSegmentsOfModelChanged(model, e) {
      model.CarSegments = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(e), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var guid = _step3.value;

          model.CarSegments.push({ CarSegmentGuid: guid });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    addNewModel: function addNewModel() {
      var _this4 = this;

      $("#inputNewCarModel").focus();
      if (!this.newModel || !this.selectedSegments[0] || this.isModelEditing) return;
      if (_.findIndex(this.modelList, function (i) {
        return i.CarModelName === _this4.newModel;
      }) > -1) {
        this.globals.showErrorSnackbar(this.lang.CMM011);
        return;
      }
      var postData = {
        CarModelName: this.newModel,
        CarSegments: []
      };
      this.carSegmentsOfModelChanged(postData, this.selectedSegments);

      $.ajax({
        method: "POST",
        url: "api/CarModel",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.modelList = data[0] ? data : [];
          _this4.globals.showSuccessSnackbar(_this4.lang.CMM012);
          _this4.newModel = "";
        },
        error: function error() {
          console.error("Error on POST in addNewModel()");
          _this4.globals.showErrorSnackbar(_this4.lang.CMM013);
        }
      });
    },
    updateModel: function updateModel(model) {
      var _this5 = this;

      $.ajax({
        method: "PUT",
        url: "api/CarModel/" + model.CarModelGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(model),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.globals.showSuccessSnackbar(_this5.lang.CMM014);
        },
        error: function error() {
          console.error("Error on PUT in updateModel()");
          _this5.globals.showErrorSnackbar(_this5.lang.CMM015);
        }
      });
    },
    deleteModel: function deleteModel(model) {
      var _this6 = this;

      if (this.isModelEditing) return;

      this.globals.$off("DeleteCarModelYesConfirmation");
      this.globals.$on("DeleteCarModelYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/CarModel/" + model.CarModelGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this6.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(_this6.modelList, function (i) {
              return i.CarModelGuid === model.CarModelGuid;
            });
            _this6.$forceUpdate();
            _this6.globals.showSuccessSnackbar(_this6.lang.CMM016);
          },
          error: function error() {
            console.error("Error on DELETE in deleteModel()");
            _this6.globals.showErrorSnackbar(_this6.lang.CMM017);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteCarModel",
        confirmationTitle: this.lang.CMM018,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: "<p>" + this.lang.CMM021 + "</p>\n                  <p><b>" + model.CarModelName + "</b></p>"
      });
    },
    editModel: function editModel(e, model) {
      if (this.isModelEditing) return;
      model.editing = true;
      this.isModelEditing = true;
      model.prevCarModelName = model.CarModelName;
      model.prevCarSegments = model.CarSegments;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveModel: function saveModel(e, model) {
      var input = $(e.target).closest("tr").find("input");

      if (!model.CarModelName || !model.CarSegments || !model.CarSegments[0]) {
        this.globals.showErrorSnackbar(this.lang.CMM022);
        input.focus();
        return;
      }

      var count = _.filter(this.modelList, function (i) {
        return i.CarModelName === model.CarModelName;
      }).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.CMM011);
        input.focus();
        return;
      }

      this.isModelEditing = false;
      delete model.editing;
      delete model.prevCarModelName;
      delete model.prevCarSegments;
      input.prop("readonly", "true");
      this.updateModel(model);
    },
    undoModelChanges: function undoModelChanges(e, model) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isModelEditing = false;
      delete model.editing;
      model.CarModelName = model.prevCarModelName;
      delete model.prevCarModelName;
      model.CarSegments = model.prevCarSegments;
      delete model.prevCarSegments;
    },
    addNewSegment: function addNewSegment() {
      var _this7 = this;

      $("#inputNewSegment").focus();
      if (!this.newSegment || this.isSegmentEditing) return;
      if (_.findIndex(this.segmentList, function (i) {
        return i.CarSegmentName === _this7.newSegment;
      }) > -1) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        return;
      }
      var postData = {
        CarSegmentName: this.newSegment
      };
      $.ajax({
        method: "POST",
        url: "api/CarModel/CarSegment",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.segmentList = data[0] ? data : [];
          _this7.globals.showSuccessSnackbar(_this7.lang.CMM024);
          _this7.newSegment = "";
        },
        error: function error() {
          console.error("Error on POST in addNewSegment()");
          _this7.globals.showErrorSnackbar(_this7.lang.CMM025);
        }
      });
    },
    updateSegment: function updateSegment(segment) {
      var _this8 = this;

      $.ajax({
        method: "PUT",
        url: "api/CarModel/CarSegment/" + segment.CarSegmentGuid,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(segment),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this8.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this8.globals.showSuccessSnackbar(_this8.lang.CMM026);
        },
        error: function error() {
          console.error("Error on PUT in updateSegment()");
          _this8.globals.showErrorSnackbar(_this8.lang.CMM027);
        }
      });
    },
    deleteSegment: function deleteSegment(segment) {
      var _this9 = this;

      if (this.isSegmentEditing) return;

      this.globals.$off("DeleteSegmentYesConfirmation");
      this.globals.$on("DeleteSegmentYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/CarModel/CarSegment/" + segment.CarSegmentGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this9.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(_this9.segmentList, function (i) {
              return i.CarSegmentGuid === segment.CarSegmentGuid;
            });
            _.remove(_this9.modelList, function (i) {
              return i.CarSegments.length === 1 && i.CarSegments[0].CarSegmentGuid === segment.CarSegmentGuid;
            });
            _this9.$forceUpdate();
            _this9.globals.showSuccessSnackbar(_this9.lang.CMM028);
          },
          error: function error() {
            console.error("Error on DELETE in deleteSegment()");
            _this9.globals.showErrorSnackbar(_this9.lang.CMM029);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteSegment",
        confirmationTitle: this.lang.CMM030,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: "<p>" + this.lang.CMM031 + "</p>\n                  <p><b>" + segment.CarSegmentName + "</b></p>\n                  <p>" + this.lang.CMM032 + "</p>"
      });
    },
    editSegment: function editSegment(e, segment) {
      if (this.isSegmentEditing) return;
      segment.editing = true;
      this.isSegmentEditing = true;
      segment.prevCarSegmentName = segment.CarSegmentName;
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveSegment: function saveSegment(e, segment) {
      var input = $(e.target).closest("tr").find("input");

      if (!segment.CarSegmentName) {
        this.globals.showErrorSnackbar(this.lang.CMM033);
        input.focus();
        return;
      }

      var count = _.filter(this.segmentList, function (i) {
        return i.CarSegmentName === segment.CarSegmentName;
      }).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        input.focus();
        return;
      }

      this.isSegmentEditing = false;
      delete segment.editing;
      delete segment.prevCarSegmentName;
      input.prop("readonly", "true");
      this.updateSegment(segment);
    },
    undoSegmentChanges: function undoSegmentChanges(e, segment) {
      var input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isSegmentEditing = false;
      delete segment.editing;
      segment.CarSegmentName = segment.prevCarSegmentName;
      delete segment.prevCarSegmentName;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CarModelManagement__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CarModelManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CarModelManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApprovalWaveStatusModal__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApprovalWaveStatusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ApprovalWaveStatusModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperApproval",
  components: {
    ShopperProposalModal: __WEBPACK_IMPORTED_MODULE_1__ShopperProposalModal___default.a,
    ShopperApprovalModal: __WEBPACK_IMPORTED_MODULE_2__ShopperApprovalModal___default.a,
    CarModelManagement: __WEBPACK_IMPORTED_MODULE_3__CarModelManagement___default.a,
    ApprovalWaveStatusModal: __WEBPACK_IMPORTED_MODULE_4__ApprovalWaveStatusModal___default.a
  },
  data: function data() {
    return {
      pageSize: 20,
      selectedPage: 1,
      pageCount: 1,
      checkCount: 0,
      sortField: "LastUpdatedAt",
      sortOrder: "desc", // Should be "asc" or "desc"
      selectedCheck: {},
      showShopperProposalModal: false,
      showShopperApprovalModal: false,
      showCarModelManagement: false,
      filterStrings: {
        Search: "",
        SurveyId: "",
        SurveyInstanceId: "",
        ImporterName: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationCountry: "",
        DealerGroup: "",
        Brand: "",
        LastUpdatedAt: [],
        ShopperId: "",
        DisplayName: "",
        Occupation: "",
        Gender: "",
        Distance: "",
        CarSegmentName: "",
        CarModelName: "",
        ShopperCar: "",
        CarMatch: "",
        ApprovedByLeadAgency: "",
        ApprovedByMainEntity: ""
      },
      lastUpdateAtFilterContent: "",
      fpFilterLastUpdateAt: null,
      approvalData: [],
      lang: {
        SA0000: "Refresh",
        SA0001: "Proposals",
        SA0002: "Approvals",
        SA0003: "Car Models",
        SA0004: "Wave Status",
        SA0005: "Search...",
        SA0006: "Elements per page",
        SA0007: "First page",
        SA0008: "Last page",
        SA0009: "Total checks count",
        SA0010: "SID",
        SA0011: "CheckID",
        SA0012: "Importer",
        SA0013: "Wave",
        SA0014: "StoreID",
        SA0015: "Location",
        SA0016: "City",
        SA0017: "Country",
        SA0018: "Group",
        SA0019: "Brand",
        SA0020: "Updated (days ago)",
        SA0021: "ShopperID",
        SA0022: "Name",
        SA0023: "Age",
        SA0024: "Gender",
        SA0025: "Distance",
        SA0026: "Profession",
        SA0027: "Model",
        SA0028: "Segment",
        SA0029: "Car",
        SA0030: "Match",
        SA0031: "Lead",
        SA0032: "Audi",
        SA0033: "Filter",
        SA0034: "any",
        SA0035: "Upgrade",
        SA0036: "Match",
        SA0037: "Downgrade",
        SA0038: "none",
        SA0039: "approved",
        SA0040: "open",
        SA0041: "rejected",
        SA0042: "Survey title",
        SA0043: "Project",
        SA0044: "Scenario",
        SA0045: "Audi car model distribution",
        SA0046: "Competitor car distribution",
        SA0047: "Approval data request failed"
      }
    };
  },

  computed: {
    isSelectedCheckOnCurrentPage: function isSelectedCheckOnCurrentPage() {
      var _this = this;

      if (!this.selectedCheck.SurveyInstanceGuid) return false;
      return _.findIndex(this.approvalData, function (check) {
        return check.SurveyInstanceGuid === _this.selectedCheck.SurveyInstanceGuid;
      }) > -1;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    var initUpdatedAtFilter = function initUpdatedAtFilter() {
      if (_this2.fpFilterLastUpdateAt) _this2.fpFilterLastUpdateAt.destroy();
      var fpConfig = _.cloneDeep(_this2.globals.flatpickrDateConfig);
      fpConfig.mode = "range";
      fpConfig.onChange = function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) return;
        _this2.filterStrings.LastUpdatedAt = [];
        if (selectedDates.length === 2) _this2.filterStrings.LastUpdatedAt = [_this2.globals.getIsoDateFromIsoTimestamp(selectedDates[0]), _this2.globals.getIsoDateFromIsoTimestamp(selectedDates[1])];

        _this2.lastUpdateAtFilterContent = instance.altInput.value;
        _this2.getApprovalData();
      };
      _this2.fpFilterLastUpdateAt = flatpickr("#inputFilterLastUpdateAt", fpConfig);
      if (_this2.filterStrings.LastUpdatedAt && _this2.filterStrings.LastUpdatedAt.length === 2) {
        _this2.fpFilterLastUpdateAt.setDate(_this2.filterStrings.LastUpdatedAt);
        _this2.lastUpdateAtFilterContent = _this2.fpFilterLastUpdateAt.altInput.value;
      }

      _this2.getApprovalData();
    };

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setElementHeights);
      initUpdatedAtFilter();
    }
    this.globals.$off("languageUpdated");
    this.globals.$on("languageUpdated", initUpdatedAtFilter);

    $(window).on("resize", this.setElementHeights).resize();
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
    if (this.fpFilterLastUpdateAt) this.fpFilterLastUpdateAt.destroy();
  },

  methods: {
    setElementHeights: function setElementHeights() {
      var height = $(window).height();
      height -= $("#approval-top-panel").height() + $("#app-navbar").height() +
      // $(".main-table > thead").height() +
      47; // 47 pixel for the free space around the cards
      $(".main-table-scrollbar").css("max-height", height);
      $(".table-space").css("max-height", height);

      //Sets top-property for filter, so it doesnt scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/shopperApproval"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      this.filterStrings.ImporterName = storedImporter.ImporterName || "";

      // let storedProject = this.$store.getters["sharedFilters/project"];
      // this.filterStrings.ProjectName = storedProject.ProjectName || "";
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperApproval", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
        this.$store.commit("sharedFilters/importer", {
          ImporterName: this.filterStrings.ImporterName
        });
      }
      // let storedProject = this.$store.getters["sharedFilters/project"];
      // if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
      //   this.$store.commit("sharedFilters/project", {
      //     ProjectName: this.filterStrings.ProjectName
      //   });
      // }
    },
    getApprovalData: function getApprovalData(callback) {
      var _this3 = this;

      var query = "api/Approval/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;

      var body = { Filter: {} };
      for (var key in this.filterStrings) {
        if (this.filterStrings[key].length > 0) body.Filter[key] = this.filterStrings[key];
      }

      $.ajax({
        method: "POST",
        url: query,
        data: _.isEmpty(body.Filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error || !data[0]) {
            _this3.globals.showErrorSnackbar(data.Error || "");
            data.Error && console.error(data.Error);
            return;
          }

          _this3.approvalData = data[0].Approvals;
          _this3.pageCount = data[0].Page_Count;
          _this3.checkCount = data[0].Count;

          var selected = _.find(_this3.approvalData, function (check) {
            return check.SurveyInstanceGuid === _this3.selectedCheck.SurveyInstanceGuid;
          });
          if (selected) _this3.selectedCheck = selected;
          if (callback) callback();
        },
        error: function error(_error) {
          console.error("Error on POST in getApprovalData()");
          _this3.globals.showErrorSnackbar(_this3.lang.SA0047);
        }
      });
    },
    sortCheckData: function sortCheckData(field) {
      var _this4 = this;

      if (field === this.sortField) {
        this.sortOrder === "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getApprovalData();
      this.$nextTick(function () {
        _this4.setElementHeights();
      });
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize) this.pageSize = pageSize;
      this.getApprovalData();
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return _.range(1, this.pageCount + 1, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return _.range(1, 7, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return _.range(this.pageCount - 5, this.pageCount + 1, 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3, 1);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperApprovalModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed"
      }
    };
  },

  computed: {
    anyShopperAlreadyApproved: function anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return _.findIndex(this.check.ShopperProposals, function (proposal) {
        return proposal.MainEntityApprovalStatus === "Approved";
      }) > -1;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#shopperApprovalModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.getLastFeedComments();
      $("#shopperApprovalModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    showFeed: function showFeed(proposal, type) {
      var _this2 = this;

      this.globals.$off("feedModalClosed");
      this.globals.$once("feedModalClosed", function (itemGuid, posts) {
        if (posts[0] && posts[0].Content) {
          if (type === "Audi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy = posts[0].FeedPostCreatedBy.Username;
          } else {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy = posts[0].FeedPostCreatedBy.Username;
          }
          _this2.$forceUpdate();
        }
      });

      var feedName = type === "Audi" ? "LeadAgencyAudi" : "LeadAgencyLocalAgency";
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: feedName
      });
    },
    getLastFeedComments: function getLastFeedComments() {
      var _this3 = this;

      var requestCount = this.check.ShopperProposals.length;
      if (this.globals.isLeadAgencyUser) requestCount *= 2;

      this.globals.$off("feedPostsReceived");
      this.globals.$on("feedPostsReceived", function (itemGuid, feedName, posts) {
        if (posts[0] && posts[0].Content) {
          var proposal = _.find(_this3.check.ShopperProposals, function (p) {
            return p.ShopperProposalGuid === itemGuid;
          });
          if (feedName === "LeadAgencyAudi") {
            proposal.LastCommentLeadAudi = posts[0].Content;
            proposal.LastCommentLeadAudiCreatedBy = posts[0].FeedPostCreatedBy.Username;
          } else if (feedName === "LeadAgencyLocalAgency") {
            proposal.LastCommentLeadLocal = posts[0].Content;
            proposal.LastCommentLeadLocalCreatedBy = posts[0].FeedPostCreatedBy.Username;
          }
        }

        if (--requestCount <= 0) {
          _this3.globals.$off("feedPostsReceived");
          _this3.$forceUpdate();
        }
      });

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.check.ShopperProposals), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var proposal = _step.value;

          if (this.globals.isLeadAgencyUser) this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyLocalAgency"
          });
          this.globals.$emit("requestFeedPosts", {
            ItemGuid: proposal.ShopperProposalGuid,
            FeedType: "ShopperProposal",
            FeedName: "LeadAgencyAudi"
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    updateApprovalState: function updateApprovalState(proposal, approvalSource) {
      var _this4 = this;

      var query = "api/Approval/ShopperApproval/" + proposal.ShopperProposalGuid;
      var body = {
        ShopperApprovalType: "Reset"
      };
      var approvalState = void 0;
      if (approvalSource === "leadAgency") approvalState = proposal.AgencyApprovalStatus;else approvalState = proposal.MainEntityApprovalStatus;

      if (approvalState === "Approved") body.ShopperApprovalType = "Approve";else if (approvalState === "Rejected") body.ShopperApprovalType = "Reject";

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            _this4.$emit("resetData");
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.SAM026);
        },
        error: function error(_error) {
          console.error("Error on POST in updateApprovalState()");
          _this4.globals.showErrorSnackbar(_this4.lang.SAM027);
          _this4.$emit("resetData");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperProposalModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      shoppers: [],
      selectedShopper: "",
      selectedCarSegment: "",
      selectedCarModel: "",
      selectedCompetitorCar: "",
      selectedCarMatch: "=",
      selectedShopperCar: "",
      carSegmentList: [],
      carModelList: [],
      shopperCars: [],
      lang: {
        SPM000: "Shopper Proposal",
        SPM001: "Car segment / model",
        SPM002: "Please select a segment...",
        SPM003: "Please select an audi car model...",
        SPM004: "Competitor car model",
        SPM005: "...or a competitor car...",
        SPM006: "Shopper",
        SPM007: "Please select a shopper...",
        SPM008: "Shopper car / Match",
        SPM009: "Please select a shopper car...",
        SPM010: "Upgrade",
        SPM011: "Match",
        SPM012: "Downgrade",
        SPM013: "Name",
        SPM014: "Model",
        SPM015: "Segment",
        SPM016: "Car",
        SPM017: "Match",
        SPM018: "Actions",
        SPM019: "Open conversation",
        SPM020: "Update shopper profile data",
        SPM021: "Delete proposal",
        SPM022: "Close",
        SPM023: "Shopper profile data updated",
        SPM024: "Shopper profile data update failed",
        SPM025: "Shopper proposal added",
        SPM026: "Shopper proposal failed",
        SPM027: "Shopper proposal deleted",
        SPM028: "Shopper proposal deletion failed",
        SPM029: "Delete Shopper Proposal",
        SPM030: "Yes",
        SPM031: "No",
        SPM032: "Do you really want to delete the following shopper proposal?",
        SPM033: "Shopper car access failed"
      }
    };
  },

  computed: {
    unproposedShoppers: function unproposedShoppers() {
      var _this = this;

      if (!this.check.ShopperProposals) return this.shoppers;
      return _.filter(this.shoppers, function (shopper) {
        return _.findIndex(_this.check.ShopperProposals, function (proposal) {
          return proposal.ShopperGuid === shopper.ShopperGuid;
        }) < 0;
      });
    },
    anyShopperAlreadyApproved: function anyShopperAlreadyApproved() {
      if (!this.check.ShopperProposals) return false;
      return _.findIndex(this.check.ShopperProposals, function (proposal) {
        return proposal.MainEntityApprovalStatus === "Approved";
      }) > -1;
    },
    carModelsOfSelectedSegment: function carModelsOfSelectedSegment() {
      var _this2 = this;

      return _.filter(this.carModelList, function (model) {
        return _.findIndex(model.CarSegments, function (segment) {
          return segment.CarSegmentGuid === _this2.selectedCarSegment;
        }) > -1;
      });
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getShopperList(function (data) {
      _this3.shoppers = [];
      for (var guid in data) {
        _this3.shoppers.push({
          ShopperGuid: guid,
          ShopperName: data[guid]
        });
      }
    });

    this.globals.getCarSegmentList(function (data) {
      _this3.carSegmentList = data;
    });
    this.globals.getCarModelList(function (data) {
      _this3.carModelList = data;
    });

    $("#shopperProposalModal").on("hidden.bs.modal", function (e) {
      return _this3.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      this.selectedShopper = "";
      this.selectedShopperCar = "";
      this.selectedCarMatch = "=";
      $("#shopperProposalModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#shopperProposalModal").modal("hide");
    },
    showFeed: function showFeed(proposal) {
      this.globals.$emit("openFeedModal", {
        ItemGuid: proposal.ShopperProposalGuid,
        FeedType: "ShopperProposal",
        FeedName: "LeadAgencyLocalAgency"
      });
    },
    updateShopperData: function updateShopperData(proposal) {
      var _this4 = this;

      var query = "/api/Approval/ShopperProposal/" + proposal.ShopperProposalGuid;

      $.ajax({
        method: "PATCH",
        url: query,
        dataType: "json",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.SPM023);
          _this4.$emit("dataUpdated");
        },
        error: function error(_error) {
          console.error("Error on PATCH in updateShopperData()");
          _this4.globals.showErrorSnackbar(_this4.lang.SPM024);
        }
      });
    },
    addShopper: function addShopper() {
      var _this5 = this;

      var sendData = {
        SurveyInstanceGuid: this.check.SurveyInstanceGuid,
        ShopperGuid: this.selectedShopper,
        CarSegmentGuid: this.selectedCarSegment,
        CarModelGuid: this.selectedCarModel,
        CarMatch: this.selectedCarMatch
      };

      if (this.selectedCompetitorCar) {
        sendData.CompetitorCarModelGuid = this.selectedCompetitorCar;
        delete sendData.CarModelGuid;
      }

      var shopperCar = _.find(this.shopperCars, function (car) {
        return car.ValueGroupGuid === _this5.selectedShopperCar;
      });
      if (shopperCar) sendData.SelectedShopperGroupProperties = [{
        ValueGroupGuid: shopperCar.ValueGroupGuid,
        ShopperPropertyGroupGuid: shopperCar.ShopperPropertyGroupGuid
      }];

      var query = "api/Approval/ShopperProposal";
      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this5.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this5.globals.showSuccessSnackbar(_this5.lang.SPM025);
          _this5.selectedShopper = "";
          _this5.selectedShopperCar = "";
          _this5.$emit("dataUpdated");
        },
        error: function error(_error2) {
          console.error("Error on POST in addShopper()");
          _this5.globals.showErrorSnackbar(_this5.lang.SPM026);
        }
      });
    },
    deleteShopper: function deleteShopper(shopper) {
      var _this6 = this;

      this.globals.$off("DeleteShopperProposalYesConfirmation");
      this.globals.$on("DeleteShopperProposalYesConfirmation", function () {
        $.ajax({
          method: "DELETE",
          url: "api/Approval/ShopperProposal/" + shopper.ShopperProposalGuid,
          success: function success(data) {
            if (data.Error) {
              console.error(data.Error);
              _this6.globals.showErrorSnackbar(data.Error);
              return;
            }
            _this6.globals.showSuccessSnackbar(_this6.lang.SPM027);
            _this6.$emit("dataUpdated");
          },
          error: function error() {
            console.error("Error on DELETE in deleteShopper()");
            _this6.globals.showErrorSnackbar(_this6.lang.SPM028);
          }
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteShopperProposal",
        confirmationTitle: this.lang.SPM029,
        colorRed: true,
        yesButtonText: this.lang.SPM030,
        noButtonText: this.lang.SPM031,
        htmlText: "<p>" + this.lang.SPM032 + "</p>\n                  <p><b>" + shopper.DisplayName + "</b></p>"
      });
    },
    getShopperCars: function getShopperCars() {
      var _this7 = this;

      this.shopperCars = [];
      if (!this.selectedShopper) return;
      $.ajax({
        method: "GET",
        url: "api/ShopperProperty/AUDI/CarsOfShopper/" + this.selectedShopper,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.shopperCars = data;
        },
        error: function error() {
          console.error("Shopper car access failed in getShopperCars()");
          _this7.globals.showErrorSnackbar(_this7.lang.SPM033);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_IntegerInput__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormComponents_IntegerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FormComponents_IntegerInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_TextInput__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormComponents_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FormComponents_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_SingleSelectInput__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormComponents_SingleSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__FormComponents_SingleSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormComponents_MultiSelectInput__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormComponents_MultiSelectInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FormComponents_MultiSelectInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormComponents_CheckboxInput__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormComponents_CheckboxInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FormComponents_CheckboxInput__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var uuidv4 = __webpack_require__(32);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomePropertiesForm",
  components: {
    IntegerInput: __WEBPACK_IMPORTED_MODULE_4__FormComponents_IntegerInput___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_5__FormComponents_TextInput___default.a,
    SingleSelectInput: __WEBPACK_IMPORTED_MODULE_6__FormComponents_SingleSelectInput___default.a,
    MultiSelectInput: __WEBPACK_IMPORTED_MODULE_7__FormComponents_MultiSelectInput___default.a,
    CheckboxInput: __WEBPACK_IMPORTED_MODULE_8__FormComponents_CheckboxInput___default.a
  },
  props: {
    shopperGuid: {
      Type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      propertiesFormSchema: [],
      guidRegex: RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)
    };
  },
  created: function created() {
    this.getShopperPropertiesAsync();
  },

  methods: {
    updateShopperValues: function updateShopperValues(property, valueGroup, value) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      if (!valueObject) {
        valueObject = {
          ShopperPropertyGuid: property.Guid,
          ShopperValues: []
        };
        if (valueGroup) {
          if (!valueGroup.Values) valueGroup.Values = [];
          valueGroup.Values.push(valueObject);
        } else {
          if (!property.Values) property.Values = [];
          property.Values.push(valueObject);
        }
      }
      var newShopperValues = [{}];

      // Write current value to ShopperValues
      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          newShopperValues[0].TextValue = value;
          break;
        case "Checkbox":
          if (typeof value === "boolean") newShopperValues[0].BitValue = value;
          break;
        case "SingleSelect":
          if (this.guidRegex.test(value)) newShopperValues[0].ListValueGuid = value;else newShopperValues[0].ListCustomValue = value;
          break;
        case "MultiSelect":
          for (var i = 0; i < value.length; i++) {
            if (!newShopperValues[i]) newShopperValues[i] = {};
            if (this.guidRegex.test(value[i])) newShopperValues[i].ListValueGuid = value[i];else newShopperValues[i].ListCustomValue = value[i];
          }
          break;
      }

      // Restore old ValueGuids
      for (var _i = 0; _i < valueObject.ShopperValues.length; _i++) {
        if (valueObject.ShopperValues[_i].ValueGuid && newShopperValues[_i]) newShopperValues[_i].ValueGuid = valueObject.ShopperValues[_i].ValueGuid;
      }

      valueObject.ShopperValues = newShopperValues;
      this.$forceUpdate();
    },
    getShopperValues: function getShopperValues(property, valueGroup) {
      var valueObject = void 0;
      if (!valueGroup) valueObject = property.Values && property.Values[0];else {
        valueObject = _.find(valueGroup.Values, function (v) {
          return v.ShopperPropertyGuid === property.Guid;
        });
      }
      var sv = valueObject && valueObject.ShopperValues;

      switch (property.PropertyType) {
        case "Text":
        case "Integer":
          if (!sv || !sv[0] || !sv[0].TextValue) return "";
          return sv[0].TextValue;
        case "Checkbox":
          return sv && sv[0] && sv[0].BitValue;
        case "SingleSelect":
          if (!sv || !sv[0]) return "";
          return sv[0].ListValueGuid || sv[0].ListCustomValue || "";
        case "MultiSelect":
          if (!sv || !sv[0]) return [];
          var result = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(sv), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var el = _step.value;

              if (el.ListValueGuid) result.push(el.ListValueGuid);
              if (el.ListCustomValue) result.push(el.ListCustomValue);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return result;
      }
    },
    addDynamicGroup: function addDynamicGroup(dynamicGroup) {
      if (!dynamicGroup.ValueGroups) dynamicGroup.ValueGroups = [];
      var newValueGroupsEntry = {
        ValueGroupGuid: uuidv4(),
        Values: []
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(dynamicGroup.ChildProperties), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var prop = _step2.value;

          newValueGroupsEntry.Values.push({
            ShopperPropertyGuid: prop.Guid,
            ShopperValues: []
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      dynamicGroup.ValueGroups.push(newValueGroupsEntry);
      this.$forceUpdate();
    },
    removeDynamicGroup: function removeDynamicGroup(groupObj, guid) {
      _.remove(groupObj.ValueGroups, function (vg) {
        return vg.ValueGroupGuid === guid;
      });
      this.$forceUpdate();
    },
    getPropertyStoreObject: function getPropertyStoreObject() {
      var result = {
        Properties: []
      };
      this.propertiesFormSchema.forEach(function (topic) {
        if (topic.ChildProperties) topic.ChildProperties.forEach(function (secondLevelProp) {
          if (secondLevelProp.ValueGroups) result.Properties.push({
            ValueGroups: secondLevelProp.ValueGroups
          });else if (secondLevelProp.Values) result.Properties.push({ Values: secondLevelProp.Values });
        });
      });
      return result;
    },
    getShopperProperties: function getShopperProperties(_success, _error) {
      var _this = this;

      this.propertiesFormSchema = [];
      var queryString = "api/ShopperProperty/Shopper/" + (this.shopperGuid || "Sturcture");

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
          _success();
        },
        error: function error() {
          console.error("Error on GET in getShopperProperties()");
          _error();
        }
      });
    },

    /**
     * async version for error bubbeling
     */
    getShopperPropertiesAsync: function getShopperPropertiesAsync() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var queryString, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.propertiesFormSchema = [];
                queryString = "api/ShopperProperty/Shopper/" + (_this2.shopperGuid || "Sturcture");
                _context.next = 4;
                return $.ajax({
                  method: "GET",
                  url: queryString
                });

              case 4:
                data = _context.sent;

                _this2.propertiesFormSchema = !_.isEmpty(data) ? data.Properties : [];
                return _context.abrupt("return", data);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    saveShopperProperties: function saveShopperProperties(successCallback, errorCallback) {
      var payload = this.getPropertyStoreObject();
      if (!this.shopperGuid) return payload;
      var queryString = "api/ShopperProperty/Shopper/" + this.shopperGuid;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on PUT in saveShopperProperties()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_liquor_tree__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component("liquor-tree", __WEBPACK_IMPORTED_MODULE_2_liquor_tree__["a" /* default */]);
var baseLiquorTree = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].options.components["liquor-tree"];
var customLiquorTree = baseLiquorTree.extend({
  methods: {
    onDragStart: function onDragStart(e) {
      return true;
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertyEditModal",
  components: {
    liquortree: customLiquorTree,
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a,
    CustomPropertyListEditModal: __WEBPACK_IMPORTED_MODULE_4__CustomPropertyListEditModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyEditModal").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    $("#customPropertyEditModal").on("shown.bs.modal", function (e) {
      if (!_this.attentionMessageShown) _this.globals.$emit("openGlobalNotificationDialog", {
        initiator: "CustomPropertyEditModalAttentionMessage",
        notificationTitle: _this.lang.SM2015,
        colorRed: true,
        closeButtonText: _this.lang.SM2016,
        htmlText: "<p><b>" + _this.lang.SM2017 + "</b></p>"
      });
      _this.attentionMessageShown = true;
    });
  },

  props: ["showDialog"],
  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) this.openCustomPropertyEditDialog();else this.closeCustomPropertyEditDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      propertyTreeData: {},
      propertyTreeFilter: "",
      selectedPropertyNode: {},
      selectedPropertyNodeData: {},
      propertyTreeOptions: {
        parentSelect: true,
        multiple: false,
        propertyNames: {
          text: "Title",
          children: "ChildNodes"
        },
        filter: {
          matcher: function matcher(query, node) {
            return node.data.text.toLowerCase().indexOf(query.toLowerCase()) > -1;
          }
        }
      },
      draggingTreeNode: null,
      currentDropTargetId: null,
      currentTreeNodes: null,
      isTreeDirty: false,
      isCurrentNodeDirty: false,
      showPropertyListEditModal: false,
      attentionMessageShown: false,
      inputPropertyTypesList: ["Checkbox", "SingleSelect", "MultiSelect", "Text", "Integer"],
      lang: {
        SM2000: "Property Management",
        SM2001: "Search...",
        SM2002: "Add new topic",
        SM2003: "Save order",
        SM2004: "Type",
        SM2005: "Title",
        SM2006: "Input type",
        SM2007: "List",
        SM2008: "Edit selectable elements",
        SM2009: "Visible",
        SM2010: "Dynamic",
        SM2011: "Active",
        SM2012: "Insert new property",
        SM2013: "Insert new property group",
        SM2014: "Save unit",
        SM2015: "ATTENTION",
        SM2016: "OK",
        SM2017: "Changes in this view will have immediate impact on the user profile of all shoppers. So please be careful if you plan to save any changes.",
        SM2018: "Unsaved changes",
        SM2019: "Save",
        SM2020: "Discard",
        SM2021: "There are unsaved changes for the previous selected element. Do you want to save them?",
        SM2022: "Missing title",
        SM2023: "Element update successful",
        SM2024: "Element update failed",
        SM2025: "Order update successful",
        SM2026: "Order update failed",
        SM2027: "If an element is not visible, only MSM users can see it. It does not appear in the profile of shoppers.",
        SM2028: "Dynamic elements can have multiple entries in the shopper profile. Shoppers can add as many entries as they need.",
        SM2029: "If an element is inactive, it does never appear in the shopper profile. Even MSM users can not see it.",
        SM2030: "Topic",
        SM2031: "Group",
        SM2032: "Property",
        SM2033: "Discard changes",
        SM2034: "Recommended",
        SM2035: "A recommended property will be highlighted in the shopper profile",
        SM2036: "Allow custom values",
        SM2037: "In addition to the predefined values in the list the shopper is allowed to add custom values that are not part of the list.",
        SM2038: "Property tree data access failed",
        SM2039: "Property data access failed",
        SM2040: "Access denied"
      }
    };
  },

  methods: {
    ltDragStart: function ltDragStart(node, e) {
      e.dataTransfer.dropEffect = "move";
      this.draggingTreeNode = node;
      this.currentTreeNodes = $("#customPropertiesTreeContainer").find(".tree-node");
    },
    ltDragEnter: function ltDragEnter(node, e) {
      var dNode = this.draggingTreeNode;
      var borderStyle = "solid 2px red";
      var borderPosition = "border-bottom";
      var targetNodeId = null;

      if (node.id === dNode.id) return false;

      if (dNode.data.Type === "Topic") {
        var targetTopic = node;
        while (targetTopic.data.Type !== "Topic") {
          targetTopic = targetTopic.parent;
        }targetNodeId = targetTopic.id;
      } else if (dNode.data.Type === "Group") {
        if (node.parent && node.parent.data.Type === "Group") targetNodeId = node.parent.id;else if (node.data.Type === "Topic" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      } else {
        if (node.data.Type !== "Property" && node.children.length > 0) {
          targetNodeId = node.children[0].id;
          borderPosition = "border-top";
        } else targetNodeId = node.id;
      }

      if (targetNodeId === dNode.id) return false; // Do not drop node on itself

      $("#customPropertiesTreeContainer").find(".tree-node[data-id=\"" + targetNodeId + "\"]").css(borderPosition, borderStyle);
      this.currentDropTargetId = targetNodeId;
      return true;
    },
    ltDragLeave: function ltDragLeave(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
    },
    ltDragEnd: function ltDragEnd(node, e) {
      this.draggingTreeNode = null;
    },
    ltDrop: function ltDrop(node, e) {
      this.currentTreeNodes.css("border", "");
      this.currentDropTargetId = null;
      this.currentTreeNodes = null;

      var dNode = this.draggingTreeNode;

      if (dNode.id === node.id) {
        return;
      }

      // Avoid moving topic or group inside itself
      if (dNode.data.Type === "Topic" && node.parent && (node.parent.id === dNode.id || node.parent.parent && node.parent.parent.id === dNode.id)) return;
      if (dNode.data.Type === "Group" && node.parent && node.parent.id === dNode.id) return;

      dNode.remove(); // Remove on old position

      // Find new position and insert dragged node
      if (node.data.Type === "Topic") {
        if (dNode.data.Type === "Topic") node.after(dNode);else node.prepend(dNode);
      }

      if (node.data.Type === "Group") {
        if (dNode.data.Type === "Topic") node.parent.after(dNode);else if (dNode.data.Type === "Group") node.after(dNode);else node.prepend(dNode);
      }

      if (node.data.Type === "Property") {
        if (dNode.data.Type === "Topic") {
          if (node.parent.data.Type === "Topic") node.parent.after(dNode);else node.parent.parent.after(dNode);
        } else if (dNode.data.Type === "Group") {
          if (node.parent.data.Type === "Group") node.parent.after(dNode);else node.after(dNode);
        } else node.after(dNode);
      }
      dNode.select();
      if (dNode.parent) dNode.parent.expand();

      this.isTreeDirty = true;
    },
    initCustomPropertyEditModal: function initCustomPropertyEditModal() {
      this.propertyTreeFilter = "";
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
    },
    openCustomPropertyEditDialog: function openCustomPropertyEditDialog() {
      this.initCustomPropertyEditModal();
      this.getProperties();
      $("#customPropertyEditModal").modal("show");
    },
    closeCustomPropertyEditDialog: function closeCustomPropertyEditDialog() {
      var _this2 = this;

      if (this.isTreeDirty || this.isCurrentNodeDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this2.isTreeDirty = false;
          _this2.isCurrentNodeDirty = false;
          $("#customPropertyEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyEditModal").modal("hide");
    },
    getProperties: function getProperties() {
      var _this3 = this;

      var queryString = "api/ShopperProperty/Tree";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property data available");
            return;
          }
          _this3.propertyTreeData = {};
          _this3.$nextTick(function () {
            _this3.propertyTreeData = data;
            _this3.isTreeDirty = false;
            _this3.globals.doAfterNTicks(_this3, 2, function () {
              var treeRef = _this3.$refs.customPropertiesTree;
              if (!treeRef) return;
              treeRef.expandAll();
              var selectedProp = treeRef.find({
                data: { Guid: _this3.selectedPropertyNodeData.Guid }
              });
              if (selectedProp) {
                selectedProp.select();
                _this3.$nextTick(function () {
                  var el = document.querySelector("li[data-id=\"" + selectedProp[0].id + "\"]");
                  var container = document.getElementById("customPropertiesTreeContainer");
                  if (!el || !container) return;
                  var nodeVisible = _this3.globals.isNodeVisibleInDOM(el, container, false);
                  if (!nodeVisible) el.scrollIntoView({ behavior: "smooth" });
                });
              }
            });
          });
        },
        error: function error() {
          console.error("Property data access failed in getProperties()");
          _this3.globals.showErrorSnackbar(_this3.lang.SM2038);
        }
      });
    },
    getPropertyData: function getPropertyData() {
      var _this4 = this;

      var queryString = "api/ShopperProperty/Property/" + this.selectedPropertyNode.data.Guid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property data available");
          }
          _this4.selectedPropertyNodeData = data;
          _this4.isCurrentNodeDirty = false;
        },
        error: function error() {
          console.error("Property data access failed in getPropertyData()");
          _this4.globals.showErrorSnackbar(_this4.lang.SM2039);
        }
      });
    },
    onPropertySelected: function onPropertySelected(node) {
      var _this5 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Read")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Read");
        return;
      }

      if (this.isCurrentNodeDirty) {
        this.globals.$off("CustomPropertyUnsavedChangesYesConfirmation");
        this.globals.$once("CustomPropertyUnsavedChangesYesConfirmation", function () {
          _this5.saveCurrentNode();
          _this5.isCurrentNodeDirty = false;
        });
        this.globals.$off("CustomPropertyUnsavedChangesCloseDialog");
        this.globals.$once("CustomPropertyUnsavedChangesCloseDialog", function () {
          _this5.selectedPropertyNode = node;
          _this5.getPropertyData();
        });
        this.globals.$emit("openGlobalConfirmationDialog", {
          initiator: "CustomPropertyUnsavedChanges",
          confirmationTitle: this.lang.SM2018,
          colorRed: true,
          yesButtonText: this.lang.SM2019,
          noButtonText: this.lang.SM2020,
          htmlText: "<p><b>" + this.lang.SM2021 + "</b></p>"
        });
        return;
      }
      this.selectedPropertyNode = node;
      this.getPropertyData();
    },
    discardCurrentNodeChanges: function discardCurrentNodeChanges() {
      if (this.selectedPropertyNode.id) {
        var node = this.$refs.customPropertiesTree.find({
          id: this.selectedPropertyNode.id
        });
        node.unselect();
      }
      this.selectedPropertyNode = {};
      this.selectedPropertyNodeData = {};
      this.isCurrentNodeDirty = false;
    },
    nodeDataChanged: function nodeDataChanged() {
      this.isCurrentNodeDirty = true;
    },
    insertNewNode: function insertNewNode(type) {
      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Create")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Create");
        return;
      }

      if (!type) return;

      var newNode = {};
      newNode.Type = type;
      newNode.Visible = false;
      newNode.Active = false;

      if (type !== "Topic") {
        newNode.ParentGuid = this.selectedPropertyNodeData.Guid;
        newNode.Dynamic = false;
      }
      if (type === "Property") {
        newNode.PropertyType = "Text";
        newNode.AllowCustomValues = false;
      }
      if (type === "Group") {
        newNode.Dynamic = true;
      }

      this.selectedPropertyNodeData = newNode;
    },
    cleanUpSelectedNode: function cleanUpSelectedNode() {
      if (this.selectedPropertyNodeData.PropertyType !== "SingleSelect" && this.selectedPropertyNodeData.PropertyType !== "MultiSelect") {
        delete this.selectedPropertyNodeData.AllowCustomValues;
        delete this.selectedPropertyNodeData.ListGuid;
      }
    },
    saveCurrentNode: function saveCurrentNode() {
      var _this6 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      if (!this.selectedPropertyNodeData.Title) {
        this.globals.showErrorSnackbar(this.lang.SM2022);
        return;
      }

      this.cleanUpSelectedNode();

      var method = this.selectedPropertyNodeData.Guid ? "PUT" : "POST";
      var url = "api/ShopperProperty/Property/" + (this.selectedPropertyNodeData.Guid || "");
      var dataString = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedPropertyNodeData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this6.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this6.globals.showSuccessSnackbar(_this6.lang.SM2023);
          if (method === "POST") _this6.selectedPropertyNodeData = data;
          _this6.isCurrentNodeDirty = false;
          _this6.getProperties();
        },
        error: function error() {
          console.error("Error on POST in saveCurrentNode()");
          _this6.globals.showErrorSnackbar(_this6.lang.SM2024);
        }
      });
    },
    saveTree: function saveTree() {
      var _this7 = this;

      if (!this.globals.isAccessAllowed("LoopOp_ShopperProperties_Update")) {
        this.globals.showErrorSnackbar(this.lang.SM2040);
        console.error("Access denied: LoopOp_ShopperProperties_Update");
        return;
      }

      var url = "api/ShopperProperty/Tree";
      var treeData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Nodes: this.createTreeJSON() });

      $.ajax({
        method: "PUT",
        url: url,
        data: treeData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this7.isTreeDirty = false;
          _this7.globals.showSuccessSnackbar(_this7.lang.SM2025);
        },
        error: function error() {
          console.error("Error on POST in saveTree()");
          _this7.globals.showErrorSnackbar(_this7.lang.SM2026);
        }
      });
    },
    createTreeJSON: function createTreeJSON() {
      var treeJSON = this.$refs.customPropertiesTree.toJSON();

      var transformNode = function transformNode(node) {
        var newNode = {
          Title: node.text,
          data: node.data
        };
        if (newNode.data.text) delete newNode.data.text;
        if (node.children.length > 0) newNode.ChildNodes = _.map(node.children, transformNode);

        return newNode;
      };

      for (var i = 0; i < treeJSON.length; i++) {
        treeJSON[i] = transformNode(treeJSON[i]);
      }

      return treeJSON;
    },
    getTypeTranslation: function getTypeTranslation(type) {
      switch (type) {
        case "Topic":
          return this.lang.SM2030;
        case "Group":
          return this.lang.SM2031;
        case "Property":
          return this.lang.SM2032;
        default:
          return type;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertyListEditModal",
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#customPropertyListEditModal").on("hide.bs.modal", function (e) {
      _this.$emit("modalClosing");
    });
  },

  props: ["showModal", "listGuid"],
  watch: {
    showModal: function showModal(newValue) {
      if (newValue) this.openListEditModal();else this.closeListEditModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      propertyListAddData: "",
      propertyListAddEnabled: false,
      propertyListData: {},
      isPropertyListDataDirty: false,
      hasPropertyListError: false,
      selectedListItems: [],
      lang: {
        SM2500: "Edit selection list",
        SM2501: "Add new entries",
        SM2502: "Select all",
        SM2503: "Unselect all",
        SM2504: "Remove selected",
        SM2505: "Hide selected",
        SM2506: "Show selected",
        SM2507: "Item",
        SM2508: "Actions",
        SM2509: "Close",
        SM2510: "Save",
        SM2511: "List update successful",
        SM2512: "List update failed",
        SM2513: "Empty values are not allowed",
        SM2514: "Value already exists"
      }
    };
  },

  methods: {
    openListEditModal: function openListEditModal() {
      this.propertyListAddData = "";
      this.propertyListAddEnabled = false;
      this.propertyListData = {};
      this.isPropertyListDataDirty = false;
      this.hasPropertyListError = false;
      this.selectedListItems = [];
      this.getPropertyListItems();
      $("#customPropertyListEditModal").modal("show");
    },
    closeListEditModal: function closeListEditModal() {
      var _this2 = this;

      if (this.isPropertyListDataDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this2.isPropertyListDataDirty = false;
          $("#customPropertyListEditModal").modal("hide");
        });
        return;
      }
      $("#customPropertyListEditModal").modal("hide");
    },
    showAddPropertyListInput: function showAddPropertyListInput() {
      this.propertyListAddEnabled = true;
      this.toggleSelectAllEntries(true);
      this.$nextTick(function () {
        $("#textareaPropertyList").focus();
      });
    },
    getPropertyListItems: function getPropertyListItems() {
      var _this3 = this;

      if (!this.listGuid) {
        //No list created yet
        return;
      }

      var queryString = "api/ShopperProperty/List/" + this.listGuid;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          if (!data) {
            console.error("No property list data available");
          }
          _this3.propertyListData = data;
          _this3.sortPropertyValues();
        },
        error: function error() {
          console.error("Property list access failed in getPropertyListItems()");
          _this3.globals.showErrorSnackbar("Property list access failed");
        }
      });
    },
    storePropertyListItems: function storePropertyListItems() {
      var _this4 = this;

      var method = this.listGuid ? "PUT" : "POST";
      var url = "api/ShopperProperty/List/" + (this.listGuid || "");
      this.sortPropertyValues();
      var dataString = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.propertyListData);

      $.ajax({
        method: method,
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar(_this4.lang.SM2511);
          _this4.isPropertyListDataDirty = false;
          if (method === "POST") _this4.$emit("propertyListCreated", data.ListGuid);
          _this4.closeListEditModal();
        },
        error: function error() {
          console.error("Error on " + method + " in storePropertyListItems()");
          _this4.globals.showErrorSnackbar(_this4.lang.SM2512);
        }
      });
    },
    addNewPropertyListEntries: function addNewPropertyListEntries() {
      this.propertyListAddEnabled = false;
      if (!this.propertyListAddData) return;

      var entries = _.split(this.propertyListAddData, "\n");
      this.propertyListAddData = "";
      if (!this.propertyListData.Values) this.propertyListData.Values = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(entries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;

          if (entry && !this.isEntryInList(entry)) this.propertyListData.Values.push({ Value: entry, selected: true });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.isPropertyListDataDirty = true;
      this.selectedListItems = [];
      this.sortPropertyValues();
    },
    isEntryInList: function isEntryInList(entry) {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["Value", entry]) > -1;
    },
    sortPropertyValues: function sortPropertyValues() {
      this.propertyListData.Values = _.sortBy(this.propertyListData.Values, [function (val) {
        return val.Value.toLowerCase();
      }]);
    },
    toggleSelectAllEntries: function toggleSelectAllEntries(clear) {
      var value = clear ? false : !this.allEntriesSelected();
      _.forEach(this.propertyListData.Values, function (val) {
        val.selected = value;
      });
      this.$forceUpdate();
    },
    isAnyEntrySelected: function isAnyEntrySelected() {
      if (!this.propertyListData.Values) return false;
      return _.findIndex(this.propertyListData.Values, ["selected", true]) > -1;
    },
    allEntriesSelected: function allEntriesSelected() {
      if (this.propertyListData.Values) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.propertyListData.Values), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _val = _step2.value;

            if (!_val.selected) return false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else return false;
      return true;
    },
    removeSelectedEntries: function removeSelectedEntries() {
      if (this.propertyListData.Values) {
        _.remove(this.propertyListData.Values, function (val) {
          return !!val.selected;
        });
        this.isPropertyListDataDirty = true;
        this.$forceUpdate();
      }
    },
    removeEntry: function removeEntry(index) {
      _.pullAt(this.propertyListData.Values, index);
      this.$forceUpdate();
    },
    editEntry: function editEntry(e) {
      var input = $(e.target).closest("tr").find("input");
      if (!this.hasPropertyListError) input.prop("readonly", "");
      input.focus();
    },
    allSelectedEntriesVisible: function allSelectedEntriesVisible() {
      if (this.propertyListData.Values) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.propertyListData.Values), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _val2 = _step3.value;

            if (_val2.selected && !_val2.Visible) return false;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else return false;
      return true;
    },
    toggleVisibilityOfSelectedEntries: function toggleVisibilityOfSelectedEntries() {
      var visible = !this.allSelectedEntriesVisible();
      this.propertyListData.Values.forEach(function (val) {
        if (val.selected) val.Visible = visible;
      });
      this.isPropertyListDataDirty = true;
      this.$forceUpdate();
    },
    propertyListEntryChanged: function propertyListEntryChanged(e, index) {
      var _this5 = this;

      if (e.target.readOnly) return;

      var newValue = e.target.value;
      var values = this.propertyListData.Values;

      var onError = function onError() {
        values[index].error = true;
        _this5.hasPropertyListError = true;
        _this5.editEntry(e);
        _this5.$forceUpdate();
      };

      if (!newValue) {
        onError();
        this.globals.showErrorSnackbar(this.lang.SM2513);
        return;
      }

      for (var i = 0; i < values.length; i++) {
        if (i !== index && values[i].Value === newValue) {
          onError();
          this.globals.showErrorSnackbar(this.lang.SM2514);
          return;
        }
      }

      delete values[index].error;
      this.hasPropertyListError = false;
      this.$forceUpdate();
      e.target.readOnly = "true";
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CheckboxInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: Boolean, default: undefined },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue() {
      if (this.readOnly) return;
      var result = void 0;
      if (this.value === true) result = false;else if (this.value === false) result = undefined;else result = true;
      this.$emit("input", result);
    }
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "IntegerInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MultiSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: Array, default: function _default() {
        return [];
      } },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    }
  },
  data: function data() {
    return {
      Value: []
    };
  },
  mounted: function mounted() {
    this.Value = this.value;
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SingleSelectInput",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_0__Tools_Select2___default.a },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: function _default() {
        return [];
      } },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: String, default: "" },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(newValue) {
      this.$emit("input", newValue);
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TextInput",
  props: {
    Title: String,
    Guid: String,
    Recommended: { type: Boolean, default: false },
    value: { type: String, default: "" },
    index: { type: Number, default: -1 },
    readOnly: { type: Boolean, default: false }
  },
  methods: {
    updateValue: function updateValue(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2__);



var _name$components$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = (_name$components$prop = {
  name: "ShopperCheckManagement",
  components: {
    CheckPaymentModal: __WEBPACK_IMPORTED_MODULE_2__CheckManagement_CheckPaymentModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2___default.a
  },
  props: ["selectedShopperGuid"],
  data: function data() {
    return {
      searchString: "",
      refreshEnabled: false,
      showCheckPaymentModal: false,
      shopperCheckList: [],
      filteredShopperChecklist: [],
      shopperChecksOnCurrentPage: [],
      selectedPage: 1,
      pageSize: 20,
      selectedCheckGuid: "",
      settlementStatusses: {},
      shopperData: {},
      selectedShopper: {},
      selectedChecks: [],
      checkStates: [100, 110, 120],
      lastSelectedCheck: -1,
      currentSort: { key: "SurveyInstanceStatusId", asc: true },
      filterStrings: {
        SurveyInstanceId: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        ClientName: "",
        ImporterName: "",
        LocationName: "",
        LocationAddress: "",
        LocationCountry: "",
        SurveyInstanceStatusId: "",
        SettlementState: "",
        SettlementNumber: "",
        SettlementDate: ""
      },
      lang: {
        SM4000: "Refresh",
        SM4001: "Close",
        SM4002: "Search...",
        SM4003: "Check ID",
        SM4004: "Export",
        SM4005: "Project",
        SM4006: "Wave",
        SM4007: "Scenario",
        SM4008: "Client",
        SM4009: "Location Name",
        SM4010: "Check State",
        SM4011: "Location Address",
        SM4012: "Location Country",
        SM4013: "Payoff State",
        SM4014: "Payoff Number",
        SM4015: "Payoff Date",
        SM4016: "Filter",
        SM4017: "Shopper Checks Export",
        SM4018: "Download",
        SM4019: "Cancel",
        SM4020: "Export checks from shopper",
        SM4021: "Payments",
        SM4022: "Importer",
        SM4023: "Items per page",
        SM4024: "First page",
        SM4025: "Last page",
        SM4026: "Total checks count",
        SM4027: "Check data request failed",
        SM4028: "Shopper data request failed",
        SM4029: "Check export failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this = this;

      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.settlementStatusses = {};
      this.filterStrings.SettlementState = "";
      this.globals.getSettlementStatusses(function (data) {
        _this.settlementStatusses = data;
        _this.getShopperCheckList();
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getSettlementStatusses(function (data) {
        _this2.settlementStatusses = data;
      });
    }
    this.getShopperInformation();
    this.getShopperCheckList();

    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    this.globals.$off("ShopperCheckExportYesConfirmation");
    this.globals.$on("ShopperCheckExportYesConfirmation", function () {
      _this2.exportSelectedShopperChecks();
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "destroyed", function destroyed() {
  this.writeComponentSettingsToStore();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$prop, "methods", {
  readComponentSettingsFromStore: function readComponentSettingsFromStore() {
    if (!this.$store.getters["userSettings/rememberFilters"]) return;

    if (!this.$store.getters["userSettings/syncFilters"]) return;
    if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
      var storedClient = this.$store.getters["sharedFilters/client"];
      if (storedClient.ClientName) {
        this.filterStrings.ClientName = this.globals.removeWildcardsFromString(storedClient.ClientName);
      } else this.filterStrings.ClientName = "";
    } else {
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (storedImporter.ImporterName) {
        this.filterStrings.ImporterName = this.globals.removeWildcardsFromString(storedImporter.ImporterName);
      } else this.filterStrings.ImporterName = "";
    }

    var storedProject = this.$store.getters["sharedFilters/project"];
    if (storedProject.ProjectName) {
      this.filterStrings.ProjectName = this.globals.removeWildcardsFromString(storedProject.ProjectName);
    } else this.filterStrings.ProjectName = "";
  },
  writeComponentSettingsToStore: function writeComponentSettingsToStore() {
    if (!this.$store.getters["userSettings/rememberFilters"]) return;

    if (!this.$store.getters["userSettings/syncFilters"]) return;
    if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
      var storedClient = this.$store.getters["sharedFilters/client"];
      if (this.globals.removeWildcardsFromString(storedClient.ClientName) !== this.filterStrings.ClientName) {
        this.$store.commit("sharedFilters/client", {
          ClientName: this.globals.addWildcardsToString(this.filterStrings.ClientName)
        });
      }
    } else {
      var storedImporter = this.$store.getters["sharedFilters/importer"];
      if (this.globals.removeWildcardsFromString(storedImporter.ImporterName) !== this.filterStrings.ImporterName) {
        this.$store.commit("sharedFilters/importer", {
          ImporterName: this.globals.addWildcardsToString(this.filterStrings.ImporterName)
        });
      }
    }

    var storedProject = this.$store.getters["sharedFilters/project"];
    if (this.globals.removeWildcardsFromString(storedProject.ProjectName) !== this.filterStrings.ProjectName) {
      this.$store.commit("sharedFilters/project", {
        ProjectName: this.globals.addWildcardsToString(this.filterStrings.ProjectName)
      });
    }
  },
  getShopperCheckList: function getShopperCheckList() {
    var _this3 = this;

    var queryString = "api/Shopper/" + this.selectedShopperGuid + "/SurveyInstances";
    this.refreshEnabled = false;

    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this3.shopperCheckList = [];
        if (!_.isEmpty(data)) _this3.shopperCheckList = data;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.shopperCheckList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var check = _step.value;

            if (check.SettlementDate) check.SettlementDate = _this3.globals.getLocalizedDateFromIsoTimestamp(check.SettlementDate);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this3.setSettlementsStates();
        _this3.doFiltering();
      },
      error: function error() {
        console.error("Error on GET in getShopperCheckList()");
        _this3.globals.showErrorSnackbar(_this3.lang.SM4027);
      },
      complete: function complete() {
        _this3.refreshEnabled = true;
      }
    });
  },
  getShopperInformation: function getShopperInformation() {
    var _this4 = this;

    var queryString = "api/Shopper/" + this.selectedShopperGuid;

    $.ajax({
      method: "GET",
      url: queryString,
      success: function success(data) {
        _this4.shopperData = data;
      },
      error: function error() {
        console.error("Error on GET in getShopperInformation()");
        _this4.globals.showErrorSnackbar(_this4.lang.SM4028);
      }
    });
  },
  setSettlementsStates: function setSettlementsStates() {
    var _this5 = this;

    if (_.isEmpty(this.settlementStatusses)) {
      // Wait for request
      setTimeout(function () {
        _this5.setSettlementsStates();
      }, 500);
      return;
    }

    this.shopperCheckList.forEach(function (check) {
      if (check.SurveyInstanceStatusId < 120) check.SettlementState = "-";else check.SettlementState = _this5.settlementStatusses[check.SettlementStatusGuid];
    });
    this.$forceUpdate();
  },
  setTableHeight: function setTableHeight() {
    this.$nextTick(function () {
      var height = $(window).height();
      height -= $("#shoppercheckmanagement-top-panel").height() + $("#app-navbar").height() +
      // $("#shoppercheckmanagement .main-table > thead").height() +
      47;
      $("#shoppercheckmanagement .main-table-scrollbar").css("max-height", height);
      $("#shoppercheckmanagement .table-space").css("max-height", height);
      //Sets top-property for filter, so it doesnt scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    });
  },
  doFiltering: function doFiltering() {
    var _this6 = this;

    // Reset filtering when search string is empty
    if (this.searchString) this.filteredShopperChecklist = this.shopperCheckList;

    var words = this.searchString.split(" ");
    var keys = ["SurveyInstanceId", "ProjectName", "WaveName", "ScenarioName", "ClientName", "ImporterName", "LocationName", "LocationAddress", "LocationCountry", "SurveyInstanceStatusId", "SettlementState", "SettlementNumber", "SettlementDate"];

    var surveyFilter = function surveyFilter(survey) {
      var containsSearch = false;
      words.forEach(function (word) {
        keys.forEach(function (key) {
          if (survey[key] && survey[key].toString().toLowerCase().indexOf(word.toLowerCase()) > -1) {
            containsSearch = true;
            return;
          }
        });
      });
      if (!containsSearch) return false;
      keys.forEach(function (key) {
        if (!containsSearch) return;
        if (!survey[key] && _this6.filterStrings[key] || survey[key] && survey[key].toString().toLowerCase().indexOf(_this6.filterStrings[key].toLowerCase()) < 0) {
          containsSearch = false;
          return;
        }
      });
      return containsSearch;
    };
    this.filteredShopperChecklist = !_.isEmpty(this.shopperCheckList) ? this.shopperCheckList.filter(surveyFilter) : [];
    this.currentSort.asc = !this.currentSort.asc;
    this.orderTableByColumn(this.currentSort.key);
  },
  showSortArrow: function showSortArrow(key, asc) {
    return this.currentSort.key === key && this.currentSort.asc === asc;
  },
  orderTableByColumn: function orderTableByColumn(orderProp) {
    var _this7 = this;

    if (!orderProp && !this.currentSort.key) return;
    if (orderProp) {
      this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
    }
    if (orderProp === "SurveyInstanceStatusId") {
      this.orderCheckStateColumn();
    } else {
      var sortFunction = function sortFunction(check) {
        if (typeof check[_this7.currentSort.key] === "string") {
          return check[_this7.currentSort.key].toLowerCase();
        }
        return check[_this7.currentSort.key];
      };
      this.filteredShopperChecklist = _.orderBy(this.filteredShopperChecklist, [sortFunction], [this.currentSort.asc ? "asc" : "desc", "asc"]);
    }
    this.loadCurrentPageOfShopperChecks();
    this.$nextTick(function () {
      _this7.setTableHeight();
    });
  },
  orderCheckStateColumn: function orderCheckStateColumn() {
    var checkStateSortOrder = [110, 100, 120];
    var ordering = {};
    checkStateSortOrder.forEach(function (element, index) {
      return ordering[element] = index;
    });
    this.currentSort.asc ? this.filteredShopperChecklist.sort(function (a, b) {
      return ordering[a.SurveyInstanceStatusId] - ordering[b.SurveyInstanceStatusId];
    }) : this.filteredShopperChecklist.sort(function (a, b) {
      return ordering[b.SurveyInstanceStatusId] - ordering[a.SurveyInstanceStatusId];
    });
    this.loadCurrentPageOfShopperChecks();
  },

  // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
  getVisiblePages: function getVisiblePages() {
    if (this.numberOfPages() <= 7) {
      return _.range(1, this.numberOfPages() + 1);
    } else if (this.numberOfPages() > 7 && this.selectedPage <= 4) {
      return _.range(1, 7);
    } else if (this.numberOfPages() > 7 && this.selectedPage >= this.numberOfPages() - 3) {
      return _.range(this.numberOfPages() - 5, this.numberOfPages() + 1);
    } else {
      return _.range(this.selectedPage - 2, this.selectedPage + 3);
    }
  },
  updatePaging: function updatePaging(pageNumber, pageSize) {
    this.selectedPage = pageNumber;
    if (pageSize != 0) this.pageSize = pageSize;
    this.loadCurrentPageOfShopperChecks();
  },

  // Returns the count of pages depending on the selected pagesize and the length of the client data list
  numberOfPages: function numberOfPages() {
    if (this.pageSize == -1) return 1;
    if (this.filteredShopperChecklist.length % this.pageSize == 0) return this.filteredShopperChecklist.length / this.pageSize;else return parseInt(this.filteredShopperChecklist.length / this.pageSize) + 1;
  },
  loadCurrentPageOfShopperChecks: function loadCurrentPageOfShopperChecks() {
    if (this.pageSize == -1) this.shopperChecksOnCurrentPage = this.filteredShopperChecklist;else {
      // Display all data, no pages
      this.shopperChecksOnCurrentPage = [];
      var startIndex = (this.selectedPage - 1) * this.pageSize;
      for (var i = startIndex; i < startIndex + this.pageSize; i++) {
        if (this.filteredShopperChecklist[i] != null) this.shopperChecksOnCurrentPage[i - startIndex] = this.filteredShopperChecklist[i];
      }
    }
  },
  openShopperCheckExportConfirmationDialog: function openShopperCheckExportConfirmationDialog() {
    this.globals.$emit("openGlobalConfirmationDialog", this.getExportShopperData());
  },
  getExportShopperData: function getExportShopperData() {
    return {
      initiator: "ShopperCheckExport",
      confirmationTitle: this.lang.SM4017,
      yesButtonText: this.lang.SM4018,
      noButtonText: this.lang.SM4019,
      htmlText: "<p>" + this.lang.SM4020 + ": " + this.shopperData.LastName + ", " + this.shopperData.FirstName + " (" + this.shopperData.Username + ")</p>"
    };
  },
  exportSelectedShopperChecks: function exportSelectedShopperChecks() {
    var _this8 = this;

    $.ajax({
      method: "GET",
      url: "api/Shopper/" + this.selectedShopperGuid + "/SurveyInstances/Export",
      success: function success(data) {
        if (data.Error) {
          _this8.globals.showErrorSnackbar(data.Error);
          console.error(data.Error);
          return;
        }

        if (data[0] && data[0].DownloadId) _this8.globals.downloadFile(data[0].DownloadId);
      },
      error: function error() {
        console.error("Error on GET in exportSelectedShopperChecks()");
        _this8.globals.showErrorSnackbar(_this8.lang.SM4029);
      }
    });
  },
  selectChecks: function selectChecks(checkGuid, e) {
    var _this9 = this;

    if (!e) return;

    if (e.ctrlKey && !e.shiftKey) {
      var idx = _.indexOf(this.selectedChecks, checkGuid);
      if (idx > -1) {
        _.pullAt(this.selectedChecks, idx);
        this.lastSelectedCheck = -1;
      } else {
        this.selectedChecks.push(checkGuid);
        this.lastSelectedCheck = checkGuid;
      }
    } else if (!e.ctrlKey && e.shiftKey) {
      document.getSelection().removeAllRanges();
      if (this.lastSelectedCheck < 0) return;

      var idx1 = _.findIndex(this.shopperChecksOnCurrentPage, function (c) {
        return c.SurveyInstanceGuid == _this9.lastSelectedCheck;
      });
      var idx2 = _.findIndex(this.shopperChecksOnCurrentPage, function (c) {
        return c.SurveyInstanceGuid == checkGuid;
      });

      if (idx1 > idx2) {
        ;

        var _ref = [idx1, idx2];
        idx2 = _ref[0];
        idx1 = _ref[1];
      }for (var i = idx1; i <= idx2; i++) {
        if (!this.isCheckSelected(this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid)) this.selectedChecks.push(this.shopperChecksOnCurrentPage[i].SurveyInstanceGuid);
      }
    } else {
      this.selectedChecks = [checkGuid];
      this.lastSelectedCheck = checkGuid;
    }
    this.$forceUpdate();
  },
  isCheckSelected: function isCheckSelected(checkGuid) {
    return _.indexOf(this.selectedChecks, checkGuid) > -1;
  }
}), _name$components$prop);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomPropertiesForm__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CustomPropertiesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CustomPropertiesForm__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperDataEditModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a,
    CustomPropertiesForm: __WEBPACK_IMPORTED_MODULE_5__CustomPropertiesForm___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
      this.globals.getRegionsList(function (data) {
        return _this.regions = data;
      });
    }

    $("#editShopperDialog").on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });

    this.fpBirthdate = flatpickr("#inputShopperBirthdate", this.globals.flatpickrDateConfig);
  },
  destroyed: function destroyed() {
    if (this.fpBirthdate) this.fpBirthdate.destroy();
  },

  props: ["showDialog", "occupationalGroupList", "dialogModeAdd", "selectedShopperGuid"],
  computed: {
    regionsOfSelectedCountry: function regionsOfSelectedCountry() {
      var _this2 = this;

      if (!this.editShopperData.CountryCode) return [];
      var resultObj = this.regions.filter(function (country) {
        return country.CountryCode === _this2.editShopperData.CountryCode;
      });
      var regions = resultObj[0] && resultObj[0].Regions || [];

      if (this.editShopperData.RegionGuid && _.findIndex(regions, function (r) {
        return r.RegionGuid === _this2.editShopperData.RegionGuid;
      }) < 0) this.editShopperData.RegionGuid = "";

      return regions;
    }
  },
  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openEditShopperDialog() : this.closeEditShopperDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this3 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
      this.globals.getRegionsList(function (data) {
        return _this3.regions = data;
      });
    }
  },
  data: function data() {
    return {
      loading: false,
      dialogTitle: "",
      invalidInputIds: [],
      fpBirthdate: null,
      profilePictureFileObject: {},
      shopperPicture: {
        fileGuid: "",
        fileName: ""
      },
      regions: [],
      editShopperData: {
        Active: true,
        ShopperSkillLevel: 3,
        Salutation: "",
        FirstName: "",
        LastName: "",
        Address1: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        RegionGuid: "",
        Birthdate: "",
        Email: "",
        Phone1: "",
        Phone2: "",
        OccupationalGroupGuid: "", // Berufsgruppe
        Occupation: "", // Tätig als
        Employer: "", // Tätig bei
        Gender: "",
        // VatNo: "",
        ProfilePictureGuid: ""
      },
      bankDetailsData: {},
      lang: {
        SM1000: "New Shopper",
        SM1001: "Edit Shopper",
        SM1002: "Shopper Information",
        SM1003: "Salutation", // form of adress
        SM1004: "Please select...",
        SM1005: "Madam",
        SM1006: "Monsieur",
        SM1007: "Close",
        SM1008: "Save",
        SM1009: "This is a required entry!",
        SM1010: "First name",
        SM1011: "Last name",
        SM1012: "Street",
        SM1013: "Postal Code",
        SM1014: "City",
        SM1015: "Country",
        SM1016: "Birthday",
        SM1017: "Email",
        SM1018: "Phone",
        SM1019: "Alternative Phone",
        SM1020: "Career",
        SM1021: "Profession",
        SM1022: "Active by",
        SM1023: "Got attention by",
        SM1024: "Picture",
        SM1025: "Please choose a picture...",
        SM1026: "Choose picture",
        SM1027: "Download picture",
        SM1028: "Delete picture",
        SM1029: "Gender",
        SM1030: "Male",
        SM1031: "Female",
        SM1032: "VAT No.",
        SM1033: "Divers",
        SM1034: "Form validation failed",
        SM1035: "Bank Details",
        SM1036: "Bank Name",
        SM1037: "BIC",
        SM1038: "IBAN",
        SM1039: "Account owner",
        SM1040: "Custom Properties",
        SM1041: "VAT No.",
        SM1042: "VAT not mandatory",
        SM1043: "Social security number",
        SM1044: "Administration",
        SM1045: "Account status",
        SM1046: "Activated",
        SM1047: "Deactivated",
        SM1048: "Username",
        SM1049: "Experience level",
        SM1050: "simple projects",
        SM1051: "difficult projects",
        SM1052: "Previous Shopper ID",
        SM1053: "Show shopper history",
        SM1054: "Region"
      }
    };
  },

  methods: {
    editShopperDataOccupationalGroupGuidChanged: function editShopperDataOccupationalGroupGuidChanged(val) {
      this.editShopperData.OccupationalGroupGuid = val;
      this.validateInput("inputShopperOccupationGroup");
    },
    editShopperDataRegionGuidChanged: function editShopperDataRegionGuidChanged(val) {
      this.editShopperData.RegionGuid = val;
      this.validateInput("inputShopperRegion");
    },
    prepareAddDialog: function prepareAddDialog() {
      var _this4 = this;

      this.dialogTitle = this.lang.SM1000;
      this.initEditShopperDialog();
      if (this.$refs.customPropertiesForm) {
        this.$nextTick(function () {
          // might be unecesary as we call it on created
          _this4.$refs.customPropertiesForm.getShopperPropertiesAsync().then(function () {
            $("#editShopperDialog").modal("show");
          }).catch(function () {
            _this4.globals.showErrorSnackbar("Shopper property data request failed");
            _this4.$emit("dialogClosed");
          });
        });
      }
    },
    prepareEditDialog: function prepareEditDialog() {
      var _this5 = this;

      this.dialogTitle = this.lang.SM1001;
      this.loading = true;

      this.getSelectedShopper().then(this.getBankDetails).then(function () {
        $("#editShopperDialog").modal("show");
        _this5.resetValidationErrors("editShopperDialog");
      }).catch(function (err) {
        if (err.statusText || err.message) {
          var msg = err.statusText || err.message;
          _this5.globals.showErrorSnackbar("Error while preparing ShopperData:" + msg);
        } else {
          _this5.globals.showErrorSnackbar("Error while preparing ShopperData:");
          _this5.$emit("dialogClosed");

          console.error(err);
        }
      }).finally(function () {
        return _this5.loading = false;
      });
    },
    openEditShopperDialog: function openEditShopperDialog() {
      this.bankDetailsData = {};
      if (this.dialogModeAdd) {
        this.prepareAddDialog();
      } else {
        this.prepareEditDialog();
      }
      this.resetValidationErrors("editShopperDialog");
    },
    getSelectedShopper: function getSelectedShopper() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var queryString, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryString = "api/Shopper/" + _this6.selectedShopperGuid;
                _context.next = 3;
                return $.ajax({
                  method: "GET",
                  url: queryString
                });

              case 3:
                data = _context.sent;


                _this6.editShopperData = data;
                if (!_this6.editShopperData.Salutation) _this6.editShopperData.Salutation = "";
                if (_this6.editShopperData.Birthdate) _this6.fpBirthdate.setDate(_this6.editShopperData.Birthdate);
                return _context.abrupt("return", data);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    closeEditShopperDialog: function closeEditShopperDialog() {
      $("#editShopperDialog").modal("hide");
    },
    initEditShopperDialog: function initEditShopperDialog() {
      var _this7 = this;

      var fieldsToRemove = ["Username", "ShopperGuid", "ShopperId", "VatNo", "VatNotMandatory", "Active", "MigratedShopperId"];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.editShopperData).forEach(function (key) {
        fieldsToRemove.indexOf(key) < 0 ? _this7.editShopperData[key] = "" : delete _this7.editShopperData[key];
      });
      this.editShopperData.Active = true;
      this.editShopperData.ShopperSkillLevel = 3;
      this.fpBirthdate.clear();
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editShopperDialog") {
        if (!result) {
          this.globals.showErrorSnackbar(this.lang.SM1034);
          return;
        }
        this.saveEditShopperData();
      }
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      // Checks validation depending on the input type or a given pattern in the template
      var result = id === "inputShopperBirthdate" ? $("#" + id)[0].value !== "" : $("#" + id)[0].checkValidity();
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },


    // Open history
    showShopperHistory: function showShopperHistory() {
      var config = {
        type: "Shopper",
        guid: this.editShopperData.ShopperGuid, // here UserId is User Guid
        id: this.editShopperData.ShopperId
      };
      this.globals.$emit("showElementHistory", config);
    },
    cleanUpEmptyData: function cleanUpEmptyData() {
      for (var prop in this.editShopperData) {
        if (typeof this.editShopperData[prop] === "string" && !this.editShopperData[prop]) delete this.editShopperData[prop];
      }
    },
    saveEditShopperData: function saveEditShopperData() {
      var _this8 = this;

      this.cleanUpEmptyData();
      var queryString = "api/Shopper";
      var reqMethod = "POST";

      if (!this.dialogModeAdd) {
        queryString += "/" + this.selectedShopperGuid;
        reqMethod = "PUT";
      } else this.editShopperData.Active = true;

      if (!this.editShopperData.ProfilePictureGuid) delete this.editShopperData.ProfilePictureGuid;

      var requestCount = 2;
      var successCallback = function successCallback() {
        if (--requestCount < 1) {
          var successMsg = _this8.dialogModeAdd ? "Shopper creation successful" : "Shopper update successful";
          _this8.globals.showSuccessSnackbar(successMsg);
          _this8.closeEditShopperDialog();
          _this8.$emit("dialogDataSaved");
        }
      };
      var errorCallback = function errorCallback() {
        var errorMsg = _this8.dialogModeAdd ? "Shopper creation failed" : "Shopper update failed";
        _this8.globals.showErrorSnackbar(errorMsg);
      };

      if (this.$refs.customPropertiesForm) {
        var custPropData = this.$refs.customPropertiesForm.saveShopperProperties(successCallback, errorCallback);
        if (custPropData && custPropData.Properties) {
          requestCount--;
          if (custPropData.Properties[0]) this.editShopperData.Properties = custPropData.Properties;
        }
      }

      $.ajax({
        method: reqMethod,
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editShopperData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          successCallback();
        },
        error: function error() {
          console.error("Error on " + reqMethod + " in saveEditShopperData()");
          errorCallback();
        }
      });
    },
    onShopperProfilePictureFileChange: function onShopperProfilePictureFileChange(e) {
      var _this9 = this;

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.editShopperData.ProfilePictureGuid = "";
        this.profilePictureFileObject = {};
        return;
      }
      this.profilePictureFileObject = files[0];
      if (this.profilePictureFileObject.type.indexOf("image/") < 0) {
        this.globals.showErrorSnackbar("Invalid file type");
        e.target.value = null;
        return;
      }

      var callback = function callback() {
        var uploadSuccess = function uploadSuccess(data) {
          _this9.editShopperData.ProfilePictureGuid = data[0].DownloadId;
          _this9.editShopperData.ProfilePictureFileName = _this9.profilePictureFileObject.name;
          _this9.globals.showSuccessSnackbar("Profile picture upload successful");
          _this9.$forceUpdate();
        };

        _this9.globals.uploadFile(_this9.profilePictureFileObject, false, uploadSuccess);
        e.target.value = null;
      };

      this.profilePictureFileObject.imageUrl = URL.createObjectURL(this.profilePictureFileObject);
      this.globals.getImageOrientation(this.profilePictureFileObject, function (orientation) {
        _this9.globals.resetImageOrientation(_this9.profilePictureFileObject, orientation, function (data) {
          _this9.profilePictureFileObject = data;
          callback();
        });
      });
    },
    removeShopperProfilePictureFile: function removeShopperProfilePictureFile() {
      $("#inputShopperProfilePictureFile")[0].value = null;
      this.editShopperData.ProfilePictureGuid = "";
      this.editShopperData.ProfilePictureFileName = "";
      this.profilePictureFileObject = {};
      this.$forceUpdate();
    },
    getBankDetails: function getBankDetails() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var queryString, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this10.globals.isAccessAllowed("LoopOp_ShopperBankDetails_ReadAll")) {
                  _context2.next = 2;
                  break;
                }

                throw new Error("Acces not allowed:LoopOp_ShopperBankDetails_ReadAll");

              case 2:
                queryString = "api/Shopper/" + _this10.selectedShopperGuid + "/BankDetails";
                _context2.next = 5;
                return $.ajax({
                  method: "GET",
                  url: queryString
                });

              case 5:
                data = _context2.sent;


                if (data) {
                  if (!_.isEmpty(data)) {
                    _this10.bankDetailsData = data[0];
                  } else {
                    _this10.bankDetailsData = {};
                  }
                }

                return _context2.abrupt("return", data);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this10);
      }))();
    },

    //TODO: bank details are readonly for now but later it might be necessary to change values for MSM users
    // saveBankDetails(success, error) {
    //   let queryString = `api/Shopper/${this.selectedShopperGuid}/BankDetails`;
    //   let reqMethod = "POST";
    //   if (this.bankDetailsData.BankDetailsGuid) {
    //     queryString += "/" + this.bankDetailsData.BankDetailsGuid;
    //     reqMethod = "PUT";
    //   }

    //   $.ajax({
    //     method: reqMethod,
    //     url: queryString,
    //     data: JSON.stringify(this.bankDetailsData),
    //     dataType: "json",
    //     contentType: "application/json; charset=utf-8",
    //     success: data => {
    //       if (data && !_.isEmpty(data)) {
    //         this.bankDetailsData = data;
    //       }
    //       success();
    //     },
    //     error: () => {
    //       console.error("Error on PUT in saveProfileData()");
    //       error();
    //     }
    //   });
    // },
    openFileSelector: function openFileSelector() {
      $("#inputShopperProfilePictureFile").click();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ShopperEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ShopperManagement",
  components: {
    "shopper-edit-modal": __WEBPACK_IMPORTED_MODULE_1__ShopperEditModal___default.a,
    "custom-property-edit-modal": __WEBPACK_IMPORTED_MODULE_2__CustomPropertyEditModal___default.a,
    "change-password-dialog": __WEBPACK_IMPORTED_MODULE_3__Tools_Dialogs_ChangePasswordDialog___default.a
  },
  data: function data() {
    return {
      searchString: "",
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      totalElementsCount: 0,
      refreshEnabled: false,
      shoppersList: [],
      currentSort: { key: "FirstName", asc: true },
      showEditShopperDataDialog: false,
      showCustomPropertyEditDialog: false,
      occupationalGroupList: {},
      selectedShopper: {},
      editShopperDialogModeAdd: true,
      showChangePasswordDialog: false,
      filterStrings: {
        Search: "",
        Username: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        Email: "",
        Age: "",
        NumberOfChecks: "",
        Active: "true"
      },
      lang: {
        SM0000: "Refresh",
        SM0001: "New Shopper",
        SM0002: "Edit",
        SM0003: "Properties",
        SM0004: "Search...",
        SM0005: "Items per page",
        SM0006: "First page",
        SM0007: "Last page",
        SM0008: "First Name",
        SM0009: "Last Name",
        SM0010: "Username",
        SM0011: "Gender",
        SM0012: "Postal Code",
        SM0013: "City",
        SM0014: "Email",
        SM0015: "Age",
        SM0016: "Number of checks",
        SM0017: "Delete",
        SM0018: "Password",
        SM0019: "Search",
        SM0020: "Export",
        SM0021: "Shopper Export",
        SM0022: "Download",
        SM0023: "Cancel",
        // SM0024: "Export Selected Shopper",
        SM0025: "View Shopper Checks",
        SM0026: "Assignment",
        SM0027: "Delete Shoppper",
        SM0028: "Yes",
        SM0029: "No",
        SM0030: "Do you really want to delete this shopper?",
        SM0031: "ID",
        SM0032: "First name",
        SM0033: "Last name",
        SM0034: "Active",
        SM0035: "Total shoppers count",
        SM0036: "Shopper data request failed",
        SM0037: "Shopper export failed",
        SM0038: "Shopper deletion failed"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this.occupationalGroupList = callbackData;
      });
    }
    this.getShoppersList();
    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    // Export
    this.globals.$off("ExportShopperYesConfirmation");
    this.globals.$on("ExportShopperYesConfirmation", function () {
      _this.exportShoppers();
    });

    // Delete shopper
    this.globals.$off("DeleteShopperYesConfirmation");
    this.globals.$on("DeleteShopperYesConfirmation", function () {
      _this.deleteSelectedShopper();
    });
  },
  destroyed: function destroyed() {
    this.writeComponentSettingsToStore();
    $(window).off("resize", this.setTableHeight);
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this2 = this;

      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList(function (callbackData) {
        _this2.occupationalGroupList = callbackData;
      });
    }
  },
  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#shoppermanagement-top-panel").height() + $("#app-navbar").height() +
        // $("#shoppermanagement .main-table > thead").height() +
        47;
        $("#shoppermanagement .main-table-scrollbar").css("max-height", height);
        $("#shoppermanagement .table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/shopperManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperManagement", {
        selectedShopper: this.selectedShopper,
        pageSize: this.pageSize,
        selectedPage: this.selectedPage,
        currentSort: this.currentSort,
        filterStrings: this.filterStrings
      });
    },
    getShoppersList: function getShoppersList() {
      var _this3 = this;

      var queryString = "api/Shopper/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.currentSort.key + "&sort_order=" + (this.currentSort.asc ? "asc" : "desc");
      queryString = encodeURI(queryString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value.length > 0) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "string") filter.Active = filter.Active === "true" ? true : false;

      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this3.shoppersList = data[0].Shoppers;
          _this3.pageCount = data[0].Page_Count;
          _this3.totalElementsCount = data[0].Count;
        },
        error: function error() {
          console.error("Shopper data request failed in getShoppersList()");
          _this3.globals.showErrorSnackbar(_this3.lang.SM0036);
        },
        complete: function complete() {
          _this3.refreshEnabled = true;
        }
      });
    },
    updateActiveFilter: function updateActiveFilter() {
      if (!this.filterStrings.Active) this.filterStrings.Active = "true";else if (this.filterStrings.Active === "true") this.filterStrings.Active = "false";else this.filterStrings.Active = "";
    },
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getShoppersList();
    },
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow: function showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn: function orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp ? this.currentSort.asc = !this.currentSort.asc : this.currentSort = { asc: true, key: orderProp };
      }
      this.getShoppersList();
    },
    isShopperSelected: function isShopperSelected() {
      return !!this.selectedShopper.ShopperGuid;
    },
    openEditShopperDialog: function openEditShopperDialog() {
      this.showEditShopperDataDialog = true;
    },
    onEditShopperDataClosed: function onEditShopperDataClosed() {
      this.showEditShopperDataDialog = false;
      // this.getShoppersList();
    },
    openCustomPropertyDialog: function openCustomPropertyDialog() {
      this.showCustomPropertyEditDialog = true;
    },
    onCustomPropertyDialogClosed: function onCustomPropertyDialogClosed() {
      this.showCustomPropertyEditDialog = false;
    },
    openShopperExportConfirmationDialog: function openShopperExportConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getExportShopperData());
    },
    getExportShopperData: function getExportShopperData() {
      return {
        initiator: "ExportShopper",
        confirmationTitle: this.lang.SM0021,
        yesButtonText: this.lang.SM0022,
        noButtonText: this.lang.SM0023
        // htmlText: `<p><b>${this.lang.SM0024}</b></p>`,
      };
    },
    exportShoppers: function exportShoppers() {
      var _this4 = this;

      $.ajax({
        method: "GET",
        url: "api/Shopper/Export",
        success: function success(data) {
          if (data.Error) {
            _this4.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }

          if (data[0] && data[0].DownloadId) _this4.globals.downloadFile(data[0].DownloadId);
        },
        error: function error() {
          console.error("Error on GET in exportShoppers()");
          _this4.globals.showErrorSnackbar(_this4.lang.SM0037);
        }
      });
    },
    onEditShopperDialogDataSaved: function onEditShopperDialogDataSaved() {
      this.getShoppersList();
    },
    openDeleteShopperConfirmationDialog: function openDeleteShopperConfirmationDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", this.getDeleteDialogData());
    },
    getDeleteDialogData: function getDeleteDialogData() {
      var shopper = this.selectedShopper;
      return {
        initiator: "DeleteShopper",
        confirmationTitle: this.lang.SM0027,
        colorRed: true,
        yesButtonText: this.lang.SM0028,
        noButtonText: this.lang.SM0029,
        htmlText: "<p><b>" + this.lang.SM0030 + "</b></p>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0031 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.ShopperId + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0032 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.FirstName + "</label>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-4 text-black\">" + this.lang.SM0033 + "</label>\n          <label class=\"col-md-8 text-black\">" + shopper.LastName + "</label>\n        </div>"
      };
    },
    deleteSelectedShopper: function deleteSelectedShopper() {
      var _this5 = this;

      var queryString = "api/Shopper/" + this.selectedShopper.ShopperGuid;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: function success(data) {
          _this5.globals.showSuccessSnackbar("Shopper deletion successful");
          _this5.getShoppersList();
        },
        error: function error() {
          console.error("Shopper deletion failed in deleteSelectedShopper()");
          _this5.globals.showErrorSnackbar(_this5.lang.SM0038);
        }
      });
    },
    openChangePasswordDialog: function openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed: function onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagement",
  components: {
    SurveyManagementEditModal: __WEBPACK_IMPORTED_MODULE_1__SurveyManagementEditModal___default.a,
    SurveyManagementTranslateModal: __WEBPACK_IMPORTED_MODULE_2__SurveyManagementTranslateModal___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    }
    this.globals.getLanguageList(function (callbackData) {
      _this.languageList = callbackData;
    });
    this.globals.getLocaleList(function (callbackData) {
      _this.localesList = callbackData;
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#surveys-top-panel").height() + $("#app-navbar").height() +
        // $(".main-table > thead").height() +
        47; // 47 pixel for the free space around the cards
        $(".table-space").css("max-height", height);
        $(".main-table-scrollbar").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".survey-management-main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/surveyManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/surveyManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName
          });
        }
      } else {
        var storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName
          });
        }
      }
    },

    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved: function onEditSurveyDialogDataSaved(survey) {
      this.getSurveyData(); // Refresh datatable
      if (survey) this.selectedSurvey = survey;
    },

    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed: function onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
      this.copySurvey = false;
    },

    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor: function redirectToSurveyEditor(surveyId) {
      var _this2 = this;

      $.ajax({
        method: "PATCH",
        url: "api/Surveys/" + surveyId + "/Lock",
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) _this2.globals.showErrorSnackbar(data.Error);else {
            window.name = "MSMLoopMainApp";
            window.open(window.origin + "/survey.html#/editor/" + surveyId);
          }
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.error("Error on PUT in redirectToSurveyEditor()");
          console.error(XMLHttpRequest + " " + textStatus + " : " + errorThrown);
          _this2.globals.showErrorSnackbar("Survey lock failed");
        }
      });
    },

    // Opens the security check dialog for deleting the selected survey
    openDeleteSurveyDialog: function openDeleteSurveyDialog() {
      $("#deleteSurvey").modal("show");
    },

    // Opens the dialog to select Survey language and then translate
    openSelectSurveyLanguageDialog: function openSelectSurveyLanguageDialog() {
      this.showTranslateSurveyDialog = true;
    },

    // Export and download of survey
    downloadSurvey: function downloadSurvey(selectedSurvey) {
      var _this3 = this;

      if (!selectedSurvey) return;
      var query = "api/Surveys/" + selectedSurvey.SurveyGuid + "/Export";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.globals.downloadFile(data[0].DownloadId);
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.error("Survey Export failed");
          console.error(XMLHttpRequest + " " + textStatus + " : " + errorThrown);
          _this3.globals.showErrorSnackbar(_this3.lang.U0046); // TODO: Use right translation
        }
      });
    },

    // Gets executed after the translateSurveyDialog got closed
    onTranslateSurveyDialogClosed: function onTranslateSurveyDialogClosed() {
      this.showTranslateSurveyDialog = false;
    },

    // Sends a delete request for the selected survey to the server
    deleteSurveyData: function deleteSurveyData() {
      var _this4 = this;

      $.ajax({
        method: "DELETE",
        url: "api/Surveys/" + this.selectedSurvey.SurveyId,
        success: function success(data) {
          // If delete was successful, refresh displayed data and hide dialog
          $("#deleteSurvey").modal("hide");
          if (data.Error) _this4.globals.showErrorSnackbar(data.Error);else _this4.globals.showSuccessSnackbar("Survey deletion successful");
          _this4.selectedSurvey = null;
          _this4.getSurveyData();
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.error("Survey data deletion failed in deleteSurveyData()");
          console.error(XMLHttpRequest + " " + textStatus + " : " + errorThrown);
          _this4.globals.showErrorSnackbar("Survey deletion failed");
        }
      });
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortSurveyData: function sortSurveyData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getSurveyData();
    },

    // Catches survey data for the table from the server, including current filter, pagination and sort settings
    getSurveyData: function getSurveyData() {
      var _this5 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      var getString = "api/Surveys/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "SurveyActive" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.SurveyActive === "number") filter.SurveyActive = !!filter.SurveyActive;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (typeof data[0] == "undefined") {
            _this5.surveyData = [];
            _this5.pageCount = 1;
          } else {
            _this5.surveyData = data[0].Surveys; // If GET was successful, store survey data and page count from server
            _this5.pageCount = data[0].Page_Count;
            _this5.totalElementsCount = data[0].Count;
          }
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          console.error("Error on POST in getSurveyData()");
          console.error(XMLHttpRequest + " " + textStatus + " : " + errorThrown);
          _this5.globals.showErrorSnackbar("Survey data access failed");
        },
        complete: function complete() {
          _this5.refreshEnabled = true;
        }
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getSurveyData();
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedSurvey: null, // ID of the selected survey, -1 if none is selected
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        SurveyId: "",
        SurveyTitle: "",
        ClientName: "",
        ImporterName: "",
        SurveyCreatedAt: "",
        CurrentUser: "",
        SurveyActive: 2
      },
      showActiveSurveys: 2, // 0 = inactive, 1 = active, 2 = all
      sortField: "SurveyTitle", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      surveyData: [], // Stores the survey data on the current page
      showEditSurveyDialog: false,
      editSurveyDialogModeAdd: true,
      copySurvey: false,
      languageList: {},
      localesList: [],
      showTranslateSurveyDialog: false,
      lang: {
        // Contains localization strings for the selected language
        U0000: "Refresh",
        U0001: "Add",
        U0002: "Edit",
        U0003: "Delete",
        U0004: "Survey Editor",
        U0005: "Search...",
        U0006: "Items per page",
        U0007: "First page",
        U0008: "Last page",
        U0009: "SID",
        U0010: "Title",
        U0011: "Client",
        U0012: "Created",
        U0013: "In use",
        U0014: "Filter",
        U0022: "Cancel",
        U0023: "Save",
        U0024: "Delete Survey",
        U0025: "Do you really want to delete the following survey?",
        U0026: "SID",
        U0027: "Title",
        U0028: "Client",
        U0029: "Created",
        U0030: "No",
        U0031: "Yes",
        U0034: "Copy",
        U0035: "Used by",
        U0036: "Active",
        U0037: "Translation",
        U0038: "Language selection",
        U0039: "Continue",
        U0043: "Importer",
        U0044: "Total surveys count",
        U0045: "Export",
        U0046: "Survey export failed"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ProjectWaves__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagementEditModal",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_4__Tools_Select2___default.a, treeselect: __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default.a },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editSurveyDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    /**
     * Explicit validation for the vue-treeselect compontent, because it is not able to give them an id.
     * @returns {boolean} true if valid, or wave selector is disabled.
     */
    validateWaveSelector: function validateWaveSelector() {
      var result = false;
      // no validation needed if wave selector disabled
      if (!this.surveyData.isMasterSurvey) return true;
      var guidRegex = new RegExp(/[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i);
      if (this.surveyData.MasterSurveyForWave && this.surveyData.MasterSurveyForWave.trim().length > 0 && guidRegex.test(this.surveyData.MasterSurveyForWave.toLowerCase())) result = true;
      if (result) {
        $(".inputMasterSurveyForWave").parent().removeClass("has-error"); // has-error has to be added to the form-group element
      } else {
        $(".inputMasterSurveyForWave").parent().addClass("has-error");
      }
      return result;
    },


    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },


    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      result = this.validateWaveSelector() && result;

      if (dialogId == "editSurveyDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditSurveyDialogData();
      }
    },


    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
    showSurveyHistory: function showSurveyHistory() {
      var config = {
        type: "Survey",
        guid: this.selectedSurvey.SurveyGuid,
        id: this.selectedSurvey.SurveyId
      };
      this.globals.$emit("showElementHistory", config);
    },


    // Redirects to the survey translation tool
    redirectToSurveyTranslation: function redirectToSurveyTranslation(key) {
      // TODO:
      console.debug("open survey translation for: " + key);
    },


    // Returns true, if the given language is already selected, otherwise false
    isLanguageSelected: function isLanguageSelected(languageCode, countryCode) {
      var langList = this.surveyData.SurveySelectedLanguages;
      if (!langList || !languageCode) return false;

      for (var i = 0; i < langList.length; i++) {
        if (langList[i].LanguageCode == languageCode) {
          if ((!langList[i].CountryCode || langList[i].CountryCode.length < 1) && !countryCode.length) return true;else if (langList[i].CountryCode == countryCode) return true;
        }
      }
      return false;
    },
    getLocaleString: function getLocaleString(languageCode, countryCode) {
      if (!this.languageList || !this.localesList) return "";

      var result = this.languageList[languageCode];

      var ll = this.localesList.filter(function (l) {
        return l.LanguageCode == languageCode;
      });

      if (ll && ll.length > 0 && ll[0].Locales) {
        var loc = ll[0].Locales.filter(function (c) {
          return c.CountryCode == countryCode;
        });
        if (loc && loc.length > 0) result += " - " + loc[0].CountryName;
      }
      return result;
    },
    getLocales: function getLocales() {
      var _this2 = this;

      var loc = this.localesList.filter(function (l) {
        return l.LanguageCode == _this2.newSurveyLanguage;
      });
      if (loc && loc.length > 0 && loc[0].Locales) this.languageLocaleList = loc[0].Locales;else this.languageLocaleList = [];
    },
    getSurveyGroupList: function getSurveyGroupList() {
      var _this3 = this;

      if (!this.surveyData.ClientGuid) return;
      var query = "api/SecurityGroups/Data/Client/" + this.surveyData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.surveyGroupList = data;
        },
        error: function error() {
          console.error("Survey group data access failed in getSurveyGroupList()");
          _this3.globals.showErrorSnackbar(_this3.lang.U1085);
        }
      });
    },


    // Adds a new survey language to the surveydata
    addNewSurveyLanguage: function addNewSurveyLanguage() {
      if (!this.newSurveyLanguage) return;
      if (this.isLanguageSelected(this.newSurveyLanguage, this.newSurveyLanguageLocale)) {
        this.globals.showErrorSnackbar(this.lang.U1040);
        this.newSurveyLanguageLocale = null;
        return;
      }

      if (!this.surveyData.SurveySelectedLanguages) this.surveyData.SurveySelectedLanguages = [];

      var newLanguage = {};
      newLanguage.LanguageCode = this.newSurveyLanguage;
      if (this.newSurveyLanguageLocale) newLanguage.CountryCode = this.newSurveyLanguageLocale;
      newLanguage.IsDefault = this.surveyData.SurveySelectedLanguages.length > 0 ? false : true;

      this.surveyData.SurveySelectedLanguages.push(newLanguage);
      this.newSurveyLanguageLocale = null;
      this.$forceUpdate();
    },


    // Removes the language with the given key from the list of selected languages
    removeSelectedLanguage: function removeSelectedLanguage(languageCode, countryCode) {
      if (!this.surveyData.SurveySelectedLanguages) return;

      var idx = _.findIndex(this.surveyData.SurveySelectedLanguages, function (l) {
        return l.LanguageCode == languageCode && l.CountryCode == countryCode;
      });
      if (idx < 0) return;

      var isDefaultLanguage = this.surveyData.SurveySelectedLanguages[idx].IsDefault;

      this.surveyData.SurveySelectedLanguages.splice(idx, 1);
      if (this.surveyData.SurveySelectedLanguages.length === 0) delete this.surveyData.SurveySelectedLanguages;else if (isDefaultLanguage) this.surveyData.SurveySelectedLanguages[0].IsDefault = true;
      this.$forceUpdate();
    },
    setDefaultSurveyLanguage: function setDefaultSurveyLanguage(index) {
      for (var i = 0; i < this.surveyData.SurveySelectedLanguages.length; i++) {
        this.surveyData.SurveySelectedLanguages[i].IsDefault = false;
      }
      this.surveyData.SurveySelectedLanguages[index].IsDefault = true;
    },


    // Writes the filename to the input of the survey attachment, after a file was selected
    onSurveyAttachmentFileChange: function onSurveyAttachmentFileChange(e) {
      var _this4 = this;

      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.attachmentFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        if (_this4.surveyData.SurveyAttachments) {
          _this4.surveyData.SurveyAttachments[0].DownloadId = data[0].DownloadId;
          _this4.surveyData.SurveyAttachments[0].DownloadFileName = _this4.attachmentFileObject.name;
        } else _this4.surveyData.SurveyAttachments = data;

        _this4.globals.showSuccessSnackbar(_this4.lang.U1077);
        _this4.$forceUpdate();
      };
      this.globals.uploadFile(this.attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },


    // Removes the survey attachment file from the survey data and resets the input field
    removeSurveyAttachmentFile: function removeSurveyAttachmentFile() {
      this.surveyData.SurveyAttachments = [{}];
      this.attachmentFileObject = {};
      this.$forceUpdate();
    },


    // Writes the filename to the input of the survey logo, after a file was selected
    onSurveyLogoFileChange: function onSurveyLogoFileChange(e) {
      var _this5 = this;

      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.logoFileObject = files[0];

      var uploadSuccess = function uploadSuccess(data) {
        _this5.surveyData.SurveyLogoId = data[0].DownloadId;
        _this5.surveyData.SurveyLogoFileName = _this5.logoFileObject.name;
        _this5.globals.showSuccessSnackbar(_this5.lang.U1078);
        _this5.$forceUpdate();
      };
      this.globals.uploadFile(this.logoFileObject, false, uploadSuccess);
      e.target.value = null;
    },


    // Removes the survey logo file from the survey data and resets the input field
    removeSurveyLogoFile: function removeSurveyLogoFile() {
      delete this.surveyData.SurveyLogoId;
      delete this.surveyData.SurveyLogoFileName;
      this.logoFileObject = {};
      this.$forceUpdate();
    },


    // Stores the current visibility settings to the data object
    storeCurrentVisibilitySettings: function storeCurrentVisibilitySettings() {
      var currentData = this.currentVisibilitySettings;

      if (!this.visibilitySettings) this.visibilitySettings = {};

      this.visibilitySettings[currentData.selected] = currentData.selectedGroups;
    },


    // Reads the current visibility settings for the given element from the data object
    readCurrentVisibilitySettings: function readCurrentVisibilitySettings(element) {
      var currentData = this.currentVisibilitySettings;
      var dataStorage = [];
      if (this.visibilitySettings && this.visibilitySettings[element]) dataStorage = this.visibilitySettings[element];

      currentData.selected = element;
      currentData.selectedGroups = dataStorage;
    },


    // Resets the all visibility settings to the default values
    resetVisibilitySettings: function resetVisibilitySettings() {
      this.currentVisibilitySettings.selected = "survey";
      this.currentVisibilitySettings.selectedGroups = [];
      this.visibilitySettings = {};
    },


    // Takes all available groups into current visibility settings and removes all groups if they are already selected
    toggleAllVisibilityGroups: function toggleAllVisibilityGroups() {
      var ids = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.surveyGroupList);

      if (ids.length <= this.currentVisibilitySettings.selectedGroups.length) {
        this.currentVisibilitySettings.selectedGroups = [];
        return;
      }

      var num = void 0;
      for (var i = 0; i < ids.length; i++) {
        num = ids[i];
        if (this.currentVisibilitySettings.selectedGroups.indexOf(num) < 0) this.currentVisibilitySettings.selectedGroups.push(num);
      }
    },


    // Refreshes displayed visibility settings after changing the submenu
    visibilitySubmenuChanged: function visibilitySubmenuChanged(element) {
      this.storeCurrentVisibilitySettings();
      this.readCurrentVisibilitySettings(element);
      var currentData = this.currentVisibilitySettings;

      // Update header text
      switch (element) {
        case "survey":
          currentData.headerText = this.lang.U1011;
          break;
        case "date":
          currentData.headerText = this.lang.U1012;
          break;
        case "time":
          currentData.headerText = this.lang.U1013;
          break;
        case "points":
          currentData.headerText = this.lang.U1014;
          break;
        case "remarks":
          currentData.headerText = this.lang.U1015;
          break;
        case "attachment":
          currentData.headerText = this.lang.U1016;
          break;
        default:
          currentData.headerText = "";
      }
    },


    // Fills the editSurvey dialog with data, depending on the dialog mode.
    openEditSurveyDialog: function openEditSurveyDialog() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.globals.getClientList();

              case 2:
                _this6.clientList = _context.sent;


                if (_this6.feature.isAudiTarget && _this6.feature.isEnabled("audi_importers")) {
                  _this6.globals.getImporterList(function (data) {
                    _this6.importerList = data;
                    if (_this6.$refs.editSurveyImporterSelect) _this6.$refs.editSurveyImporterSelect.updateValue();
                  });
                }

                _this6.visibilitySubmenuChanged("survey");

                _this6.removeSurveyAttachmentFile();
                _this6.removeSurveyLogoFile();
                _this6.newSurveyLanguage = null;
                _this6.newSurveyLanguageLocale = null;

                if (_this6.dialogModeAdd) {
                  _this6.dialogTitle = _this6.lang.U0032;
                  _this6.surveyData = {};
                  if (_this6.selectedClient) _this6.surveyData.ClientGuid = _this6.selectedClient.ClientGuid;
                  _this6.surveyData.SurveyAttachments = [{}];
                  _this6.surveyData.SurveyActive = true;
                  _this6.surveyData.SurveyShowAttachmentsPage = true;
                  _this6.surveyData.SurveySkillLevel = 3;
                  // todo remove where the feature is not needed
                  _this6.surveyData.SurveyShowHistoryCounter = 0;

                  if (_this6.feature.isAudiTarget && _this6.feature.isEnabled("audi_importers") && _this6.clientList[0]) _this6.surveyData.ClientGuid = _this6.clientList[0].ClientGuid;

                  if (_this6.surveyData.ClientGuid) _this6.getSurveyGroupList();

                  _this6.resetVisibilitySettings();
                  $("#editSurveyDialog").modal("show");
                } else {
                  _this6.dialogTitle = _this6.copySurvey ? _this6.lang.U1061 : _this6.lang.U0033;
                  _this6.surveyData = { SurveyAttachments: [{}] };

                  $.ajax({
                    method: "GET",
                    url: "api/Surveys/" + _this6.selectedSurvey.SurveyId,
                    success: function success(data) {
                      if (!data.Error) {
                        _this6.surveyData = data.SurveyData;
                        _this6.visibilitySettings = data.VisibilitySettings;
                        if (_this6.surveyData.Importers) {
                          _this6.surveyData.ImporterGuid = _this6.surveyData.Importers[0].ImporterGuid;
                          delete _this6.surveyData.Importers;
                        }
                        _this6.readCurrentVisibilitySettings(_this6.currentVisibilitySettings.selected);
                        _this6.logoFileObject.name = _this6.surveyData.SurveyLogoFileName;
                        if (!_this6.surveyData.SurveyAttachments) _this6.surveyData.SurveyAttachments = [{}];else _this6.attachmentFileObject.name = _this6.surveyData.SurveyAttachments[0].DownloadFileName;
                        $("#editSurveyDialog").modal("show");

                        _this6.getSurveyGroupList();
                      } else {
                        _this6.globals.showErrorSnackbar(data.Error);
                        _this6.$emit("dialogClosed");
                      }
                    },
                    error: function error() {
                      console.error("Survey data access failed in openEditSurveyDialog()");
                      _this6.globals.showErrorSnackbar(_this6.lang.U1086);
                      _this6.$emit("dialogClosed");
                    }
                  });
                }
                _this6.showAlert = false;
                _this6.resetValidationErrors("editSurveyDialog");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },


    // Closes the editSurveyDialog
    closeEditSurveyDialog: function closeEditSurveyDialog() {
      $("#editSurveyDialog").modal("hide");
    },


    // Sends the data from editSurvey dialog to the server to store it in the database
    saveEditSurveyDialogData: function saveEditSurveyDialogData(forceSave) {
      var _this7 = this;

      if (!this.surveyData.SurveySelectedLanguages) {
        this.globals.showErrorSnackbar(this.lang.U1079);
        return;
      }
      if (!this.surveyData.ClientGuid) {
        this.globals.showErrorSnackbar(this.lang.U1080);
        return;
      }

      this.storeCurrentVisibilitySettings();

      var sendData = {
        SurveyData: _.cloneDeep(this.surveyData),
        VisibilitySettings: _.cloneDeep(this.visibilitySettings)
      };

      if (!sendData.SurveyData.isMasterSurvey) {
        this.surveyData.MasterSurveyForWave = null;
        sendData.SurveyData.MasterSurveyForWave = null;
      }
      if (!this.surveyData.SurveyAttachments[0].DownloadId) {
        sendData.SurveyData.SurveyAttachments = [];
      }

      if (sendData.SurveyData.ImporterGuid) {
        sendData.SurveyData.Importers = [{ ImporterGuid: sendData.SurveyData.ImporterGuid }];
        delete sendData.SurveyData.ImporterGuid;
      }

      if (this.dialogModeAdd || this.copySurvey) {
        if (this.copySurvey) {
          sendData.IsCopyOf = this.surveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyId;
        }
        // Create new survey
        $.ajax({
          method: "POST",
          url: "api/Surveys",
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this7.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            _this7.globals.showSuccessSnackbar(_this7.lang.U1081);
            _this7.closeEditSurveyDialog();
            _this7.$emit("dialogDataSaved", data[0]);
            _this7.$emit("surveyEditorRedirect", data[0].SurveyId);
          },
          error: function error(XMLHttpRequest, textStatus, errorThrown) {
            console.error("Error on POST in saveEditSurveyDialogData=> status:" + textStatus + " error:" + errorThrown);
            _this7.globals.showErrorSnackbar(_this7.lang.U1082);
          }
        });
      } else {
        // Update existing survey
        if (forceSave) sendData.ForceSave = true;
        $.ajax({
          method: "PUT",
          url: "api/Surveys/" + this.surveyData.SurveyId,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this7.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }

            if (data && data.Confirmation && data.Confirmation === "EXISTING_CHECKS") {
              _this7.globals.$off("SaveSurveyDataYesConfirmation");
              _this7.globals.$on("SaveSurveyDataYesConfirmation", function () {
                _this7.saveEditSurveyDialogData(true);
              });

              _this7.globals.$emit("openGlobalConfirmationDialog", {
                initiator: "SaveSurveyData",
                confirmationTitle: _this7.lang.U1062,
                colorRed: true,
                yesButtonText: _this7.lang.U1063,
                noButtonText: _this7.lang.U1064,
                htmlText: "<b>\n                  <p>" + _this7.lang.U1065 + "</p>\n                  <p class=\"text-uppercase\">" + _this7.lang.U1066 + "</p>\n                </b>"
              });
            } else {
              // If PUT was successful, refresh displayed data and hide dialog
              _this7.globals.showSuccessSnackbar(_this7.lang.U1083);
              _this7.closeEditSurveyDialog();
              _this7.$emit("dialogDataSaved", sendData.SurveyData);
            }
          },
          error: function error(XMLHttpRequest, textStatus, errorThrown) {
            console.error("Error on PUT in saveEditSurveyDialogData()");
            console.error(XMLHttpRequest, " " + textStatus + " : " + errorThrown);
            _this7.globals.showErrorSnackbar(_this7.lang.U1084);
          }
        });
      }
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog && (this.dialogModeAdd || this.globals.isAccessAllowed("LoopOp_Surveys_Read"))) this.openEditSurveyDialog();else {
        this.closeEditSurveyDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["selectedSurvey", "selectedClient", "showDialog", "dialogModeAdd", "copySurvey", "languageList", "localesList"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      newSurveyLanguage: null,
      newSurveyLanguageLocale: null,
      languageLocaleList: {},
      surveyData: {
        SurveyAttachments: [{}]
      }, // The survey data of the selected survey is stored here
      visibilitySettings: {},
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      logoFileObject: {},
      attachmentFileObject: {},
      surveyGroupList: {},
      clientList: [],
      waveList: [],
      importerList: [],
      currentVisibilitySettings: {
        selected: "survey",
        headerText: "",
        selectedGroups: []
      },
      initialVisibilitySettings: {
        survey: [],
        date: [],
        time: [],
        points: [],
        remarks: [],
        attachment: []
      },
      lang: {
        U0015: "General",
        U0016: "Client",
        U0017: "Title",
        U0018: "Title 2 (subtitle)",
        U0019: "Title 3 (subtitle)",
        U0020: "This is a required entry!",
        U0021: "The inputs are incorrect. Please check the fields marked in red!",
        U0022: "Cancel",
        U0023: "Save",
        U0032: "Add survey",
        U0033: "Edit survey",
        U0040: "Difficulty",
        U0041: "simple",
        U0042: "difficult",
        U1000: "Please select...",
        U1001: "Security group for survey",
        U1002: "Survey",
        U1003: "Date",
        U1004: "Time",
        U1005: "Points",
        U1006: "Mystery Shopper information",
        U1007: "Annex",
        U1011: "The survey is visible for the following groups",
        U1012: "Date (Client view / Export) is visible for the following groups",
        U1013: "Time (Client view / Export) is visible for the following groups",
        U1014: "Points (Client view / Export)  are visible for the following groups",
        U1015: "Mystery Shopper information are visible for the following groups",
        U1016: "Annexes (Client view / Export) are visible for the following groups",
        U1017: "Language versions",
        U1018: "Language selection",
        U1019: "Add",
        U1020: "Language",
        U1021: "Actions",
        U1022: "Annex",
        U1023: "Name of the annex",
        U1024: "File",
        U1025: "Please select a file...",
        U1026: "Other",
        U1027: "Logo",
        U1028: "Please select a logo...",
        U1029: "Minimal annexes",
        U1031: "Activated",
        U1032: "Select all",
        U1033: "Clean selection",
        U1034: "Select file",
        U1035: "Download file",
        U1036: "Delete file",
        U1037: "Survey active",
        U1038: "Is a CX Survey",
        U1040: "This language was already selected",
        U1059: "Country",
        U1060: "The following content will NOT be copied and has to be set manually",
        U1061: "Copy survey",
        U1062: "Save survey",
        U1063: "Yes",
        U1064: "No",
        U1065: "ATTENTION: There are already existing checks based on this survey. Do you really want to save?",
        U1066: "All affected checks will be changed by this action",
        U1067: "Please select a language...",
        U1068: "Please select a country...",
        U1069: "Reporting default",
        U1074: "Attachments allowed",
        U1075: "Importer",
        U1076: "Permission denied",
        U1077: "Attachment upload successful",
        U1078: "Logo upload successful",
        U1079: "No survey language selected",
        U1080: "No client selected",
        U1081: "Survey creation successful",
        U1082: "Survey creation failed",
        U1083: "Survey update successful",
        U1084: "Survey update failed",
        U1085: "Survey group data access failed",
        U1086: "Survey data access failed",
        U1087: "Show survey history",
        U1088: "CX Exploration Sichtbar",
        U1089: "Is Master survey",
        U1090: "Master survey for wave",
        U1091: "valid for wave",
        U1092: "Number of Histories to be shown"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveyManagementTranslateModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#translateSurveyDialog").on("hidden.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
  },

  methods: {
    // Adjusts the height of textareas with the "autoExpand" class
    correctTextareaHeight: function correctTextareaHeight() {
      this.$nextTick(function () {
        var textareas = document.getElementsByClassName("autoExpand");
        for (var i = 0; i < textareas.length; i++) {
          $(textareas[i]).trigger("input");
        }
      });
    },
    openTranslateSurveyDialog: function openTranslateSurveyDialog() {
      this.dialogTitle = this.lang.U1039;
      this.selectedLanguage = "";
      this.translationList = [];
      this.translationListDirty = false;
      this.loadSurveyLocales();
      $("#translateSurveyDialog").modal("show");
    },
    closeTranslateSurveyDialog: function closeTranslateSurveyDialog() {
      if (this.translationListDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          $("#translateSurveyDialog").modal("hide");
        });
        return;
      }
      $("#translateSurveyDialog").modal("hide");
    },
    loadSurveyLocales: function loadSurveyLocales() {
      var _this2 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey + "/Locales";

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this2.surveyLocales = data;
          _this2.$nextTick(function () {
            $("#inputSurveyLanguage").val("").trigger("change");
          });
        },
        error: function error() {
          console.error("Survey locale data access failed in loadSurveyLocales()");
          _this2.globals.showErrorSnackbar("Survey locale data access failed");
        }
      });
    },
    selectedLanguageChanged: function selectedLanguageChanged(value, oldValue, event) {
      var _this3 = this;

      if (!value) return;
      if (this.translationListDirty) {
        this.globals.$emit("openGlobalUnsavedChangesDialog", function () {
          _this3.selectedLanguage = value;
          _this3.loadSurveyTranslation();
        }, function () {
          _this3.selectedLanguage = oldValue;
          $(event.target).val(_this3.selectedLanguage).trigger("change");
        });
        return;
      }
      this.selectedLanguage = value;
      this.loadSurveyTranslation();
    },
    loadSurveyTranslation: function loadSurveyTranslation() {
      var _this4 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey + "?localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "GET",
        url: queryString,
        success: function success(data) {
          _this4.translationData = data;
          _this4.translationList = _.cloneDeep(_this4.translationData.Translations);
          _this4.translationList.forEach(function (trans) {
            delete trans.Translation;
          });

          // Needed to relieve the textarea v-model construct #1401
          _this4.$nextTick(function () {
            _this4.translationList = _this4.translationData.Translations;
          });
          _this4.translationListDirty = false;
          _this4.correctTextareaHeight();
        },
        error: function error() {
          console.error("Survey translation data access failed in loadSurveyTranslation()");
          _this4.globals.showErrorSnackbar("Translation data access failed");
        }
      });
    },
    toggleAgencyTranslatePermission: function toggleAgencyTranslatePermission() {
      this.translationData.AllowAgencyEdit = !this.translationData.AllowAgencyEdit;
      this.updateAgencyTranslatePermission();
    },
    submitTranslationsFromAgency: function submitTranslationsFromAgency() {
      var _this5 = this;

      this.translationData.AllowAgencyEdit = false;
      if (this.translationListDirty) this.saveTranslateSurveyDialogData(function () {
        _this5.updateAgencyTranslatePermission();
      });else this.updateAgencyTranslatePermission();
    },
    updateAgencyTranslatePermission: function updateAgencyTranslatePermission() {
      var _this6 = this;

      var sendData = { AllowAgencyEdit: this.translationData.AllowAgencyEdit };
      var queryString = "api/SurveyTranslation/" + this.selectedSurvey + "?localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "PATCH",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (_this6.globals.currentUserRole == 1) _this6.globals.showSuccessSnackbar("Permission update successful");else if (_this6.globals.currentUserRole == 2) _this6.globals.showSuccessSnackbar("Translations submitted");
        },
        error: function error() {
          console.error("Error on PATCH in toggleAgencyTranslatePermission()");
          if (_this6.globals.currentUserRole == 1) _this6.globals.showSuccessSnackbar("Permission update failed");else if (_this6.globals.currentUserRole == 2) _this6.globals.showSuccessSnackbar("Translations submit failed");
        }
      });
    },
    isNewGroup: function isNewGroup(currGroupId) {
      return currGroupId !== this.groupId;
    },
    setNewGroup: function setNewGroup(currGroupId) {
      this.groupId = currGroupId;
    },
    trimTranslation: function trimTranslation(data) {
      /** @type {any[]} */
      var Translations = void 0;
      Translations = data.Translations;

      Translations.forEach(function (el, idx) {
        if (el.Translation) {
          el.Translation = el.Translation.trim();
        }
      });

      return data;
    },
    saveTranslateSurveyDialogData: function saveTranslateSurveyDialogData(callback) {
      var _this7 = this;

      var queryString = "api/SurveyTranslation/" + this.selectedSurvey + "?localeCode=" + this.selectedLanguage;
      var updatedData = this.trimTranslation(this.translationData);

      $.ajax({
        method: "PUT",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatedData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this7.globals.showErrorSnackbar(data.Error);
            _this7.loadSurveyTranslation();
            return;
          }
          _this7.translationListDirty = false;
          _this7.globals.showSuccessSnackbar("Translation data update successful");
          if (callback) callback();
        },
        error: function error() {
          console.error("Error on POST in saveTranslateSurveyDialogData()");
          _this7.globals.showErrorSnackbar("Translation data update failed");
        }
      });
    },
    downloadTranslationExportData: function downloadTranslationExportData() {
      var _this8 = this;

      var queryString = "api/SurveyTranslation/Export?file_type=" + this.exportTranslationFileType + "&SurveyId=" + this.selectedSurvey + "&localeCode=" + this.selectedLanguage;

      $.ajax({
        method: "POST",
        url: queryString,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.translationList),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          var guid = data[0].DownloadId;
          _this8.globals.downloadFile(guid);
          $("#exportTranslation").modal("hide");
        },
        error: function error() {
          console.error("Error on POST in downloadExportTranslationData()");
          _this8.globals.showErrorSnackbar("Translation export failed");
        }
      });
    },

    // Uploads import data to the server and manipulates the UI depending on the progress and response from the server
    uploadImportData: function uploadImportData() {
      if (this.importTranslationDialogData.selectedOption == "text") {
        if (this.importTranslationDialogData.selectedText == "") {
          console.error("Error: No import text available in uploadImportData()");
          return;
        }

        this.translationList = JSON.parse(this.importTranslationDialogData.selectedText);
      } else if (this.importTranslationDialogData.selectedOption == "file") {
        if (typeof this.importTranslationDialogData.selectedFile == "undefined") {
          console.error("Error: No import file available in uploadImportData()");
          return;
        }
        console.debug("Uploading file: " + this.importTranslationDialogData.selectedFile.name);

        var reader = new FileReader();
        reader.readAsDataURL(this.importTranslationDialogData.selectedFile);
        reader.onload = function () {};
        reader.onerror = function (error) {};
      } else console.error("Error on file upload in uploadImportData()");
      $("#importTranslation").modal("hide");
    },


    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange: function onImportFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var uploadFile = files[0];
      if (typeof uploadFile.name == "undefined" || uploadFile.name == "") return;
      this.importTranslationDialogData.selectedFile = uploadFile;
    },


    // Cleans up the import data after the import got closed
    importClosed: function importClosed() {
      this.displayTranslationImport = false;
      this.importTranslationDialogData.selectedText = "";
      this.importTranslationDialogData.selectedFile = {};
    }
  },
  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) this.openTranslateSurveyDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  props: ["selectedSurvey", "showDialog"],
  data: function data() {
    // Global data inside the component is stored here
    return {
      maxlength_textarea: 3000,
      dialogTitle: "",
      translationList: [],
      translationData: {},
      translationListDirty: false,
      surveyLocales: {},
      selectedLanguage: "",
      exportTranslationFileType: "xlsx",
      importTranslationDialogData: {
        selectedOption: "text", // Should be "text" or "file"
        selectedText: "", // String that is pasted to the textarea on text import
        selectedFile: {}, // File informations of the selected file on file import
        serverResponse: {}, // Response data from the server has to be stored here
        trimImportData: false
      },
      lang: {
        U0023: "Save",
        U1039: "Survey Translation",
        U1018: "Language selection",
        U0056: "Export",
        U0057: "Import",
        U1041: "Survey Import",
        U1042: "Please select an import option",
        U1043: "Text-Import",
        U1044: "File-Import",
        U1045: "Text",
        U1046: "Please insert the table data to be imported here.",
        U1047: "File",
        U1048: "Please select a file...",
        U1049: "Cancel",
        U1050: "OK",
        U1051: "Export translations",
        U1052: "The translation data is ready to download.",
        U1053: "Text CSV (.csv)",
        U1054: "Microsoft Excel 97-2003 (.xls)",
        U1055: "Microsoft Excel 2007-2013 XML (.xlsx)",
        U1056: "Download",
        U1057: "Close",
        U1058: "Load translations",
        U1070: "Enable for agency",
        U1071: "Disable for agency",
        U1072: "Please select...",
        U1073: "Submit"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ChangePasswordDialog",
  props: {
    showDialog: {
      default: false,
      type: Boolean
    },
    userGuid: {
      default: "",
      type: String
    },
    userName: {
      default: "",
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#changePasswordDialog" + this._uid).on("hide.bs.modal", function (e) {
      _this.$emit("dialogClosed");
    });
    this.globals.getPasswordPolicyList(function (callbackData) {
      _this.passwordPolicy = callbackData;
    });
    this.debouncedCheckPasswordValidity = _.debounce(this.validatePassword, 500);
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openChangePasswordDialog() : this.closeChangePasswordDialog();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      passwordsMatch: false,
      isPasswordValid: false,
      passwordPolicy: [],
      passwordValidity: {},
      passwords: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      },
      lang: {
        PW0000: "Reset password",
        PW0001: "New password",
        PW0002: "Change new password",
        PW0003: "Password policies",
        PW0004: "at least",
        PW0005: "letters",
        PW0006: "capital letter(s)",
        PW0007: "small letter(s)",
        PW0008: "numeral(s)",
        PW0009: "special character(s)",
        PW0010: "Cancel",
        PW0011: "Save",
        PW0012: "Passwords match",
        PW0013: "Old password",
        PW0014: "Change password",
        PW0015: "Old password missing",
        PW0016: "Password changed",
        PW0017: "User"
      }
    };
  },

  methods: {
    openChangePasswordDialog: function openChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("show");
      this.initChangePasswordDialog();
    },
    closeChangePasswordDialog: function closeChangePasswordDialog() {
      $("#changePasswordDialog" + this._uid).modal("hide");
    },
    initChangePasswordDialog: function initChangePasswordDialog() {
      this.passwordsMatch = false;
      this.isPasswordValid = false;
      this.passwordValidity = {};
      this.passwords = {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      };
    },
    doCheckIfPasswordIsValid: function doCheckIfPasswordIsValid() {
      if (this.debouncedCheckPasswordValidity) this.debouncedCheckPasswordValidity();
    },
    validatePassword: function validatePassword() {
      var _this2 = this;

      var passwordToCheck = {
        Password: this.passwords.newPassword
      };
      $.ajax({
        method: "POST",
        url: "api/Password/ValidatePassword",
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordToCheck),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this2.passwordValidity = data;
          _this2.checkPasswordValidity();
        },
        error: function error() {
          console.error("Error on POST in validatePassword()");
          _this2.globals.showErrorSnackbar("Password check failed");
        }
      });
    },
    checkIfPasswordsMatch: function checkIfPasswordsMatch() {
      this.passwordsMatch = !!this.passwords.newPassword && !!this.passwords.newPasswordRepeat ? this.passwords.newPassword === this.passwords.newPasswordRepeat : false;
    },
    checkPasswordValidity: function checkPasswordValidity() {
      this.isPasswordValid = _.filter(this.passwordValidity, function (value) {
        return !value;
      }).length === 0;
    },
    checkIfNewPasswordPassed: function checkIfNewPasswordPassed() {
      if (this.isPasswordValid && this.passwordsMatch) this.saveNewPassword();
    },
    saveNewPassword: function saveNewPassword() {
      var _this3 = this;

      var request = this.userGuid ? "api/Password/ChangePassword/" + this.userGuid : "api/Password/ChangePassword";

      var passwordData = { Password: this.passwords.newPassword };
      if (!this.userGuid) {
        if (!this.passwords.oldPassword) {
          this.globals.showErrorSnackbar(this.lang.PW0015);
          return;
        }
        passwordData.OldPassword = this.passwords.oldPassword;
      }

      $.ajax({
        method: "PATCH",
        url: request,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(passwordData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this3.globals.showSuccessSnackbar(_this3.lang.PW0016);
          _this3.closeChangePasswordDialog();
        },
        error: function error() {
          console.error("Error on PUT in saveNewPassword()");
          _this3.globals.showErrorSnackbar("Password update failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ConfirmationDialog",
  props: {
    dialogId: {
      type: String,
      default: "confirmationDialog"
    },
    confirmationTitle: {
      type: String,
      default: ""
    },
    yesButtonText: {
      type: String,
      default: "Yes"
    },
    yesButtonDisable: {
      type: Boolean,
      default: false
    },
    noButtonText: {
      type: String,
      default: "No"
    },
    noButtonDisable: {
      type: Boolean,
      default: false
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      return _this.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      this.showDialog ? this.openConfirmationDialog() : this.closeConfirmationDialog();
    }
  },
  methods: {
    openConfirmationDialog: function openConfirmationDialog() {
      var _this2 = this;

      this.$nextTick(function () {
        $("#" + _this2.dialogId).modal("show");
      });
    },
    closeConfirmationDialog: function closeConfirmationDialog() {
      $("#" + this.dialogId).modal("hide");
    },
    onYesConfirmation: function onYesConfirmation() {
      this.$emit("onYesConfirmation");
    },
    onNoConfirmation: function onNoConfirmation() {
      this.$emit("onNoConfirmation");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_SurveyInstances__ = __webpack_require__(99);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ElementHistoryModal",
  data: function data() {
    return {
      title: "",
      elementId: 0,
      history: [],

      // Needed for survey instance history export
      showExportButton: false,
      surveyInstanceGuid: null,

      lang: {
        HIS000: "Info",
        HIS001: "Action",
        HIS002: "No history entries available.",
        HIS003: "Close",
        HIS004: "Check History",
        HIS005: "Location History",
        HIS006: "History data request failed",
        HIS007: "Project History",
        HIS008: "User History",
        HIS009: "Shopper History",
        HIS010: "Survey History",
        HIS011: "Download Check Answer History",
        HIS012: "Export",
        HIS013: "Check history export failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showElementHistory");
    this.globals.$on("showElementHistory", function (config) {
      _this.getElementHistory(config);
    });
  },

  methods: {
    openModal: function openModal() {
      $("#elementHistoryModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#elementHistoryModal").modal("hide");
    },
    getElementHistory: function getElementHistory(config) {
      var _this2 = this;

      if (!config) return;
      var query = "";
      switch (config.type) {
        case "Location":
          query = "api/LocationHistory/" + config.guid;
          this.title = this.lang.HIS005;
          break;

        case "Survey":
          query = "api/SurveyHistory/" + config.guid;
          this.title = this.lang.HIS010;
          break;

        case "SurveyInstance":
          query = "api/SurveyInstanceHistory/" + config.guid;
          this.showExportButton = true;
          this.surveyInstanceGuid = config.guid;
          this.title = this.lang.HIS004;
          break;

        case "Project":
          query = "api/ProjectHistory/" + config.guid;
          this.title = this.lang.HIS007;
          break;

        case "User":
          query = "api/UserHistory/" + config.guid;
          this.title = this.lang.HIS008;
          break;

        case "Shopper":
          query = "api/ShopperHistory/" + config.guid;
          this.title = this.lang.HIS009;
          break;

        default:
          break;
      }

      if (!query) {
        console.error("History config error");
        return;
      }

      this.elementId = config.id;
      this.history = [];
      // Use new type for this one
      if (config.type === "SurveyInstance") {
        __WEBPACK_IMPORTED_MODULE_0__services_SurveyInstances__["a" /* default */].getHistoryByGUID(config.guid).then(function (res) {
          var data = res.data;
          if (data[0]) _this2.history = data;
          _this2.openModal();
        }).catch(function (err) {
          console.error(err.msg);
          _this2.globals.showErrorSnackbar(err.Error);
        });
        return;
      }
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this2.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data[0]) _this2.history = data;
          _this2.openModal();
        },
        error: function error(_error) {
          console.error("Error on GET in getElementHistory()");
          _this2.globals.showErrorSnackbar(_this2.lang.HIS006);
        }
      });
    },
    exportSurveyInstance: function exportSurveyInstance() {
      var _this3 = this;

      if (!this.surveyInstanceGuid) return;
      var query = "api/SurveyInstanceAnswerHistory/" + this.surveyInstanceGuid + "/Export/";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.globals.downloadFile(data[0].DownloadId);
        },
        error: function error() {
          console.error("Export failed");
          _this3.globals.showErrorSnackbar(_this3.lang.HIS013);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UploadProgressModal",
  data: function data() {
    return {
      lang: {
        UPM000: "Uploading",
        UPM001: "Cancel"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUploadProgress": function globalsCurrentUploadProgress(newValue) {
      var _this = this;

      if (newValue === 100) this.closeModal();else {
        setTimeout(function () {
          if (_this.globals.currentUploadProgress < 50) _this.openModal();
        }, 1000);
      }
    }
  },
  mounted: function mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },

  methods: {
    openModal: function openModal() {
      $("#uploadProgressModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#uploadProgressModal").modal("hide");
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__);

//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Select2",
  props: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    /**
     * @see https://select2.org/configuration/options-api
     */
    name: "",
    value: null,
    options: {
      Object: Object
    },
    width: {
      type: String,
      default: "100%"
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    tags: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    minimumInputLength: {
      type: Number,
      default: 0
    },
    noResultsString: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String
    },
    /**
     * Pass a function that gets called before the component returns it to the parent
     */
    dataTransformer: {
      type: Function
    },
    /**
     * Pass a function that gets executed after value change happend
     */
    afterChange: {
      type: Function,
      default: function _default() {}
    }
  }, "tags", {
    type: Boolean,
    default: false
  }),
  data: function data() {
    return {
      /**
       * Used for the destroy method as this.$el didnt have the select2 element
       */
      selectEl: null
    };
  },
  mounted: function mounted() {
    var _this = this,
        _options;

    var placeholder = this.globals.lang.G00000;
    if (this.placeholder && this.placeholder.length > 1) {
      placeholder = this.placeholder;
    }

    var options = (_options = {
      width: this.width,
      allowClear: this.allowClear,
      tags: this.tags,
      multiple: this.multiple,
      placeholder: placeholder,
      closeOnSelect: this.closeOnSelect
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_options, "tags", this.tags), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_options, "language", {
      noResults: function noResults() {
        return _this.noResultsString || _this.globals.lang.G00000;
      }
    }), _options);

    var vm = this;
    var select = $(this.$el);
    select.select2(options).on("change", function (event) {
      if (select.val() === [] && !_this.multiple) return;
      if (!options.allowClear && select.val() == null) return;
      vm.$emit("input", select.val());
      _this.afterChange(select.val(), _this.value, event);
    });
    select.val(this.value).trigger("change");
  },

  watch: {
    options: function options(_options2) {
      // update options
      $(this.$el).empty().select2({ data: _options2 });
    }
  },
  methods: {
    clearSelection: function clearSelection() {
      this.setCurrentSelected(this.$el, null);
    },
    setCurrentSelected: function setCurrentSelected(selEL, data) {
      if (!data || data.length <= 0) {
        selEL.val(null).trigger("change");
        return;
      }
      if (this.multiple) {
        selEL.val(data);
        selEL.trigger("change");
      } else {
        selEL.val(data);
        selEL.trigger("change");
      }
    },
    fetchdata: function fetchdata(el) {
      var data = $(el).select2("data");
      if (this.dataTransformer) {
        return this.dataTransformer(data);
      }

      if (this.multiple) {
        return data.map(function (el) {
          return el.id;
        });
      } else {
        return data[0].id;
      }
    },
    addEvents: function addEvents(el) {
      var that = this;
      $(el).on("select2:select", function (e) {
        var data = that.fetchdata(el);
        that.$emit("change", data);
      });

      $(el).on("select2:unselect", function () {
        var data = that.fetchdata(el);
        that.$emit("change", data);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_pointerScroll_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_typeAheadPointer_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_ajax_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__childComponents_js__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_appendToBody_js__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utility_sortAndStringify_js__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utility_uniqueId_js__ = __webpack_require__(384);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/**
 * @name VueSelect
 */
/* harmony default export */ __webpack_exports__["default"] = ({
  components: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__childComponents_js__["a" /* default */]),

  directives: { appendToBody: __WEBPACK_IMPORTED_MODULE_9__directives_appendToBody_js__["a" /* default */] },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_pointerScroll_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_typeAheadPointer_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_ajax_js__["a" /* default */]],

  props: {
    /**
     * Contains the currently selected value. Very similar to a
     * `value` attribute on an <input>. You can listen for changes
     * with the 'input' event.
     * @type {Object||String||null}
     */
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    value: {},

    /**
     * An object with any custom components that you'd like to overwrite
     * the default implementation of in your app. The keys in this object
     * will be merged with the defaults.
     * @see https://vue-select.org/guide/components.html
     * @type {Function}
     */
    components: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * An array of strings or objects to be used as dropdown choices.
     * If you are using an array of objects, vue-select will look for
     * a `label` key (ex. [{label: 'This is Foo', value: 'foo'}]). A
     * custom label key can be set with the `label` prop.
     * @type {Array}
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /**
     * Disable the entire component.
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Can the user clear the selected property.
     * @type {Boolean}
     */
    clearable: {
      type: Boolean,
      default: true
    },

    /**
     * Can the user deselect an option by clicking it from
     * within the dropdown.
     * @type {Boolean}
     */
    deselectFromDropdown: {
      type: Boolean,
      default: false
    },

    /**
     * Enable/disable filtering the options.
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },

    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Equivalent to the `placeholder` attribute on an `<input>`.
     * @type {String}
     */
    placeholder: {
      type: String,
      default: ""
    },

    /**
     * Sets a Vue transition property on the `.vs__dropdown-menu`.
     * @type {String}
     */
    transition: {
      type: String,
      default: "vs__fade"
    },

    /**
     * Enables/disables clearing the search text when an option is selected.
     * @type {Boolean}
     */
    clearSearchOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Close a dropdown when an option is chosen. Set to false to keep the dropdown
     * open (useful when combined with multi-select, for example)
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },

    /**
     * Tells vue-select what key to use when generating option
     * labels when each `option` is an object.
     * @type {String}
     */
    label: {
      type: String,
      default: "label"
    },

    /**
     * Value of the 'autocomplete' field of the input
     * element.
     * @type {String}
     */
    autocomplete: {
      type: String,
      default: "off"
    },

    /**
     * When working with objects, the reduce
     * prop allows you to transform a given
     * object to only the information you
     * want passed to a v-model binding
     * or @input event.
     */
    reduce: {
      type: Function,
      default: function _default(option) {
        return option;
      }
    },

    /**
     * Decides whether an option is selectable or not. Not selectable options
     * are displayed but disabled and cannot be selected.
     *
     * @type {Function}
     * @since 3.3.0
     * @param {Object|String} option
     * @return {Boolean}
     */
    selectable: {
      type: Function,
      default: function _default(option) {
        return true;
      }
    },

    /**
     * Callback to generate the label text. If {option}
     * is an object, returns option[this.label] by default.
     *
     * Label text is used for filtering comparison and
     * displaying. If you only need to adjust the
     * display, you should use the `option` and
     * `selected-option` slots.
     *
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionLabel: {
      type: Function,
      default: function _default(option) {
        if ((typeof option === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(option)) === "object") {
          if (!option.hasOwnProperty(this.label)) {
            return console.warn("[vue-select warn]: Label key \"option." + this.label + "\" does not" + (" exist in options object " + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(option) + ".\n") + "https://vue-select.org/api/props.html#getoptionlabel");
          }
          return option[this.label];
        }
        return option;
      }
    },

    /**
     * Generate a unique identifier for each option. If `option`
     * is an object and `option.hasOwnProperty('id')` exists,
     * `option.id` is used by default, otherwise the option
     * will be serialized to JSON.
     *
     * If you are supplying a lot of options, you should
     * provide your own keys, as JSON.stringify can be
     * slow with lots of objects.
     *
     * The result of this function *must* be unique.
     *
     * @type {Function}
     * @param  {Object || String} option
     * @return {String}
     */
    getOptionKey: {
      type: Function,
      default: function _default(option) {
        if ((typeof option === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(option)) !== "object") {
          return option;
        }

        try {
          return option.hasOwnProperty("id") ? option.id : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utility_sortAndStringify_js__["a" /* default */])(option);
        } catch (e) {
          var warning = "[vue-select warn]: Could not stringify this option " + "to generate unique key. Please provide'getOptionKey' prop " + "to return a unique key for each option.\n" + "https://vue-select.org/api/props.html#getoptionkey";
          return console.warn(warning, option, e);
        }
      }
    },

    /**
     * Select the current value if selectOnTab is enabled
     * @deprecated since 3.3
     */
    onTab: {
      type: Function,
      default: function _default() {
        if (this.selectOnTab && !this.isComposing) {
          this.typeAheadSelect();
        }
      }
    },

    /**
     * Enable/disable creating options from searchEl.
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },

    /**
     * Set the tabindex for the input field.
     * @type {Number}
     */
    tabindex: {
      type: Number,
      default: null
    },

    /**
     * When true, newly created tags will be added to
     * the options list.
     * @type {Boolean}
     */
    pushTags: {
      type: Boolean,
      default: false
    },

    /**
     * When true, existing options will be filtered
     * by the search text. Should not be used in conjunction
     * with taggable.
     * @type {Boolean}
     */
    filterable: {
      type: Boolean,
      default: true
    },

    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     * @type   {Function}
     * @param  {Object || String} option
     * @param  {String} label
     * @param  {String} search
     * @return {Boolean}
     */
    filterBy: {
      type: Function,
      default: function _default(option, label, search) {
        return (label || "").toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
      }
    },

    /**
     * Callback to filter results when search text
     * is provided. Default implementation loops
     * each option, and returns the result of
     * this.filterBy.
     * @type   {Function}
     * @param  {Array} list of options
     * @param  {String} search text
     * @param  {Object} vSelect instance
     * @return {Boolean}
     */
    filter: {
      type: Function,
      default: function _default(options, search) {
        var _this = this;

        return options.filter(function (option) {
          var label = _this.getOptionLabel(option);
          if (typeof label === "number") {
            label = label.toString();
          }
          return _this.filterBy(option, label, search);
        });
      }
    },

    /**
     * User defined function for adding Options
     * @type {Function}
     */
    createOption: {
      type: Function,
      default: function _default(option) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.optionList[0]) === "object" ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.label, option) : option;
      }
    },

    /**
     * When false, updating the options will not reset the selected value. Accepts
     * a `boolean` or `function` that returns a `boolean`. If defined as a function,
     * it will receive the params listed below.
     *
     * @since 3.4 - Type changed to {Boolean|Function}
     *
     * @type {Boolean|Function}
     * @param {Array} newOptions
     * @param {Array} oldOptions
     * @param {Array} selectedValue
     */
    resetOnOptionsChange: {
      default: false,
      validator: function validator(value) {
        return ["function", "boolean"].includes(typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value));
      }
    },

    /**
     * If search text should clear on blur
     * @return {Boolean} True when single and clearSearchOnSelect
     */
    clearSearchOnBlur: {
      type: Function,
      default: function _default(_ref2) {
        var clearSearchOnSelect = _ref2.clearSearchOnSelect,
            multiple = _ref2.multiple;

        return clearSearchOnSelect && !multiple;
      }
    },

    /**
     * Disable the dropdown entirely.
     * @type {Boolean}
     */
    noDrop: {
      type: Boolean,
      default: false
    },

    /**
     * Sets the id of the input element.
     * @type {String}
     * @default {null}
     */
    // eslint-disable-next-line vue/require-default-prop
    inputId: {
      type: String
    },

    /**
     * Sets RTL support. Accepts 'ltr', 'rtl', 'auto'.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir
     * @type {String}
     * @default 'auto'
     */
    dir: {
      type: String,
      default: "auto"
    },

    /**
     * When true, hitting the 'tab' key will select the current select value
     * @type {Boolean}
     * @deprecated since 3.3 - use selectOnKeyCodes instead
     */
    selectOnTab: {
      type: Boolean,
      default: false
    },

    /**
     * Keycodes that will select the current option.
     * @type Array
     */
    selectOnKeyCodes: {
      type: Array,
      default: function _default() {
        return [13];
      }
    },

    /**
     * Query Selector used to find the search input
     * when the 'search' scoped slot is used.
     *
     * Must be a valid CSS selector string.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
     * @type {String}
     */
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },

    /**
     * Used to modify the default keydown events map
     * for the search input. Can be used to implement
     * custom behaviour for key presses.
     */

    mapKeydown: {
      type: Function,
      /**
       * @param map {Object}
       * @param vm {VueSelect}
       * @return {Object}
       */
      default: function _default(map, vm) {
        return map;
      }
    },

    /**
     * Append the dropdown element to the end of the body
     * and size/position it dynamically. Use it if you have
     * overflow or z-index issues.
     * @type {Boolean}
     */
    appendToBody: {
      type: Boolean,
      default: false
    },

    /**
     * When `appendToBody` is true, this function is responsible for
     * positioning the drop down list.
     *
     * If a function is returned from `calculatePosition`, it will
     * be called when the drop down list is removed from the DOM.
     * This allows for any garbage collection you may need to do.
     *
     * @since v3.7.0
     * @see http://vue-select.org/guide/positioning.html
     */
    calculatePosition: {
      type: Function,
      /**
       * @param dropdownList {HTMLUListElement}
       * @param component {Vue} current instance of vue select
       * @param width {string} calculated width in pixels of the dropdown menu
       * @param top {string} absolute position top value in pixels relative to the document
       * @param left {string} absolute position left value in pixels relative to the document
       * @return {function|void}
       */
      default: function _default(dropdownList, component, _ref3) {
        var width = _ref3.width,
            top = _ref3.top,
            left = _ref3.left;

        dropdownList.style.top = top;
        dropdownList.style.left = left;
        dropdownList.style.width = width;
      }
    },

    /**
     * Determines whether the dropdown should be open.
     * Receives the component instance as the only argument.
     *
     * @since v3.12.0
     * @return boolean
     */
    dropdownShouldOpen: {
      type: Function,
      default: function _default(_ref4) {
        var noDrop = _ref4.noDrop,
            open = _ref4.open,
            mutableLoading = _ref4.mutableLoading;

        return noDrop ? false : open && !mutableLoading;
      }
    },

    /**
     * A unique identifier used to generate IDs in HTML.
     * Must be unique for every instance of the component.
     */
    uid: {
      type: [String, Number],
      default: function _default() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utility_uniqueId_js__["a" /* default */])();
      }
    }
  },

  data: function data() {
    return {
      search: "",
      open: false,
      isComposing: false,
      pushedTags: [],
      // eslint-disable-next-line vue/no-reserved-keys
      _value: [] // Internal value managed by Vue Select if no `value` prop is passed
    };
  },


  computed: {
    /**
     * Determine if the component needs to
     * track the state of values internally.
     * @return {boolean}
     */
    isTrackingValues: function isTrackingValues() {
      return typeof this.value === "undefined" || this.$options.propsData.hasOwnProperty("reduce");
    },


    /**
     * The options that are currently selected.
     * @return {Array}
     */
    selectedValue: function selectedValue() {
      var value = this.value;
      if (this.isTrackingValues) {
        // Vue select has to manage value internally
        value = this.$data._value;
      }

      if (value !== undefined && value !== null && value !== "") {
        return [].concat(value);
      }

      return [];
    },


    /**
     * The options available to be chosen
     * from the dropdown, including any
     * tags that have been pushed.
     *
     * @return {Array}
     */
    optionList: function optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },


    /**
     * Find the search input DOM element.
     * @returns {HTMLInputElement}
     */
    searchEl: function searchEl() {
      return !!this.$scopedSlots["search"] ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },


    /**
     * The object to be bound to the $slots.search scoped slot.
     * @returns {Object}
     */
    scope: function scope() {
      var _this2 = this;

      var listSlot = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": "vs" + this.uid + "__combobox",
            "aria-controls": "vs" + this.uid + "__listbox",
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": "vs" + this.uid + "__option-" + this.typeAheadPointer
          } : {}),
          events: {
            compositionstart: function compositionstart() {
              return _this2.isComposing = true;
            },
            compositionend: function compositionend() {
              return _this2.isComposing = false;
            },
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: function input(e) {
              return _this2.search = e.target.value;
            }
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: listSlot,
        listFooter: listSlot,
        header: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, listSlot, { deselect: this.deselect }),
        footer: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, listSlot, { deselect: this.deselect })
      };
    },


    /**
     * Returns an object containing the child components
     * that will be used throughout the component. The
     * `component` prop can be used to overwrite the defaults.
     *
     * @return {Object}
     */
    childComponents: function childComponents() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__childComponents_js__["a" /* default */], this.components);
    },


    /**
     * Holds the current state of the component.
     * @return {Object}
     */
    stateClasses: function stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },


    /**
     * Return the current state of the
     * search input
     * @return {Boolean} True if non empty value
     */
    searching: function searching() {
      return !!this.search;
    },


    /**
     * Return the current state of the
     * dropdown menu.
     * @return {Boolean} True if open
     */
    dropdownOpen: function dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },


    /**
     * Return the placeholder string if it's set
     * & there is no value selected.
     * @return {String} Placeholder text
     */
    searchPlaceholder: function searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : undefined;
    },


    /**
     * The currently displayed options, filtered
     * by the search elements value. If tagging
     * true, the search text will be prepended
     * if it doesn't already exist.
     *
     * @return {array}
     */
    filteredOptions: function filteredOptions() {
      var optionList = [].concat(this.optionList);

      if (!this.filterable && !this.taggable) {
        return optionList;
      }

      var options = this.search.length ? this.filter(optionList, this.search, this) : optionList;
      if (this.taggable && this.search.length) {
        var createdOption = this.createOption(this.search);
        if (!this.optionExists(createdOption)) {
          options.unshift(createdOption);
        }
      }
      return options;
    },


    /**
     * Check if there aren't any options selected.
     * @return {Boolean}
     */
    isValueEmpty: function isValueEmpty() {
      return this.selectedValue.length === 0;
    },


    /**
     * Determines if the clear button should be displayed.
     * @return {Boolean}
     */
    showClearButton: function showClearButton() {
      return this.clearable && !this.isValueEmpty;
    }
  },

  watch: {
    /**
     * Maybe reset the value
     * when options change.
     * Make sure selected option
     * is correct.
     * @return {[type]} [description]
     */
    options: function options(newOptions, oldOptions) {
      var _this3 = this;

      var shouldReset = function shouldReset() {
        return typeof _this3.resetOnOptionsChange === "function" ? _this3.resetOnOptionsChange(newOptions, oldOptions, _this3.selectedValue) : _this3.resetOnOptionsChange;
      };

      if (!this.taggable && shouldReset()) {
        this.clearSelection();
      }

      if (this.value && this.isTrackingValues) {
        this.setInternalValueFromOptions(this.value);
      }
    },


    /**
     * Make sure to update internal
     * value if prop changes outside
     */
    value: {
      immediate: true,
      handler: function handler(val) {
        if (this.isTrackingValues) {
          this.setInternalValueFromOptions(val);
        }
      }
    },

    /**
     * Always reset the value when
     * the multiple prop changes.
     * @return {void}
     */
    multiple: function multiple() {
      this.clearSelection();
    },
    open: function open(isOpen) {
      this.$emit(isOpen ? "open" : "close");
    }
  },

  created: function created() {
    this.mutableLoading = this.loading;

    this.$on("option:created", this.pushTag);
  },


  methods: {
    /**
     * Make sure tracked value is
     * one option if possible.
     * @param  {Object|String} value
     * @return {void}
     */
    setInternalValueFromOptions: function setInternalValueFromOptions(value) {
      var _this4 = this;

      if (Array.isArray(value)) {
        this.$data._value = value.map(function (val) {
          return _this4.findOptionFromReducedValue(val);
        });
      } else {
        this.$data._value = this.findOptionFromReducedValue(value);
      }
    },


    /**
     * Select or deselect a given option.
     * Allow deselect if clearable or if not the only selected option.
     * @param  {Object|String} option
     * @return {void}
     */
    select: function select(option) {
      this.$emit("option:selecting", option);
      if (!this.isOptionSelected(option)) {
        if (this.taggable && !this.optionExists(option)) {
          this.$emit("option:created", option);
        }
        if (this.multiple) {
          option = this.selectedValue.concat(option);
        }
        this.updateValue(option);
        this.$emit("option:selected", option);
      } else if (this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1)) {
        this.deselect(option);
      }
      this.onAfterSelect(option);
    },


    /**
     * De-select a given option.
     * @param  {Object|String} option
     * @return {void}
     */
    deselect: function deselect(option) {
      var _this5 = this;

      this.$emit("option:deselecting", option);
      this.updateValue(this.selectedValue.filter(function (val) {
        return !_this5.optionComparator(val, option);
      }));
      this.$emit("option:deselected", option);
    },


    /**
     * Clears the currently selected value(s)
     * @return {void}
     */
    clearSelection: function clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },


    /**
     * Called from this.select after each selection.
     * @param  {Object|String} option
     * @return {void}
     */
    onAfterSelect: function onAfterSelect(option) {
      var _this6 = this;

      if (this.closeOnSelect) {
        this.open = !this.open;
        this.searchEl.blur();
      }

      if (this.clearSearchOnSelect) {
        this.search = "";
      }
      if (this.noDrop && this.multiple) {
        this.$nextTick(function () {
          return _this6.$refs.search.focus();
        });
      }
    },


    /**
     * Accepts a selected value, updates local
     * state when required, and triggers the
     * input event.
     *
     * @emits input
     * @param value
     */
    updateValue: function updateValue(value) {
      var _this7 = this;

      if (typeof this.value === "undefined") {
        // Vue select has to manage value
        this.$data._value = value;
      }

      if (value !== null) {
        if (Array.isArray(value)) {
          value = value.map(function (val) {
            return _this7.reduce(val);
          });
        } else {
          value = this.reduce(value);
        }
      }

      this.$emit("input", value);
    },


    /**
     * Toggle the visibility of the dropdown menu.
     * @param  {Event} event
     * @return {void}
     */
    toggleDropdown: function toggleDropdown(event) {
      var targetIsNotSearch = event.target !== this.searchEl;
      if (targetIsNotSearch) {
        event.preventDefault();
      }

      //  don't react to click on deselect/clear buttons,
      //  they dropdown state will be set in their click handlers
      var ignoredButtons = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$refs["deselectButtons"] || []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()([this.$refs["clearButton"]] || []));

      if (this.searchEl === undefined || ignoredButtons.filter(Boolean).some(function (ref) {
        return ref.contains(event.target) || ref === event.target;
      })) {
        event.preventDefault();
        return;
      }

      if (this.open && targetIsNotSearch) {
        this.searchEl.blur();
      } else if (!this.disabled) {
        this.open = true;
        this.searchEl.focus();
      }
    },


    /**
     * Check if the given option is currently selected.
     * @param  {Object|String}  option
     * @return {Boolean}        True when selected | False otherwise
     */
    isOptionSelected: function isOptionSelected(option) {
      var _this8 = this;

      return this.selectedValue.some(function (value) {
        return _this8.optionComparator(value, option);
      });
    },


    /**
     *  Can the current option be removed via the dropdown?
     */
    isOptionDeselectable: function isOptionDeselectable(option) {
      return this.isOptionSelected(option) && this.deselectFromDropdown;
    },


    /**
     * Determine if two option objects are matching.
     *
     * @param a {Object}
     * @param b {Object}
     * @returns {boolean}
     */
    optionComparator: function optionComparator(a, b) {
      return this.getOptionKey(a) === this.getOptionKey(b);
    },


    /**
     * Finds an option from the options
     * where a reduced value matches
     * the passed in value.
     *
     * @param value {Object}
     * @returns {*}
     */
    findOptionFromReducedValue: function findOptionFromReducedValue(value) {
      var _this9 = this;

      var predicate = function predicate(option) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this9.reduce(option)) === __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(value);
      };

      var matches = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.options), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.pushedTags)).filter(predicate);

      if (matches.length === 1) {
        return matches[0];
      }

      /**
       * This second loop is needed to cover an edge case where `taggable` + `reduce`
       * were used in conjunction with a `create-option` that doesn't create a
       * unique reduced value.
       * @see https://github.com/sagalbot/vue-select/issues/1089#issuecomment-597238735
       */
      return matches.find(function (match) {
        return _this9.optionComparator(match, _this9.$data._value);
      }) || value;
    },


    /**
     * 'Private' function to close the search options
     * @emits  {search:blur}
     * @returns {void}
     */
    closeSearchOptions: function closeSearchOptions() {
      this.open = false;
      this.$emit("search:blur");
    },


    /**
     * Delete the value on Delete keypress when there is no
     * text in the search input, & there's tags to delete
     * @return {this.value}
     */
    maybeDeleteValue: function maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        var value = null;
        if (this.multiple) {
          value = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.selectedValue.slice(0, this.selectedValue.length - 1)));
        }
        this.updateValue(value);
      }
    },


    /**
     * Determine if an option exists
     * within this.optionList array.
     *
     * @param  {Object || String} option
     * @return {boolean}
     */
    optionExists: function optionExists(option) {
      var _this10 = this;

      return this.optionList.some(function (_option) {
        return _this10.optionComparator(_option, option);
      });
    },


    /**
     * Ensures that options are always
     * passed as objects to scoped slots.
     * @param option
     * @return {*}
     */
    normalizeOptionForSlot: function normalizeOptionForSlot(option) {
      return (typeof option === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(option)) === "object" ? option : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.label, option);
    },


    /**
     * If push-tags is true, push the
     * given option to `this.pushedTags`.
     *
     * @param  {Object || String} option
     * @return {void}
     */
    pushTag: function pushTag(option) {
      this.pushedTags.push(option);
    },


    /**
     * If there is any text in the search input, remove it.
     * Otherwise, blur the search input to close the dropdown.
     * @return {void}
     */
    onEscape: function onEscape() {
      if (!this.search.length) {
        this.searchEl.blur();
      } else {
        this.search = "";
      }
    },


    /**
     * Close the dropdown on blur.
     * @emits  {search:blur}
     * @return {void}
     */
    onSearchBlur: function onSearchBlur() {
      if (this.mousedown && !this.searching) {
        this.mousedown = false;
      } else {
        var clearSearchOnSelect = this.clearSearchOnSelect,
            multiple = this.multiple;

        if (this.clearSearchOnBlur({ clearSearchOnSelect: clearSearchOnSelect, multiple: multiple })) {
          this.search = "";
        }
        this.closeSearchOptions();
        return;
      }
      // Fixed bug where no-options message could not be closed
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },


    /**
     * Open the dropdown on focus.
     * @emits  {search:focus}
     * @return {void}
     */
    onSearchFocus: function onSearchFocus() {
      this.open = true;
      this.$emit("search:focus");
    },


    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     * firing a `blur` event when clicking
     * the dropdown's scrollbar, causing it
     * to collapse abruptly.
     * @see https://github.com/sagalbot/vue-select/issues/106
     * @return {void}
     */
    onMousedown: function onMousedown() {
      this.mousedown = true;
    },


    /**
     * Event-Handler to help workaround IE11 (probably fixes 10 as well)
     * @see https://github.com/sagalbot/vue-select/issues/106
     * @return {void}
     */
    onMouseUp: function onMouseUp() {
      this.mousedown = false;
    },


    /**
     * Search <input> KeyBoardEvent handler.
     * @param e {KeyboardEvent}
     * @return {Function}
     */
    onSearchKeyDown: function onSearchKeyDown(e) {
      var _this11 = this;

      var preventAndSelect = function preventAndSelect(e) {
        e.preventDefault();
        return !_this11.isComposing && _this11.typeAheadSelect();
      };

      var defaults = {
        //  backspace
        8: function _(e) {
          return _this11.maybeDeleteValue();
        },
        //  tab
        9: function _(e) {
          return _this11.onTab();
        },
        //  esc
        27: function _(e) {
          return _this11.onEscape();
        },
        //  up.prevent
        38: function _(e) {
          e.preventDefault();
          return _this11.typeAheadUp();
        },
        //  down.prevent
        40: function _(e) {
          e.preventDefault();
          return _this11.typeAheadDown();
        }
      };

      this.selectOnKeyCodes.forEach(function (keyCode) {
        return defaults[keyCode] = preventAndSelect;
      });

      var handlers = this.mapKeydown(defaults, this);

      if (typeof handlers[e.keyCode] === "function") {
        return handlers[e.keyCode](e);
      }
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ImportUsersModal__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ImportUsersModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ImportUsersModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SettingsPoliciesControl__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SettingsPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__UserMgmt_SettingsPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserMgmt_CustomPropertiesPoliciesControl__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserMgmt_CustomPropertiesPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserMgmt_CustomPropertiesPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserMgmt_SurveysQuestionsPoliciesControl__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UserMgmt_SurveysQuestionsPoliciesControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UserMgmt_SurveysQuestionsPoliciesControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Tools_Select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ChangePasswordDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_UserSecurity__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_policiesmixin__ = __webpack_require__(63);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UserManagement",
  components: {
    SettingsPoliciesControl: __WEBPACK_IMPORTED_MODULE_6__UserMgmt_SettingsPoliciesControl___default.a,
    CustomPropertiesPoliciesControl: __WEBPACK_IMPORTED_MODULE_7__UserMgmt_CustomPropertiesPoliciesControl___default.a,
    SurveysQuestionsPoliciesControl: __WEBPACK_IMPORTED_MODULE_8__UserMgmt_SurveysQuestionsPoliciesControl___default.a,
    ImportUsersModal: __WEBPACK_IMPORTED_MODULE_5__components_ImportUsersModal___default.a,
    Select2: __WEBPACK_IMPORTED_MODULE_9__Tools_Select2___default.a,
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_10__Tools_Dialogs_ConfirmationDialog___default.a,
    "change-password-dialog": __WEBPACK_IMPORTED_MODULE_11__Tools_Dialogs_ChangePasswordDialog___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixins_policiesmixin__["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    this.readComponentSettingsFromStore();
    // Gets executed right after rendering the component
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getUserData();
    }
    this.getEditUserDialogSelectData();
    this.getTargetGroups();

    $('a[data-toggle="tab"]').on("hidden.bs.tab", function (e) {
      // Removes selected items on the security dialog after switching the tab
      _this.securityDialogData.selectedAssignedGroupGuids = [];
      _this.securityDialogData.selectedUnassignedGroupGuids = [];
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo) this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    this.globals.$off("SecurityGroupDeleteModalYesConfirmation");
    this.globals.$on("SecurityGroupDeleteModalYesConfirmation", function () {
      _this.deleteSelectedGroup();
    });
  },
  destroyed: function destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },

  computed: {
    clientListNumberd: function clientListNumberd() {
      return this.clientList.map(function (client) {
        return {
          ClientId: Number(client.ClientId),
          ClientName: client.ClientName
        };
      });
    },

    // List of security groups that are assigned to the current user
    groupListAssigned: function groupListAssigned() {
      var _this2 = this;

      return this.securityDialogData.dataLists.customGroupData.filter(function (g) {
        return _this2.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) > -1;
      });
    },

    // List of available security groups that are not assigned to the current user
    groupListAvailable: function groupListAvailable() {
      var _this3 = this;

      return this.securityDialogData.dataLists.customGroupData.filter(function (g) {
        return _this3.securityDialogData.assignedGroupGuids.indexOf(g.GroupGuid) < 0;
      });
    }
  },
  methods: {
    setTableHeight: function setTableHeight() {
      this.$nextTick(function () {
        var height = $(window).height();
        height -= $("#users-top-panel").height() + $("#app-navbar").height() +
        //$(".main-table > thead").height() +
        47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        height -= 100; // Lower height for client policies table because of dialog size limitations
        $(".client-policies-table").css("max-height", height);
        $("#locations2Tab .main-table-scrollbar").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore: function readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      var storedData = this.$store.getters["localFilters/userManagement"];
      if (storedData) {
        for (var key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (!this.feature.isAudiTarget || !this.feature.isEnabled("audi_importers")) {
        var storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.Company = storedClient.ClientName || "";
      }
    },
    writeComponentSettingsToStore: function writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/userManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize
      });
    },

    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput: function validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id).parent().parent().removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id).parent().parent().addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError: function inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },

    // returns user info text in format:
    // "Benutzername: Lastname, Firstname (Username); Benutzer-ID: {GUID}; Typ: {UserType}"
    getSelectedUserInfoText: function getSelectedUserInfoText() {
      var usr = this.selectedUserData;
      if (!usr) return "user informations unknown";
      var infoText = this.lang.S0178 + ": " + usr.LastName + ", " + usr.FirstName + " (" + usr.LoginName + "); " + this.lang.S0009 + ":" + usr.RoleType + ":" + usr.Role;
      if (usr.Company) infoText += " - " + usr.Company;
      return infoText;
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit: function validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          // escape special characters, because the ID is used in selector (this is a quick fix for #editUserDialogData.userData.RoleTypeGuid)
          result = this.validateInput(elements[i].id.replaceAll(".", "\\.")) && result; // If only one input is invalid, the whole form is invalid
      }

      if (dialogId == "editUser") {
        this.editUserDialogData.showAlert = !result;
        if (!result) return;
        this.saveEditUserDialogData();
      }
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors: function resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0) $("#" + elements[i].id).parent().parent().removeClass("has-error");
      }
      this.invalidInputIds = [];
    },


    // Open history
    showUserHistory: function showUserHistory() {
      var config = {
        type: "User",
        guid: this.editUserDialogData.userData.UserId, // here UserId is User Guid
        id: this.editUserDialogData.userData.UserId
      };
      this.globals.$emit("showElementHistory", config);
    },


    // Opens the security check dialog for deleting the selected user
    openDeleteUserDialog: function openDeleteUserDialog() {
      var _this4 = this;

      var objIndex = _.findIndex(this.userData, function (o) {
        return o.UserId == _this4.selectedUser;
      });
      this.deleteUserDialogData = this.userData[objIndex];
      $("#deleteUserDialog").modal("show");
    },

    // Sends a delete request for the selected user to the server
    deleteUserData: function deleteUserData() {
      var _this5 = this;

      $.ajax({
        method: "DELETE",
        url: "api/SecurityUsers/" + this.selectedUser,
        success: function success(data) {
          if (data.Error) {
            _this5.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          // If delete was successful, refresh displayed data and hide dialog
          _this5.globals.showSuccessSnackbar("User deletion successful");
          $("#deleteUserDialog").modal("hide");
          _this5.selectedUser = "";
          _this5.getUserData();
        },
        error: function error() {
          console.error("User data deletion failed in deleteUserData()");
          _this5.globals.showErrorSnackbar("User deletion failed");
        }
      });
    },

    // Refreshes the region list in the dropdown of the editUser dialog depending on the selected country
    changedCountry: function changedCountry(country) {
      var regionObj = [{ Regions: [] }];
      var tzObj = [{ TimeZones: [] }];

      if (typeof this.regionList != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          regionObj = this.regionList.filter(function (region) {
            // Filter regions for the given country
            return region.CountryCode.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (typeof this.timeZones != "undefined") {
        if (typeof country != "undefined" && country != "" && country != "  ") {
          tzObj = this.timeZones.filter(function (tz) {
            // Filter timezones for the given country
            return tz.Country.toLowerCase().indexOf(country.toLowerCase()) >= 0;
          });
        }
      }

      if (regionObj.length == 0) this.editUserDialogData.currentRegions = [];else this.editUserDialogData.currentRegions = regionObj[0].Regions;

      if (tzObj.length == 0) this.editUserDialogData.currentTimeZones = [];else this.editUserDialogData.currentTimeZones = tzObj[0].TimeZones;

      var idx = this.editUserDialogData.currentRegions.map(function (e) {
        return e.RegionGuid;
      }).indexOf(this.editUserDialogData.userData.RegionGuid);

      if (idx < 0) delete this.editUserDialogData.userData.RegionGuid;

      idx = this.editUserDialogData.currentTimeZones.map(function (e) {
        return e.TimeZoneId;
      }).indexOf(this.editUserDialogData.userData.TimeZone);

      if (idx < 0) delete this.editUserDialogData.userData.TimeZone;
    },
    roleTypeChanged: function roleTypeChanged() {
      delete this.editUserDialogData.userData.AgencyGuid;
      delete this.editUserDialogData.userData.ClientId;
      delete this.editUserDialogData.userData.RoleGuid;
      this.setCurrentRoles();
      this.$forceUpdate();
    },
    setCurrentRoles: function setCurrentRoles() {
      var _this6 = this;

      this.editUserDialogData.currentRoles = [];
      if (!this.editUserDialogData.userData.RoleTypeGuid || !this.roleData[0]) return;

      var rtData = _.find(this.roleData, function (rt) {
        return rt.RoleTypeGuid === _this6.editUserDialogData.userData.RoleTypeGuid;
      });
      if (rtData && rtData.Roles) {
        this.editUserDialogData.currentRoles = rtData.Roles;
        if (rtData.Roles.length === 1) this.editUserDialogData.userData.RoleGuid = rtData.Roles[0].RoleGuid;

        //this.$refs.editUserSelectRole.updateValue();
      }
    },
    securityDialogDataReceived: function securityDialogDataReceived() {
      $("#securityDialog").modal("show");
    },
    openSecurityDialog: function openSecurityDialog() {
      var _this7 = this;

      var doneCounter = 0;
      var requestCount = 2;

      this.securityDialogData.dataLists.securityGroupData = [];
      this.securityDialogData.dataLists.roleData = [];
      this.securityDialogData.dataLists.customGroupData = [];
      this.securityDialogData.assignedGroupGuids = [];
      this.securityDialogData.selectedAssignedGroupGuids = [];
      this.securityDialogData.selectedUnassignedGroupGuids = [];
      this.clearGroupManagementInputs();

      var query = "api/SecurityGroups";
      if (this.selectedUserData.ClientGuid) query += "?ClientGuid=" + this.selectedUserData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          var sortedData = _.sortBy(data, [function (g) {
            return g.GroupName.toLowerCase();
          }]);
          // Request general group informations
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sortedData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var group = _step.value;

              // Copy group data to different lists for roles, security groups and custom groups
              if (group.GroupType === "SM") _this7.securityDialogData.dataLists.securityGroupData.push(group);else if (group.GroupType === "SYSTEM") _this7.securityDialogData.dataLists.roleData.push(group);else if (group.GroupType === "SMUSER") _this7.securityDialogData.dataLists.customGroupData.push(group);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        },
        error: function error() {
          console.error("Group data access failed in openSecurityDialog()");
          _this7.globals.showErrorSnackbar("Group data access failed");
          doneCounter = -1;
        },
        complete: function complete() {
          doneCounter++;
          if (doneCounter >= requestCount) _this7.securityDialogDataReceived();
        }
      });

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/" + this.selectedUser + "/Groups",
        success: function success(data) {
          // Request groups that are assigned to current user
          _this7.securityDialogData.assignedGroupGuids = data;
        },
        error: function error() {
          console.error("Group assignment data access failed in openSecurityDialog()");
          _this7.globals.showErrorSnackbar("Group assignment data access failed");
          doneCounter = -1;
        },
        complete: function complete() {
          doneCounter++;
          if (doneCounter >= requestCount) _this7.securityDialogDataReceived();
        }
      });
    },
    getAllSecurityGroups: function getAllSecurityGroups() {
      var _this8 = this;

      var query = "api/SecurityGroups";
      if (this.selectedUserData.ClientGuid) query += "?ClientGuid=" + this.selectedUserData.ClientGuid;

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this8.securityDialogData.dataLists.securityGroupData = [];
          _this8.securityDialogData.dataLists.roleData = [];
          _this8.securityDialogData.dataLists.customGroupData = [];

          var sortedData = _.sortBy(data, [function (g) {
            return g.GroupName.toLowerCase();
          }]);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(sortedData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var group = _step2.value;

              // Copy group data to different lists for roles, security groups and custom groups
              if (group.GroupType === "SM") _this8.securityDialogData.dataLists.securityGroupData.push(group);else if (group.GroupType === "SYSTEM") _this8.securityDialogData.dataLists.roleData.push(group);else if (group.GroupType === "SMUSER") _this8.securityDialogData.dataLists.customGroupData.push(group);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        },
        error: function error() {
          console.error("Group data access failed in getAllSecurityGroups()");
          _this8.globals.showErrorSnackbar("Group data access failed");
        }
      });
    },
    getSecurityGroupData: function getSecurityGroupData() {
      var _this9 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
        success: function success(data) {
          // Request groups that are assigned to current user
          _this9.securityDialogData.groupManagement.selectedGroupData = data;
        },
        error: function error() {
          console.error("Group data access failed in getSecurityGroupData()");
          _this9.globals.showErrorSnackbar("Group data access failed");
        }
      });
    },
    getTargetGroups: function getTargetGroups() {
      var _this10 = this;

      var query = "api/Data/TargetGroups";

      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this10.targetGroups = data;
        },
        error: function error() {
          console.error("Target group data access failed in getTargetGroups()");
          _this10.globals.showErrorSnackbar("Target group data access failed");
        }
      });
    },
    targetGroupGuidChanged: function targetGroupGuidChanged(targetGroupGuid) {
      var groupGuid = this.isTargetGroupAlreadyInUse(targetGroupGuid);
      if (groupGuid && groupGuid !== this.securityDialogData.groupManagement.selectedGroupData.GroupGuid) {
        this.globals.$emit("openGlobalNotificationDialog", {
          initiator: "GroupManagementTargetGroupChange",
          notificationTitle: this.lang.S0198,
          colorRed: true,
          closeButtonText: this.lang.S0164,
          htmlText: "<b>\n            <p>" + this.lang.S0199 + "</p>\n          </b>"
        });
      }
      this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid = targetGroupGuid;
    },

    // Returns GUID of the group that uses the target group
    isTargetGroupAlreadyInUse: function isTargetGroupAlreadyInUse(targetGroupGuid) {
      if (this.securityDialogData.dataLists.customGroupData.length < 1) return "";

      var group = _.find(this.securityDialogData.dataLists.customGroupData, ["TargetGroupGuid", targetGroupGuid]);
      return group ? group.GroupGuid : "";
    },
    findNextFreeTargetGroup: function findNextFreeTargetGroup() {
      if (this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid) return this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid;

      for (var tg in this.targetGroups) {
        if (!this.isTargetGroupAlreadyInUse(tg)) return tg;
      }
      return "";
    },
    reportingGroupFlagToggled: function reportingGroupFlagToggled() {
      if (this.securityDialogData.groupManagement.selectedGroupData.IsReportingGroup) {
        if (this.selectedUserData.ClientGuid) {
          this.securityDialogData.groupManagement.selectedGroupData.ClientGuid = this.selectedUserData.ClientGuid;
          this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid = this.findNextFreeTargetGroup();
          this.$forceUpdate();
        }
      }
    },
    getSelectedClients: function getSelectedClients() {
      //return this.security2DialogData.dataLists.selectedClients.filter(i => {return i.Permitted})
      return this.security2DialogData.dataLists.selectedClients.filter(function (i) {
        return i.Permitted;
      });
    },

    // Opens the securityDialog after the dialog data is received
    security2DialogDataReceived: function security2DialogDataReceived() {
      $("#security2Dialog").modal("show");
    },

    //Apply filters for Location Data
    filterLocationData: function filterLocationData() {
      var keys = ["LocationStoreId", "LocationName", "LocationAddress", "LocationCountry", "LocationStatusId"];
      var filterStrings = this.security2DialogData.locationFilterStrings;
      var permittedLocations = this.security2DialogData.dataLists.permittedLocations;

      var locationFilter = function locationFilter(location) {
        var filterPassed = true;

        // Filter for location permission
        var locationPermitted = _.indexOf(permittedLocations, location.LocationGuid) > -1;
        if (filterStrings.LocationVisible === 0 && locationPermitted || filterStrings.LocationVisible === 1 && !locationPermitted) return false;

        // Filter for filterstrings
        keys.forEach(function (key) {
          if (typeof location[key] === "string" && location[key].toLowerCase().indexOf(filterStrings[key].toLowerCase()) < 0) {
            filterPassed = false;
            return;
          }
        });
        return filterPassed;
      };

      var filteredLocations = !_.isEmpty(this.security2DialogData.dataLists.locations) ? this.security2DialogData.dataLists.locations.filter(locationFilter) : [];

      // Filter top 100
      if (this.security2DialogData.showTop100LocationsOnly && filteredLocations.length > 100) filteredLocations = filteredLocations.slice(0, 100);

      this.security2DialogData.dataLists.filteredLocations = filteredLocations;
    },

    // Requests needed group data for the security dialog from the server
    openSecurity2Dialog: function openSecurity2Dialog() {
      var _this11 = this;

      var requestCount = 4;
      var successCallback = function successCallback() {
        if (--requestCount === 0) {
          _this11.security2DialogDataReceived();
        }
      };
      var errorCallback = function errorCallback() {
        _this11.globals.showErrorSnackbar("Policy data request failed");
      };

      this.security2DialogData.dataLists.selectedClients = [];
      this.security2DialogData.dataLists.clientSetting = [];
      this.security2DialogData.dataLists.locationProperties = [];
      this.security2DialogData.dataLists.locations = [];
      this.security2DialogData.hasAccessToAllLocations = false;

      // this.$refs.questions2Tab.loadPolicies();
      if (!this.security2DialogData.hasAccessToAllLocations) this.$refs.locationProperties2Tab.loadPolicies(successCallback, errorCallback);
      this.$refs.reportingFeatures2Tab.loadPolicies(successCallback, errorCallback);

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Clients",
        success: function success(data) {
          if (data && data[0] && data[0].ClientGuid && data[0].ClientGuid === _this11.selectedUserData.ClientGuid && data[0].Permitted === true) {
            _this11.security2DialogData.hasAccessToAllLocations = true;
          }
          successCallback();
        },
        error: function error() {
          console.error("Client data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Projects/Client/" + this.selectedUserData.ClientGuid,
        success: function success(data) {
          _this11.security2DialogData.dataLists.clientSetting = _.isEmpty(data) ? [] : data;
          successCallback();
        },
        error: function error() {
          console.error("Project data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });

      $.ajax({
        method: "GET",
        url: "/api/UserSecurity/" + this.selectedUser + "/Locations/Client/" + this.selectedUserData.ClientGuid,
        success: function success(data) {
          if (data && data[0]) {
            if (data[0].Locations) _this11.security2DialogData.dataLists.locations = data[0].Locations;else _this11.security2DialogData.dataLists.locations = [];

            if (data[0].Permitted) _this11.security2DialogData.dataLists.permittedLocations = data[0].Permitted;else _this11.security2DialogData.dataLists.permittedLocations = [];

            _this11.filterLocationData();
          }
          successCallback();
        },
        error: function error() {
          console.error("Location data access failed in openSecurity2Dialog()");
          errorCallback();
        }
      });
    },
    toggleLocationPermission: function toggleLocationPermission(locGuid) {
      this.security2DialogData.dataLists.permittedLocations = _.xor(this.security2DialogData.dataLists.permittedLocations, [locGuid]);
    },
    isLocationPermitted: function isLocationPermitted(locGuid) {
      return _.indexOf(this.security2DialogData.dataLists.permittedLocations, locGuid) > -1;
    },

    // Adds a new item to a list if it's not already in the list. Otherwise the item will me removed from the list.
    toggleListItem: function toggleListItem(list, item) {
      var index = list.indexOf(item);
      if (index > -1) {
        list.splice(index, 1);
      } else list.push(item);
    },

    // Assigns selected groups to the user
    assignGroups: function assignGroups() {
      if (this.securityDialogData.selectedUnassignedGroupGuids.length == 0) return;
      for (var i = 0; i < this.securityDialogData.selectedUnassignedGroupGuids.length; i++) {
        this.securityDialogData.assignedGroupGuids.push(this.securityDialogData.selectedUnassignedGroupGuids[i]);
      }
      this.securityDialogData.selectedUnassignedGroupGuids = [];
    },

    // Unassigns selected groups from the user
    unassignGroups: function unassignGroups() {
      if (this.securityDialogData.selectedAssignedGroupGuids.length == 0) return;
      for (var i = 0; i < this.securityDialogData.selectedAssignedGroupGuids.length; i++) {
        var index = this.securityDialogData.assignedGroupGuids.indexOf(this.securityDialogData.selectedAssignedGroupGuids[i]);
        this.securityDialogData.assignedGroupGuids.splice(index, 1);
      }
      this.securityDialogData.selectedAssignedGroupGuids = [];
    },

    // Edits a custom group to the group list or adds a new group if the group does not exist
    editGroup: function editGroup() {
      var _this12 = this;

      if (!this.securityDialogData.groupManagement.selectedGroupData.IsReportingGroup) delete this.securityDialogData.groupManagement.selectedGroupData.TargetGroupGuid;

      var groupData = _.cloneDeep(this.securityDialogData.groupManagement.selectedGroupData);
      if (!groupData.ClientGuid) delete groupData.ClientGuid;

      if (!this.securityDialogData.groupManagement.selectedGroup) {
        $.ajax({
          // Stores a new group on the server
          method: "POST",
          url: "api/SecurityGroups",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (!data || _.isEmpty(data)) {
              console.error("No valid group data returned in editGroup()");
              return;
            }
            if (data.Error) {
              _this12.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If POST was successful, store new data to local datalist and select the new group
            _this12.globals.showSuccessSnackbar("Group creation successful");
            groupData = data;
            _this12.getAllSecurityGroups();
            _this12.securityDialogData.groupManagement.selectedGroup = groupData.GroupGuid;
            _this12.securityDialogData.groupManagement.selectedGroupData = groupData;
            _this12.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          },
          error: function error() {
            console.error("Error on POST in editGroup()");
            _this12.globals.showErrorSnackbar("Group creation failed");
          }
        });
      } else {
        $.ajax({
          // Stores changes of a group on the server
          method: "PUT",
          url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(groupData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this12.globals.showErrorSnackbar(data.Error);
              return;
            }
            // If PUT was successful, store data to local datalist and select the new group
            _this12.globals.showSuccessSnackbar("Group update successful");
            var updatedGroupIndex = _.findIndex(_this12.securityDialogData.dataLists.customGroupData, ["GroupGuid", _this12.securityDialogData.groupManagement.selectedGroup]);

            _this12.getAllSecurityGroups();
            _this12.securityDialogData.groupManagement.isSelectedGroupDirty = false;
            _this12.$forceUpdate();
          },
          error: function error() {
            console.error("Error on PUT in editGroup()");
            _this12.globals.showErrorSnackbar("Group update failed");
          }
        });
      }
    },

    // Selects the group with the given ID and fills groupmanagement data fields depending on the selected group
    selectGroup: function selectGroup(groupGuid) {
      if (this.securityDialogData.groupManagement.selectedGroup === groupGuid) {
        this.clearGroupManagementInputs();
      } else {
        this.securityDialogData.groupManagement.selectedGroup = groupGuid;
        this.getSecurityGroupData();
      }
    },
    openGroupDeletionDialog: function openGroupDeletionDialog() {
      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "SecurityGroupDeleteModal",
        confirmationTitle: this.lang.S0192,
        colorRed: true,
        yesButtonText: this.lang.S0101,
        noButtonText: this.lang.S0102,
        htmlText: "<p><b>" + this.lang.S0193 + "</b></p>\n          <div class=\"form-group\">\n            <label class=\"col-md-3 text-black\">" + this.lang.S0194 + "</label>\n            <label class=\"col-md-9 text-black\">" + this.securityDialogData.groupManagement.selectedGroupData.GroupName + "</label>\n          </div>"
      });
    },

    // Removes the selected group from the list of custom groups
    deleteSelectedGroup: function deleteSelectedGroup() {
      var _this13 = this;

      $.ajax({
        // Stores a new group on the server
        method: "DELETE",
        url: "api/SecurityGroups/" + this.securityDialogData.groupManagement.selectedGroup,
        data: {},
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          // If DELETE was successful, remove data from local datalist
          _this13.globals.showSuccessSnackbar("Group deletion successful");
          _this13.securityDialogData.dataLists.customGroupData = _this13.securityDialogData.dataLists.customGroupData.filter(function (e) {
            return e.GroupGuid !== _this13.securityDialogData.groupManagement.selectedGroup;
          });
          _this13.clearGroupManagementInputs();
        },
        error: function error() {
          console.error("Error on DELETE in deleteSelectedGroup()");
          _this13.globals.showErrorSnackbar("Group deletion failed");
        }
      });
    },

    // Clears the input fields in groupmanagement
    clearGroupManagementInputs: function clearGroupManagementInputs() {
      this.securityDialogData.groupManagement = {
        selectedGroup: "",
        selectedGroupData: {}
      };
    },

    // Sends data from the security dialog to the server to store it in the database
    saveSecurityData: function saveSecurityData() {
      var _this14 = this;

      if (this.globals.isAccessAllowed("LoopOp_SecurityUsersSecurityGroups_Update")) {
        $.ajax({
          // Stores groups that are assigned to the selected user
          method: "PUT",
          url: "api/SecurityUsers/" + this.selectedUser + "/Groups",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.securityDialogData.assignedGroupGuids),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If PUT was successful, hide dialog
            _this14.globals.showSuccessSnackbar("Group security update successful");
            $("#securityDialog").modal("hide");
          },
          error: function error() {
            console.error("Error on PUT in saveSecurityData()");
            _this14.globals.showErrorSnackbar("Group security update failed");
          }
        });
      }
    },

    /**
     * turns a functions with an succes and error callback into
     * a promise to await or Promise.all
     * @param {function}  fn
     * @returns {Promise<T>}
     */
    promisfy: function promisfy(fn) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        fn(resolve, reject);
      });
    },
    saveSecurity2Data: function saveSecurity2Data() {
      var _this15 = this;

      var refCallbacks = [this.$refs.reportingFeatures2Tab.saveChanges];
      if (!this.security2DialogData.hasAccessToAllLocations) refCallbacks.push(this.$refs.locationProperties2Tab.saveChanges);

      var saveClients = function saveClients(succ, onerror) {
        var clients = [];
        if (_this15.security2DialogData.hasAccessToAllLocations) clients.push(_this15.selectedUserData.ClientGuid);
        $.ajax({
          method: "PUT",
          url: "api/UserSecurity/" + _this15.selectedUser + "/Clients",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(clients),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success() {
            succ();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.error("Error on PUT (Clients) in saveSecurity2Data()");
            onerror({ jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
          }
        });
      };

      //this.$refs.questions2Tab.saveChanges();
      var saveLocations = function saveLocations(succ, onerror) {
        $.ajax({
          method: "PUT",
          url: "api/UserSecurity/" + _this15.selectedUser + "/Locations",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this15.security2DialogData.dataLists.permittedLocations),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success() {
            succ();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.error("Error on PUT (Locations) in saveSecurity2Data()");
            onerror({ jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
          }
        });
      };

      var clientSettingsData = this.getClientSettingsPutData();
      var saveProjects = function saveProjects(succ, onerror) {
        $.ajax({
          method: "PUT",
          url: "api/UserSecurity/" + _this15.selectedUser + "/Projects",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(clientSettingsData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success() {
            succ();
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.error("Error on PUT (Client Settings) in saveSecurity2Data()");
            onerror({ jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
          }
        });
      };

      var requests = [saveClients, saveLocations, saveProjects].concat(refCallbacks).map(function (fn) {
        return _this15.promisfy(fn);
      });

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(requests).then(function (_data) {
        _this15.globals.showSuccessSnackbar("Security data update successful");
      }).catch(function (err) {
        console.error(err);
        if (err.textStatus) {
          _this15.globals.showErrorSnackbar("Security data update failed " + err.textStatus);
        } else {
          _this15.globals.showErrorSnackbar("Security data update failed");
        }
      });
    },
    getClientSettingsPutData: function getClientSettingsPutData() {
      var projects = this.security2DialogData.dataLists.clientSetting;
      var visibleProjects = [],
          visibleWaves = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(projects), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var project = _step3.value;

          if (project.Forbidden) visibleProjects.push(project.ProjectGuid);else if (project.Waves) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(project.Waves), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _wave = _step4.value;

                if (_wave.Forbidden) visibleWaves.push(_wave.WaveGuid);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return { Projects: visibleProjects, Waves: visibleWaves };
    },
    hasForbiddenWaves: function hasForbiddenWaves(project) {
      if (!project || project.Forbidden || !project.Waves) return false;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(project.Waves), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var wave = _step5.value;
          if (wave.Forbidden) return true;
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },
    editUserDialogDataReceived: function editUserDialogDataReceived() {
      $("#editUser").modal("show");
    },
    openEditUserDialog: function openEditUserDialog(mode) {
      var _this16 = this;

      if (mode == "create") {
        this.editUserDialogData.dialogTitle = this.lang.S0052;
        this.editUserDialogData.dialogType = "create";
        this.editUserDialogData.userData.RoleTypeGuid = this.roleData[0].RoleTypeGuid;
        delete this.editUserDialogData.userData.RoleGuid;
        this.setCurrentRoles();
        delete this.editUserDialogData.userData.UserId;
        delete this.editUserDialogData.userData.LoginName;
        delete this.editUserDialogData.userData.Password;
        delete this.editUserDialogData.userData.FirstName;
        delete this.editUserDialogData.userData.LastName;
        delete this.editUserDialogData.userData.CompanyName;
        delete this.editUserDialogData.userData.Gender;
        delete this.editUserDialogData.userData.AgencyGuid;
        delete this.editUserDialogData.userData.ClientId;
        delete this.editUserDialogData.userData.Address1;
        delete this.editUserDialogData.userData.Address2;
        delete this.editUserDialogData.userData.City;
        delete this.editUserDialogData.userData.Region;
        delete this.editUserDialogData.userData.Country;
        delete this.editUserDialogData.userData.PostalCode;
        delete this.editUserDialogData.userData.PhoneHome;
        delete this.editUserDialogData.userData.PhoneWork;
        delete this.editUserDialogData.userData.PhoneMobile;
        delete this.editUserDialogData.userData.Fax;
        delete this.editUserDialogData.userData.Email;
        delete this.editUserDialogData.userData.TimeZone;
        this.editUserDialogData.userData.Active = "true";
        delete this.editUserDialogData.userData.LanguageCode;
        // this.editUserDialogData.userData.DateRegistered = "";
        delete this.editUserDialogData.userData.DefaultWelcomePage;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Lat;
        delete this.editUserDialogData.userData.GeographyFromGeocoding_Long;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Lat;
        delete this.editUserDialogData.userData.GeographyFromPostalCode_Long;
        delete this.editUserDialogData.userData.DistanceUnit;
        this.changedCountry("");
        $("#editUser").modal("show");
      } else if (mode == "edit") {
        this.editUserDialogData.dialogTitle = this.lang.S0053;
        this.editUserDialogData.dialogType = "edit";
        this.editUserDialogData.userData = {};

        $.ajax({
          method: "GET",
          url: "api/SecurityUsers/" + this.selectedUser,
          success: function success(data) {
            _this16.editUserDialogDataReceived();
            if (_this16.copyUser) {
              delete data.LoginName;
            }
            _this16.editUserDialogData.userData = data; // Store response data from server
            _this16.changedCountry(_this16.editUserDialogData.userData.Country); // Load region dropdown depending on the selected country
            if (_this16.editUserDialogData.userData.LocationProperties) {
              _this16.editUserDialogData.userData.LocationProperties.forEach(function (locationPropertie) {
                if (locationPropertie.LocationPropertyName === "Market_short") {
                  _this16.editUserDialogData.userData.Market = locationPropertie.LocationPropertyValue;
                }
              });
            }
            _this16.setCurrentRoles();
            _this16.$forceUpdate();
          },
          error: function error() {
            console.error("User data access failed in openEditUserDialog()");
            _this16.globals.showErrorSnackbar("User data access failed");
          }
        });
      } else {
        // Wrong mode
        console.error("Wrong user dialog mode in openEditUserDialog()");
        $("#editUser").modal("hide");
        return false;
      }
      this.editUserDialogData.showAlert = false;
      this.resetValidationErrors("editUser");
      return true; // Mode was ok
    },

    // Catch client list
    getClientList: function getClientList() {
      var _this17 = this;

      $.ajax({
        method: "GET",
        url: "api/Data/Clients",
        success: function success(data) {
          _this17.clientList = [];
          for (var x in data) {
            _this17.clientList.push({ ClientId: x, ClientName: data[x] });
          }

          _this17.clientList.sort(function (a, b) {
            // Sort clients by name
            if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) return -1;
            if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) return 1;
            return 0;
          });
        },
        error: function error() {
          console.error("Client data access failed in getClientList()");
          _this17.globals.showErrorSnackbar("Client data access failed");
        }
      });
    },

    // Catches data for dropdown lists from server
    getEditUserDialogSelectData: function getEditUserDialogSelectData() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this18.globals.getCountryList();
                _this18.globals.getRegionsList(function (callbackData) {
                  _this18.regionList = callbackData;
                });
                _this18.globals.getLanguageList(function (callbackData) {
                  _this18.languageList = callbackData;
                });
                _this18.globals.getMarketList(function (callbackData) {
                  _this18.marketList = callbackData;
                });
                if (_this18.globals.selectedLanguage) _this18.globals.getRoleData(function (callbackData) {
                  _this18.roleData = callbackData;
                });
                _this18.globals.getTimezonesList(function (callbackData) {
                  _this18.timeZones = callbackData;
                });
                _this18.globals.getDistanceUnitList(function (callbackData) {
                  _this18.distanceUnits = callbackData;
                });
                _this18.globals.getAgencyList(function (callbackData) {
                  _this18.agencyList = callbackData;
                });
                _this18.getClientList();
                _context.next = 11;
                return _this18.globals.getClientList();

              case 11:
                _this18.clientListWithGuid = _context.sent;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this18);
      }))();
    },
    saveSelectedMarket: function saveSelectedMarket() {
      if (this.editUserDialogData.userData.Market_short) {
        var itms = [{
          LocationPropertyGuid: this.editUserDialogData.userData.Market_short.LocationPropertyGuid,
          LocationPropertyValue: this.editUserDialogData.userData.Market_short.LocationPropertyValue
        }];
        var url = "api/UserSecurity/" + this.editUserDialogData.userData.UserId + "/LocationProperties";
        return __WEBPACK_IMPORTED_MODULE_12__services_UserSecurity__["a" /* default */].LocationProperties.updateforUser(this.editUserDialogData.userData.UserId, itms);
      } else {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          // nothing to save
          reject("No market to save.");
        });
      }
    },

    // Sends the data from editUser dialog to the server to store it in the database
    saveEditUserDialogData: function saveEditUserDialogData() {
      var _this19 = this;

      if (this.feature.isAudiTarget && this.globals.roleTypeHasSuffix(this.editUserDialogData.userData.RoleTypeGuid, "Audi") && this.clientList[0] && this.clientList[0].ClientId) this.editUserDialogData.userData.ClientId = this.clientList[0].ClientId;

      // Security Role -> Admin
      // Bei allen Usern
      if (this.feature.isPorscheTarget && this.editUserDialogData.userData.Market_short) {
        this.saveSelectedMarket().then(function (res) {
          _this19.globals.showSuccessSnackbar("Saved Market");
        }).catch(function (err) {
          console.error(err);
          _this19.globals.showErrorSnackbar("Error in saveSelectedMarket()");
        });
      }

      if (this.editUserDialogData.dialogType == "create" || this.copyUser) {
        // copy user
        if (this.copyUser) {
          this.editUserDialogData.userData.IsCopyOf = this.editUserDialogData.userData.UserId;
          delete this.editUserDialogData.userData.UserId;
        }
        // Create new user
        $.ajax({
          method: "POST",
          url: "api/SecurityUsers",
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            if (data.Error) {
              _this19.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            _this19.globals.showSuccessSnackbar("User creation successful");
            _this19.getUserData();
            _this19.selectedUser = data[0].UserId;
            $("#editUser").modal("hide");
            _this19.copyUser = false;
          },
          error: function error() {
            console.error("Error on POST in saveEditUserDialogData()");
            _this19.globals.showErrorSnackbar("User creation failed");
          }
        });
      } else if (this.editUserDialogData.dialogType == "edit") {
        // Update existing user
        $.ajax({
          method: "PUT",
          url: "api/SecurityUsers/" + this.editUserDialogData.userData.UserId,
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.editUserDialogData.userData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function success(data) {
            // If PUT was successful, refresh displayed data and hide dialog
            _this19.globals.showSuccessSnackbar("User update successful");
            _this19.getUserData();
            $("#editUser").modal("hide");
          },
          error: function error() {
            console.error("Error on PUT in saveEditUserDialogData()");
            _this19.globals.showErrorSnackbar("User update failed");
          }
        });
      } else console.error("Wrong user dialog mode");
    },

    // Calculates the sort order for the given column and refreshes the displayed data
    sortUserData: function sortUserData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc" ? this.sortOrder = "desc" : this.sortOrder = "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getUserData();
    },

    // Catches user data for the table from the server, including current filter, pagination and sort settings
    getUserData: function getUserData() {
      var _this20 = this;

      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      var getString = "api/SecurityUsers/Get?page_size=" + this.pageSize + "&page=" + this.selectedPage + "&sort_column=" + this.sortField + "&sort_order=" + this.sortOrder;
      getString = encodeURI(getString);

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          _this20.userData = data[0].Users; // If GET was successful, store user data and page count from server
          _this20.pageCount = data[0].Page_Count;
          _this20.totalElementsCount = data[0].Count;

          if (_this20.selectedUser) {
            var selUser = _.find(_this20.userData, ["UserId", _this20.selectedUser]);
            if (selUser) _this20.selectedUserData = selUser;
          }
        },
        error: function error() {
          console.error("Error on POST in getUserData()");
          _this20.globals.showErrorSnackbar("User data request failed");
        },
        complete: function complete() {
          _this20.refreshEnabled = true;
        }
      });
    },

    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging: function updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getUserData();
    },
    exportUsers: function exportUsers() {
      var _this21 = this;

      var getString = "api/SecurityUsers/Export";

      if (this.feature.isAudiTarget && this.clientList[0]) {
        this.exportUsersDialogData.UserTypeId = 4;
        this.exportUsersDialogData.ClientId = this.clientList[0].ClientId;
      }

      if (this.exportUsersDialogData.UserTypeId) {
        getString += "?userTypeId=" + this.exportUsersDialogData.UserTypeId;
        if (this.exportUsersDialogData.UserTypeId == 4 && this.exportUsersDialogData.ClientId) getString += "&clientId=" + this.exportUsersDialogData.ClientId;
        if (this.exportUsersDialogData.UserTypeId == 2 && this.exportUsersDialogData.AgencyId) getString += "&agencyId=" + this.exportUsersDialogData.AgencyId;
      }

      var filter = _.pickBy(this.filterStrings, function (value, key) {
        if (key === "Active" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "number") filter.Active = !!filter.Active;

      getString = encodeURI(getString);

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.length > 0 && data[0].DownloadId) _this21.globals.downloadFile(data[0].DownloadId);
        },
        error: function error(data) {
          console.error("Error on POST in exportUsers()");
          _this21.globals.showErrorSnackbar("Users export failed");
        }
      });
    },

    // Returns a range of numbers with min-value, max-value and stepsize
    getRange: function getRange(min, max, step) {
      var range = [],
          j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },

    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages: function getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (this.pageCount > 7 && this.selectedPage >= this.pageCount - 3) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },

    // open change password dialog
    openChangePasswordDialog: function openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed: function onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      var _this22 = this;

      this.globals.getLanguageStrings(this);
      this.globals.getRoleData(function (callbackData) {
        _this22.roleData = callbackData;
      });
      this.getUserData();
    },
    selectedSecurity2Page: function selectedSecurity2Page(newValue) {
      if (newValue === "locations2Tab") $("#security2Dialog > .modal-dialog").css("width", "80vw");else $("#security2Dialog > .modal-dialog").css("width", "50vw");
    },

    "securityDialogData.groupManagement.selectedGroupData": {
      handler: function handler(newValue, oldValue) {
        if (_.isEmpty(newValue)) {
          this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
          return;
        }
        if (newValue.GroupGuid === oldValue.GroupGuid) this.securityDialogData.groupManagement.isSelectedGroupDirty = true;else this.securityDialogData.groupManagement.isSelectedGroupDirty = false;
      },

      deep: true
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      selectedSecurity2Page: "clientSettings2Tab",
      selectedUser: "", // GUID of the selected user
      selectedUserData: {},
      pageSize: 20, // Number of users on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      showImportUsersDialog: false,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        RoleType: "",
        Role: "",
        Active: 2, // 0 = inactive, 1 = active, 2 = all
        Company: "",
        LoginName: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        City: "",
        Region: "",
        Country: "",
        Email: ""
      },
      sortField: "LoginName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if user data is requested and server did not respond yet to avoid multiple requests at the same time
      userData: [], // Stores the user data on the current page
      timeZones: [], // List of available timezones
      roleData: [],
      languageList: [], // List of available languages for the user
      regionList: [], // List of all available regions
      agencyList: [], // List of all agencies
      clientList: [],
      clientListWithGuid: [],
      marketList: [], // List of markets
      targetGroups: {},
      distanceUnits: {},
      editUserDialogData: {
        // Data for the editUser dialog
        dialogType: "", // Should be "create" or "edit"
        dialogTitle: "", // Title of the dialog
        userData: {}, // The user data of the selected user is stored here
        currentRoles: [],
        currentRegions: [], // List of regions in the selected country
        currentTimeZones: [],
        showAlert: false // true --> Alert for validation errors is visible
      },
      securityDialogData: {
        // Data for the securityDialog
        dataLists: {
          // Stores information about roles, security groups and custom groups
          roleData: [],
          securityGroupData: [],
          customGroupData: []
        },
        assignedGroupGuids: [], // Stores IDs of all groups that are assigned to the selected user
        selectedAssignedGroupGuids: [], // Stores selected assigned groups in the dialog
        selectedUnassignedGroupGuids: [], // Stores selected unassigned groups in the dialog
        groupManagement: {
          // Stores temporary data for the group management tab
          selectedGroup: "",
          selectedGroupData: {},
          isSelectedGroupDirty: false
        }
      },
      security2DialogData: {
        selectedClient: "",
        showTop100LocationsOnly: true,
        hasAccessToAllLocations: false,
        locationFilterStrings: {
          LocationStoreId: "",
          LocationName: "",
          LocationAddress: "",
          LocationCountry: "",
          LocationStatusId: "",
          LocationVisible: 2
        },
        dataLists: {
          clientSetting: [],
          selectedClients: [],
          locationProperties: [],
          locations: [],
          filteredLocations: [],
          permittedLocations: []
        }
      },
      invalidInputIds: [], // IDs of inputs with validation error
      deleteUserDialogData: {},
      showExportDialog: false,
      exportUsersDialogDataUserID: -1,
      exportUsersDialogData: {},
      lang: {
        // Contains localization strings for the selected language
        S0000: "Aktualisieren",
        S0001: "Neuer Benutzer",
        S0002: "Bearbeiten",
        S0003: "Groups",
        S0004: "Suche...",
        S0005: "Elemente pro Seite",
        S0006: "Erste Seite",
        S0007: "Letzte Seite",
        S0008: "Benutzer-ID",
        S0009: "Typ",
        S0010: "Benutzername",
        S0011: "Vorname",
        S0012: "Nachname",
        S0013: "Geschlecht",
        S0014: "Stadt",
        S0015: "Region",
        S0016: "Land",
        S0017: "E-Mail",
        S0018: "Filter",
        S0019: "Allgemein",
        S0020: "Benutzername",
        S0021: "Kennwort",
        S0022: "Vorname",
        S0023: "Nachname",
        S0024: "Firmenname",
        S0025: "Geschlecht",
        S0026: "männlich",
        S0027: "weiblich",
        S0028: "Benutzersprache",
        S0029: "Zeitzone",
        S0030: "Startseite",
        S0031: "Beispiel",
        S0032: "Nicht verwenden",
        S0033: "Account Status",
        S0034: "Aktiviert",
        S0035: "Deaktiviert",
        S0036: "Kontakt",
        S0037: "Straße",
        S0038: "Adresszusatz",
        S0039: "Stadt",
        S0040: "Region",
        S0041: "Bitte auswählen...",
        S0042: "Land",
        S0043: "PLZ",
        S0044: "Telefon privat",
        S0045: "Telefon geschäftlich",
        S0046: "Telefon mobil",
        S0047: "Fax",
        S0048: "E-Mail",
        S0049: "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        S0050: "Abbrechen",
        S0051: "Speichern",
        S0052: "Neuer Benutzer",
        S0053: "Benutzer bearbeiten",
        S0054: "Group Security",
        S0055: "Systemgruppen",
        S0056: "Sicherheitsgruppen",
        S0057: "Benutzerdefinierte Gruppen",
        S0058: "Verfügbare Gruppen",
        S0059: "Zugeordnete Gruppen",
        S0060: "Abbrechen",
        S0061: "Speichern",
        S0062: "Passwort",
        S0063: "Kundenrichtlinien",
        S0064: "Gruppenverwaltung",
        S0065: "Kunden",
        S0066: "Richtlinien",
        S0067: "Kunden/ Standort Administration",
        S0068: "Fragebogen erstellen",
        S0069: "Projektplanung",
        S0070: "Zuweisung Management",
        S0071: "Eingereichte Fragebogen Manager",
        S0072: "Kunden Reporting",
        S0073: "Nicht zugewiesen",
        S0074: "Ansicht",
        S0075: "Bearbeiten",
        S0076: "Alle Kunden auswählen",
        S0077: "Auswahl aufheben",
        S0078: "Verfügbare Gruppen",
        S0079: "Gruppen bearbeiten",
        S0080: "Gruppenname",
        S0081: "Beschreibung",
        S0082: "Speichern",
        S0083: "Löschen",
        S0084: "Passwort zurücksetzen",
        S0085: "Neues Passwort",
        S0086: "Neues Passwort wiederholen",
        S0087: "Konto entsperren",
        S0088: "Die eingegebenen Passwörter stimmen nicht überein!",
        S0089: "Abbrechen",
        S0090: "Speichern",
        S0091: "Nicht zugewiesen",
        S0092: "Ansicht",
        S0093: "Bearbeiten",
        S0095: "Diese Angabe ist erforderlich!",
        S0096: "Dies ist keine gültige Telefonnummer!",
        S0097: "Dies ist keine gültige Faxnummer!",
        S0098: "Dies ist keine gültige E-Mail Adresse!",
        S0099: "Benutzer löschen",
        S0100: "Soll folgender Benutzer wirklich gelöscht werden?",
        S0101: "Ja",
        S0102: "Nein",
        S0103: "Anzeigen",
        S0104: "Bearbeiten",
        S0105: "Standortrichtlinien",
        S0106: "Benutzereigenschaftenrichtlinien",
        S0107: "Fragebogenrichtlinien",
        S0108: "Standort",
        S0109: "Genehmigt",
        S0110: "Nicht genehmigt",
        S0111: "Kunde",
        S0112: "Bitte auswählen",
        S0113: "Benutzereigenschaft",
        S0114: "Wert der Benutzereigenschaft",
        S0115: "Fragebogen",
        S0116: "Agentur",
        S0117: "Breitengrad aus Geokodierung",
        S0118: "Längengrad aus Geokodierung",
        S0119: "Breitengrad aus PLZ",
        S0120: "Längengrad aus PLZ",
        S0121: "Entfernungseinheit",
        S0122: "Ungültiger Wert",
        S0123: "Projekte",
        S0124: "Projekt",
        S0125: "Projektwellen",
        S0126: "Reporting Features",
        S0127: "Check Explorer",
        S0128: "Media Explorer",
        S0129: "Raw Data",
        S0130: "Frequencies",
        S0131: "Aggregated Reports",
        S0132: "Fragen",
        S0133: "Security Role",
        S0134: "Export",
        S0135: "Import",
        S0138: "User Security",
        S0139: "Client Settings",
        S0140: "Location Properties",
        S0141: "Locations",
        S0142: "Reporting Features",
        S0143: "Questions",
        S0144: "Visibility",
        S0145: "Client Level",
        S0146: "Copy User",
        S0147: "Auto next Wave",
        S0148: "Passwortrichtlinien",
        S0149: "Buchstaben",
        S0150: "Großbuchstabe(n)",
        S0151: "Kleinbuchstabe(n)",
        S0152: "Ziffer(n)",
        S0153: "Sonderzeiche(n)",
        S0154: "mindestens",
        S0155: "Client Selection",
        S0156: "Client Level (select all levels)",
        S0157: "Scenarios",
        S0158: "Please select clients in Client Selection tab first.",
        S0159: "New",
        S0160: "Company",
        S0161: "Security",
        S0162: "Permitted",
        S0163: "Active",
        S0164: "Close",
        S0165: "Project Level",
        S0166: "StoreID",
        S0167: "Status",
        S0168: "Address",
        S0169: "Name",
        S0170: "Location Property",
        S0171: "Location Property Values",
        S0172: "Visible",
        S0173: "Show only top 100 locations",
        S0174: "Projectname",
        S0175: "Hide",
        S0176: "No waves available for this project",
        S0177: "Wavename",
        S0178: "User",
        S0179: "Country",
        S0180: "Export Users",
        S0181: "Download",
        S0182: "Cancel",
        S0183: "User Type",
        S0184: "Please select an user type...",
        S0185: "Client",
        S0186: "Please select a client...",
        S0187: "Partner",
        S0188: "Please select a partner...",
        S0189: "Grant access to all locations",
        S0190: "Access to all locations granted",
        S0191: "Reporting Group",
        S0192: "Delete Security Group",
        S0193: "Do you really want to delete the following group?",
        S0194: "Groupname",
        S0195: "Client selection is required for reporting groups.",
        S0196: "Reporting settings are needed for the client. Please contact the support!",
        S0197: "Target group",
        S0198: "Target group already in use",
        S0199: "This target group is already assigned to another security group. If you save the current group, the target groups will be swapped.",
        S0200: "Total users count",
        S0201: "Show user history",
        S0202: "Market",
        S0203: "divers"
      },
      copyUser: false,
      showChangePasswordDialog: false
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools_Select2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tools_Select2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_policiesmixin__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_usermanagement_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_usermanagement_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "CustomPropertiesPoliciesControl",
  data: function data() {
    return {
      customPropertyValuePairs: [],
      changedValues: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a()
    };
  },

  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_3__Tools_Select2_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_policiesmixin__["a" /* default */]],
  props: {
    user: {
      type: Object
      // required: true
    },
    lang: {
      type: Object,
      required: true
    },
    selectedClient: {
      type: String
      // required: true
    }
  },
  methods: {
    updateChangedValue: function updateChangedValue(data, _ref) {
      var LocationPropertyGuid = _ref.LocationPropertyGuid,
          LocationPropertyValues = _ref.LocationPropertyValues;

      if (data.length > 0) {
        var filterdData = data.filter(function (el) {
          return LocationPropertyValues.includes(el);
        });
        this.changedValues.set(LocationPropertyGuid, filterdData);
      } else {
        this.changedValues.set(LocationPropertyGuid, []);
      }
    },
    togglePermitted: function togglePermitted(item) {
      if (!item.LocationPropertyValues) return;
      if (item.SelectedItems.length === item.LocationPropertyValues.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.LocationPropertyValues.forEach(function (element) {
          item.SelectedItems.push(element.id);
        });
      }
    },
    getPropertySubItems: function getPropertySubItems(property) {
      if (!property.LocationPropertyValues) return [];
      return property.LocationPropertyValues;
    },
    getSelectedSubItems: function getSelectedSubItems(cppairs) {
      var result = [];
      if (!cppairs || cppairs.length < 1) return result;
      cppairs.forEach(function (cppair) {
        if (cppair.SelectedItems) {
          if (!cppair.LocationPropertyValues) return;
          var newcppair = {
            LocationPropertyGuid: cppair.LocationPropertyGuid,
            LocationPropertyValues: []
          };
          cppair.LocationPropertyValues.forEach(function (locValue) {
            if (cppair.SelectedItems.includes(locValue.id)) {
              newcppair.LocationPropertyValues.push(locValue.label);
            }
          });
          if (newcppair.LocationPropertyValues.length > 0) result.push(newcppair);
        }
      });
      return result;
    },
    saveChanges: function saveChanges(successCallback, errorCallback) {
      /**
       * we expect data in format
       *
       *  [
            {
              "LocationPropertyGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
              "LocationPropertyValues": [
                "string"
              ]
            }
       *  ]
       */
      // turn Map into array
      var itms = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.changedValues)).map(function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            LocationPropertyGuid = _ref3[0],
            LocationPropertyValues = _ref3[1];

        if (LocationPropertyValues.length > 0) return {
          LocationPropertyGuid: LocationPropertyGuid,
          LocationPropertyValues: LocationPropertyValues
        };
      });
      var url = "api/UserSecurity/" + this.user.UserId + "/LocationProperties";
      this.putItems(this, url, itms, "CustomPropertyPolicies", successCallback, errorCallback);
    },
    getSelected: function getSelected(locValues) {
      return locValues.filter(function (el) {
        return el.Permitted;
      }).map(function (v) {
        return v.LocationPropertyValue;
      });
    },
    convertToTreeselectData: function convertToTreeselectData(data) {
      var _this = this;

      data.forEach(function (LocationProperty) {
        if (LocationProperty.LocationPropertyValues) {
          LocationProperty.SelectedItems = _this.getSelected(LocationProperty.LocationPropertyValues);
          LocationProperty.LocationPropertyValues = LocationProperty.LocationPropertyValues.map(function (v) {
            return v.LocationPropertyValue;
          });
        } else {
          LocationProperty.LocationPropertyValues = [];
        }
      });
      return data;
    },
    loadPolicies: function loadPolicies(successCallback, errorCallback) {
      var _this2 = this;

      if (!this.selectedClient) return;
      this.customPropertyValuePairs = [];
      var url = "api/UserSecurity/" + this.user.UserId + "/LocationProperties/Client/" + this.selectedClient;

      $.ajax({
        method: "GET",
        url: url,
        success: function success(data) {
          _this2.customPropertyValuePairs = _.isEmpty(data) ? [] : _this2.convertToTreeselectData(data);
          successCallback();
        },
        error: function error() {
          console.error("Data access failed in CustomPropertiesPoliciesControl.loadPolicies()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settingsPoliciesControl",
  data: function data() {
    return {
      settings: []
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__["a" /* default */]],
  props: ["user", "lang"],
  methods: {
    toggleAll: function toggleAll() {
      this.togglePermission(this.settings);
    },
    togglePermission: function togglePermission(_items) {
      var selected = _.takeWhile(_items, ["Permitted", true]);
      if (selected.length !== _items.length) _.forEach(_items, function (itm) {
        itm.Permitted = true;
      });else _.forEach(_items, function (itm) {
        itm.Permitted = false;
      });
    },
    saveChanges: function saveChanges(successCallback, errorCallback) {
      var featureList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.settings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var feature = _step.value;

          if (feature.Permitted) featureList.push(feature.ReportingFeatureGuid);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.putItems(this, this.getServiceUrl(), featureList, "settingsPolicies", successCallback, errorCallback);
    },
    getServiceUrl: function getServiceUrl() {
      return "api/UserSecurity/" + this.user.UserId + "/ReportingFeatures";
    },
    getUnifiedId: function getUnifiedId(_data) {
      _.forEach(_data, function (item) {
        item.id = item.settingId;
      });
      return _data;
    },
    loadPolicies: function loadPolicies(successCallback, errorCallback) {
      var _this = this;

      this.settings = [];

      $.ajax({
        method: "GET",
        url: this.getServiceUrl(),
        success: function success(data) {
          _this.settings = _this.getUnifiedId(data);
          successCallback();
        },
        error: function error() {
          console.error("Data access failed in settingsPoliciesControl.loadPolicies()");
          errorCallback();
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect_dist_vue_treeselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_usermanagement_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "SurveysQuestionsPoliciesControl",
  data: function data() {
    return {
      surveys: [],
      actualClient: -1
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_policiesmixin__["a" /* default */]],
  props: {
    user: Object,
    lang: Object,
    clients: Array
  },
  methods: {
    togglePermitted: function togglePermitted(item) {
      if (!item.surveysQuestions) return;
      if (item.SelectedItems.length === item.surveysQuestions.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.surveysQuestions.forEach(function (element) {
          item.SelectedItems.push(element.waveId);
        });
      }
    },

    getPropertySubItems: function getPropertySubItems(property) {
      if (!property.surveysQuestions) return [];
      return property.surveysQuestions;
    },
    getSelectedSubItems: function getSelectedSubItems(items) {
      var result = [];
      if (!(items.length > 0)) return result;
      items.forEach(function (element) {
        result = result.concat(element.SelectedItems);
      });
      return result;
    },
    saveChanges: function saveChanges() {
      var itms = this.getSelectedSubItems(this.surveys);
      this.putItems(this, this.getServiceUrl(this), itms, "SurveysQuestionsPolicies");
    },
    getServiceUrl: function getServiceUrl(_this) {
      return "api/SurveysQuestionsPolicies/" + _this.user.UserId + "/" + _this.actualClient;
    },
    getUnifiedId: function getUnifiedId(_data) {
      _.forEach(_data, function (item) {
        var selected = [];
        _.forEach(item.surveysQuestions, function (val) {
          if (val.P === true) selected.push(val.id);
        });
        item.SelectedItems = selected;
      });
      return _data;
    },
    loadPolicies: function loadPolicies() {
      if (!this.actualClient || this.actualClient == -1) return;
      var _this = this;
      _this.surveys = [];

      $.ajax({
        method: "GET",
        url: _this.getServiceUrl(_this),
        success: function success(data) {
          _this.surveys = _this.getUnifiedId(data);
        },
        error: function error() {
          console.error("Data access failed in SurveysQuestionsPoliciesControl.loadPolicies()");
        },
        complete: function complete() {
          _this.$root.$emit("measureScreenRequested", "");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tools_Select2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "UserSettings",
  components: { Select2: __WEBPACK_IMPORTED_MODULE_1__Tools_Select2___default.a, ChangePasswordDialog: __WEBPACK_IMPORTED_MODULE_0__components_Tools_Dialogs_ChangePasswordDialog___default.a },
  data: function data() {
    return {
      showChangePasswordDialog: false,
      loginAsUserId: "",
      userList: [],
      lang: {
        US0000: "Password",
        US0001: "Change Password",
        US0002: "Filter",
        US0003: "Remember filter settings",
        US0004: "Tables remember their own filters and sort orders.",
        US0005: "Synchronize filter settings",
        US0006: "If possible, filter settings will be synchronized between several components of the application.",
        US0007: "Reset all filters",
        US0008: "Login as",
        US0009: "Leave session",
        US0010: "Please select a user...",
        US0011: "Login",
        US0012: "Login as user failed",
        US0013: "Leaving session failed"
      }
    };
  },

  computed: {
    rememberFilters: {
      get: function get() {
        return this.$store.getters["userSettings/rememberFilters"];
      },
      set: function set(value) {
        this.$store.commit("userSettings/rememberFilters", value);
      }
    },
    syncFilters: {
      get: function get() {
        return this.$store.getters["userSettings/syncFilters"];
      },
      set: function set(value) {
        this.$store.commit("userSettings/syncFilters", value);
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.globals.getLanguageStrings(this);

    if (this.globals.currentUserRole < 0) {
      this.globals.$on("currentUserInfoReceived", function () {
        _this.globals.getUserList(function (data) {
          _this.userList = data;
        });
      });
    } else if (this.globals.currentUserRole === 1) this.globals.getUserList(function (data) {
      _this.userList = data;
    });
  },

  methods: {
    clearFilters: function clearFilters() {
      this.clearSharedFilters();
      this.clearLocalFilters();
    },
    clearSharedFilters: function clearSharedFilters() {
      this.$store.commit("sharedFilters/clearAll");
    },
    clearLocalFilters: function clearLocalFilters() {
      this.$store.commit("localFilters/clearAll");
    },
    requestLoginAs: function requestLoginAs() {
      var _this2 = this;

      if (!this.loginAsUserId) return;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/LoginAs/" + this.loginAsUserId,
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this2.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this2.globals.showSpinner(true);
          _this2.$nextTick(function () {
            location.reload();
          });
        },
        error: function error(_error) {
          console.error("Error on GET in requestLoginAs()");
          _this2.globals.showErrorSnackbar(_this2.lang.US0012);
        }
      });
    },
    leaveLoginAsSession: function leaveLoginAsSession() {
      var _this3 = this;

      $.ajax({
        method: "GET",
        url: "api/SecurityUsers/LogoutAs",
        // dataType: "json",
        // contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this3.globals.showSpinner(true);
          _this3.$nextTick(function () {
            location.reload();
          });
        },
        error: function error(_error2) {
          console.error("Error on GET in leaveLoginAsSession()");
          _this3.globals.showErrorSnackbar(_this3.lang.US0013);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  surveyInstanceCustomReportingDate: "",
  get SurSurveyInstanceCustomReportingDate() {
    return this.surveyInstanceCustomReportingDate;
  },
  set SurSurveyInstanceCustomReportingDate(value) {
    this.surveyInstanceCustomReportingDate = value;
    this.raiseChangedEvent("SurveyInstanceCustomReportingDate", value);
  },

  surveyInstanceVisibleInNotification: 0,
  get SurveyInstanceVisibleInNotification() {
    return this.surveyInstanceVisibleInNotification;
  },
  set SurveyInstanceVisibleInNotification(value) {
    this.surveyInstanceVisibleInNotification = value;
    this.raiseChangedEvent("SurveyInstanceVisibleInNotification", value);
  },

  surveyInstanceExternalInterface: 0,
  get SurveyInstanceExternalInterface() {
    return this.surveyInstanceExternalInterface;
  },
  set SurveyInstanceExternalInterface(value) {
    this.surveyInstanceExternalInterface = value;
    this.raiseChangedEvent("SurveyInstanceExternalInterface", value);
  },

  surveyInstanceLocationNotification: 0,
  get SurveyInstanceLocationNotification() {
    return this.surveyInstanceLocationNotification;
  },
  set SurveyInstanceLocationNotification(value) {
    this.surveyInstanceLocationNotification = value;
    this.raiseChangedEvent("SurveyInstanceLocationNotification", value);
  },

  surveyInstanceQueryTool: 0,
  get SurveyInstanceQueryTool() {
    return this.surveyInstanceQueryTool;
  },
  set SurveyInstanceQueryTool(value) {
    this.surveyInstanceQueryTool = value;
    this.raiseChangedEvent("SurveyInstanceQueryTool", value);
  },

  surveyInstanceDashboard: 0,
  get SurveyInstanceDashboard() {
    return this.surveyInstanceDashboard;
  },
  set SurveyInstanceDashboard(value) {
    this.surveyInstanceDashboard = value;
    this.raiseChangedEvent("SurveyInstanceDashboard", value);
  },

  surveyInstanceCheckExplorer: 0,
  get SurveyInstanceCheckExplorer() {
    return this.surveyInstanceCheckExplorer;
  },
  set SurveyInstanceCheckExplorer(value) {
    this.surveyInstanceCheckExplorer = value;
    this.raiseChangedEvent("SurveyInstanceCheckExplorer", value);
  },

  surveyInstanceAggregatedReport: 0,
  get SurveyInstanceAggregatedReport() {
    return this.surveyInstanceAggregatedReport;
  },
  set SurveyInstanceAggregatedReport(value) {
    this.surveyInstanceAggregatedReport = value;
    this.raiseChangedEvent("SurveyInstanceAggregatedReport", value);
  },

  surveyInstanceRawDataExports: 0,
  get SurveyInstanceRawDataExports() {
    return this.surveyInstanceRawDataExports;
  },
  set SurveyInstanceRawDataExports(value) {
    this.surveyInstanceRawDataExports = value;
    this.raiseChangedEvent("SurveyInstanceRawDataExports", value);
  },

  surveyInstanceFrequencies: 0,
  get SurveyInstanceFrequencies() {
    return this.surveyInstanceFrequencies;
  },
  set SurveyInstanceFrequencies(value) {
    this.surveyInstanceFrequencies = value;
    this.raiseChangedEvent("SurveyInstanceFrequencies", value);
  },

  surveyInstanceMediaExplorer: 0,
  get SurveyInstanceMediaExplorer() {
    return this.surveyInstanceMediaExplorer;
  },
  set SurveyInstanceMediaExplorer(value) {
    this.surveyInstanceMediaExplorer = value;
    this.raiseChangedEvent("SurveyInstanceMediaExplorer", value);
  },

  surveyInstanceNote: "",
  get SurveyInstanceNote() {
    return this.surveyInstanceNote;
  },
  set SurveyInstanceNote(value) {
    this.surveyInstanceNote = value;
    this.raiseChangedEvent("SurveyInstanceNote", value);
  },

  surveyInstanceLocationGuid: "",
  get SurveyInstanceLocationGuid() {
    return this.surveyInstanceLocationGuid;
  },
  set SurveyInstanceLocationGuid(value) {
    this.surveyInstanceLocationGuid = value;
    this.raiseChangedEvent("SurveyInstanceLocationGuid", value);
  },

  surveyInstanceUntil: null,
  get SurveyInstanceUntil() {
    return this.surveyInstanceUntil;
  },
  set SurveyInstanceUntil(value) {
    this.surveyInstanceUntil = value;
    this.raiseChangedEvent("SurveyInstanceUntil", value);
  },

  surveyInstanceSince: null,
  get SurveyInstanceSince() {
    return this.surveyInstanceSince;
  },
  set SurveyInstanceSince(value) {
    this.surveyInstanceSince = value;
    this.raiseChangedEvent("SurveyInstanceSince", value);
  },

  surveyInstanceDescription: null,
  get SurveyInstanceDescription() {
    return this.surveyInstanceDescription;
  },
  set SurveyInstanceDescription(value) {
    this.surveyInstanceDescription = value;
    this.raiseChangedEvent("SurveyInstanceDescription", value);
  },

  briefingDownloadGuid: "",
  get BriefingDownloadGuid() {
    return this.briefingDownloadGuid;
  },
  set BriefingDownloadGuid(value) {
    this.briefingDownloadGuid = value;
    this.raiseChangedEvent("BriefingDownloadGuid", value);
  },

  surveyDownloadGuid: "",
  get SurveyDownloadGuid() {
    return this.surveyDownloadGuid;
  },
  set SurveyDownloadGuid(value) {
    this.surveyDownloadGuid = value;
    this.raiseChangedEvent("SurveyDownloadGuid", value);
  },

  surveyInstanceType: "",
  get SurveyInstanceType() {
    return this.surveyInstanceType;
  },
  set SurveyInstanceType(value) {
    this.surveyInstanceType = value;
    this.raiseChangedEvent("SurveyInstanceType", value);
  },

  isReadonly: false,
  get IsReadonly() {
    return this.isReadonly;
  },
  set IsReadonly(value) {
    this.isReadonly = value;
    this.raiseChangedEvent("IsReadonly", value);
  },

  maxSurveyInstanceStatusId: null,
  get MaxSurveyInstanceStatusId() {
    return this.maxSurveyInstanceStatusId;
  },
  set MaxSurveyInstanceStatusId(value) {
    this.maxSurveyInstanceStatusId = value;
    this.raiseChangedEvent("MaxSurveyInstanceStatusId", value);
  },

  onlineState: null,
  get OnlineState() {
    return this.onlineState;
  },
  set OnlineState(value) {
    this.onlineState = value;
    this.raiseChangedEvent("OnlineState", value);
  },

  surveySkillLevel: 0,
  get SurveySkillLevel() {
    return this.surveySkillLevel;
  },
  set SurveySkillLevel(value) {
    this.surveySkillLevel = value;
    this.raiseChangedEvent("SurveySkillLevel", value);
  },

  surveyInstanceSkillLevel: 0,
  get SurveyInstanceSkillLevel() {
    return this.surveyInstanceSkillLevel;
  },
  set SurveyInstanceSkillLevel(value) {
    this.surveyInstanceSkillLevel = value;
    this.raiseChangedEvent("SurveyInstanceSkillLevel", value);
  },

  locationFree: null,
  get LocationFree() {
    return this.locationFree;
  },
  set LocationFree(value) {
    this.locationFree = value;
    this.raiseChangedEvent("LocationFree", value);
  },

  surveyInstanceCxReporting: 0,
  get SurveyInstanceCxReporting() {
    return this.surveyInstanceCxReporting;
  },
  set SurveyInstanceCxReporting(value) {
    this.surveyInstanceCxReporting = value;
    this.raiseChangedEvent("SurveyInstanceCxReporting", value);
  },

  surveyInstanceTotalPayment: 0,
  get SurveyInstanceTotalPayment() {
    return this.surveyInstanceTotalPayment;
  },
  set SurveyInstanceTotalPayment(value) {
    this.surveyInstanceTotalPayment = value;
    this.raiseChangedEvent("SurveyInstanceTotalPayment", value);
  },

  surveyInstanceScenarioGuid: "",
  get SurveyInstanceScenarioGuid() {
    return this.surveyInstanceScenarioGuid;
  },
  set SurveyInstanceScenarioGuid(value) {
    this.surveyInstanceScenarioGuid = value;
    this.raiseChangedEvent("SurveyInstanceScenarioGuid", value);
  },

  surveyInstanceWaveGuid: "",
  get SurveyInstanceWaveGuid() {
    return this.surveyInstanceWaveGuid;
  },
  set SurveyInstanceWaveGuid(value) {
    this.surveyInstanceWaveGuid = value;
    this.raiseChangedEvent("SurveyInstanceWaveGuid", value);
  },

  surveyInstanceAssignedShopperGuid: "",
  get SurveyInstanceAssignedShopperGuid() {
    return this.surveyInstanceAssignedShopperGuid;
  },
  set SurveyInstanceAssignedShopperGuid(value) {
    this.surveyInstanceAssignedShopperGuid = value;
    this.raiseChangedEvent("SurveyInstanceAssignedShopperGuid", value);
  },

  surveyInstanceAssignedLocalAgencyGuid: "",
  get SurveyInstanceAssignedLocalAgencyGuid() {
    return this.surveyInstanceAssignedLocalAgencyGuid;
  },
  set SurveyInstanceAssignedLocalAgencyGuid(value) {
    this.surveyInstanceAssignedLocalAgencyGuid = value;
    this.raiseChangedEvent("SurveyInstanceAssignedLocalAgencyGuid", value);
  },

  surveyInstanceInfo: "",
  get SurveyInstanceInfo() {
    return this.surveyInstanceInfo;
  },
  set SurveyInstanceInfo(value) {
    this.surveyInstanceInfo = value;
    this.raiseChangedEvent("SurveyInstanceInfo", value);
  },

  setDataCounter: 0,

  setData: function setData(data) {
    if (this.setDataCounter === 0) this.initialData = data;

    this.surveyInstanceCustomReportingDate = data.SurveyInstanceCustomReportingDate;
    this.SurveyInstanceVisibleInNotification = data.SurveyInstanceVisibleInNotification;
    this.SurveyInstanceExternalInterface = data.SurveyInstanceExternalInterface;
    this.SurveyInstanceLocationNotification = data.SurveyInstanceLocationNotification;
    this.SurveyInstanceQueryTool = data.SurveyInstanceQueryTool;
    this.SurveyInstanceDashboard = data.SurveyInstanceDashboard;
    this.SurveyInstanceCheckExplorer = data.SurveyInstanceCheckExplorer;
    this.SurveyInstanceAggregatedReport = data.SurveyInstanceAggregatedReport;
    this.SurveyInstanceRawDataExports = data.SurveyInstanceRawDataExports;
    this.SurveyInstanceFrequencies = data.SurveyInstanceFrequencies;
    this.SurveyInstanceMediaExplorer = data.SurveyInstanceMediaExplorer;
    this.SurveyInstanceNote = data.SurveyInstanceNote;
    this.SurveyInstanceLocationGuid = data.SurveyInstanceLocationGuid;
    this.surveyInstanceScenarioGuid = data.SurveyInstanceScenarioGuid;
    this.surveyInstanceWaveGuid = data.SurveyInstanceWaveGuid;
    this.SurveyInstanceAssignedShopperGuid = data.SurveyInstanceAssignedShopperGuid;
    this.SurveyInstanceAssignedLocalAgencyGuid = data.SurveyInstanceAssignedLocalAgencyGuid;
    this.SurveyInstanceInfo = data.SurveyInstanceInfo;
    if (data.SurveyInstanceDescription) this.SurveyInstanceDescription = data.SurveyInstanceDescription;
    if (data.BriefingDownloadGuid) this.BriefingDownloadGuid = data.BriefingDownloadGuid;
    if (data.SurveyDownloadGuid) this.SurveyDownloadGuid = data.SurveyDownloadGuid;
    if (data.SurveyInstanceType) this.SurveyInstanceType = data.SurveyInstanceType;
    if (data.IsReadonly != undefined) this.IsReadonly = data.IsReadonly;
    if (data.MaxSurveyInstanceStatusId) this.MaxSurveyInstanceStatusId = data.MaxSurveyInstanceStatusId;
    if (data.OnlineState) this.OnlineState = data.OnlineState;
    if (data.SurveySkillLevel) this.SurveySkillLevel = data.SurveySkillLevel;
    if (data.SurveyInstanceSkillLevel) this.SurveyInstanceSkillLevel = data.SurveyInstanceSkillLevel;
    if (data.LocationFree) this.LocationFree = data.LocationFree;

    this.SurveyInstanceCxReporting = data.SurveyInstanceCxReporting;
    if (data.SurveyInstanceTotalPayment) this.SurveyInstanceTotalPayment = data.SurveyInstanceTotalPayment;
    this.setDataCounter++;
  },

  initialData: {},

  valueChangedCallback: null,

  onChange: function onChange(callback) {
    this.valueChangedCallback = callback;
  },

  changeCounter: 0,

  get Changed() {
    return this.changeCounter > 0;
  },

  raiseChangedEvent: function raiseChangedEvent(propertyName, v) {
    if (this.valueChangedCallback) {
      this.valueChangedCallback(propertyName, v);
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Deselect_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Deselect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Deselect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenIndicator_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OpenIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__OpenIndicator_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  Deselect: __WEBPACK_IMPORTED_MODULE_0__Deselect_vue___default.a,
  OpenIndicator: __WEBPACK_IMPORTED_MODULE_1__OpenIndicator_vue___default.a
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el, bindings, _ref) {
    var context = _ref.context;

    if (context.appendToBody) {
      var _context$$refs$toggle = context.$refs.toggle.getBoundingClientRect(),
          height = _context$$refs$toggle.height,
          top = _context$$refs$toggle.top,
          left = _context$$refs$toggle.left,
          width = _context$$refs$toggle.width;

      var scrollX = window.scrollX || window.pageXOffset;
      var scrollY = window.scrollY || window.pageYOffset;

      el.unbindPosition = context.calculatePosition(el, context, {
        width: width + 'px',
        left: scrollX + left + 'px',
        top: scrollY + top + height + 'px'
      });

      document.body.appendChild(el);
    }
  },
  unbind: function unbind(el, bindings, _ref2) {
    var context = _ref2.context;

    if (context.appendToBody) {
      if (el.unbindPosition && typeof el.unbindPosition === 'function') {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Select_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Select_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Select_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_index_js__ = __webpack_require__(382);
/* unused harmony reexport VueSelect */
/* unused harmony reexport mixins */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__components_Select_vue___default.a);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__typeAheadPointer_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pointerScroll_js__ = __webpack_require__(111);




/* unused harmony default export */ var _unused_webpack_default_export = ({ ajax: __WEBPACK_IMPORTED_MODULE_0__ajax_js__["a" /* default */], pointer: __WEBPACK_IMPORTED_MODULE_1__typeAheadPointer_js__["a" /* default */], pointerScroll: __WEBPACK_IMPORTED_MODULE_2__pointerScroll_js__["a" /* default */] });

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/**
 * @param sortable {object}
 * @return {string}
 */
function sortAndStringify(sortable) {
  var ordered = {};

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sortable).sort().forEach(function (key) {
    ordered[key] = sortable[key];
  });

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ordered);
}

/* harmony default export */ __webpack_exports__["a"] = (sortAndStringify);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var idCount = 0;

/**
 * Dead simple unique ID implementation.
 * Thanks lodash!
 * @return {number}
 */
function uniqueId() {
  return ++idCount;
}

/* harmony default export */ __webpack_exports__["a"] = (uniqueId);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRange;
/**
 * Returns a range of numbers with min-value, max-value and stepsize
 * @param {number} min start of range
 * @param {number} max end of range
 * @param {number} step steps of range
 * @returns {number[]}
 */
function getRange(min, max, step) {
  var range = [],
      j = 0;
  for (var i = min; i <= max; i += step) {
    range[j++] = i;
  }
  return range;
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);


var API_BASE = "api/Clients";

/**
 * Get all Clients
 */
function getClients() {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE);
}

/**
 * Get 1 Client by id
 * @param {number} id
 */
function getClientbyID(id) {
  var queryString = API_BASE + "/" + id;
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(queryString);
}

/**
 * create a new Client
 * @param {JSON} content - the new Client
 */
function createClient(content) {
  var queryString = "" + API_BASE;
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].post(queryString, content);
}

/**
 * Update 1 Client
 * @param {number} id The id of the Client
 * @param {JSON} content The updated ClientData
 */
function updateClient(id, content) {
  var queryString = API_BASE + "/" + id;
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(queryString, content);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getClientbyID: getClientbyID,
  getClients: getClients,
  updateClient: updateClient,
  createClient: createClient
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILES_STORE_NAME; });
/* unused harmony export SURVEY_STORE_NAME */
/* unused harmony export TICKETS_STORE_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DB_NAME; });
/* unused harmony export setupIndexDB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return storeHas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addFiletoDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilefromDB_byID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearFileStore; });
/* unused harmony export currentDB */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




/**
 * @param {string} name - The name of the db
 * @param {number} version - The version of the DB,lower versions will get rejected
 * @returns {IDBOpenDBRequest} The potential connection to the db
 */
var getDb = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name, version) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var request = window.indexedDB.open(name, version);

              request.onerror = function (e) {
                console.error("Error opening db", e);
                reject(e);
              };

              request.onsuccess = function (e) {
                resolve(e.target.result);
              };
              // Modify the Schema here
              request.onupgradeneeded = function (e) {
                console.error("DB version upgrade");

                DB = e.target.result;
                var objectStore1 = DB.createObjectStore(SURVEY_STORE_NAME, {
                  autoIncrement: false,
                  keyPath: "SurveyInstanceId"
                });
                var tickets = DB.createObjectStore(TICKETS_STORE_NAME, {
                  autoIncrement: false,
                  keyPath: "SurveyInstanceId"
                });

                var filestore = DB.createObjectStore(FILES_STORE_NAME, {
                  autoIncrement: false,
                  keyPath: "GUID"
                });
              };
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getDb(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Setup the internal Browser DB and set a flag if succesfull
 */


var dbready = false;
/**
 * @type {IDBDatabase}
 */
var DB = null;
var FILES_STORE_NAME = "Files";
var SURVEY_STORE_NAME = "SurveyInstances";
var TICKETS_STORE_NAME = "Tickets";

var VERSION = parseFloat(2.0).toFixed(2);
var DB_NAME = "MSM_LOOPDB";var setupIndexDB = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.indexedDB) {
              _context2.next = 3;
              break;
            }

            console.error("Your browser doesn't support a stable version of IndexedDB. Offline Saving features will not be available.");
            throw TypeError("IndexDB is not defined");

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return getDb(DB_NAME, 1);

          case 6:
            DB = _context2.sent;

            dbready = true;
            _context2.next = 14;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);

            dbready = false;
            throw Error(_context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 10]]);
  }));

  return function setupIndexDB() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @param {String} store The store you wish to search
 * @param {*} key the key to the obj
 * @returns {Promise<Boolean>}
 */
var storeHas = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(store, key) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (dbready) {
              _context3.next = 3;
              break;
            }

            _context3.next = 3;
            return setupIndexDB().catch(function (err) {
              console.error("Error in addFiletoDb", err);
            });

          case 3:
            return _context3.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              // Start a database transaction and get the object store
              var trans = DB.transaction(store, "readonly");
              var objstore = trans.objectStore(store);
              // count the objects
              var req = objstore.get(key);
              trans.oncomplete = function (e) {
                if (req.result === undefined) {
                  resolve(false);
                } else {
                  resolve(true);
                }
              };
              trans.onerror = function (err) {
                reject(err);
              };
            }));

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function storeHas(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 *
 * @param {File} file -the File to Upload
 * @param {*} GUID -The key for the db
 * @returns
 */
var addFiletoDB = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(file, GUID) {
    var reader, filegeobj;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (dbready) {
              _context4.next = 3;
              break;
            }

            _context4.next = 3;
            return setupIndexDB().catch(function (err) {
              console.error("Error in addFiletoDb", err);
            });

          case 3:
            reader = new FileReader();

            reader.readAsDataURL(file);
            filegeobj = {
              GUID: GUID,
              file: file
            };

            reader.onload = function (e) {
              filegeobj.file = e.target.result;
            };

            return _context4.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              // Start a database transaction and get the files object store
              var trans = DB.transaction(FILES_STORE_NAME, "readwrite");
              var store = trans.objectStore(FILES_STORE_NAME);
              // put the file in store
              store.put(filegeobj);

              trans.oncomplete = function (e) {
                resolve(GUID);
              };
              trans.onerror = function (err) {
                reject(err);
              };
            }));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function addFiletoDB(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @param {string} id The Id of the the file
 * @returns {Promise<File>} The File if found
 */
var getFilefromDB_byID = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (dbready) {
              _context5.next = 3;
              break;
            }

            _context5.next = 3;
            return setupIndexDB().catch(function (err) {
              console.error("Error in getFilefromDB_byID", err);
            });

          case 3:
            return _context5.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var trans = DB.transaction([FILES_STORE_NAME], "readonly");
              var result = void 0;
              trans.oncomplete = function (e) {
                if (result && result.file) {
                  resolve(result.file);
                } else {
                  reject("obj with key:" + id + " not found in DB");
                }
              };
              trans.onerror = function (err) {
                return reject(err);
              };

              var store = trans.objectStore(FILES_STORE_NAME);
              var getreq = store.get(id);
              getreq.onsuccess = function () {
                result = getreq.result;
              };
            }));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getFilefromDB_byID(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * @param {string} id The Id of the the file
 * @returns {Promise<File>} The File if found
 */
var clearFileStore = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (dbready) {
              _context6.next = 3;
              break;
            }

            _context6.next = 3;
            return setupIndexDB().catch(function (err) {
              console.error("Error in getFilefromDB_byID", err);
            });

          case 3:
            return _context6.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var trans = DB.transaction([FILES_STORE_NAME], "readwrite");
              trans.oncomplete = function (e) {
                resolve();
              };
              trans.onerror = function (err) {
                return reject(err);
              };

              var store = trans.objectStore(FILES_STORE_NAME);
              var clearReq = store.clear();
              clearReq.onsuccess = function () {
                console.debug(FILES_STORE_NAME + " cleared");
              };
            }));

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function clearFileStore() {
    return _ref6.apply(this, arguments);
  };
}();

var currentDB = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (dbready) {
              _context7.next = 9;
              break;
            }

            _context7.prev = 1;
            _context7.next = 4;
            return setupIndexDB();

          case 4:
            _context7.next = 9;
            break;

          case 6:
            _context7.prev = 6;
            _context7.t0 = _context7["catch"](1);

            console.error("Error in getFilefromDB_byID", _context7.t0);

          case 9:
            return _context7.abrupt("return", DB);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[1, 6]]);
  }));

  return function currentDB() {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__requestBase__ = __webpack_require__(20);



var API_BASE = "api/Language/Translations";

/**
 * Get the Translation for the given strings
 * @param {object} langobj - the lang Object where the Keys are the ids of the localizable string
 * @returns
 */
function getTranslationfor(langobj) {
  var langKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(langobj);
  return __WEBPACK_IMPORTED_MODULE_1__requestBase__["a" /* default */].post(API_BASE, langKeys);
}

var UseLang = {
  getTranslationfor: getTranslationfor
};

/* harmony default export */ __webpack_exports__["a"] = (UseLang);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);


var API_BASE = "/api/Locations/Translations";
/**
 * @typedef {string} GUID
 */
/**
 * Update the Translation of a Location for a GIven CountryCode/Language
 * @param {GUID} guid The Location GUID
 */
function update(guid, data) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(API_BASE + "/" + guid, data);
}

function deleteByGuid(guid) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].delete(API_BASE + "/" + guid);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  update: update,
  deleteByGuid: deleteByGuid
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_typdefs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types_typdefs__);



var API_BASE = "api/ProjectWaves";

/**
 * Update project wave
 * @param {string} guid
 * @param {*} content
 * @returns
 */
function updateProjectWave(guid, content) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(API_BASE + "/" + guid, content);
}

function deleteWave(guid) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].delete(API_BASE + "/" + guid);
}

function getWaveStatus(guid) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + guid + "/Status");
}

/**
 * Read project waves belonging to the survey
 * @param {number} id - the survey id
 * @returns
 */
function getBySurveyId(id) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/SurveyId/" + id);
}

/**
 * All API
 */
var UseProjectWaves = {
  updateProjectWave: updateProjectWave,
  deleteWave: deleteWave,
  getWaveStatus: getWaveStatus,
  getBySurveyId: getBySurveyId
};

/* unused harmony default export */ var _unused_webpack_default_export = (UseProjectWaves);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__requestBase__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_typdefs__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_typdefs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types_typdefs__);



var API_BASE = "api/SurveyInstancesAnswers";

/**
 * Gets a SurveyInstance with the id "id"
 * @param {number} id
 * @param {String} lang
 * @returns {Promise<SurveyInstanceData>}
 */
function getById(id) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";

  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].get(API_BASE + "/" + id + "?localeCode=" + lang);
}

/**
 * Update the SurveyInstance with the id "id"
 * @param {Nnumber} id The SurveyInstanceId
 * @param {SurveyInstanceData} content
 * @returns
 */
function update(id, content) {
  return __WEBPACK_IMPORTED_MODULE_0__requestBase__["a" /* default */].put(API_BASE + "/" + id, content);
}

var View = {
  getById: getById,
  update: update
};

/* harmony default export */ __webpack_exports__["a"] = (View);

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(614),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(486)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6725a014",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a81d124",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(618),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46ec6f7c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(520)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(658),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5c73b34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77c91682",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(501)
  __webpack_require__(502)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-93aaba56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1b6ddafe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f54cbfc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(654),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be58ad74",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(604),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16f5d598",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9485686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58b71bf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e927c768",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(510)
  __webpack_require__(511)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(652),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5e52ff4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(616),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f5e184e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(508)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abbfb1e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(665),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f92d4a34",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9563d628",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d87b043",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-559ff9cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7394d6c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(461)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(599),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04c963f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b304d86",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(653),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bd21c294",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ecb0bf40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a2e1f37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(622),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48c21c08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4876088e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e5ea545",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95799446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00f97517",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(459)
  __webpack_require__(460)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(598),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0405896e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e0ba686",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e1dd5a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
  __webpack_require__(472)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(611),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-206e88c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(514)
  __webpack_require__(515)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c4d1dada",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(659),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d82dd8ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(619),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4756388a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ec1d1af",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(474)
  __webpack_require__(475)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(615),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3db9da06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a84486f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a35de99",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(664),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(602),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(637),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(516)
  __webpack_require__(517)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce3448ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(605),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-175798e3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9220755a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(661),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec5786c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(518)
  __webpack_require__(519)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d5b5a308",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(487)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67d76aeb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(479)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-481db255",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(617),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(613),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(473)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(612),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(462)
  __webpack_require__(463)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(600),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b33b7a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(597),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03557008",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(610),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20380c09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(647),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-980576d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(651),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ae03ad60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.lang.RCC000) + "\n    "), (typeof _vm.resultCheckData.SurveyInstanceCount === 'number') ? _c('span', {
    class: {
      'text-red': _vm.checkCountExceeded
    },
    attrs: {
      "id": "checkCounterContainer"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.RCC001) + ": " + _vm._s(_vm.resultCheckData.SurveyInstanceCount))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkCountExceeded),
      expression: "checkCountExceeded"
    }],
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])]) : _vm._e(), _vm._v(" "), (_vm.checkCountExceeded) ? _c('b-tooltip', {
    attrs: {
      "target": "checkCounterContainer",
      "delay": _vm.globals.tooltipDelay,
      "boundary": "viewport",
      "placement": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC021))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')) ? _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "selectCheckFilterClientFormGroup"
    }
  }, [_c('select2', {
    ref: "clientSelect",
    attrs: {
      "id": "selectCheckFilterClient",
      "placeholder": ((_vm.lang.RCC002) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n          " + _vm._s(client.ClientName) + "\n        ")])
  })], 2), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterClientFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC002))])], 1) : _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "selectCheckFilterImporterFormGroup"
    }
  }, [_c('select2', {
    ref: "importerSelect",
    attrs: {
      "id": "selectCheckFilterImporter",
      "afterChange": _vm.selectedImporterChanged,
      "placeholder": ((_vm.lang.RCC022) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n          " + _vm._s(importer.ImporterName) + "\n        ")])
  }), 0), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterImporterFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC022))])], 1), _vm._v(" "), (_vm.selectedClient) ? _c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "selectCheckFilterProjectFormGroup"
    }
  }, [_c('select2', {
    ref: "projectSelect",
    attrs: {
      "id": "selectCheckFilterProject",
      "placeholder": ((_vm.lang.RCC003) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, _vm._l((_vm.projectsOfSelectedClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n          " + _vm._s(project.ProjectName) + "\n        ")])
  }), 0), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterProjectFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC003))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedProject) ? _c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "selectCheckFilterWaveFormGroup"
    }
  }, [_c('select2', {
    ref: "waveSelect",
    attrs: {
      "id": "selectCheckFilterWave",
      "placeholder": ((_vm.lang.RCC004) + "..."),
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, _vm._l((_vm.wavesOfSelectedProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n          " + _vm._s(wave.WaveName) + "\n        ")])
  }), 0), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckFilterWaveFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC004))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedWave) ? [_vm._l((_vm.dynamicFilters), function(filter) {
    return _c('div', {
      key: filter.Guid,
      staticClass: "form-group form-group-dynamic"
    }, [_c('div', {
      staticClass: "form-group col-md-3",
      attrs: {
        "id": ("selectCheckFilterDynamicTypeFormGroup" + (filter.Guid))
      }
    }, [_c('select2', {
      ref: ("filterTypeSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicType" + (filter.Guid)),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true,
        "afterChange": function (t) {
          _vm.filterTypeChanged(t, filter);
        }
      },
      model: {
        value: (filter.Type),
        callback: function($$v) {
          _vm.$set(filter, "Type", $$v)
        },
        expression: "filter.Type"
      }
    }, _vm._l((_vm.filterTypes), function(type, idx) {
      return _c('option', {
        key: idx,
        attrs: {
          "disabled": !_vm.isTypeEnabled(type, filter)
        },
        domProps: {
          "value": type
        }
      }, [_vm._v("\n              " + _vm._s(_vm.getTranslationFor(type)) + "\n            ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicTypeFormGroup" + (filter.Guid)),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCC006))])], 1), _vm._v(" "), (
      filter.Type === 'Region' &&
      filter.currentDynamicFilterValues &&
      filter.currentDynamicFilterValues.length < 1
    ) ? _c('span', {
      staticClass: "vertical-center"
    }, [_vm._v(_vm._s(_vm.lang.RCC026))]) : (filter.secondLevelSelectVisible) ? _c('div', {
      staticClass: "form-group col-md-8",
      attrs: {
        "id": ("selectCheckFilterDynamicValueFormGroup" + (filter.Guid))
      }
    }, [_c('select2', {
      key: filter.Type,
      ref: ("secondLevelSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicValue" + (filter.Guid)),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true,
        "multiple": filter.Type !== 'LocationProperty',
        "tags": filter.Type === 'City' ||
          filter.Type === 'PostalCode' ||
          filter.Type === 'Location' ||
          filter.Type === 'Check',
        "noResultsString": filter.Type === 'City' ||
          filter.Type === 'PostalCode' ||
          filter.Type === 'Location' ||
          filter.Type === 'Check' ?
          _vm.lang.RCC019 :
          undefined,
        "afterChange": function (v) {
          _vm.filterValueChanged(v, filter);
        }
      },
      model: {
        value: (filter.Value),
        callback: function($$v) {
          _vm.$set(filter, "Value", $$v)
        },
        expression: "filter.Value"
      }
    }, [(filter.Type === 'City') ? _vm._l((filter.currentDynamicFilterValues), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value.City
        }
      }, [_vm._v("\n                " + _vm._s(value.City) + "\n              ")])
    }) : (filter.Type === 'Country') ? _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Code")],
        domProps: {
          "value": value[((filter.Type) + "Code")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    }) : (filter.Type === 'Status') ? _vm._l((filter.currentDynamicFilterValues), function(value, idx) {
      return _c('option', {
        key: idx,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                " + _vm._s(_vm.getTranslationFor(value)) + "\n              ")])
    }) : _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Guid")],
        attrs: {
          "disabled": _vm.propertyAlreadyUsed(value[((filter.Type) + "Guid")])
        },
        domProps: {
          "value": value[((filter.Type) + "Guid")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    })], 2), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicValueFormGroup" + (filter.Guid)),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.getTranslationFor(filter.Type)))])], 1) : _vm._e(), _vm._v(" "), (filter.thirdLevelSelectVisible) ? _c('div', {
      staticClass: "form-group col-md-11",
      attrs: {
        "id": ("selectCheckFilterDynamicValueValuesFormGroup" + (filter.Guid))
      }
    }, [_c('select2', {
      ref: ("thirdLevelSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("selectCheckFilterDynamicValueValues" + (filter.Guid)),
        "placeholder": ((_vm.lang.RCC005) + "..."),
        "allowClear": true,
        "multiple": true,
        "afterChange": function (s) {
          _vm.filterSubvalueChanged(s, filter);
        }
      },
      model: {
        value: (filter.Subvalue),
        callback: function($$v) {
          _vm.$set(filter, "Subvalue", $$v)
        },
        expression: "filter.Subvalue"
      }
    }, _vm._l((filter.currentDynamicFilterValueValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Value")],
        domProps: {
          "value": value[((filter.Type) + "Value")]
        }
      }, [_vm._v("\n              " + _vm._s(value[((filter.Type) + "Value")]) + "\n            ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectCheckFilterDynamicValueValuesFormGroup" + (filter.Guid)),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCC007))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 pull-right",
      class: {
        'centerized-remove-button': filter.thirdLevelSelectVisible,
      }
    }, [_c('button', {
      staticClass: "btn btn-remove-filter",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeDynamicFilter(filter)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-default btn-add-filter",
    attrs: {
      "type": "button",
      "id": "addDynamicFilterButton",
      "disabled": _vm.isLastDynamicFilterEmpty()
    },
    on: {
      "click": function($event) {
        return _vm.addDynamicFilter()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])]), _vm._v(" "), (!_vm.isLastDynamicFilterEmpty()) ? _c('b-tooltip', {
    attrs: {
      "target": "addDynamicFilterButton",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCC008))]) : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [(_vm.selectedClient) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w40"
  }, [_vm._v(_vm._s(_vm.lang.S0170))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w60"
  }, [_vm._v(_vm._s(_vm.lang.S0171))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.customPropertyValuePairs), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w40 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.LocationPropertyName))])]), _vm._v(" "), _c('td', {
      staticClass: "w60"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": ("items-select-" + index),
        "multiple": true,
        "closeOnSelect": false,
        "placeholder": _vm.lang.CM2001,
        "allowClear": true,
        "afterChange": function (data) { return _vm.updateChangedValue(data, property); }
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    }, _vm._l((property.LocationPropertyValues), function(value, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                  " + _vm._s(value) + "\n                ")])
    }), 0)], 1)])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mapInitDone),
      expression: "mapInitDone"
    }],
    staticClass: "map-controls-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "controls gmaps-input",
    attrs: {
      "id": "gmapsSearchInput",
      "type": "text",
      "placeholder": _vm.lang.RCM000
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.currentMapRadius),
      expression: "currentMapRadius",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "controls gmaps-input",
    attrs: {
      "id": "gmapsRadiusInput",
      "type": "number",
      "step": "1",
      "min": "0",
      "max": "9999"
    },
    domProps: {
      "value": (_vm.currentMapRadius)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.currentMapRadius = _vm._n($event.target.value)
      }, function($event) {
        return _vm.currentMapRadiusChanged()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 help-icon",
    attrs: {
      "id": "gmapsHelpIcon"
    }
  }, [_vm._v("help")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 search-icon",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.searchLocation()
      }
    }
  }, [_vm._v("search")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24 radius-icon",
    attrs: {
      "id": "gmapsRadiusVisibilityIcon"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.changeMapRadiusVisibility()
      }
    }
  }, [_vm._v(_vm._s(_vm.isMapRadiusVisible ? "radio_button_unchecked" : "block"))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsRadiusInput",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCM001))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsRadiusVisibilityIcon",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCM002))]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "gmapsHelpIcon",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "bottomleft",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('shopper').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM010) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('NOT_ASSIGNED').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM013) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('ASSIGNED_NO_ANSWER').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM011) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tooltip-div"
  }, [_c('img', {
    attrs: {
      "src": _vm.iconMarkerFactory('ASSIGNED_WITH_ANSWER').url,
      "height": "35",
      "width": "35"
    }
  }), _vm._v("\n        → " + _vm._s(_vm.lang.RCM012) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "gmaps-container"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importLocationsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LIM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [(_vm.clientList.length > 1) ? _c('div', {
    staticClass: "form-group fg-client-select"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "locationImportClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "locationImportClientSelect",
      "placeholder": _vm.lang.LIM010
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                  " + _vm._s(client.ClientName) + "\n                ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#textImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importOption = 'text'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM001))])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Upload_Create')) ? _c('li', [_c('a', {
    attrs: {
      "href": "#fileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importOption = 'file'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM002))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "textImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "textAreaImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importText),
      expression: "importText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "textAreaImport"
    },
    domProps: {
      "value": (_vm.importText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.lang.LIM004))])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.trimImportData = !_vm.trimImportData
      }
    }
  }, [(_vm.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                  " + _vm._s(_vm.lang.LIM009) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "fileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "inputFileImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.LIM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "locationImportFileInput",
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.selectedFile.name) ? _c('label', [_vm._v(_vm._s(_vm.lang.LIM006))]) : _c('label', [_vm._v(_vm._s(_vm.selectedFile.name))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.trimImportData = !_vm.trimImportData
      }
    }
  }, [(_vm.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                    " + _vm._s(_vm.lang.LIM009) + "\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LIM007) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LIM008) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_ReadAll')) ? _c('div', [_c('ImportUsersModal', {
    attrs: {
      "showDialog": _vm.showImportUsersDialog,
      "roleData": _vm.roleData,
      "clientList": _vm.clientList,
      "agencyList": _vm.agencyList
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showImportUsersDialog = false
      },
      "importComplete": function($event) {
        return _vm.getUserData()
      }
    }
  }), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('confirmation-dialog', {
    attrs: {
      "dialogId": 'UserManagementExportUsersConfirmation',
      "confirmationTitle": _vm.lang.S0180,
      "yesButtonText": _vm.lang.S0181,
      "noButtonText": _vm.lang.S0182,
      "showDialog": _vm.showExportDialog
    },
    on: {
      "onYesConfirmation": _vm.exportUsers,
      "dialogClosed": function($event) {
        _vm.showExportDialog = false
      }
    }
  }, [
    [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersUserTypeSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0183))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersUserTypeSelect",
        "afterChange": function (u) {
          _vm.exportUsersDialogDataUserID = u;
        },
        "placeholder": _vm.lang.S0184,
        "dataTransformer": function (data) { return Number(data[0].id); },
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.UserTypeId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "UserTypeId", $$v)
        },
        expression: "exportUsersDialogData.UserTypeId"
      }
    }, _vm._l((_vm.roleData.filter(
      function (r) { return r.RoleTypeName !== 'MSM_Administrator'; }
    )), function(type) {
      return _c('option', {
        key: type.RoleTypeGuid,
        domProps: {
          "value": type.UserTypeId
        }
      }, [_vm._v("\n              " + _vm._s(type.RoleTypeDisplayName) + "\n            ")])
    }), 0)], 1)]), _vm._v(" "), (_vm.exportUsersDialogDataUserID == 4) ? [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersClientSelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0185))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      key: _vm.exportUsersDialogData.UserTypeId,
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersClientSelect",
        "placeholder": _vm.lang.S0186,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.ClientId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "ClientId", $$v)
        },
        expression: "exportUsersDialogData.ClientId"
      }
    }, _vm._l((_vm.clientList), function(client) {
      return _c('option', {
        key: client.ClientId,
        domProps: {
          "value": client.ClientId
        }
      }, [_vm._v("\n              " + _vm._s(client.ClientName) + "\n            ")])
    }), 0)], 1)] : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.exportUsersDialogData.UserTypeId == 2),
        expression: "exportUsersDialogData.UserTypeId == 2"
      }],
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label",
      attrs: {
        "for": "exportUsersAgencySelect"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0187))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": "exportUsersAgencySelect",
        "placeholder": _vm.lang.S0188,
        "allowClear": true
      },
      model: {
        value: (_vm.exportUsersDialogData.AgencyId),
        callback: function($$v) {
          _vm.$set(_vm.exportUsersDialogData, "AgencyId", $$v)
        },
        expression: "exportUsersDialogData.AgencyId"
      }
    }, _vm._l((_vm.agencyList), function(agency) {
      return _c('option', {
        key: agency.AgencyGuid,
        domProps: {
          "value": agency.AgencyId
        }
      }, [_vm._v("\n              " + _vm._s(agency.AgencyName) + "\n            ")])
    }), 0)], 1)])]
  ], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "users-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getUserData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedUser = ''), _vm.openEditUserDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-edit-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openEditUserDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        _vm.openEditUserDialog('edit'), (_vm.copyUser = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0146) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "user-management-delete-button",
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteUserDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0083) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openSecurityDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUserData.ClientGuid
    },
    on: {
      "click": function($event) {
        return _vm.openSecurity2Dialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("lock")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0138) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedUser
    },
    on: {
      "click": function($event) {
        return _vm.openChangePasswordDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0062) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersExport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showExportDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0134) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SecurityUsersImport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showImportUsersDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("publish")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.S0135) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.S0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "usersTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "usersTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0200))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('RoleType')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0009) + "\n                  "), (_vm.sortField == 'RoleType' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'RoleType' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Role')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0133) + "\n                  "), (_vm.sortField == 'Role' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Role' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Active')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0163) + "\n                  "), (_vm.sortField == 'Active' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Active' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Company')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0160) + "\n                  "), (_vm.sortField == 'Company' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Company' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LoginName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0010) + "\n                  "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LoginName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('FirstName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0011) + "\n                  "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'FirstName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('LastName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0012) + "\n                  "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LastName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Gender')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0013) + "\n                  "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Gender' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('City')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0014) + "\n                  "), (_vm.sortField == 'City' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'City' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Country')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0016) + "\n                  "), (_vm.sortField == 'Country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortUserData('Email')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.S0017) + "\n                  "), (_vm.sortField == 'Email' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Email' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.RoleType),
      expression: "filterStrings.RoleType"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.RoleType)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "RoleType", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Role),
      expression: "filterStrings.Role"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Role)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Role", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.filterStrings.Active = (_vm.filterStrings.Active + 1) % 3),
        _vm.getUserData()
      }
    }
  }, [(_vm.filterStrings.Active == 1) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.Active == 0) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Company),
      expression: "filterStrings.Company"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Company)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LoginName),
      expression: "filterStrings.LoginName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LoginName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LoginName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FirstName),
      expression: "filterStrings.FirstName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.FirstName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "FirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LastName),
      expression: "filterStrings.LastName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.LastName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.City),
      expression: "filterStrings.City"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.City)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Country),
      expression: "filterStrings.Country"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Country)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Country", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Email),
      expression: "filterStrings.Email"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (_vm.filterStrings.Email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getUserData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Email", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userData), function(user) {
    return _c('tr', {
      key: user.UserId,
      class: {
        info: user.UserId == _vm.selectedUser
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedUser = user.UserId), (_vm.selectedUserData = user)
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Read') ||
            _vm.openEditUserDialog('edit')
        }
      }
    }, [_c('td', [_vm._v(_vm._s(user.RoleType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Role))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "6px 0 0 0"
      }
    }, [(user.Active) ? _c('i', {
      staticClass: "material-icons md-24 user-active"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 user-inactive"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Company))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.LoginName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.FirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.LastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Gender))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.City))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.Email))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editUser",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editUserDialogData.dialogTitle))])]), _vm._v(" "), (_vm.editUserDialogData.userData.UserId != undefined) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.editUserDialogData.userData.UserId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showUserHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showUserHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showUserHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.S0201))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLoginName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0020) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LoginName),
      expression: "editUserDialogData.userData.LoginName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLoginName",
      "name": "inputLoginName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LoginName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLoginName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LoginName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLoginName')),
      expression: "inputHasError('inputLoginName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.FirstName),
      expression: "editUserDialogData.userData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFirstName",
      "name": "inputFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.FirstName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFirstName')),
      expression: "inputHasError('inputFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0023) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.LastName),
      expression: "editUserDialogData.userData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLastName",
      "name": "inputLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.LastName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLastName')),
      expression: "inputHasError('inputLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCompanyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.CompanyName),
      expression: "editUserDialogData.userData.CompanyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCompanyName"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.CompanyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "CompanyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0025) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.Gender,
    staticClass: "form-control",
    attrs: {
      "id": "inputUserGender",
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.validationInput('inputUserGender')
      }
    },
    model: {
      value: (_vm.editUserDialogData.userData.Gender),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "Gender", $$v)
      },
      expression: "editUserDialogData.userData.Gender"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0026))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0027))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0203))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputUserGender')),
      expression: "inputHasError('inputUserGender')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0095))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRoleType"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), (_vm.editUserDialogData.userData.RoleTypeGuid) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.RoleTypeGuid,
    staticClass: "form-control",
    attrs: {
      "id": "editUserDialogData.userData.RoleTypeGuid",
      "afterChange": _vm.roleTypeChanged
    },
    model: {
      value: (_vm.editUserDialogData.userData.RoleTypeGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "RoleTypeGuid", $$v)
      },
      expression: "editUserDialogData.userData.RoleTypeGuid"
    }
  }, _vm._l((_vm.roleData), function(roleType) {
    return _c('option', {
      key: roleType.RoleTypeGuid,
      domProps: {
        "value": roleType.RoleTypeGuid
      }
    }, [_vm._v("\n                          " + _vm._s(roleType.RoleTypeDisplayName) + "\n                        ")])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), (
    _vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Agency'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0116) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectAgency",
      "name": "selectAgency",
      "afterChange": function (a) {
        _vm.validateInput('selectAgency');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.AgencyGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "AgencyGuid", $$v)
      },
      expression: "editUserDialogData.userData.AgencyGuid"
    }
  }, _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(agency.AgencyName) + "\n                        ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Client'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0111) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.editUserDialogData.userData.RoleTypeGuid) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectClient",
      "name": "selectClient",
      "dataTransformer": function (data) { return Number(data[0].id); },
      "afterChange": function (c) {
        _vm.validateInput('selectClient');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "ClientId", $$v)
      },
      expression: "editUserDialogData.userData.ClientId"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (
    !_vm.globals.roleTypeHasSuffix(
      _vm.editUserDialogData.userData.RoleTypeGuid,
      'Audi'
    )
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editUserSelectRole"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0133) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.RoleGuid,
    ref: "editUserSelectRole",
    staticClass: "form-control",
    attrs: {
      "id": "editUserSelectRole",
      "name": "editUserSelectRole",
      "afterChange": function (a) {
        _vm.validateInput('editUserSelectRole');
      },
      "placeholder": _vm.lang.S0041,
      "required": ""
    },
    model: {
      value: (_vm.editUserDialogData.userData.RoleGuid),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "RoleGuid", $$v)
      },
      expression: "editUserDialogData.userData.RoleGuid"
    }
  }, _vm._l((_vm.editUserDialogData.currentRoles), function(role) {
    return _c('option', {
      key: role.RoleGuid,
      domProps: {
        "value": role.RoleGuid
      }
    }, [_vm._v("\n                          " + _vm._s(role.RoleDisplayName) + "\n                        ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocalization"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.editUserDialogData.userData.LanguageCode,
    staticClass: "form-control",
    attrs: {
      "id": "inputLocalization",
      "placeholder": _vm.lang.S0041
    },
    model: {
      value: (_vm.editUserDialogData.userData.LanguageCode),
      callback: function($$v) {
        _vm.$set(_vm.editUserDialogData.userData, "LanguageCode", $$v)
      },
      expression: "editUserDialogData.userData.LanguageCode"
    }
  }, _vm._l((_vm.languageList), function(language, id) {
    return _c('option', {
      key: id + '_' + language,
      domProps: {
        "value": id
      }
    }, [_vm._v("\n                          " + _vm._s(language) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDefaultWelcomePage"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      ),
      expression: "\n                          editUserDialogData.userData.DefaultWelcomePage\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDefaultWelcomePage"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData.DefaultWelcomePage
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "DefaultWelcomePage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputDefaultWelcomePage",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0031) + ":")]), _vm._v(" "), _c('br'), _vm._v("clientname.msmloop.com\n                      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDisabled"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Active),
      expression: "editUserDialogData.userData.Active"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0035))])])])]), _vm._v(" "), (
    _vm.selectedUserData.RoleGuid === 'Market' &&
    _vm.selectedUserData.RoleTypeGuid === 'Client'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputMarket"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0202))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Market_short),
      expression: "editUserDialogData.userData.Market_short"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Market_short", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.marketList), function(market, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": market.marketShortName
      }
    }, [_vm._v("\n                          " + _vm._s(market.marketShortName) + "\n                        ")])
  })], 2)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.S0036))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address1),
      expression: "editUserDialogData.userData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress1"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Address2),
      expression: "editUserDialogData.userData.Address2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Address2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.City),
      expression: "editUserDialogData.userData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Country),
      expression: "editUserDialogData.userData.Country"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "Country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(_vm.editUserDialogData.userData.Country)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.RegionGuid),
      expression: "editUserDialogData.userData.RegionGuid"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentRegions.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "RegionGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.editUserDialogData.currentRegions.length > 0) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentRegions), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.TimeZone),
      expression: "editUserDialogData.userData.TimeZone"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editUserDialogData.currentTimeZones.length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "TimeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editUserDialogData.currentTimeZones.length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editUserDialogData.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                          " + _vm._s(tz.TimeZoneName) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PostalCode),
      expression: "editUserDialogData.userData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeographyFromGeocoding_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0117))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "inputGeographyFromGeocoding_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputGeographyFromGeocoding_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.inputHasError('inputGeographyFromGeocoding_Lat')
      ),
      expression: "\n                          inputHasError('inputGeographyFromGeocoding_Lat')\n                        "
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromGeocoding_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0118))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromGeocoding_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromGeocoding_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromGeocoding_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromGeocoding_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromGeocoding_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromGeocoding_Long')),
      expression: "inputHasError('GeographyFromGeocoding_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Lat"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0119))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Lat\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-90",
      "max": "90",
      "id": "GeographyFromPostalCode_Lat"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Lat
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Lat", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Lat')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Lat')),
      expression: "inputHasError('GeographyFromPostalCode_Lat')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-small"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "GeographyFromPostalCode_Long"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0120))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      ),
      expression: "\n                          editUserDialogData.userData\n                            .GeographyFromPostalCode_Long\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.000001",
      "min": "-180",
      "max": "180",
      "id": "GeographyFromPostalCode_Long"
    },
    domProps: {
      "value": (
        _vm.editUserDialogData.userData
        .GeographyFromPostalCode_Long
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "GeographyFromPostalCode_Long", $event.target.value)
      }, function($event) {
        return _vm.validateInput('GeographyFromPostalCode_Long')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('GeographyFromPostalCode_Long')),
      expression: "inputHasError('GeographyFromPostalCode_Long')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0122))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistanceUnit"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0121))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.DistanceUnit),
      expression: "editUserDialogData.userData.DistanceUnit"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUserDialogData.userData, "DistanceUnit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.S0041) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.distanceUnits), function(unit, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                          " + _vm._s(unit) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneHome"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneHome),
      expression: "editUserDialogData.userData.PhoneHome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneHome"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneHome)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneHome')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneHome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneHome')),
      expression: "inputHasError('inputPhoneHome')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneWork"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneWork),
      expression: "editUserDialogData.userData.PhoneWork"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneWork"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneWork)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneWork')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneWork", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneWork')),
      expression: "inputHasError('inputPhoneWork')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhoneMobile"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.PhoneMobile),
      expression: "editUserDialogData.userData.PhoneMobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhoneMobile"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.PhoneMobile)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhoneMobile')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "PhoneMobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhoneMobile')),
      expression: "inputHasError('inputPhoneMobile')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0096))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Fax),
      expression: "editUserDialogData.userData.Fax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Fax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Fax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0097))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0048))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUserDialogData.userData.Email),
      expression: "editUserDialogData.userData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "name": "inputEmail"
    },
    domProps: {
      "value": (_vm.editUserDialogData.userData.Email)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUserDialogData.userData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputEmail')),
      expression: "inputHasError('inputEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.S0098))])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editUserDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editUserDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0049))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.copyUser = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0050) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "user-management-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_SecurityUsers_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editUser')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0051) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "securityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    staticStyle: {
      "width": "80vw"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0054))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [(
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityGroups_ReadAll'
    ) &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SecurityUsersSecurityGroups_Read'
    )
  ) ? _c('a', {
    attrs: {
      "href": "#customGroupDataTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0056))]) : _vm._e()]), _vm._v(" "), _c('li', [(
    _vm.globals.isAccessAllowed('LoopOp_SecurityGroups_ReadAll')
  ) ? _c('a', {
    attrs: {
      "href": "#groupManagementTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0064))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._l((_vm.securityDialogData.dataLists), function(groupList, key) {
    return _c('div', {
      key: key,
      staticClass: "tab-pane fade in",
      class: {
        active: key == 'customGroupData'
      },
      attrs: {
        "id": key + 'Tab'
      }
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedAssignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unassignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
      attrs: {
        "disabled": _vm.securityDialogData.selectedUnassignedGroupGuids
          .length == 0 ||
          !_vm.globals.isAccessAllowed(
            'LoopOp_SecurityUsersSecurityGroups_Update'
          )
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.assignGroups()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center sticky-header"
    }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0058) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAvailable), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedUnassignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedUnassignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedUnassignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAvailable' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAvailable' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('table', {
      staticClass: "table table-striped table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center sticky-header"
    }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0059) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.groupListAssigned), function(group) {
      return _c('tr', {
        key: group.GroupGuid,
        class: {
          info: _vm.securityDialogData.selectedAssignedGroupGuids.indexOf(
            group.GroupGuid
          ) > -1,
        },
        attrs: {
          "role": "button"
        },
        on: {
          "click": function($event) {
            return _vm.toggleListItem(
              _vm.securityDialogData.selectedAssignedGroupGuids,
              group.GroupGuid
            )
          },
          "dblclick": function($event) {
            !_vm.globals.isAccessAllowed(
                'LoopOp_SecurityUsersSecurityGroups_Update'
              ) ||
              ((_vm.securityDialogData.selectedAssignedGroupGuids = []),
                _vm.toggleListItem(
                  _vm.securityDialogData.assignedGroupGuids,
                  group.GroupGuid
                ))
          }
        }
      }, [_c('td', {
        attrs: {
          "id": 'tdAssigned' + key + group.GroupName
        }
      }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (group.IsReportingGroup),
          expression: "group.IsReportingGroup"
        }],
        staticClass: "reporting-group-table-symbol"
      }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
        ref: "tooltip",
        refInFor: true,
        attrs: {
          "target": 'tdAssigned' + key + group.GroupName,
          "delay": _vm.globals.tooltipDelay
        }
      }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
    }), 0)])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "groupManagementTab"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0078) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.securityDialogData.dataLists
    .customGroupData), function(group) {
    return _c('tr', {
      key: group.GroupGuid,
      class: {
        info: _vm.securityDialogData.groupManagement
          .selectedGroup == group.GroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectGroup(group.GroupGuid)
        }
      }
    }, [_c('td', {
      attrs: {
        "id": 'tdAvailableCustomGroupData' + group.GroupName
      }
    }, [_vm._v("\n                            " + _vm._s(group.GroupName) + "\n                            "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.IsReportingGroup),
        expression: "group.IsReportingGroup"
      }],
      staticClass: "reporting-group-table-symbol"
    }, [_vm._v("R")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": 'tdAvailableCustomGroupData' + group.GroupName,
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(group.GroupDescription))])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.S0079) + "\n                          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupName"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0080) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGroupName"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0081))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.GroupDescription\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3",
      "id": "inputGroupDescription"
    },
    domProps: {
      "value": (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.GroupDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "GroupDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.selectedUserData.ClientGuid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsIsReportingGroupCheckbox",
      "id": "securityGroupsIsReportingGroupCheckboxLabel"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0191) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                                securityDialogData.groupManagement\n                                  .selectedGroupData.IsReportingGroup\n                              "
    }],
    attrs: {
      "type": "checkbox",
      "id": "securityGroupsIsReportingGroupCheckbox",
      "disabled": !_vm.findNextFreeTargetGroup()
    },
    domProps: {
      "checked": Array.isArray(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ) ? _vm._i(
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup, null) > -1 : (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      )
    },
    on: {
      "change": [function($event) {
        var $$a =
          _vm.securityDialogData.groupManagement
          .selectedGroupData.IsReportingGroup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.securityDialogData.groupManagement
              .selectedGroupData, "IsReportingGroup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.securityDialogData.groupManagement
            .selectedGroupData, "IsReportingGroup", $$c)
        }
      }, function($event) {
        return _vm.reportingGroupFlagToggled()
      }]
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "securityGroupsIsReportingGroupCheckboxLabel",
      "placement": "left",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0195) + "\n                        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.S0196) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "securityGroupsClientSelect"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.S0185) + "\n                        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
      ),
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.IsReportingGroup\n                          "
    }]
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "securityGroupsClientSelect",
      "allowClear": true,
      "placeholder": _vm.lang.S0186,
      "disabled": _vm.securityDialogData.groupManagement
        .selectedGroupData.IsReportingGroup
    },
    model: {
      value: (
        _vm.securityDialogData.groupManagement
        .selectedGroupData.ClientGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.securityDialogData.groupManagement
          .selectedGroupData, "ClientGuid", $$v)
      },
      expression: "\n                            securityDialogData.groupManagement\n                              .selectedGroupData.ClientGuid\n                          "
    }
  }, _vm._l((_vm.clientListWithGuid), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                            " + _vm._s(client.ClientName) + "\n                          ")])
  }), 0)], 1)]), _vm._v(" "), (
    _vm.securityDialogData.groupManagement.selectedGroupData
    .IsReportingGroup
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "targetGroupRadios"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0197))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, _vm._l((_vm.targetGroups), function(tg, guid) {
    return _c('div', {
      key: guid,
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "targetGroupRadios",
        "id": ("targetGroupRadio" + tg)
      },
      domProps: {
        "value": guid,
        "checked": guid ===
          _vm.securityDialogData.groupManagement
          .selectedGroupData.TargetGroupGuid
      },
      on: {
        "change": function($event) {
          return _vm.targetGroupGuidChanged(guid)
        }
      }
    }), _vm._v("\n                            " + _vm._s(_vm.lang.S0197) + " " + _vm._s(tg) + "\n                            "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearGroupManagementInputs()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0159) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.securityDialogData.groupManagement
        .isSelectedGroupDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroupData
        .GroupName ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Create'
          ) &&
          !_vm.securityDialogData.groupManagement
          .selectedGroup) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_SecurityGroups_Update'
          ) &&
          _vm.securityDialogData.groupManagement.selectedGroup)
    },
    on: {
      "click": function($event) {
        return _vm.editGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0082) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.securityDialogData.groupManagement.selectedGroup ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SecurityGroups_Delete'
        )
    },
    on: {
      "click": function($event) {
        return _vm.openGroupDeletionDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.S0083) + "\n                    ")])])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0060) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurityData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "security2Dialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0161))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSelectedUserInfoText()))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    _vm.selectedSecurity2Page === 'locations2Tab' &&
    _vm.security2DialogData.dataLists.locations.length > 100
  ) ? _c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "7px 0 0 0",
      "padding": "2px 20px",
      "position": "absolute"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.showTop100LocationsOnly = !_vm.security2DialogData.showTop100LocationsOnly),
        _vm.filterLocationData()
      }
    }
  }, [(_vm.security2DialogData.showTop100LocationsOnly) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0173) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.security2DialogData.hasAccessToAllLocations = !_vm.security2DialogData.hasAccessToAllLocations
      }
    }
  }, [(_vm.security2DialogData.hasAccessToAllLocations) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n              " + _vm._s(_vm.lang.S0189) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-security",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#clientSettings2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'clientSettings2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0139))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locationProperties2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locationProperties2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0140))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#locations2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'locations2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0141))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#reportingFeatures2Tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedSecurity2Page = 'reportingFeatures2Tab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.S0142))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "clientSettings2Tab"
    }
  }, [_c('div', [_c('table', {
    staticClass: "table outer-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v(_vm._s(_vm.lang.S0174))]), _vm._v(" "), _c('th', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-scrollbar"
  }, [_vm._l((_vm.security2DialogData.dataLists
    .clientSetting), function(project) {
    return [_c('tr', {
      key: project.ProjectGuid,
      staticClass: "accordion-toggle background-grey",
      class: {
        'cursor-pointer': !project.Forbidden
      },
      attrs: {
        "data-toggle": "collapse",
        "data-target": '#securityProjectWaves' + project.ProjectGuid
      },
      on: {
        "click": function($event) {
          (project.expanded = !project.expanded),
          _vm.$forceUpdate()
        }
      }
    }, [_c('td', {
      staticClass: "project-name-data"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      staticClass: "material-icons"
    }, [_vm._v("chevron_right")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && !project.expanded),
        expression: "!project.Forbidden && !project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_more")]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!project.Forbidden && project.expanded),
        expression: "!project.Forbidden && project.expanded"
      }],
      staticClass: "material-icons"
    }, [_vm._v("expand_less")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(project.ProjectName))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          project.expanded = false
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (project.Forbidden),
        expression: "project.Forbidden"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_projectForbidden_' + project.ProjectGuid
      },
      domProps: {
        "checked": Array.isArray(project.Forbidden) ? _vm._i(project.Forbidden, null) > -1 : (project.Forbidden)
      },
      on: {
        "change": function($event) {
          var $$a = project.Forbidden,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(project, "Forbidden", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(project, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(project, "Forbidden", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasForbiddenWaves(project)),
        expression: "hasForbiddenWaves(project)"
      }],
      staticClass: "material-icons"
    }, [_vm._v("priority_high")])])])]), _vm._v(" "), (!project.Forbidden) ? _c('tr', {
      key: project.ProjectGuid + 'waves'
    }, [_c('td', {
      staticClass: "hiddenRow",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "accordion-body collapse",
      attrs: {
        "id": 'securityProjectWaves' + project.ProjectGuid
      }
    }, [(
      !project.Waves || project.Waves.length < 1
    ) ? _c('span', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_vm._v(_vm._s(_vm.lang.S0176))]) : _c('table', {
      staticClass: "table table-hover inner-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "col-md-8"
    }, [_vm._v(_vm._s(_vm.lang.S0177))]), _vm._v(" "), _c('th', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(_vm.lang.S0175))])])]), _vm._v(" "), _c('tbody', _vm._l((project.Waves), function(wave) {
      return _c('tr', {
        key: wave.WaveGuid
      }, [_c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "checkbox",
        staticStyle: {
          "margin": "0px"
        }
      }, [_c('label', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (wave.Forbidden),
          expression: "wave.Forbidden"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'cb_waveForbidden_' +
            wave.WaveGuid
        },
        domProps: {
          "checked": Array.isArray(wave.Forbidden) ? _vm._i(wave.Forbidden, null) > -1 : (wave.Forbidden)
        },
        on: {
          "change": function($event) {
            var $$a = wave.Forbidden,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(wave, "Forbidden", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(wave, "Forbidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(wave, "Forbidden", $$c)
            }
          }
        }
      }), _vm._v(" "), _vm._m(5, true)])])])])
    }), 0)])])])]) : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locationProperties2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        !_vm.security2DialogData.hasAccessToAllLocations &&
        _vm.selectedUserData.ClientGuid
      ),
      expression: "\n                  !security2DialogData.hasAccessToAllLocations &&\n                  selectedUserData.ClientGuid\n                "
    }]
  }, [_c('CustomPropertiesPoliciesControl', {
    key: _vm.selectedUserData.ClientGuid,
    ref: "locationProperties2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData,
      "selectedClient": _vm.selectedUserData.ClientGuid
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "locations2Tab"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.security2DialogData.hasAccessToAllLocations),
      expression: "security2DialogData.hasAccessToAllLocations"
    }]
  }, [_vm._v("\n                " + _vm._s(_vm.lang.S0190) + "\n              ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.security2DialogData.hasAccessToAllLocations),
      expression: "!security2DialogData.hasAccessToAllLocations"
    }]
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', [_c('tr', [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0166) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0169) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0168) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0179) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0167) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.S0172) + "\n                            ")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStoreId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStoreId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationName\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationName
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationAddress\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationAddress
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationCountry\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationCountry
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      ),
      expression: "\n                                    security2DialogData.locationFilterStrings\n                                      .LocationStatusId\n                                  "
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.S0018
    },
    domProps: {
      "value": (
        _vm.security2DialogData.locationFilterStrings
        .LocationStatusId
      )
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.security2DialogData.locationFilterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.security2DialogData.locationFilterStrings.LocationVisible =
          (_vm.security2DialogData
            .locationFilterStrings
            .LocationVisible +
            1) %
          3),
        _vm.filterLocationData()
      }
    }
  }, [(
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 1
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (
    _vm.security2DialogData
    .locationFilterStrings
    .LocationVisible == 0
  ) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])]), _vm._v(" "), _vm._l((_vm.security2DialogData.dataLists
    .filteredLocations), function(location) {
    return _c('tr', {
      key: location.LocationId
    }, [_c('td', [_vm._v("\n                              " + _vm._s(location.LocationStoreId) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationName) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationAddress) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationCountry) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(location.LocationStatusId) + "\n                            ")]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn-default btn-cb-policies",
      on: {
        "click": function($event) {
          return _vm.toggleLocationPermission(
            location.LocationGuid
          )
        }
      }
    }, [(
      _vm.isLocationPermitted(location.LocationGuid)
    ) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "reportingFeatures2Tab"
    }
  }, [_c('div', [_c('SettingsPoliciesControl', {
    ref: "reportingFeatures2Tab",
    attrs: {
      "lang": _vm.lang,
      "user": _vm.selectedUserData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0164) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSecurity2Data()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0061) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteUserDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.S0099))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.S0100))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0020))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LoginName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.FirstName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.LastName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.RoleType))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.S0133))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteUserDialogData.Role))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "user-management-modal-delete-false-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0102) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "user-management-modal-delete-true-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteUserData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.S0101) + "\n          ")])])])])]), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog,
      "userGuid": _vm.selectedUser,
      "userName": _vm.selectedUserData.LoginName
    },
    on: {
      "dialogClosed": _vm.onChangePasswordDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiCopyModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KCM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "kpiCopyModal-source-project-select",
      "placeholder": _vm.lang.KCM002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSourceProject),
      callback: function($$v) {
        _vm.selectedSourceProject = $$v
      },
      expression: "selectedSourceProject"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.KCM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "kpiCopyModal-targetpoject-select",
      "placeholder": _vm.lang.KCM004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedTargetProject),
      callback: function($$v) {
        _vm.selectedTargetProject = $$v
      },
      expression: "selectedTargetProject"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedSourceProject || !_vm.selectedTargetProject
    },
    on: {
      "click": function($event) {
        return _vm.copyKpis()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KCM006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value.length < 1
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "tags": _vm.AllowCustomValues,
      "multiple": true,
      "placeholder": ' ',
      "disabled": _vm.readOnly,
      "afterChange": _vm.updateValue
    },
    model: {
      value: (_vm.Value),
      callback: function($$v) {
        _vm.Value = $$v
      },
      expression: "Value"
    }
  }, _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.confirmationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }, [_vm._v(_vm._s(_vm.htmlText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "id": "noButton",
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.noButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onNoConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.noButtonText) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "id": "yesButton",
      "type": "button",
      "disabled": _vm.yesButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.onYesConfirmation()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.yesButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperFilterModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CSM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ShopperFilter', {
    ref: "shopperFilterComponent",
    attrs: {
      "currentFilterObject": _vm.filterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList,
      "regionList": _vm.regionList
    },
    on: {
      "filterUpdate": function($event) {
        _vm.filterObject = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.copyFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": !_vm.copyData.filterObject || _vm.copyData.client !== _vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.restoreFilter()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM005) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CSM001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editShopperDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "shopperEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.editShopperData.ShopperId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.editShopperData.ShopperId) + ", " + _vm._s(_vm.lang.SM1048) + ":\n              " + _vm._s(_vm.editShopperData.Username))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showShopperHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showShopperHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showShopperHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1053))])], 1) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1002))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-push-9",
    attrs: {
      "id": "profilePictureContainer"
    },
    on: {
      "click": function($event) {
        return _vm.openFileSelector()
      }
    }
  }, [(_vm.editShopperData.ProfilePictureGuid) ? _c('img', {
    attrs: {
      "src": '/api/download/' + _vm.editShopperData.ProfilePictureGuid
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/avatar.png"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control hidden",
    attrs: {
      "id": "inputShopperProfilePictureFile",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onShopperProfilePictureFileChange,
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editShopperData.ProfilePictureGuid),
      expression: "editShopperData.ProfilePictureGuid"
    }],
    attrs: {
      "role": "button",
      "id": "removeProfilePictureButton"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.removeShopperProfilePictureFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperSalutation"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Salutation),
      expression: "editShopperData.Salutation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperSalutation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Salutation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1004))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1005))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1006))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperSalutation')),
      expression: "inputHasError('inputShopperSalutation')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperFirstName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.FirstName),
      expression: "editShopperData.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperFirstName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.FirstName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperFirstName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperFirstName')),
      expression: "inputHasError('inputShopperFirstName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperLastName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1011) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.LastName),
      expression: "editShopperData.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperLastName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.LastName)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperLastName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperLastName')),
      expression: "inputHasError('inputShopperLastName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-9 col-md-pull-3 noclearfix"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputShopperGender"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1029) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Gender),
      expression: "editShopperData.Gender"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperGender",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.validateInput('inputShopperGender')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.SM1004) + "\n                        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1031))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1030))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1033))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperGender')),
      expression: "inputHasError('inputShopperGender')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperAddress1"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1012) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Address1),
      expression: "editShopperData.Address1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperAddress1",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Address1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperAddress1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperAddress1')),
      expression: "inputHasError('inputShopperAddress1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1013) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.PostalCode),
      expression: "editShopperData.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPostalCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.PostalCode)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPostalCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "PostalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPostalCode')),
      expression: "inputHasError('inputShopperPostalCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1014) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.City),
      expression: "editShopperData.City"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperCity",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.City)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperCity')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "City", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCity')),
      expression: "inputHasError('inputShopperCity')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1015) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.globals.countryList) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperCountryCode",
      "placeholder": _vm.lang.SM1004,
      "afterChange": function () { return _vm.validateInput('inputShopperCountryCode'); },
      "required": ""
    },
    model: {
      value: (_vm.editShopperData.CountryCode),
      callback: function($$v) {
        _vm.$set(_vm.editShopperData, "CountryCode", $$v)
      },
      expression: "editShopperData.CountryCode"
    }
  }, _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                          " + _vm._s(country) + "\n                        ")])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperCountryCode')),
      expression: "inputHasError('inputShopperCountryCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1054) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.editShopperData.CountryCode,
    ref: "inputShopperRegion",
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperRegion",
      "placeholder": _vm.lang.SM1054,
      "afterChange": function () { return _vm.validateInput('inputShopperRegion'); },
      "required": "",
      "disabled": !_vm.editShopperData.CountryCode ||
        _vm.regionsOfSelectedCountry.length < 1
    },
    model: {
      value: (_vm.editShopperData.RegionGuid),
      callback: function($$v) {
        _vm.$set(_vm.editShopperData, "RegionGuid", $$v)
      },
      expression: "editShopperData.RegionGuid"
    }
  }, _vm._l((_vm.regionsOfSelectedCountry), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                          " + _vm._s(region.RegionName) + "\n                        ")])
  }), 0)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperRegion')),
      expression: "inputHasError('inputShopperRegion')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperBirthdate"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1016) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputShopperBirthdate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Birthdate),
      expression: "editShopperData.Birthdate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperBirthdate",
      "required": ""
    },
    domProps: {
      "value": (_vm.editShopperData.Birthdate)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperBirthdate')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Birthdate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperBirthdate')),
      expression: "inputHasError('inputShopperBirthdate')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmail"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1017) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Email),
      expression: "editShopperData.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmail",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Email)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperEmail')),
      expression: "inputHasError('inputShopperEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone1"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1018) + "\n                      "), (!_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Phone1),
      expression: "editShopperData.Phone1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone1",
      "required": !_vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Phone1)
    },
    on: {
      "change": function($event) {
        return _vm.validateInput('inputShopperPhone1')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Phone1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperPhone1')),
      expression: "inputHasError('inputShopperPhone1')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperPhone2"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Phone2),
      expression: "editShopperData.Phone2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperPhone2"
    },
    domProps: {
      "value": (_vm.editShopperData.Phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Phone2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupationGroup"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1020) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.editShopperData.RegionGuid,
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperOccupationGroup",
      "placeholder": _vm.lang.SM1004,
      "afterChange": function () { return _vm.validateInput('inputShopperOccupationGroup'); },
      "required": ""
    },
    model: {
      value: (_vm.editShopperData.OccupationalGroupGuid),
      callback: function($$v) {
        _vm.$set(_vm.editShopperData, "OccupationalGroupGuid", $$v)
      },
      expression: "editShopperData.OccupationalGroupGuid"
    }
  }, _vm._l((_vm.occupationalGroupList), function(occupationGroup, occupationGroupGuid) {
    return _c('option', {
      key: occupationGroupGuid,
      domProps: {
        "value": occupationGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(occupationGroup) + "\n                        ")])
  }), 0)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperOccupationGroup')),
      expression: "inputHasError('inputShopperOccupationGroup')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperOccupation"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM1021) + "\n                      "), (_vm.feature.isAudiTarget) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Occupation),
      expression: "editShopperData.Occupation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperOccupation",
      "required": _vm.feature.isAudiTarget
    },
    domProps: {
      "value": (_vm.editShopperData.Occupation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Occupation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperOccupation')),
      expression: "inputHasError('inputShopperOccupation')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperEmployer"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Employer),
      expression: "editShopperData.Employer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperEmployer"
    },
    domProps: {
      "value": (_vm.editShopperData.Employer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "Employer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputShopperEmployer')),
      expression: "inputHasError('inputShopperEmployer')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.SM1009))])])]) : _vm._e(), _vm._v(" "), (
    _vm.editShopperData.ShopperGuid && !_vm.feature.isAudiTarget
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperVatNo"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1041) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.VatNo),
      expression: "editShopperData.VatNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperVatNo",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editShopperData.VatNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "VatNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.VatNotMandatory),
      expression: "editShopperData.VatNotMandatory"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.editShopperData.VatNotMandatory) ? _vm._i(_vm.editShopperData.VatNotMandatory, null) > -1 : (_vm.editShopperData.VatNotMandatory)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editShopperData.VatNotMandatory,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editShopperData, "VatNotMandatory", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editShopperData, "VatNotMandatory", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editShopperData, "VatNotMandatory", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.SM1042))])])])])]) : _vm._e(), _vm._v(" "), (
    _vm.editShopperData.SocialSecurityNumber &&
    !_vm.feature.isAudiTarget
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShopperSocialSecurityNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1043) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.SocialSecurityNumber),
      expression: "editShopperData.SocialSecurityNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShopperSocialSecurityNumber",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editShopperData.SocialSecurityNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editShopperData, "SocialSecurityNumber", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (
    !_vm.dialogModeAdd &&
    _vm.globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBankDetails",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseBankDetails",
      "aria-expanded": "true",
      "aria-controls": "collapseBankDetails"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1035))])])]) : _vm._e(), _vm._v(" "), (
    !_vm.dialogModeAdd &&
    _vm.globals.isAccessAllowed('LoopOp_ShopperBankDetails_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseBankDetails",
      "role": "tabpanel",
      "aria-labelledby": "headingBankDetails"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsBankName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.BankName),
      expression: "bankDetailsData.BankName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsBankName",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.BankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "BankName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsSwiftCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.SwiftCode),
      expression: "bankDetailsData.SwiftCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsSwiftCode",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.SwiftCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "SwiftCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountNumber),
      expression: "bankDetailsData.AccountNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountNumber",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBankDetailsAccountName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankDetailsData.AccountName),
      expression: "bankDetailsData.AccountName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBankDetailsAccountName",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bankDetailsData.AccountName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bankDetailsData, "AccountName", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperProperties_Shopper_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustomProperties",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustomProperties",
      "aria-expanded": "true",
      "aria-controls": "collapseCustomProperties"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1040))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperProperties_Shopper_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustomProperties",
      "role": "tabpanel",
      "aria-labelledby": "headingCustomProperties"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('CustomPropertiesForm', {
    ref: "customPropertiesForm",
    attrs: {
      "shopperGuid": _vm.selectedShopperGuid
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingShopperAdministration",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseShopperAdministration",
      "aria-expanded": "true",
      "aria-controls": "collapseShopperAdministration"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.SM1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseShopperAdministration",
      "role": "tabpanel",
      "aria-labelledby": "headingShopperAdministration"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.editShopperData.MigratedShopperId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM1052))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.editShopperData.MigratedShopperId))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectShopperAccountStatus"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editShopperData.Active),
      expression: "editShopperData.Active"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectShopperAccountStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editShopperData, "Active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1046))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1047))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectShopperSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM1049))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.editShopperData.ShopperSkillLevel),
      expression: "editShopperData.ShopperSkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectShopperSkillLevel",
      "disabled": !_vm.globals.operationPermitted(
        'Fields.Shopper_ShopperSkillLevel.AllowUpdate'
      )
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.editShopperData, "ShopperSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectShopperSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                      1 → " + _vm._s(_vm.lang.SM1050) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      5 → " + _vm._s(_vm.lang.SM1051) + "\n                    ")])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM1007) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "shopper-management-save-button-modal",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Shopper_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editShopperDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM1008) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM2000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "add-checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row row-margin"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedClient,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-clients",
      "afterChange": function (c) {
        _vm.selectedClientLocal = c;
        _vm.$emit('clientSelected', c);
      },
      "placeholder": _vm.lang.CM2001,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                        " + _vm._s(client.ClientName) + "\n                      ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers') ?
      'col-md-2' :
      'col-md-4'
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.showDialog) ? _c('select2', {
    key: _vm.selectedProjectLocal,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-projects",
      "disabled": !_vm.selectedClientLocal && !_vm.selectedProject,
      "placeholder": _vm.lang.CM2002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProjectLocal),
      callback: function($$v) {
        _vm.selectedProjectLocal = $$v
      },
      expression: "selectedProjectLocal"
    }
  }, _vm._l((_vm.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                        " + _vm._s(project.ProjectName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), (_vm.feature.isMSMGermanyTarget) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.showDialog) ? _c('select2', {
    key: _vm.selectedSubProject,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-subprojects",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": "Select Subproject",
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSubProject),
      callback: function($$v) {
        _vm.selectedSubProject = $$v
      },
      expression: "selectedSubProject"
    }
  }, _vm._l((_vm.filteredSubProjects), function(subProject) {
    return _c('option', {
      key: subProject.SubProjectId,
      domProps: {
        "value": subProject.SubProjectId
      }
    }, [_vm._v("\n                        " + _vm._s(subProject.SubProjectName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.feature.isMSMGermanyTarget) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.showDialog) ? _c('select2', {
    key: _vm.selectedOrder,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-order",
      "disabled": !_vm.selectedSubProject,
      "placeholder": "Select Order",
      "allowClear": true
    },
    model: {
      value: (_vm.selectedOrder),
      callback: function($$v) {
        _vm.selectedOrder = $$v
      },
      expression: "selectedOrder"
    }
  }, _vm._l((_vm.filteredOrders), function(order) {
    return _c('option', {
      key: order.OrderId,
      domProps: {
        "value": order.OrderId
      }
    }, [_vm._v("\n                        " + _vm._s(order.OrderName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedSurvey,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-surveys",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2003,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedSurvey),
      callback: function($$v) {
        _vm.selectedSurvey = $$v
      },
      expression: "selectedSurvey"
    }
  }, _vm._l((_vm.surveysOfProject), function(survey) {
    return _c('option', {
      key: survey.SurveyId,
      domProps: {
        "value": survey.SurveyId
      }
    }, [_vm._v("\n                        " + _vm._s(survey.SurveyTitle) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedWave,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-waves",
      "disabled": !_vm.selectedProjectLocal,
      "placeholder": _vm.lang.CM2004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                        " + _vm._s(wave.WaveName) + "\n                      ")])
  }), 0)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedScenario,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-scenarios",
      "disabled": !_vm.selectedWave,
      "placeholder": _vm.lang.CM2005,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedScenario),
      callback: function($$v) {
        _vm.selectedScenario = $$v
      },
      expression: "selectedScenario"
    }
  }, _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                        " + _vm._s(scenario.ScenarioName) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedBriefingGuid,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-add-modal-briefing-guid-select",
      "placeholder": _vm.lang.CM2029,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedBriefingGuid),
      callback: function($$v) {
        _vm.selectedBriefingGuid = $$v
      },
      expression: "selectedBriefingGuid"
    }
  }, _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                        " + _vm._s(briefing.FileName) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedSurveyGuid,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-addmodal-surveyguid-select",
      "placeholder": _vm.lang.CM2030,
      "allowClear": true,
      "disabled": !_vm.selectedProjectLocal
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                        " + _vm._s(survey.FileName) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), (
    _vm.feature.isAudiTarget && _vm.feature.isEnabled('leadAgencies')
  ) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedAgency,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-lead-agency",
      "placeholder": _vm.lang.CM2013,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                        " + _vm._s(agency.AgencyName) + "\n                      ")])
  }), 0)], 1)]) : _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedCheckType,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-create-check-types",
      "placeholder": _vm.lang.CM2031,
      "allowClear": true,
      "afterChange": _vm.selectedCheckTypeChanged
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2032))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2033))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2034))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCT"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2046))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "height": "45px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.selectedCheckType === 'MA' ||
        _vm.selectedCheckType === 'DCT'
      ),
      expression: "\n                      selectedCheckType === 'MA' ||\n                      selectedCheckType === 'DCT'\n                    "
    }],
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedUser,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-addmodal-user-select",
      "afterChange": function (u) {
        _vm.selectedAgency = '';
      },
      "placeholder": _vm.lang.CM2006,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  }, _vm._l((_vm.dataLists.shopperList), function(user) {
    return _c('option', {
      key: user.Guid,
      domProps: {
        "value": user.Guid
      }
    }, [_vm._v("\n                        " + _vm._s(user.Shopper) + "\n                      ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.selectedCheckType === 'AG' && !_vm.feature.isAudiTarget
      ),
      expression: "\n                      selectedCheckType === 'AG' && !feature.isAudiTarget\n                    "
    }],
    staticClass: "form-group"
  }, [_c('select2', {
    key: _vm.selectedAgency,
    staticClass: "form-control",
    attrs: {
      "id": "check-management-addmodal-agency-select",
      "placeholder": _vm.lang.CM2013,
      "allowClear": true,
      "afterChange": function (a) {
        _vm.selectedUser = '';
      }
    },
    model: {
      value: (_vm.selectedAgency),
      callback: function($$v) {
        _vm.selectedAgency = $$v
      },
      expression: "selectedAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                        " + _vm._s(agency.AgencyName) + "\n                      ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCheckType === 'FO'),
      expression: "selectedCheckType === 'FO'"
    }],
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showFurtherSettingsModal = true
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2038))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-margin"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputGlobalAmount"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.globalAmount),
      expression: "globalAmount",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "inputGlobalAmount"
    },
    domProps: {
      "value": (_vm.globalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalAmount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group input-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkInfo),
      expression: "checkInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "50",
      "placeholder": _vm.lang.CM2044
    },
    domProps: {
      "value": (_vm.checkInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkInfo = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchAddChecks",
      "placeholder": _vm.lang.CM2014
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('div', {
    staticClass: "form-group form-group-buttons"
  }, [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.CM2010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(!_vm.isPageSelected()) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM2011))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM2012))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 last-row-button-container"
  }, [_c('span', {
    staticClass: "selected-locations-counter"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM2037) + ": " + _vm._s(_vm.selectedLocations.length || 0) + "\n                  "), (_vm.selectedLocations.length) ? [_c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectedLocations = []
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2036))])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdownAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2015))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2016))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButtonAddChecks",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2017))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "addChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "addChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM2045))])], 1)], 2)])])]), _vm._v(" "), (_vm.selectedCheckType == 'DCT') ? _c('div', {
    staticClass: "panel panel-default panel-locationdummy",
    class: {
      'panel-activated': _vm.isLocationDummy
    },
    on: {
      "click": function($event) {
        return _vm.toggleLocationDummyActivated()
      }
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "color": "#004080",
      "font-weight": "bold",
      "margin": "1em"
    },
    attrs: {
      "for": "isLocationDummy"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM2047) + "\n              ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default locations-table-panel"
  }, [_c('div', {
    staticClass: "panel-body scrollLocations"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "possibleLocations"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2018) + "\n                        "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2019) + "\n                        "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCountry')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2020) + "\n                        "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationAddress')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2021) + "\n                        "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationAddress' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationProperties')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2022) + "\n                        "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationProperties' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStatusId')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2023) + "\n                        "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStatusId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('SurveyInstancesCount')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM2024) + "\n                        "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstancesCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('a', {
    staticClass: "table-header"
  }, [_vm._v(_vm._s(_vm.lang.CM2009))])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationId),
      expression: "filterStrings.LocationId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "8%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationProperties),
      expression: "filterStrings.LocationProperties"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationProperties)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationProperties", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStatusId),
      expression: "filterStrings.LocationStatusId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStatusId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstancesCount),
      expression: "filterStrings.SurveyInstancesCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM2025
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstancesCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstancesCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "create-checks-table"
    }
  }, _vm._l((_vm.locationData), function(location) {
    return _c('tr', {
      key: location.LocationId,
      class: {
        info: _vm.isLocationSelected(location.LocationId),
        'location-inactive': location.LocationStatusId === 'X',
        'location-temp-inactive': location.LocationStatusId === 'T',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleLocationSelected(location.LocationId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [_vm._v(_vm._s(location.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v(_vm._s(location.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationAddress) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationProperties) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.LocationStatusId) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_vm._v("\n                      " + _vm._s(location.SurveyInstancesCount) + "\n                    ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (location.Amount),
        expression: "location.Amount",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control nopadding",
      attrs: {
        "type": "number",
        "min": "0"
      },
      domProps: {
        "value": (location.Amount)
      },
      on: {
        "click": function($event) {
          return $event.stopPropagation()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(location, "Amount", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2039) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "check-management-create",
      "type": "button",
      "disabled": (_vm.selectedLocations.length < 1 && !_vm.isLocationDummy) ||
        !_vm.selectedSurvey ||
        !_vm.selectedScenario ||
        (!_vm.selectedUser &&
          !_vm.selectedAgency &&
          _vm.selectedCheckType !== 'FO' &&
          _vm.selectedCheckType !== 'DCT')
    },
    on: {
      "click": function($event) {
        return _vm.createChecks()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM2026) + "\n          ")])])])])]), _vm._v(" "), _c('AddChecksFurtherSettingsModal', {
    ref: "addChecksFurtherSettingsModal",
    attrs: {
      "showModal": _vm.showFurtherSettingsModal,
      "survey": _vm.selectedSurveyData
    },
    on: {
      "modalClosed": _vm.furtherSettingsModalClosed
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdownAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButtonAddChecks"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "nopadding",
    staticStyle: {
      "width": "6%"
    }
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })])
}]}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationDataTranslateModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LTM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.LTM001) + " / " + _vm._s(_vm.lang.LTM002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    ref: "selectLocalizedLocationDataCountryCode",
    staticClass: "form-control",
    attrs: {
      "id": "locationdata-translate-modal-country-select",
      "placeholder": _vm.lang.LTM003,
      "allowClear": true,
      "afterChange": _vm.countryChanged
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, _vm._l((_vm.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                " + _vm._s(country) + "\n              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    key: _vm.selectedLanguage,
    ref: "selectLocalizedLocationDataLanguageCode",
    staticClass: "form-control",
    attrs: {
      "id": "locationdata-translate-modal-language-select",
      "disabled": !_vm.selectedCountry,
      "placeholder": _vm.lang.LTM004,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  }, _vm._l((_vm.currentCountryLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                " + _vm._s(language.LanguageName) + "\n              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedLanguage || !_vm.currentTranslationData.LocationGuid
    },
    on: {
      "click": function($event) {
        return _vm.deleteTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-red"
  }, [_vm._v("clear")])])]), _vm._v(" "), (_vm.selectedLanguage) ? [(!_vm.currentTranslationData.LocationGuid) ? _c('div', {
    staticClass: "col-md-12 location-translation-form"
  }, [_vm._v("\n              " + _vm._s(_vm.lang.LTM005) + "\n              "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-fab",
    on: {
      "click": function($event) {
        return _vm.addNewTranslationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])]) : _c('div', {
    staticClass: "col-md-12 location-translation-form",
    on: {
      "input": function($event) {
        _vm.currentTranslationDataDirty = true
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationName))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationName),
      expression: "currentTranslationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM007))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress),
      expression: "currentTranslationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM008))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationAddress2))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationAddress2),
      expression: "currentTranslationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCounty"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM009))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCounty))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCounty),
      expression: "currentTranslationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCounty",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM010))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationCity))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationCity),
      expression: "currentTranslationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationTranslationLocationPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.LTM011))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-5 base-data-label"
  }, [_vm._v(_vm._s(_vm.baseLocationData.LocationPostalCode))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTranslationData.LocationPostalCode),
      expression: "currentTranslationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationTranslationLocationPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.currentTranslationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTranslationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM012) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.currentTranslationDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveLocalizedLocationData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LTM013) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editWaveDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WV0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.WV0024) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ProjectId) + " -\n            " + _vm._s(_vm.selectedProjectData.ProjectName) + ",\n            "), _c('b', [_vm._v(_vm._s(_vm.lang.WV0025) + ":")]), _vm._v("\n            " + _vm._s(_vm.selectedProjectData.ClientId) + " -\n            " + _vm._s(_vm.selectedProjectData.ClientName) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterWaveString),
      expression: "filterWaveString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "editwave-modal-inputSearch",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterWaveString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterWaveString = $event.target.value
      }, function($event) {
        return _vm.doFilteringWaves()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.wavePositionsDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWavePositions()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.lang.WV0026) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container table-waves",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "wavesTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0004) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0005) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.WV0027) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredWaves), function(wave) {
    return _c('tr', {
      key: wave.WaveGuid,
      class: {
        info: _vm.isWaveSelected(wave.WaveGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectWave(wave.WaveGuid)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(wave.WaveId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(wave.WaveName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveSince
    )) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.globals.getLocalizedDateFromIsoTimestamp(
      wave.WaveUntil
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (wave.WavePosition),
        expression: "wave.WavePosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(wave, "WavePosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderWaves(), (_vm.wavePositionsDirty = true)
        }],
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, _vm._l((_vm.waves), function(w) {
      return _c('option', {
        key: w.WavePosition,
        domProps: {
          "value": w.WavePosition
        }
      }, [_vm._v("\n                                " + _vm._s(w.WavePosition) + "\n                              ")])
    }), 0)])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-wave-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editWaveTab",
      "id": "project-management-wave-edit-add-wave-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editWaveTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0006))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#assignScenariosTab",
      "id": "project-management-wave-edit-assign-scenarios-tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'assignScenariosTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0007))])]), _vm._v(" "), _c('li', [(_vm.carModelList.length > 0) ? _c('a', {
    attrs: {
      "href": "#carModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'carModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0029))]) : _vm._e()]), _vm._v(" "), _c('li', [(
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('shopperApproval')
  ) ? _c('a', {
    attrs: {
      "href": "#competitorCarModelDistributionTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'competitorCarModelDistributionTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0035))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editWaveTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveName"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveName),
      expression: "selectedWave.WaveName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveName"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveName", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputShortWaveName"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.ShortWaveName),
      expression: "selectedWave.ShortWaveName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputShortWaveName",
      "maxlength": "19"
    },
    domProps: {
      "value": (_vm.selectedWave.ShortWaveName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "ShortWaveName", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    attrs: {
      "id": "inputWaveStartDateFlatpickr"
    },
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveSince),
      expression: "selectedWave.WaveSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveStartDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveSince)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveSince", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputWaveEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveUntil),
      expression: "selectedWave.WaveUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEndDate"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveUntil)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveUntil", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditCostCenter"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.CostCenter),
      expression: "selectedWave.CostCenter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditCostCenter"
    },
    domProps: {
      "value": (_vm.selectedWave.CostCenter)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "CostCenter", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditWaveInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.WaveInfo),
      expression: "selectedWave.WaveInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputWaveEditWaveInfo",
      "maxlength": "500",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.selectedWave.WaveInfo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedWave, "WaveInfo", $event.target.value)
      }, function($event) {
        _vm.selectedWaveDirty = true
      }]
    }
  })])]), _vm._v(" "), (_vm.feature.isPorscheTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveEditCostCenter"
    }
  }, [_vm._v("Select master survey")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedWave.MasterSurvey,
    staticClass: "inputMasterSurveyForWave col-md-10",
    attrs: {
      "id": "wave-editmodal-masterwave-select",
      "name": "inputMasterSurveyForWave",
      "instanceId": "inputMasterSurveyForWave",
      "placeholder": "No survey selected",
      "allowClear": true
    },
    model: {
      value: (_vm.selectedWave.MasterSurvey),
      callback: function($$v) {
        _vm.$set(_vm.selectedWave, "MasterSurvey", $$v)
      },
      expression: "selectedWave.MasterSurvey"
    }
  }, _vm._l((_vm.surveyList), function(survey) {
    return _c('option', {
      key: survey.SurveyId,
      attrs: {
        "disabled": survey.disabled
      },
      domProps: {
        "value": survey.SurveyId
      }
    }, [_vm._v("\n                            (SID:" + _vm._s(survey.SurveyId) + ")\n                            " + _vm._s(survey.SurveyTitle) + "\n                          ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputWaveReportingVisibility"
    }
  }, [_vm._v(_vm._s(_vm.lang.WV0008))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWave.ReportingVisibility),
      expression: "selectedWave.ReportingVisibility"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputWaveReportingVisibility"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedWave.ReportingVisibility) ? _vm._i(_vm.selectedWave.ReportingVisibility, null) > -1 : (_vm.selectedWave.ReportingVisibility)
    },
    on: {
      "input": function($event) {
        _vm.selectedWaveDirty = true
      },
      "change": [function($event) {
        var $$a = _vm.selectedWave.ReportingVisibility,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedWave, "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedWave, "ReportingVisibility", $$c)
        }
      }, function($event) {
        return _vm.waveReportingVisibilityChanged(_vm.selectedWave)
      }]
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.createNewWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0009) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success btn-top-bar",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    attrs: {
      "id": "project-management-wave-save",
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName ||
        !_vm.selectedWave.WaveSince ||
        !_vm.selectedWave.WaveUntil ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Create'
          ) &&
          !_vm.selectedWave.WaveId) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Update'
          ) &&
          _vm.selectedWave.WaveId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId ||
        !_vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteWaveConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0011) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveId
    },
    on: {
      "click": function($event) {
        return _vm.showWaveStatus()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.WV0034) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignScenariosTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.WV0001
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "saveAssignment",
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName ||
        !_vm.selectedWave.WaveSince ||
        !_vm.selectedWave.WaveUntil ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Create'
          ) &&
          !_vm.selectedWave.WaveId) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Update'
          ) &&
          _vm.selectedWave.WaveId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.WV0010) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "scenarioTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0012) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0013) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0014) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': !_vm.selectedWave.WaveId,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioId) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioName) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioDescription) + "\n                            ")])])
  }), 0)])])]), _vm._v(" "), (_vm.carModelList.length > 0) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "carModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.carModelList), function(model) {
    return _c('tr', {
      key: model.CarModelGuid
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.Distribution),
        expression: "model.Distribution",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (model.Distribution)
      },
      on: {
        "change": function($event) {
          (_vm.selectedWaveDirty = true),
          _vm.validateDistributionValue(model, 'audi')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "Distribution", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName ||
        !_vm.selectedWave.WaveSince ||
        !_vm.selectedWave.WaveUntil ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Create'
          ) &&
          !_vm.selectedWave.WaveId) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Update'
          ) &&
          _vm.selectedWave.WaveId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('shopperApproval')
  ) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "competitorCarModelDistributionTab"
    }
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0030) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0031) + " (%)\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.WV0036) + "\n                            ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedWave.CompetitorCarModelDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (model.CompetitorCarModel),
        expression: "model.CompetitorCarModel",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "maxlength": "200"
      },
      domProps: {
        "value": (model.CompetitorCarModel)
      },
      on: {
        "change": function($event) {
          _vm.selectedWaveDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "CompetitorCarModel", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (model.Distribution || 0) * 100
      },
      on: {
        "change": function($event) {
          (model.Distribution =
            ($event.target.value || 0) / 100),
          (_vm.selectedWaveDirty = true),
          _vm.validateDistributionValue(
            model,
            'competitor'
          )
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      on: {
        "click": function($event) {
          return _vm.deleteCompetitorCarModel(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName
    },
    on: {
      "click": function($event) {
        return _vm.addCompetitorCarModel()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0037) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.selectedWaveDirty
    },
    staticStyle: {
      "float": "right",
      "margin-right": "20px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedWave.WaveName ||
        !_vm.selectedWave.WaveSince ||
        !_vm.selectedWave.WaveUntil ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Create'
          ) &&
          !_vm.selectedWave.WaveId) ||
        (!_vm.globals.isAccessAllowed(
            'LoopOp_ProjectWaves_Update'
          ) &&
          _vm.selectedWave.WaveId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedWave()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.WV0010) + "\n                    ")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.WV0015) + "\n          ")])])])])]), _vm._v(" "), _c('WaveStatusModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w80"
  }, [_vm._v(_vm._s(_vm.lang.S0139))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w20"
  }, [_c('span', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.toggleAll
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.settings), function(setting) {
    return _c('tr', {
      key: setting.ReportingFeatureGuid
    }, [_c('td', {
      staticClass: "td-cb-policies w80"
    }, [_c('span', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          setting.Permitted = !setting.Permitted
        }
      }
    }, [_vm._v(_vm._s(setting.ReportingFeatureName))])]), _vm._v(" "), _c('td', {
      staticClass: "td-cb-policies w20"
    }, [_c('a', {
      staticClass: "btn btn-default btn-cb-policies2",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (setting.Permitted = !setting.Permitted), _vm.$forceUpdate()
        }
      }
    }, [(setting.Permitted) ? _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("check_box_outline_blank")])])])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "carModelManagement",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CMM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editCarModelsTab",
      "data-toggle": "tab",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM001))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#editCarSegmentsTab",
      "data-toggle": "tab",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM002))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editCarModelsTab"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputNewCarModel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newModel),
      expression: "newModel"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewCarModel",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newModel)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewModel()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newModel = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputNewCarModel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    attrs: {
      "multiple": true
    },
    model: {
      value: (_vm.selectedSegments),
      callback: function($$v) {
        _vm.selectedSegments = $$v
      },
      expression: "selectedSegments"
    }
  }, _vm._l((_vm.segmentList), function(segment) {
    return _c('option', {
      key: segment.CarSegmentGuid,
      domProps: {
        "value": segment.CarSegmentGuid
      }
    }, [_vm._v("\n                        " + _vm._s(segment.CarSegmentName) + "\n                      ")])
  }), 0)], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.newModel || !_vm.selectedSegments[0] || _vm.isModelEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewModel()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CMM005) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "carModelTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "carModelTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-7"
  }, [_vm._v(_vm._s(_vm.lang.CMM006))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-3"
  }, [_vm._v(_vm._s(_vm.lang.CMM007))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.CMM008))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.modelList), function(model, index) {
    return _c('tr', {
      key: index,
      class: {
        info: model.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding",
      on: {
        "dblclick": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (model.CarModelName),
        expression: "model.CarModelName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (model.CarModelName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(model, "CarModelName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      class: {
        nopadding: model.editing
      },
      on: {
        "dblclick": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [(model.editing) ? _c('div', {
      staticClass: "form-group"
    }, [_c('select2', {
      attrs: {
        "id": "select-carsegment",
        "value": _vm.getCarSegmentsGuidList(model),
        "multiple": true
      },
      on: {
        "change": function($event) {
          return _vm.carSegmentsOfModelChanged(model, $event)
        }
      }
    }, _vm._l((_vm.segmentList), function(segment) {
      return _c('option', {
        key: segment.CarSegmentGuid,
        domProps: {
          "value": segment.CarSegmentGuid
        }
      }, [_vm._v("\n                              " + _vm._s(segment.CarSegmentName) + "\n                            ")])
    }), 0)], 1) : _c('span', [_vm._v(_vm._s(_vm.getCarSegmentNameList(model.CarSegments)))])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "carModelActionButtonContainer"
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!model.editing),
        expression: "!model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isModelEditing
      },
      on: {
        "click": function($event) {
          return _vm.editModel($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (model.editing),
        expression: "model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveModel($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!model.editing),
        expression: "!model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isModelEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteModel(model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (model.editing),
        expression: "model.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoModelChanges($event, model)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "editCarSegmentsTab"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewSegment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CMM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSegment),
      expression: "newSegment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewSegment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newSegment)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewSegment()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSegment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.newSegment || _vm.isSegmentEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewSegment()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CMM005) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "segmentTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "segmentsTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.CMM006))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.CMM008))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.segmentList), function(segment, index) {
    return _c('tr', {
      key: index,
      class: {
        info: segment.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (segment.CarSegmentName),
        expression: "segment.CarSegmentName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (segment.CarSegmentName)
      },
      on: {
        "dblclick": function($event) {
          return _vm.editSegment($event, segment)
        },
        "blur": function($event) {
          segment.CarSegmentName !==
            segment.prevCarSegmentName ||
            _vm.undoSegmentChanges($event, segment)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(segment, "CarSegmentName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "segmentActionButtonContainer"
      }
    }, [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!segment.editing),
        expression: "!segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isSegmentEditing
      },
      on: {
        "click": function($event) {
          return _vm.editSegment($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (segment.editing),
        expression: "segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveSegment($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!segment.editing),
        expression: "!segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isSegmentEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteSegment(segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (segment.editing),
        expression: "segment.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoSegmentChanges($event, segment)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.isModelEditing || _vm.isSegmentEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CMM010) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-select",
    class: _vm.stateClasses,
    attrs: {
      "dir": _vm.dir
    }
  }, [_vm._t("header", null, null, _vm.scope.header), _vm._v(" "), _c('div', {
    ref: "toggle",
    staticClass: "vs__dropdown-toggle",
    attrs: {
      "id": ("vs" + _vm.uid + "__combobox"),
      "role": "combobox",
      "aria-expanded": _vm.dropdownOpen.toString(),
      "aria-owns": ("vs" + _vm.uid + "__listbox"),
      "aria-label": "Search for option"
    },
    on: {
      "mousedown": function($event) {
        return _vm.toggleDropdown($event)
      }
    }
  }, [_c('div', {
    ref: "selectedOptions",
    staticClass: "vs__selected-options"
  }, [_vm._l((_vm.selectedValue), function(option) {
    return _vm._t("selected-option-container", [_c('span', {
      key: _vm.getOptionKey(option),
      staticClass: "vs__selected"
    }, [(_vm.multiple) ? _c('button', {
      ref: "deselectButtons",
      refInFor: true,
      staticClass: "vs__deselect",
      attrs: {
        "disabled": _vm.disabled,
        "type": "button",
        "title": ("Deselect " + (_vm.getOptionLabel(option))),
        "aria-label": ("Deselect " + (_vm.getOptionLabel(option)))
      },
      on: {
        "click": function($event) {
          return _vm.deselect(option)
        }
      }
    }, [_c(_vm.childComponents.Deselect, {
      tag: "component"
    })], 1) : _vm._e(), _vm._v(" "), _vm._t("selected-option", [_vm._v("\n            " + _vm._s(_vm.getOptionLabel(option)) + "\n          ")], null, _vm.normalizeOptionForSlot(option))], 2)], {
      "option": _vm.normalizeOptionForSlot(option),
      "deselect": _vm.deselect,
      "multiple": _vm.multiple,
      "disabled": _vm.disabled
    })
  }), _vm._v(" "), _vm._t("search", [_c('input', _vm._g(_vm._b({
    staticClass: "vs__search"
  }, 'input', _vm.scope.search.attributes, false), _vm.scope.search.events))], null, _vm.scope.search)], 2), _vm._v(" "), _c('div', {
    ref: "actions",
    staticClass: "vs__actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClearButton),
      expression: "showClearButton"
    }],
    ref: "clearButton",
    staticClass: "vs__clear",
    attrs: {
      "disabled": _vm.disabled,
      "type": "button",
      "title": "Clear Selected",
      "aria-label": "Clear Selected"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_c(_vm.childComponents.Deselect, {
    tag: "component"
  })], 1), _vm._v(" "), _vm._t("open-indicator", [(!_vm.noDrop) ? _c(_vm.childComponents.OpenIndicator, _vm._b({
    tag: "component"
  }, 'component', _vm.scope.openIndicator.attributes, false)) : _vm._e()], null, _vm.scope.openIndicator), _vm._v(" "), _vm._t("spinner", [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mutableLoading),
      expression: "mutableLoading"
    }],
    staticClass: "vs__spinner"
  }, [_vm._v("Loading...")])], null, _vm.scope.spinner)], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.dropdownOpen) ? _c('ul', {
    directives: [{
      name: "append-to-body",
      rawName: "v-append-to-body"
    }],
    key: ("vs" + _vm.uid + "__listbox"),
    ref: "dropdownMenu",
    staticClass: "vs__dropdown-menu",
    attrs: {
      "id": ("vs" + _vm.uid + "__listbox"),
      "role": "listbox",
      "tabindex": "-1"
    },
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.onMousedown($event)
      },
      "mouseup": _vm.onMouseUp
    }
  }, [_vm._t("list-header", null, null, _vm.scope.listHeader), _vm._v(" "), _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: _vm.getOptionKey(option),
      staticClass: "vs__dropdown-option",
      class: {
        'vs__dropdown-option--deselect': _vm.isOptionDeselectable(option) && index === _vm.typeAheadPointer,
        'vs__dropdown-option--selected': _vm.isOptionSelected(option),
        'vs__dropdown-option--highlight': index === _vm.typeAheadPointer,
        'vs__dropdown-option--disabled': !_vm.selectable(option),
      },
      attrs: {
        "id": ("vs" + _vm.uid + "__option-" + index),
        "role": "option",
        "aria-selected": index === _vm.typeAheadPointer ? true : null
      },
      on: {
        "mouseover": function($event) {
          _vm.selectable(option) ? (_vm.typeAheadPointer = index) : null
        },
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.selectable(option) ? _vm.select(option) : null
        }
      }
    }, [_vm._t("option", [_vm._v("\n          " + _vm._s(_vm.getOptionLabel(option)) + "\n        ")], null, _vm.normalizeOptionForSlot(option))], 2)
  }), _vm._v(" "), (_vm.filteredOptions.length === 0) ? _c('li', {
    staticClass: "vs__no-options"
  }, [_vm._t("no-options", [_vm._v("\n          Sorry, no matching options.\n        ")], null, _vm.scope.noOptions)], 2) : _vm._e(), _vm._v(" "), _vm._t("list-footer", null, null, _vm.scope.listFooter)], 2) : _c('ul', {
    staticStyle: {
      "display": "none",
      "visibility": "hidden"
    },
    attrs: {
      "id": ("vs" + _vm.uid + "__listbox"),
      "role": "listbox"
    }
  })]), _vm._v(" "), _vm._t("footer", null, null, _vm.scope.footer)], 2)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "14",
      "height": "10"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
    !_vm.globals.isLocalAgencyUser
  ) ? _c('div', [_c('div', [_c('agency-management-toolbar', {
    ref: "agencyManagementToolbar",
    attrs: {
      "table-element-count": _vm.tableElementCount,
      "agencySelected": _vm.agencySelected,
      "refreshEnabled": _vm.refreshEnabled
    },
    on: {
      "searchTextChanged": _vm.onSearchTextChanged,
      "pageSizeChanged": _vm.onPageSizeChanged,
      "pageNumberChanged": _vm.onPageNumberChanged,
      "openEditAgency": _vm.toggleModal,
      "openDeleteAgency": function($event) {
        _vm.showDeleteModal = true
      },
      "onTriggerReload": _vm.triggerReload,
      "hook:mounted": _vm.readComponentSettingsFromStore
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('agency-management-table', {
    ref: "agencyManagementTable",
    attrs: {
      "table-filter": _vm.tableFilter,
      "page-size": _vm.pageSize,
      "page-number": _vm.pageNumer,
      "selectedAgency": _vm.selectedAgency
    },
    on: {
      "onTableElementsCountChange": _vm.onTableElementsCountChange,
      "onAgencySelected": _vm.onAgencySelected,
      "onAgencyOpenEdit": _vm.onAgencyOpenEdit,
      "onRefreshEnabled": _vm.onRefreshEnabled,
      "agenciesReceived": function($event) {
        _vm.agencyList = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('agency-management-edit-modal', {
    attrs: {
      "show-edit-modal": _vm.showEditModal,
      "mode-add": _vm.modeAdd,
      "edit-agency-model": _vm.selectedAgency,
      "allRegions": _vm.allRegions,
      "agencyList": _vm.agencyList
    },
    on: {
      "modalClosed": _vm.onModalClosed,
      "onAgencySaved": _vm.onAgencySaved
    }
  }), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.AM0000,
      "yesButtonText": _vm.lang.AM0002,
      "noButtonText": _vm.lang.AM0003,
      "showDialog": _vm.showDeleteModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.onAgencyDeleted,
      "dialogClosed": function($event) {
        _vm.showDeleteModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.AM0001))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0004))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.selectedAgency.AgencyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0005))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencyName) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.AM0006))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedAgency.AgencySince) + "\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "customPropertyEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "propertyEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeCustomPropertyEditDialog()
      }
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SM2000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propertyTreeFilter),
      expression: "propertyTreeFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM2001
    },
    domProps: {
      "value": (_vm.propertyTreeFilter)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.propertyTreeFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Topic')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2002) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isTreeDirty,
      'btn-success': !_vm.isTreeDirty,
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveTree()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2003) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "customPropertiesTreeContainer"
    }
  }, [(_vm.propertyTreeData.Nodes) ? _c('liquortree', {
    ref: "customPropertiesTree",
    attrs: {
      "data": _vm.propertyTreeData.Nodes,
      "filter": _vm.propertyTreeFilter,
      "options": _vm.propertyTreeOptions
    },
    on: {
      "node:selected": _vm.onPropertySelected
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('div', {
          staticClass: "draggable-tree-node",
          class: {
            'node-inactive': !node.data.Active
          },
          attrs: {
            "draggable": "true"
          },
          on: {
            "dragover": function($event) {
              $event.preventDefault();
            },
            "dragstart": function($event) {
              return _vm.ltDragStart(node, $event)
            },
            "dragenter": function($event) {
              return _vm.ltDragEnter(node, $event)
            },
            "dragleave": function($event) {
              return _vm.ltDragLeave(node, $event)
            },
            "dragend": function($event) {
              return _vm.ltDragEnd(node, $event)
            },
            "drop": function($event) {
              return _vm.ltDrop(node, $event)
            }
          }
        }, [(node.data.Type === 'Topic') ? _c('i', {
          staticClass: "material-icons"
        }, [_vm._v("title")]) : _vm._e(), _vm._v(" "), (node.data.Type === 'Group') ? _c('i', {
          staticClass: "material-icons"
        }, [_vm._v("group_work")]) : _vm._e(), _vm._v(" "), (!node.data.Visible) ? _c('i', {
          staticClass: "material-icons visibility-off"
        }, [_vm._v("visibility_off")]) : _vm._e(), _vm._v("\n                        " + _vm._s(node.text) + "\n                      ")])
      }
    }], null, false, 3767787081)
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedPropertyNodeData.Type) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    },
    on: {
      "change": function($event) {
        return _vm.nodeDataChanged()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM2004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.getTypeTranslation(_vm.selectedPropertyNodeData.Type)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPropertyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2005) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Title),
      expression: "selectedPropertyNodeData.Title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPropertyName"
    },
    domProps: {
      "value": (_vm.selectedPropertyNodeData.Title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedPropertyNodeData, "Title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.selectedPropertyNodeData.Type === 'Property') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPropertyInputType"
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.PropertyType),
      expression: "selectedPropertyNodeData.PropertyType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputPropertyInputType",
      "disabled": _vm.selectedPropertyNodeData.HasShopperValues
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.selectedPropertyNodeData, "PropertyType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.inputPropertyTypesList), function(inputType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": inputType
      }
    }, [_vm._v("\n                          " + _vm._s(inputType) + "\n                        ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.PropertyType ===
    'SingleSelect' ||
    _vm.selectedPropertyNodeData.PropertyType === 'MultiSelect'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SM2007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showPropertyListEditModal = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SM2008) + "\n                      ")])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.PropertyType ===
    'SingleSelect' ||
    _vm.selectedPropertyNodeData.PropertyType === 'MultiSelect'
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelAllowCustomListValues",
      "for": "inputAllowCustomListValues"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2036) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedPropertyNodeData.AllowCustomValues
      ),
      expression: "\n                              selectedPropertyNodeData.AllowCustomValues\n                            "
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputAllowCustomListValues"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.AllowCustomValues,
      "checked": Array.isArray(
        _vm.selectedPropertyNodeData.AllowCustomValues
      ) ? _vm._i(
        _vm.selectedPropertyNodeData.AllowCustomValues, _vm.selectedPropertyNodeData.AllowCustomValues) > -1 : (
        _vm.selectedPropertyNodeData.AllowCustomValues
      )
    },
    on: {
      "change": function($event) {
        var $$a =
          _vm.selectedPropertyNodeData.AllowCustomValues,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.AllowCustomValues,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "AllowCustomValues", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelAllowCustomListValues",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2037))])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedPropertyNodeData.Type === 'Property') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyRecommended",
      "for": "inputPropertyRecommended"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2034) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Recommended),
      expression: "selectedPropertyNodeData.Recommended"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyRecommended"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Recommended,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Recommended) ? _vm._i(_vm.selectedPropertyNodeData.Recommended, _vm.selectedPropertyNodeData.Recommended) > -1 : (_vm.selectedPropertyNodeData.Recommended)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Recommended,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Recommended,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Recommended", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyRecommended",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2035))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyVisible",
      "for": "inputPropertyVisible"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2009) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Visible),
      expression: "selectedPropertyNodeData.Visible"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyVisible"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Visible,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Visible) ? _vm._i(_vm.selectedPropertyNodeData.Visible, _vm.selectedPropertyNodeData.Visible) > -1 : (_vm.selectedPropertyNodeData.Visible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Visible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Visible,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Visible", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Visible", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Visible", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyVisible",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2027))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "id": "labelPropertyActive",
      "for": "inputPropertyActive"
    }
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.lang.SM2011) + "\n                        "), _c('i', {
    staticClass: "material-icons md-18 form-hint-icon"
  }, [_vm._v("help_outline")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPropertyNodeData.Active),
      expression: "selectedPropertyNodeData.Active"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputPropertyActive"
    },
    domProps: {
      "value": _vm.selectedPropertyNodeData.Active,
      "checked": Array.isArray(_vm.selectedPropertyNodeData.Active) ? _vm._i(_vm.selectedPropertyNodeData.Active, _vm.selectedPropertyNodeData.Active) > -1 : (_vm.selectedPropertyNodeData.Active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectedPropertyNodeData.Active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.selectedPropertyNodeData.Active,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedPropertyNodeData, "Active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedPropertyNodeData, "Active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedPropertyNodeData, "Active", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "labelPropertyActive",
      "boundary": "viewport",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM2029))])], 1), _vm._v(" "), _c('div', [(
    _vm.selectedPropertyNodeData.Guid &&
    _vm.selectedPropertyNodeData.Type !== 'Property'
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Property')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2012) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.selectedPropertyNodeData.Guid &&
    _vm.selectedPropertyNodeData.Type === 'Topic'
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.insertNewNode('Group')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2013) + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.isCurrentNodeDirty || !_vm.selectedPropertyNodeData.Guid
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.discardCurrentNodeChanges()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2033) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isCurrentNodeDirty,
      'btn-success': !_vm.isCurrentNodeDirty,
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveCurrentNode()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SM2014) + "\n                    ")])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('CustomPropertyListEditModal', {
    attrs: {
      "showModal": _vm.showPropertyListEditModal,
      "listGuid": _vm.selectedPropertyNodeData.ListGuid
    },
    on: {
      "modalClosing": function($event) {
        _vm.showPropertyListEditModal = false
      },
      "propertyListCreated": function($event) {
        (_vm.selectedPropertyNodeData.ListGuid = $event), _vm.nodeDataChanged()
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKPIGroupDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKPIGroupDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM4006))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM4007) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4010) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKpiGroupString),
      expression: "filterKpiGroupString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM4013
    },
    domProps: {
      "value": (_vm.filterKpiGroupString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKpiGroupString = $event.target.value
      }, function($event) {
        return _vm.doFilterKpiGroups()
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedClientGuid,
    staticClass: "form-control",
    attrs: {
      "id": "kpi-group-editmodal-clientguid-select",
      "afterChange": _vm.selectedClientGuidChanged,
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4036) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredKpiGroups), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupGuid,
      class: {
        info: _vm.selectedKpiGroupGuid === kpiGroup.KPIGroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGroupGuid = kpiGroup.KPIGroupGuid),
          _vm.getSelectedKpiGroupInformation()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                        ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-group-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'editKpiGroupTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4014))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4017))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiGroupOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiGroupOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4037))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiGroupTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupCode",
      "id": "inputKpiGroupCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiGroupInformation.KPIGroupCode),
      expression: "selectedKpiGroupInformation.KPIGroupCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiGroupInformation.KPIGroupCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupCode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupCode')),
      expression: "inputHasError('inputKpiGroupCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4032))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupShortText",
      "id": "inputKpiGroupShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupShortText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiGroupShortText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupShortText')),
      expression: "inputHasError('inputKpiGroupShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4033))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupLongText",
      "id": "inputKpiGroupLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4004) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupLongText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupLongText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupLongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupLongText')),
      expression: "inputHasError('inputKpiGroupLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupWeightInput",
      "id": "KPIGroupWeightInputLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4031) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupWeight\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "KPIGroupWeightInput",
      "min": "0",
      "max": "100",
      "step": "0.01"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "KPIGroupWeightInputLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupProjectSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4008) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedProjectGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupProjectSelect",
      "placeholder": _vm.lang.KM4009,
      "afterChange": function (g) {
        _vm.selectedKpiGroupDirty = true;
      },
      "required": ""
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                              " + _vm._s(project.ProjectName) + "\n                            ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupsSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiGroupInformation.KPIEvaluationRuleGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupsSelectEvaluation",
      "placeholder": _vm.lang.KM4011,
      "afterChange": function () {
        _vm.selectedKpiGroupDirty = true;
      },
      "required": ""
    },
    model: {
      value: (
        _vm.selectedKpiGroupInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiGroupInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, _vm._l((_vm.kpiGroupEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      ),
      expression: "\n                                selectedKpiGroupInformation.KPIGroupDescription\n                              "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiGroupDescription"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4028))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpiGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4015) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiGroupDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKPIGroupDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4003) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiGroupConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4016) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4018) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4019))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup &&
        _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiGroupOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4038) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4039))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiGroup.KPIGroupPosition),
        expression: "kpiGroup.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpiGroup, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpiGroups(),
            (_vm.changeKpiGroupOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup2) {
      return _c('option', {
        key: kpiGroup2.KPIGroupPosition,
        domProps: {
          "value": kpiGroup2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpiGroup2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiGroupOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup &&
        _vm.kpiGroupsOfSelectedClient.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiGroupsNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM4002) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "10",
      "height": "10",
      "transform": "scale(0.8)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addChecksFurtherSettingsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.lang.CFM000))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.OnlineState),
      expression: "settings.OnlineState"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.OnlineState) ? _vm._i(_vm.settings.OnlineState, null) > -1 : (_vm.settings.OnlineState)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.OnlineState,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "OnlineState", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "OnlineState", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "OnlineState", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM001))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.LocationFree),
      expression: "settings.LocationFree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.LocationFree) ? _vm._i(_vm.settings.LocationFree, null) > -1 : (_vm.settings.LocationFree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.LocationFree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "LocationFree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "LocationFree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "LocationFree", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.lang.CFM002))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM003))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsStartDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceSince),
      expression: "settings.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsStartDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFurtherSettingsEndDate')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SurveyInstanceUntil),
      expression: "settings.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputFurtherSettingsEndDate"
    },
    domProps: {
      "value": (_vm.settings.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsBasePayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsBasePayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstanceBasePayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstanceBasePayment", $$v)
      },
      expression: "settings.SurveyInstanceBasePayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputFurtherSettingsPlusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputFurtherSettingsPlusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale
    },
    model: {
      value: (_vm.settings.SurveyInstancePlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "SurveyInstancePlusPayment", $$v)
      },
      expression: "settings.SurveyInstancePlusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CFM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(_vm.totalPayment, "EUR")))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CFM013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.settings.SurveyInstanceSkillLevel),
      expression: "settings.SurveyInstanceSkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveyInstanceSkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.settings, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CFM018) + "\n                "), (_vm.survey.SurveySkillLevel > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.survey.SurveySkillLevel) + ")")]) : _vm._e()]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  })], 2)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n            1 → " + _vm._s(_vm.lang.CFM015) + "\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            5 → " + _vm._s(_vm.lang.CFM016) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM008) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CFM012) + "\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearSettings()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CFM010) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperProposalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SPM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarSegmentSelect",
      "afterChange": (_vm.selectedCarModel = ''),
      "placeholder": _vm.lang.SPM002,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedCarSegment),
      callback: function($$v) {
        _vm.selectedCarSegment = $$v
      },
      expression: "selectedCarSegment"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carSegmentList), function(segment) {
    return _c('option', {
      key: segment.CarSegmentGuid,
      domProps: {
        "value": segment.CarSegmentGuid
      }
    }, [_vm._v("\n                " + _vm._s(segment.CarSegmentName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarModelSelect",
      "afterChange": (_vm.selectedCompetitorCar = ''),
      "placeholder": _vm.lang.SPM003,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    model: {
      value: (_vm.selectedCarModel),
      callback: function($$v) {
        _vm.selectedCarModel = $$v
      },
      expression: "selectedCarModel"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.carModelsOfSelectedSegment), function(model) {
    return _c('option', {
      key: model.CarModelGuid,
      domProps: {
        "value": model.CarModelGuid
      }
    }, [_vm._v("\n                " + _vm._s(model.CarModelName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), (_vm.check.CompetitorCarModelDistribution) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCompetitorCarModelSelect",
      "afterChange": (_vm.selectedCarModel = ''),
      "placeholder": _vm.lang.SPM005,
      "allowClear": true,
      "disabled": !_vm.selectedCarSegment
    },
    model: {
      value: (_vm.selectedCompetitorCar),
      callback: function($$v) {
        _vm.selectedCompetitorCar = $$v
      },
      expression: "selectedCompetitorCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.check.CompetitorCarModelDistribution), function(model) {
    return _c('option', {
      key: model.CompetitorCarModelGuid,
      domProps: {
        "value": model.CompetitorCarModelGuid
      }
    }, [_vm._v("\n                " + _vm._s(model.CompetitorCarModel) + "\n              ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperSelect",
      "afterchange": function () {
        _vm.selectedShopperCar = '';
        _vm.getShopperCars();
      },
      "placeholder": _vm.lang.SPM007,
      "allowClear": true,
      "disabled": _vm.anyShopperAlreadyApproved
    },
    model: {
      value: (_vm.selectedShopper),
      callback: function($$v) {
        _vm.selectedShopper = $$v
      },
      expression: "selectedShopper"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.unproposedShoppers), function(shopper) {
    return _c('option', {
      key: shopper.ShopperGuid,
      domProps: {
        "value": shopper.ShopperGuid
      }
    }, [_vm._v("\n                " + _vm._s(shopper.ShopperName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fab",
    attrs: {
      "disabled": !_vm.selectedShopperCar ||
        !_vm.selectedCarSegment ||
        (!_vm.selectedCarModel && !_vm.selectedCompetitorCar)
    },
    on: {
      "click": function($event) {
        return _vm.addShopper()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.SPM008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalShopperCarSelect",
      "placeholder": _vm.lang.SPM009,
      "allowClear": true,
      "disabled": !_vm.selectedShopper
    },
    model: {
      value: (_vm.selectedShopperCar),
      callback: function($$v) {
        _vm.selectedShopperCar = $$v
      },
      expression: "selectedShopperCar"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.shopperCars), function(car) {
    return _c('option', {
      key: car.ValueGroupGuid,
      domProps: {
        "value": car.ValueGroupGuid
      }
    }, [_vm._v("\n                " + _vm._s(car.Brand) + " " + _vm._s(car.Model) + " (" + _vm._s(car.Year) + ")\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-inline"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCarMatch),
      expression: "selectedCarMatch"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newShopperProposalCarMatchSelect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCarMatch = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "+"
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SPM010))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SPM011))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-"
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SPM012))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.check && _vm.check.ShopperProposals) ? [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM013) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM014) + " (" + _vm._s(_vm.lang.SPM015) + ")\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM016) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM017) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SPM018) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid
    }, [_c('td', [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(proposal.CarModelName) + "\n                  "), (proposal.CarSegmentName) ? [_vm._v("(" + _vm._s(proposal.CarSegmentName) + ")")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("openProposalFeedButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM019))]), _vm._v(" "), (proposal.UpdateShopperProposal) ? [_c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.updateShopperData(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("refresh")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM020))])] : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn nopadding",
      attrs: {
        "id": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "disabled": proposal.AgencyApprovalStatus
      },
      on: {
        "click": function($event) {
          return _vm.deleteShopper(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("deleteShopperProposalButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM021))])], 2)])
  }), 0)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SPM022) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('hr')])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "uploadProgressModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content msm-form-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.UPM000) + "...")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-msm",
    style: (("width: " + (_vm.globals.currentUploadProgress) + "%"))
  })]), _vm._v("\n        " + _vm._s(_vm.globals.currentUploadProgress) + " %\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.globals.cancelPendingUploads()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.UPM001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editScenarioDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "project-management-scenario-close-dialog-cross",
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SC0000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.SC0020) + ":")]), _vm._v("\n          " + _vm._s(_vm.selectedClient) + " - " + _vm._s(_vm.nameOfSelectedClient) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterScenarioString),
      expression: "filterScenarioString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SC0011
    },
    domProps: {
      "value": (_vm.filterScenarioString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterScenarioString = $event.target.value
      }, function($event) {
        return _vm.doFilteringScenarios()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedClient,
    staticClass: "form-control",
    attrs: {
      "id": "selectedClientSelect",
      "afterChange": _vm.getScenariosOfSelectedClient
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: 'option_' + client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                    " + _vm._s(client.ClientName) + "\n                  ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container table-scenarios",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0012) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0013) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.SC0014) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredScenarios), function(scenario) {
    return _c('tr', {
      key: scenario.ScenarioGuid,
      class: {
        info: _vm.isScenarioSelected(scenario.ScenarioGuid),
        'cursor-not-allowed': _vm.selectedTab === 'assignClientTab' &&
          _vm.selectedClient < 0,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario.ScenarioGuid)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                        " + _vm._s(scenario.ScenarioDescription) + "\n                      ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-scenario-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editScenarioTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editScenarioTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0007))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editScenarioTab"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioName"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioName),
      expression: "selectedScenario.ScenarioName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioName",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioName", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioLongtext"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioLongtext),
      expression: "selectedScenario.ScenarioLongtext"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputScenarioLongtext",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioLongtext)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioLongtext", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputScenarioDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.SC0005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedScenario.ScenarioDescription),
      expression: "selectedScenario.ScenarioDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedScenario.ScenarioDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedScenario, "ScenarioDescription", $event.target.value)
      }, function($event) {
        _vm.selectedScenarioDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId
    },
    on: {
      "click": function($event) {
        return _vm.createNewScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0010) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedScenarioDirty
    },
    attrs: {
      "type": "button",
      "id": "project-management-scenario-save",
      "disabled": _vm.selectedScenario.ScenarioName.length < 1 ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Create') &&
          !_vm.selectedScenario.ScenarioId) ||
        (!_vm.globals.isAccessAllowed('LoopOp_Scenarios_Update') &&
          _vm.selectedScenario.ScenarioId)
    },
    on: {
      "click": function($event) {
        return _vm.saveSelectedScenario()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0002) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedScenario.ScenarioId ||
        _vm.selectedScenario.ScenarioId < 0 ||
        !_vm.globals.isAccessAllowed('LoopOp_Scenarios_Delete')
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteScenarioConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SC0003) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "assignClientTab"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterClientString),
      expression: "filterClientString"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "40%",
      "display": "inline",
      "float": "left"
    },
    attrs: {
      "type": "search",
      "placeholder": 'Filter'
    },
    domProps: {
      "value": (_vm.filterClientString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterClientString = $event.target.value
      }, function($event) {
        return _vm.doFilteringClients()
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.unsavedAssignments
    },
    staticStyle: {
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_ClientsScenarios_Update'
        )
    },
    on: {
      "click": function($event) {
        return _vm.saveScenariosOfSelectedClient()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0002) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.copyScenarios
    },
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedClient < 0 && !_vm.copyScenarios
    },
    on: {
      "click": function($event) {
        return _vm.copyScenariosClicked()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SC0001) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0012) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.SC0009) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredClients), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: _vm.isClientSelected(client.ClientId)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectClient(client.ClientId)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v(_vm._s(client.ClientName))])])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "project-management-scenario-close-dialog-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SC0006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editProjectForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.projectData.ProjectId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.projectData.ProjectId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showProjectHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showProjectHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showProjectHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P1041))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditProject",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditProjectGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditProjectGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1001) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectName),
      expression: "projectData.ProjectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputName",
      "name": "inputName",
      "required": ""
    },
    domProps: {
      "value": (_vm.projectData.ProjectName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputName')),
      expression: "inputHasError('inputName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.projectData.ClientId,
    staticClass: "form-control",
    attrs: {
      "id": "editProjectClientSelect",
      "dataTransformer": function (data) { return Number(data[0].id); },
      "afterChange": _vm.getAvailableSurveysForClient,
      "placeholder": _vm.lang.P1004,
      "disabled": !_vm.dialogModeAdd,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ClientId", $$v)
      },
      expression: "projectData.ClientId"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": parseInt(client.ClientId)
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectClientSelect')),
      expression: "inputHasError('editProjectClientSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editProjectImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1036) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editProjectImporterSelect",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ImporterGuid", $$v)
      },
      expression: "projectData.ImporterGuid"
    }
  }, _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('editProjectImporterSelect')),
      expression: "inputHasError('editProjectImporterSelect')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectAccountable"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.projectData.ProjectAccountableGuid,
    staticClass: "form-control",
    attrs: {
      "id": "inputProjectAccountable",
      "placeholder": _vm.lang.P1004,
      "required": ""
    },
    model: {
      value: (_vm.projectData.ProjectAccountableGuid),
      callback: function($$v) {
        _vm.$set(_vm.projectData, "ProjectAccountableGuid", $$v)
      },
      expression: "projectData.ProjectAccountableGuid"
    }
  }, _vm._l((_vm.listOfProjectAccountables), function(accountable, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": guid
      }
    }, [_vm._v("\n                          " + _vm._s(accountable) + "\n                        ")])
  }), 0), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputProjectAccountable')),
      expression: "inputHasError('inputProjectAccountable')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.P1002))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectSince"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectSince')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectSince),
      expression: "projectData.ProjectSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectSince",
      "name": "inputProjectSince"
    },
    domProps: {
      "value": (_vm.projectData.ProjectSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputProjectUntil"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputProjectUntil')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectData.ProjectUntil),
      expression: "projectData.ProjectUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputProjectUntil",
      "name": "inputProjectUntil"
    },
    domProps: {
      "value": (_vm.projectData.ProjectUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projectData, "ProjectUntil", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1005))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "role": "button",
      "disabled": _vm.selectedAssignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.unassignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-fab btn-fab-mini dialog-btn-primary",
    attrs: {
      "id": "assignSurveysButton",
      "role": "button",
      "disabled": _vm.selectedUnassignedSurveyIds.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.assignSurveys()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_forward")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "availableSurveys"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.P1006))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getUnassignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedUnassignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedUnassignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedUnassignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1007) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1014) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAssignedSurveys()), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.selectedAssignedSurveyIds.indexOf(
          survey.SurveyId
        ) > -1,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleListItem(
            _vm.selectedAssignedSurveyIds,
            survey.SurveyId
          )
        },
        "dblclick": function($event) {
          (_vm.selectedAssignedSurveyIds = []),
          _vm.toggleSurveyListItem(
            _vm.projectData.Surveys,
            survey.SurveyId
          )
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v("\n                            " + _vm._s(survey.SurveyTitle) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%",
        "padding": "5px"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ),
        expression: "\n                                    projectData.Surveys[\n                                      getIndexOfSurveyInProjectDataSurveys(\n                                        survey.SurveyId\n                                      )\n                                    ].ReportingVisibility\n                                  "
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        ) ? _vm._i(
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility, null) > -1 : (
          _vm.projectData.Surveys[
            _vm.getIndexOfSurveyInProjectDataSurveys(
              survey.SurveyId
            )
          ].ReportingVisibility
        )
      },
      on: {
        "change": [function($event) {
          var $$a =
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ].ReportingVisibility,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.projectData.Surveys[
                _vm.getIndexOfSurveyInProjectDataSurveys(
                  survey.SurveyId
                )
              ], "ReportingVisibility", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ], "ReportingVisibility", $$c)
          }
        }, function($event) {
          _vm.surveyReportingVisibilityChanged(
            _vm.projectData.Surveys[
              _vm.getIndexOfSurveyInProjectDataSurveys(
                survey.SurveyId
              )
            ]
          )
        }]
      }
    }), _vm._v(" "), _vm._m(0, true)])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectFileUpload",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectDocuments",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectDocuments"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1023))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectDocuments",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBriefingAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputBriefingAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1025
    },
    on: {
      "change": _vm.onBriefingAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1026))]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.briefings), function(briefing, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(briefing.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1027,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(briefing.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1028,
        "disabled": !briefing.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.briefings, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "accept": "application/pdf",
      "title": _vm.lang.P1032
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.P1033))]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1029) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.P1030) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveys), function(survey, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(survey.FileName))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1034,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.globals.downloadFile(survey.DownloadId)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-green"
    }, [_vm._v("file_download")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button",
        "title": _vm.lang.P1035,
        "disabled": !survey.DownloadId
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachmentFile(_vm.surveys, index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons text-red"
    }, [_vm._v("clear")])])])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectResponsibility",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectResponsibility",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectResponsibility"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1037))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectResponsibility",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectResponsibility"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8",
    attrs: {
      "id": "departmentUsersNameTableHeader"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.P1038) + "\n                          "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "departmentUsersFilterStringInputContainer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.departmentUsersFilterString),
      expression: "departmentUsersFilterString"
    }],
    staticClass: "form-control nopadding",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": _vm.lang.P1039
    },
    domProps: {
      "value": (_vm.departmentUsersFilterString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.departmentUsersFilterString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.lang.P1040))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "table-scrollbar text-left"
  }, [_vm._l((_vm.filteredDepartmentUsers), function(department) {
    return [_c('tr', {
      key: department.DepartmentId,
      staticClass: "tr-department"
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', [_vm._v(_vm._s(department.DepartmentName))])])]), _vm._v(" "), _vm._l((department.Employees), function(emp) {
      return _c('tr', {
        key: emp.UserId
      }, [_c('td', {
        staticStyle: {
          "padding": "7px"
        }
      }, [_c('label', {
        staticClass: "text-black nopadding",
        attrs: {
          "role": "button",
          "for": ("cb_empResponsible_" + (emp.UserId))
        }
      }, [_vm._v(_vm._s(emp.DisplayName))])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "padding": "5px",
          "padding-left": "10px",
          "overflow": "hidden"
        }
      }, [_c('div', {
        staticClass: "checkbox",
        staticStyle: {
          "margin": "0px"
        }
      }, [_c('label', [_c('input', {
        attrs: {
          "type": "checkbox",
          "id": ("cb_empResponsible_" + (emp.UserId))
        },
        domProps: {
          "checked": _vm.isEmployeeResponsible(emp.UserId)
        },
        on: {
          "change": function($event) {
            return _vm.toggleEmployeeResponsibility(emp.UserId)
          }
        }
      }), _vm._v(" "), _vm._m(3, true)])])])])
    })]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditProjectPlanning",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditProject",
      "href": "#collapseEditProjectPlanning",
      "aria-expanded": "false",
      "aria-controls": "collapseEditProjectPlanning"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.P1008))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isGanttVisible),
      expression: "isGanttVisible"
    }],
    attrs: {
      "id": "zoomButtonBar"
    }
  }, [_c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom out",
      "disabled": _vm.currentScaleUnit == 'year'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("remove")])]), _vm._v(" "), _c('a', {
    staticClass: "btn text-primary nopadding",
    attrs: {
      "role": "button",
      "title": "Zoom in",
      "disabled": _vm.currentScaleUnit == 'week'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.zoomGanttChart(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditProjectPlanning",
      "role": "tabpanel",
      "aria-labelledby": "headingEditProjectPlanning"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "container gantt-container"
  }, [_c('gantt', {
    ref: "pmGantt",
    staticClass: "left-container",
    attrs: {
      "id": "pmGantt",
      "tasks": _vm.projectData.Gantt
    },
    on: {
      "task-updated": _vm.updateGanttTask
    }
  })], 1)])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.P1009))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1010) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "project-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Projects_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editProjectDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P1011) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Projects_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "projects-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getProjectData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-create-button",
      "disabled": _vm.clientList.length < 1
    },
    on: {
      "click": function($event) {
        (_vm.selectedProject = -1),
        (_vm.editProjectDialogModeAdd = true),
        (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-edit-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        (_vm.editProjectDialogModeAdd = false), (_vm.showEditProjectDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Projects_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-delete-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteProjectDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Scenarios_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-scenario-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditScenarioDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("wallpaper")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0028) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_ReadAll') &&
    _vm.globals.isAccessAllowed('LoopOp_ProjectWaves_Read')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "project-management-wave-button",
      "disabled": _vm.selectedProject == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditWaveDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("schedule")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.P0029) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "projectmanagement-inputSearch",
      "placeholder": _vm.lang.P0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "projectsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "projectsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.P0032))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "projectmanagement-project-list"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0008) + "\n                  "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('projectName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0009) + "\n                  "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'projectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('clientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0030) + "\n                  "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'clientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('importerName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0031) + "\n                  "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'importerName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectActiveLocationsCount')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0010) + "\n                  "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectActiveLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectTotalLocationsCount')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0011) + "\n                  "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectTotalLocationsCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSurveysCount')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0012) + "\n                  "), (
    _vm.sortField == 'ProjectSurveysCount' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectSurveysCount' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectSince')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0014) + "\n                  "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectSince' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortProjectData('ProjectCreatedBy')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.P0015) + "\n                  "), (
    _vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ProjectCreatedBy' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectId),
      expression: "filterStrings.ProjectId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectName),
      expression: "filterStrings.ProjectName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectActiveLocationsCount),
      expression: "filterStrings.ProjectActiveLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectActiveLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectActiveLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectTotalLocationsCount),
      expression: "filterStrings.ProjectTotalLocationsCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectTotalLocationsCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectTotalLocationsCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSurveysCount),
      expression: "filterStrings.ProjectSurveysCount"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSurveysCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSurveysCount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectSince),
      expression: "filterStrings.ProjectSince"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectSince)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectCreatedBy),
      expression: "filterStrings.ProjectCreatedBy"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.P0016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectCreatedBy)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getProjectData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectCreatedBy", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.projectData), function(project) {
    return _c('tr', {
      key: project.ProjectId,
      class: {
        info: project.ProjectId == _vm.selectedProject
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedProject = project.ProjectId),
          (_vm.clientOfSelectedProject = project.ClientId)
        },
        "dblclick": function($event) {
          (_vm.editProjectDialogModeAdd = false),
          (_vm.showEditProjectDialog = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(project.ProjectId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.ProjectName))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(project.ClientName) + "\n              ")]) : _c('td', [_vm._v(_vm._s(project.ImporterName))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(project.ProjectActiveLocationsCount) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(project.ProjectTotalLocationsCount) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.ProjectSurveysCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.ProjectSince))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.ProjectCreatedBy))])])
  }), 0)])])])]), _vm._v(" "), _c('ProjectManagementEditModal', {
    attrs: {
      "selectedProject": _vm.selectedProject,
      "clientList": _vm.clientList,
      "surveyList": _vm.surveyList,
      "showDialog": _vm.showEditProjectDialog,
      "dialogModeAdd": _vm.editProjectDialogModeAdd
    },
    on: {
      "dialogClosed": _vm.onEditProjectDialogClosed,
      "dialogDataSaved": _vm.onEditProjectDialogDataSaved
    }
  }), _vm._v(" "), _c('ScenarioEditModal', {
    attrs: {
      "showDialog": _vm.showEditScenarioDialog,
      "selectedProjectData": _vm.selectedProjectData,
      "clientList": _vm.clientList,
      "selectedClientFromProject": _vm.clientOfSelectedProject
    },
    on: {
      "dialogClosed": _vm.onEditScenarioDialogClosed
    }
  }), _vm._v(" "), _c('WaveEditModal', {
    attrs: {
      "showDialog": _vm.showEditWaveDialog,
      "selectedClient": _vm.clientOfSelectedProject,
      "selectedProjectData": _vm.selectedProjectData
    },
    on: {
      "dialogClosed": _vm.onEditWaveDialogClosed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteProjectDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.P0019))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.P0020))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0021))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0022))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 text-black"
  }, [_vm._v(_vm._s(_vm.lang.P0023))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-9 text-black"
  }, [_vm._v(_vm._s(_vm.deleteProjectDialogData.ProjectSince))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "deleteFalse",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0024) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "project-management-delete-true-dialog-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteProjectData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.P0025) + "\n          ")])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportLocationsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LEX000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.clientList.length > 1) ? _c('div', {
    staticClass: "form-group fg-client-select"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "locationExportClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.LEX005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "locationExportClientSelect",
      "placeholder": _vm.lang.LEX005
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExportData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX002) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importerManagementModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "disabled": _vm.isImporterEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.IMP000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewImporter"
    }
  }, [_vm._v(_vm._s(_vm.lang.IMP001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newImporter),
      expression: "newImporter"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewImporter",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newImporter)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addNewImporter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newImporter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "importer-modal-add-button",
      "type": "button",
      "disabled": !_vm.newImporter || _vm.isImporterEditing
    },
    on: {
      "click": function($event) {
        return _vm.addNewImporter()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.IMP002) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "importersTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "importersTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.IMP003))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.IMP004))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.importerList), function(importer, index) {
    return _c('tr', {
      key: index,
      class: {
        info: importer.editing
      },
      attrs: {
        "role": "button"
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (importer.ImporterName),
        expression: "importer.ImporterName"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (importer.ImporterName)
      },
      on: {
        "dblclick": function($event) {
          importer.ImporterGuid ===
            '1D86A788-07D6-4681-BD8C-9C15800DF8BA' ||
            _vm.editImporter($event, importer)
        },
        "blur": function($event) {
          importer.ImporterName !==
            importer.prevImporterName ||
            _vm.undoImporterChanges($event, importer)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(importer, "ImporterName", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "importerActionButtonContainer"
      }
    }, [(
      importer.ImporterGuid !==
      '1D86A788-07D6-4681-BD8C-9C15800DF8BA'
    ) ? [_c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!importer.editing),
        expression: "!importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "id": "importer-action-button-container-edit",
        "type": "button",
        "disabled": _vm.isImporterEditing
      },
      on: {
        "click": function($event) {
          return _vm.editImporter($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (importer.editing),
        expression: "importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveImporter($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("save")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!importer.editing),
        expression: "!importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button",
        "disabled": _vm.isImporterEditing
      },
      on: {
        "click": function($event) {
          return _vm.deleteImporter(importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (importer.editing),
        expression: "importer.editing"
      }],
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.undoImporterChanges($event, importer)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-primary"
    }, [_vm._v("undo")])])] : _vm._e()], 2)])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.isImporterEditing
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.IMP005) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && _vm.value === undefined
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('button', {
    staticClass: "btn-checkbox pull-left",
    class: {
      'checkbox-readonly': _vm.readOnly
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateValue()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [(_vm.value === true) ? _c('span', [_vm._v("check_box")]) : (_vm.value === false) ? _c('span', [_vm._v("check_box_outline_blank")]) : _c('span', [_vm._v("indeterminate_check_box")])])])])])
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editAgency",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDialog(false)
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.modeAdd ? _vm.lang.AM3000 : _vm.lang.AM3001))])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.AM3002))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyName"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3003) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyName),
      expression: "agencyEditModel.AgencyName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyName",
      "name": "inputAgencyName",
      "required": ""
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputAgencyName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputAgencyName')),
      expression: "inputHasError('inputAgencyName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.AM3014))])])]), _vm._v(" "), (
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies') &&
    !_vm.globals.isAgencyUser
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.AM3015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 text-left"
  }, _vm._l((_vm.agencyTypeList), function(type) {
    return _c('div', {
      key: type.AgencyTypeGuid,
      staticClass: "radio"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.agencyEditModel.AgencyTypeGuid),
        expression: "agencyEditModel.AgencyTypeGuid"
      }],
      attrs: {
        "type": "radio",
        "name": "editAgencyTypeRadios",
        "disabled": _vm.globals.currentUserInfo.AgencyGuid ===
          _vm.agencyEditModel.AgencyGuid
      },
      domProps: {
        "value": type.AgencyTypeGuid,
        "checked": _vm._q(_vm.agencyEditModel.AgencyTypeGuid, type.AgencyTypeGuid)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.agencyEditModel, "AgencyTypeGuid", type.AgencyTypeGuid)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text text-primary"
    }, [_vm._v(_vm._s(type.AgencyTypeName))]), _vm._v(" "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies') &&
    _vm.agencyEditModel.AgencyTypeGuid === _vm.localAgencyTypeGuid
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyParentSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3016) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyParentSelect",
      "disabled": _vm.globals.currentUserInfo.AgencyGuid ===
        _vm.agencyEditModel.AgencyGuid || _vm.globals.isAgencyUser,
      "required": ""
    },
    model: {
      value: (_vm.agencyEditModel.ParentAgency),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "ParentAgency", $$v)
      },
      expression: "agencyEditModel.ParentAgency"
    }
  }, _vm._l((_vm.leadAgencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                        " + _vm._s(agency.AgencyName) + "\n                      ")])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyStreet"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyAddress),
      expression: "agencyEditModel.AgencyAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyStreet",
      "name": "inputAgencyStreet"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyStreet2"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3012))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyAddress2),
      expression: "agencyEditModel.AgencyAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyStreet2",
      "name": "inputAgencyStreet2"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyCity),
      expression: "agencyEditModel.AgencyCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyCity",
      "name": "inputAgencyCity"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencyZip"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencyPostalCode),
      expression: "agencyEditModel.AgencyPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAgencyZip",
      "name": "inputAgencyZip"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencyPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencyPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyCountrySelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3007) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyCountrySelect",
      "afterChange": function (d) {
        _vm.countryChanged(true);
      },
      "placeholder": _vm.lang.AM3013,
      "allowClear": true,
      "required": ""
    },
    model: {
      value: (_vm.agencyEditModel.AgencyCountry),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "AgencyCountry", $$v)
      },
      expression: "agencyEditModel.AgencyCountry"
    }
  }, _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editAgencyRegionSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3011) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.agencyEditModel.AgencyCountry,
    ref: "editAgencyRegionSelect",
    staticClass: "form-control",
    attrs: {
      "id": "editAgencyRegionSelect",
      "disabled": !_vm.agencyEditModel.AgencyCountry ||
        _vm.regionsOfCountry.length < 1,
      "placeholder": _vm.lang.AM3013,
      "allowClear": true,
      "required": ""
    },
    model: {
      value: (_vm.agencyEditModel.RegionGuid),
      callback: function($$v) {
        _vm.$set(_vm.agencyEditModel, "RegionGuid", $$v)
      },
      expression: "agencyEditModel.RegionGuid"
    }
  }, _vm._l((_vm.regionsOfCountry), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                        " + _vm._s(region.RegionName) + "\n                      ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAgencySince"
    }
  }, [_vm._v(_vm._s(_vm.lang.AM3008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputAgencySince')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agencyEditModel.AgencySince),
      expression: "agencyEditModel.AgencySince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "inputAgencySince",
      "name": "inputAgencySince"
    },
    domProps: {
      "value": (_vm.agencyEditModel.AgencySince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.agencyEditModel, "AgencySince", $event.target.value)
      }
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDialog(false)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AM3009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "agency-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Agencies_Update')
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editAgency')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AM3010) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "elementHistoryModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content msm-form-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "element-history-modal-content"
  }, [(_vm.history.length > 0) ? _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS000) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.HIS001) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(entry) {
    return _c('tr', {
      key: entry.SurveyInstanceHistoryGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(entry.EntryCreatedByDisplayName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "entry-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      entry.EntryCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(entry.Message))])])
  }), 0)]) : _c('span', [_vm._v(_vm._s(_vm.lang.HIS002))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "grid-area": "left"
    }
  }, [(_vm.showExportButton) ? _c('button', {
    staticClass: "btn btn-raised btn-light",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.exportSurveyInstance
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.HIS011) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "grid-area": "right",
      "box-sizing": "border-box"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-light",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.HIS003) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "select2-control"
  }, [(!_vm.multiple) ? _c('option') : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Locations_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "locations-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getLocationData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedLocation = -1),
        (_vm.selectedLocationGuid = ''),
        (_vm.showEditLocationModal = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-edit-button",
      "disabled": _vm.selectedLocation == -1
    },
    on: {
      "click": function($event) {
        _vm.showEditLocationModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "location-management-delete-button",
      "disabled": _vm.selectedLocation == -1
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteLocationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Locations_Update')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedLocationGuid
    },
    on: {
      "click": function($event) {
        _vm.showLocationDataTranslateModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0091) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_LocationsExport_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showLocationExportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("pin_drop")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0087) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_LocationsImport_Create') &&
    _vm.globals.isAccessAllowed('LoopOp_LocationsImport_Read')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showLocationImportDataModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_location")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.L0086) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.L0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "locationsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "locationsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0089))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ClientId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0077) + "\n                  "), (_vm.sortField == 'ClientId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ClientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0009) + "\n                  "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('ImporterName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0088) + "\n                  "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0010) + "\n                  "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0011) + "\n                  "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header",
    style: (("width:" + (_vm.feature.isAudiTarget && _vm.feature.isEnabled('audi_importers')
                    ? '29'
                    : '23') + "%;"))
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationAddress')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0012) + "\n                  "), (
    _vm.sortField == 'LocationAddress' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationAddress' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCity')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0013) + "\n                  "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationPostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0015) + "\n                  "), (
    _vm.sortField == 'LocationPostalCode' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationPostalCode' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0016) + "\n                  "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortLocationData('LocationStatusId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.L0019) + "\n                  "), (
    _vm.sortField == 'LocationStatusId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStatusId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientId),
      expression: "filterStrings.ClientId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ClientId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter",
    style: (("width:" + (_vm.feature.isAudiTarget && _vm.feature.isEnabled('audi_importers')
                    ? '29'
                    : '23') + "%;"))
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationPostalCode),
      expression: "filterStrings.LocationPostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationPostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStatusId),
      expression: "filterStrings.LocationStatusId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.L0020
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStatusId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getLocationData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStatusId", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.locationData), function(location) {
    return _c('tr', {
      key: location.LocationId,
      class: {
        info: location.LocationId == _vm.selectedLocation,
        'location-inactive': location.LocationStatusId === 'X',
        'location-temp-inactive': location.LocationStatusId === 'T',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedLocation = location.LocationId),
          (_vm.selectedLocationGuid = location.LocationGuid)
        },
        "dblclick": function($event) {
          _vm.globals.isAccessAllowed('LoopOp_Locations_Read') &&
            (_vm.showEditLocationModal = true)
        }
      }
    }, [(
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(location.ClientId) + "\n              ")]) : _vm._e(), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(location.ClientName) + "\n              ")]) : _c('td', [_vm._v(_vm._s(location.ImporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationStoreId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationName))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(location.LocationAddress) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationPostalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationCountry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(location.LocationStatusId))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteLocation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.L0060))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.L0061))])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0062))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.ClientName))])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0088))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.ImporterName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0063))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationStoreId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0064))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0065))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0066))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationCity))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0068))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationPostalCode))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0069))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationCountry))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.L0072))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.deleteLocationDialogData.LocationStatusId))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "location-management-delete-false-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.L0073) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "location-management-delete-true-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteLocationData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.L0074) + "\n          ")])])])])]), _vm._v(" "), _c('LocationImportDataModal', {
    attrs: {
      "showModal": _vm.showLocationImportDataModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationImportDataModal = false
      }
    }
  }), _vm._v(" "), _c('LocationExportModal', {
    attrs: {
      "showModal": _vm.showLocationExportModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationExportModal = false
      }
    }
  }), _vm._v(" "), _c('LocationManagementEditModal', {
    attrs: {
      "showModal": _vm.showEditLocationModal,
      "selectedLocation": _vm.selectedLocation,
      "lang": _vm.lang
    },
    on: {
      "modalClosed": function($event) {
        _vm.showEditLocationModal = false
      },
      "locationDataUpdated": _vm.onLocationDataUpdated
    }
  }), _vm._v(" "), _c('LocationDataTranslateModal', {
    attrs: {
      "showModal": _vm.showLocationDataTranslateModal,
      "selectedLocation": _vm.selectedLocationGuid,
      "selectedLocationId": _vm.selectedLocation
    },
    on: {
      "modalClosed": function($event) {
        _vm.showLocationDataTranslateModal = false
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gantt"
  })
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "recruitingMainPanel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-7",
    attrs: {
      "id": "mapContainer"
    }
  }, [_c('GoogleMaps', {
    ref: "recruitingGmaps",
    attrs: {
      "checkList": _vm.checkFilterResults.SurveyInstances,
      "shopperList": _vm.shopperFilterResults.Shoppers,
      "currentFilterObject": _vm.currentFilterObject
    },
    on: {
      "mapRadiusChanged": _vm.updateMapRadius,
      "markerInfoSelectButtonClicked": _vm.onCheckSelectionChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    attrs: {
      "id": "checkFilterContainer"
    }
  }, [_c('CheckFilter', {
    ref: "checkFilterRef",
    attrs: {
      "currentFilterObject": _vm.currentFilterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList,
      "regionList": _vm.regionList
    },
    on: {
      "checkDataChanged": _vm.onCheckDataChanged,
      "filterUpdate": _vm.updateCheckFilter,
      "requestLocationProperties": _vm.getLocationProperties
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    attrs: {
      "id": "shopperFilterContainer"
    }
  }, [_c('ShopperFilter', {
    ref: "shopperFilterRef",
    attrs: {
      "currentFilterObject": _vm.currentFilterObject,
      "locationPropertiesList": _vm.locationPropertiesList,
      "countryList": _vm.countryList,
      "regionList": _vm.regionList
    },
    on: {
      "shopperDataChanged": _vm.onShopperDataChanged,
      "filterUpdate": _vm.updateShopperFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 text-right",
    attrs: {
      "id": "buttonBarContainer"
    }
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default btn-grey pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilters()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.checkFilterResults.SurveyInstanceCount &&
        !_vm.shopperFilterResults.ShopperCount
    },
    on: {
      "click": function($event) {
        _vm.$refs.recruitingGmaps.showChecksOnMap(),
          _vm.$refs.recruitingGmaps.showShoppersOnMap()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isExportDisabled
    },
    on: {
      "click": function($event) {
        return _vm.exportResults()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.RC001) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "approvalWaveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.lang.AWS001) + " / " + _vm._s(_vm.lang.AWS002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "approval-wave-status-project-select",
      "placeholder": _vm.lang.AWS003,
      "allowClear": true,
      "afterChange": (_vm.selectedWave = '')
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projectsWaves), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select2', {
    ref: "waveSelect",
    staticClass: "form-control",
    attrs: {
      "id": "approval-wave-status-wave-select",
      "placeholder": _vm.lang.AWS004,
      "allowClear": true,
      "disabled": !_vm.selectedProject,
      "afterChange": _vm.getWaveStatus()
    },
    model: {
      value: (_vm.selectedWave),
      callback: function($$v) {
        _vm.selectedWave = $$v
      },
      expression: "selectedWave"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.availableWaves), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                " + _vm._s(wave.WaveName) + "\n              ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [(_vm.selectedWave && _vm.statusData.SurveyInstances) ? _c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(
    _vm.statusData.SurveyInstances &&
    _vm.statusData.SurveyInstances.Status
  ) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS005))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS006))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS007))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS008))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS009))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS010))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + "\n                          %\n                        ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS011))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS012))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Approvals.None * 100).toFixed(2)
  )) + "\n                          %\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS013))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Approvals.Open * 100).toFixed(2)
  )) + "\n                          %\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS014))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Approvals.Approved * 100).toFixed(2)
  )) + "\n                          %\n                        ")])])])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS015))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('tbody', [(_vm.statusData.Shopper.Gender) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS016))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS017) + ":")]), _vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Shopper.Gender.Male * 100).toFixed(
      2
    )
  )) + "\n                          %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS018) + ":")]), _vm._v("\n                          " + _vm._s(Number(
    (
      _vm.statusData.Shopper.Gender.Female * 100
    ).toFixed(2)
  )) + "\n                          %\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Age) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS019))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Age.Max) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS022) + ":")]), _vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Shopper.Age.Above65 * 100).toFixed(
      2
    )
  )) + "\n                          %\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Distance) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS023))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Min / 1000).toFixed(
    0
  )) + "\n                          km\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s((_vm.statusData.Shopper.Distance.Max / 1000).toFixed(
    0
  )) + "\n                          km\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Shopper.Car) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS024))]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS020) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Min) + "\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS021) + ":")]), _vm._v("\n                          " + _vm._s(_vm.statusData.Shopper.Car.YearOfBuild.Max) + "\n                        ")]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (_vm.statusData.Model) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.AWS025) + " (-|=|+)")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS026) + ":")]), _vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Model.Downgrade * 100).toFixed(2)
  )) + "\n                          %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS027) + ":")]), _vm._v("\n                          " + _vm._s(Number((_vm.statusData.Model.Match * 100).toFixed(2))) + "\n                          %\n                        ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.lang.AWS028) + ":")]), _vm._v("\n                          " + _vm._s(Number(
    (_vm.statusData.Model.Upgrade * 100).toFixed(2)
  )) + "\n                          %\n                        ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.AWS034) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "import-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.noErrors && _vm.selectedRowNumbers.length == 0
    },
    on: {
      "click": function($event) {
        return _vm.saveImportData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.noErrors
    },
    on: {
      "click": function($event) {
        return _vm.validateImportData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("redo")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.cancelLocationImport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0002) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "well col-md-2 well-counter"
  }, [_vm._v("\n        " + _vm._s(_vm.lang.I0033) + ": " + _vm._s(_vm.selectedRowNumbers.length) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0034) + ": " + _vm._s(_vm.serverResponse.Error_Counter) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0035) + ": " + _vm._s(_vm.serverResponse.Updated_Counter) + "\n        "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.I0036) + ": " + _vm._s(_vm.serverResponse.Inserted_Counter) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar color-error",
    on: {
      "click": function($event) {
        (_vm.errorFilterState = !_vm.errorFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.errorFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0003) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar color-new",
    on: {
      "click": function($event) {
        (_vm.newFilterState = !_vm.newFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.newFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar color-updated",
    on: {
      "click": function($event) {
        (_vm.updatedFilterState = !_vm.updatedFilterState), (_vm.selectedPage = 1)
      }
    }
  }, [(_vm.updatedFilterState) ? _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.I0005) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('a', {
    staticClass: "btn btn-raised color-info",
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "role": "button",
      "disabled": _vm.selectedRowNumbers.length == 0
    },
    on: {
      "click": function($event) {
        _vm.selectedRowNumbers = []
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.I0037))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0030))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0031))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.selectedPage == _vm.pageCount
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.I0032))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body table-responsive import-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('thead', [_c('tr', [(_vm.tableHeaders.length > 1) ? _vm._l((_vm.tableHeaders), function(header) {
    return _c('th', {
      key: header,
      staticClass: "text-center sticky-header"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.sortColumn = header), (_vm.sortOrderAsc = !_vm.sortOrderAsc)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(header) + "\n                  "), (_vm.sortColumn == header && _vm.sortOrderAsc) ? _c('span', {
      staticClass: "glyphicon glyphicon-triangle-top"
    }) : _vm._e(), _vm._v(" "), (_vm.sortColumn == header && !_vm.sortOrderAsc) ? _c('span', {
      staticClass: "glyphicon glyphicon-triangle-bottom"
    }) : _vm._e()])])
  }) : _c('th', [_vm._v(_vm._s(_vm.lang.I0038))])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.serverResponse.Locations), function(location, rowindex) {
    return _c('tr', {
      key: rowindex,
      class: {
        info: _vm.isRowSelected(rowindex),
        'color-error': _vm.rowContainsError(rowindex),
        'color-new': _vm.isRowNew(rowindex) && !_vm.rowContainsError(rowindex),
        'color-updated': _vm.isRowUpdated(rowindex) && !_vm.rowContainsError(rowindex),
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleRowSelected(rowindex)
        }
      }
    }, _vm._l((_vm.getVisibleLocationData(location)), function(value, column) {
      return _c('td', {
        key: column
      }, [(_vm.isErrorValue(rowindex, column)) ? _c('div', {
        staticClass: "form-group nopadding error-input"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.serverResponse.Locations[rowindex][column]),
          expression: "serverResponse.Locations[rowindex][column]"
        }],
        staticClass: "form-control text-center nopadding",
        attrs: {
          "type": "text",
          "readonly": "true",
          "onblur": "this.readOnly='true';",
          "ondblclick": "this.readOnly='';"
        },
        domProps: {
          "value": (_vm.serverResponse.Locations[rowindex][column])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.serverResponse.Locations[rowindex], column, $event.target.value)
          }
        }
      })]) : _c('div', [_vm._v(_vm._s(value))])])
    }), 0)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "feedbackModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.feedbackModalData.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.feedbackModalData.text)
    }
  }), _vm._v(" "), (_vm.feedbackModalData.type == 'YesNoCancelImport') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0006) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.discardImportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0007) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.feedbackModalData.type == 'okImportSuccessful') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exitImport()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0008) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.feedbackModalData.type == 'okNoAction') ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.I0008) + "\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkLocalAgencyAssignmentModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CLAA00))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CLAA01))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    ref: "selectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "id": "check-local-agency-assignment-select",
      "placeholder": _vm.lang.CLAA02,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedLocalAgency),
      callback: function($$v) {
        _vm.selectedLocalAgency = $$v
      },
      expression: "selectedLocalAgency"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                " + _vm._s(agency.AgencyName) + "\n              ")])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA03) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveAgencyAssignment()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CLAA04) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'changePasswordDialog' + _vm._uid,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(!_vm.userGuid ? _vm.lang.PW0014 : _vm.lang.PW0000))])]), _vm._v(" "), (_vm.userName) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.lang.PW0017) + ": " + _vm._s(_vm.userName))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [(!_vm.userGuid) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputOldPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.oldPassword),
      expression: "passwords.oldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputOldPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "oldPassword", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPassword' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPassword),
      expression: "passwords.newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPassword' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPassword", $event.target.value)
      }, function($event) {
        _vm.doCheckIfPasswordIsValid(), _vm.checkIfPasswordsMatch()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-bottom": "2px"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": 'inputNewPasswordRepeat' + _vm._uid
    }
  }, [_vm._v(_vm._s(_vm.lang.PW0002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords.newPasswordRepeat),
      expression: "passwords.newPasswordRepeat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": 'inputNewPasswordRepeat' + _vm._uid
    },
    domProps: {
      "value": (_vm.passwords.newPasswordRepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passwords, "newPasswordRepeat", $event.target.value)
      }, function($event) {
        return _vm.checkIfPasswordsMatch()
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "passwordPolicy"
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.PW0003))])]), _vm._v(" "), (_vm.passwordPolicy.length > 0) ? _c('table', {
    staticClass: "table table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.enoughCharacters) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[0].value) + "\n                  " + _vm._s(_vm.lang.PW0005) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasUpperCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[1].value) + "\n                  " + _vm._s(_vm.lang.PW0006) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasLowerCase) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[2].value) + "\n                  " + _vm._s(_vm.lang.PW0007) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNumbers) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[3].value) + "\n                  " + _vm._s(_vm.lang.PW0008) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordValidity.hasNonalphas) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.PW0004) + " " + _vm._s(_vm.passwordPolicy[4].value) + "\n                  " + _vm._s(_vm.lang.PW0009) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "nopadding width-20"
  }, [(!_vm.passwordsMatch) ? _c('i', {
    staticClass: "material-icons md-24 text-red"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons md-24 text-green"
  }, [_vm._v("done")])]), _vm._v(" "), _c('td', {
    staticClass: "width-80"
  }, [_vm._v(_vm._s(_vm.lang.PW0012))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.isPasswordValid || !_vm.passwordsMatch
    },
    on: {
      "click": function($event) {
        return _vm.checkIfNewPasswordPassed()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.PW0011) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "allowClear": true,
      "placeholder": ' ',
      "tags": _vm.AllowCustomValues,
      "disabled": _vm.readOnly,
      "afterChange": _vm.updateValue
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.ListValues), function(element) {
    return _c('option', {
      key: element.ValueGuid,
      domProps: {
        "value": element.ValueGuid
      }
    }, [_vm._v("\n        " + _vm._s(element.Value) + "\n      ")])
  }), 0)], 1)])
},staticRenderFns: []}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkPaymentModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CPM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    on: {
      "change": function($event) {
        _vm.paymentFormDirty = true
      }
    }
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionCheckPayment",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCheckPaymentGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionCheckPayment",
      "href": "#collapseCheckPaymentGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseCheckPaymentGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CPM001) + " (" + _vm._s(_vm.checkDataList.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseCheckPaymentGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingCheckPaymentGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12 text-red text-bold"
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CPM002) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "disabled": !_vm.globals.operationPermitted(
        'Entities.SurveyInstancePayment.AllowUpdate'
      )
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePayoutApprovedForAll()
      }
    }
  }, [(_vm.generalSettlementData.PayoutApproved === true) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettlementData.PayoutApproved === false
  ) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CPM003))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBasePaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputBasePaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('BasePayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.BasePayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "BasePayment", $$v)
      },
      expression: "generalSettlementData.BasePayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.BasePaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPlusPaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPlusPaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('PlusPayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.PlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "PlusPayment", $$v)
      },
      expression: "generalSettlementData.PlusPayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.PlusPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputMinusPaymentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputMinusPaymentAll",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    on: {
      "change": function($event) {
        _vm.writeToAllChecks('MinusPayment'),
          _vm.calcGeneralTotalPayment()
      }
    },
    model: {
      value: (_vm.generalSettlementData.MinusPayment),
      callback: function($$v) {
        _vm.$set(_vm.generalSettlementData, "MinusPayment", $$v)
      },
      expression: "generalSettlementData.MinusPayment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.MinusPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.TotalPayment,
    "EUR"
  )))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.TotalPaymentSum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM008))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 sum-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("functions")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.generalSettlementData.PurchaseMoneySum,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSettlementCommentAll"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettlementData.SettlementComment),
      expression: "generalSettlementData.SettlementComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text",
      "id": "inputSettlementCommentAll",
      "disabled": !_vm.generalSettlementData.EnableEditPayments
    },
    domProps: {
      "value": (_vm.generalSettlementData.SettlementComment)
    },
    on: {
      "change": function($event) {
        return _vm.writeToAllChecks('SettlementComment')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettlementData, "SettlementComment", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCheckPaymentSpecific",
      "data-toggle": "collapse",
      "data-parent": "#accordionCheckPayment",
      "href": "#collapseCheckPaymentSpecific",
      "aria-expanded": "false",
      "aria-controls": "collapseCheckPaymentSpecific"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CPM010))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCheckPaymentSpecific",
      "role": "tabpanel",
      "aria-labelledby": "headingCheckPaymentSpecific"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-2",
    attrs: {
      "id": "checkListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.lang.CPM011))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "check-list-table"
    }
  }, _vm._l((_vm.checkDataList), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.selectedCheck.SurveyInstanceId ===
          check.SurveyInstanceId,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCheck.SurveyInstanceId),
      expression: "selectedCheck.SurveyInstanceId"
    }],
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM012))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.ProjectName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.WaveName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM014))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v(_vm._s(_vm.selectedCheck.ScenarioName))])])]), _vm._v(" "), (_vm.selectedCheck.ShopperUsername) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left"
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCheck.ShopperFirstName) + "\n                        " + _vm._s(_vm.selectedCheck.ShopperLastName) + " (" + _vm._s(_vm.selectedCheck.ShopperUsername) + ")\n                        "), _c('span', {
    staticClass: "pull-right vat-mandatory-info"
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CPM016) + ":\n                          "), (_vm.selectedCheck.VatNotMandatory) ? _c('i', {
    staticClass: "material-icons text-red icon-vat-mandatory"
  }, [_vm._v("clear")]) : _c('i', {
    staticClass: "material-icons text-green icon-vat-mandatory"
  }, [_vm._v("done")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputBasePayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputBasePayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.BasePayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "BasePayment", $$v)
      },
      expression: "selectedCheck.BasePayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPlusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPlusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.PlusPayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "PlusPayment", $$v)
      },
      expression: "selectedCheck.PlusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputMinusPayment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM006))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputMinusPayment",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.MinusPayment),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "MinusPayment", $$v)
      },
      expression: "selectedCheck.MinusPayment"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.selectedCheck.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.selectedCheck.TotalPayment,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputPurchaseMoney"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM008))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('currency-input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputPurchaseMoney",
      "currency": "EUR",
      "min": 0,
      "locale": _vm.globals.currentLocale,
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    on: {
      "change": function($event) {
        return _vm.calcSpecificTotalPayment()
      }
    },
    model: {
      value: (_vm.selectedCheck.PurchaseMoney),
      callback: function($$v) {
        _vm.$set(_vm.selectedCheck, "PurchaseMoney", $$v)
      },
      expression: "selectedCheck.PurchaseMoney"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM017))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "form-control text-left",
    attrs: {
      "disabled": !_vm.selectedCheck.EnableEditPayments
    }
  }, [_vm._v(_vm._s(_vm.globals.getCurrencyString(
    _vm.selectedCheck.Payout,
    "EUR"
  )))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSettlementComment"
    }
  }, [_vm._v(_vm._s(_vm.lang.CPM009))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCheck.SettlementComment),
      expression: "selectedCheck.SettlementComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text",
      "id": "inputSettlementComment",
      "disabled": !_vm.selectedCheck.EnableEditPayments
    },
    domProps: {
      "value": (_vm.selectedCheck.SettlementComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedCheck, "SettlementComment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(_vm._s(_vm.lang.CPM018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedCheck.EnablePayoutApprovedChange ||
        !_vm.globals.operationPermitted(
          'Entities.SurveyInstancePayment.AllowUpdate'
        )
    },
    on: {
      "click": function($event) {
        _vm.selectedCheck.PayoutApproved = !_vm.selectedCheck.PayoutApproved
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedCheck.PayoutApproved ?
    _vm.lang.CPM019 :
    _vm.lang.CPM020) + "\n                      ")]), _vm._v(" "), (_vm.selectedCheck.PayoutApproved) ? _c('span', [(_vm.selectedCheck.PayoutApprovedAt) ? _c('span', [_vm._v(_vm._s(_vm.lang.CPM021) + ":\n                          " + _vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
    _vm.selectedCheck.PayoutApprovedAt
  )))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CPM022))])]) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.globals.operationPermitted('Entities.VatRate.AllowRead')) ? _c('button', {
    staticClass: "btn btn-raised pull-left edit-vat-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openEditVATModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM025) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM023) + "\n        ")]), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Entities.SurveyInstancePayment.AllowUpdate'
    )
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.paymentFormDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.savePaymentData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.CPM024) + "\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "height": "45px"
    }
  })])
}]}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    class: {
      'recruiting-panel': _vm.isRecruitingFilter
    }
  }, [(_vm.isRecruitingFilter) ? _c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("\n    " + _vm._s(_vm.lang.RCS000) + "\n    "), (typeof _vm.resultShopperData.ShopperCount === 'number') ? _c('span', {
    class: {
      'text-red': _vm.shopperCountExceeded
    },
    attrs: {
      "id": "shopperCounterContainer"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang.RCS001) + ": " + _vm._s(_vm.resultShopperData.ShopperCount))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shopperCountExceeded),
      expression: "shopperCountExceeded"
    }],
    staticClass: "material-icons md-24"
  }, [_vm._v("warning")])]) : _vm._e(), _vm._v(" "), (_vm.shopperCountExceeded) ? _c('b-tooltip', {
    attrs: {
      "target": "shopperCounterContainer",
      "delay": _vm.globals.tooltipDelay,
      "boundary": "viewport",
      "placement": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS030))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "filter-border col-md-12"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    attrs: {
      "id": "inputShopperFilterNotSameLocationFormGroup"
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notSameLocation),
      expression: "notSameLocation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputShopperFilterNotSameLocation",
      "disabled": _vm.notWithLocationPropertyGuids.length > 0
    },
    domProps: {
      "checked": Array.isArray(_vm.notSameLocation) ? _vm._i(_vm.notSameLocation, null) > -1 : (_vm.notSameLocation)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.notSameLocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.notSameLocation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.notSameLocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.notSameLocation = $$c
        }
      }, function($event) {
        return _vm.getShopperFilterResult()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.RCS002) + ":")])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "inputShopperFilterNotSameLocationFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS003))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespanValueFormGroup"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.notWithinTimespanValue),
      expression: "notWithinTimespanValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputShopperFilterNotWithinTimespanValue",
      "step": "1",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.notWithinTimespanValue)
    },
    on: {
      "change": function($event) {
        _vm.validateTimespanValue(), _vm.getShopperFilterResult()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notWithinTimespanValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespanFormGroup"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notWithinTimespan),
      expression: "notWithinTimespan"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputShopperFilterNotWithinTimespan"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.notWithinTimespan = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getShopperFilterResult()
      }]
    }
  }, _vm._l((_vm.timespans), function(span, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": span
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getTranslationFor(span)) + "\n          ")])
  }), 0)]), _vm._v(" "), (_vm.locationPropertiesList.length > 0) ? _c('div', {
    staticClass: "form-group col-md-12",
    attrs: {
      "id": "inputShopperFilterNotWithinLocationPropertiesFormGroup"
    }
  }, [_c('select2', {
    attrs: {
      "id": "inputShopperFilterNotWithinLocationProperties",
      "placeholder": _vm.lang.RCS004,
      "allowClear": true,
      "multiple": true,
      "afterChange": function () {
        _vm.notSameLocation = true;
        _vm.getShopperFilterResult();
      }
    },
    model: {
      value: (_vm.notWithLocationPropertyGuids),
      callback: function($$v) {
        _vm.notWithLocationPropertyGuids = $$v
      },
      expression: "notWithLocationPropertyGuids"
    }
  }, _vm._l((_vm.locationPropertiesList), function(prop) {
    return _c('option', {
      key: prop.LocationPropertyGuid,
      domProps: {
        "value": prop.LocationPropertyGuid
      }
    }, [_vm._v("\n            " + _vm._s(prop.LocationPropertyName) + "\n          ")])
  }), 0), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "inputShopperFilterNotWithinLocationPropertiesFormGroup",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS005))])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.dynamicFilters), function(filter, index) {
    return _c('div', {
      key: filter.Guid,
      staticClass: "form-group form-group-dynamic"
    }, [_c('div', {
      staticClass: "form-group col-md-3",
      attrs: {
        "id": ("selectShopperFilterDynamicTypeFormGroup" + (filter.Guid))
      }
    }, [_c('select2', {
      ref: ("filterTypeSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("selectShopperFilterDynamicType" + (filter.Guid)),
        "name": "selectFilterType",
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": false,
        "afterChange": function (t) {
          _vm.filterTypeChanged(t, filter);
        }
      },
      model: {
        value: (filter.Type),
        callback: function($$v) {
          _vm.$set(filter, "Type", $$v)
        },
        expression: "filter.Type"
      }
    }, _vm._l((_vm.filterTypes), function(type, idx) {
      return _c('option', {
        key: idx,
        attrs: {
          "disabled": !_vm.isTypeEnabled(type, filter)
        },
        domProps: {
          "value": type
        }
      }, [_vm._v("\n            " + _vm._s(_vm.getTranslationFor(type)) + "\n          ")])
    }), 0), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicTypeFormGroup" + (filter.Guid)),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCS007))])], 1), _vm._v(" "), (
      filter.Type === 'Region' &&
      filter.currentDynamicFilterValues &&
      filter.currentDynamicFilterValues.length < 1
    ) ? _c('span', {
      staticClass: "vertical-center"
    }, [_vm._v(_vm._s(_vm.lang.RCS033))]) : _vm._e(), _vm._v(" "), (
      filter.Type === 'ShopperMinChecks' && filter.secondLevelRangeVisible
    ) ? _c('div', {
      staticClass: "form-group col-md-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (filter.Value),
        expression: "filter.Value",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "100",
        "placeholder": _vm.lang.RCS034
      },
      domProps: {
        "value": (filter.Value)
      },
      on: {
        "change": function($event) {
          return _vm.filterValueChanged(filter.Value, filter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter, "Value", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (filter.Type === 'Age' && filter.secondLevelRangeVisible) ? _c('div', {
      staticClass: "form-group col-md-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (filter.Value.From),
        expression: "filter.Value.From",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "100",
        "placeholder": _vm.lang.RCS022,
        "id": 'AgeFrom'
      },
      domProps: {
        "value": (filter.Value.From)
      },
      on: {
        "change": function($event) {
          return _vm.filterValueChanged(_vm.v, filter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter.Value, "From", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e(), _vm._v(" "), (filter.Type === 'Age' && filter.secondLevelRangeVisible) ? _c('div', {
      staticClass: "form-group col-md-4"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (filter.Value.To),
        expression: "filter.Value.To",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "1",
        "min": "0",
        "max": "100",
        "placeholder": _vm.lang.RCS023,
        "id": 'AgeTo'
      },
      domProps: {
        "value": (filter.Value.To)
      },
      on: {
        "change": function($event) {
          return _vm.filterValueChanged(_vm.v, filter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter.Value, "To", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : (
      filter.Type !== 'Age' &&
      filter.Type !== 'ShopperMinChecks' &&
      !this.isVueSelect &&
      !this.isInputNumber &&
      !filter.secondLevelRangeVisible
    ) ? _c('div', [_c('div', {
      staticClass: "form-group col-md-8",
      attrs: {
        "id": ("selectShopperFilterDynamicValueFormGroup" + (filter.Guid))
      }
    }, [(
      filter.Type !== 'Age' &&
      filter.Type !== 'ShopperMinChecks' &&
      !this.isVueSelect &&
      !this.isInputNumber
    ) ? _c('select2', {
      key: filter.Type,
      ref: ("secondLevelSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("selectShopperFilterDynamicValue-" + index),
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": filter.Type !== 'ShopperProperty',
        "multiple": filter.Type !== 'ShopperProperty',
        "tags": filter.Type === 'City' ||
          filter.Type === 'PostalCode' ||
          filter.Type === 'ShopperMinChecks' ||
          filter.Type === 'Age',
        "noResultsString": filter.Type === 'City' ||
          filter.Type === 'PostalCode' ||
          filter.Type === 'ShopperMinChecks' ||
          filter.Type === 'Age' ?
          _vm.lang.RCS018 :
          undefined,
        "afterChange": function (v) {
          _vm.filterValueChanged(v, filter);
        }
      },
      model: {
        value: (filter.Value),
        callback: function($$v) {
          _vm.$set(filter, "Value", $$v)
        },
        expression: "filter.Value"
      }
    }, [(filter.Type === 'Country' || filter.Type === 'Gender') ? _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Code")],
        domProps: {
          "value": value[((filter.Type) + "Code")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    }) : (filter.Type === 'ShopperProperty') ? _vm._l((filter.currentDynamicFilterValues), function(topic) {
      return _c('optgroup', {
        key: topic[((filter.Type) + "Guid")],
        attrs: {
          "label": topic[((filter.Type) + "Name")]
        }
      }, _vm._l((topic.ChildProperties), function(property) {
        return _c('option', {
          key: property[((filter.Type) + "Guid")],
          attrs: {
            "disabled": _vm.propertyAlreadyUsed(property[((filter.Type) + "Guid")])
          },
          domProps: {
            "value": property[((filter.Type) + "Guid")]
          }
        }, [_vm._v("\n                  " + _vm._s(property[((filter.Type) + "Name")]) + "\n                  "), (property.GroupTitle) ? _c('span', [_vm._v("(" + _vm._s(property.GroupTitle) + ")")]) : _vm._e()])
      }), 0)
    }) : (
      filter.currentDynamicFilterValues &&
      filter.currentDynamicFilterValues.length > 0
    ) ? _vm._l((filter.currentDynamicFilterValues), function(value) {
      return _c('option', {
        key: value[((filter.Type) + "Guid")],
        domProps: {
          "value": value[((filter.Type) + "Guid")]
        }
      }, [_vm._v("\n                " + _vm._s(value[((filter.Type) + "Name")]) + "\n              ")])
    }) : _vm._l((filter.Value), function(value) {
      return _c('option', {
        key: value,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      (filter.Type === 'City' || filter.Type === 'PostalCode') &&
      this.isVueSelect &&
      !this.isInputNumber &&
      filter.Type !== 'ShopperMinChecks' &&
      filter.Type !== 'Age'
    ) ? _c('div', {
      staticClass: "form-group col-md-8"
    }, [_c('vueSelect', {
      attrs: {
        "v-if": !filter.updating &&
          filter.Type !== 'ShopperMinChecks' &&
          filter.Type !== 'Age',
        "value": filter.Value,
        "taggable": true,
        "multiple": true,
        "noDrop": true,
        "clearable": true,
        "placeholder": ((_vm.lang.RCS006) + "...")
      },
      on: {
        "input": function (v) {
          _vm.vueSelectFilterChanged(v, filter);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicValueFormGroup-" + index),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.getTranslationFor(filter.Type)))])], 1)]) : _vm._e(), _vm._v(" "), (filter.thirdLevelInputVisible) ? _c('div', {
      staticClass: "form-group col-md-11",
      attrs: {
        "id": ("selectShopperFilterDynamicValueValuesFormGroup" + (filter.Guid))
      }
    }, [(
      filter.thirdLevelInputType === 'SingleSelect' ||
      filter.thirdLevelInputType === 'MultiSelect'
    ) ? _c('select2', {
      ref: ("thirdLevelSelect" + (filter.Guid)),
      refInFor: true,
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + (filter.Guid)),
        "placeholder": ((_vm.lang.RCS006) + "..."),
        "allowClear": true,
        "multiple": filter.thirdLevelInputType === 'MultiSelect',
        "tags": true,
        "afterChange": function (s) {
          _vm.filterSubvalueChanged(s, filter);
        }
      },
      model: {
        value: (filter.Subvalue),
        callback: function($$v) {
          _vm.$set(filter, "Subvalue", $$v)
        },
        expression: "filter.Subvalue"
      }
    }, _vm._l((filter.currentDynamicFilterValueValues), function(value) {
      return _c('option', {
        key: value["ListValueGuid"],
        domProps: {
          "value": value["ListValueGuid"]
        }
      }, [_vm._v("\n            " + _vm._s(value.IsNoAnswer ? ("[" + (_vm.lang.RCS031) + "]") : value["ListValue"]) + "\n          ")])
    }), 0) : (filter.thirdLevelInputType === 'Checkbox') ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('span', [_vm._v(_vm._s(_vm.lang.RCS008) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("inputShopperFilterDynamicValueValues" + (filter.Guid))
      },
      domProps: {
        "value": filter.Subvalue,
        "checked": Array.isArray(filter.Subvalue) ? _vm._i(filter.Subvalue, filter.Subvalue) > -1 : (filter.Subvalue)
      },
      on: {
        "change": [function($event) {
          var $$a = filter.Subvalue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = filter.Subvalue,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(filter, "Subvalue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(filter, "Subvalue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(filter, "Subvalue", $$c)
          }
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "checkbox-material"
    }, [_c('span', {
      staticClass: "check"
    })])])]) : (
      filter.thirdLevelInputType === 'Text' ||
      filter.thirdLevelInputType === 'Integer'
    ) ? _c('div', [((filter.thirdLevelInputType === 'Text' ? 'text' : 'number') === 'checkbox') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + (filter.Guid)),
        "step": "1",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(filter.Subvalue) ? _vm._i(filter.Subvalue, null) > -1 : (filter.Subvalue)
      },
      on: {
        "change": [function($event) {
          var $$a = filter.Subvalue,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(filter, "Subvalue", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(filter, "Subvalue", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(filter, "Subvalue", $$c)
          }
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }) : ((filter.thirdLevelInputType === 'Text' ? 'text' : 'number') === 'radio') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + (filter.Guid)),
        "step": "1",
        "type": "radio"
      },
      domProps: {
        "checked": _vm._q(filter.Subvalue, null)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(filter, "Subvalue", null)
        }, function($event) {
          return _vm.getShopperFilterResult()
        }]
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (filter.Subvalue),
        expression: "filter.Subvalue"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("inputShopperFilterDynamicValueValues" + (filter.Guid)),
        "step": "1",
        "type": filter.thirdLevelInputType === 'Text' ? 'text' : 'number'
      },
      domProps: {
        "value": (filter.Subvalue)
      },
      on: {
        "change": function($event) {
          return _vm.getShopperFilterResult()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(filter, "Subvalue", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("selectShopperFilterDynamicValueValuesFormGroup" + (filter.Guid)),
        "boundary": "viewport",
        "triggers": "hover",
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.RCS009))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 pull-right",
      class: {
        'centerized-remove-button': filter.thirdLevelInputVisible
      }
    }, [_c('button', {
      staticClass: "btn btn-remove-filter",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeDynamicFilter(filter)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fab btn-fab-mini btn-default btn-add-filter",
    attrs: {
      "type": "button",
      "id": "addDynamicFilterButton",
      "disabled": _vm.isLastDynamicFilterEmpty()
    },
    on: {
      "click": function($event) {
        return _vm.addDynamicFilter()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36 text-green"
  }, [_vm._v("add")])]), _vm._v(" "), (!_vm.isLastDynamicFilterEmpty()) ? _c('b-tooltip', {
    attrs: {
      "target": "addDynamicFilterButton",
      "boundary": "viewport",
      "triggers": "hover",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.RCS010))]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editSurveyForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.surveyData.SurveyId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.surveyData.SurveyId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showSurveyHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showSurveyHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showSurveyHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U1087))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditSurvey",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditSurveyGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U0015))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditSurveyGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0016) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.surveyData.ClientGuid,
    ref: "editSurveyClientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyClientSelect",
      "name": "editSurveyClientSelect",
      "afterChange": _vm.getSurveyGroupList,
      "placeholder": _vm.lang.U1000,
      "allowClear": _vm.dialogModeAdd,
      "disabled": !_vm.dialogModeAdd && !_vm.copySurvey,
      "required": ""
    },
    model: {
      value: (_vm.surveyData.ClientGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ClientGuid", $$v)
      },
      expression: "surveyData.ClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: 'option_' + client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0)], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1075))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    ref: "editSurveyImporterSelect",
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyImporterSelect",
      "afterChange": _vm.getSurveyGroupList,
      "placeholder": _vm.lang.U1000,
      "allowClear": true
    },
    model: {
      value: (_vm.surveyData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ImporterGuid", $$v)
      },
      expression: "surveyData.ImporterGuid"
    }
  }, _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0017) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle),
      expression: "surveyData.SurveyTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle",
      "name": "inputTitle",
      "required": ""
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputTitle')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTitle')),
      expression: "inputHasError('inputTitle')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.U0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle2"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle2),
      expression: "surveyData.SurveyTitle2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle2"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle3"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle3),
      expression: "surveyData.SurveyTitle3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle3"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectSurveySkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.surveyData.SurveySkillLevel),
      expression: "surveyData.SurveySkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveySkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.surveyData, "SurveySkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveySkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                      1 → " + _vm._s(_vm.lang.U0041) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      5 → " + _vm._s(_vm.lang.U0042) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyActive"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyActive),
      expression: "surveyData.SurveyActive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputSurveyActive"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.SurveyActive) ? _vm._i(_vm.surveyData.SurveyActive, null) > -1 : (_vm.surveyData.SurveyActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCXSurvey"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.CXSurvey),
      expression: "surveyData.CXSurvey"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "id": "inputCXSurvey"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.CXSurvey) ? _vm._i(_vm.surveyData.CXSurvey, null) > -1 : (_vm.surveyData.CXSurvey)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.CXSurvey,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "CXSurvey", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "CXSurvey", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "CXSurvey", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), (_vm.surveyData.CXSurvey) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCXSurveyExploration"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1088))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.CXExploration),
      expression: "surveyData.CXExploration"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputCXSurveyExploration"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.CXExploration) ? _vm._i(_vm.surveyData.CXExploration, null) > -1 : (_vm.surveyData.CXExploration)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.CXExploration,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "CXExploration", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "CXExploration", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "CXExploration", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyShowHistoryCounter"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1092))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.surveyData.SurveyShowHistoryCounter),
      expression: "surveyData.SurveyShowHistoryCounter",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "id": "inputSurveyShowHistoryCounter"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyShowHistoryCounter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyShowHistoryCounter", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "inputSurveyShowHistoryCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("0 = disabled")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyVisibility",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyVisibility",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyVisibility"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyVisibility",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyVisibility"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "tab-content col-xs-12"
  }, [_c('div', {
    staticClass: "tab-pane tab-content-visibility active in",
    attrs: {
      "id": "visibilitySettingsTabContent"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "black",
      "padding-top": "15px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVisibilitySettings.headerText) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllVisibilityGroups()
      }
    }
  }, [(
    _vm.currentVisibilitySettings.selectedGroups.length ==
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.currentVisibilitySettings.selectedGroups.length ==
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), (
    _vm.currentVisibilitySettings.selectedGroups.length !=
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.U1032))]) : _c('span', [_vm._v(_vm._s(_vm.lang.U1033))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-content-visibility"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('tbody', _vm._l((_vm.surveyGroupList), function(group, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "padding": "4px",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.currentVisibilitySettings.selectedGroups
        ),
        expression: "\n                                      currentVisibilitySettings.selectedGroups\n                                    "
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_visibilitygroups_' + key
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(
          _vm.currentVisibilitySettings.selectedGroups
        ) ? _vm._i(
          _vm.currentVisibilitySettings.selectedGroups, key) > -1 : (
          _vm.currentVisibilitySettings.selectedGroups
        )
      },
      on: {
        "change": function($event) {
          var $$a =
            _vm.currentVisibilitySettings.selectedGroups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(3, true)])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px",
        "padding": "6px",
        "width": "80%"
      }
    }, [_c('label', {
      staticClass: "text-black nopadding",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "role": "button",
        "for": 'cb_visibilitygroups_' + key
      }
    }, [_vm._v(_vm._s(group))])])])
  }), 0)])])])])]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyLocalization",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyLocalization",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyLocalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyLocalization",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyLocalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    key: _vm.surveyData.ClientGuid,
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguage",
      "afterChange": _vm.getLocales,
      "placeholder": _vm.lang.U1067,
      "allowClear": true
    },
    model: {
      value: (_vm.newSurveyLanguage),
      callback: function($$v) {
        _vm.newSurveyLanguage = $$v
      },
      expression: "newSurveyLanguage"
    }
  }, _vm._l((_vm.languageList), function(language, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                            " + _vm._s(language) + "\n                          ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguageLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1059))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    key: _vm.newSurveyLanguage,
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguageLocale",
      "placeholder": _vm.lang.U1068,
      "allowClear": true,
      "disabled": !_vm.newSurveyLanguage ||
        _vm.languageLocaleList.length < 1
    },
    model: {
      value: (_vm.newSurveyLanguageLocale),
      callback: function($$v) {
        _vm.newSurveyLanguageLocale = $$v
      },
      expression: "newSurveyLanguageLocale"
    }
  }, _vm._l((_vm.languageLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.CountryCode
      }
    }, [_vm._v("\n                            " + _vm._s(locale.CountryName) + "\n                          ")])
  }), 0)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "addNewSurveyLanguage",
      "type": "button",
      "disabled": !_vm.newSurveyLanguageLocale
    },
    on: {
      "click": function($event) {
        return _vm.addNewSurveyLanguage()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.U1019) + "\n                      ")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1020) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1069) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1021) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveyData.SurveySelectedLanguages), function(lang, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v("\n                          " + _vm._s(_vm.getLocaleString(
      lang.LanguageCode,
      lang.CountryCode
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('div', {
      staticClass: "radio",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "rd_defaultRepLanguage",
        "id": 'rd_defaultRepLanguage_' + key
      },
      domProps: {
        "value": key,
        "checked": lang.IsDefault
      },
      on: {
        "change": function($event) {
          return _vm.setDefaultSurveyLanguage(key)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedLanguage(
            lang.LanguageCode,
            lang.CountryCode
          )
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyAttachment",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyAttachment",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyAttachment"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1022))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyAttachment",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyAttachment"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAttachmentName"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      ),
      expression: "\n                          surveyData.SurveyAttachments[0].DownloadDescription\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAttachmentName"
    },
    domProps: {
      "value": (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData.SurveyAttachments[0], "DownloadDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    !_vm.surveyData.SurveyAttachments[0].DownloadFileName
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1025))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyAttachments[0].DownloadFileName))]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(
          _vm.surveyData.SurveyAttachments[0].DownloadId
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyAttachmentFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyOthers",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyOthers",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyOthers"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1026))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyOthers",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyOthers"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyLogoFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyLogoFile",
      "type": "file",
      "accept": ".jpg, .jpeg, .png, .bmp",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyLogoFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.surveyData.SurveyLogoFileName) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1028))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyLogoFileName))]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "id": "showSurveyLogoButton",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(_vm.surveyData.SurveyLogoId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyLogoFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])]), _vm._v(" "), (_vm.surveyData.SurveyLogoId) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputSurveyLogoFile",
      "delay": _vm.globals.tooltipDelay,
      "placement": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": '/api/Download/' + _vm.surveyData.SurveyLogoId,
      "height": "200"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputMinimumAttachments"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyMinimumAttachments),
      expression: "surveyData.SurveyMinimumAttachments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputMinimumAttachments",
      "min": "0",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyMinimumAttachments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyMinimumAttachments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox col-md-3"
  }, [_c('label', {
    staticClass: "pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyShowAttachmentsPage),
      expression: "surveyData.SurveyShowAttachmentsPage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.SurveyShowAttachmentsPage) ? _vm._i(_vm.surveyData.SurveyShowAttachmentsPage, null) > -1 : (_vm.surveyData.SurveyShowAttachmentsPage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyShowAttachmentsPage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(6), _vm._v("\n                        " + _vm._s(_vm.lang.U1074) + "\n                      ")])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U0021))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0022) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "survey-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editSurveyDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0023) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "CustomPropertiesFormGenerator"
    }
  }, _vm._l((_vm.propertiesFormSchema), function(property) {
    return _c('div', {
      key: property.Guid
    }, [(property.ChildProperties) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('h4', {
      staticClass: "propertyThemeTitle"
    }, [_vm._v(_vm._s(property.Title))])]) : _vm._e(), _vm._v(" "), (property.ChildProperties) ? _vm._l((property.ChildProperties), function(childProperty) {
      return _c('div', {
        key: childProperty.Guid
      }, [(
        childProperty.Type === 'Group' && childProperty.ChildProperties
      ) ? _c('h5', {
        staticClass: "propertyGroupTitle"
      }, [_vm._v("\n          " + _vm._s(childProperty.Title) + "\n          "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (
            childProperty.Dynamic &&
            childProperty.ChildProperties &&
            childProperty.ChildProperties[0]
          ),
          expression: "\n              childProperty.Dynamic &&\n              childProperty.ChildProperties &&\n              childProperty.ChildProperties[0]\n            "
        }],
        staticClass: "btn btn-default btn-fab btn-fab-mini",
        attrs: {
          "disabled": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.addDynamicGroup(childProperty)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons text-green"
      }, [_vm._v("add")])])]) : _vm._e(), _vm._v(" "), (childProperty.Dynamic && childProperty.ValueGroups) ? _vm._l((childProperty.ValueGroups), function(valueGroup) {
        return _c('div', {
          key: valueGroup.ValueGroupGuid,
          staticClass: "col-md-12"
        }, [_c('div', {
          staticClass: "dynamicGroupBorder"
        }, [_vm._l((childProperty.ChildProperties), function(property) {
          return _c('div', {
            key: property.Guid,
            staticClass: "col-md-11"
          }, [_c(((property.PropertyType) + "Input"), _vm._b({
            tag: "component",
            attrs: {
              "value": _vm.getShopperValues(property, valueGroup),
              "readOnly": !_vm.globals.isAccessAllowed(
                'LoopOp_ShopperProperties_Shopper_Update'
              )
            },
            on: {
              "input": function($event) {
                return _vm.updateShopperValues(property, valueGroup, $event)
              }
            }
          }, 'component', property, false))], 1)
        }), _vm._v(" "), _c('div', [_c('button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (childProperty.Dynamic),
            expression: "childProperty.Dynamic"
          }],
          staticClass: "btn btn-default btn-fab btn-fab-mini btn-clear",
          attrs: {
            "disabled": !_vm.globals.isAccessAllowed(
              'LoopOp_ShopperProperties_Shopper_Update'
            )
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeDynamicGroup(
                childProperty,
                valueGroup.ValueGroupGuid
              )
            }
          }
        }, [_c('i', {
          staticClass: "material-icons text-red"
        }, [_vm._v("clear")])])])], 2)])
      }) : (childProperty.Type === 'Property') ? [_c('div', {
        staticClass: "col-md-12 nonDynamicGroup"
      }, [_c(((childProperty.PropertyType) + "Input"), _vm._b({
        tag: "component",
        attrs: {
          "value": _vm.getShopperValues(childProperty, null),
          "readOnly": !_vm.globals.isAccessAllowed(
            'LoopOp_ShopperProperties_Shopper_Update'
          )
        },
        on: {
          "input": function($event) {
            return _vm.updateShopperValues(childProperty, null, $event)
          }
        }
      }, 'component', childProperty, false))], 1)] : _vm._e()], 2)
    }) : _vm._e()], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyId')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2000) + "\n            "), (_vm.showSortArrow('AgencyId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyName')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2001) + "\n            "), (_vm.showSortArrow('AgencyName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2002) + "\n            "), (_vm.showSortArrow('AgencyAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyAddress2')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2007) + "\n            "), (_vm.showSortArrow('AgencyAddress2', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyAddress2', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCity')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2003) + "\n            "), (_vm.showSortArrow('AgencyCity', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCity', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyState_Region')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2004) + "\n            "), (_vm.showSortArrow('AgencyState_Region', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyState_Region', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyPostalCode')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2005) + "\n            "), (_vm.showSortArrow('AgencyPostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyPostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencyCountry')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2006) + "\n            "), (_vm.showSortArrow('AgencyCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencyCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableCell('AgencySinceDate')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.AM2008) + "\n            "), (_vm.showSortArrow('AgencySinceDate', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('AgencySinceDate', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pagedAgencies), function(agency) {
    return _c('tr', {
      key: agency.AgencyId,
      class: {
        info: agency.AgencyGuid === _vm.selectedAgency.AgencyGuid,
        'text-bold': agency.AgencyTypeName === 'Lead',
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectAgency(agency)
        },
        "dblclick": function($event) {
          return _vm.openEditAgency(agency)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(agency.AgencyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyAddress2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.RegionCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyPostalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencyCountry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agency.AgencySince))])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
    !(
      _vm.feature.isAudiTarget &&
      (_vm.globals.isLeadAgencyUser || _vm.globals.isAudiUser)
    )
  ) ? _c('div', {
    attrs: {
      "id": "shoppermanagement"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "shoppermanagement-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getShoppersList()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.editShopperDialogModeAdd = true),
        (_vm.selectedShopper = {}),
        _vm.openEditShopperDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        (_vm.editShopperDialogModeAdd = false), _vm.openEditShopperDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Shopper_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "shopper-management-delete-button",
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteShopperConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0017) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword') &&
    !_vm.globals.isAgencyUser
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isShopperSelected()
    },
    on: {
      "click": function($event) {
        return _vm.openChangePasswordDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0018) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_ShopperProperties_ReadAll') &&
    !_vm.globals.isAgencyUser
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openCustomPropertyDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0003) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openShopperExportConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0020) + "\n        ")]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_ShopperSurveyInstances_ReadAll'
    ) && !_vm.feature.isAudiTarget
  ) ? _c('router-link', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "tag": "button",
      "disabled": !_vm.isShopperSelected(),
      "to": ("shoppermanagement/checks?selectedShopperGuid=" + (_vm.selectedShopper.ShopperGuid))
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("list")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM0025) + "\n        ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SM0004
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0005))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0006))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "shoppersTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "shoppersTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM0035))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Username')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0010) + "\n                  "), (_vm.showSortArrow('Username', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Username', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('FirstName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0008) + "\n                  "), (_vm.showSortArrow('FirstName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('FirstName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LastName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0009) + "\n                  "), (_vm.showSortArrow('LastName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LastName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Gender')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0011) + "\n                  "), (_vm.showSortArrow('Gender', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Gender', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('PostalCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0012) + "\n                  "), (_vm.showSortArrow('PostalCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('PostalCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('City')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0013) + "\n                  "), (_vm.showSortArrow('City', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('City', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('CountryCode')
      }
    }
  }, [_vm._v("\n                  Land\n                  "), (_vm.showSortArrow('CountryCode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('CountryCode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Email')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0014) + "\n                  "), (_vm.showSortArrow('Email', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Email', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Age')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0015) + "\n                  "), (_vm.showSortArrow('Age', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Age', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('NumberOfChecks')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0016) + "\n                  "), (_vm.showSortArrow('NumberOfChecks', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('NumberOfChecks', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Active')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM0034) + "\n                  "), (_vm.showSortArrow('Active', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Active', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Username),
      expression: "filterStrings.Username"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Username", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.FirstName),
      expression: "filterStrings.FirstName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.FirstName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "FirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LastName),
      expression: "filterStrings.LastName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.LastName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.PostalCode),
      expression: "filterStrings.PostalCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.PostalCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "PostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.City),
      expression: "filterStrings.City"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.City)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "City", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CountryCode),
      expression: "filterStrings.CountryCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.CountryCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CountryCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Email),
      expression: "filterStrings.Email"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Age),
      expression: "filterStrings.Age"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.Age)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Age", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.NumberOfChecks),
      expression: "filterStrings.NumberOfChecks"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM0019
    },
    domProps: {
      "value": (_vm.filterStrings.NumberOfChecks)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getShoppersList()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "NumberOfChecks", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateActiveFilter(), _vm.getShoppersList()
      }
    }
  }, [(_vm.filterStrings.Active === 'true') ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.Active === 'false') ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shoppersList), function(shopper) {
    return _c('tr', {
      key: shopper.ShopperGuid,
      class: {
        info: shopper.ShopperGuid === _vm.selectedShopper.ShopperGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedShopper = shopper
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_Shopper_Read') ||
            ((_vm.editShopperDialogModeAdd = false),
              _vm.openEditShopperDialog())
        }
      }
    }, [_c('td', [_vm._v(_vm._s(shopper.Username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.FirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.LastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.Gender))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.PostalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.City))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.CountryCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.Email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.Age))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shopper.NumberOfChecks))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "6px 0 0 0"
      }
    }, [(shopper.Active) ? _c('i', {
      staticClass: "material-icons md-24 text-green"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])
  }), 0)])])])]), _vm._v(" "), _c('shopper-edit-modal', {
    attrs: {
      "showDialog": _vm.showEditShopperDataDialog,
      "occupationalGroupList": _vm.occupationalGroupList,
      "dialogModeAdd": _vm.editShopperDialogModeAdd,
      "selectedShopperGuid": _vm.selectedShopper.ShopperGuid
    },
    on: {
      "dialogClosed": _vm.onEditShopperDataClosed,
      "dialogDataSaved": _vm.onEditShopperDialogDataSaved
    }
  }), _vm._v(" "), _c('custom-property-edit-modal', {
    attrs: {
      "showDialog": _vm.showCustomPropertyEditDialog
    },
    on: {
      "dialogClosed": _vm.onCustomPropertyDialogClosed
    }
  }), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog,
      "userGuid": _vm.selectedShopper.ShopperGuid,
      "userName": _vm.selectedShopper.Username
    },
    on: {
      "dialogClosed": _vm.onChangePasswordDialogClosed
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') &&
    _vm.globals.currentUserRole < 3
  ) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getCheckData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0000) + "\n        ")]), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Entities.SurveyInstance.AllowCreate'
    ) &&
    _vm.globals.operationPermitted(
      'Entities.SurveyInstanceLocation.AllowRead'
    ) &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedChecks = []),
        (_vm.selectedCheckIds = []),
        (_vm.showAddChecksDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesProperties_Update'
    ) &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesProperties_Create'
    ) &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-edit-button",
      "disabled": _vm.includeChecks ?
        _vm.selectedCheckIds.length == 0 :
        _vm.selectedCheckIds.length == _vm.checkCount
    },
    on: {
      "click": function($event) {
        _vm.showEditChecksDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Entities.SurveyInstancePayment.AllowRead'
    ) && !_vm.feature.isAudiTarget
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCheckPaymentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0061) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Entities.SurveyInstance.AllowDelete'
    ) &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser) &&
    false
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-delete-button",
      "disabled": _vm.isDeleteDisabled
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteChecksDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-assign-agency-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0075) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isCheckImportTester()) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showCheckImportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_upload")]), _vm._v(" "), _c('br'), _vm._v("\n          IMPORT\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-copy-check-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.cloneSelectedChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0076) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.operationPermitted('Functions.SurveyInstanceExport.Allow')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showExportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("get_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0004) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length < 1 || _vm.globals.isAgencyUser
    },
    on: {
      "click": function($event) {
        return _vm.showAutovalidationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("Autovalidate\n        ")]), _vm._v(" "), (
    !_vm.globals.isAudiUser &&
    _vm.globals.operationPermitted(
      'Entities.SurveyInstanceAnswer.AllowRead'
    )
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar top-btn-primary",
    attrs: {
      "disabled": _vm.selectedCheckIds.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.openChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("zoom_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0005) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAudiUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedCheckIds.length != 1
    },
    on: {
      "click": function($event) {
        return _vm.showCheckHistory()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("history")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0080) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 nopadding"
  }, [_c('div', {
    staticClass: "well well-top-bar"
  }, [_c('div', {
    staticClass: "form-group selectbar"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "statusCodeUpdateSelection"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-raised",
    attrs: {
      "role": "button",
      "disabled": !_vm.selectedStatusCode ||
        _vm.selectedChecks.length == 0 ||
        !_vm.globals.operationPermitted(
          'Entities.SurveyInstance.AllowUpdate'
        )
    },
    on: {
      "click": function($event) {
        return _vm.changeSelectedChecksStatus()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0006) + ": " + _vm._s(_vm.selectedStatusCode))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-raised dropdown-toggle",
    class: {
      disabled: _vm.allowedStatusCodes.length < 1 ||
        !_vm.globals.operationPermitted(
          'Entities.SurveyInstance.AllowUpdate'
        ),
    },
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "disabled": _vm.allowedStatusCodes.length < 1 ||
        !_vm.globals.operationPermitted(
          'Entities.SurveyInstance.AllowUpdate'
        )
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.allowedStatusCodes), function(code, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedStatusCode = code
        }
      }
    }, [_vm._v(_vm._s(_vm.getStatusCodeDescription(code)))])])
  }), 0)]), _vm._v(" "), (
    !_vm.filterStrings.SurveyInstanceStatusId &&
    _vm.globals.operationPermitted(
      'Entities.SurveyInstance.AllowUpdate'
    )
  ) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "statusCodeUpdateSelection",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0046))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(_vm.isPageSelected() ? !_vm.includeChecks : _vm.includeChecks) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM0007))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM0008))])]), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Functions.SettlementExport.Allow'
    ) && !_vm.feature.isAudiTarget
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    on: {
      "click": function($event) {
        _vm.showSettlementDownloadModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0059) + "\n            ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    key: _vm.selectedClient,
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-clients-selector",
      "afterChange": function () {
        _vm.onClientSelection();
      },
      "placeholder": _vm.lang.CM0011,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  }), 0)], 1) : _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-importer-selector",
      "afterChange": function () {
        _vm.getCheckData();
      },
      "placeholder": _vm.lang.CM0074,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, _vm._l((_vm.dataLists.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-project-selector",
      "afterChange": function () {
        _vm.onProjectSelection();
      },
      "disabled": !_vm.selectedClient,
      "placeholder": _vm.lang.CM0048,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, _vm._l((_vm.dataLists.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0)], 1), _vm._v(" "), (_vm.globals.currentUserRole < 2 && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "select-filter-container",
    class: {
      'width-15': _vm.selectedCheckType === 'FO'
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "check-management-check-type-select",
      "afterChange": function () {
        _vm.getCheckData();
      },
      "placeholder": _vm.lang.CM0066,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0063))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0064))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0065))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCT"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0081))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0082))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedCheckType === 'FO') ? _c('div', {
    staticClass: "select-filter-container width-15"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleOnlineStateFilter()
      }
    }
  }, [(_vm.selectedOnlineState === true) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.selectedOnlineState === false) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM0067))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0012))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0013))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0014))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "checksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0049))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "check-management-main-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0015) + "\n                  "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0016) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ShortSurveyCode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0017) + "\n                  "), (
    _vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0018) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceStatusId' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceStatusId' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ProjectName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0019) + "\n                  "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0020) + "\n                  "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ScenarioName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0021) + "\n                  "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0073) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0050) + "\n                  "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0051) + "\n                  "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationAddress')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0022) + "\n                  "), (
    _vm.sortField == 'LocationAddress' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationAddress' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0023) + "\n                  "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceAnswerDateOfVisit')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0024) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceAnswerDateOfVisit' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceAnswerDateOfVisit' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceNote')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0027) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceUntil')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0028) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceUntil' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceUntil' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceResponsable')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.CM0065 : _vm.lang.CM0029) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceResponsable' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceResponsable' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtScoreColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceScore')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0030) + "\n                  "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceScore' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceScore' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtScoreColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0052))])], 1), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceProgress')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0031) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceProgress' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceProgress' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtSettlementColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SettlementStatus')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0060) + "\n                  "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (
    _vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtSettlementColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0068) + ":\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  + → " + _vm._s(_vm.lang.CM0069) + "\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  o → " + _vm._s(_vm.lang.CM0070) + "\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  x → " + _vm._s(_vm.lang.CM0071) + "\n                  "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  - → " + _vm._s(_vm.lang.CM0072) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceModifiedAt')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.CM0047) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceModifiedAt' &&
    _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceModifiedAt' &&
    _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShortSurveyCode),
      expression: "filterStrings.ShortSurveyCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ShortSurveyCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShortSurveyCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "checkMgmtStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "check-management-survey-instance-status",
      "allowClear": true,
      "placeholder": _vm.lang.CM0032
    },
    model: {
      value: (_vm.filterStrings.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SurveyInstanceStatusId", $$v)
      },
      expression: "filterStrings.SurveyInstanceStatusId"
    }
  }, _vm._l((_vm.filterableStatusCodes), function(status) {
    return _c('option', {
      key: status.SurveyInstanceStatusId,
      domProps: {
        "value": status.SurveyInstanceStatusId
      }
    }, [_vm._v("\n                      " + _vm._s(status.SurveyInstanceStatusId) + "\n                    ")])
  }), 0)], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit),
      expression: "filterStrings.SurveyInstanceAnswerDateOfVisit"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceNote),
      expression: "filterStrings.SurveyInstanceNote"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceNote)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceNote", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceUntil),
      expression: "filterStrings.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceUntil)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceResponsable),
      expression: "filterStrings.SurveyInstanceResponsable"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceResponsable)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceResponsable", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceScore),
      expression: "filterStrings.SurveyInstanceScore"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceScore)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceScore", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceProgress),
      expression: "filterStrings.SurveyInstanceProgress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceProgress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceProgress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementStatus),
      expression: "filterStrings.SettlementStatus"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementStatus)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementStatus", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceModifiedAt),
      expression: "filterStrings.SurveyInstanceModifiedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceModifiedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceModifiedAt", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "v-click-outside=clearLastSelection"
  }, _vm._l((_vm.checkData), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      staticClass: "check-management-check-row",
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceGuid) ?
          _vm.includeChecks :
          !_vm.includeChecks,
        'text-red': check.SurveyInstanceIsExpired,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectCheck(
            check.SurveyInstanceGuid,
            check.SurveyInstanceId,
            $event
          )
        },
        "dblclick": function($event) {
          _vm.globals.operationPermitted(
              'Entities.SurveyInstanceAnswer.AllowRead'
            ) &&
            !_vm.globals.isAudiUser &&
            _vm.openCheck(
              check.SurveyInstanceId,
              check.LocationExportDefaultLanguageCode,
              check.LocationExportDefaultCountryCode
            )
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.ShortSurveyCode))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(check.SurveyInstanceStatusId) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.ProjectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.WaveName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.ScenarioName))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(check.SurveyInstanceInfo) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationStoreId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(check.SurveyInstanceAnswerDateOfVisit) + "\n              ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "`tdSurveyInstanceNote${check.SurveyInstanceId}`"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.globals.truncateString(check.SurveyInstanceNote, 30)) + "\n              ")]), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("tdSurveyInstanceNote" + (check.SurveyInstanceId)),
        "delay": _vm.globals.tooltipDelay,
        "boundary": "viewport"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceNote))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceUntil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceResponsable))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceScore))]), _vm._v(" "), _c('td', [_vm._v(">" + _vm._s(check.SurveyInstanceProgress))]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('td', [_vm._v("\n                " + _vm._s(check.SettlementStatus) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceModifiedAt))])], 1)
  }), 0)])])])]), _vm._v(" "), _c('CheckManagementAddModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "showDialog": _vm.showAddChecksDialog
    },
    on: {
      "clientSelected": _vm.onClientSelection,
      "dialogClosed": _vm.onAddChecksDialogClosed,
      "dialogDataSaved": _vm.onAddChecksDialogDataSaved,
      "checksCreated": function($event) {
        (_vm.selectedChecks = $event.guids), (_vm.selectedCheckIds = $event.ids)
      }
    }
  }), _vm._v(" "), _c('CheckManagementEditModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedChecks": _vm.selectedChecks,
      "selectedCheckIds": _vm.selectedCheckIds,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "includeChecks": _vm.includeChecks,
      "showDialog": _vm.showEditChecksDialog,
      "projectSelected": !!_vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onEditChecksDialogClosed
    }
  }), _vm._v(" "), _c('SettlementDownloadModal', {
    attrs: {
      "showModal": _vm.showSettlementDownloadModal
    },
    on: {
      "closeModal": function($event) {
        _vm.showSettlementDownloadModal = false
      }
    }
  }), _vm._v(" "), _c('CheckPaymentModal', {
    attrs: {
      "showModal": _vm.showCheckPaymentModal,
      "surveyInstanceGuids": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        (_vm.showCheckPaymentModal = false), _vm.getCheckData()
      }
    }
  }), _vm._v(" "), _c('ShopperFilterModal', {
    attrs: {
      "showModal": _vm.showShopperFilterModal,
      "selectedClient": _vm.selectedClient
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperFilterModal = false
      }
    }
  }), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('CheckLocalAgencyAssignmentModal', {
    attrs: {
      "showModal": _vm.showCheckLocalAgencyAssignmentModal,
      "selectedChecks": _vm.selectedChecks,
      "agencies": _vm.dataLists.agencyList
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = false
      },
      "modalDataSaved": function($event) {
        return _vm.getCheckData()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCheckImportTester() && _vm.showCheckImportModal) ? _c('CheckImportModal', {
    on: {
      "modalClosed": function($event) {
        _vm.showCheckImportModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM0034))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.CM0035))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM0036) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "check-management-delete-modal-yes-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteChecks()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM0037) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.CM0038,
      "yesButtonText": _vm.lang.CM0039,
      "noButtonText": _vm.lang.CM0040,
      "showDialog": _vm.showExportModal
    },
    on: {
      "onYesConfirmation": _vm.downloadCheckData,
      "dialogClosed": function($event) {
        _vm.showExportModal = false
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.lang.CM0041) + ":\n        "), _c('b', [_vm._v(_vm._s(_vm.getNameOfSelectedClient()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "autovalidationDialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [(
    _vm.autovalidation.invalidChecks.length == 0 &&
    _vm.autovalidation.validatedChecks.length == 0
  ) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("\n              Do you want to autovalidate\n              " + _vm._s(_vm.selectedCheckIds.length) + " checks?\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0036) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startAutovalidation()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0037) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.autovalidation.invalidChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Invalid Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.invalidChecks
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.autovalidation.validatedChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Validated Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    staticClass: "autovalidationTable",
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.validatedChecks
    }
  })], 1)]) : _vm._e()])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Autovalidation")])])])
}]}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM3001))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.lang.KM3008) + ": " + _vm._s(_vm.client.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectLocale",
      "afterChange": _vm.selectedLocaleChanged,
      "placeholder": _vm.lang.KM3003
    }
  }, _vm._l((_vm.avaibleLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.LocaleCode
      }
    }, [_vm._v("\n                      " + _vm._s(locale.LocaleName) + "\n                    ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectKpiTranslationProject"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [(_vm.showDialog) ? _c('Select2', {
    key: _vm.selectedProject,
    staticClass: "form-control",
    attrs: {
      "id": "selectKpiTranslationProject",
      "placeholder": _vm.lang.KM3016,
      "allowClear": true
    },
    on: {
      "change": function (p) { return (_vm.selectedProject = p); }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSearchKpi"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKpiString),
      expression: "searchKpiString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchKpi"
    },
    domProps: {
      "value": (_vm.searchKpiString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKpiString = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLocaleCode
    },
    on: {
      "click": function($event) {
        return _vm.getInitialSort()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM3014) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "id": "kpiTypeColumnHeader"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Type')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3005) + "\n                      "), (_vm.showSortArrow('Type', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Type', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Text')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3006) + "\n                      "), (_vm.showSortArrow('Text', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Text', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Translation')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3007) + "\n                      "), (_vm.showSortArrow('Translation', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Translation', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredKpiTranslations), function(kpiInformation, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.selectedProject ||
          kpiInformation.ProjectGuid === _vm.selectedProject
        ),
        expression: "\n                    !selectedProject ||\n                    kpiInformation.ProjectGuid === selectedProject\n                  "
      }],
      key: index
    }, [_c('td', [_vm._v(_vm._s(kpiInformation.Type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpiInformation.Text))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiInformation.Translation),
        expression: "kpiInformation.Translation"
      }],
      staticClass: "form-control text-center textarea-kpi-translations autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text",
        "placeholder": kpiInformation.InheritedTranslation
      },
      domProps: {
        "value": (kpiInformation.Translation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(kpiInformation, "Translation", $event.target.value)
        }, function($event) {
          _vm.isTranslationDirty = true
        }]
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.isTranslationDirty,
      'dialog-btn-primary': !_vm.isTranslationDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_KPIsTranslation_Update') ||
        !_vm.isTranslationDirty
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiTranslations()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3000) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "waveStatusModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS000))])]), _vm._v(" "), (_vm.elementId) ? _c('label', {
    staticClass: "control-label nopadding"
  }, [_vm._v("ID: " + _vm._s(_vm.elementId))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wave-status-modal-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(
    _vm.statusData.SurveyInstances &&
    _vm.statusData.SurveyInstances.Status
  ) ? _c('tr', [_c('td', {
    staticClass: "text-left noborder"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS001))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left noborder"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS002))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.SurveyInstances.Status.Count))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS003))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Approval) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS004))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.InProgress) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS005))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.statusData.SurveyInstances.Status.Reporting) + "\n                        ")])]), _vm._v(" "), (_vm.statusData.Wave) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS006))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((_vm.statusData.Wave.InTime * 100).toFixed(2))) + "\n                          %\n                        ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.Approvals) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS007))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "width": "66.67%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS008))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithoutProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS009))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.WithProposals))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS010))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Approved))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.lang.WVS011))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.statusData.Approvals.Rejected))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS012))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution) ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.WVS018))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.WVS013))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS014))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.WVS015))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CompetitorCarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.WVS016) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('div', {
    staticClass: "input-group group"
  }, [_c('label', {
    staticClass: "comboBoxLabel"
  }, [_vm._v(_vm._s(_vm.lang.S0111) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualClient),
      expression: "actualClient"
    }],
    staticClass: "form-control nopadding comboBoxGroup",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.actualClient = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.loadPolicies()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "-1"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0112))]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n            " + _vm._s(client.ClientName) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.actualClient && _vm.actualClient != -1) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w30"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0115))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center w70"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.lang.S0172))])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, [(_vm.surveys) ? _vm._l((_vm.surveys), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w30 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.surveyTitle))])]), _vm._v(" "), _c('td', {
      staticClass: "w70",
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "reset-this"
    }, [_c('treeselect', {
      attrs: {
        "placeholder": _vm.lang.S0041,
        "options": property.surveysQuestions,
        "auto-load-root-options": false,
        "multiple": true,
        "limit": 5,
        "searchable": true,
        "showCount": true,
        "flat": true,
        "valueFormat": "id",
        "showCountOf": "LEAF_DESCENDANTS",
        "disabled": true
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    })], 1)])])
  }) : _vm._e()], 2)])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default agency--panel"
  }, [_c('div', {
    staticClass: "panel-body menu__panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        _vm.emitUserSearch(), _vm.emitTriggerReload()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1000) + "\n      ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Create')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-create-button"
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1002) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Read')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-edit-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitEditAgency(false)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1003) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Agencies_Delete')) ? _c('button', {
    staticClass: "btn btn-raised button__toolbar",
    attrs: {
      "id": "agency-management-delete-button",
      "disabled": !_vm.agencySelected
    },
    on: {
      "click": function($event) {
        return _vm.emitDeleteAgency()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.lang.AM1008) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body paging__panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar__form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.AM1001
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emitUserSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1004))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === _vm.tableElementCount,
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changePageSize(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1005))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageNumbers.length || _vm.currentPage === 1,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1006))])], 1), _vm._v(" "), (_vm.pageNumbers.length > 5 && _vm.currentPage > 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.showPages), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.currentPage === pageNumber
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectPage(pageNumber)
        }
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (
    _vm.pageNumbers.length > 5 && _vm.currentPage < _vm.pageNumbers.length - 2
  ) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.pageNumbers.length || _vm.currentPage === _vm.pageNumbers.length,
    }
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    },
    on: {
      "click": function($event) {
        return _vm.selectPage(_vm.pageNumbers.length)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1007))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "agenciesTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.tableElementCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "agenciesTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.AM1009))])], 1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "customPropertyListEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "propertyListEditForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeListEditModal()
      }
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SM2500))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [(!_vm.propertyListAddEnabled) ? _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showAddPropertyListInput()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2501) + "\n                  ")]) : _c('button', {
    staticClass: "btn btn-raised btn-warning btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewPropertyListEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2501) + "\n                  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.propertyListAddEnabled),
      expression: "!propertyListAddEnabled"
    }],
    staticClass: "col-md-10 text-left"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSelectAllEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v(_vm._s(_vm.allEntriesSelected() ? "remove_circle" : "check_circle"))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.allEntriesSelected() ? _vm.lang.SM2503 : _vm.lang.SM2502) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    attrs: {
      "disabled": !_vm.isAnyEntrySelected()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeSelectedEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.SM2504) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-entry-actions",
    attrs: {
      "disabled": !_vm.isAnyEntrySelected()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleVisibilityOfSelectedEntries()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v(_vm._s(_vm.allSelectedEntriesVisible() ?
    "visibility_off" :
    "visibility"))]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.allSelectedEntriesVisible() ? _vm.lang.SM2505 : _vm.lang.SM2506) + "\n                  ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.propertyListAddEnabled),
      expression: "propertyListAddEnabled"
    }],
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propertyListAddData),
      expression: "propertyListAddData"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "5",
      "id": "textareaPropertyList",
      "placeholder": ((_vm.lang.SM2507) + " 1\n" + (_vm.lang.SM2507) + " 2\n" + (_vm.lang.SM2507) + " 3")
    },
    domProps: {
      "value": (_vm.propertyListAddData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.propertyListAddData = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "propertyListValuesTableContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover",
    attrs: {
      "id": "propertyListValuesTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center col-md-10"
  }, [_vm._v(_vm._s(_vm.lang.SM2507))]), _vm._v(" "), _c('th', {
    staticClass: "text-center col-md-2"
  }, [_vm._v(_vm._s(_vm.lang.SM2508))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.propertyListData.Values), function(entry, index) {
    return _c('tr', {
      key: index,
      class: {
        info: entry.selected,
        error: entry.error
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (entry.selected = !entry.selected), _vm.$forceUpdate()
        }
      }
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (entry.Value),
        expression: "entry.Value"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "type": "text",
        "readonly": "true"
      },
      domProps: {
        "value": (entry.Value)
      },
      on: {
        "blur": function($event) {
          return _vm.propertyListEntryChanged($event, index)
        },
        "dblclick": _vm.editEntry,
        "click": function($event) {
          $event.target.readOnly ||
            $event.stopPropagation()
        },
        "change": function($event) {
          _vm.isPropertyListDataDirty = true
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return $event.target.blur()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(entry, "Value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      attrs: {
        "id": "actionButtonContainer"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.isPropertyListDataDirty = true
        }
      }
    }, [_c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.editEntry
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("edit")])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          (entry.Visible = !entry.Visible), _vm.$forceUpdate()
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      class: {
        'text-grey': !entry.Visible
      }
    }, [_vm._v(_vm._s(entry.Visible ? "visibility" : "visibility_off"))])]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEntry(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24 text-red"
    }, [_vm._v("clear")])])])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default btn-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeListEditModal()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM2509) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.isPropertyListDataDirty,
      'btn-success': !_vm.isPropertyListDataDirty,
    },
    attrs: {
      "type": "button",
      "disabled": _vm.hasPropertyListError || _vm.propertyListAddEnabled
    },
    on: {
      "click": function($event) {
        return _vm.storePropertyListItems()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.SM2510) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "kpi-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled || !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.getKpiData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiGroupEditModal()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("group_work")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openEditKpiDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiAssignmentDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0017) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showKPICopyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0021) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-client-select",
      "afterChange": _vm.onClientSelection,
      "allowClear": true,
      "placeholder": _vm.lang.KM0011
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  }), 0)], 1) : _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-importer-select",
      "afterChange": _vm.selectedImporterChanged,
      "allowClear": true,
      "placeholder": _vm.lang.KM0018
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-project-select",
      "disabled": _vm.clientProjectList.length < 1,
      "allowClear": true,
      "placeholder": _vm.lang.KM0012,
      "afterChange": _vm.doFiltering
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "KPIManagementSearchInput",
      "placeholder": _vm.lang.KM0002
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1),
        (_vm.selectedKpiGuid = ''),
        (_vm.selectedKpiData = {}),
        _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0003))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredKpiData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0004))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredKpiData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0005))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "kpisTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredKpiData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "kpisTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0020))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPICode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0006) + "\n                  "), (_vm.showSortArrow('KPICode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPICode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIShortText')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0007) + "\n                  "), (_vm.showSortArrow('KPIShortText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIShortText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPILongText')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0008) + "\n                  "), (_vm.showSortArrow('KPILongText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPILongText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIGroups')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0010) + "\n                  "), (_vm.showSortArrow('KPIGroups', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIGroups', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ClientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0013) + "\n                  "), (_vm.showSortArrow('ClientName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ClientName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Importers')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0019) + "\n                  "), (_vm.showSortArrow('Importers', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Importers', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Projects')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0015) + "\n                  "), (_vm.showSortArrow('Projects', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Projects', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyIdString')
      }
    }
  }, [_vm._v("\n                  Survey\n                  "), (_vm.showSortArrow('SurveyIdString', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyIdString', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIEvaluationRuleName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0016) + "\n                  "), (_vm.showSortArrow('KPIEvaluationRuleName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIEvaluationRuleName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPICode),
      expression: "columnFilterObject.KPICode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPICode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPICode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIShortText),
      expression: "columnFilterObject.KPIShortText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIShortText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIShortText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPILongText),
      expression: "columnFilterObject.KPILongText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPILongText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPILongText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIGroups),
      expression: "columnFilterObject.KPIGroups"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIGroups)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIGroups", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.ClientName),
      expression: "columnFilterObject.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.SurveyIdString),
      expression: "columnFilterObject.SurveyIdString"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.SurveyIdString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "SurveyIdString", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIEvaluationRuleName),
      expression: "columnFilterObject.KPIEvaluationRuleName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIEvaluationRuleName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIEvaluationRuleName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpiDataOnCurrentPage), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: kpi.KPIGuid === _vm.selectedKpiGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), (_vm.selectedKpiData = kpi)
        },
        "dblclick": function($event) {
          return _vm.openKpiAssignmentDialog()
        }
      }
    }, [_c('td', [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIShortText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPILongText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIGroups[0].KPIGroupCode))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(kpi.ClientName) + "\n              ")]) : _c('td', [_vm._v("\n                " + _vm._s(kpi.Importers ? kpi.Importers[0].ImporterName : "") + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.Projects[0].ProjectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.SurveyIdString))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIEvaluationRuleName))])])
  }), 0)])])])]), _vm._v(" "), _c('kpi-group-edit-modal', {
    attrs: {
      "showDialog": _vm.showKpiGroupEditDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList,
      "selectedClientForKpiGroups": _vm.selectedClient
    },
    on: {
      "dialogClosed": _vm.onKpiGroupEditDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-edit-modal', {
    attrs: {
      "showDialog": _vm.showEditKpiDialog,
      "clientList": _vm.clientList,
      "selectedClientForKpi": _vm.selectedClient,
      "selectedProjectGuidFromParent": _vm.selectedProject,
      "projectList": _vm.projectList,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onEditKpiDialogClosed
    }
  }), _vm._v(" "), _c('kpi-assignment-modal', {
    attrs: {
      "showDialog": _vm.showKpiAssignmentDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "selectedClientFromParent": _vm.selectedClient,
      "selectedKpiData": _vm.selectedKpiData,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onKpiAssignmentDialogDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-translate-modal', {
    attrs: {
      "showDialog": _vm.showTranslateKpiDialog,
      "client": _vm.selectedClientForKpiTranslation,
      "projects": _vm.clientProjectList,
      "initialProject": _vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onTranslateKpiDialogClosed
    }
  }), _vm._v(" "), _c('KPICopyModal', {
    attrs: {
      "showModal": _vm.showKPICopyModal,
      "projects": _vm.clientProjectList,
      "selectedProject": _vm.selectedProject
    },
    on: {
      "copyDone": function($event) {
        return _vm.getKpiData()
      },
      "modalClosed": function($event) {
        _vm.showKPICopyModal = false
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.globals.currentUserInfo) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel panel-default text-left"
  }, [(
    _vm.globals.currentUserRole < 3 &&
    _vm.feature.isEnabled('changePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ChangePasswordSelf') &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('div', {
    attrs: {
      "id": "passwordResetContainer"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.lang.US0000))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showChangePasswordDialog = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0001) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "filterSettingsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0002) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbRememberFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberFilters),
      expression: "rememberFilters"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberFilters) ? _vm._i(_vm.rememberFilters, null) > -1 : (_vm.rememberFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.rememberFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberFilters = $$c
        }
      }, function($event) {
        (_vm.syncFilters = false), _vm.clearFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0003))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbRememberFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0004))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "cbSyncFilterSettings"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.syncFilters),
      expression: "syncFilters"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.rememberFilters
    },
    domProps: {
      "checked": Array.isArray(_vm.syncFilters) ? _vm._i(_vm.syncFilters, null) > -1 : (_vm.syncFilters)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.syncFilters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.syncFilters = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.syncFilters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.syncFilters = $$c
        }
      }, function($event) {
        return _vm.clearSharedFilters()
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text text-black"
  }, [_vm._v(_vm._s(_vm.lang.US0005))])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "cbSyncFilterSettings",
      "boundary": "viewport",
      "triggers": "hover",
      "placement": "topright",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.US0006))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.rememberFilters
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.US0007) + "\n        ")])], 1), _vm._v(" "), (
    (_vm.globals.operationPermitted('Functions.UserLoginAs.Allow') ||
      _vm.globals.currentUserInfo.IsLoggedInAsUser) &&
    _vm.feature.isEnabled('loginAs')
  ) ? _c('div', {
    attrs: {
      "id": "loginAsContainer"
    }
  }, [_c('h2', [_vm._v("\n          " + _vm._s(_vm.lang.US0008) + "\n          "), _c('span', {
    staticClass: "beta-feature-indicator"
  }, [_vm._v("BETA")])]), _vm._v(" "), (_vm.globals.currentUserInfo.IsLoggedInAsUser) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.leaveLoginAsSession()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0009) + "\n          ")])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "user-settings-loginAsUser",
      "width": '300px',
      "placeholder": _vm.lang.US0010,
      "allowClear": true
    },
    model: {
      value: (_vm.loginAsUserId),
      callback: function($$v) {
        _vm.loginAsUserId = $$v
      },
      expression: "loginAsUserId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.userList), function(user) {
    return _c('option', {
      key: user.UserId,
      domProps: {
        "value": user.UserId
      }
    }, [_vm._v("\n              " + _vm._s(user.LastName) + ", " + _vm._s(user.FirstName) + " (" + _vm._s(user.LoginName) + ")\n            ")])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.loginAsUserId
    },
    on: {
      "click": function($event) {
        return _vm.requestLoginAs()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.US0011) + "\n          ")])], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('change-password-dialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showChangePasswordDialog = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "kpiAssignmentDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "kpiAssignmentDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM1000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM1001) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1013) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1002) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM1003) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfselectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedClientGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalClientSelect",
      "afterChange": _vm.selectedClientGuidChanged,
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiGroupSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiGroupGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiGroupSelect",
      "placeholder": _vm.lang.KM1006,
      "disabled": _vm.kpiGroupsOfSelectedClient.length < 1,
      "afterChange": _vm.selectedKpiGroupGuidChanged
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalKpiSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1007))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalKpiSelect",
      "placeholder": _vm.lang.KM1008,
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1,
      "afterChange": _vm.selectedKpiGuidChanged
    },
    model: {
      value: (_vm.selectedKpiGuid),
      callback: function($$v) {
        _vm.selectedKpiGuid = $$v
      },
      expression: "selectedKpiGuid"
    }
  }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('option', {
      key: kpi.KPIGuid,
      domProps: {
        "value": kpi.KPIGuid
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPICode) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.treeViewChanged
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.treeViewChanged || !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiQuestionAssignmentData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.lang.KM1012) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIAssignmentModalSurveySelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM1010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedSurveyGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIAssignmentModalSurveySelect",
      "placeholder": _vm.lang.KM1011,
      "disabled": _vm.surveysFromSelectedKpiGroup.length < 1,
      "afterChange": _vm.selectedSurveyGuidChanged
    },
    model: {
      value: (_vm.selectedSurveyGuid),
      callback: function($$v) {
        _vm.selectedSurveyGuid = $$v
      },
      expression: "selectedSurveyGuid"
    }
  }, _vm._l((_vm.surveysFromSelectedKpiGroup), function(survey) {
    return _c('option', {
      key: survey.SurveyGuid,
      domProps: {
        "value": survey.SurveyGuid
      }
    }, [_vm._v("\n                          " + _vm._s(survey.SurveyId) + " - " + _vm._s(survey.SurveyTitle) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "well",
    attrs: {
      "id": "liquortreeContainerWell"
    }
  }, [(_vm.showTree) ? _c('liquortree', {
    ref: "kpiQuestionAssignmentTree",
    attrs: {
      "data": _vm.treeData,
      "options": _vm.treeOptions
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;

        return _c('span', {
          staticClass: "tree-text"
        }, [(!node.data.IsCluster) ? [_c('div', {
          staticClass: "checkbox",
          staticStyle: {
            "margin": "0px",
            "padding-top": "3px"
          }
        }, [_c('label', [_c('input', {
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": node.checked()
          },
          on: {
            "change": function($event) {
              return _vm.toggleQuestionCheckbox(node)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "checkbox-material"
        }, [_c('span', {
          staticClass: "check"
        })]), _vm._v(" "), _c('span', {
          staticClass: "ltree-types-and-points"
        }, [_vm._v("(" + _vm._s(_vm.convertQuestionTypeToLetter(node.data.Type)) + "|" + _vm._s(node.data.PointsMax ?
          node.data.PointsMax :
          0) + ")")]), _vm._v(" "), _c('span', {
          staticClass: "text-black",
          attrs: {
            "id": node.data.QuestionGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.QuestionGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])], 1)])] : [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v(_vm._s(node.checked() || node.indeterminate() ?
          "folder" :
          "folder_open"))]), _vm._v(" "), _c('span', {
          attrs: {
            "id": node.data.PanelGuid
          }
        }, [_vm._v(_vm._s(node.text))]), _vm._v(" "), _c('b-tooltip', {
          ref: "tooltip",
          attrs: {
            "target": node.data.PanelGuid,
            "delay": _vm.globals.tooltipDelay
          }
        }, [_vm._v(_vm._s(node.text))])]], 2)
      }
    }], null, false, 3633694616)
  }) : _vm._e()], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM1009) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "locationManagementEditModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), (_vm.locationData.LocationId) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID: " + _vm._s(_vm.locationData.LocationId))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons md-24",
    attrs: {
      "id": "showLocationHistoryInfoIcon"
    },
    on: {
      "click": function($event) {
        return _vm.showLocationHistory()
      }
    }
  }, [_vm._v("history")]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "showLocationHistoryInfoIcon",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.L0090))])], 1) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0021))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClient"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0022) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputClient",
      "name": "inputClient",
      "placeholder": _vm.lang.L0023,
      "disabled": _vm.selectedLocation > 0,
      "afterChange": _vm.getLocationProperties,
      "required": ""
    },
    model: {
      value: (_vm.locationData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ClientId", $$v)
      },
      expression: "locationData.ClientId"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                        " + _vm._s(client.ClientName) + "\n                      ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClient')),
      expression: "inputHasError('inputClient')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationImporter"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0088) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputLocationImporter",
      "name": "inputLocationImporter",
      "placeholder": _vm.lang.L0023,
      "required": ""
    },
    model: {
      value: (_vm.locationData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "ImporterGuid", $$v)
      },
      expression: "locationData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                        " + _vm._s(importer.ImporterName) + "\n                      ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationImporter')),
      expression: "inputHasError('inputLocationImporter')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStoreId"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0024) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStoreId),
      expression: "locationData.LocationStoreId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputStoreId",
      "name": "inputStoreId",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputStoreId')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationStoreId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputStoreId')),
      expression: "inputHasError('inputStoreId')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLocationName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0025) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationName),
      expression: "locationData.LocationName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputLocationName",
      "name": "inputLocationName",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLocationName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLocationName')),
      expression: "inputHasError('inputLocationName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0078))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0026))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress),
      expression: "locationData.LocationAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAddress2),
      expression: "locationData.LocationAddress2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.locationData.LocationAddress2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputDistrict"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCounty),
      expression: "locationData.LocationCounty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputDistrict",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.locationData.LocationCounty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCounty", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationCity),
      expression: "locationData.LocationCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.locationData.LocationCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.locationData) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "location-management-edit-modal-locationCountry-select",
      "afterChange": _vm.changedCountry,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationCountry),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationCountry", $$v)
      },
      expression: "locationData.LocationCountry"
    }
  }, _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  }), 0) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    ref: "regionSelect",
    staticClass: "form-control",
    attrs: {
      "id": "location-management-edit-modal-region-select",
      "disabled": _vm.currentRegions.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.RegionGuid),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "RegionGuid", $$v)
      },
      expression: "locationData.RegionGuid"
    }
  }, _vm._l((_vm.currentRegions), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                        " + _vm._s(region.RegionName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0032))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    ref: "timeZoneSelect",
    staticClass: "form-control",
    attrs: {
      "id": "location-management-edit-modal-location-timezone-select",
      "disabled": _vm.currentTimeZones.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationTimeZoneId),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationTimeZoneId", $$v)
      },
      expression: "locationData.LocationTimeZoneId"
    }
  }, _vm._l((_vm.currentTimeZones), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                        " + _vm._s(tz.TimeZoneName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportCountryCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0084))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputExportCountryCode",
      "afterChange": function (d) { return _vm.changedExportCountryCode(false, d); },
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultCountryCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultCountryCode", $$v)
      },
      expression: "locationData.LocationExportDefaultCountryCode"
    }
  }, _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                        " + _vm._s(country) + "\n                      ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportLanguageCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0085))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select2', {
    ref: "exportLanguageSelect",
    staticClass: "form-control",
    attrs: {
      "id": "inputExportLanguageCode",
      "disabled": _vm.currentExportLanguages.length < 1,
      "placeholder": _vm.lang.L0023,
      "allowClear": true
    },
    model: {
      value: (_vm.locationData.LocationExportDefaultLanguageCode),
      callback: function($$v) {
        _vm.$set(_vm.locationData, "LocationExportDefaultLanguageCode", $$v)
      },
      expression: "locationData.LocationExportDefaultLanguageCode"
    }
  }, _vm._l((_vm.currentExportLanguages), function(language) {
    return _c('option', {
      key: language.LanguageCode,
      domProps: {
        "value": language.LanguageCode
      }
    }, [_vm._v("\n                        " + _vm._s(language.LanguageName) + "\n                      ")])
  }), 0) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPostalCode),
      expression: "locationData.LocationPostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode",
      "maxlength": "12"
    },
    domProps: {
      "value": (_vm.locationData.LocationPostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhone),
      expression: "locationData.LocationPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputPhone",
      "name": "inputPhone"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhone)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhone')),
      expression: "inputHasError('inputPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0079))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationFax),
      expression: "locationData.LocationFax"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputFax",
      "name": "inputFax"
    },
    domProps: {
      "value": (_vm.locationData.LocationFax)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputFax')),
      expression: "inputHasError('inputFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0080))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPhotoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationPhotoURL),
      expression: "locationData.LocationPhotoURL"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputPhotoURL",
      "name": "inputPhotoURL"
    },
    domProps: {
      "value": (_vm.locationData.LocationPhotoURL)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputPhotoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationPhotoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputPhotoURL')),
      expression: "inputHasError('inputPhotoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0081))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMail"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0038))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmail),
      expression: "locationData.LocationExportEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputExportMail",
      "name": "inputExportMail",
      "multiple": ""
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmail)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputExportMail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputExportMail')),
      expression: "inputHasError('inputExportMail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0082))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputExportMailName"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationExportEmailName),
      expression: "locationData.LocationExportEmailName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputExportMailName"
    },
    domProps: {
      "value": (_vm.locationData.LocationExportEmailName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationExportEmailName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputStatus"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.showModal) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationStatusId),
      expression: "locationData.LocationStatusId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.locationData, "LocationStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }, _vm._l((_vm.locationStatusList), function(status, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                        " + _vm._s(status) + "\n                      ")])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLatitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLatitude),
      expression: "locationData.LocationLatitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-90",
      "max": "90",
      "id": "inputLatitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLatitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLatitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLatitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLatitude')),
      expression: "inputHasError('inputLatitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLongitude"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationLongitude),
      expression: "locationData.LocationLongitude"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "min": "-180",
      "max": "180",
      "id": "inputLongitude"
    },
    domProps: {
      "value": (_vm.locationData.LocationLongitude)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationLongitude", $event.target.value)
      }, function($event) {
        return _vm.validateInput('inputLongitude')
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLongitude')),
      expression: "inputHasError('inputLongitude')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.L0083))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputGeocodeSource"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationGeocodeSource),
      expression: "locationData.LocationGeocodeSource"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputGeocodeSource"
    },
    domProps: {
      "value": (_vm.locationData.LocationGeocodeSource)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationGeocodeSource", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingRemarks",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseRemarks",
      "aria-expanded": "false",
      "aria-controls": "collapseRemarks"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0052))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseRemarks",
      "role": "tabpanel",
      "aria-labelledby": "headingRemarks"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.L0053))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locationData.LocationAdditionalInfo),
      expression: "locationData.LocationAdditionalInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "maxlength": "2000",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (_vm.locationData.LocationAdditionalInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.locationData, "LocationAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.L0054))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.locationData.CustomProperties),
      expression: "locationData.CustomProperties"
    }],
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0055) + "\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.L0056) + "\n                      ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.locationData.CustomProperties), function(property) {
    return _c('tr', {
      key: property.ID
    }, [_c('td', [_vm._v(_vm._s(property.Name))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Value),
        expression: "property.Value"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text"
      },
      domProps: {
        "value": (property.Value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Value", $event.target.value)
        }
      }
    })])])])
  }), 0)])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.L0057))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0058) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "id": "location-management-dialog-save-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Locations_Update') &&
        _vm.selectedLocation > 0
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('locationManagementEditModal')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.L0059) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "settlementDownloadModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SDM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputSettlementNumber"
    }
  }, [_vm._v(_vm._s(_vm.lang.SDM001))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settlementNumber),
      expression: "settlementNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSettlementNumber"
    },
    domProps: {
      "value": (_vm.settlementNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settlementNumber = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.globals.operationPermitted('Entities.Settlement.AllowCreate')) ? _c('button', {
    staticClass: "btn btn-raised btn-success pull-left",
    attrs: {
      "type": "button",
      "id": "createNewSettlementButton",
      "disabled": !!_vm.settlementNumber
    },
    on: {
      "click": function($event) {
        return _vm.createNewSettlementList()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM002) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM003) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.settlementNumber
    },
    on: {
      "click": function($event) {
        return _vm.downloadSettlementList()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SDM004) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "approval-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.getApprovalData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isLocalAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(function () { return (_vm.showShopperProposalModal = true); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("person_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser || _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.isSelectedCheckOnCurrentPage || !_vm.selectedCheck.ShopperProposals
    },
    on: {
      "click": function($event) {
        _vm.getApprovalData(function () { return (_vm.showShopperApprovalModal = true); })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.showCarModelManagement = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("drive_eta")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0003) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        _vm.getApprovalData(),
          _vm.globals.$emit('showApprovalWaveStatus', _vm.selectedCheck)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("insert_chart")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SA0004) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize === 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage === pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage === _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "approvalTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "approvalTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0009))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    attrs: {
      "id": "approvalMainTable"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0010) + "\n                  "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0011) + "\n                  "), (
    _vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ImporterName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0012) + "\n                  "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0013) + "\n                  "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0014) + "\n                  "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0015) + "\n                  "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCity')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0016) + "\n                  "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCity' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0017) + "\n                  "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('DealerGroup')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0018) + "\n                  "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'DealerGroup' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('Brand')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0019) + "\n                  "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'Brand' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LastUpdatedAt')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SA0020) + "\n                  "), (_vm.sortField == 'LastUpdatedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LastUpdatedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0021) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0022) + " (" + _vm._s(_vm.lang.SA0023) + ")\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0024) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0025) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0026) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0027) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0028) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0029) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0030) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0031) + "\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header unsortable-column-header"
  }, [_vm._v("\n                " + _vm._s(_vm.lang.SA0032) + "\n              ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCity),
      expression: "filterStrings.LocationCity"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCity)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DealerGroup),
      expression: "filterStrings.DealerGroup"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DealerGroup)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DealerGroup", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Brand),
      expression: "filterStrings.Brand"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Brand)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Brand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "inputFilterLastUpdateAtContainer"
    },
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputFilterLastUpdateAt')
      }
    }
  }, [_c('input', {
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "text",
      "id": "inputFilterLastUpdateAt",
      "placeholder": _vm.lang.SA0033
    }
  }), _vm._v(" "), (_vm.lastUpdateAtFilterContent) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputFilterLastUpdateAtContainer",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lastUpdateAtFilterContent))]) : _vm._e()], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperId),
      expression: "filterStrings.ShopperId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.DisplayName),
      expression: "filterStrings.DisplayName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.DisplayName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "DisplayName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Gender),
      expression: "filterStrings.Gender"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Gender)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Gender", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Distance),
      expression: "filterStrings.Distance"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Distance)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Distance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Occupation),
      expression: "filterStrings.Occupation"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.Occupation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Occupation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarModelName),
      expression: "filterStrings.CarModelName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarModelName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarModelName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarSegmentName),
      expression: "filterStrings.CarSegmentName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.CarSegmentName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CarSegmentName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShopperCar),
      expression: "filterStrings.ShopperCar"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SA0033
    },
    domProps: {
      "value": (_vm.filterStrings.ShopperCar)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getApprovalData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShopperCar", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CarMatch),
      expression: "filterStrings.CarMatch"
    }],
    staticClass: "form-control text-center nopadding",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "CarMatch", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v(_vm._s(_vm.lang.SA0034))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '+'
    }
  }, [_vm._v("+ " + _vm._s(_vm.lang.SA0035))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '='
    }
  }, [_vm._v("= " + _vm._s(_vm.lang.SA0036))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": '-'
    }
  }, [_vm._v("- " + _vm._s(_vm.lang.SA0037))])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByLeadAgency),
      expression: "filterStrings.ApprovedByLeadAgency"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByLeadAgency === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByLeadAgency === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByLeadAgency === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByLeadAgency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData()
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0034) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0038) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0039) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0040) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0041) + "\n                    ")])])])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedByMainEntity),
      expression: "filterStrings.ApprovedByMainEntity"
    }],
    staticClass: "form-control text-center nopadding",
    class: {
      'option-green': _vm.filterStrings.ApprovedByMainEntity === 'Approved',
      'option-red': _vm.filterStrings.ApprovedByMainEntity === 'Rejected',
      'option-yellow': _vm.filterStrings.ApprovedByMainEntity === 'Open',
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filterStrings, "ApprovedByMainEntity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        (_vm.selectedPage = 1), _vm.getApprovalData()
      }]
    }
  }, [_c('option', {
    staticClass: "option-white",
    domProps: {
      "value": ''
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0034) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-white",
    domProps: {
      "value": 'None'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0038) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-green",
    domProps: {
      "value": 'Approved'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0039) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-yellow",
    domProps: {
      "value": 'Open'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0040) + "\n                    ")]), _vm._v(" "), _c('option', {
    staticClass: "option-red",
    domProps: {
      "value": 'Rejected'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.SA0041) + "\n                    ")])])])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.approvalData), function(check) {
    return [_c('tr', {
      key: check.SurveyInstanceGuid,
      class: {
        info: check.SurveyInstanceGuid ===
          _vm.selectedCheck.SurveyInstanceGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedCheck = check
        }
      }
    }, [_c('td', {
      staticClass: "wave-state-indicator",
      class: {
        'state-yellow': check.AudiStatus === 'WaveStarted',
        'state-orange': check.AudiStatus === 'WaveOneHalfPassed',
        'state-red': check.AudiStatus === 'WaveTwoThirdsPassed' ||
          check.AudiStatus === 'ActionRequired',
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "3%"
      },
      attrs: {
        "id": ("approvalSurveyIdTableData" + (check.SurveyInstanceGuid))
      }
    }, [_vm._v("\n                  " + _vm._s(check.SurveyId) + "\n                  "), _c('br'), _vm._v(" "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("info_outline")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalSurveyIdTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_c('div', {
      staticClass: "survey-id-info-tooltip"
    }, [_c('b', [_vm._v(_vm._s(_vm.lang.SA0042) + ":")]), _vm._v("\n                    " + _vm._s(check.SurveyTitle) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SA0043) + ":")]), _vm._v("\n                    " + _vm._s(check.ProjectName) + "\n                    "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.lang.SA0044) + ":")]), _vm._v("\n                    " + _vm._s(check.ScenarioName) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.ImporterName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      },
      attrs: {
        "id": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid))
      }
    }, [_vm._v("\n                  " + _vm._s(check.WaveName) + "\n                  "), _c('br'), _vm._v(" "), (check.CarModelDistribution) ? _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("info_outline")]) : _vm._e()]), _vm._v(" "), (
      check.CarModelDistribution ||
      check.CompetitorCarModelDistribution
    ) ? _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalWaveNameTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [(check.CarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0045) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CarModelDistribution), function(model) {
      return _c('span', {
        key: model.CarModelGuid
      }, [_vm._v("\n                      " + _vm._s(model.CarModelName) + " -\n                      " + _vm._s(model.Distribution * 100) + "%\n                      "), _c('br')])
    })] : _vm._e(), _vm._v(" "), (
      check.CarModelDistribution &&
      check.CompetitorCarModelDistribution
    ) ? [_c('br')] : _vm._e(), _vm._v(" "), (check.CompetitorCarModelDistribution) ? [_c('b', [_vm._v(_vm._s(_vm.lang.SA0046) + ":")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((check.CompetitorCarModelDistribution), function(model) {
      return _c('span', {
        key: model.CompetitorCarModelGuid
      }, [_vm._v("\n                      " + _vm._s(model.CompetitorCarModel) + " -\n                      " + _vm._s(model.Distribution * 100) + "%\n                      "), _c('br')])
    })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      }
    }, [_vm._v(_vm._s(check.LocationStoreId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "7%"
      }
    }, [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.LocationCity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "3%"
      }
    }, [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.DealerGroup))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s(check.Brand))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "4%"
      },
      attrs: {
        "id": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid))
      }
    }, [_vm._v("\n                  " + _vm._s(check.DateDiffLastChangedAt) + "\n                ")]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("approvalDateDiffTableData" + (check.SurveyInstanceGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(check.LastUpdatedAt))]), _vm._v(" "), _c('td', {
      staticClass: "nested-table-container",
      staticStyle: {
        "width": "50%"
      }
    }, [(check.ShopperProposals) ? [_c('table', {
      staticClass: "nested-table"
    }, _vm._l((check.ShopperProposals), function(proposal) {
      return _c('tr', {
        key: proposal.ShopperProposalGuid
      }, [_c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperId))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "16%"
        }
      }, [_vm._v(_vm._s(proposal.DisplayName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.Gender))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [(typeof proposal.Distance === 'number') ? _c('span', [_vm._v(_vm._s(proposal.Distance) + " km")]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "14%"
        }
      }, [_vm._v(_vm._s(proposal.Occupation))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.CarModelName))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%"
        }
      }, [_vm._v("\n                          " + _vm._s(proposal.CarSegmentName) + "\n                        ")]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "10%"
        }
      }, [_vm._v(_vm._s(proposal.ShopperCar))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "6%"
        }
      }, [_vm._v(_vm._s(proposal.CarMatch))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(
        proposal.AgencyApprovalStatus === 'Approved'
      ) ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (
        proposal.AgencyApprovalStatus === 'Rejected'
      ) ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "8%",
          "padding": "6px 0 0 0"
        }
      }, [(
        proposal.MainEntityApprovalStatus === 'Approved'
      ) ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-green"
      }, [_vm._v("done")]) : (
        proposal.MainEntityApprovalStatus === 'Rejected'
      ) ? _c('i', {
        staticClass: "material-icons md-24 nopadding text-red"
      }, [_vm._v("clear")]) : _c('i', {
        staticClass: "material-icons md-24 nopadding text-yellow"
      }, [_vm._v("lens")])])])
    }), 0)] : _vm._e()], 2)], 1)]
  })], 2)])])])]), _vm._v(" "), _c('ShopperProposalModal', {
    attrs: {
      "showModal": _vm.showShopperProposalModal,
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperProposalModal = false
      },
      "dataUpdated": function($event) {
        return _vm.getApprovalData()
      }
    }
  }), _vm._v(" "), _c('ShopperApprovalModal', {
    attrs: {
      "showModal": _vm.showShopperApprovalModal,
      "check": _vm.selectedCheck
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperApprovalModal = false
      },
      "resetData": function($event) {
        return _vm.getApprovalData()
      }
    }
  }), _vm._v(" "), _c('CarModelManagement', {
    attrs: {
      "showModal": _vm.showCarModelManagement
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCarModelManagement = false
      }
    }
  }), _vm._v(" "), _c('ApprovalWaveStatusModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_ShopperSurveyInstances_ReadAll')) ? _c('div', {
    attrs: {
      "id": "shoppercheckmanagement"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "shoppercheckmanagement-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getShopperCheckList()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4000) + "\n        ")]), _vm._v(" "), (
    _vm.globals.operationPermitted(
      'Entities.SurveyInstancePayment.AllowRead'
    )
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCheckPaymentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4021) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    on: {
      "click": function($event) {
        return _vm.openShopperCheckExportConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4004) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "tag": "button",
      "to": "/shoppermanagement"
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("exit_to_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.SM4001) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.SM4002
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "well user-info-box"
  }, [_c('span', [_vm._v(_vm._s(_vm.shopperData.LastName) + ", " + _vm._s(_vm.shopperData.FirstName) + " (" + _vm._s(_vm.shopperData.Username) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4023))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredShopperChecklist.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4024))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredShopperChecklist.length ||
        _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4025))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "shopperChecksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredShopperChecklist.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "shopperChecksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.SM4026))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4003) + "\n                  "), (_vm.showSortArrow('SurveyInstanceId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ProjectName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4005) + "\n                  "), (_vm.showSortArrow('ProjectName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ProjectName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('WaveName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4006) + "\n                  "), (_vm.showSortArrow('WaveName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('WaveName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ScenarioName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4007) + "\n                  "), (_vm.showSortArrow('ScenarioName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ScenarioName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ClientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4008) + "\n                  "), (_vm.showSortArrow('ClientName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ClientName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ImporterName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4022) + "\n                  "), (_vm.showSortArrow('ImporterName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ImporterName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4009) + "\n                  "), (_vm.showSortArrow('LocationName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationAddress')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4011) + "\n                  "), (_vm.showSortArrow('LocationAddress', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationAddress', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('LocationCountry')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4012) + "\n                  "), (_vm.showSortArrow('LocationCountry', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('LocationCountry', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4010) + "\n                  "), (_vm.showSortArrow('SurveyInstanceStatusId', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyInstanceStatusId', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementState')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4013) + "\n                  "), (_vm.showSortArrow('SettlementState', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementState', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementNumber')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4014) + "\n                  "), (_vm.showSortArrow('SettlementNumber', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementNumber', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SettlementDate')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SM4015) + "\n                  "), (_vm.showSortArrow('SettlementDate', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SettlementDate', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ProjectName),
      expression: "filterStrings.ProjectName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ProjectName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ProjectName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "checkStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "shopper-check-management-surveyinstance-status-id-select",
      "allowClear": true,
      "placeholder": _vm.lang.SM4016,
      "afterChange": function () {
        _vm.selectedPage = 1;
        _vm.doFiltering();
      }
    },
    model: {
      value: (_vm.filterStrings.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SurveyInstanceStatusId", $$v)
      },
      expression: "filterStrings.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.checkStates), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v("\n                      " + _vm._s(status) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [(Object.keys(_vm.settlementStatusses).length > 0) ? _c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "settlementStatusFilterContainer"
    }
  }, [_c('Select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "shopper-check-management-settlement-state-select",
      "allowClear": true,
      "placeholder": _vm.lang.SM4016,
      "afterChange": function () {
        _vm.selectedPage = 1;
        _vm.doFiltering();
      }
    },
    model: {
      value: (_vm.filterStrings.SettlementState),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SettlementState", $$v)
      },
      expression: "filterStrings.SettlementState"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.settlementStatusses), function(name, guid) {
    return _c('option', {
      key: guid,
      domProps: {
        "value": name
      }
    }, [_vm._v("\n                      " + _vm._s(name) + "\n                    ")])
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementNumber),
      expression: "filterStrings.SettlementNumber"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementDate),
      expression: "filterStrings.SettlementDate"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.SM4016
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementDate)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementDate", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shopperChecksOnCurrentPage), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceGuid)
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectChecks(check.SurveyInstanceGuid, $event)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.ProjectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.WaveName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.ScenarioName))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(check.ClientName) + "\n              ")]) : _c('td', [_vm._v(_vm._s(check.ImporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.LocationCountry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SurveyInstanceStatusId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SettlementState))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SettlementNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(check.SettlementDate))])])
  }), 0)])])])]), _vm._v(" "), _c('CheckPaymentModal', {
    attrs: {
      "showModal": _vm.showCheckPaymentModal,
      "surveyInstanceGuids": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        (_vm.showCheckPaymentModal = false), _vm.getShopperCheckList()
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1051))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1052))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            U1049\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadTranslationExportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1056) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importTranslation",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U1041))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U1042))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#textImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'text'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1043))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#fileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importTranslationDialogData.selectedOption = 'file'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U1044))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "textImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "textAreaImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importTranslationDialogData.selectedText),
      expression: "importTranslationDialogData.selectedText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "textAreaImport"
    },
    domProps: {
      "value": (_vm.importTranslationDialogData.selectedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.importTranslationDialogData, "selectedText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.lang.U1046))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "fileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "inputFileImport"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".csv, .xls, .xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    typeof _vm.importTranslationDialogData.selectedFile
    .name == 'undefined'
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1048))]) : _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.importTranslationDialogData.selectedFile.name))]), _vm._v(" "), _vm._m(0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1049) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U1050) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "surveyTranslateForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "surveyTranslationTopRow"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "translate-label control-label",
    attrs: {
      "for": "inputSurveyLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputSurveyLanguage",
      "width": '200px',
      "afterChange": _vm.selectedLanguageChanged,
      "placeholder": _vm.lang.U1072
    },
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  }, _vm._l((_vm.surveyLocales), function(value) {
    return _c('option', {
      key: value.LocaleCode,
      domProps: {
        "value": value.LocaleCode
      }
    }, [_vm._v("\n                    " + _vm._s(value.LocaleName) + "\n                  ")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslationExport_Create'
        ),
      "data-toggle": "modal",
      "data-target": "#exportTranslation"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0056) + "\n                ")]), _vm._v(" "), (_vm.globals.currentUserRole == 1) ? _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-success': !_vm.translationData.AllowAgencyEdit,
      'btn-warning': _vm.translationData.AllowAgencyEdit,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage
    },
    on: {
      "click": function($event) {
        return _vm.toggleAgencyTranslatePermission()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.translationData.AllowAgencyEdit ? _vm.lang.U1071 : _vm.lang.U1070) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.globals.currentUserRole == 2) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLanguage || !_vm.translationData.AllowAgencyEdit
    },
    on: {
      "click": function($event) {
        return _vm.submitTranslationsFromAgency()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U1073) + "\n                ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "modalScrollableArea",
    attrs: {
      "id": "surveyTranslation"
    }
  }, _vm._l((_vm.translationList), function(item, key) {
    return _c('div', {
      key: key
    }, [(_vm.isNewGroup(item.ParentId) && !item.QuestionName) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group col-md-12"
    }, [_c('label', {
      staticClass: "col-md-6 translate-label",
      class: {
        'translate-label-child': item.Key !== 'title' && item.ParentId > 0,
      },
      attrs: {
        "for": 'textareaTranslationElement' + key
      }
    }, [(item.Key === 'title' && item.QuestionNumber) ? _c('span', [_vm._v(_vm._s(item.QuestionNumber) + " -")]) : _vm._e(), _vm._v("\n                      " + _vm._s(item.Name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Translation),
        expression: "item.Translation"
      }],
      staticClass: "form-control textarea-survey-translations autoExpand",
      attrs: {
        "id": 'textareaTranslationElement' + key,
        "maxlength": _vm.maxlength_textarea,
        "rows": "1",
        "disabled": _vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit,
        "placeholder": item.InheritedTranslation
      },
      domProps: {
        "value": (item.Translation)
      },
      on: {
        "change": function($event) {
          _vm.translationListDirty = true
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Translation", $event.target.value)
        }
      }
    })])]), _vm._v("\n                  " + _vm._s(_vm.setNewGroup(item.ParentId)) + "\n                ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row modal-footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeTranslateSurveyDialog()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U1057) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.translationListDirty,
      'btn-success': !_vm.translationListDirty,
    },
    attrs: {
      "type": "button",
      "disabled": _vm.translationList.length < 1 ||
        !_vm.globals.isAccessAllowed(
          'LoopOp_SurveyTranslation_Update'
        ) ||
        (_vm.globals.currentUserRole == 2 &&
          !_vm.translationData.AllowAgencyEdit)
    },
    on: {
      "click": function($event) {
        return _vm.saveTranslateSurveyDialogData()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.U0023) + "\n              ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "checkImportModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.importDataChecked) ? _c('div', [_c('p', [_vm._v("Enter the SurveyID and select your import file. Then click on 'Check Data'. The file will be checked and potential problems will be shown.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getSurveyDataAndCheckImportData()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sid),
      expression: "sid"
    }],
    attrs: {
      "type": "number",
      "name": "sid",
      "id": "sidInput",
      "placeholder": "SID",
      "required": ""
    },
    domProps: {
      "value": (_vm.sid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control nopadding",
    attrs: {
      "id": "checkImportFileInput",
      "type": "file",
      "accept": ".xlsx",
      "required": ""
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Check Data")])])]) : _vm._e(), _vm._v(" "), (_vm.importDataChecked && !_vm.importFinished) ? _c('div', [(!_vm.showUndefinedElements && _vm.invalidChecks.length == 0 && !_vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("No Problems found! Proceed with import by clicking 'Import'")]) : _vm._e(), _vm._v(" "), (_vm.showUndefinedElements || _vm.invalidChecks.length != 0 || _vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("The following problems have been identified:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion"
  }, [(_vm.invalidChecks.length != 0) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionInvalidChecks"),
      expression: "`accordionInvalidChecks`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconInvalidChecks')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Invalid Checks")]), _vm._v(" (" + _vm._s(_vm.invalidChecks.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconInvalidChecks"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionInvalidChecks"
    }
  }, _vm._l((_vm.invalidChecks), function(check) {
    return _c('div', {
      key: check.checkId
    }, [_c('p', [_vm._v("Row: " + _vm._s(check.row) + ", CheckID: " + _vm._s(check.checkId) + ", Message: " + _vm._s(check.msg))])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.showUndefinedElements) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionUndefinedElements"),
      expression: "`accordionUndefinedElements`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconUndefinedElements')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Undefined Elements")]), _vm._v(" (" + _vm._s(_vm.undefinedElements.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconUndefinedElements"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionUndefinedElements"
    }
  }, _vm._l((_vm.undefinedElements), function(e) {
    return _c('div', {
      key: e.guid
    }, [_c('p', [_vm._v("Column: " + _vm._s(e.column) + ", GUID: " + _vm._s(e.guid))])])
  }), 0)], 1) : _vm._e(), _vm._v(" "), (_vm.showUndefinedQuestionChoices) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionUndefinedQuestionChoices"),
      expression: "`accordionUndefinedQuestionChoices`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconUndefinedQuestionChoices')
      }
    }
  }, [_c('span', [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Undefined Question Choices")]), _vm._v(" (" + _vm._s(_vm.undefinedQuestionChoices.length) + ")")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconUndefinedQuestionChoices"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionUndefinedQuestionChoices"
    }
  }, _vm._l((_vm.undefinedQuestionChoices), function(e, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v("Row: " + _vm._s(e.row) + ", Column: " + _vm._s(e.column) + ", CheckID: " + _vm._s(e.check) + ", GUID: " + _vm._s(e.guid))])])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), (_vm.showUndefinedElements || _vm.invalidChecks.length != 0 || _vm.showUndefinedQuestionChoices) ? _c('p', [_vm._v("Do you want to proceed? Problematic elements will be skipped.")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.enableUpload()
    },
    on: {
      "click": function($event) {
        return _vm.saveSurveys()
      }
    }
  }, [_vm._v("\n            Import\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.importFinished) ? _c('div', [_c('p', [_vm._v("The import was finished.")]), _vm._v(" "), _c('p', [_vm._v("Start: " + _vm._s(_vm.importStart))]), _vm._v(" "), _c('p', [_vm._v("End: " + _vm._s(_vm.importEnd))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.failedRequests.length) + " check imports failed.")]), _vm._v(" "), _c('div', {
    staticClass: "accordion"
  }, [(_vm.showFailedRequests) ? _c('div', {
    staticClass: "accordionElement"
  }, [_c('button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: ("accordionFailedRequests"),
      expression: "`accordionFailedRequests`"
    }],
    staticClass: "accordionBtn",
    on: {
      "click": function($event) {
        return _vm.turnAround('iconFailedRequests')
      }
    }
  }, [_c('span', {
    staticClass: "accordionElementTitle"
  }, [_vm._v("Failed Requests")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "iconFailedRequests"
    }
  }, [_vm._v("\n                  expand_more\n                ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "accordionContent",
    attrs: {
      "id": "accordionFailedRequests"
    }
  }, _vm._l((_vm.failedRequests), function(e, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v("CheckID: " + _vm._s(e.check) + ", Time: " + _vm._s(e.time))])])
  }), 0)], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Close\n          ")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("CHECK IMPORT")])])])
}]}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SAM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SAM001))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM002) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM003) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM004) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM005) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperId))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM006) + " (" + _vm._s(_vm.lang.SAM007) + "):\n                    "), _c('b', [_vm._v(_vm._s(proposal.DisplayName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM008) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Gender))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM009) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Distance) + " km")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (proposal.Profession),
        expression: "proposal.Profession"
      }]
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM010) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Profession))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM011) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarModelName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM012) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarSegmentName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM013) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperCar))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM014) + ":\n                    "), _c('b', [(proposal.CarMatch === '-') ? _c('span', [_vm._v("- " + _vm._s(_vm.lang.SAM015))]) : (proposal.CarMatch === '=') ? _c('span', [_vm._v("= " + _vm._s(_vm.lang.SAM016))]) : (proposal.CarMatch === '+') ? _c('span', [_vm._v("+ " + _vm._s(_vm.lang.SAM017))]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM018) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.LastUpdatedAt))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.globals.isLeadAgencyUser) ? _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Agency')
        }
      }
    }, [_vm._v(_vm._s(_vm.lang.SAM019))]), _vm._v(" "), (proposal.LastCommentLeadLocal) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadLocalCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(
      proposal.LastCommentLeadLocal,
      120
    )) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Audi')
        }
      }
    }, [_vm._v(_vm._s(_vm.globals.isAudiUser ? _vm.lang.SAM021 : _vm.lang.SAM020))]), _vm._v(" "), (proposal.LastCommentLeadAudi) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadAudiCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(
      proposal.LastCommentLeadAudi,
      120
    )) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.AgencyApprovalStatus),
        expression: "proposal.AgencyApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.AgencyApprovalStatus === 'Approved',
        'option-red': proposal.AgencyApprovalStatus === 'Rejected',
        'option-yellow': !proposal.AgencyApprovalStatus,
      },
      attrs: {
        "disabled": !_vm.globals.isAgencyUser ||
          proposal.MainEntityApprovalStatus
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "AgencyApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'leadAgency')
        }]
      }
    }, [_c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.MainEntityApprovalStatus),
        expression: "proposal.MainEntityApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.MainEntityApprovalStatus === 'Approved',
        'option-red': proposal.MainEntityApprovalStatus === 'Rejected',
        'option-yellow': !proposal.MainEntityApprovalStatus,
      },
      attrs: {
        "disabled": !_vm.globals.isAudiUser ||
          proposal.AgencyApprovalStatus !== 'Approved'
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "MainEntityApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'mainEntity')
        }]
      }
    }, [(
      !_vm.anyShopperAlreadyApproved ||
      proposal.MainEntityApprovalStatus === 'Approved'
    ) ? _c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SAM025) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "importUsersDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.importStep === 1) ? _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.feature.isAudiTarget) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersUserTypeSelect"
    }
  }, [_vm._v("User Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.importUsersDialogData.UserTypeId,
    staticClass: "form-control",
    attrs: {
      "id": "importUsersUserTypeSelect",
      "afterChange": function (u) {
        _vm.selectedRoleID = u;
      },
      "dataTransformer": function (data) { return Number(data[0].id); },
      "placeholder": 'Please select an user type...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.UserTypeId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "UserTypeId", $$v)
      },
      expression: "importUsersDialogData.UserTypeId"
    }
  }, _vm._l((_vm.roleData.filter(
    function (r) { return r.RoleTypeName !== 'MSM_Administrator'; }
  )), function(type) {
    return _c('option', {
      key: type.RoleTypeGuid,
      attrs: {
        "disabled": type.UserTypeId != 4
      },
      domProps: {
        "value": type.UserTypeId
      }
    }, [_vm._v("\n                  " + _vm._s(type.RoleTypeDisplayName) + "\n                ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedRoleID == 4),
      expression: "selectedRoleID == 4"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersClientSelect"
    }
  }, [_vm._v("Client *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.importUsersDialogData.UserTypeId,
    staticClass: "form-control",
    attrs: {
      "id": "importUsersClientSelect",
      "placeholder": 'Please select a client...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.ClientId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "ClientId", $$v)
      },
      expression: "importUsersDialogData.ClientId"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientId,
      domProps: {
        "value": client.ClientId
      }
    }, [_vm._v("\n                  " + _vm._s(client.ClientName) + "\n                ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedRoleID == 2),
      expression: "selectedRoleID == 2"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "importUsersAgencySelect"
    }
  }, [_vm._v("Partner")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    key: _vm.importUsersDialogData.UserTypeId,
    staticClass: "form-control",
    attrs: {
      "id": "importUsersAgencySelect",
      "placeholder": 'Please select a partner...',
      "allowClear": true
    },
    model: {
      value: (_vm.importUsersDialogData.AgencyId),
      callback: function($$v) {
        _vm.$set(_vm.importUsersDialogData, "AgencyId", $$v)
      },
      expression: "importUsersDialogData.AgencyId"
    }
  }, _vm._l((_vm.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyId
      }
    }, [_vm._v("\n                  " + _vm._s(agency.AgencyName) + "\n                ")])
  }), 0)], 1)])] : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs nav-import",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#importUsersTextImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.selectedOption = 'text'
      }
    }
  }, [_vm._v("Text")])]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Upload_Create')) ? _c('li', [_c('a', {
    attrs: {
      "href": "#importUsersFileImport",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.selectedOption = 'file'
      }
    }
  }, [_vm._v("File")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "importUsersTabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "importUsersTextImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "importUsersImportTextArea"
    }
  }, [_vm._v("Text-Import")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importUsersDialogData.selectedText),
      expression: "importUsersDialogData.selectedText"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "importUsersImportTextArea"
    },
    domProps: {
      "value": (_vm.importUsersDialogData.selectedText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.importUsersDialogData, "selectedText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "importUsersFileImport"
    }
  }, [_c('label', {
    staticClass: "col-md-1 control-label",
    attrs: {
      "for": "importUsersImportFileInput"
    }
  }, [_vm._v("File-Import")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "importUsersImportFileInput",
      "type": "file",
      "accept": ".xlsx"
    },
    on: {
      "change": _vm.onImportFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.importUsersDialogData.selectedFile.name) ? _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v("Bitte wählen Sie eine Datei...")]) : _c('label', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_vm._v(_vm._s(_vm.importUsersDialogData.selectedFile.name))]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.importUsersDialogData.trimImportData = !_vm.importUsersDialogData.trimImportData
      }
    }
  }, [(_vm.importUsersDialogData.trimImportData) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v("\n                  Trim import data\n                ")])])])])])], 2) : _vm._e(), _vm._v(" "), (_vm.importStep === 2) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n          An folgenden Positionen der hochgeladenen Daten, sind Fehler\n          aufgetreten:\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.importStep === 3) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n          Eine Liste der generierten Passwörter steht jetzt zum Download\n          bereit\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), (_vm.importStep === 1) ? _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadImportData()
      }
    }
  }, [_vm._v("\n          Upload\n        ")]) : _vm._e(), _vm._v(" "), (_vm.importStep === 3) ? _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadUserList()
      }
    }
  }, [_vm._v("\n          Download\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Import Users")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bitte wählen Sie eine Option aus")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')) ? _c('div', [_c('SurveyManagementEditModal', {
    attrs: {
      "selectedSurvey": _vm.selectedSurvey,
      "showDialog": _vm.showEditSurveyDialog,
      "dialogModeAdd": _vm.editSurveyDialogModeAdd,
      "copySurvey": _vm.copySurvey,
      "languageList": _vm.languageList,
      "localesList": _vm.localesList
    },
    on: {
      "surveyEditorRedirect": _vm.redirectToSurveyEditor,
      "dialogClosed": _vm.onEditSurveyDialogClosed,
      "dialogDataSaved": _vm.onEditSurveyDialogDataSaved
    }
  }), _vm._v(" "), (_vm.selectedSurvey) ? _c('SurveyManagementTranslateModal', {
    attrs: {
      "selectedSurvey": _vm.selectedSurvey.SurveyId,
      "showDialog": _vm.showTranslateSurveyDialog
    },
    on: {
      "dialogClosed": _vm.onTranslateSurveyDialogClosed
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "surveys-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getSurveyData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0000) + "\n        ")]), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedSurvey = null),
        (_vm.editSurveyDialogModeAdd = true),
        (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-edit-button",
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false), (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false),
        (_vm.showEditSurveyDialog = true),
        (_vm.copySurvey = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0034) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_Surveys_Delete')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-delete-button",
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteSurveyDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0003) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_Surveys_Read') &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSurveyEditor(_vm.selectedSurvey.SurveyId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add_check")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0004) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyTranslation_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "survey-management-translation-button",
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.openSelectSurveyLanguageDialog(_vm.selectedSurvey.SurveyId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0037) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyTranslation_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedSurvey
    },
    on: {
      "click": function($event) {
        return _vm.downloadSurvey(_vm.selectedSurvey)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("get_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.U0045) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.Search),
      expression: "filterStrings.Search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "inputSearch",
      "placeholder": _vm.lang.U0005
    },
    domProps: {
      "value": (_vm.filterStrings.Search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "Search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0006))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0007))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0008))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "surveysTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.totalElementsCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "surveysTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.U0044))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover survey-management-main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyId')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0009) + "\n                  "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyTitle')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0010) + "\n                  "), (_vm.sortField == 'SurveyTitle' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyTitle' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('ClientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0011) + "\n                  "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ClientName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('ImporterName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0043) + "\n                  "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ImporterName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyCreatedAt')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0012) + "\n                  "), (
    _vm.sortField == 'SurveyCreatedAt' && _vm.sortOrder == 'asc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (
    _vm.sortField == 'SurveyCreatedAt' && _vm.sortOrder == 'desc'
  ) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('CurrentUser')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0035) + "\n                  "), (_vm.sortField == 'CurrentUser' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'CurrentUser' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortSurveyData('SurveyActive')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.U0036) + "\n                  "), (_vm.sortField == 'SurveyActive' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyActive' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyTitle),
      expression: "filterStrings.SurveyTitle"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ClientName),
      expression: "filterStrings.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ImporterName),
      expression: "filterStrings.ImporterName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.ImporterName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ImporterName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyCreatedAt),
      expression: "filterStrings.SurveyCreatedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyCreatedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyCreatedAt", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.CurrentUser),
      expression: "filterStrings.CurrentUser"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.U0014
    },
    domProps: {
      "value": (_vm.filterStrings.CurrentUser)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getSurveyData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "CurrentUser", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        (_vm.filterStrings.SurveyActive =
          (_vm.filterStrings.SurveyActive + 1) % 3),
        _vm.getSurveyData()
      }
    }
  }, [(_vm.filterStrings.SurveyActive === 1) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box")])]) : (_vm.filterStrings.SurveyActive === 0) ? _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")])]) : _c('div', {
    staticClass: "cb-active-filter-container"
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("indeterminate_check_box")])])])])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveyData), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      staticClass: "survey-management-survey-row",
      class: {
        info: _vm.selectedSurvey &&
          survey.SurveyGuid == _vm.selectedSurvey.SurveyGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedSurvey = survey
        },
        "dblclick": function($event) {
          (_vm.editSurveyDialogModeAdd = false),
          (_vm.showEditSurveyDialog = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.SurveyTitle))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(survey.ClientName) + "\n              ")]) : _c('td', [_vm._v(_vm._s(survey.ImporterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.SurveyCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.CurrentUser))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "6px 0 0 0"
      }
    }, [(survey.SurveyActive) ? _c('i', {
      staticClass: "material-icons md-24 survey-active"
    }, [_vm._v("done")]) : _c('i', {
      staticClass: "material-icons md-24 survey-inactive"
    }, [_vm._v("clear")])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "deleteSurvey",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.U0024))])])]), _vm._v(" "), (_vm.selectedSurvey) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.U0025))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0026))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0027))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0028))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.ClientName))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.U0029))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.selectedSurvey.SurveyCreatedAt))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "id": "survey-management-delete-false-dialog-button",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0030) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "id": "survey-management-delete-true-dialog-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteSurveyData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0031) + "\n          ")])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.currentUserRole > 0) ? _c('div', {
    attrs: {
      "id": "pageNotFoundComponent"
    }
  }, [_c('h1', [_vm._v("😕")]), _vm._v(" "), _c('h2', [_vm._v("Oh no! How did you get here?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.setInitialRoute
    }
  }, [_vm._v("Click here to get back on track")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editChecksDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editChecksForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditChecks",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditChecksGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditChecksGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksGeneral"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceVisibleInNotification')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceVisibleInNotification >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceVisibleInNotification <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1002))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceExternalInterface')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceExternalInterface >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceExternalInterface <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1003))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceLocationNotification')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceLocationNotification >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceLocationNotification <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1004))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceQueryTool')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceQueryTool > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceQueryTool < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1005))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceDashboard')
      }
    }
  }, [(_vm.generalSettingsData.SurveyInstanceDashboard > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceDashboard < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1006))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceCheckExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceCheckExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceCheckExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1007))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceAggregatedReport')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceAggregatedReport >
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceAggregatedReport <
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1008))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceRawDataExports')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceRawDataExports > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceRawDataExports < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1009))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceFrequencies')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceFrequencies > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceFrequencies < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1010))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceMediaExplorer')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceMediaExplorer > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceMediaExplorer < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1011))])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-cb-edit-checks",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        _vm.generalSettingsData.IsReadonly ||
          _vm.toggleSetting('SurveyInstanceCxReporting')
      }
    }
  }, [(
    _vm.generalSettingsData.SurveyInstanceCxReporting > 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.generalSettingsData.SurveyInstanceCxReporting < 0
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1077))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCustomReportingDateCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1013))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      ),
      expression: "\n                            generalSettingsData.SurveyInstanceCustomReportingDate\n                          "
    }],
    staticClass: "form-control custom-reporting-date-input",
    attrs: {
      "type": "date",
      "id": "inputCustomReportingDateCheckMgmtEdit",
      "disabled": _vm.disabled.inputCustomReportingDateCheckMgmtEdit
    },
    domProps: {
      "value": (
        _vm.generalSettingsData.SurveyInstanceCustomReportingDate
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceCustomReportingDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 200\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "inputCustomReportingDateCheckMgmtEditToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'inputCustomReportingDateCheckMgmtEdit'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), (_vm.languageStringsReceived && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurveyInstanceType"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    key: _vm.selectedCheckIds[0],
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurveyInstanceType",
      "afterChange": _vm.surveyInstanceTypeChanged,
      "disabled": _vm.disabled.checkManagementEditModalSelectSurveyInstanceType
    },
    model: {
      value: (_vm.generalSettingsData.SurveyInstanceType),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceType", $$v)
      },
      expression: "generalSettingsData.SurveyInstanceType"
    }
  }, [_c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1037))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1038))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1039))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCT"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1074))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DCA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1075))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 200\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectSurveyInstanceTypeToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectSurveyInstanceType'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.generalSettingsData.SurveyInstanceType === 'FO' ||
        _vm.generalSettingsData.SurveyInstanceType === 'MA'
      ),
      expression: "\n                        generalSettingsData.SurveyInstanceType === 'FO' ||\n                        generalSettingsData.SurveyInstanceType === 'MA'\n                      "
    }],
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectUser"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    key: _vm.generalSettingsData.SurveyInstanceType,
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectUser",
      "name": "checkManagementEditModalSelectUser",
      "afterChange": _vm.SurveyInstanceShopperChanged,
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectUser
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedShopperGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedShopperGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceAssignedShopperGuid\n                          "
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.generalSettingsData.SurveyInstanceType) + "\n                          "), _vm._l((_vm.dataLists.shopperList), function(user) {
    return _c('option', {
      key: user.Guid,
      domProps: {
        "value": user.Guid
      }
    }, [_vm._v("\n                            " + _vm._s(user.Shopper) + "\n                          ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 200\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectUserToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('checkManagementEditModalSelectUser');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), (_vm.generalSettingsData.SurveyInstanceType === 'AG') ? [(
    _vm.feature.isAudiTarget &&
    _vm.feature.isEnabled('leadAgencies')
  ) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.generalSettingsData.SurveyInstanceType === 'AG'
      ),
      expression: "\n                            generalSettingsData.SurveyInstanceType === 'AG'\n                          "
    }],
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLeadAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1066))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    ref: "checkEditSelectLeadAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLeadAgency",
      "name": "checkManagementEditModalSelectLeadAgency",
      "afterChange": _vm.SurveyInstanceAssignedLeadAgencyGuidChanged,
      "disabled": _vm.disabled.checkManagementEditModalSelectLeadAgency
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLeadAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLeadAgencyGuid\n                              "
    }
  }, _vm._l((_vm.leadAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                                this.generalSettingsData\n                                  .MaxSurveyInstanceStatusId <= 200\n                              "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectLeadAgencyToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectLeadAgency'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), (!_vm.globals.currentUserInfo.IsAudiUser) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocalAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1067))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    ref: "checkEditSelectLocalAgency",
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocalAgency",
      "name": "checkManagementEditModalSelectLocalAgency",
      "afterChange": _vm.SurveyInstanceAssignedLocalAgencyGuidChanged,
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectLocalAgency
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                                generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                              "
    }
  }, _vm._l((_vm.localAgencies), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                                " + _vm._s(agency.AgencyName) + "\n                              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                                this.generalSettingsData\n                                  .MaxSurveyInstanceStatusId <= 200\n                              "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectLocalAgencyToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectLocalAgency'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e()] : _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1016))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectAgency",
      "name": "checkManagementEditModalSelectAgency",
      "afterChange": _vm.SurveyInstanceAssignedLocalAgencyGuidChanged,
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectAgency
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceAssignedLocalAgencyGuid", $$v)
      },
      expression: "\n                              generalSettingsData.SurveyInstanceAssignedLocalAgencyGuid\n                            "
    }
  }, _vm._l((_vm.dataLists.agencyList), function(agency) {
    return _c('option', {
      key: agency.AgencyGuid,
      domProps: {
        "value": agency.AgencyGuid
      }
    }, [_vm._v("\n                              " + _vm._s(agency.AgencyName) + "\n                            ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectAgencyToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectAgency'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])])] : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      "for": "checkManagementEditModalSelectWave"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectWave",
      "name": "checkManagementEditModalSelectWave",
      "afterChange": _vm.SurveyInstanceWaveGuidChanged,
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectWave
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceWaveGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceWaveGuid", $$v)
      },
      expression: "\n                              generalSettingsData.SurveyInstanceWaveGuid\n                            "
    }
  }, _vm._l((_vm.wavesOfProject), function(wave) {
    return _c('option', {
      key: wave.WaveGuid,
      domProps: {
        "value": wave.WaveGuid
      }
    }, [_vm._v("\n                              " + _vm._s(wave.WaveName) + "\n                            ")])
  }), 0)], 1), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      "for": "checkManagementEditModalSelectScenario"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1014))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "padding-right": "0px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectScenario",
      "name": "checkManagementEditModalSelectScenario",
      "disabled": _vm.disabled.checkManagementEditModalSelectScenario ||
        !_vm.generalSettingsData.SurveyInstanceWaveGuid,
      "placeholder": ' ',
      "allowClear": true
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceScenarioGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceScenarioGuid", $$v)
      },
      expression: "\n                              generalSettingsData.SurveyInstanceScenarioGuid\n                            "
    }
  }, _vm._l((_vm.scenariosOfWave), function(scenario) {
    return _c('option', {
      key: scenario.ScenarioGuid,
      domProps: {
        "value": scenario.ScenarioGuid
      }
    }, [_vm._v("\n                              " + _vm._s(scenario.ScenarioName) + "\n                            ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 200\n                          "
    }],
    staticClass: "btn-edit",
    staticStyle: {
      "position": "relative",
      "overflow": "hidden",
      "margin-top": "25px"
    },
    attrs: {
      "id": "checkManagementEditModalSelectWaveToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('checkManagementEditModalSelectWave');
        _vm.toggleBtn(
          'checkManagementEditModalSelectScenario'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e(), _vm._v(" "), (_vm.projectSelected) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectLocation"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectLocation",
      "name": "checkManagementEditModalSelectLocation",
      "afterChange": _vm.selectedLocationChanged,
      "disabled": _vm.disabled.checkManagementEditModalSelectLocation
    },
    model: {
      value: (
        _vm.generalSettingsData.SurveyInstanceLocationGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceLocationGuid", $$v)
      },
      expression: "\n                            generalSettingsData.SurveyInstanceLocationGuid\n                          "
    }
  }, _vm._l((_vm.locationsOfSelectedClient), function(location) {
    return _c('option', {
      key: location.LocationGuid,
      domProps: {
        "value": location.LocationGuid
      }
    }, [_vm._v("\n                            (" + _vm._s(location.LocationStoreId) + ")\n                            " + _vm._s(location.LocationAddress) + "\n                          ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 190 &&
        _vm.generalSettingsData.SurveyInstanceLocationGuid !=
        '-1'
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 190 &&\n                            generalSettingsData.SurveyInstanceLocationGuid !=\n                              '-1'\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectLocationToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectLocation'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedProject) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectBriefing"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectBriefing",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectBriefing
    },
    model: {
      value: (_vm.generalSettingsData.BriefingDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "BriefingDownloadGuid", $$v)
      },
      expression: "generalSettingsData.BriefingDownloadGuid"
    }
  }, _vm._l((_vm.briefingAttachments), function(briefing) {
    return _c('option', {
      key: briefing.DownloadId,
      domProps: {
        "value": briefing.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(briefing.FileName) + "\n                          ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 190
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 190\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectBriefingToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'checkManagementEditModalSelectBriefing'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedProject) ? _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "checkManagementEditModalSelectSurvey"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "checkManagementEditModalSelectSurvey",
      "placeholder": ' ',
      "allowClear": true,
      "disabled": _vm.disabled.checkManagementEditModalSelectSurvey
    },
    model: {
      value: (_vm.generalSettingsData.SurveyDownloadGuid),
      callback: function($$v) {
        _vm.$set(_vm.generalSettingsData, "SurveyDownloadGuid", $$v)
      },
      expression: "generalSettingsData.SurveyDownloadGuid"
    }
  }, _vm._l((_vm.surveyAttachments), function(survey) {
    return _c('option', {
      key: survey.DownloadId,
      domProps: {
        "value": survey.DownloadId
      }
    }, [_vm._v("\n                            " + _vm._s(survey.FileName) + "\n                          ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 190
      ),
      expression: "\n                            this.generalSettingsData\n                              .MaxSurveyInstanceStatusId <= 190\n                          "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "checkManagementEditModalSelectSurveyToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('checkManagementEditModalSelectSurvey');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditSurveyInstanceInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1056))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceInfo),
      expression: "generalSettingsData.SurveyInstanceInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputCheckEditSurveyInstanceInfo",
      "disabled": _vm.disabled.inputCheckEditSurveyInstanceInfo
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn-edit",
    attrs: {
      "id": "inputCheckEditSurveyInstanceInfoToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('inputCheckEditSurveyInstanceInfo');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.generalSettingsData.SurveyInstanceType === 'FO'),
      expression: "generalSettingsData.SurveyInstanceType === 'FO'"
    }]
  }, [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditStartDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceSince),
      expression: "generalSettingsData.SurveyInstanceSince"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "inputCheckEditStartDate",
      "disabled": _vm.disabled.inputCheckEditStartDate
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceSince)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSince", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "inputCheckEditStartDateToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('inputCheckEditStartDate');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputCheckEditEndDate"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceUntil),
      expression: "generalSettingsData.SurveyInstanceUntil"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "inputCheckEditEndDate",
      "disabled": _vm.disabled.inputCheckEditEndDate
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceUntil)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "inputCheckEditEndDateToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('inputCheckEditEndDate');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectCheckEditSurveyInstanceSkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1057))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.generalSettingsData.SurveyInstanceSkillLevel
      ),
      expression: "\n                              generalSettingsData.SurveyInstanceSkillLevel\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectCheckEditSurveyInstanceSkillLevel",
      "disabled": _vm.disabled.selectCheckEditSurveyInstanceSkillLevel
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceSkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeCounter()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.generalSettingsData.SurveySkillLevel
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.CM1061) + "\n                              "), _c('span', [_vm._v("(" + _vm._s(_vm.generalSettingsData.SurveySkillLevel) + ")")])]), _vm._v(" "), _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v("\n                              " + _vm._s(i) + "\n                            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "selectCheckEditSurveyInstanceSkillLevelToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn(
          'selectCheckEditSurveyInstanceSkillLevel'
        );
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectCheckEditSurveyInstanceSkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                          1 → " + _vm._s(_vm.lang.CM1058) + "\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                          5 → " + _vm._s(_vm.lang.CM1059) + "\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "onlineStatus"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.disabled.onlineStatus
    },
    on: {
      "click": function () {
        if (!_vm.disabled.onlineStatus) {
          _vm.generalSettingsData.IsReadonly ||
            _vm.toggleSettingNew('OnlineState');
          return false;
        }
      }
    }
  }, [(_vm.generalSettingsData.OnlineState > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.OnlineState < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1042))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "onlineStatusToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('onlineStatus');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "locationFreeStatus"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-state",
    attrs: {
      "role": "button",
      "disabled": _vm.generalSettingsData.IsReadonly ||
        _vm.disabled.locationFreeStatus
    },
    on: {
      "click": function () {
        if (!_vm.disabled.locationFreeStatus) {
          _vm.generalSettingsData.IsReadonly ||
            _vm.toggleSettingNew('LocationFree');
          return false;
        }
      }
    }
  }, [(_vm.generalSettingsData.LocationFree > 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.generalSettingsData.LocationFree < 0) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]) : _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM1043))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "locationFreeToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('locationFreeStatus');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openHtmlEditor()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1044) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.generalSettingsData.IsReadonly
    },
    on: {
      "click": function($event) {
        return _vm.openShopperFilterModal()
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.CM1053) + "\n                        ")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group fg-general-settings-input"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditSurveyInstanceNote"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1052))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.generalSettingsData.SurveyInstanceNote),
      expression: "generalSettingsData.SurveyInstanceNote"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "maxlength": "1000",
      "id": "inputEditSurveyInstanceNote",
      "disabled": _vm.disabled.inputEditSurveyInstanceNote
    },
    domProps: {
      "value": (_vm.generalSettingsData.SurveyInstanceNote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.generalSettingsData, "SurveyInstanceNote", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        this.generalSettingsData
        .MaxSurveyInstanceStatusId <= 200
      ),
      expression: "\n                              this.generalSettingsData\n                                .MaxSurveyInstanceStatusId <= 200\n                            "
    }],
    staticClass: "btn-edit",
    attrs: {
      "id": "inputEditSurveyInstanceNoteToggle",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleBtn('inputEditSurveyInstanceNote');
        return false;
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")])])])])])], 2)]) : _vm._e()]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksSpecific",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksSpecific",
      "aria-expanded": "false",
      "aria-controls": "collapseEditChecksSpecific"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.CM1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_Read'
    ) && !_vm.generalSettingsData.IsReadonly
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditChecksSpecific",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksSpecific"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "checkListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.CM1018) + "\n                          ")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "check-list-table"
    }
  }, _vm._l((_vm.specificSettingsData.dataList), function(check, key) {
    return _c('tr', {
      key: key,
      class: {
        info: _vm.specificSettingsData.selectedCheck
          .SurveyInstanceGuid ===
          check.SurveyInstanceGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.specificSettingsData.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(
    _vm.specificSettingsData.selectedCheck.ApprovedShopper
  ) ? _c('div', {
    staticClass: "shopper-info"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.CM1068) + ":")]), _vm._v("\n                      " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .DisplayName) + "\n                      "), _c('div', {
    attrs: {
      "id": "approvedShopperDetailsContainer"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.CM1069) + " (" + _vm._s(_vm.lang.CM1070) + "):\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperAge) + "\n                        (" + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .Gender) + ")\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1071) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .ShopperCar) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1072) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarSegmentName) + "\n                        "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.CM1073) + ":\n                        " + _vm._s(_vm.specificSettingsData.selectedCheck.ApprovedShopper
    .CarModelName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputDateOfVisitCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerDateOfVisit\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "type": "date",
      "id": "inputDateOfVisitCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerDateOfVisit
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeInCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1020))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeIn\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "type": "time",
      "id": "inputTimeInCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeIn
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeIn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputTimeOutCheckMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1021))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerTimeOut\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "type": "time",
      "id": "inputTimeOutCheckMgmtEdit",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerTimeOut
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerTimeOut", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoShopper"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoShopper\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "rows": "4",
      "id": "inputMemoShopper",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoShopper
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoShopper", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoAgency"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoAgency\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "rows": "4",
      "id": "inputMemoAgency",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoAgency
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoAgency", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputMemoMSM"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      ),
      expression: "\n                            specificSettingsData.selectedCheck\n                              .SurveyInstanceAnswerMemoMSM\n                          "
    }],
    staticClass: "form-control specific-settings-data-input",
    attrs: {
      "rows": "4",
      "id": "inputMemoMSM",
      "disabled": !_vm.globals.isAccessAllowed(
        'LoopOp_SurveyInstancesAnswers_Update'
      )
    },
    domProps: {
      "value": (
        _vm.specificSettingsData.selectedCheck
        .SurveyInstanceAnswerMemoMSM
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.specificSettingsData.selectedCheck, "SurveyInstanceAnswerMemoMSM", $event.target.value)
      }
    }
  })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.feature.isMSMGermanyTarget) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditChecksControlling",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditChecks",
      "href": "#collapseEditChecksControlling",
      "aria-expanded": "false",
      "aria-controls": "collapseEditChecksControlling"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.feature.isMSMGermanyTarget) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditChecksControlling",
      "role": "tabpanel",
      "aria-labelledby": "headingEditChecksControlling"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 container-scrollbar",
    attrs: {
      "id": "controllingCheckListContainer"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.CM1018) + "\n                          ")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar",
    attrs: {
      "id": "controlling-check-list-table"
    }
  }, _vm._l((_vm.controllingSettingsData.dataList), function(check, key) {
    return _c('tr', {
      key: key,
      class: {
        info: _vm.controllingSettingsData.selectedCheck
          .SurveyInstanceGuid ===
          check.SurveyInstanceGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.controllingSettingsData.selectedCheck = check
        }
      }
    }, [_c('td', [_vm._v(_vm._s(check.SurveyInstanceId))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "check-management-edit-subprojects"
    }
  }, [_vm._v("Subproject")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    key: _vm.controllingSettingsData.selectedCheck.SubProjectId,
    attrs: {
      "id": "check-management-edit-subprojects",
      "placeholder": "Select Subproject",
      "allowClear": true,
      "afterChange": _vm.controllSettingDataChanged
    },
    model: {
      value: (
        _vm.controllingSettingsData.selectedCheck.SubProjectId
      ),
      callback: function($$v) {
        _vm.$set(_vm.controllingSettingsData.selectedCheck, "SubProjectId", $$v)
      },
      expression: "\n                          controllingSettingsData.selectedCheck.SubProjectId\n                        "
    }
  }, _vm._l((_vm.filteredSubProjects), function(subProject) {
    return _c('option', {
      key: subProject.SubProjectId,
      domProps: {
        "value": subProject.SubProjectId
      }
    }, [_vm._v("\n                          " + _vm._s(subProject.SubProjectName) + "\n                        ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "check-management-edit-order"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    key: _vm.controllingSettingsData.selectedCheck.OrderId,
    attrs: {
      "id": "check-management-edit-order",
      "placeholder": "Select Order",
      "allowClear": true,
      "afterChange": _vm.controllSettingDataChanged
    },
    model: {
      value: (
        _vm.controllingSettingsData.selectedCheck.OrderId
      ),
      callback: function($$v) {
        _vm.$set(_vm.controllingSettingsData.selectedCheck, "OrderId", $$v)
      },
      expression: "\n                          controllingSettingsData.selectedCheck.OrderId\n                        "
    }
  }, _vm._l((_vm.filteredOrders), function(order) {
    return _c('option', {
      key: order.OrderId,
      domProps: {
        "value": order.OrderId
      }
    }, [_vm._v("\n                          " + _vm._s(order.OrderName) + "\n                        ")])
  }), 0)], 1)])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1025) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disableSaveButton && !_vm.shopperFilterDataDirty
    },
    on: {
      "click": function($event) {
        return _vm.saveEditCheckDialogData()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.CM1026) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v("Controlling Settings")])])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    class: {
      'text-red': _vm.Recommended && !_vm.value
    },
    attrs: {
      "for": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid)
    }
  }, [_vm._v("\n    " + _vm._s(_vm.Title) + "\n    "), (_vm.Recommended) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": ("input-shopper-custprop-" + _vm.Guid + "-" + _vm._uid),
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKpiDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM2000))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM2026) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2029) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedProject) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM2028) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedClient,
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-edit-modal-client-select",
      "afterChange": _vm.selectedClientChanged,
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedProjectGuid,
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-edit-modal-project-select",
      "disabled": _vm.clientProjectList.length < 1,
      "placeholder": _vm.lang.KM2030,
      "allowClear": true,
      "afterChange": _vm.filterKpiGroupsByProject
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-4",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    key: _vm.selectedKpiGroupGuid,
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-edit-modal-kpi-select",
      "placeholder": _vm.lang.KM2001,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid || _vm.projectKpiGroupList.length < 1,
      "afterChange": _vm.selectedKpiGroupGuidCHanged
    },
    model: {
      value: (_vm.selectedKpiGroupGuid),
      callback: function($$v) {
        _vm.selectedKpiGroupGuid = $$v
      },
      expression: "selectedKpiGroupGuid"
    }
  }, _vm._l((_vm.projectKpiGroupList), function(kpiGroup) {
    return _c('option', {
      key: kpiGroup.KPIGroupGuid,
      domProps: {
        "value": kpiGroup.KPIGroupGuid
      }
    }, [_vm._v("\n                      " + _vm._s(kpiGroup.KPIGroupCode) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2002) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2003) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2004) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: _vm.selectedKpiGuid === kpi.KPIGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), _vm.getKpiData()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpi.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v(_vm._s(kpi.KPIShortText))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-edit",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'editKpiTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2005))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderInKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'kpiOrderInKpiGroupTab'
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2006))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiCode",
      "id": "inputKpiCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2007) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPICode),
      expression: "selectedKpiInformation.KPICode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiCode",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPICode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPICode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiCode')),
      expression: "inputHasError('inputKpiCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2037))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiShortText",
      "id": "inputKpiShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2008) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIShortText),
      expression: "selectedKpiInformation.KPIShortText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiShortText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIShortText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiShortText')),
      expression: "inputHasError('inputKpiShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiLongText",
      "id": "inputKpiLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2009) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPILongText),
      expression: "selectedKpiInformation.KPILongText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiLongText",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPILongText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPILongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiLongText')),
      expression: "inputHasError('inputKpiLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM2011))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiWeight",
      "id": "inputKpiWeightLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM2032) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.selectedKpiInformation.KPIWeight),
      expression: "selectedKpiInformation.KPIWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputKpiWeight",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIWeight)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiWeightLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2036))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIManagementSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    key: _vm.selectedKpiInformation.KPIEvaluationRuleGuid,
    staticClass: "form-control",
    attrs: {
      "id": "KPIManagementSelectEvaluation",
      "placeholder": _vm.lang.KM2031,
      "allowClear": true,
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === '',
      "afterChange": function () {
        _vm.selectedKpiDirty = true;
      }
    },
    model: {
      value: (
        _vm.selectedKpiInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2010))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiInformation.KPIDescription),
      expression: "selectedKpiInformation.KPIDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiDescription",
      "disabled": !_vm.selectedProjectGuid === '' ||
        _vm.selectedKpiGroupGuid === ''
    },
    domProps: {
      "value": (_vm.selectedKpiInformation.KPIDescription)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiInformation, "KPIDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiDirty = true
      }]
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2012))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpi()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2013) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid && !_vm.selectedKpiDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKpiDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2014) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM2015) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderInKpiGroupTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM2016) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM2017))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(kpi.KPICode),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM2033) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM2018) + "\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_Clients_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "clients-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-refresh-button",
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getClientData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-create-button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Create')
    },
    on: {
      "click": function($event) {
        (_vm.selectedClient = -1), _vm.openEditClientDialog('create')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Clients_Read')
    },
    on: {
      "click": function($event) {
        return _vm.openEditClientDialog('edit')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0002) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedClient == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Create')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = true), (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0006) + "\n        ")]), _vm._v(" "), (
    _vm.feature.isEnabled('audi_importers') &&
    _vm.globals.operationPermitted('Entities.Importer.AllowRead')
  ) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "client-management-importer-button"
    },
    on: {
      "click": function($event) {
        _vm.showImportersModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.C0118) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearch",
      "placeholder": _vm.lang.C0007
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.filterClientData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0008))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == -1
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, -1)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0009))])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredClientData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0010))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredClientData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0011))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "clientsTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredClientData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "clientsTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.C0119))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('id')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0012) + "\n                  "), (_vm.sortField == 'id' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'id' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('name')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0013) + "\n                  "), (_vm.sortField == 'name' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'name' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('address')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0014) + "\n                  "), (_vm.sortField == 'address' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'address' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('city')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0015) + "\n                  "), (_vm.sortField == 'city' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'city' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('region')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0016) + "\n                  "), (_vm.sortField == 'region' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'region' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('postalcode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0017) + "\n                  "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'postalcode' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortClientData('country')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.C0018) + "\n                  "), (_vm.sortField == 'country' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'country' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientDataOnCurrentPage), function(client) {
    return _c('tr', {
      key: client.ClientId,
      class: {
        info: client.ClientId == _vm.selectedClient
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedClient = client.ClientId
        },
        "dblclick": function($event) {
          !_vm.globals.isAccessAllowed('LoopOp_Clients_Read') ||
            _vm.openEditClientDialog('edit')
        }
      }
    }, [_c('td', [_vm._v(_vm._s(client.ClientId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientRegionName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientPostalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.ClientCountry))])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editClient",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n              ×\n            ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.editClientDialogData.dialogTitle))])]), _vm._v(" "), (
    typeof _vm.editClientDialogData.clientData.ClientId != 'undefined'
  ) ? _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.lang.C0019) + ":\n                " + _vm._s(_vm.editClientDialogData.clientData.ClientId))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputClientName"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0021) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientName),
      expression: "editClientDialogData.clientData.ClientName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputClientName",
      "name": "inputClientName",
      "required": ""
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientName)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputClientName')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputClientName')),
      expression: "inputHasError('inputClientName')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0090))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0022))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientAddress2
      ),
      expression: "\n                            editClientDialogData.clientData.ClientAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.clientData.ClientCity),
      expression: "editClientDialogData.clientData.ClientCity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCity"
    },
    domProps: {
      "value": (_vm.editClientDialogData.clientData.ClientCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientCountry
      ),
      expression: "\n                            editClientDialogData.clientData.ClientCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData.ClientCountry,
          'general'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0025))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientRegionGuid
      ),
      expression: "\n                            editClientDialogData.clientData.ClientRegionGuid\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientRegionGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsGeneral), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTimeZone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0030))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientTimeZoneId
      ),
      expression: "\n                            editClientDialogData.clientData.ClientTimeZoneId\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentTimeZonesGeneral
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientTimeZoneId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentTimeZonesGeneral
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentTimeZonesGeneral), function(tz) {
    return _c('option', {
      key: tz.TimeZoneId,
      domProps: {
        "value": tz.TimeZoneId
      }
    }, [_vm._v("\n                            " + _vm._s(tz.TimeZoneName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0028))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-check-container"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "CXKunde",
      "title": _vm.lang.C0125
    }
  }, [_vm._v(_vm._s(_vm.lang.C0124))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.C0125
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientCx
      ),
      expression: "\n                                editClientDialogData.clientData.ClientCx\n                              "
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "CXKunde"
    },
    domProps: {
      "checked": Array.isArray(
        _vm.editClientDialogData.clientData.ClientCx
      ) ? _vm._i(
        _vm.editClientDialogData.clientData.ClientCx, null) > -1 : (
        _vm.editClientDialogData.clientData.ClientCx
      )
    },
    on: {
      "change": [function($event) {
        var $$a =
          _vm.editClientDialogData.clientData.ClientCx,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editClientDialogData.clientData, "ClientCx", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editClientDialogData.clientData, "ClientCx", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editClientDialogData.clientData, "ClientCx", $$c)
        }
      }, _vm.setCXKunde]
    }
  }), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSinceClientMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10",
    on: {
      "click": function($event) {
        return _vm.globals.toggleFlatpickr('inputSinceClientMgmtEdit')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientSince
      ),
      expression: "\n                            editClientDialogData.clientData.ClientSince\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSinceClientMgmtEdit"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientSince
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientSince", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectClientTypeClientMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0120))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientTypeGuid
      ),
      expression: "\n                            editClientDialogData.clientData.ClientTypeGuid\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectClientTypeClientMgmtEdit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientTypeGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clientTypes), function(type) {
    return _c('option', {
      key: type.ClientTypeGuid,
      domProps: {
        "value": type.ClientTypeGuid
      }
    }, [_vm._v("\n                            " + _vm._s(type.ClientTypeName) + "\n                          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectClientStatusClientMgmtEdit"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0121))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientStatusId
      ),
      expression: "\n                            editClientDialogData.clientData.ClientStatusId\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectClientStatusClientMgmtEdit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0122))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "I"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0123))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAdditionalInfo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0031))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientAdditionalInfo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAdditionalInfo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientAdditionalInfo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientAdditionalInfo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingContact",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseContact",
      "aria-expanded": "false",
      "aria-controls": "collapseContact"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0032))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseContact",
      "role": "tabpanel",
      "aria-labelledby": "headingContact"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFirstname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0033))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactFirstName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactFirstname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactFirstName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFirstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactLastname"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0034))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientContactLastName\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputContactLastname"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientContactLastName
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactLastName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactPhone"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0035))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactPhone
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactPhone\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactPhone",
      "name": "inputContactPhone"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactPhone
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactPhone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactPhone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactPhone')),
      expression: "inputHasError('inputContactPhone')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0091))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactFax"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0036))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactFax
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactFax\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "inputContactFax",
      "name": "inputContactFax"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactFax
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactFax')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactFax", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactFax')),
      expression: "inputHasError('inputContactFax')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0092))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputContactEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientContactEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientContactEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputContactEmail",
      "name": "inputContactEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientContactEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputContactEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientContactEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputContactEmail')),
      expression: "inputHasError('inputContactEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingBillingDetail",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseBillingDetail",
      "aria-expanded": "false",
      "aria-controls": "collapseBillingDetail"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0038))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseBillingDetail",
      "role": "tabpanel",
      "aria-labelledby": "headingBillingDetail"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillTo"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0039))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillTo
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillTo\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillTo"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillTo
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillTo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingAddress2"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0041))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingAddress2\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingAddress2"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingAddress2
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingAddress2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCity"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0042))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingCity
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingCity\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingCity"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingCity
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0044))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingCountry
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingCountry\n                          "
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changedCountry(
          _vm.editClientDialogData.clientData
          .ClientBillingCountry,
          'billing'
        )
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.globals.countryList), function(country, ISOCode) {
    return _c('option', {
      key: ISOCode,
      domProps: {
        "value": ISOCode
      }
    }, [_vm._v("\n                            " + _vm._s(country) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingRegion"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0043))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingRegionGuid
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingRegionGuid\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.editClientDialogData.currentRegionsBilling
        .length < 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingRegionGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(
    _vm.editClientDialogData.currentRegionsBilling
    .length > 0
  ) ? _c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": 'undefined'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0026) + "\n                          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.editClientDialogData.currentRegionsBilling), function(region) {
    return _c('option', {
      key: region.RegionGuid,
      domProps: {
        "value": region.RegionGuid
      }
    }, [_vm._v("\n                            " + _vm._s(region.RegionName) + "\n                          ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingPostalCode"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0045))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      ),
      expression: "\n                            editClientDialogData.clientData\n                              .ClientBillingPostalCode\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingPostalCode"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData
        .ClientBillingPostalCode
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingPostalCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingEmail"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0046))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillToEmail\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputBillingEmail",
      "name": "inputBillingEmail"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillToEmail
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputBillingEmail')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillToEmail", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputBillingEmail')),
      expression: "inputHasError('inputBillingEmail')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0094))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputBillingTerms"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0047))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      ),
      expression: "\n                            editClientDialogData.clientData.ClientBillingTerms\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputBillingTerms"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientBillingTerms
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientBillingTerms", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingPersonalization",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapsePersonalization",
      "aria-expanded": "false",
      "aria-controls": "collapsePersonalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0048))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapsePersonalization",
      "role": "tabpanel",
      "aria-labelledby": "headingPersonalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputLogoURL"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0049))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      ),
      expression: "\n                            editClientDialogData.clientData.ClientPageLogoURL\n                          "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "id": "inputLogoURL",
      "name": "inputLogoURL"
    },
    domProps: {
      "value": (
        _vm.editClientDialogData.clientData.ClientPageLogoURL
      )
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputLogoURL')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData.clientData, "ClientPageLogoURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputLogoURL')),
      expression: "inputHasError('inputLogoURL')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.C0093))])])])])]), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingSurveys",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseSurveys",
      "aria-expanded": "false",
      "aria-controls": "collapseSurveys"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0059))])])]) : _vm._e(), _vm._v(" "), (
    _vm.selectedClient != -1 &&
    _vm.globals.isAccessAllowed('LoopOp_Surveys_ReadAll')
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseSurveys",
      "role": "tabpanel",
      "aria-labelledby": "headingSurveys"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey.SurveyId == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read')
    },
    on: {
      "click": function($event) {
        (_vm.editSurveyDialogModeAdd = false),
        (_vm.showEditSurveyDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0107) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey.SurveyId == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Read') ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update')
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSurveyEditor(
          _vm.editClientDialogData.selectedSurvey.SurveyId
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("playlist_add_check")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0108) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar btn-top-dialog",
    attrs: {
      "type": "button",
      "disabled": _vm.editClientDialogData.selectedSurvey.SurveyId == -1 ||
        !_vm.globals.isAccessAllowed('LoopOp_Surveys_Delete')
    },
    on: {
      "click": function($event) {
        _vm.showDeleteSurveyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("clear")]), _vm._v(" "), _c('br'), _vm._v("\n                      " + _vm._s(_vm.lang.C0109) + "\n                    ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0060) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0061) + "\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .Surveys), function(survey) {
    return _c('tr', {
      key: survey.SurveyId,
      class: {
        info: _vm.editClientDialogData.selectedSurvey.SurveyId ==
          survey.SurveyId,
      },
      on: {
        "click": function($event) {
          _vm.editClientDialogData.selectedSurvey.SurveyId =
            survey.SurveyId
        },
        "dblclick": function($event) {
          (_vm.editSurveyDialogModeAdd = false),
          (_vm.showEditSurveyDialog = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(survey.SurveyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(survey.SurveyTitle))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingCustProp",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseCustProp",
      "aria-expanded": "false",
      "aria-controls": "collapseCustProp"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.C0062))])])]) : _vm._e(), _vm._v(" "), (_vm.selectedClient != -1) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseCustProp",
      "role": "tabpanel",
      "aria-labelledby": "headingCustProp"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputCustProp"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0063))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClientDialogData.newCustomProperty),
      expression: "editClientDialogData.newCustomProperty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputCustProp"
    },
    domProps: {
      "value": (_vm.editClientDialogData.newCustomProperty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editClientDialogData, "newCustomProperty", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.canAddNewNewCustomProperty() === false
    },
    on: {
      "click": function($event) {
        return _vm.addNewCustomProperty()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.C0064) + "\n                      ")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0065) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.lang.C0066) + "\n                          ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0103))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.lang.C0067))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.editClientDialogData.clientData
    .CustomProperties), function(property) {
    return _c('tr', {
      key: property.Position
    }, [_c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Name),
        expression: "property.Name"
      }],
      staticClass: "form-control text-center textarea-custom-properties autoExpand",
      staticStyle: {
        "margin": "0px"
      },
      attrs: {
        "rows": "1",
        "type": "text",
        "disabled": property.Cx
      },
      domProps: {
        "value": (property.Name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(property, "Name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(property.Id))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "margin-right": "10px !important"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Visibility),
        expression: "property.Visibility"
      }],
      staticClass: "form-control text-center nopadding",
      attrs: {
        "disabled": property.Cx
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Visibility", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0104))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.lang.C0105))])])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (property.Position),
        expression: "property.Position"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(property, "Position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.reorderCustomProperties(property.Name)
        }]
      }
    }, _vm._l((_vm.editClientDialogData
      .clientData.CustomProperties), function(property2) {
      return _c('option', {
        key: property2.Position,
        domProps: {
          "value": property2.Position
        }
      }, [_vm._v("\n                                  " + _vm._s(property2.Position) + "\n                                ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "40%",
        "float": "left"
      }
    }, [(_vm.isCustomPropertyRemovable(property)) ? _c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openRemoveCustomPropertyDialog(property.Id)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])]) : _vm._e()])])])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.editClientDialogData.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.editClientDialogData.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.C0068))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0069) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "client-management-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Clients_Update') &&
        _vm.editClientDialogData.dialogType == 'edit'
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editClient')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.C0070) + "\n            ")])])])])])]), _vm._v(" "), _c('SurveyManagementEditModal', {
    attrs: {
      "selectedSurvey": _vm.editClientDialogData.selectedSurvey,
      "selectedClient": _vm.selectedClientData,
      "showDialog": _vm.showEditSurveyDialog,
      "dialogModeAdd": _vm.editSurveyDialogModeAdd,
      "languageList": _vm.languageList,
      "localesList": _vm.localesList
    },
    on: {
      "surveyEditorRedirect": _vm.redirectToSurveyEditor,
      "dialogClosed": _vm.onEditSurveyDialogClosed,
      "dialogDataSaved": _vm.onEditSurveyDialogDataSaved
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "removeCustomPropertySecurityDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.C0110))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.lang.C0111))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.lang.C0112) + "\n                "), _c('b', [_vm._v(_vm._s(_vm.removeCustomPropertySecurityDialogData.propName))]), _vm._v("\n                " + _vm._s(_vm.lang.C0113) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0114) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeCustomProperty(
          _vm.removeCustomPropertySecurityDialogData.propId
        )
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.C0115) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.C0116,
      "yesButtonText": _vm.lang.C0115,
      "noButtonText": _vm.lang.C0114,
      "showDialog": _vm.showDeleteSurveyModal,
      "colorRed": true
    },
    on: {
      "onYesConfirmation": _vm.deleteSurvey,
      "dialogClosed": function($event) {
        _vm.showDeleteSurveyModal = false
      }
    }
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.C0117))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0019))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.editClientDialogData.selectedSurvey.SurveyId))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 text-black"
  }, [_vm._v(_vm._s(_vm.lang.C0098))]), _vm._v(" "), _c('label', {
    staticClass: "col-md-10 text-black"
  }, [_vm._v(_vm._s(_vm.getSelectedSurveyTitle()))])])]), _vm._v(" "), (
    _vm.feature.isEnabled('audi_importers') &&
    _vm.globals.operationPermitted('Entities.Importer.AllowRead')
  ) ? _c('ImporterManagement', {
    attrs: {
      "showModal": _vm.showImportersModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showImportersModal = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 667 */,
/* 668 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 176,
	"./af.js": 176,
	"./ar": 183,
	"./ar-dz": 177,
	"./ar-dz.js": 177,
	"./ar-kw": 178,
	"./ar-kw.js": 178,
	"./ar-ly": 179,
	"./ar-ly.js": 179,
	"./ar-ma": 180,
	"./ar-ma.js": 180,
	"./ar-sa": 181,
	"./ar-sa.js": 181,
	"./ar-tn": 182,
	"./ar-tn.js": 182,
	"./ar.js": 183,
	"./az": 184,
	"./az.js": 184,
	"./be": 185,
	"./be.js": 185,
	"./bg": 186,
	"./bg.js": 186,
	"./bm": 187,
	"./bm.js": 187,
	"./bn": 188,
	"./bn.js": 188,
	"./bo": 189,
	"./bo.js": 189,
	"./br": 190,
	"./br.js": 190,
	"./bs": 191,
	"./bs.js": 191,
	"./ca": 192,
	"./ca.js": 192,
	"./cs": 193,
	"./cs.js": 193,
	"./cv": 194,
	"./cv.js": 194,
	"./cy": 195,
	"./cy.js": 195,
	"./da": 196,
	"./da.js": 196,
	"./de": 199,
	"./de-at": 197,
	"./de-at.js": 197,
	"./de-ch": 198,
	"./de-ch.js": 198,
	"./de.js": 199,
	"./dv": 200,
	"./dv.js": 200,
	"./el": 201,
	"./el.js": 201,
	"./en-SG": 202,
	"./en-SG.js": 202,
	"./en-au": 203,
	"./en-au.js": 203,
	"./en-ca": 204,
	"./en-ca.js": 204,
	"./en-gb": 205,
	"./en-gb.js": 205,
	"./en-ie": 206,
	"./en-ie.js": 206,
	"./en-il": 207,
	"./en-il.js": 207,
	"./en-nz": 208,
	"./en-nz.js": 208,
	"./eo": 209,
	"./eo.js": 209,
	"./es": 212,
	"./es-do": 210,
	"./es-do.js": 210,
	"./es-us": 211,
	"./es-us.js": 211,
	"./es.js": 212,
	"./et": 213,
	"./et.js": 213,
	"./eu": 214,
	"./eu.js": 214,
	"./fa": 215,
	"./fa.js": 215,
	"./fi": 216,
	"./fi.js": 216,
	"./fo": 217,
	"./fo.js": 217,
	"./fr": 220,
	"./fr-ca": 218,
	"./fr-ca.js": 218,
	"./fr-ch": 219,
	"./fr-ch.js": 219,
	"./fr.js": 220,
	"./fy": 221,
	"./fy.js": 221,
	"./ga": 222,
	"./ga.js": 222,
	"./gd": 223,
	"./gd.js": 223,
	"./gl": 224,
	"./gl.js": 224,
	"./gom-latn": 225,
	"./gom-latn.js": 225,
	"./gu": 226,
	"./gu.js": 226,
	"./he": 227,
	"./he.js": 227,
	"./hi": 228,
	"./hi.js": 228,
	"./hr": 229,
	"./hr.js": 229,
	"./hu": 230,
	"./hu.js": 230,
	"./hy-am": 231,
	"./hy-am.js": 231,
	"./id": 232,
	"./id.js": 232,
	"./is": 233,
	"./is.js": 233,
	"./it": 235,
	"./it-ch": 234,
	"./it-ch.js": 234,
	"./it.js": 235,
	"./ja": 236,
	"./ja.js": 236,
	"./jv": 237,
	"./jv.js": 237,
	"./ka": 238,
	"./ka.js": 238,
	"./kk": 239,
	"./kk.js": 239,
	"./km": 240,
	"./km.js": 240,
	"./kn": 241,
	"./kn.js": 241,
	"./ko": 242,
	"./ko.js": 242,
	"./ku": 243,
	"./ku.js": 243,
	"./ky": 244,
	"./ky.js": 244,
	"./lb": 245,
	"./lb.js": 245,
	"./lo": 246,
	"./lo.js": 246,
	"./lt": 247,
	"./lt.js": 247,
	"./lv": 248,
	"./lv.js": 248,
	"./me": 249,
	"./me.js": 249,
	"./mi": 250,
	"./mi.js": 250,
	"./mk": 251,
	"./mk.js": 251,
	"./ml": 252,
	"./ml.js": 252,
	"./mn": 253,
	"./mn.js": 253,
	"./mr": 254,
	"./mr.js": 254,
	"./ms": 256,
	"./ms-my": 255,
	"./ms-my.js": 255,
	"./ms.js": 256,
	"./mt": 257,
	"./mt.js": 257,
	"./my": 258,
	"./my.js": 258,
	"./nb": 259,
	"./nb.js": 259,
	"./ne": 260,
	"./ne.js": 260,
	"./nl": 262,
	"./nl-be": 261,
	"./nl-be.js": 261,
	"./nl.js": 262,
	"./nn": 263,
	"./nn.js": 263,
	"./pa-in": 264,
	"./pa-in.js": 264,
	"./pl": 265,
	"./pl.js": 265,
	"./pt": 267,
	"./pt-br": 266,
	"./pt-br.js": 266,
	"./pt.js": 267,
	"./ro": 268,
	"./ro.js": 268,
	"./ru": 269,
	"./ru.js": 269,
	"./sd": 270,
	"./sd.js": 270,
	"./se": 271,
	"./se.js": 271,
	"./si": 272,
	"./si.js": 272,
	"./sk": 273,
	"./sk.js": 273,
	"./sl": 274,
	"./sl.js": 274,
	"./sq": 275,
	"./sq.js": 275,
	"./sr": 277,
	"./sr-cyrl": 276,
	"./sr-cyrl.js": 276,
	"./sr.js": 277,
	"./ss": 278,
	"./ss.js": 278,
	"./sv": 279,
	"./sv.js": 279,
	"./sw": 280,
	"./sw.js": 280,
	"./ta": 281,
	"./ta.js": 281,
	"./te": 282,
	"./te.js": 282,
	"./tet": 283,
	"./tet.js": 283,
	"./tg": 284,
	"./tg.js": 284,
	"./th": 285,
	"./th.js": 285,
	"./tl-ph": 286,
	"./tl-ph.js": 286,
	"./tlh": 287,
	"./tlh.js": 287,
	"./tr": 288,
	"./tr.js": 288,
	"./tzl": 289,
	"./tzl.js": 289,
	"./tzm": 291,
	"./tzm-latn": 290,
	"./tzm-latn.js": 290,
	"./tzm.js": 291,
	"./ug-cn": 292,
	"./ug-cn.js": 292,
	"./uk": 293,
	"./uk.js": 293,
	"./ur": 294,
	"./ur.js": 294,
	"./uz": 296,
	"./uz-latn": 295,
	"./uz-latn.js": 295,
	"./uz.js": 296,
	"./vi": 297,
	"./vi.js": 297,
	"./x-pseudo": 298,
	"./x-pseudo.js": 298,
	"./yo": 299,
	"./yo.js": 299,
	"./zh-cn": 300,
	"./zh-cn.js": 300,
	"./zh-hk": 301,
	"./zh-hk.js": 301,
	"./zh-tw": 302,
	"./zh-tw.js": 302
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 791;

/***/ }),
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = (function (element, listener) {
	var expand = document.createElement('_');
	var shrink = expand.appendChild(document.createElement('_'));
	var expandChild = expand.appendChild(document.createElement('_'));
	var shrinkChild = shrink.appendChild(document.createElement('_'));

	var lastWidth = void 0,
	    lastHeight = void 0;

	shrink.style.cssText = expand.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:0s;width:100%;z-index:-1';
	shrinkChild.style.cssText = expandChild.style.cssText = 'display:block;height:100%;transition:0s;width:100%';
	shrinkChild.style.width = shrinkChild.style.height = '200%';

	element.appendChild(expand);

	test();

	return stop;

	function test() {
		unbind();

		var width = element.offsetWidth;
		var height = element.offsetHeight;

		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;

			expandChild.style.width = width * 2 + 'px';
			expandChild.style.height = height * 2 + 'px';

			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
			shrink.scrollLeft = shrink.scrollWidth;
			shrink.scrollTop = shrink.scrollHeight;

			listener({ width: width, height: height });
		}

		shrink.addEventListener('scroll', test);
		expand.addEventListener('scroll', test);
	}

	function unbind() {
		shrink.removeEventListener('scroll', test);
		expand.removeEventListener('scroll', test);
	}

	function stop() {
		unbind();

		element.removeChild(expand);
	}
});

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 800 */,
/* 801 */,
/* 802 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 803 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_themes_material_blue_css__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_themes_material_blue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flatpickr_dist_themes_material_blue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_typeface_roboto_index_css__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_animate_css_animate_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_snackbarjs__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_snackbarjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_snackbarjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__globals__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__feature__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_app_service__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_currency_input__ = __webpack_require__(1769);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















// Import JS services

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, "$appService", {
  value: __WEBPACK_IMPORTED_MODULE_14__services_app_service__["a" /* default */]
});


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_currency_input__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component("treeselect", __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default.a);

try {
  // Send access token to service worker if requested.
  var authChannel = new BroadcastChannel("authChannel");

  authChannel.onmessage = function (event) {
    if (event.data === "getAuthTokenHeader") {
      authChannel.postMessage({
        authTokenHeader: "Bearer " + __WEBPACK_IMPORTED_MODULE_14__services_app_service__["a" /* default */].getAccessToken()
      });
    }
  };
} catch (e) {
  this.globals.showErrorSnackbar("Your browser does not support all used functionality for this webapplication.");
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.globals = __WEBPACK_IMPORTED_MODULE_11__globals__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.feature = __WEBPACK_IMPORTED_MODULE_12__feature__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.name === "DirectToLoginCallback" || to.name === "DirectToLogoutCallback") {
    __WEBPACK_IMPORTED_MODULE_14__services_app_service__["a" /* default */].redirectAfterLoginCallback();
    return;
  }

  if (!__WEBPACK_IMPORTED_MODULE_14__services_app_service__["a" /* default */].isUserAuthenticated()) {
    __WEBPACK_IMPORTED_MODULE_14__services_app_service__["a" /* default */].renewToken();
  }
  next();
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
  template: "<App/>",
  components: {
    App: __WEBPACK_IMPORTED_MODULE_9__App___default.a
  }
});

/***/ }),
/* 805 */,
/* 806 */
/***/ (function(module, exports) {

module.exports = {"dev":{"changes":["Some general bugfixes and improvements"]},"2.4.8":{"date":"2023-04-19","changes":["Add new check editing functionality","Fixing wave behaivior if scenario gets changed while edit check","Improve deselecting behaivor in check management","Improvement of imprint and dataProtection","Performance Improvements","Fix some bugs regarding autosave functionality","Fix visual bug regarding assignment of surveys to project","Fixes and some improvements of status changes","Fix some upload issues","Fixes for the shopper filter","Fix for rating questions min and max points","Fix for inital custom properties of new clients"]},"2.3.0":{"date":"2020-11-11","changes":["Added client type and status","Added project responsibilities","Added export for shoppers and shopper checks","Added export for surveys","Added some new columns to user export and import","Added new KPI evaluation rules","Added new check property \"Visible in Notification\"","Added custom question numbers in KPI assignment modal","Added automatic first target group creation for new clients","Added default first target group for new client users","Added start date information on check opening for shoppers","Added syntax based security filter for survey elements","Added histories for projects, shoppers, surveys, users and check answers (export)","Added regions to shopper profile and recruiting filters","Added check and location ID filters for recruiting","Added filter storage for recruiting components","Added translations for html questions","Added positive flag for answers of SC and MC questions","Changed a few column names in invoice export","Improved check status workflow for agencies","Check answers will now be limited to visible questions on save or validate if the associated option is enabled for the survey","Made checks readonly for shoppers if start date is not reached yet","Filter shoppers in shopper management for active state by default","Inactive shoppers are no longer available in recruiting","Fixed order of reporting features","Fixed wave FF feature not working as expected","Fixed KPI group data update in KPI management","Some general bugfixes and improvements"]},"2.2.1":{"date":"2020-07-22","changes":["Added project filter for KPI translations","Enabled table setting storage for checks and KPIs","Enabled reporting group and security setting access for audi users","Disabled check opening for audi users","Improved check export content for audi system","Improved check status workflow","Some general bugfixes and improvements"]},"2.2.0":{"date":"2020-07-15","changes":["Added new importer management (Audi)","Added new agency types local and lead (Audi)","Added new user settings component","Added storage for table settings and filters (activate in user settings)","Added synchrionization of filters for clients, projects and importers (activate in user settings)","Added new approval component (Audi)","Added new car model management (Audi)","Added car model distribution for waves (Audi)","Added new wave info","Added new longtext for scenarios","Added some new properties to recruiting map pin info (Audi)","Added check deletion and copy of deleted checks for lead agencies (Audi)","Added new local agency check assignment dialog for lead agencies (Audi)","Added new check history","Added new location history","Added new wave status","Added Audi as new user type (Audi)","Added translation tool for location data","Added shopper name to checks table (Audi)","Added approved shopper informations to check view","Added KPI copy between projects of a client","Enabled editing of location properties on location creation","Enabled user management and recruiting access for agencies (Audi)","Enabled shopper management access for local agencies (Audi)","Disabled shopper list access (Audi)","Disabled clientmanagement access for agencies (Audi)","Disabled cost center for waves (Audi)","Disabled invoice features for Audi system","Limited user export and import to client users (Audi)","Changed visibility of some buttons depending on user policies","Moved location import and export to locationmanagement","Removed project accountables (Audi)","Updated Audi CI","Some general bugfixes and improvements"]},"2.1.2":{"date":"2020-07-01","changes":["Added total elements count for datatables","Added third state (not answered) for shopper properties checkbox type","Added distance filtering of shoppers in recruiting map","Added user account unlock by password reset","Some general bugfixes and improvements"]},"2.1.1":{"date":"2020-05-04","changes":["Added option to change own password for shoppers","Added german shopper manual download link","Added fixed position for table filters","Added free offers distance sort for shoppers","Added free offers distance and location free info for shopper","Changed translation for shopper custom properties","Improved free offers filter for shoppers","Improved email workflow for shopper registration","Fixed IBAN and BIC validation error because of included blanks","Some general bugfixes and performance improvements"]},"2.1.0":{"date":"2020-03-10","changes":["Added shopper filter for free offers","Added validation for IBAN and BIC","Added flag to list types of shopper properties to decide if the shopper should be able to add custom values","Added account status for shoppers","Added tooltip for invoice state values in checkmanagement","Added online state filter for free offers in checkmanagement","Added storage of table settings in shoppermanagement","Added new columns for postal code, country, city and location informations to free offers table for shoppers","Added new 404 page for undefined routes","Added some new translations","Added SurveyId information for KPIs","Added new check info (max. 50 characters)","Added date order check for start and end date of free offers","Added reset of check answer and status if a status 110 free offer is separated from its shopper","Added old shopper ID to administration tab of shopper profile","Improved tab rendering in some dialogs","Improved rendering performance for some data tables","Improved spinner behavior","Improved datepicker performance and month selection","Improved language request frequency on application start","Improved login workflow","Disabled filtering free offers by date and payment for shoppers","Disabled clients tab for Audi users","Removed check report template setting for surveys","Removed old surveycode from check export","Removed ability to delete or change the shopper of checks with invoice state \"o\"","Removed ability to delete checks from database that do not have status 100 or 300","Changed translation of survey title to \"project\" for shoppers","Fixed changing internal note for checks changed check status","Fixed upload dialog scaling down images after drawing mode usage","Fixed upload dialog showing up on pressing enter with focus inside survey form","Fixed shopper not able to copy information from invoice table","Fixed currency value of 0 in checks not passing validation","Fixed location property filter in recruiting component showing redundant values","Fixed shopper or agency not showing up in select on check editing","Fixed german translation for text length validation in survey","Fixed changing survey code after update of some reporting settings of the check","Fixed select2 rendering issue in firefox","Fixed an issue that prevented from changing check types in some cases","Fixed an issue with the user import receiving names with more than 19 characters","Some general bugfixes and styling improvements"]},"2.0.13":{"date":"2020-01-20","changes":["Added shopper management","Added shopper profile","Added shopper property management","Added shopper property form in shopper profile","Added recruiting component","Added payment module","Added free offers module","Added check type filter in check management","Added expiry date in check management","Added red text color for expired checks","Added cost center information for waves","Added internal note for checks","Added new question type \"expression\"","Added location information column instead of check description to shopper checks","Added new reporting permissions","Added preselection of new created checks in check management","Added new check states for deleted checks (301 - 304)","Limited reporting permissions for survey elements to groups that are assigned to the survey","Removed security group filter for survey elements","Fixed ability to save locations with high precision GPS coordinates","Improved behavior of check creation modal","Some general bugfixes"]},"2.0.10":{"date":"2019-10-30","changes":["Added target groups for reporting","Added briefing and survey documents","Added possibility for partner to export the survey translations","Added automatic retrieval of geocoding information for shopper and locations","Added export of last modified date of checks","Fixed order of location properties in check view not consistent","Fixed searching with chinese characters did not work","Fixed survey translations being truncated after 250 characters","Fixed wave based filtering of questions did not work as expected","Fixed shopper in rare cases overwriting translation answers given by MSM","Fixed multiple uploads in rare cases not being saved correctly","Fixed error when copying a user","Changed layout of \"survey already submitted\" notice when logging in with survey code"]},"2.0.6":{"date":"2019-08-15","changes":["Added delay to upload progress indicator","Added counter for selected locations and reset button in check creator","Added ability to change the location of existing checks","Added ability to open check properties readonly if their status is higher than 200","Added error message for user creation if the chosen username already exists","Added error message if no client is selected in user export with active client filter","Allowed cluster weight values up to 999.999","Changed translation of upload dialog button","Fixed some bugs in SurveyUploadDialog","Fixed user export error if custom property of the client is called \"Region\"","Fixed check deletion error","Some general bugfixes"]},"2.0.5":{"date":"2019-07-26","changes":["Added version number and changelog","Added progress indicator for file uploads","Bugfixes"]},"2.0.4":{"date":"2019-07-24","changes":["Improved survey translations","Added KPI translation dialog","Added ability to open checks in new browsertabs","Added check language selection","Added question numbers to survey editor filter selections","Added weight property to survey clusters","Fixed wrong orientation of some images after upload","Some more bugfixes and performance improvements"]}}

/***/ }),
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect_dist_vue_treeselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_material_design_dist_css_bootstrap_material_design_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_material_design_dist_css_ripples_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_material_design_dist_js_material_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_material_design_dist_js_ripples_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_serviceWorkerInit_js__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flatpickr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_flatpickr_dist_l10n__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_flatpickr_dist_l10n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_flatpickr_dist_l10n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Tools_gmaps__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_css_vars_ponyfill__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__package_json__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ConfirmationDialog__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ConfirmationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ConfirmationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_NotificationDialog__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_NotificationDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_NotificationDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangelogModal__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangelogModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangelogModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_EditVatRatesModal__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_EditVatRatesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_EditVatRatesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_HtmlEditorModal__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_HtmlEditorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_HtmlEditorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_FeedModal__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_FeedModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_FeedModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Tools_Dialogs_ElementHistoryModal__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Tools_Dialogs_ElementHistoryModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Tools_Dialogs_ElementHistoryModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__services_Live__ = __webpack_require__(142);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Import CSS






// Import JavaScript





// Import flatpickr



// Google Maps






// import dialogs











/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    ConfirmationDialog: __WEBPACK_IMPORTED_MODULE_16__components_Tools_Dialogs_ConfirmationDialog___default.a,
    NotificationDialog: __WEBPACK_IMPORTED_MODULE_17__components_Tools_Dialogs_NotificationDialog___default.a,
    ChangelogModal: __WEBPACK_IMPORTED_MODULE_18__components_Tools_Dialogs_ChangelogModal___default.a,
    UploadProgressModal: __WEBPACK_IMPORTED_MODULE_19__components_Tools_Dialogs_UploadProgressModal___default.a,
    EditVatRatesModal: __WEBPACK_IMPORTED_MODULE_20__components_Tools_Dialogs_EditVatRatesModal___default.a,
    HtmlEditorModal: __WEBPACK_IMPORTED_MODULE_21__components_Tools_Dialogs_HtmlEditorModal___default.a,
    FeedModal: __WEBPACK_IMPORTED_MODULE_22__components_Tools_Dialogs_FeedModal___default.a,
    ElementHistoryModal: __WEBPACK_IMPORTED_MODULE_23__components_Tools_Dialogs_ElementHistoryModal___default.a
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    $.material.init();
    this.$store.commit("initStore");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__src_serviceWorkerInit_js__["a" /* default */])();
    window.addEventListener("click", function (e) {
      _this.$linkClicked = e.target.tagName.toLowerCase() === "a";
      setTimeout(function () {
        delete _this.$linkClicked;
      }, 100);
    });
    window.addEventListener("beforeunload", function () {
      if (!_this.$linkClicked) {
        _this.globals.$appUnloading = true;
        _this.$destroy();
      }
    });

    if (this.feature.isAudiTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(245, 5, 55)",
          "color-primary-rgb": "245, 5, 55",
          "color-primary-input": "rgb(51, 51, 51)",
          "color-primary-input-rgb": "51, 51, 51",
          "color-primary-input-hover": "rgb(76, 76, 76)",
          "color-primary-input-hover-rgb": "76, 76, 76",
          "active-alpha": "0.2"
        }
      });
      $("head > title").text("Audi Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/favicon-audi.webp");
    } else if (this.feature.isDBTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(236, 0, 22)",
          "color-primary-rgb": "236, 0, 22",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103"
        }
      });
      $("head > title").text("DB Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/DB_loop_logo.svg");
    } else if (this.feature.isPorscheTarget) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_css_vars_ponyfill__["a" /* default */])({
        variables: {
          "color-primary": "rgb(213, 0, 28)",
          "color-primary-rgb": "213, 0, 28",
          "color-primary-input": "rgb(79, 75, 65)",
          "color-primary-input-rgb": "79, 75, 65",
          "color-primary-input-hover": "rgb(116, 112, 103)",
          "color-primary-input-hover-rgb": "116, 112, 103"
        }
      });
      $("head > title").text("Porsche Loop");
      $("head > link[type='image/x-icon']").attr("href", "/static/Porsche_logo_favico.webp");
    } else __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_css_vars_ponyfill__["a" /* default */])();

    // Makes tooltips available for all rendered components
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // Allows textarea to expand automatically
    // Applied globally on all textareas with the "autoExpand" class
    $(document).on("input.autoExpand", "textarea.autoExpand", function () {
      if (!this.scrollHeight) return;
      var minRows = 1,
          rows = void 0;
      this.rows = minRows;

      var style = window.getComputedStyle(this, null).getPropertyValue("font-size"); // Get font size from textarea
      var fontSize = parseFloat(style);

      if (!this.baseScrollHeight) {
        var valueBackup = this.value;
        this.value = "";
        this.baseScrollHeight = this.scrollHeight;
        this.value = valueBackup;
      }

      rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / (fontSize + 6)); // 6px for line spacing
      if (rows < 0) rows = 0;
      this.rows = minRows + rows;
    });

    $(document).on("show.bs.modal", ".modal", function () {
      var zIndex = 1040 + 10 * $(".modal:visible").length;
      $(this).css("z-index", zIndex);
      setTimeout(function () {
        $(".modal-backdrop").not(".modal-stack").css("z-index", zIndex - 1).addClass("modal-stack");
      }, 0);
    });

    // Ensures that select2 and flatpickr can get input focus inside modal
    $.fn.modal.Constructor.prototype.enforceFocus = function () {};
  },
  created: function created() {
    var _this2 = this;

    if (location.hash.indexOf("#/surveycode") > -1) return;

    var checkAccessToken = function checkAccessToken() {
      _this2.isAccessTokenAvailable = !!_this2.$appService.getAccessToken();
      if (!_this2.isAccessTokenAvailable) {
        console.warn("No access token available");
      }
    };

    this.globals.$off("accessTokenChanged");
    this.globals.$on("accessTokenChanged", checkAccessToken);
    checkAccessToken();

    $(document).ajaxStart(function () {
      _this2.globals.showSpinner();
    }).ajaxStop(function () {
      _this2.globals.hideSpinner();
    });

    this.$appService.initializeGlobalAjaxEvents();

    this.globals.$off("openGlobalConfirmationDialog");
    this.globals.$on("openGlobalConfirmationDialog", function (confirmationDialogData) {
      _this2.confirmationDialogData = confirmationDialogData;
      _this2.openConfirmationDialog();
    });

    this.globals.$off("openGlobalNotificationDialog");
    this.globals.$on("openGlobalNotificationDialog", function (notificationDialogData) {
      _this2.notificationDialogData = notificationDialogData;
      _this2.openNotificationDialog();
    });

    this.globals.$off("openEditVatRatesModal");
    this.globals.$on("openEditVatRatesModal", function () {
      _this2.showEditVatRatesModal = true;
    });

    this.globals.$off("openHtmlEditorModal");
    this.globals.$on("openHtmlEditorModal", function () {
      _this2.showHtmlEditorModal = true;
    });

    this.globals.$off("openGlobalUnsavedChangesDialog");
    this.globals.$on("openGlobalUnsavedChangesDialog", function (yesCallback, cancelCallback) {
      _this2.globals.$off("GlobalUnsavedChangesYesConfirmation");
      if (yesCallback) _this2.globals.$once("GlobalUnsavedChangesYesConfirmation", function () {
        yesCallback();
      });
      _this2.globals.$off("GlobalUnsavedChangesNoConfirmation");
      if (cancelCallback) _this2.globals.$once("GlobalUnsavedChangesNoConfirmation", function () {
        cancelCallback();
      });

      _this2.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "GlobalUnsavedChanges",
        confirmationTitle: _this2.lang.A0025,
        colorRed: true,
        yesButtonText: _this2.lang.A0026,
        noButtonText: _this2.lang.A0027,
        htmlText: "<p><b>" + _this2.lang.A0028 + "</b></p>"
      });
    });

    this.initGoogleApi();
  },
  mounted: function mounted() {
    var _this3 = this;

    document.addEventListener("securitypolicyviolation", function (e) {
      console.debug(e.blockedURI);
      console.debug(e.violatedDirective);
      console.debug(e.originalPolicy);
    });
    if (location.hash.indexOf("#/surveycode") > -1) return;

    // Gets executed right after rendering the component
    var userInfoCallback = function userInfoCallback() {
      if (_this3.globals.currentUserInfo.IsAudiUser) {
        _this3.$router.beforeResolve(function (to, from, next) {
          if (to.name === "ClientManagement") {
            next("/");
            return;
          }
          next();
        });
        if (_this3.$route.name === "ClientManagement") _this3.$router.push("/");
      }
      _this3.setInitialRoute();
      _this3.nextLanguage = _this3.globals.selectedLanguage;
    };
    this.globals.getCurrentUserInfo(userInfoCallback);

    this.getLanguageList();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    if (this.feature.isAudiTarget) this.mainOpHost = "projects.audi-mysteryshopping.com";else if (this.feature.isDBTarget) this.mainOpHost = "projects.qm-servicestoredb.de";else if (this.feature.isPorscheTarget) this.mainOpHost = "projects.sar-pag.de";
  },

  computed: {
    userLoginState: function userLoginState() {
      return this.globals.currentUserInfo ? true : false;
    }
  },
  methods: {
    redirectToSupport: function redirectToSupport() {
      if (this.feature.currentTarget === "china") {
        if (this.globals.currentUserRole < 2) window.open("https://help.msmloop.asia/redmine");else alert("Please contact your MSM Asia project manager!");
      } else {
        if (this.globals.currentUserRole == 2) window.open("https://projects.msmloop.com/api/Download/055f8eec-c35a-4bf3-ad9c-3190839d62bc");else window.open("http://help.msmloop.com/redmine/login");
      }
    },
    clearData: function clearData() {
      if (this.clearDataSelection.Cache && this.clearDataSelection.Cookies && this.clearDataSelection.Storage && this.clearDataSelection.ExecutionContexts) {
        __WEBPACK_IMPORTED_MODULE_24__services_Live__["a" /* default */].clearSiteDataAll().then(function (res) {
          // location.reload(true);
        }).catch(function () {
          console.error("Live error");
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_24__services_Live__["a" /* default */].clearSiteDataCombined(this.clearDataSelection);
      }
    },
    setInitialRoute: function setInitialRoute() {
      if (this.$route.name && this.$route.name !== "PageNotFound") return; // Route is already selected

      if (this.globals.currentUserRole === 1) {
        this.globals.currentUserInfo.IsAudiUser ? this.$router.push("/locationmanagement") : this.$router.push("/clientmanagement");
      } else if (this.globals.currentUserRole === 2) {
        this.$router.push("/checkmanagement");
      }
    },

    // Opens the dialog to select a language
    openSelectLanguageDialog: function openSelectLanguageDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_SecurityUsersLocalization_Update") || !this.globals.isAccessAllowed("LoopOp_Language_Read")) {
        this.globals.showErrorSnackbar("Access denied");
        return;
      }
      $("#selectLanguageDialog").modal("show");
    },


    // Opens the dialog to select a language
    openClearDataDialog: function openClearDataDialog() {
      $("#selectClearData").modal("show");
    },
    userLogout: function userLogout() {
      this.$appService.logout();
    },
    initGoogleApi: function initGoogleApi() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__components_Tools_gmaps__["a" /* default */])(_this4.globals.googleApiKey);

              case 3:
                _this4.globals.$emit("googleInitDone");
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 6]]);
      }))();
    },


    // Closes the language selection dialog
    closeSelectLanguageDialog: function closeSelectLanguageDialog() {
      $("#selectLanguageDialog").modal("hide");
    },


    // Requests a list of available languages from the server
    getLanguageList: function getLanguageList() {
      var _this5 = this;

      $.ajax({
        method: "GET",
        url: "api/Language",
        success: function success(data) {
          // this.languageList = data;
          //TODO: Only show german and english in production
          _this5.languageList = {
            de: data.de,
            en: data.en
          };
          if (["china", "dev"].indexOf(_this5.feature.currentTarget) > -1) _this5.languageList.zh = data.zh;
        },
        error: function error() {
          console.error("Language data access failed in getLanguageList()");
        }
      });
    },
    selectedLanguageDialogClosed: function selectedLanguageDialogClosed() {
      var _this6 = this;

      if (this.nextLanguage === this.globals.selectedLanguage) return;
      var param = "?LanguageCode=" + this.nextLanguage.substring(0, 2);

      $.ajax({
        method: "PUT",
        url: "api/SecurityUsers/Localization" + param,
        dataType: "text",
        success: function success(data) {
          _this6.globals.selectedLanguage = _this6.nextLanguage;
          _this6.globals.showSuccessSnackbar("Language switched to: " + _this6.globals.selectedLanguage);
        },
        error: function error() {
          console.error("Error on PUT in selectedLanguageDialogClosed()");
          _this6.globals.showErrorSnackbar("Language update failed");
        }
      });
    },
    selecteClearDataDialogClosed: function selecteClearDataDialogClosed() {
      this.clearData();
    },
    openConfirmationDialog: function openConfirmationDialog() {
      this.confirmationDialogId = this.confirmationDialogData.initiator + "Confirmation";
      this.showConfirmationDialog = true;
    },
    onYesConfirmation: function onYesConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "YesConfirmation");
      this.showConfirmationDialog = false;
    },
    onNoConfirmation: function onNoConfirmation() {
      this.globals.$emit(this.confirmationDialogData.initiator + "NoConfirmation");
      this.showConfirmationDialog = false;
    },
    onCloseConfirmationDialog: function onCloseConfirmationDialog() {
      this.globals.$emit(this.confirmationDialogData.initiator + "CloseDialog");
    },
    onConfirmationDialogClosed: function onConfirmationDialogClosed() {
      this.globals.$emit(this.confirmationDialogData.initiator + "DialogClosed");
      this.showConfirmationDialog = false;
    },
    openNotificationDialog: function openNotificationDialog() {
      this.notificationDialogId = this.notificationDialogData.initiator + "Notification";
      this.showNotificationDialog = true;
    },
    onCloseNotificationDialog: function onCloseNotificationDialog() {
      this.globals.$emit(this.notificationDialogData.initiator + "CloseDialog");
    },
    onNotificationDialogClosed: function onNotificationDialogClosed() {
      this.globals.$emit(this.notificationDialogData.initiator + "DialogClosed");
      this.showNotificationDialog = false;
    },

    /**
     *
     * @param {String} versionA
     * @param {String} versionB
     * @return {Number} difference on version number
     */
    compareVersions: function compareVersions(versionA, versionB) {
      if (versionA === versionB) return 0;

      if (versionA.split(".")[0] != versionB.split(".")[0]) {
        return 1;
      }

      if (versionA.split(".")[1] != versionB.split(".")[1]) {
        return 2;
      }

      if (versionA.split(".")[2] != versionB.split(".")[2]) {
        return 3;
      }

      if (versionA.split(".")[3] != versionB.split(".")[3]) {
        return 4;
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    // Global data inside the component is stored here
    return {
      maintenance: false,
      appVersion: __WEBPACK_IMPORTED_MODULE_15__package_json__["version"],
      mainOpHost: "projects.msmloop.com",
      isAccessTokenAvailable: false,
      nextLanguage: "en",
      showMaintenance: false,
      clearDataSelection: {
        Cache: true,
        Cookies: true,
        Storage: true,
        ExecutionContexts: true
      },
      languageList: [], // Stores a list of all available languages
      lang: {
        A0000: "Clients",
        A0001: "Locations",
        A0002: "User",
        A0003: "Log Out",
        A0004: "Edit profile",
        A0006: "Language",
        A0007: "Select a language",
        A0009: "Accept",
        A0010: "Users",
        A0011: "Projects",
        A0012: "Partners",
        A0013: "Surveys",
        A0014: "Checks",
        A0015: "Survey View",
        A0016: "KPIs",
        A0017: "Data Protection",
        A0018: "Imprint",
        A0019: "Free Offers",
        A0020: "Survey Payment",
        A0021: "Support",
        A0023: "Shopper",
        A0024: "Settings",
        A0025: "Unsaved changes",
        A0026: "Yes",
        A0027: "Cancel",
        A0028: "There are unsaved changes that will be lost after this action. Do you want to proceed anyway?",
        A0029: "Recruiting",
        A0032: "Approval",
        A0033: "Logged in as",
        A0034: "Clear Cache Data",
        A0035: "Cache",
        A0036: "Cookies",
        A0037: "Storage",
        A0038: "Execution Contexts"
      },
      confirmationDialogData: {},
      showConfirmationDialog: false,
      notificationDialogData: {},
      showNotificationDialog: false,
      confirmationDialogId: "confirmationDialog",
      notificationDialogId: "notificationDialog",
      showChangelogModal: false,
      showEditVatRatesModal: false,
      showHtmlEditorModal: false
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__changelog_json__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__changelog_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__changelog_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "ChangelogModal",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openChangelogModal: function openChangelogModal() {
      $("#changelogModal").modal("show");
    },
    closeChangelogModal: function closeChangelogModal() {
      $("#changelogModal").modal("hide");
    }
  },
  mounted: function mounted() {
    var _this = this;

    $("#changelogModal").on("hide.bs.modal", function (e) {
      return _this.$emit("closeDialog");
    });
  },

  watch: {
    showDialog: function showDialog(newValue) {
      if (newValue) {
        this.openChangelogModal();
      } else {
        this.closeChangelogModal();
      }
    }
  },
  data: function data() {
    return {
      changelog: __WEBPACK_IMPORTED_MODULE_0__changelog_json__
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Select2__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "EditVatRatesModal",
  components: {
    Select2: __WEBPACK_IMPORTED_MODULE_2__Select2___default.a
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      vatDataDirty: false,
      selectedCountry: "",
      currentEntry: {
        CountryCode: "",
        VatRate: undefined
      },
      vatDataList: [],
      lang: {
        EVR000: "VAT",
        EVR001: "Tax Rates",
        EVR002: "Country",
        EVR003: "VAT Rate",
        EVR004: "Close",
        EVR005: "Save"
      }
    };
  },

  computed: {
    vatRatePercentage: {
      get: function get() {
        if (!this.currentEntry.VatRate) return undefined;
        return (this.currentEntry.VatRate * 100).toFixed(2);
      },
      set: function set(value) {
        if (!value || value < 0) value = 0;
        if (value > 100) value = 100;
        this.currentEntry.VatRate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()((value / 100).toFixed(4));
      }
    }
  },
  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    },
    showModal: function showModal(newVal) {
      newVal ? this.openModal() : this.closeModal();
    },
    selectedCountry: function selectedCountry(newCountryCode) {
      var entry = _.find(this.vatDataList, function (v) {
        return v.CountryCode === newCountryCode;
      });
      if (!entry) {
        entry = {
          CountryCode: newCountryCode,
          VatRate: undefined
        };
        this.vatDataList.push(entry);
      }
      this.currentEntry = entry;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.globals.getCountryList();
    }

    $("#editVatRatesModal").on("hidden.bs.modal", function (e) {
      return _this.$emit("modalClosed");
    });
  },

  methods: {
    openModal: function openModal() {
      var _this2 = this;

      this.vatDataDirty = false;
      var success = function success() {
        _this2.$nextTick(function () {
          _this2.selectedCountry = "DE";
          $("#editVatRatesModal").modal("show");
        });
      };
      this.getVatRates(success);
    },
    closeModal: function closeModal() {
      $("#editVatRatesModal").modal("hide");
    },
    getVatRates: function getVatRates(_success) {
      var _this3 = this;

      this.selectedCountry = "";
      var query = "api/Administration/VatRates#test";
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          _this3.vatDataList = data;
          if (_success) _success();
        },
        error: function error() {
          console.error("Error on GET in getVatRates()");
          _this3.globals.showErrorSnackbar("Tax rates data access failed");
        }
      });
    },
    saveVatRates: function saveVatRates() {
      var _this4 = this;

      var sendData = _.cloneDeep(this.vatDataList);
      _.remove(sendData, function (entry) {
        return !entry.VatRate;
      });

      var query = "api/Administration/VatRates";
      $.ajax({
        method: "PUT",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.globals.showSuccessSnackbar("Tax rates updated");
          _this4.vatDataDirty = false;
        },
        error: function error(_error) {
          console.error("Error on PUT in saveVatRates()");
          _this4.globals.showErrorSnackbar("Tax rates update failed");
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "FeedModal",
  data: function data() {
    return {
      title: "",
      newFeedPostContent: "",
      availableFeeds: [],
      currentFeedConfig: {},
      currentFeedPosts: [],
      lang: {
        FEE000: "Feed",
        FEE001: "New message...",
        FEE002: "Send",
        FEE003: "No messages available yet.",
        FEE004: "Info",
        FEE005: "Message",
        FEE006: "Close",
        FEE007: "Available feeds request failed",
        FEE008: "Feed data request failed",
        FEE009: "Message sent",
        FEE010: "Sending failed"
      }
    };
  },

  watch: {
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.getAvailableFeeds();

    $("#feedModal").on("hidden.bs.modal", function (e) {
      _this.globals.$emit("feedModalClosed", _this.currentFeedConfig.ItemGuid, _this.currentFeedPosts);
    });

    this.globals.$off("openFeedModal");
    this.globals.$on("openFeedModal", function (config) {
      _this.currentFeedConfig = config;
      _this.getFeedPosts();
      $("#feedModal").modal("show");
    });
    this.globals.$off("closeFeedModal");
    this.globals.$on("closeFeedModal", function () {
      $("#feedModal").modal("hide");
    });

    this.globals.$off("requestFeedPosts");
    this.globals.$on("requestFeedPosts", function (config) {
      _this.getFeedPosts(config);
    });
  },

  methods: {
    addContentHighlighting: function addContentHighlighting(content) {
      var userHighlightString = "@" + this.globals.currentUserName;

      var result = content.replace(userHighlightString, "<span class=\"text-red text-bold\">" + userHighlightString + "</span>");
      return result;
    },
    getCurrentFeedGuid: function getCurrentFeedGuid(config) {
      var currentFeed = _.find(this.availableFeeds, function (f) {
        return f.FeedType === config.FeedType && f.FeedName === config.FeedName;
      });
      return currentFeed && currentFeed.FeedGuid;
    },
    getAvailableFeeds: function getAvailableFeeds() {
      var _this2 = this;

      $.ajax({
        method: "GET",
        url: "api/Feed/Available",
        success: function success(data) {
          if (data.Error) {
            _this2.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          _this2.availableFeeds = [];
          if (data[0]) _this2.availableFeeds = data;
        },
        error: function error(_error) {
          console.error("Error on GET in getAvailableFeeds()");
          _this2.globals.showErrorSnackbar(_this2.lang.FEE007);
        }
      });
    },
    getFeedPosts: function getFeedPosts(config) {
      var _this3 = this;

      var cfg = config || this.currentFeedConfig;
      if (!cfg.ItemGuid) return;

      var currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      var query = "api/Feed/" + currentFeedGuid + "/Posts/" + cfg.ItemGuid;
      $.ajax({
        method: "GET",
        url: query,
        success: function success(data) {
          if (data.Error) {
            _this3.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }

          _this3.currentFeedPosts = data[0] ? _.orderBy(data, ["FeedPostCreatedAt"], ["desc"]) : [];

          _this3.globals.$emit("feedPostsReceived", cfg.ItemGuid, cfg.FeedName, _this3.currentFeedPosts);
        },
        error: function error(_error2) {
          console.error("Error on GET in getFeedPosts()");
          _this3.globals.showErrorSnackbar(_this3.lang.FEE008);
          _this3.currentFeedPosts = [];
          _this3.globals.$emit("feedPostsReceived", cfg.ItemGuid, cfg.FeedName, []);
        }
      });
    },
    addFeedPost: function addFeedPost() {
      var _this4 = this;

      var cfg = this.currentFeedConfig;
      if (!cfg.ItemGuid || !this.newFeedPostContent) return;

      var currentFeedGuid = this.getCurrentFeedGuid(cfg);
      if (!currentFeedGuid) return;

      var sendData = {
        Content: this.newFeedPostContent
      };
      var query = "api/Feed/" + currentFeedGuid + "/Posts/" + cfg.ItemGuid;

      $.ajax({
        method: "POST",
        url: query,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function success(data) {
          if (data.Error) {
            console.error(data.Error);
            _this4.globals.showErrorSnackbar(data.Error);
            return;
          }
          _this4.getFeedPosts();
          _this4.newFeedPostContent = "";
          _this4.globals.showSuccessSnackbar(_this4.lang.FEE009);
        },
        error: function error(_error3) {
          console.error("Error on POST in addFeedPost()");
          _this4.globals.showErrorSnackbar(_this4.lang.FEE010);
        }
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ace_builds__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ace_builds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ace_builds__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "HtmlEditorModal",
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal: function openModal() {
      $("#htmlEditorModal").modal("show");
    },
    closeModal: function closeModal() {
      $("#htmlEditorModal").modal("hide");
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#htmlEditorModal").on("hidden.bs.modal", function (e) {
      _this.$emit("modalClosed");
      _this.globals.$emit("getDataFromHtmlEditorModal", _this.content);
    });

    this.globals.$off("sendDataToHtmlEditorModal");
    this.globals.$on("sendDataToHtmlEditorModal", function (data) {
      _this.title = data.title;
      _this.content = data.content || "";
      _this.content.substring(0, 39999);
      _this.aceEditor.setValue(_this.content);
    });

    __webpack_require__(821);
    __WEBPACK_IMPORTED_MODULE_0_ace_builds___default.a.require("ace/ext/language_tools");
    this.aceEditor = __WEBPACK_IMPORTED_MODULE_0_ace_builds___default.a.edit("aceEditor");
    this.aceEditor.session.setMode("ace/mode/html");
    this.aceEditor.setTheme("ace/theme/tomorrow");
    this.aceEditor.on("blur", function () {
      _this.content = _this.aceEditor.getValue();
    });
    this.aceEditor.on("change", function (data) {
      var value = _this.aceEditor.getValue();
      _this.currentChars = value.length;
      if (value.length > 39999) {
        _this.globals.showErrorSnackbar(_this.lang.HEM003);
        try {
          _this.aceEditor.session.getUndoManager().undo();
        } catch (error) {
          console.error("UndoManager Error", error);
        }
      }
    });
  },

  watch: {
    showModal: function showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage": function globalsSelectedLanguage() {
      this.globals.getLanguageStrings(this);
    }
  },
  data: function data() {
    return {
      title: "",
      content: "",
      aceEditor: null,
      currentChars: 0,
      lang: {
        HEM000: "HTML Editor",
        HEM001: "Preview",
        HEM002: "Close",
        HEM003: "Maximum characters reached"
      }
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "NotificationDialog",
  props: {
    dialogId: {
      type: String,
      default: "notificationDialog"
    },
    notificationTitle: {
      type: String,
      default: ""
    },
    closeButtonText: {
      type: String,
      default: "Close"
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    colorRed: {
      type: Boolean,
      default: false
    },
    htmlText: {
      type: String,
      default: ""
    }
  },
  methods: {
    openNotificationDialog: function openNotificationDialog() {
      var _this = this;

      this.$nextTick(function () {
        $("#" + _this.dialogId).modal("show");
      });
    },
    closeNotificationDialog: function closeNotificationDialog() {
      $("#" + this.dialogId).modal("hide");
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    $("#" + this.dialogId).on("hide.bs.modal", function (e) {
      return _this2.$emit("closeDialog");
    });
    $("#" + this.dialogId).on("hidden.bs.modal", function (e) {
      _this2.$emit("dialogClosed");
    });
  },

  watch: {
    showDialog: function showDialog() {
      if (this.showDialog) {
        this.openNotificationDialog();
      } else {
        this.closeNotificationDialog();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var resolveInitPromise = void 0;
var rejectInitPromise = void 0;
// This promise handles the initialization
// status of the google maps script.
var initPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
  resolveInitPromise = resolve;
  rejectInitPromise = reject;
});

function init(apiKey) {
  // If Google Maps already is initialized
  // the `initPromise` should get resolved
  // eventually.
  if (!!window.google) return initPromise;

  // The callback function is called by
  // the Google Maps script if it is
  // successfully loaded.
  window["gmapsCallback"] = function () {
    return resolveInitPromise(window.google);
  };

  // We inject a new script tag into
  // the `<head>` of our HTML to load
  // the Google Maps script.
  var script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.id = "gmapsScript";
  script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&callback=gmapsCallback&libraries=places";
  script.onerror = rejectInitPromise;
  document.querySelector("head").appendChild(script);
  return initPromise;
}

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initServiceWorker = function initServiceWorker() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      navigator.serviceWorker.getRegistrations().then(function (registration) {
        if (!registration.active) {
          navigator.serviceWorker.register("/sw.js").then(function (registration) {
            // Registration was successful
            console.debug("ServiceWorker registration successful with scope: ", registration.scope);
          }).catch(function (err) {
            console.debug("ServiceWorker registration failed: ", err);
          });
        }
      });
    });
  } else {
    console.debug("no serviceWorker");
  }
};

/* harmony default export */ __webpack_exports__["a"] = (initServiceWorker);

/***/ }),
/* 867 */,
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_localFilters__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_sharedFilters__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userSettings__ = __webpack_require__(871);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: {
    localFilters: __WEBPACK_IMPORTED_MODULE_4__modules_localFilters__["a" /* default */],
    sharedFilters: __WEBPACK_IMPORTED_MODULE_5__modules_sharedFilters__["a" /* default */],
    userSettings: __WEBPACK_IMPORTED_MODULE_6__modules_userSettings__["a" /* default */]
  },
  strict: "production" !== "production",
  mutations: {
    initStore: function initStore(state) {
      var storedUserSettings = localStorage.getItem("userSettings");
      if (storedUserSettings) {
        state.userSettings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.userSettings, JSON.parse(storedUserSettings));
      }

      var storedLocalFilters = localStorage.getItem("localFilters");
      if (storedLocalFilters) {
        state.localFilters = JSON.parse(storedLocalFilters);
      }

      var storedSharedFilters = localStorage.getItem("sharedFilters");
      if (storedSharedFilters) {
        state.sharedFilters = JSON.parse(storedSharedFilters);
      }
    }
  }
});

// Detects any changes to the state
store.subscribe(function (mutation, state) {
  if (mutation.type.startsWith("userSettings/")) {
    localStorage.setItem("userSettings", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.userSettings));

    if (mutation.type === "userSettings/rememberFilters") {
      localStorage.removeItem("localFilters");
      localStorage.removeItem("sharedFilters");
    } else if (mutation.type === "userSettings/syncFilters") {
      localStorage.removeItem("sharedFilters");
    }
  } else if (store.getters["userSettings/rememberFilters"] && mutation.type.startsWith("localFilters/")) {
    localStorage.setItem("localFilters", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.localFilters));
  } else if (store.getters["userSettings/syncFilters"] && mutation.type.startsWith("sharedFilters/")) {
    localStorage.setItem("sharedFilters", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.sharedFilters));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);


// initial state
var state = {
  clientManagement: {},
  locationManagement: {},
  userManagement: {},
  projectManagement: {},
  agencyManagement: {},
  surveyManagement: {},
  checkManagement: {},
  kpiManagement: {},
  shopperManagement: {},
  recruiting_checkFilter: {},
  recruiting_shopperFilter: {},
  shopperApproval: {}
};

var getters = {
  clientManagement: function clientManagement(state) {
    return state.clientManagement;
  },
  locationManagement: function locationManagement(state) {
    return state.locationManagement;
  },
  userManagement: function userManagement(state) {
    return state.userManagement;
  },
  projectManagement: function projectManagement(state) {
    return state.projectManagement;
  },
  agencyManagement: function agencyManagement(state) {
    return state.agencyManagement;
  },
  surveyManagement: function surveyManagement(state) {
    return state.surveyManagement;
  },
  checkManagement: function checkManagement(state) {
    return state.checkManagement;
  },
  kpiManagement: function kpiManagement(state) {
    return state.kpiManagement;
  },
  shopperManagement: function shopperManagement(state) {
    return state.shopperManagement;
  },
  recruiting_checkFilter: function recruiting_checkFilter(state) {
    return state.recruiting_checkFilter;
  },
  recruiting_shopperFilter: function recruiting_shopperFilter(state) {
    return state.recruiting_shopperFilter;
  },
  shopperApproval: function shopperApproval(state) {
    return state.shopperApproval;
  }
};

var actions = {};

var mutations = {
  clearAll: function clearAll(state) {
    state.clientManagement = {};
    state.locationManagement = {};
    state.userManagement = {};
    state.projectManagement = {};
    state.agencyManagement = {};
    state.surveyManagement = {};
    state.checkManagement = {};
    state.kpiManagement = {};
    state.shopperManagement = {};
    state.recruiting_checkFilter = {};
    state.recruiting_shopperFilter = {};
    state.shopperApproval = {};
  },
  clientManagement: function clientManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "clientManagement", filters);
  },
  locationManagement: function locationManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "locationManagement", filters);
  },
  userManagement: function userManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "userManagement", filters);
  },
  projectManagement: function projectManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "projectManagement", filters);
  },
  agencyManagement: function agencyManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "agencyManagement", filters);
  },
  surveyManagement: function surveyManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "surveyManagement", filters);
  },
  checkManagement: function checkManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "checkManagement", filters);
  },
  kpiManagement: function kpiManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "kpiManagement", filters);
  },
  shopperManagement: function shopperManagement(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "shopperManagement", filters);
  },
  recruiting_checkFilter: function recruiting_checkFilter(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "recruiting_checkFilter", filters);
  },
  recruiting_shopperFilter: function recruiting_shopperFilter(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "recruiting_shopperFilter", filters);
  },
  shopperApproval: function shopperApproval(state, filters) {
    filters = filters || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, "shopperApproval", filters);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(27);


// initial state
var state = {
  client: {},
  importer: {},
  project: {}
};

var getters = {
  client: function client(state) {
    var result = {
      ClientName: state.client.ClientName || "",
      ClientGuid: state.client.ClientGuid || ""
    };
    return result;
  },
  importer: function importer(state) {
    var result = {
      ImporterName: state.importer.ImporterName || "",
      ImporterGuid: state.importer.ImporterGuid || ""
    };
    return result;
  },
  project: function project(state) {
    var result = {
      ProjectName: state.project.ProjectName || "",
      ProjectGuid: state.project.ProjectGuid || ""
    };
    return result;
  }
};

var actions = {};

var mutations = {
  clearAll: function clearAll(state) {
    state.client = {};
    state.importer = {};
    state.project = {};
  },
  client: function client(state, _client) {
    _client = _client || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.client, "ClientName", _client.ClientName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.client, "ClientGuid", _client.ClientGuid || "");
  },
  importer: function importer(state, _importer) {
    _importer = _importer || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.importer, "ImporterName", _importer.ImporterName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.importer, "ImporterGuid", _importer.ImporterGuid || "");
  },
  project: function project(state, _project) {
    _project = _project || {};
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.project, "ProjectName", _project.ProjectName || "");
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.project, "ProjectGuid", _project.ProjectGuid || "");
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// initial state
var state = {
  filters: {
    remember: false,
    sync: false
  }
};

var getters = {
  rememberFilters: function rememberFilters(state) {
    return state.filters.remember;
  },
  syncFilters: function syncFilters(state) {
    return state.filters.sync;
  }
};

var actions = {};

var mutations = {
  rememberFilters: function rememberFilters(state, value) {
    state.filters.remember = value;
  },
  syncFilters: function syncFilters(state, value) {
    state.filters.sync = value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */,
/* 1320 */,
/* 1321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1322 */,
/* 1323 */,
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */,
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */,
/* 1328 */,
/* 1329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1329)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1799),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1796),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81acb4da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1321)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1792),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64dc79cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1324)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-721540f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1790),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a84faeb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1330)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1800),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c098cfa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "htmlEditorModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('h6', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("(" + _vm._s(this.currentChars) + "/39999)")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#htmlEditorEditorTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.HEM000))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#htmlEditorPreviewTab",
      "data-toggle": "tab"
    }
  }, [_vm._v(_vm._s(_vm.lang.HEM001))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "htmlEditorPreviewTab"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.HEM002) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "htmlEditorEditorTab"
    }
  }, [_c('pre', {
    attrs: {
      "id": "aceEditor"
    }
  })])
}]}

/***/ }),
/* 1791 */,
/* 1792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editVatRatesModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.EVR000) + " - " + _vm._s(_vm.lang.EVR001))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "selectEditVatRatesCountry"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectEditVatRatesCountry"
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  }, _vm._l((_vm.globals.countryList), function(name, code) {
    return _c('option', {
      key: code,
      domProps: {
        "value": code
      }
    }, [_vm._v("\n                " + _vm._s(name) + "\n              ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "inputEditVatRatesValue"
    }
  }, [_vm._v(_vm._s(_vm.lang.EVR003) + " (%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.vatRatePercentage),
      expression: "vatRatePercentage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputEditVatRatesValue",
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.vatRatePercentage)
    },
    on: {
      "change": function($event) {
        _vm.vatDataDirty = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vatRatePercentage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR004) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-success",
    class: {
      'btn-warning': _vm.vatDataDirty
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveVatRates()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.EVR005) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1793 */,
/* 1794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "feedModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.FEE000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "feed-modal-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFeedPostContent),
      expression: "newFeedPostContent"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputNewFeedPost",
      "rows": "3",
      "maxlength": "1000",
      "placeholder": _vm.lang.FEE001
    },
    domProps: {
      "value": (_vm.newFeedPostContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFeedPostContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "disabled": !_vm.newFeedPostContent
    },
    on: {
      "click": function($event) {
        return _vm.addFeedPost()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.FEE002) + "\n              ")])])]), _vm._v(" "), (_vm.currentFeedPosts.length < 1) ? _c('div', [_vm._v(_vm._s(_vm.lang.FEE003))]) : _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE004) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.FEE005) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentFeedPosts), function(post) {
    return _c('tr', {
      key: post.FeedPostGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(post.FeedPostCreatedBy.Lastname) + ",\n                    " + _vm._s(post.FeedPostCreatedBy.Firstname))]), _vm._v("\n                  -\n                  "), _c('span', {
      class: {
        'text-red text-bold': post.FeedPostCreatedBy.Username ===
          _vm.globals.currentUserName,
      }
    }, [_vm._v(_vm._s(post.FeedPostCreatedBy.Username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "post-creation-timestamp"
    }, [_vm._v(_vm._s(_vm.globals.getLocalizedDateTimeFromUtcIsoTimestamp(
      post.FeedPostCreatedAt
    )))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left",
      domProps: {
        "innerHTML": _vm._s(_vm.addContentHighlighting(post.Content))
      }
    })])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.FEE006) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1795 */,
/* 1796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "changelogModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.changelog), function(content, version) {
    return _c('div', {
      key: version
    }, [(
      version === 'dev' && ['dev', 'training', 'dev-audi', 'training-audi'].indexOf(
        _vm.feature.currentTarget
      ) > -1
    ) ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("In Progress")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), (version !== 'dev') ? [_c('span', {
      staticClass: "version-number"
    }, [_vm._v("v" + _vm._s(version))]), _vm._v(" "), _c('span', {
      staticClass: "version-date"
    }, [_vm._v("(" + _vm._s(content.date) + ")")]), _vm._v(" "), _vm._l((content.changes), function(entry, index) {
      return _c('div', {
        key: index,
        staticClass: "change-entry"
      }, [_vm._v("\n              ● " + _vm._s(entry) + "\n            ")])
    }), _vm._v(" "), _c('hr')] : _vm._e()], 2)
  }), 0), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Changelog")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          Close\n        ")])])
}]}

/***/ }),
/* 1797 */,
/* 1798 */,
/* 1799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__main",
    attrs: {
      "id": "app"
    }
  }, [(_vm.globals.spinnerVisible) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    class: {
      db_layout: _vm.feature.isDBTarget
    },
    attrs: {
      "id": "app-navbar"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: !_vm.$route.name
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.feature.isAudiTarget) ? _c('img', {
    attrs: {
      "src": "/static/audi_loop_logo.png",
      "height": "40"
    }
  }) : (_vm.feature.isDBTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/DB_loop_service_store_logo.png",
      "height": "25"
    }
  }) : (_vm.feature.isPorscheTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/Porsche_loop_logo.png",
      "height": "35"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/msm_loop_logo.png",
      "height": "40"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.globals.operationPermitted('Entities.Client.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ClientManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/clientmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0000))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Location.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'LocationManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/locationmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0001))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.User.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'UserManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/usermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0010))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Project.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ProjectManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/projectmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0011))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Agency.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AgencyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/agencymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0012))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Survey.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'SurveyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0013))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.globals.operationPermitted('Entities.SurveyInstance.AllowRead')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'CheckManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/checkmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.KPI.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'KPIManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/kpimanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0016))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Shopper.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shoppermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0023))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Recruiting.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Recruiting'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/recruiting"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0029))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shopperApproval') && _vm.globals.currentUserInfo
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperApproval'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shopperapproval"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0032))])], 1) : _vm._e()]), _vm._v(" "), (_vm.userLoginState) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSelectLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("public")]), _vm._v("\n            " + _vm._s(_vm.languageList[_vm.globals.selectedLanguage]) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "href": "bootstrap-elements.html",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n            " + _vm._s(_vm.globals.currentUserInfo.LoginName) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.feature.isEnabled('userSettings')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("settings")]), _vm._v("\n                " + _vm._s(_vm.lang.A0024) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('clearData')) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openClearDataDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("delete_forever")]), _vm._v("\n                " + _vm._s(_vm.lang.A0034) + "\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSupport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("live_help")]), _vm._v("\n                " + _vm._s(_vm.lang.A0021) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("exit_to_app")]), _vm._v("\n                " + _vm._s(_vm.lang.A0003) + "\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.maintenance) ? _c('div', {
    staticClass: "maintenance"
  }, [_c('h3', {
    staticClass: "maintenance-headline",
    on: {
      "click": function($event) {
        _vm.showMaintenance = !_vm.showMaintenance
      }
    }
  }, [(_vm.globals.selectedLanguage == 'de') ? [_vm._v("\n        Demnächst Wartungsarbeiten!\n      ")] : [_vm._v(" Maintenance soon! ")], _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMaintenance),
      expression: "!showMaintenance"
    }],
    staticClass: "material-icons"
  }, [_vm._v("\n        expand_more ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaintenance),
      expression: "showMaintenance"
    }],
    staticClass: "material-icons"
  }, [_vm._v("\n        expand_less\n      ")])], 2), _vm._v(" "), _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaintenance),
      expression: "showMaintenance"
    }],
    staticClass: "maintenance-article"
  }, [(_vm.globals.selectedLanguage == 'de') ? _c('span', [_vm._v("Sehr geehrte/r Nutzer/in "), _c('br'), _c('br'), _vm._v("\n        die Loop Plattform wird am 20.01.2022 aufgrund von Wartungsarbeiten\n        zwischen 17:00 und 21:00 Uhr für 120 Minuten nicht erreichbar sein."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Wartungsfenster:")]), _vm._v(" Am 20.01.2022 von 17 Uhr bis 21 Uhr\n        (GMT+1)."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Ausfalldauer:")]), _vm._v(" 120 Minuten."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Hinweis:")]), _vm._v(" Entsprechende Hinweise werden auf den Webseiten\n        platziert. Nach Abschluss der Arbeiten versenden wir eine\n        Statusmeldung. "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Grund:")]), _vm._v(" Der Betreiber des Rechenzentrums führt technische\n        Umbaumaßnahmen durch, die eine Teilabschaltung der Datenleitungen\n        erfordern.\n      ")]) : _c('span', [_vm._v("Dear user,"), _c('br'), _c('br'), _vm._v("\n        the Loop platform will be unavailable for 120 minutes between 17:00\n        and 21:00 on 20.01.2022 due to maintenance work."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Maintenance work:")]), _vm._v(" January 20, 2022 from 5pm until 9pm\n        (GMT+1)."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Loss of connectivity:")]), _vm._v(" 120 minutes."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Notifications:")]), _vm._v(" Appropriate notice will be placed on the\n        website. A status mail will be sent after completion of\n        maintenance."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Reason:")]), _vm._v(" The data centre operations team implements technical\n        modifications that require a partial connectivity loss.")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app__router-view"
  }, [(_vm.isAccessTokenAvailable) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectLanguageDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0006))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.A0007))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextLanguage),
      expression: "nextLanguage"
    }],
    staticClass: "form-control language-select",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language, isocode) {
    return _c('option', {
      key: isocode,
      domProps: {
        "value": isocode
      }
    }, [_vm._v("\n                  " + _vm._s(language) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectedLanguageDialogClosed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectClearData",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0034))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "right",
      "overflow": "hidden"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataCache",
      "title": _vm.lang.A0035
    }
  }, [_vm._v(_vm._s(_vm.lang.A0035) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0035
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Cache),
      expression: "clearDataSelection.Cache"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataCache"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Cache) ? _vm._i(_vm.clearDataSelection.Cache, null) > -1 : (_vm.clearDataSelection.Cache)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Cache,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Cache", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Cache", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Cache", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataCookies",
      "title": _vm.lang.A0036
    }
  }, [_vm._v(_vm._s(_vm.lang.A0036) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0036
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Cookies),
      expression: "clearDataSelection.Cookies"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataCookies"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Cookies) ? _vm._i(_vm.clearDataSelection.Cookies, null) > -1 : (_vm.clearDataSelection.Cookies)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Cookies,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Cookies", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Cookies", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Cookies", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataStorage",
      "title": _vm.lang.A0037
    }
  }, [_vm._v(_vm._s(_vm.lang.A0037) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0037
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Storage),
      expression: "clearDataSelection.Storage"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataStorage"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Storage) ? _vm._i(_vm.clearDataSelection.Storage, null) > -1 : (_vm.clearDataSelection.Storage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Storage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Storage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Storage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Storage", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataExecutionContexts",
      "title": _vm.lang.A0038
    }
  }, [_vm._v(_vm._s(_vm.lang.A0038) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0038
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.ExecutionContexts),
      expression: "clearDataSelection.ExecutionContexts"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataExecutionContexts"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.ExecutionContexts) ? _vm._i(_vm.clearDataSelection.ExecutionContexts, null) > -1 : (_vm.clearDataSelection.ExecutionContexts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.ExecutionContexts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selecteClearDataDialogClosed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": _vm.confirmationDialogId,
      "confirmationTitle": _vm.confirmationDialogData.confirmationTitle,
      "yesButtonText": _vm.confirmationDialogData.yesButtonText,
      "noButtonText": _vm.confirmationDialogData.noButtonText,
      "showDialog": _vm.showConfirmationDialog,
      "colorRed": _vm.confirmationDialogData.colorRed,
      "htmlText": _vm.confirmationDialogData.htmlText
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed,
      "closeDialog": _vm.onCloseConfirmationDialog
    }
  }), _vm._v(" "), _c('notification-dialog', {
    attrs: {
      "dialogId": _vm.notificationDialogId,
      "notificationTitle": _vm.notificationDialogData.notificationTitle,
      "closeButtonText": _vm.notificationDialogData.closeButtonText,
      "showDialog": _vm.showNotificationDialog,
      "colorRed": _vm.notificationDialogData.colorRed,
      "htmlText": _vm.notificationDialogData.htmlText
    },
    on: {
      "closeDialog": _vm.onCloseNotificationDialog,
      "dialogClosed": _vm.onNotificationDialogClosed
    }
  }), _vm._v(" "), _c('UploadProgressModal'), _vm._v(" "), (_vm.globals.currentUserRole < 2) ? _c('edit-vat-rates-modal', {
    attrs: {
      "showModal": _vm.showEditVatRatesModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showEditVatRatesModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('changelog-modal', {
    attrs: {
      "showDialog": _vm.showChangelogModal
    },
    on: {
      "closeDialog": function($event) {
        _vm.showChangelogModal = false
      }
    }
  }), _vm._v(" "), _c('HtmlEditorModal', {
    attrs: {
      "showModal": _vm.showHtmlEditorModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showHtmlEditorModal = false
      }
    }
  }), _vm._v(" "), _c('ElementHistoryModal'), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Feed.AllowRead')) ? _c('FeedModal') : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      warning: _vm.globals.isLoggedInAsOtherUser
    },
    attrs: {
      "id": "defaultAppFooter"
    }
  }, [(_vm.globals.isLoggedInAsOtherUser) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.lang.A0033) + ":\n      "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.globals.currentUserInfo.IsLoggedInAsUser))])])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "footerLinkContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/imprint.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0018))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/dataProtection.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0017))])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "frontendVersionIndicator"
    },
    on: {
      "click": function($event) {
        _vm.showChangelogModal = true
      }
    }
  }, [_vm._v("v" + _vm._s(_vm.appVersion))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.dialogId,
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.notificationTitle))])])]), _vm._v(" "), (!_vm.htmlText) ? _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "modal-body",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlText)
    }
  }, [_vm._v(_vm._s(_vm.htmlText))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    class: [this.colorRed ? 'btn-danger' : 'dialog-btn-primary'],
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.closeButtonText) + "\n        ")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(304);
module.exports = __webpack_require__(804);


/***/ })
],[1806]);


// WEBPACK FOOTER //
// static/js/app.6bb19d2a4233ce825d1e.js